
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3ueMA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf; }, function (v) { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf = v; });
var $289fa3fab82a0cd6$export$6503ec6e8aabbaf;
var $289fa3fab82a0cd6$export$f7ad0328861e2f03;
"use strict";
var $289fa3fab82a0cd6$var$mapping = new Map();
function $289fa3fab82a0cd6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$289fa3fab82a0cd6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $289fa3fab82a0cd6$var$resolve(id) {
    var resolved = $289fa3fab82a0cd6$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$289fa3fab82a0cd6$export$6503ec6e8aabbaf = $289fa3fab82a0cd6$var$register;
$289fa3fab82a0cd6$export$f7ad0328861e2f03 = $289fa3fab82a0cd6$var$resolve;

});

parcelRegister("eeH7J", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hKcVW"));

});
parcelRegister("hKcVW", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = '18.3.1';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ''; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || '';
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== 'object' && typeof partialState !== 'function' && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
    };
    var deprecatedAPIs = {
        isMounted: [
            'isMounted',
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            'replaceState',
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = '.';
    var SUBSEPARATOR = ':';
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            '=': '=0',
            ':': '=2'
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return '$' + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, '$&/');
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === 'object' && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape('' + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case 'string':
            case 'number':
                invokeCallback = true;
                break;
            case 'object':
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = '';
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + '/';
                mapIntoArray(mappedChild, array, escapedChildKey, '', function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === 'function') {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === 'object') {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, '', '', function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error('React.Children.only expected to receive a single React element child.');
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!('default' in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'defaultProps', {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'propTypes', {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== 'function') error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
        else if (render.length !== 0 && render.length !== 2) error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? 'null' : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, 'type', {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ('require' + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, 'timers').setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === 'undefined') error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === 'object' && typeof result.then === 'function') {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== 'undefined') // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});


parcelRegister("apqNv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7941069a82d93a79$export$ae55be85d98224ed; }, function (v) { return $7941069a82d93a79$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $7941069a82d93a79$export$d39a5bbd09211389; }, function (v) { return $7941069a82d93a79$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $7941069a82d93a79$export$882461b6382ed46c; }, function (v) { return $7941069a82d93a79$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $7941069a82d93a79$export$466bfc07425424d5; }, function (v) { return $7941069a82d93a79$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $7941069a82d93a79$export$cd75ccfd720a3cd4; }, function (v) { return $7941069a82d93a79$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $7941069a82d93a79$export$fa8d919ba61d84db; }, function (v) { return $7941069a82d93a79$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $7941069a82d93a79$export$757ceba2d55c277e; }, function (v) { return $7941069a82d93a79$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $7941069a82d93a79$export$b3890eb0ae9dca99; }, function (v) { return $7941069a82d93a79$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $7941069a82d93a79$export$502457920280e6be; }, function (v) { return $7941069a82d93a79$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $7941069a82d93a79$export$c78a37762a8d58e1; }, function (v) { return $7941069a82d93a79$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $7941069a82d93a79$export$dc54d992c10e8a18; }, function (v) { return $7941069a82d93a79$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $7941069a82d93a79$export$83d89fbfd8236492; }, function (v) { return $7941069a82d93a79$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7941069a82d93a79$export$ae55be85d98224ed;
var $7941069a82d93a79$export$d39a5bbd09211389;
var $7941069a82d93a79$export$882461b6382ed46c;
var $7941069a82d93a79$export$466bfc07425424d5;
var $7941069a82d93a79$export$cd75ccfd720a3cd4;
var $7941069a82d93a79$export$fa8d919ba61d84db;
var $7941069a82d93a79$export$757ceba2d55c277e;
var $7941069a82d93a79$export$b3890eb0ae9dca99;
var $7941069a82d93a79$export$502457920280e6be;
var $7941069a82d93a79$export$c78a37762a8d58e1;
var $7941069a82d93a79$export$dc54d992c10e8a18;
var $7941069a82d93a79$export$83d89fbfd8236492;
'use strict';


(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("eeH7J"));
    var Scheduler = (parcelRequire("l7BOg"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning('warn', format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning('error', format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === 'onDoubleClick') possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'disableRemotePlayback',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL('' + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === '') return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === '' + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === '' + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === '' + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, '' + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : '';
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = '' + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_SCOPE_TYPE = Symbol.for('react.scope');
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for('react.debug_trace_mode');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for('react.legacy_hidden');
    var REACT_CACHE_TYPE = Symbol.for('react.cache');
    var REACT_TRACING_MARKER_TYPE = Symbol.for('react.tracing_marker');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame('Lazy');
            case SuspenseComponent:
                return describeBuiltInComponentFrame('Suspense');
            case SuspenseListComponent:
                return describeBuiltInComponentFrame('SuspenseList');
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return '';
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = '';
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || 'Context';
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return 'Cache';
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + '.Consumer';
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + '.Provider';
            case DehydratedFragment:
                return 'DehydratedFragment';
            case ForwardRef:
                return getWrappedName$1(type, type.render, 'ForwardRef');
            case Fragment:
                return 'Fragment';
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return 'Portal';
            case HostRoot:
                return 'Root';
            case HostText:
                return 'Text';
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return 'StrictMode';
                return 'Mode';
            case OffscreenComponent:
                return 'Offscreen';
            case Profiler:
                return 'Profiler';
            case ScopeComponent:
                return 'Scope';
            case SuspenseComponent:
                return 'Suspense';
            case SuspenseListComponent:
                return 'SuspenseList';
            case TracingMarkerComponent:
                return 'TracingMarker';
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === 'function') return type.displayName || type.name || null;
                if (typeof type === 'string') return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
                return value;
            case 'object':
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return '';
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = '';
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? 'true' : 'false';
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps('input', props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, 'checked', checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === 'number') {
                if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty('value')) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty('defaultValue')) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== '') node.name = '';
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== '') node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, 'name');
            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === 'object' && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === 'string' || typeof child === 'number') return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute('value', toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return '\n\nCheck the render method of `' + ownerName + '`.';
        return '';
    }
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps('select', props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps('textarea', props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
                if (isArray(children)) {
                    if (children.length > 1) throw new Error('<textarea> can only have at most one child.');
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = '';
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg'; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!('innerHTML' in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimingFunction'
        ],
        background: [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ],
        backgroundPosition: [
            'backgroundPositionX',
            'backgroundPositionY'
        ],
        border: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderBlockEnd: [
            'borderBlockEndColor',
            'borderBlockEndStyle',
            'borderBlockEndWidth'
        ],
        borderBlockStart: [
            'borderBlockStartColor',
            'borderBlockStartStyle',
            'borderBlockStartWidth'
        ],
        borderBottom: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ],
        borderColor: [
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor'
        ],
        borderImage: [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ],
        borderInlineEnd: [
            'borderInlineEndColor',
            'borderInlineEndStyle',
            'borderInlineEndWidth'
        ],
        borderInlineStart: [
            'borderInlineStartColor',
            'borderInlineStartStyle',
            'borderInlineStartWidth'
        ],
        borderLeft: [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ],
        borderRadius: [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ],
        borderRight: [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ],
        borderStyle: [
            'borderBottomStyle',
            'borderLeftStyle',
            'borderRightStyle',
            'borderTopStyle'
        ],
        borderTop: [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderWidth: [
            'borderBottomWidth',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth'
        ],
        columnRule: [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ],
        columns: [
            'columnCount',
            'columnWidth'
        ],
        flex: [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ],
        flexFlow: [
            'flexDirection',
            'flexWrap'
        ],
        font: [
            'fontFamily',
            'fontFeatureSettings',
            'fontKerning',
            'fontLanguageOverride',
            'fontSize',
            'fontSizeAdjust',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition',
            'fontWeight',
            'lineHeight'
        ],
        fontVariant: [
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition'
        ],
        gap: [
            'columnGap',
            'rowGap'
        ],
        grid: [
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        gridArea: [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ],
        gridColumn: [
            'gridColumnEnd',
            'gridColumnStart'
        ],
        gridColumnGap: [
            'columnGap'
        ],
        gridGap: [
            'columnGap',
            'rowGap'
        ],
        gridRow: [
            'gridRowEnd',
            'gridRowStart'
        ],
        gridRowGap: [
            'rowGap'
        ],
        gridTemplate: [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        listStyle: [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ],
        margin: [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ],
        marker: [
            'markerEnd',
            'markerMid',
            'markerStart'
        ],
        mask: [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPositionX',
            'maskPositionY',
            'maskRepeat',
            'maskSize'
        ],
        maskPosition: [
            'maskPositionX',
            'maskPositionY'
        ],
        outline: [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ],
        overflow: [
            'overflowX',
            'overflowY'
        ],
        padding: [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ],
        placeContent: [
            'alignContent',
            'justifyContent'
        ],
        placeItems: [
            'alignItems',
            'justifyItems'
        ],
        placeSelf: [
            'alignSelf',
            'justifySelf'
        ],
        textDecoration: [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle'
        ],
        textEmphasis: [
            'textEmphasisColor',
            'textEmphasisStyle'
        ],
        transition: [
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ],
        wordWrap: [
            'overflowWrap'
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
            if (typeof props.dangerouslySetInnerHTML !== 'object' || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== 'object') throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        imagesizes: 'imageSizes',
        imagesrcset: 'imageSrcSet',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-description': 0,
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== 'function') throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== 'function') throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, 'passive', {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === 'undefined' || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event');
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === 'object') try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error('Unable to find node on an unmounted component.');
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error('Unable to find node on an unmounted component.');
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error('Unable to find node on an unmounted component.');
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error('Unable to find node on an unmounted component.');
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error('React instrumentation encountered an error: %s.', err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === 'function') try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === 'function') {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === 'function') try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === 'function') injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === 'function') injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === 'function') injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === 'function') injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === 'function') injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === 'function') injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === 'function') injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === 'function') injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === 'function') injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === 'function') injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === 'function') injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === 'function') injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === 'function') injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === 'function') injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === 'function') injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === 'function') injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return 'Sync';
        if (lane & InputContinuousHydrationLane) return 'InputContinuousHydration';
        if (lane & InputContinuousLane) return 'InputContinuous';
        if (lane & DefaultHydrationLane) return 'DefaultHydration';
        if (lane & DefaultLane) return 'Default';
        if (lane & TransitionHydrationLane) return 'TransitionHydration';
        if (lane & TransitionLanes) return 'Transition';
        if (lane & RetryLanes) return 'Retry';
        if (lane & SelectiveHydrationLane) return 'SelectiveHydration';
        if (lane & IdleHydrationLane) return 'IdleHydration';
        if (lane & IdleLane) return 'Idle';
        if (lane & OffscreenLane) return 'Offscreen';
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        'mousedown',
        'mouseup',
        'touchcancel',
        'touchend',
        'touchstart',
        'auxclick',
        'dblclick',
        'pointercancel',
        'pointerdown',
        'pointerup',
        'dragend',
        'dragstart',
        'drop',
        'compositionend',
        'compositionstart',
        'keydown',
        'keypress',
        'keyup',
        'input',
        'textInput',
        'copy',
        'cut',
        'paste',
        'click',
        'change',
        'contextmenu',
        'reset',
        'submit'
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case 'focusin':
            case 'focusout':
                queuedFocus = null;
                break;
            case 'dragenter':
            case 'dragleave':
                queuedDrag = null;
                break;
            case 'mouseover':
            case 'mouseout':
                queuedMouse = null;
                break;
            case 'pointerover':
            case 'pointerout':
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case 'focusin':
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case 'dragenter':
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case 'mouseover':
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case 'pointerover':
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case 'gotpointercapture':
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            // eslint-disable-next-line no-fallthrough
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            // eslint-disable-next-line no-fallthrough
            case 'beforeblur':
            case 'afterblur':
            // eslint-disable-next-line no-fallthrough
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
                return DiscreteEventPriority;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'toggle':
            case 'touchmove':
            case 'wheel':
            // eslint-disable-next-line no-fallthrough
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
                return ContinuousEventPriority;
            case 'message':
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ('value' in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== 'unknown') event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== 'unknown') // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === 'mousemove') {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ('movementX' in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ('movementY' in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== 'Unidentified') return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        return '';
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') return getEventCharCode(event);
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
    var documentMode = null;
    if (canUseDOM && 'documentMode' in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste'
        ]);
        registerTwoPhaseEvent('onCompositionEnd', [
            'compositionend',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionStart', [
            'compositionstart',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionUpdate', [
            'compositionupdate',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case 'compositionstart':
                return 'onCompositionStart';
            case 'compositionend':
                return 'onCompositionEnd';
            case 'compositionupdate':
                return 'onCompositionUpdate';
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case 'keyup':
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case 'keydown':
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = 'onCompositionStart';
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = 'onCompositionEnd';
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === 'onCompositionStart') isComposing = initialize(nativeEventTarget);
            else if (eventType === 'onCompositionEnd') {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case 'compositionend':
                return getDataFromCustomEvent(nativeEvent);
            case 'keypress':
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case 'textInput':
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case 'paste':
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case 'keypress':
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case 'compositionend':
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') return !!supportedInputTypes[elem.type];
        if (nodeName === 'textarea') return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent('onChange', [
            'change',
            'click',
            'focusin',
            'focusout',
            'input',
            'keydown',
            'keyup',
            'selectionchange'
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');
        if (listeners.length > 0) {
            var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, 'number', node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === 'focusout') handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent('onMouseEnter', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onMouseLeave', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onPointerEnter', [
            'pointerout',
            'pointerover'
        ]);
        registerDirectEvent('onPointerLeave', [
            'pointerout',
            'pointerover'
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';
        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = 'onPointerLeave';
            enterEventType = 'onPointerEnter';
            eventTypePrefix = 'pointer';
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ('contains' in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === 'function') priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ('selectionStart' in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', [
            'focusout',
            'contextmenu',
            'dragend',
            'focusin',
            'keydown',
            'keyup',
            'mousedown',
            'mouseup',
            'selectionchange'
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');
            if (listeners.length > 0) {
                var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case 'focusin':
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case 'focusout':
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case 'mousedown':
                mouseDown = true;
                break;
            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case 'selectionchange':
                if (skipSelectionChangeEvent) break;
            // falls through
            case 'keydown':
            case 'keyup':
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!('TransitionEvent' in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName('animationend');
    var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
    var ANIMATION_START = getVendorPrefixedEventName('animationstart');
    var TRANSITION_END = getVendorPrefixedEventName('transitionend');
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        'abort',
        'auxClick',
        'cancel',
        'canPlay',
        'canPlayThrough',
        'click',
        'close',
        'contextMenu',
        'copy',
        'cut',
        'drag',
        'dragEnd',
        'dragEnter',
        'dragExit',
        'dragLeave',
        'dragOver',
        'dragStart',
        'drop',
        'durationChange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'gotPointerCapture',
        'input',
        'invalid',
        'keyDown',
        'keyPress',
        'keyUp',
        'load',
        'loadedData',
        'loadedMetadata',
        'loadStart',
        'lostPointerCapture',
        'mouseDown',
        'mouseMove',
        'mouseOut',
        'mouseOver',
        'mouseUp',
        'paste',
        'pause',
        'play',
        'playing',
        'pointerCancel',
        'pointerDown',
        'pointerMove',
        'pointerOut',
        'pointerOver',
        'pointerUp',
        'progress',
        'rateChange',
        'reset',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'submit',
        'suspend',
        'timeUpdate',
        'touchCancel',
        'touchEnd',
        'touchStart',
        'volumeChange',
        'scroll',
        'toggle',
        'touchMove',
        'waiting',
        'wheel'
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, 'on' + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, 'onAnimationEnd');
        registerSimpleEvent(ANIMATION_ITERATION, 'onAnimationIteration');
        registerSimpleEvent(ANIMATION_START, 'onAnimationStart');
        registerSimpleEvent('dblclick', 'onDoubleClick');
        registerSimpleEvent('focusin', 'onFocus');
        registerSimpleEvent('focusout', 'onBlur');
        registerSimpleEvent(TRANSITION_END, 'onTransitionEnd');
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case 'keypress':
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case 'keydown':
            case 'keyup':
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case 'focusin':
                reactEventType = 'focus';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'focusout':
                reactEventType = 'blur';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'beforeblur':
            case 'afterblur':
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'click':
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            /* falls through */ case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case 'scroll':
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case 'wheel':
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case 'copy':
            case 'cut':
            case 'paste':
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === 'scroll';
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        'abort',
        'canplay',
        'canplaythrough',
        'durationchange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'loadeddata',
        'loadedmetadata',
        'loadstart',
        'pause',
        'play',
        'playing',
        'progress',
        'ratechange',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'suspend',
        'timeupdate',
        'volumechange',
        'waiting'
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        'cancel',
        'close',
        'invalid',
        'load',
        'scroll',
        'toggle'
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== 'selectionchange') {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent('selectionchange', false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
    var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
    var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
    var AUTOFOCUS = 'autoFocus';
    var CHILDREN = 'children';
    var STYLE = 'style';
    var HTML$1 = '__html';
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error('Extra attributes from the server: %s', names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error('Text content does not match server-rendered HTML.');
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string') {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === 'number') setTextContent(domElement, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === 'script') {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement('div');
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === 'select') {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                props = rawProps;
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = '';
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = '';
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string' || typeof nextProp === 'number') (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case 'input':
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case 'value':
                    break;
                case 'checked':
                    break;
                case 'selected':
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === 'string') {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === 'number') {
                    if (domElement.textContent !== '' + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            '' + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === 'boolean') {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute('style');
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === '') // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'base',
        'basefont',
        'bgsound',
        'blockquote',
        'body',
        'br',
        'button',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dir',
        'div',
        'dl',
        'dt',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'iframe',
        'img',
        'input',
        'isindex',
        'li',
        'link',
        'listing',
        'main',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'nav',
        'noembed',
        'noframes',
        'noscript',
        'object',
        'ol',
        'p',
        'param',
        'plaintext',
        'pre',
        'script',
        'section',
        'select',
        'source',
        'style',
        'summary',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul',
        'wbr',
        'xmp'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        'applet',
        'caption',
        'html',
        'table',
        'td',
        'th',
        'marquee',
        'object',
        'template',
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject',
        'desc',
        'title'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        'button'
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        'dd',
        'dt',
        'li',
        'option',
        'optgroup',
        'p',
        'rp',
        'rt'
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === 'form') ancestorInfo.formTag = info;
        if (tag === 'a') ancestorInfo.aTagInScope = info;
        if (tag === 'button') ancestorInfo.buttonTagInScope = info;
        if (tag === 'nobr') ancestorInfo.nobrTagInScope = info;
        if (tag === 'p') ancestorInfo.pTagInButtonScope = info;
        if (tag === 'li') ancestorInfo.listItemTagAutoclosing = info;
        if (tag === 'dd' || tag === 'dt') ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
                return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case 'option':
                return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case 'tbody':
            case 'thead':
            case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case 'colgroup':
                return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
                return tag === 'frame';
            case '#document':
                return tag === 'html';
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return ancestorInfo.pTagInButtonScope;
            case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
                return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
                return ancestorInfo.buttonTagInScope;
            case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case 'nobr':
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error('validateDOMNesting: when childText is passed, childTag should be null');
            childTag = '#text';
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = '';
        if (childTag === '#text') {
            if (/\S/.test(childText)) tagDisplayName = 'Text nodes';
            else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = '<' + childTag + '>';
        if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
    var SUSPENSE_START_DATA = '$';
    var SUSPENSE_END_DATA = '/$';
    var SUSPENSE_PENDING_START_DATA = '$?';
    var SUSPENSE_FALLBACK_START_DATA = '$!';
    var STYLE$1 = 'style';
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
            case 'img':
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === 'function' ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : typeof localPromise !== 'undefined' ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                if (newProps.autoFocus) domElement.focus();
                return;
            case 'img':
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, '');
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') style.setProperty('display', 'none', 'important');
        else style.display = 'none';
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = '';
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== 'head' && parentType !== 'body';
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error('An error occurred during hydration. The server HTML was replaced with client content in <%s>.', parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = '__reactFiber$' + randomKey;
    var internalPropsKey = '__reactProps$' + randomKey;
    var internalContainerInstanceKey = '__reactContainer$' + randomKey;
    var internalEventHandlersKey = '__reactEvents$' + randomKey;
    var internalEventHandlerListenersKey = '__reactListeners$' + randomKey;
    var internalEventHandlesSetKey = '__reactHandles$' + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error('getNodeFromInstance: Invalid argument.');
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error('Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) error('Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || 'Unknown';
        checkPropTypes(contextTypes, context, 'context', name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== 'function') {
            var componentName = getComponentNameFromFiber(fiber) || 'Unknown';
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
        }
        var name = getComponentNameFromFiber(fiber) || 'Unknown';
        checkPropTypes(childContextTypes, childContext, 'child context', name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = '';
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error('We should not be hydrating here. This is a bug in React. Please file a bug.');
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== 'object') throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === 'function' && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + 'bug in React. Please file an issue.');
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, 'ref');
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== 'string') throw new Error('Expected ref to be a function, a string, an object returned by React.createRef(), or null.');
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + ' the following reasons:\n' + '1. You may be adding a ref to a function component\n' + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + '3. You have multiple copies of React loaded\n' + 'See https://reactjs.org/link/refs-must-have-owner for more information.');
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== 'function') throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error('An iterable object provided no iterator.');
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error('Resuming work not yet implemented.');
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error('We just came from a parent so we must have had a parent. This is a bug in React.');
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== 'function') throw new Error('Invalid argument passed as callback. Expected a function. Instead ' + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error('Rendered more hooks than during the previous render.');
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error('The result of getServerSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error('The result of getSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error('The result of getSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty('current')) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ':' + identifierPrefix + 'R' + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += 'H' + localId.toString(32);
            id += ':';
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ':' + identifierPrefix + 'r' + globalClientId.toString(32) + ':';
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + '_' + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === 'function') error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || 'A pure component');
        if (typeof instance.componentDidUnmount === 'function') error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === 'function') error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === 'function') error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === 'function') error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === 'function') error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === 'function') error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray(_state))) error('%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || 'Anonymous';
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console['error'](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== 'function') // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || 'Unknown');
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || 'Unknown';
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === 'hidden' || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error('Simulated error coming from DevTools');
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error('Should have a current fiber. This is a bug in React.');
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = '';
        if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        }
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error('%s: Function components do not support contextType.', _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: 'visible',
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === 'function';
        if (isAnArray || isIterable) {
            var type = isAnArray ? 'array' : 'iterable';
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== 'function') error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== 'function') {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = 'useLayoutEffect';
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = 'useInsertionEffect';
                        else hookName = 'useEffect';
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === 'function') addendum = '\n\nIt looks like you wrote ' + hookName + '(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + hookName + '(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                        else addendum = ' You returned: ' + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onPostCommit === 'function') onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onRender === 'function') onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === 'function') onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === 'function') safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === 'function') {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty('current')) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error('Expected finished root and lanes to be set. This is a bug in React.');
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor('selector.role');
        TEST_NAME_TYPE = symbolFor('selector.test_id');
        TEXT_TYPE = symbolFor('selector.text');
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== 'undefined';
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error('useInsertionEffect must not schedule updates.');
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error('Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.');
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error('Root did not complete. This is a bug in React.');
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error('Unknown root exit status.');
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error('Root did not complete. This is a bug in React.');
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Cannot flush passive effects while already rendering.');
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || 'ReactComponent';
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === 'object' && replayError !== null && replayError._suppressLogging && typeof originalError === 'object' && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || 'Unknown';
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== 'string') error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = 'DELETED';
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? 'hydrateRoot()' : 'createRoot()';
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? 'hydrate()' : 'render()';
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = '18.3.1';
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw new Error('Unable to find node on an unmounted component.');
            else {
                var keys = Object.keys(component).join(',');
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || 'Unknown');
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== 'function') error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === 'function' ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console['error'](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error('Cannot update an unmounted root.');
        if (typeof arguments[1] === 'function') error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== 'undefined') error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === 'function') error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error('createRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn('hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.');
            else if (typeof options === 'object' && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error('hydrateRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === 'function') {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== 'function') error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || 'A component');
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error('Target container is not a DOM element.');
        if (parentComponent == null || !has(parentComponent)) throw new Error('parentComponent must be a valid React Component');
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error('unmountComponentAtNode(...): Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error('Target container is not a DOM element.');
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === 'file:' ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ''), 'font-weight:bold');
        }
    }
    $7941069a82d93a79$export$ae55be85d98224ed = Internals;
    $7941069a82d93a79$export$d39a5bbd09211389 = createPortal$1;
    $7941069a82d93a79$export$882461b6382ed46c = createRoot$1;
    $7941069a82d93a79$export$466bfc07425424d5 = findDOMNode;
    $7941069a82d93a79$export$cd75ccfd720a3cd4 = flushSync$1;
    $7941069a82d93a79$export$fa8d919ba61d84db = hydrate;
    $7941069a82d93a79$export$757ceba2d55c277e = hydrateRoot$1;
    $7941069a82d93a79$export$b3890eb0ae9dca99 = render;
    $7941069a82d93a79$export$502457920280e6be = unmountComponentAtNode;
    $7941069a82d93a79$export$c78a37762a8d58e1 = batchedUpdates$1;
    $7941069a82d93a79$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $7941069a82d93a79$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("l7BOg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7Zio5"));

});
parcelRegister("7Zio5", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5d0c7e45b1bae445$export$c4744153514ff05d; }, function (v) { return $5d0c7e45b1bae445$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5d0c7e45b1bae445$export$3e506c1ccc9cc1a7; }, function (v) { return $5d0c7e45b1bae445$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5d0c7e45b1bae445$export$e26fe2ed2fa76875; }, function (v) { return $5d0c7e45b1bae445$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5d0c7e45b1bae445$export$502329bbf4b505b1; }, function (v) { return $5d0c7e45b1bae445$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5d0c7e45b1bae445$export$6e3807111c4874c4; }, function (v) { return $5d0c7e45b1bae445$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5d0c7e45b1bae445$export$c27134553091fb3a; }, function (v) { return $5d0c7e45b1bae445$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5d0c7e45b1bae445$export$33ee1acdc04fd2a2; }, function (v) { return $5d0c7e45b1bae445$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5d0c7e45b1bae445$export$b00a404bbd5edef2; }, function (v) { return $5d0c7e45b1bae445$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $5d0c7e45b1bae445$export$8352ce38b91d0c62; }, function (v) { return $5d0c7e45b1bae445$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5d0c7e45b1bae445$export$d66a1c1c77bd778b; }, function (v) { return $5d0c7e45b1bae445$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5d0c7e45b1bae445$export$d3dfb8e4810cb555; }, function (v) { return $5d0c7e45b1bae445$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $5d0c7e45b1bae445$export$839f9183b0465a69; }, function (v) { return $5d0c7e45b1bae445$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5d0c7e45b1bae445$export$72fdf0e06517287b; }, function (v) { return $5d0c7e45b1bae445$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $5d0c7e45b1bae445$export$4b844e58a3e414b4; }, function (v) { return $5d0c7e45b1bae445$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5d0c7e45b1bae445$export$816d2913ae6b83b1; }, function (v) { return $5d0c7e45b1bae445$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5d0c7e45b1bae445$export$61bcfe829111a1d0; }, function (v) { return $5d0c7e45b1bae445$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5d0c7e45b1bae445$export$7ee8c9beb337bc3f; }, function (v) { return $5d0c7e45b1bae445$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5d0c7e45b1bae445$export$b5836b71941fa3ed; }, function (v) { return $5d0c7e45b1bae445$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5d0c7e45b1bae445$export$cf845f2c119da08a; }, function (v) { return $5d0c7e45b1bae445$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5d0c7e45b1bae445$export$c4744153514ff05d;
var $5d0c7e45b1bae445$export$3e506c1ccc9cc1a7;
var $5d0c7e45b1bae445$export$e26fe2ed2fa76875;
var $5d0c7e45b1bae445$export$502329bbf4b505b1;
var $5d0c7e45b1bae445$export$6e3807111c4874c4;
var $5d0c7e45b1bae445$export$c27134553091fb3a;
var $5d0c7e45b1bae445$export$33ee1acdc04fd2a2;
var $5d0c7e45b1bae445$export$b00a404bbd5edef2;
var $5d0c7e45b1bae445$export$8352ce38b91d0c62;
var $5d0c7e45b1bae445$export$d66a1c1c77bd778b;
var $5d0c7e45b1bae445$export$d3dfb8e4810cb555;
var $5d0c7e45b1bae445$export$839f9183b0465a69;
var $5d0c7e45b1bae445$export$72fdf0e06517287b;
var $5d0c7e45b1bae445$export$4b844e58a3e414b4;
var $5d0c7e45b1bae445$export$816d2913ae6b83b1;
var $5d0c7e45b1bae445$export$61bcfe829111a1d0;
var $5d0c7e45b1bae445$export$7ee8c9beb337bc3f;
var $5d0c7e45b1bae445$export$b5836b71941fa3ed;
var $5d0c7e45b1bae445$export$cf845f2c119da08a;
'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $5d0c7e45b1bae445$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $5d0c7e45b1bae445$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === 'function' ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === 'function' ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== 'undefined' ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== 'undefined' && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $5d0c7e45b1bae445$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === 'function') {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $5d0c7e45b1bae445$export$c4744153514ff05d();
                if (typeof continuationCallback === 'function') currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $5d0c7e45b1bae445$export$c4744153514ff05d();
        var startTime;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $5d0c7e45b1bae445$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console['error']("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $5d0c7e45b1bae445$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === 'function') // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== 'undefined') {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($5d0c7e45b1bae445$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $5d0c7e45b1bae445$export$3e506c1ccc9cc1a7 = IdlePriority;
    $5d0c7e45b1bae445$export$e26fe2ed2fa76875 = ImmediatePriority;
    $5d0c7e45b1bae445$export$502329bbf4b505b1 = LowPriority;
    $5d0c7e45b1bae445$export$6e3807111c4874c4 = NormalPriority;
    $5d0c7e45b1bae445$export$c27134553091fb3a = unstable_Profiling;
    $5d0c7e45b1bae445$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $5d0c7e45b1bae445$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $5d0c7e45b1bae445$export$8352ce38b91d0c62 = unstable_continueExecution;
    $5d0c7e45b1bae445$export$d66a1c1c77bd778b = forceFrameRate;
    $5d0c7e45b1bae445$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $5d0c7e45b1bae445$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $5d0c7e45b1bae445$export$72fdf0e06517287b = unstable_next;
    $5d0c7e45b1bae445$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $5d0c7e45b1bae445$export$816d2913ae6b83b1 = unstable_requestPaint;
    $5d0c7e45b1bae445$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $5d0c7e45b1bae445$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $5d0c7e45b1bae445$export$b5836b71941fa3ed = shouldYieldToHost;
    $5d0c7e45b1bae445$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("ayKK6", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2uNLd.default;
    }
});

var $2uNLd = parcelRequire("2uNLd");

});
parcelRegister("2uNLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d14fb7eba32896d$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $2OuJK = parcelRequire("2OuJK");

var $dRzna = parcelRequire("dRzna");
'use client';
function $1d14fb7eba32896d$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $dRzna.jsx)((0, $2OuJK.default), (0, $h4XE0.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
    Component.muiName = (0, $2OuJK.default).muiName;
    return /*#__PURE__*/ $eeH7J.memo(/*#__PURE__*/ $eeH7J.forwardRef(Component));
}

});
parcelRegister("h4XE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6f1137fdd741ee5$export$2e2bcd8739ae039; });
function $c6f1137fdd741ee5$export$2e2bcd8739ae039() {
    return $c6f1137fdd741ee5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6f1137fdd741ee5$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("2OuJK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20c817fcf130f793$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $4A7Fh = parcelRequire("4A7Fh");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $hZWMo = parcelRequire("hZWMo");

var $dRzna = parcelRequire("dRzna");
'use client';
const $20c817fcf130f793$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $20c817fcf130f793$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $4A7Fh.default)(color)}`,
            `fontSize${(0, $4A7Fh.default)(fontSize)}`
        ]
    };
    return (0, $doIAf.default)(slots, (0, $hZWMo.getSvgIconUtilityClass), classes);
};
const $20c817fcf130f793$var$SvgIconRoot = (0, $hikmr.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $4A7Fh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $4A7Fh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $20c817fcf130f793$var$SvgIcon = /*#__PURE__*/ $eeH7J.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $fbOaB.default)(props, $20c817fcf130f793$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $eeH7J.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $20c817fcf130f793$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsxs)($20c817fcf130f793$var$SvgIconRoot, (0, $h4XE0.default)({
        as: component,
        className: (0, $er6YD.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $dRzna.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$20c817fcf130f793$var$SvgIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Node passed into the SVG element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'inherit',
            'action',
            'disabled',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */ fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'inherit',
            'large',
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Applies a color attribute to the SVG element.
   */ htmlColor: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */ inheritViewBox: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */ shapeRendering: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */ titleAccess: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */ viewBox: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
};
$20c817fcf130f793$var$SvgIcon.muiName = 'SvgIcon';
var $20c817fcf130f793$export$2e2bcd8739ae039 = $20c817fcf130f793$var$SvgIcon;

});
parcelRegister("fbOaB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0eeccd462f407d6$export$2e2bcd8739ae039; });
function $b0eeccd462f407d6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("4yBem", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $ittWF = parcelRequire("ittWF");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $351737a4f5900595$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("12dec"))($ittWF.isElement, $351737a4f5900595$var$throwOnDirectAccess);

});
parcelRegister("ittWF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7sHCA"));

});
parcelRegister("7sHCA", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $56ecfc37ca301a7d$export$2b8d127b894957b9; }, function (v) { return $56ecfc37ca301a7d$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $56ecfc37ca301a7d$export$cea3a54a6425200c; }, function (v) { return $56ecfc37ca301a7d$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $56ecfc37ca301a7d$export$a7c73072b1a182ae; }, function (v) { return $56ecfc37ca301a7d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $56ecfc37ca301a7d$export$9f27bc3417b4524d; }, function (v) { return $56ecfc37ca301a7d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $56ecfc37ca301a7d$export$db77ccec0bb4ccac; }, function (v) { return $56ecfc37ca301a7d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $56ecfc37ca301a7d$export$8392c0c9d3dcbd35; }, function (v) { return $56ecfc37ca301a7d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $56ecfc37ca301a7d$export$ffb0004e005737fa; }, function (v) { return $56ecfc37ca301a7d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $56ecfc37ca301a7d$export$b624eff549462981; }, function (v) { return $56ecfc37ca301a7d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $56ecfc37ca301a7d$export$7897aa7841a5380c; }, function (v) { return $56ecfc37ca301a7d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $56ecfc37ca301a7d$export$602eac185826482c; }, function (v) { return $56ecfc37ca301a7d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $56ecfc37ca301a7d$export$e2c29f18771995cb; }, function (v) { return $56ecfc37ca301a7d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $56ecfc37ca301a7d$export$5f8d39834fd61797; }, function (v) { return $56ecfc37ca301a7d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $56ecfc37ca301a7d$export$74bf444e3cd11ea5; }, function (v) { return $56ecfc37ca301a7d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $56ecfc37ca301a7d$export$92387174baf9b227; }, function (v) { return $56ecfc37ca301a7d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $56ecfc37ca301a7d$export$ec112efeb987d9c6; }, function (v) { return $56ecfc37ca301a7d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $56ecfc37ca301a7d$export$b706b080d889d2c9; }, function (v) { return $56ecfc37ca301a7d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $56ecfc37ca301a7d$export$5be5a87408f70ddc; }, function (v) { return $56ecfc37ca301a7d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $56ecfc37ca301a7d$export$45a5e7f76e0caa8d; }, function (v) { return $56ecfc37ca301a7d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $56ecfc37ca301a7d$export$455c2e768291efa6; }, function (v) { return $56ecfc37ca301a7d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $56ecfc37ca301a7d$export$9522e17588c12572; }, function (v) { return $56ecfc37ca301a7d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $56ecfc37ca301a7d$export$2110ac352bb060b9; }, function (v) { return $56ecfc37ca301a7d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $56ecfc37ca301a7d$export$56885ab8b9c456ab; }, function (v) { return $56ecfc37ca301a7d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $56ecfc37ca301a7d$export$d927fcb6adf8f9de; }, function (v) { return $56ecfc37ca301a7d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $56ecfc37ca301a7d$export$b82d16f27459e05a; }, function (v) { return $56ecfc37ca301a7d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $56ecfc37ca301a7d$export$522c17b4f5e123e8; }, function (v) { return $56ecfc37ca301a7d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $56ecfc37ca301a7d$export$1aabd8a0274ecfd6; }, function (v) { return $56ecfc37ca301a7d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $56ecfc37ca301a7d$export$9b621391a187a31a; }, function (v) { return $56ecfc37ca301a7d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $56ecfc37ca301a7d$export$f5bbd400c2f4426f; }, function (v) { return $56ecfc37ca301a7d$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $56ecfc37ca301a7d$export$2b8d127b894957b9;
var $56ecfc37ca301a7d$export$cea3a54a6425200c;
var $56ecfc37ca301a7d$export$a7c73072b1a182ae;
var $56ecfc37ca301a7d$export$9f27bc3417b4524d;
var $56ecfc37ca301a7d$export$db77ccec0bb4ccac;
var $56ecfc37ca301a7d$export$8392c0c9d3dcbd35;
var $56ecfc37ca301a7d$export$ffb0004e005737fa;
var $56ecfc37ca301a7d$export$b624eff549462981;
var $56ecfc37ca301a7d$export$7897aa7841a5380c;
var $56ecfc37ca301a7d$export$602eac185826482c;
var $56ecfc37ca301a7d$export$e2c29f18771995cb;
var $56ecfc37ca301a7d$export$5f8d39834fd61797;
var $56ecfc37ca301a7d$export$74bf444e3cd11ea5;
var $56ecfc37ca301a7d$export$92387174baf9b227;
var $56ecfc37ca301a7d$export$ec112efeb987d9c6;
var $56ecfc37ca301a7d$export$b706b080d889d2c9;
var $56ecfc37ca301a7d$export$5be5a87408f70ddc;
var $56ecfc37ca301a7d$export$45a5e7f76e0caa8d;
var $56ecfc37ca301a7d$export$455c2e768291efa6;
var $56ecfc37ca301a7d$export$9522e17588c12572;
var $56ecfc37ca301a7d$export$2110ac352bb060b9;
var $56ecfc37ca301a7d$export$56885ab8b9c456ab;
var $56ecfc37ca301a7d$export$d927fcb6adf8f9de;
var $56ecfc37ca301a7d$export$b82d16f27459e05a;
var $56ecfc37ca301a7d$export$522c17b4f5e123e8;
var $56ecfc37ca301a7d$export$1aabd8a0274ecfd6;
var $56ecfc37ca301a7d$export$9b621391a187a31a;
var $56ecfc37ca301a7d$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $56ecfc37ca301a7d$export$2b8d127b894957b9 = AsyncMode;
    $56ecfc37ca301a7d$export$cea3a54a6425200c = ConcurrentMode;
    $56ecfc37ca301a7d$export$a7c73072b1a182ae = ContextConsumer;
    $56ecfc37ca301a7d$export$9f27bc3417b4524d = ContextProvider;
    $56ecfc37ca301a7d$export$db77ccec0bb4ccac = Element;
    $56ecfc37ca301a7d$export$8392c0c9d3dcbd35 = ForwardRef;
    $56ecfc37ca301a7d$export$ffb0004e005737fa = Fragment;
    $56ecfc37ca301a7d$export$b624eff549462981 = Lazy;
    $56ecfc37ca301a7d$export$7897aa7841a5380c = Memo;
    $56ecfc37ca301a7d$export$602eac185826482c = Portal;
    $56ecfc37ca301a7d$export$e2c29f18771995cb = Profiler;
    $56ecfc37ca301a7d$export$5f8d39834fd61797 = StrictMode;
    $56ecfc37ca301a7d$export$74bf444e3cd11ea5 = Suspense;
    $56ecfc37ca301a7d$export$92387174baf9b227 = isAsyncMode;
    $56ecfc37ca301a7d$export$ec112efeb987d9c6 = isConcurrentMode;
    $56ecfc37ca301a7d$export$b706b080d889d2c9 = isContextConsumer;
    $56ecfc37ca301a7d$export$5be5a87408f70ddc = isContextProvider;
    $56ecfc37ca301a7d$export$45a5e7f76e0caa8d = isElement;
    $56ecfc37ca301a7d$export$455c2e768291efa6 = isForwardRef;
    $56ecfc37ca301a7d$export$9522e17588c12572 = isFragment;
    $56ecfc37ca301a7d$export$2110ac352bb060b9 = isLazy;
    $56ecfc37ca301a7d$export$56885ab8b9c456ab = isMemo;
    $56ecfc37ca301a7d$export$d927fcb6adf8f9de = isPortal;
    $56ecfc37ca301a7d$export$b82d16f27459e05a = isProfiler;
    $56ecfc37ca301a7d$export$522c17b4f5e123e8 = isStrictMode;
    $56ecfc37ca301a7d$export$1aabd8a0274ecfd6 = isSuspense;
    $56ecfc37ca301a7d$export$9b621391a187a31a = isValidElementType;
    $56ecfc37ca301a7d$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("12dec", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $ittWF = parcelRequire("ittWF");

var $eVtLI = parcelRequire("eVtLI");

var $e6VZV = parcelRequire("e6VZV");

var $kzZuu = parcelRequire("kzZuu");

var $eMZMw = parcelRequire("eMZMw");
var $0c103d2602b98d51$var$printWarning = function() {};
$0c103d2602b98d51$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $0c103d2602b98d51$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $e6VZV) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $0c103d2602b98d51$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($0c103d2602b98d51$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $e6VZV);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$ittWF.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $0c103d2602b98d51$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $0c103d2602b98d51$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $0c103d2602b98d51$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($kzZuu(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $e6VZV);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $0c103d2602b98d51$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $0c103d2602b98d51$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $0c103d2602b98d51$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $0c103d2602b98d51$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $e6VZV);
                if (checkerResult == null) return null;
                if (checkerResult.data && $kzZuu(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $e6VZV);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $eVtLI({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($kzZuu(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $e6VZV);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $eMZMw;
    ReactPropTypes.resetWarningCache = $eMZMw.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("eVtLI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $addd7afc72aed831$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $addd7afc72aed831$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $addd7afc72aed831$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $addd7afc72aed831$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $addd7afc72aed831$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $addd7afc72aed831$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $addd7afc72aed831$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($addd7afc72aed831$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($addd7afc72aed831$var$getOwnPropertySymbols) {
            symbols = $addd7afc72aed831$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($addd7afc72aed831$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("e6VZV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a45e9d61400164c5$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $a45e9d61400164c5$var$ReactPropTypesSecret;

});

parcelRegister("kzZuu", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("eMZMw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $ac4578e7ebce306e$var$printWarning = function() {};

var $e6VZV = parcelRequire("e6VZV");
var $ac4578e7ebce306e$var$loggedTypeFailures = {};

var $kzZuu = parcelRequire("kzZuu");
$ac4578e7ebce306e$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $ac4578e7ebce306e$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($kzZuu(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $e6VZV);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $ac4578e7ebce306e$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $ac4578e7ebce306e$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $ac4578e7ebce306e$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $ac4578e7ebce306e$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $ac4578e7ebce306e$var$checkPropTypes.resetWarningCache = function() {
    $ac4578e7ebce306e$var$loggedTypeFailures = {};
};
module.exports = $ac4578e7ebce306e$var$checkPropTypes;

});



parcelRegister("er6YD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b90ddf26ab5023d$export$2e2bcd8739ae039; });
function $7b90ddf26ab5023d$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $7b90ddf26ab5023d$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $7b90ddf26ab5023d$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $7b90ddf26ab5023d$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7b90ddf26ab5023d$export$2e2bcd8739ae039 = $7b90ddf26ab5023d$export$4f5d2d50c9deca37;

});

parcelRegister("doIAf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c1019a297696187$export$2e2bcd8739ae039; });
function $9c1019a297696187$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("4A7Fh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35607844765610f5$export$2e2bcd8739ae039; });

var $3Rthm = parcelRequire("3Rthm");
var $35607844765610f5$export$2e2bcd8739ae039 = (0, $3Rthm.default);

});
parcelRegister("3Rthm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cfd0882d5a7c0f7$export$2e2bcd8739ae039; });

function $2cfd0882d5a7c0f7$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error(`MUI: \`capitalize(string)\` expects a string argument.`);
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("lNnGW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $fde08d41c31b2f19$export$2440da353cedad43; });

var $h4XE0 = parcelRequire("h4XE0");
parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $d9OwS = parcelRequire("d9OwS");

var $dRzna = parcelRequire("dRzna");
'use client';
function $fde08d41c31b2f19$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $d9OwS.default), (0, $h4XE0.default)({}, props));
}
$fde08d41c31b2f19$var$DefaultPropsProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object.isRequired
};
var $fde08d41c31b2f19$export$2e2bcd8739ae039 = $fde08d41c31b2f19$var$DefaultPropsProvider;
function $fde08d41c31b2f19$export$2440da353cedad43(params) {
    return (0, $d9OwS.useDefaultProps)(params);
}

});
parcelRegister("d9OwS", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $99434fb52bd21f87$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $99434fb52bd21f87$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $8hRD1 = parcelRequire("8hRD1");

var $dRzna = parcelRequire("dRzna");
'use client';
const $99434fb52bd21f87$var$PropsContext = /*#__PURE__*/ $eeH7J.createContext(undefined);
function $99434fb52bd21f87$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $dRzna.jsx)($99434fb52bd21f87$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
$99434fb52bd21f87$var$DefaultPropsProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
function $99434fb52bd21f87$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $8hRD1.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $8hRD1.default)(config, props);
    return props;
}
function $99434fb52bd21f87$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $eeH7J.useContext($99434fb52bd21f87$var$PropsContext);
    return $99434fb52bd21f87$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $99434fb52bd21f87$export$2e2bcd8739ae039 = $99434fb52bd21f87$var$DefaultPropsProvider;

});
parcelRegister("8hRD1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $608982bdd078e66c$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");
function $608982bdd078e66c$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $h4XE0.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $h4XE0.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $h4XE0.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $608982bdd078e66c$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});

parcelRegister("dRzna", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8YEqt"));

});
parcelRegister("8YEqt", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $689349132606a880$export$ffb0004e005737fa; }, function (v) { return $689349132606a880$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $689349132606a880$export$34b9dba7ce09269b; }, function (v) { return $689349132606a880$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $689349132606a880$export$25062201e9e25d76; }, function (v) { return $689349132606a880$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $689349132606a880$export$ffb0004e005737fa;
var $689349132606a880$export$34b9dba7ce09269b;
var $689349132606a880$export$25062201e9e25d76;
'use strict';

(function() {
    'use strict';
    var React = (parcelRequire("eeH7J"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = '' + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = '' + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, 'key')) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== 'key';
            });
            var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $689349132606a880$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $689349132606a880$export$34b9dba7ce09269b = jsx;
    $689349132606a880$export$25062201e9e25d76 = jsxs;
})();

});




parcelRegister("hikmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c973e965039ce4b4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("lzlXq")).default; });

var $j5iT3 = parcelRequire("j5iT3");

var $xHBjO = parcelRequire("xHBjO");

var $4hHwC = parcelRequire("4hHwC");

var $lzlXq = parcelRequire("lzlXq");

var $jXkrt = parcelRequire("jXkrt");
'use client';
const $c973e965039ce4b4$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($j5iT3)))({
    themeId: (0, $4hHwC.default),
    defaultTheme: $xHBjO.default,
    rootShouldForwardProp: $lzlXq.default
});
var $c973e965039ce4b4$export$2e2bcd8739ae039 = $c973e965039ce4b4$var$styled;

});
parcelRegister("j5iT3", function(module, exports) {
"use strict";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de4d227db3f9471a$var$createStyled;
module.exports.shouldForwardProp = $de4d227db3f9471a$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $de4d227db3f9471a$var$_extends2 = $aoClO((parcelRequire("eq7pw")));

var $de4d227db3f9471a$var$_objectWithoutPropertiesLoose2 = $aoClO((parcelRequire("jA2mn")));

var $de4d227db3f9471a$var$_styledEngine = $de4d227db3f9471a$var$_interopRequireWildcard((parcelRequire("jKjg1")));

var $gvqxq = parcelRequire("gvqxq");

var $de4d227db3f9471a$var$_capitalize = $aoClO((parcelRequire("dJiib")));

var $de4d227db3f9471a$var$_getDisplayName = $aoClO((parcelRequire("lwEBy")));

var $de4d227db3f9471a$var$_createTheme = $aoClO((parcelRequire("8mLQJ")));

var $de4d227db3f9471a$var$_styleFunctionSx = $aoClO((parcelRequire("8ZYrY")));
const $de4d227db3f9471a$var$_excluded = [
    "ownerState"
], $de4d227db3f9471a$var$_excluded2 = [
    "variants"
], $de4d227db3f9471a$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $de4d227db3f9471a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($de4d227db3f9471a$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $de4d227db3f9471a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $de4d227db3f9471a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $de4d227db3f9471a$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $de4d227db3f9471a$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $de4d227db3f9471a$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $de4d227db3f9471a$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $de4d227db3f9471a$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $de4d227db3f9471a$var$_createTheme.default)();
const $de4d227db3f9471a$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $de4d227db3f9471a$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $de4d227db3f9471a$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $de4d227db3f9471a$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $de4d227db3f9471a$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $de4d227db3f9471a$var$_objectWithoutPropertiesLoose2.default)(_ref, $de4d227db3f9471a$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $de4d227db3f9471a$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$de4d227db3f9471a$var$processStyleArg(resolvedStyle, (0, $de4d227db3f9471a$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $de4d227db3f9471a$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $de4d227db3f9471a$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $de4d227db3f9471a$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $de4d227db3f9471a$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $de4d227db3f9471a$var$shallowLayer((0, $de4d227db3f9471a$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $de4d227db3f9471a$var$shallowLayer((0, $de4d227db3f9471a$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $de4d227db3f9471a$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $de4d227db3f9471a$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $de4d227db3f9471a$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $de4d227db3f9471a$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $de4d227db3f9471a$var$_styleFunctionSx.default)((0, $de4d227db3f9471a$var$_extends2.default)({}, props, {
            theme: $de4d227db3f9471a$var$resolveTheme((0, $de4d227db3f9471a$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $de4d227db3f9471a$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $de4d227db3f9471a$var$defaultOverridesResolver($de4d227db3f9471a$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $de4d227db3f9471a$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $de4d227db3f9471a$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        if (componentName) // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${$de4d227db3f9471a$var$lowercaseFirstLetter(componentSlot || 'Root')}`;
        let shouldForwardPropOption = $de4d227db3f9471a$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($de4d227db3f9471a$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $de4d227db3f9471a$var$_styledEngine.default)(tag, (0, $de4d227db3f9471a$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $gvqxq.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $de4d227db3f9471a$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $de4d227db3f9471a$var$processStyleArg(stylesArg, (0, $de4d227db3f9471a$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $de4d227db3f9471a$var$resolveTheme((0, $de4d227db3f9471a$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $de4d227db3f9471a$var$processStyleArg(slotStyle, (0, $de4d227db3f9471a$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $de4d227db3f9471a$var$resolveTheme((0, $de4d227db3f9471a$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $de4d227db3f9471a$var$processStyleArg({
                    variants: themeVariants
                }, (0, $de4d227db3f9471a$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            {
                let displayName;
                if (componentName) displayName = `${componentName}${(0, $de4d227db3f9471a$var$_capitalize.default)(componentSlot || '')}`;
                if (displayName === undefined) displayName = `Styled(${(0, $de4d227db3f9471a$var$_getDisplayName.default)(tag)})`;
                Component.displayName = displayName;
            }
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("aoClO", function(module, exports) {
function $7919e4f01a316972$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $7919e4f01a316972$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eq7pw", function(module, exports) {
function $a7f93e0248e9369b$var$_extends() {
    return module.exports = $a7f93e0248e9369b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a7f93e0248e9369b$var$_extends.apply(null, arguments);
}
module.exports = $a7f93e0248e9369b$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jA2mn", function(module, exports) {
function $e41335bd938cf7d6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $e41335bd938cf7d6$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jKjg1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e601404bcdb1be68$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $e601404bcdb1be68$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $e601404bcdb1be68$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("kHakb")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("1IdKE")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("1IdKE")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("1D9gg")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("hNMeS")).default; });
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5CDJR = parcelRequire("5CDJR");

var $aFKDM = parcelRequire("aFKDM");

var $1IdKE = parcelRequire("1IdKE");
var $kHakb = parcelRequire("kHakb");

var $1D9gg = parcelRequire("1D9gg");

var $hNMeS = parcelRequire("hNMeS");
'use client';
function $e601404bcdb1be68$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5CDJR.default)(tag, options);
    return (...styles)=>{
        const component = typeof tag === 'string' ? `"${tag}"` : 'component';
        if (styles.length === 0) console.error([
            `MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`,
            'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'
        ].join('\n'));
        else if (styles.some((style)=>style === undefined)) console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
        return stylesFactory(...styles);
    };
}
const $e601404bcdb1be68$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $e601404bcdb1be68$var$wrapper = [];
function $e601404bcdb1be68$export$13a2d3ef13012b32(styles) {
    $e601404bcdb1be68$var$wrapper[0] = styles;
    return (0, $aFKDM.serializeStyles)($e601404bcdb1be68$var$wrapper);
}

});
parcelRegister("5CDJR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $417f539fd2fb9b5d$export$2e2bcd8739ae039; });

var $iUD4P = parcelRequire("iUD4P");
parcelRequire("eq7pw");

parcelRequire("aFKDM");
parcelRequire("5YKxY");
parcelRequire("eNLvO");
parcelRequire("eeH7J");
parcelRequire("de32V");
var $417f539fd2fb9b5d$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $417f539fd2fb9b5d$export$2e2bcd8739ae039 = (0, $iUD4P.default).bind(null);
$417f539fd2fb9b5d$var$tags.forEach(function(tagName) {
    $417f539fd2fb9b5d$export$2e2bcd8739ae039[tagName] = $417f539fd2fb9b5d$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("iUD4P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc4bc4d2bd1439ff$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");
parcelRequire("1IdKE");
var $kHakb = parcelRequire("kHakb");

var $aFKDM = parcelRequire("aFKDM");

var $5YKxY = parcelRequire("5YKxY");

var $eNLvO = parcelRequire("eNLvO");

var $eeH7J = parcelRequire("eeH7J");

var $de32V = parcelRequire("de32V");
var $dc4bc4d2bd1439ff$var$isBrowser = typeof document !== 'undefined';
var $dc4bc4d2bd1439ff$var$isDevelopment = false;
var $dc4bc4d2bd1439ff$var$testOmitPropsOnStringTag = (0, $de32V.default);
var $dc4bc4d2bd1439ff$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $dc4bc4d2bd1439ff$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $dc4bc4d2bd1439ff$var$testOmitPropsOnStringTag : $dc4bc4d2bd1439ff$var$testOmitPropsOnComponent;
};
var $dc4bc4d2bd1439ff$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $dc4bc4d2bd1439ff$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eNLvO.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $5YKxY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eNLvO.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$dc4bc4d2bd1439ff$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $eeH7J.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $dc4bc4d2bd1439ff$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $dc4bc4d2bd1439ff$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $dc4bc4d2bd1439ff$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $kHakb.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $eeH7J.useContext((0, $kHakb.T));
            }
            if (typeof props.className === 'string') className = (0, $eNLvO.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $aFKDM.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $dc4bc4d2bd1439ff$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($dc4bc4d2bd1439ff$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $eeH7J.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $dc4bc4d2bd1439ff$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $h4XE0.default)({}, options, nextOptions, {
                shouldForwardProp: $dc4bc4d2bd1439ff$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("1IdKE", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $13f4914729044c85$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $13f4914729044c85$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $13f4914729044c85$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("kHakb")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("kHakb")).w; });

var $kHakb = parcelRequire("kHakb");

var $eeH7J = parcelRequire("eeH7J");

var $eNLvO = parcelRequire("eNLvO");

var $5YKxY = parcelRequire("5YKxY");

var $aFKDM = parcelRequire("aFKDM");
parcelRequire("1FLCJ");
parcelRequire("eq7pw");
parcelRequire("6q2Od");

parcelRequire("3ojZ1");
var $13f4914729044c85$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $kHakb.h).call(props, 'css')) return $eeH7J.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $kHakb.E);
    createElementArgArray[1] = (0, $kHakb.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $eeH7J.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($13f4914729044c85$export$c8a8987d4410bf2d || ($13f4914729044c85$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $13f4914729044c85$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $kHakb.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $aFKDM.serializeStyles)([
        styles
    ], undefined, $eeH7J.useContext((0, $kHakb.T)));
    if (!(0, $kHakb.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $eeH7J.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eeH7J.useRef();
    (0, $5YKxY.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $5YKxY.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $eNLvO.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $13f4914729044c85$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $aFKDM.serializeStyles)(args);
}
function $13f4914729044c85$export$d25ddfdf17c3ad3e() {
    var insertable = $13f4914729044c85$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $13f4914729044c85$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $13f4914729044c85$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $eNLvO.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $13f4914729044c85$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $5YKxY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $eNLvO.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $kHakb.i) && res !== undefined) rules += res;
        }
        if (!(0, $kHakb.i)) return rules;
    });
    if (!(0, $kHakb.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $eeH7J.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $13f4914729044c85$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $kHakb.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $kHakb.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $aFKDM.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $eNLvO.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $kHakb.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $13f4914729044c85$var$merge(cache.registered, css, $13f4914729044c85$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eeH7J.useContext((0, $kHakb.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($13f4914729044c85$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("kHakb", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $f10fd50637a04bde$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $f10fd50637a04bde$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $f10fd50637a04bde$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $f10fd50637a04bde$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $f10fd50637a04bde$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $f10fd50637a04bde$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $f10fd50637a04bde$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $f10fd50637a04bde$export$a9c23c6ac3fc3eca; });

var $eeH7J = parcelRequire("eeH7J");

var $1FLCJ = parcelRequire("1FLCJ");

var $h4XE0 = parcelRequire("h4XE0");

var $6q2Od = parcelRequire("6q2Od");

var $4x8zX = parcelRequire("4x8zX");

var $eNLvO = parcelRequire("eNLvO");

var $aFKDM = parcelRequire("aFKDM");

var $5YKxY = parcelRequire("5YKxY");
var $f10fd50637a04bde$export$407448d2b89b1813 = false;
var $f10fd50637a04bde$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $f10fd50637a04bde$var$EmotionCacheContext = /* #__PURE__ */ $eeH7J.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $1FLCJ.default)({
    key: 'css'
}) : null);
var $f10fd50637a04bde$export$e7094788287c5e9b = $f10fd50637a04bde$var$EmotionCacheContext.Provider;
var $f10fd50637a04bde$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $eeH7J.useContext)($f10fd50637a04bde$var$EmotionCacheContext);
};
var $f10fd50637a04bde$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eeH7J.useContext)($f10fd50637a04bde$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$f10fd50637a04bde$export$23f2a1d2818174ef) $f10fd50637a04bde$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $eeH7J.useContext)($f10fd50637a04bde$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $1FLCJ.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $eeH7J.createElement($f10fd50637a04bde$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $f10fd50637a04bde$export$971d5caa766a69d7 = /* #__PURE__ */ $eeH7J.createContext({});
var $f10fd50637a04bde$export$3b14a55fb2447963 = function useTheme() {
    return $eeH7J.useContext($f10fd50637a04bde$export$971d5caa766a69d7);
};
var $f10fd50637a04bde$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $h4XE0.default)({}, outerTheme, theme);
};
var $f10fd50637a04bde$var$createCacheWithTheme = /* #__PURE__ */ (0, $6q2Od.default)(function(outerTheme) {
    return (0, $6q2Od.default)(function(theme) {
        return $f10fd50637a04bde$var$getTheme(outerTheme, theme);
    });
});
var $f10fd50637a04bde$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $eeH7J.useContext($f10fd50637a04bde$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $f10fd50637a04bde$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eeH7J.createElement($f10fd50637a04bde$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $f10fd50637a04bde$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $eeH7J.forwardRef(function render(props, ref) {
        var theme = $eeH7J.useContext($f10fd50637a04bde$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eeH7J.createElement(Component, (0, $h4XE0.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $4x8zX.default)(WithTheme, Component);
}
var $f10fd50637a04bde$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $f10fd50637a04bde$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $f10fd50637a04bde$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($f10fd50637a04bde$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$f10fd50637a04bde$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $f10fd50637a04bde$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eNLvO.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $5YKxY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eNLvO.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f10fd50637a04bde$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $eeH7J.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f10fd50637a04bde$var$Emotion = /* #__PURE__ */ $f10fd50637a04bde$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$f10fd50637a04bde$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $eNLvO.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $aFKDM.serializeStyles)(registeredStyles, undefined, $eeH7J.useContext($f10fd50637a04bde$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($f10fd50637a04bde$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $f10fd50637a04bde$var$typePropName && !$f10fd50637a04bde$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($f10fd50637a04bde$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $eeH7J.createElement(WrappedComponent, newProps));
});
var $f10fd50637a04bde$export$a9c23c6ac3fc3eca = $f10fd50637a04bde$var$Emotion;

});
parcelRegister("1FLCJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $137e8fdb53ee3dd8$export$2e2bcd8739ae039; });

var $ljtBt = parcelRequire("ljtBt");

var $8SDLF = parcelRequire("8SDLF");

var $6q2Od = parcelRequire("6q2Od");

var $d5hMW = parcelRequire("d5hMW");
var $137e8fdb53ee3dd8$var$isBrowser = typeof document !== 'undefined';
var $137e8fdb53ee3dd8$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $8SDLF.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $8SDLF.token)(character)) break;
        (0, $8SDLF.next)();
    }
    return (0, $8SDLF.slice)(begin, (0, $8SDLF.position));
};
var $137e8fdb53ee3dd8$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $8SDLF.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $8SDLF.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $137e8fdb53ee3dd8$var$identifierWithPointTracking((0, $8SDLF.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $8SDLF.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $8SDLF.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $8SDLF.from)(character);
    }
    while (character = (0, $8SDLF.next)());
    return parsed;
};
var $137e8fdb53ee3dd8$var$getRules = function getRules(value, points) {
    return (0, $8SDLF.dealloc)($137e8fdb53ee3dd8$var$toRules((0, $8SDLF.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $137e8fdb53ee3dd8$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $137e8fdb53ee3dd8$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$137e8fdb53ee3dd8$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $137e8fdb53ee3dd8$var$fixedElements.set(element, true);
    var points = [];
    var rules = $137e8fdb53ee3dd8$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $137e8fdb53ee3dd8$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $137e8fdb53ee3dd8$var$prefix(value, length) {
    switch((0, $8SDLF.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $8SDLF.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $8SDLF.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MOZ) + value + (0, $8SDLF.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + value + value;
        // order
        case 6165:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.replace)(value, /(\w+).+(:[^]+)/, (0, $8SDLF.WEBKIT) + 'box-$1$2' + (0, $8SDLF.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + 'flex-item-' + (0, $8SDLF.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + 'flex-line-pack' + (0, $8SDLF.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $8SDLF.WEBKIT) + 'box-' + (0, $8SDLF.replace)(value, '-grow', '') + (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $8SDLF.WEBKIT) + (0, $8SDLF.replace)(value, /([^-])(transform)/g, '$1' + (0, $8SDLF.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $8SDLF.replace)((0, $8SDLF.replace)((0, $8SDLF.replace)(value, /(zoom-|grab)/, (0, $8SDLF.WEBKIT) + '$1'), /(image-set)/, (0, $8SDLF.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $8SDLF.replace)(value, /(image-set\([^]*)/, (0, $8SDLF.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $8SDLF.replace)((0, $8SDLF.replace)(value, /(.+:)(flex-)?(.*)/, (0, $8SDLF.WEBKIT) + 'box-pack:$3' + (0, $8SDLF.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $8SDLF.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $8SDLF.replace)(value, /(.+)-inline(.+)/, (0, $8SDLF.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $8SDLF.strlen)(value) - 1 - length > 6) switch((0, $8SDLF.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $8SDLF.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $8SDLF.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $8SDLF.WEBKIT) + '$2-$3' + '$1' + (0, $8SDLF.MOZ) + ((0, $8SDLF.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $8SDLF.indexof)(value, 'stretch') ? $137e8fdb53ee3dd8$var$prefix((0, $8SDLF.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $8SDLF.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $8SDLF.charat)(value, (0, $8SDLF.strlen)(value) - 3 - (~(0, $8SDLF.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $8SDLF.replace)(value, ':', ':' + (0, $8SDLF.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $8SDLF.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $8SDLF.WEBKIT) + ((0, $8SDLF.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $8SDLF.WEBKIT) + '$2$3' + '$1' + (0, $8SDLF.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $8SDLF.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + value + value;
    }
    return value;
}
var $137e8fdb53ee3dd8$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $8SDLF.DECLARATION:
                element["return"] = $137e8fdb53ee3dd8$var$prefix(element.value, element.length);
                break;
            case 0, $8SDLF.KEYFRAMES:
                return (0, $8SDLF.serialize)([
                    (0, $8SDLF.copy)(element, {
                        value: (0, $8SDLF.replace)(element.value, '@', '@' + (0, $8SDLF.WEBKIT))
                    })
                ], callback);
            case 0, $8SDLF.RULESET:
                if (element.length) return (0, $8SDLF.combine)(element.props, function(value) {
                    switch((0, $8SDLF.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8SDLF.serialize)([
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(read-\w+)/, ':' + (0, $8SDLF.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8SDLF.serialize)([
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, ':' + (0, $8SDLF.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, ':' + (0, $8SDLF.MOZ) + '$1')
                                    ]
                                }),
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, (0, $8SDLF.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $137e8fdb53ee3dd8$var$getServerStylisCache = $137e8fdb53ee3dd8$var$isBrowser ? undefined : (0, $6q2Od.default)(function() {
    return (0, $d5hMW.default)(function() {
        return {};
    });
});
var $137e8fdb53ee3dd8$var$defaultStylisPlugins = [
    $137e8fdb53ee3dd8$var$prefixer
];
var $137e8fdb53ee3dd8$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($137e8fdb53ee3dd8$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $137e8fdb53ee3dd8$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($137e8fdb53ee3dd8$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $137e8fdb53ee3dd8$var$compat,
        $137e8fdb53ee3dd8$var$removeLabel
    ];
    if (!$137e8fdb53ee3dd8$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $8SDLF.stringify),
            (0, $8SDLF.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $8SDLF.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $8SDLF.serialize)((0, $8SDLF.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $8SDLF.stringify)
        ];
        var _serializer = (0, $8SDLF.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $8SDLF.serialize)((0, $8SDLF.compile)(styles), _serializer);
        };
        var serverStylisCache = $137e8fdb53ee3dd8$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $ljtBt.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("ljtBt", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $f84255f78a4c850c$export$9d753cd7ae895cce; });
var $f84255f78a4c850c$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $f84255f78a4c850c$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $f84255f78a4c850c$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $f84255f78a4c850c$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$f84255f78a4c850c$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($f84255f78a4c850c$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $f84255f78a4c850c$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("8SDLF", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $13b056f6b69c32bc$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $13b056f6b69c32bc$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $13b056f6b69c32bc$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $13b056f6b69c32bc$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $13b056f6b69c32bc$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $13b056f6b69c32bc$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $13b056f6b69c32bc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $13b056f6b69c32bc$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $13b056f6b69c32bc$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $13b056f6b69c32bc$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $13b056f6b69c32bc$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $13b056f6b69c32bc$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $13b056f6b69c32bc$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $13b056f6b69c32bc$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $13b056f6b69c32bc$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $13b056f6b69c32bc$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $13b056f6b69c32bc$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $13b056f6b69c32bc$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $13b056f6b69c32bc$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $13b056f6b69c32bc$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $13b056f6b69c32bc$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $13b056f6b69c32bc$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $13b056f6b69c32bc$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $13b056f6b69c32bc$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $13b056f6b69c32bc$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $13b056f6b69c32bc$export$38bcb760f1d4871c; });
var $13b056f6b69c32bc$export$71ad59f2e432cfe8 = "-ms-";
var $13b056f6b69c32bc$export$2c0f367103c8d01c = "-moz-";
var $13b056f6b69c32bc$export$39dfd62a25e0fe93 = "-webkit-";
var $13b056f6b69c32bc$export$a29989082612d0d9 = "comm";
var $13b056f6b69c32bc$export$aa3a2e812ca8570d = "rule";
var $13b056f6b69c32bc$export$527d108ccf083c2b = "decl";
var $13b056f6b69c32bc$export$d3d35020fa5b54f0 = "@page";
var $13b056f6b69c32bc$export$500415a86c544f73 = "@media";
var $13b056f6b69c32bc$export$a763edbf796b780a = "@import";
var $13b056f6b69c32bc$export$2790aeb8b4e5c826 = "@charset";
var $13b056f6b69c32bc$export$1cc683e23b84b133 = "@viewport";
var $13b056f6b69c32bc$export$9447a5efea57e862 = "@supports";
var $13b056f6b69c32bc$export$ef011b4e114b1fba = "@document";
var $13b056f6b69c32bc$export$6aad947bda0f3f46 = "@namespace";
var $13b056f6b69c32bc$export$b44a8529a35fcb60 = "@keyframes";
var $13b056f6b69c32bc$export$2c16de31893252e6 = "@font-face";
var $13b056f6b69c32bc$export$3d846dd52e150c6f = "@counter-style";
var $13b056f6b69c32bc$export$22314bfbb57653fe = "@font-feature-values";
var $13b056f6b69c32bc$export$d773506282b3cfe6 = "@layer";
var $13b056f6b69c32bc$export$2335f513bbd82c6d = Math.abs;
var $13b056f6b69c32bc$export$6788812c4e6611e6 = String.fromCharCode;
var $13b056f6b69c32bc$export$e6e34fd1f2686227 = Object.assign;
function $13b056f6b69c32bc$export$d6af199866bfb566(e, r) {
    return $13b056f6b69c32bc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 0)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 1)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 2)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 3) : 0;
}
function $13b056f6b69c32bc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $13b056f6b69c32bc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $13b056f6b69c32bc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $13b056f6b69c32bc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $13b056f6b69c32bc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $13b056f6b69c32bc$export$36776f635604f274(e) {
    return e.length;
}
function $13b056f6b69c32bc$export$f9084667e487ed46(e) {
    return e.length;
}
function $13b056f6b69c32bc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $13b056f6b69c32bc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $13b056f6b69c32bc$export$53f1d5ea8de3d7c = 1;
var $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1;
var $13b056f6b69c32bc$export$f24224f1c91d8156 = 0;
var $13b056f6b69c32bc$export$5880b8b5730aff45 = 0;
var $13b056f6b69c32bc$export$c0306caf338ac095 = 0;
var $13b056f6b69c32bc$export$30a86d91af8ff6e6 = "";
function $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $13b056f6b69c32bc$export$53f1d5ea8de3d7c,
        column: $13b056f6b69c32bc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $13b056f6b69c32bc$export$784d13d8ee351f07(e, r) {
    return $13b056f6b69c32bc$export$e6e34fd1f2686227($13b056f6b69c32bc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $13b056f6b69c32bc$export$eba6f6f03b0a92e7() {
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$232faf9add678146() {
    $13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$5880b8b5730aff45 > 0 ? $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, --$13b056f6b69c32bc$export$5880b8b5730aff45) : 0;
    if ($13b056f6b69c32bc$export$4e0c71f277ca26b3--, $13b056f6b69c32bc$export$c0306caf338ac095 === 10) $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$53f1d5ea8de3d7c--;
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$48cfd1e771a65c4f() {
    $13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$5880b8b5730aff45 < $13b056f6b69c32bc$export$f24224f1c91d8156 ? $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, $13b056f6b69c32bc$export$5880b8b5730aff45++) : 0;
    if ($13b056f6b69c32bc$export$4e0c71f277ca26b3++, $13b056f6b69c32bc$export$c0306caf338ac095 === 10) $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$53f1d5ea8de3d7c++;
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$4d3fb11e950abb9e() {
    return $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, $13b056f6b69c32bc$export$5880b8b5730aff45);
}
function $13b056f6b69c32bc$export$e88cb2efb12ae807() {
    return $13b056f6b69c32bc$export$5880b8b5730aff45;
}
function $13b056f6b69c32bc$export$58adb3bec8346d0f(e, r) {
    return $13b056f6b69c32bc$export$2f35ab04d2335697($13b056f6b69c32bc$export$30a86d91af8ff6e6, e, r);
}
function $13b056f6b69c32bc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $13b056f6b69c32bc$export$2de70f21292aac9e(e) {
    return $13b056f6b69c32bc$export$53f1d5ea8de3d7c = $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$f24224f1c91d8156 = $13b056f6b69c32bc$export$36776f635604f274($13b056f6b69c32bc$export$30a86d91af8ff6e6 = e), $13b056f6b69c32bc$export$5880b8b5730aff45 = 0, [];
}
function $13b056f6b69c32bc$export$45918ac1574455b1(e) {
    return $13b056f6b69c32bc$export$30a86d91af8ff6e6 = "", e;
}
function $13b056f6b69c32bc$export$410ac95b9ec204b8(e) {
    return $13b056f6b69c32bc$export$87c2784dc9fc4ab($13b056f6b69c32bc$export$58adb3bec8346d0f($13b056f6b69c32bc$export$5880b8b5730aff45 - 1, $13b056f6b69c32bc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $13b056f6b69c32bc$export$660b2ee2d4fb4eff(e) {
    return $13b056f6b69c32bc$export$45918ac1574455b1($13b056f6b69c32bc$export$5f8c09e3ae6f64e1($13b056f6b69c32bc$export$2de70f21292aac9e(e)));
}
function $13b056f6b69c32bc$export$7af1228ff777d175(e) {
    while($13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$4d3fb11e950abb9e())if ($13b056f6b69c32bc$export$c0306caf338ac095 < 33) $13b056f6b69c32bc$export$48cfd1e771a65c4f();
    else break;
    return $13b056f6b69c32bc$export$9e1725a4cfeada27(e) > 2 || $13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $13b056f6b69c32bc$export$5f8c09e3ae6f64e1(e) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())switch($13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$c0306caf338ac095)){
        case 0:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$c2ab62c7bf24634($13b056f6b69c32bc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$410ac95b9ec204b8($13b056f6b69c32bc$export$c0306caf338ac095), e);
            break;
        default:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$6788812c4e6611e6($13b056f6b69c32bc$export$c0306caf338ac095), e);
    }
    return e;
}
function $13b056f6b69c32bc$export$955ba06d119e085e(e, r) {
    while(--r && $13b056f6b69c32bc$export$48cfd1e771a65c4f())if ($13b056f6b69c32bc$export$c0306caf338ac095 < 48 || $13b056f6b69c32bc$export$c0306caf338ac095 > 102 || $13b056f6b69c32bc$export$c0306caf338ac095 > 57 && $13b056f6b69c32bc$export$c0306caf338ac095 < 65 || $13b056f6b69c32bc$export$c0306caf338ac095 > 70 && $13b056f6b69c32bc$export$c0306caf338ac095 < 97) break;
    return $13b056f6b69c32bc$export$58adb3bec8346d0f(e, $13b056f6b69c32bc$export$e88cb2efb12ae807() + (r < 6 && $13b056f6b69c32bc$export$4d3fb11e950abb9e() == 32 && $13b056f6b69c32bc$export$48cfd1e771a65c4f() == 32));
}
function $13b056f6b69c32bc$export$c889f2fcc19dbf12(e) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())switch($13b056f6b69c32bc$export$c0306caf338ac095){
        case e:
            return $13b056f6b69c32bc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $13b056f6b69c32bc$export$c889f2fcc19dbf12($13b056f6b69c32bc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $13b056f6b69c32bc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $13b056f6b69c32bc$export$48cfd1e771a65c4f();
            break;
    }
    return $13b056f6b69c32bc$export$5880b8b5730aff45;
}
function $13b056f6b69c32bc$export$4254d4e2b3745c4c(e, r) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())if (e + $13b056f6b69c32bc$export$c0306caf338ac095 === 57) break;
    else if (e + $13b056f6b69c32bc$export$c0306caf338ac095 === 84 && $13b056f6b69c32bc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $13b056f6b69c32bc$export$58adb3bec8346d0f(r, $13b056f6b69c32bc$export$5880b8b5730aff45 - 1) + "*" + $13b056f6b69c32bc$export$6788812c4e6611e6(e === 47 ? e : $13b056f6b69c32bc$export$48cfd1e771a65c4f());
}
function $13b056f6b69c32bc$export$c2ab62c7bf24634(e) {
    while(!$13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$4d3fb11e950abb9e()))$13b056f6b69c32bc$export$48cfd1e771a65c4f();
    return $13b056f6b69c32bc$export$58adb3bec8346d0f(e, $13b056f6b69c32bc$export$5880b8b5730aff45);
}
function $13b056f6b69c32bc$export$ef7acd7185315e22(e) {
    return $13b056f6b69c32bc$export$45918ac1574455b1($13b056f6b69c32bc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $13b056f6b69c32bc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $13b056f6b69c32bc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $13b056f6b69c32bc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $13b056f6b69c32bc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($13b056f6b69c32bc$export$f8e21b1e77979a08(j += $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $13b056f6b69c32bc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $13b056f6b69c32bc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $13b056f6b69c32bc$export$955ba06d119e085e($13b056f6b69c32bc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($13b056f6b69c32bc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$4a34f930e789283c($13b056f6b69c32bc$export$4254d4e2b3745c4c($13b056f6b69c32bc$export$48cfd1e771a65c4f(), $13b056f6b69c32bc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $13b056f6b69c32bc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $13b056f6b69c32bc$export$36776f635604f274(j) - l) $13b056f6b69c32bc$export$10d8903dec122b9d(p > 32 ? $13b056f6b69c32bc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $13b056f6b69c32bc$export$f8483753829ec8f3($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $13b056f6b69c32bc$export$10d8903dec122b9d(y = $13b056f6b69c32bc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $13b056f6b69c32bc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $13b056f6b69c32bc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $13b056f6b69c32bc$export$98e6a39c04603d36(e, y, y, n && $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $13b056f6b69c32bc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $13b056f6b69c32bc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $13b056f6b69c32bc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $13b056f6b69c32bc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($13b056f6b69c32bc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($13b056f6b69c32bc$export$4d3fb11e950abb9e() === 45) j += $13b056f6b69c32bc$export$410ac95b9ec204b8($13b056f6b69c32bc$export$48cfd1e771a65c4f());
                    v = $13b056f6b69c32bc$export$4d3fb11e950abb9e(), o = l = $13b056f6b69c32bc$export$36776f635604f274(g = j += $13b056f6b69c32bc$export$c2ab62c7bf24634($13b056f6b69c32bc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $13b056f6b69c32bc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $13b056f6b69c32bc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $13b056f6b69c32bc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $13b056f6b69c32bc$export$2f35ab04d2335697(e, v + 1, v = $13b056f6b69c32bc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $13b056f6b69c32bc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, s === 0 ? $13b056f6b69c32bc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $13b056f6b69c32bc$export$4a34f930e789283c(e, r, a) {
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, $13b056f6b69c32bc$export$a29989082612d0d9, $13b056f6b69c32bc$export$6788812c4e6611e6($13b056f6b69c32bc$export$eba6f6f03b0a92e7()), $13b056f6b69c32bc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $13b056f6b69c32bc$export$f8483753829ec8f3(e, r, a, n) {
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, $13b056f6b69c32bc$export$527d108ccf083c2b, $13b056f6b69c32bc$export$2f35ab04d2335697(e, 0, n), $13b056f6b69c32bc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $13b056f6b69c32bc$export$82e9f45cca5ba907(n, c, s) {
    switch($13b056f6b69c32bc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $13b056f6b69c32bc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$2c0f367103c8d01c + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-$1$2" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-item-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-row-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-line-pack" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-pack:$3" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-column-align" + $13b056f6b69c32bc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $13b056f6b69c32bc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$13b056f6b69c32bc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$13b056f6b69c32bc$export$f8e21b1e77979a08(s, "span") ? $13b056f6b69c32bc$export$4659b591c19bdf3d(s, /\d+/) : +$13b056f6b69c32bc$export$4659b591c19bdf3d(s, /\d+/) - +$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $13b056f6b69c32bc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($13b056f6b69c32bc$export$36776f635604f274(n) - 1 - c > 6) switch($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $13b056f6b69c32bc$export$2c0f367103c8d01c + ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$13b056f6b69c32bc$export$f8e21b1e77979a08(n, "stretch") ? $13b056f6b69c32bc$export$82e9f45cca5ba907($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $13b056f6b69c32bc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 6) === 121) return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $13b056f6b69c32bc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($13b056f6b69c32bc$export$a9db5e087081082d(n, $13b056f6b69c32bc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + ($13b056f6b69c32bc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $13b056f6b69c32bc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $13b056f6b69c32bc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $13b056f6b69c32bc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $13b056f6b69c32bc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $13b056f6b69c32bc$export$a763edbf796b780a:
        case $13b056f6b69c32bc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $13b056f6b69c32bc$export$a29989082612d0d9:
            return "";
        case $13b056f6b69c32bc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $13b056f6b69c32bc$export$36776f635604f274(a = $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $13b056f6b69c32bc$export$5a7767152ae0305f(e) {
    var r = $13b056f6b69c32bc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $13b056f6b69c32bc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $13b056f6b69c32bc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $13b056f6b69c32bc$export$527d108ccf083c2b:
                n.return = $13b056f6b69c32bc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $13b056f6b69c32bc$export$b44a8529a35fcb60:
                return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                    $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                        value: $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $13b056f6b69c32bc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
                if (n.length) return $13b056f6b69c32bc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($13b056f6b69c32bc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $13b056f6b69c32bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $13b056f6b69c32bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $13b056f6b69c32bc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $13b056f6b69c32bc$export$1be1fc439b849fdf($13b056f6b69c32bc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($13b056f6b69c32bc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $13b056f6b69c32bc$export$2f35ab04d2335697(r, 1, $13b056f6b69c32bc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $13b056f6b69c32bc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $13b056f6b69c32bc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $13b056f6b69c32bc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("6q2Od", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ac759958d9264be$export$2e2bcd8739ae039; });
var $4ac759958d9264be$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("d5hMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98698a5e781a3a77$export$2e2bcd8739ae039; });
function $98698a5e781a3a77$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4x8zX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d0e61215740556$export$2e2bcd8739ae039; });

var $3ojZ1 = parcelRequire("3ojZ1");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $34d0e61215740556$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ojZ1)))(targetComponent, sourceComponent);
};

});
parcelRegister("3ojZ1", function(module, exports) {
'use strict';

var $ittWF = parcelRequire("ittWF");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $27831d414646f384$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $27831d414646f384$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $27831d414646f384$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $27831d414646f384$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $27831d414646f384$var$TYPE_STATICS = {};
$27831d414646f384$var$TYPE_STATICS[$ittWF.ForwardRef] = $27831d414646f384$var$FORWARD_REF_STATICS;
$27831d414646f384$var$TYPE_STATICS[$ittWF.Memo] = $27831d414646f384$var$MEMO_STATICS;
function $27831d414646f384$var$getStatics(component) {
    // React v16.11 and below
    if ($ittWF.isMemo(component)) return $27831d414646f384$var$MEMO_STATICS;
     // React v16.12 and above
    return $27831d414646f384$var$TYPE_STATICS[component['$$typeof']] || $27831d414646f384$var$REACT_STATICS;
}
var $27831d414646f384$var$defineProperty = Object.defineProperty;
var $27831d414646f384$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $27831d414646f384$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $27831d414646f384$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $27831d414646f384$var$getPrototypeOf = Object.getPrototypeOf;
var $27831d414646f384$var$objectPrototype = Object.prototype;
function $27831d414646f384$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($27831d414646f384$var$objectPrototype) {
            var inheritedComponent = $27831d414646f384$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $27831d414646f384$var$objectPrototype) $27831d414646f384$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $27831d414646f384$var$getOwnPropertyNames(sourceComponent);
        if ($27831d414646f384$var$getOwnPropertySymbols) keys = keys.concat($27831d414646f384$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $27831d414646f384$var$getStatics(targetComponent);
        var sourceStatics = $27831d414646f384$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$27831d414646f384$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $27831d414646f384$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $27831d414646f384$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $27831d414646f384$var$hoistNonReactStatics;

});


parcelRegister("eNLvO", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $ac6a7f3910b5ff63$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $ac6a7f3910b5ff63$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $ac6a7f3910b5ff63$export$6f077d94b33a01aa; });
var $ac6a7f3910b5ff63$var$isBrowser = typeof document !== 'undefined';
function $ac6a7f3910b5ff63$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $ac6a7f3910b5ff63$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ac6a7f3910b5ff63$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ac6a7f3910b5ff63$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ac6a7f3910b5ff63$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$ac6a7f3910b5ff63$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$ac6a7f3910b5ff63$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("aFKDM", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $7c51e98d03ccb2e4$export$6321afa313b251b5; });

var $g3tXG = parcelRequire("g3tXG");

var $3Lp5J = parcelRequire("3Lp5J");

var $d5hMW = parcelRequire("d5hMW");
var $7c51e98d03ccb2e4$var$isDevelopment = false;
var $7c51e98d03ccb2e4$var$hyphenateRegex = /[A-Z]|^ms/g;
var $7c51e98d03ccb2e4$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $7c51e98d03ccb2e4$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $7c51e98d03ccb2e4$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $7c51e98d03ccb2e4$var$processStyleName = /* #__PURE__ */ (0, $d5hMW.default)(function(styleName) {
    return $7c51e98d03ccb2e4$var$isCustomProperty(styleName) ? styleName : styleName.replace($7c51e98d03ccb2e4$var$hyphenateRegex, '-$&').toLowerCase();
});
var $7c51e98d03ccb2e4$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($7c51e98d03ccb2e4$var$animationRegex, function(match, p1, p2) {
                $7c51e98d03ccb2e4$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $7c51e98d03ccb2e4$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3Lp5J.default)[key] !== 1 && !$7c51e98d03ccb2e4$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $7c51e98d03ccb2e4$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $7c51e98d03ccb2e4$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $7c51e98d03ccb2e4$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $7c51e98d03ccb2e4$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $7c51e98d03ccb2e4$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $7c51e98d03ccb2e4$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $7c51e98d03ccb2e4$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $7c51e98d03ccb2e4$var$cursor;
                var result = interpolation(mergedProps);
                $7c51e98d03ccb2e4$var$cursor = previousCursor;
                return $7c51e98d03ccb2e4$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $7c51e98d03ccb2e4$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $7c51e98d03ccb2e4$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($7c51e98d03ccb2e4$var$isProcessableValue(asString)) string += $7c51e98d03ccb2e4$var$processStyleName(key) + ":" + $7c51e98d03ccb2e4$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $7c51e98d03ccb2e4$var$isDevelopment) throw new Error($7c51e98d03ccb2e4$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($7c51e98d03ccb2e4$var$isProcessableValue(value[_i])) string += $7c51e98d03ccb2e4$var$processStyleName(key) + ":" + $7c51e98d03ccb2e4$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $7c51e98d03ccb2e4$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $7c51e98d03ccb2e4$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $7c51e98d03ccb2e4$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $7c51e98d03ccb2e4$var$cursor;
function $7c51e98d03ccb2e4$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $7c51e98d03ccb2e4$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $7c51e98d03ccb2e4$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $7c51e98d03ccb2e4$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $7c51e98d03ccb2e4$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $7c51e98d03ccb2e4$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $g3tXG.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $7c51e98d03ccb2e4$var$cursor
    };
}

});
parcelRegister("g3tXG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb042aec4fffa986$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $bb042aec4fffa986$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3Lp5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bd939849740902a$export$2e2bcd8739ae039; });
var $2bd939849740902a$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("5YKxY", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $45a6a99454d732a7$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $45a6a99454d732a7$export$811a713a7276cb9d; });

var $eeH7J = parcelRequire("eeH7J");
var $45a6a99454d732a7$var$isBrowser = typeof document !== 'undefined';
var $45a6a99454d732a7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $45a6a99454d732a7$var$useInsertionEffect = $eeH7J.useInsertionEffect ? $eeH7J.useInsertionEffect : false;
var $45a6a99454d732a7$export$db21c7ffa21794e7 = !$45a6a99454d732a7$var$isBrowser ? $45a6a99454d732a7$var$syncFallback : $45a6a99454d732a7$var$useInsertionEffect || $45a6a99454d732a7$var$syncFallback;
var $45a6a99454d732a7$export$811a713a7276cb9d = $45a6a99454d732a7$var$useInsertionEffect || $eeH7J.useLayoutEffect;

});



parcelRegister("de32V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a0ef20d80bd1f47$export$2e2bcd8739ae039; });

var $d5hMW = parcelRequire("d5hMW");
// eslint-disable-next-line no-undef
var $9a0ef20d80bd1f47$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $9a0ef20d80bd1f47$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $d5hMW.default)(function(prop) {
    return $9a0ef20d80bd1f47$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("1D9gg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13009e15e2d861d3$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $kHakb = parcelRequire("kHakb");

var $1FLCJ = parcelRequire("1FLCJ");

var $dRzna = parcelRequire("dRzna");
'use client';
function $13009e15e2d861d3$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $1FLCJ.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $13009e15e2d861d3$var$cacheMap = new Map();
function $13009e15e2d861d3$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $eeH7J.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $13009e15e2d861d3$var$cacheMap.has(cacheKey)) return $13009e15e2d861d3$var$cacheMap.get(cacheKey);
        const fresh = $13009e15e2d861d3$var$getCache(injectFirst, enableCssLayer);
        $13009e15e2d861d3$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $dRzna.jsx)((0, $kHakb.C), {
        value: cache,
        children: children
    });
    return children;
}
$13009e15e2d861d3$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If true, MUI styles are wrapped in CSS `@layer mui` rule.
   * It helps to override MUI styles when using CSS Modules, Tailwind CSS, plain CSS, or any other styling solution.
   */ enableCssLayer: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */ injectFirst: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
};

});

parcelRegister("hNMeS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5c6e8ac33a3011$export$2e2bcd8739ae039; });
parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $1IdKE = parcelRequire("1IdKE");

var $dRzna = parcelRequire("dRzna");
'use client';
function $cf5c6e8ac33a3011$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $cf5c6e8ac33a3011$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($cf5c6e8ac33a3011$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $1IdKE.Global), {
        styles: globalStyles
    });
}
$cf5c6e8ac33a3011$export$2e2bcd8739ae039.propTypes = {
    defaultTheme: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ])
};

});


parcelRegister("gvqxq", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $c0442081528d98bf$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $c0442081528d98bf$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");
function $c0442081528d98bf$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $c0442081528d98bf$var$deepClone(source) {
    if (/*#__PURE__*/ $eeH7J.isValidElement(source) || !$c0442081528d98bf$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $c0442081528d98bf$var$deepClone(source[key]);
    });
    return output;
}
function $c0442081528d98bf$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $h4XE0.default)({}, target) : target;
    if ($c0442081528d98bf$export$53b83ca8eaab0383(target) && $c0442081528d98bf$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $eeH7J.isValidElement(source[key])) output[key] = source[key];
        else if ($c0442081528d98bf$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $c0442081528d98bf$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $c0442081528d98bf$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $c0442081528d98bf$export$53b83ca8eaab0383(source[key]) ? $c0442081528d98bf$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("dJiib", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3Rthm")).default; });

var $3Rthm = parcelRequire("3Rthm");

});

parcelRegister("lwEBy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cXju3")).default; });

var $cXju3 = parcelRequire("cXju3");
$parcel$exportWildcard(module.exports, $cXju3);

});
parcelRegister("cXju3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $96ea1bc4afa3ad57$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $96ea1bc4afa3ad57$export$2e2bcd8739ae039; });

var $lxnRr = parcelRequire("lxnRr");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $96ea1bc4afa3ad57$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $96ea1bc4afa3ad57$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($96ea1bc4afa3ad57$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $96ea1bc4afa3ad57$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $96ea1bc4afa3ad57$export$aad197c7121a6651(Component) || fallback;
}
function $96ea1bc4afa3ad57$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $96ea1bc4afa3ad57$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $96ea1bc4afa3ad57$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $96ea1bc4afa3ad57$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $lxnRr.ForwardRef:
            return $96ea1bc4afa3ad57$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $lxnRr.Memo:
            return $96ea1bc4afa3ad57$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("lxnRr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("knq2V"));

});
parcelRegister("knq2V", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ed5a28d8399e5e68$export$a7c73072b1a182ae; }, function (v) { return $ed5a28d8399e5e68$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ed5a28d8399e5e68$export$9f27bc3417b4524d; }, function (v) { return $ed5a28d8399e5e68$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ed5a28d8399e5e68$export$db77ccec0bb4ccac; }, function (v) { return $ed5a28d8399e5e68$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ed5a28d8399e5e68$export$8392c0c9d3dcbd35; }, function (v) { return $ed5a28d8399e5e68$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ed5a28d8399e5e68$export$ffb0004e005737fa; }, function (v) { return $ed5a28d8399e5e68$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ed5a28d8399e5e68$export$b624eff549462981; }, function (v) { return $ed5a28d8399e5e68$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ed5a28d8399e5e68$export$7897aa7841a5380c; }, function (v) { return $ed5a28d8399e5e68$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ed5a28d8399e5e68$export$602eac185826482c; }, function (v) { return $ed5a28d8399e5e68$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ed5a28d8399e5e68$export$e2c29f18771995cb; }, function (v) { return $ed5a28d8399e5e68$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ed5a28d8399e5e68$export$5f8d39834fd61797; }, function (v) { return $ed5a28d8399e5e68$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ed5a28d8399e5e68$export$74bf444e3cd11ea5; }, function (v) { return $ed5a28d8399e5e68$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ed5a28d8399e5e68$export$998bcd577473dd93; }, function (v) { return $ed5a28d8399e5e68$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ed5a28d8399e5e68$export$b706b080d889d2c9; }, function (v) { return $ed5a28d8399e5e68$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ed5a28d8399e5e68$export$5be5a87408f70ddc; }, function (v) { return $ed5a28d8399e5e68$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ed5a28d8399e5e68$export$45a5e7f76e0caa8d; }, function (v) { return $ed5a28d8399e5e68$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ed5a28d8399e5e68$export$455c2e768291efa6; }, function (v) { return $ed5a28d8399e5e68$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ed5a28d8399e5e68$export$9522e17588c12572; }, function (v) { return $ed5a28d8399e5e68$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ed5a28d8399e5e68$export$2110ac352bb060b9; }, function (v) { return $ed5a28d8399e5e68$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ed5a28d8399e5e68$export$56885ab8b9c456ab; }, function (v) { return $ed5a28d8399e5e68$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ed5a28d8399e5e68$export$d927fcb6adf8f9de; }, function (v) { return $ed5a28d8399e5e68$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ed5a28d8399e5e68$export$b82d16f27459e05a; }, function (v) { return $ed5a28d8399e5e68$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ed5a28d8399e5e68$export$522c17b4f5e123e8; }, function (v) { return $ed5a28d8399e5e68$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ed5a28d8399e5e68$export$1aabd8a0274ecfd6; }, function (v) { return $ed5a28d8399e5e68$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ed5a28d8399e5e68$export$3d6c20d97e46b957; }, function (v) { return $ed5a28d8399e5e68$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ed5a28d8399e5e68$export$9b621391a187a31a; }, function (v) { return $ed5a28d8399e5e68$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ed5a28d8399e5e68$export$f5bbd400c2f4426f; }, function (v) { return $ed5a28d8399e5e68$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed5a28d8399e5e68$export$a7c73072b1a182ae;
var $ed5a28d8399e5e68$export$9f27bc3417b4524d;
var $ed5a28d8399e5e68$export$db77ccec0bb4ccac;
var $ed5a28d8399e5e68$export$8392c0c9d3dcbd35;
var $ed5a28d8399e5e68$export$ffb0004e005737fa;
var $ed5a28d8399e5e68$export$b624eff549462981;
var $ed5a28d8399e5e68$export$7897aa7841a5380c;
var $ed5a28d8399e5e68$export$602eac185826482c;
var $ed5a28d8399e5e68$export$e2c29f18771995cb;
var $ed5a28d8399e5e68$export$5f8d39834fd61797;
var $ed5a28d8399e5e68$export$74bf444e3cd11ea5;
var $ed5a28d8399e5e68$export$998bcd577473dd93;
var $ed5a28d8399e5e68$export$b706b080d889d2c9;
var $ed5a28d8399e5e68$export$5be5a87408f70ddc;
var $ed5a28d8399e5e68$export$45a5e7f76e0caa8d;
var $ed5a28d8399e5e68$export$455c2e768291efa6;
var $ed5a28d8399e5e68$export$9522e17588c12572;
var $ed5a28d8399e5e68$export$2110ac352bb060b9;
var $ed5a28d8399e5e68$export$56885ab8b9c456ab;
var $ed5a28d8399e5e68$export$d927fcb6adf8f9de;
var $ed5a28d8399e5e68$export$b82d16f27459e05a;
var $ed5a28d8399e5e68$export$522c17b4f5e123e8;
var $ed5a28d8399e5e68$export$1aabd8a0274ecfd6;
var $ed5a28d8399e5e68$export$3d6c20d97e46b957;
var $ed5a28d8399e5e68$export$9b621391a187a31a;
var $ed5a28d8399e5e68$export$f5bbd400c2f4426f;
"use strict";
(function() {
    function typeOf(object) {
        if ("object" === typeof object && null !== object) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    switch(object = object.type, object){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                        case REACT_VIEW_TRANSITION_TYPE:
                            return object;
                        default:
                            switch(object = object && object.$$typeof, object){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                    return object;
                                case REACT_CONSUMER_TYPE:
                                    return object;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    $ed5a28d8399e5e68$export$a7c73072b1a182ae = REACT_CONSUMER_TYPE;
    $ed5a28d8399e5e68$export$9f27bc3417b4524d = REACT_CONTEXT_TYPE;
    $ed5a28d8399e5e68$export$db77ccec0bb4ccac = REACT_ELEMENT_TYPE;
    $ed5a28d8399e5e68$export$8392c0c9d3dcbd35 = REACT_FORWARD_REF_TYPE;
    $ed5a28d8399e5e68$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $ed5a28d8399e5e68$export$b624eff549462981 = REACT_LAZY_TYPE;
    $ed5a28d8399e5e68$export$7897aa7841a5380c = REACT_MEMO_TYPE;
    $ed5a28d8399e5e68$export$602eac185826482c = REACT_PORTAL_TYPE;
    $ed5a28d8399e5e68$export$e2c29f18771995cb = REACT_PROFILER_TYPE;
    $ed5a28d8399e5e68$export$5f8d39834fd61797 = REACT_STRICT_MODE_TYPE;
    $ed5a28d8399e5e68$export$74bf444e3cd11ea5 = REACT_SUSPENSE_TYPE;
    $ed5a28d8399e5e68$export$998bcd577473dd93 = REACT_SUSPENSE_LIST_TYPE;
    $ed5a28d8399e5e68$export$b706b080d889d2c9 = function(object) {
        return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    $ed5a28d8399e5e68$export$5be5a87408f70ddc = function(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    $ed5a28d8399e5e68$export$45a5e7f76e0caa8d = function(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    $ed5a28d8399e5e68$export$455c2e768291efa6 = function(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    $ed5a28d8399e5e68$export$9522e17588c12572 = function(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    $ed5a28d8399e5e68$export$2110ac352bb060b9 = function(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    };
    $ed5a28d8399e5e68$export$56885ab8b9c456ab = function(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    };
    $ed5a28d8399e5e68$export$d927fcb6adf8f9de = function(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    };
    $ed5a28d8399e5e68$export$b82d16f27459e05a = function(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    };
    $ed5a28d8399e5e68$export$522c17b4f5e123e8 = function(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    $ed5a28d8399e5e68$export$1aabd8a0274ecfd6 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    $ed5a28d8399e5e68$export$3d6c20d97e46b957 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    $ed5a28d8399e5e68$export$9b621391a187a31a = function(type) {
        return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
    };
    $ed5a28d8399e5e68$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("8mLQJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kO80n")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("7XMgw")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("hfYj4")).default; });

var $kO80n = parcelRequire("kO80n");

var $7XMgw = parcelRequire("7XMgw");

var $hfYj4 = parcelRequire("hfYj4");

});
parcelRegister("kO80n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f25eafc736152d5c$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $gvqxq = parcelRequire("gvqxq");

var $7XMgw = parcelRequire("7XMgw");

var $gnznl = parcelRequire("gnznl");

var $eKnPT = parcelRequire("eKnPT");

var $zC31W = parcelRequire("zC31W");

var $kgL9n = parcelRequire("kgL9n");

var $hfYj4 = parcelRequire("hfYj4");
const $f25eafc736152d5c$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $f25eafc736152d5c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $fbOaB.default)(options, $f25eafc736152d5c$var$_excluded);
    const breakpoints = (0, $7XMgw.default)(breakpointsInput);
    const spacing = (0, $eKnPT.default)(spacingInput);
    let muiTheme = (0, $gvqxq.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $h4XE0.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $h4XE0.default)({}, (0, $gnznl.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $hfYj4.default);
    muiTheme = args.reduce((acc, argument)=>(0, $gvqxq.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $h4XE0.default)({}, (0, $kgL9n.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $zC31W.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $f25eafc736152d5c$export$2e2bcd8739ae039 = $f25eafc736152d5c$var$createTheme;

});
parcelRegister("7XMgw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cc37b9a9efec9e6$export$2e2bcd8739ae039; });

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");
const $5cc37b9a9efec9e6$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $5cc37b9a9efec9e6$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $5cc37b9a9efec9e6$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $h4XE0.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $5cc37b9a9efec9e6$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $fbOaB.default)(breakpoints, $5cc37b9a9efec9e6$var$_excluded);
    const sortedValues = $5cc37b9a9efec9e6$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $h4XE0.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("gnznl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beca3c27acae2349$export$2e2bcd8739ae039; });
const $beca3c27acae2349$var$shape = {
    borderRadius: 4
};
var $beca3c27acae2349$export$2e2bcd8739ae039 = $beca3c27acae2349$var$shape;

});

parcelRegister("eKnPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc7d9ea5fafa214$export$2e2bcd8739ae039; });

var $hvMj8 = parcelRequire("hvMj8");
function $abc7d9ea5fafa214$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $hvMj8.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        if (!(argsInput.length <= 4)) console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("hvMj8", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $cbfacdd34c3a731f$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $cbfacdd34c3a731f$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $cbfacdd34c3a731f$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $cbfacdd34c3a731f$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $cbfacdd34c3a731f$export$6f98e8eaf0be1996; });

var $ckzQX = parcelRequire("ckzQX");

var $kA5Ko = parcelRequire("kA5Ko");

var $78Maz = parcelRequire("78Maz");

var $hjS9n = parcelRequire("hjS9n");

var $f2R1I = parcelRequire("f2R1I");
const $cbfacdd34c3a731f$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $cbfacdd34c3a731f$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $cbfacdd34c3a731f$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $cbfacdd34c3a731f$var$getCssProperties = (0, $f2R1I.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($cbfacdd34c3a731f$var$aliases[prop]) prop = $cbfacdd34c3a731f$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $cbfacdd34c3a731f$var$properties[a];
    const direction = $cbfacdd34c3a731f$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $cbfacdd34c3a731f$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $cbfacdd34c3a731f$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $cbfacdd34c3a731f$var$spacingKeys = [
    ...$cbfacdd34c3a731f$export$aab52a0dde05ad8a,
    ...$cbfacdd34c3a731f$export$f8397d44f03ab6ad
];
function $cbfacdd34c3a731f$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $78Maz.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        if (typeof abs !== 'number') console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        if (!Number.isInteger(abs)) console.error([
            `MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`
        ].join('\n'));
        else if (abs > themeSpacing.length - 1) console.error([
            `MUI: The value provided (${abs}) overflows.`,
            `The supported values are: ${JSON.stringify(themeSpacing)}.`,
            `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`
        ].join('\n'));
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    console.error([
        `MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`,
        'It should be a number, an array or a function.'
    ].join('\n'));
    return ()=>undefined;
}
function $cbfacdd34c3a731f$export$1def6f833384e3d1(theme) {
    return $cbfacdd34c3a731f$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $cbfacdd34c3a731f$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $cbfacdd34c3a731f$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $cbfacdd34c3a731f$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $cbfacdd34c3a731f$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $cbfacdd34c3a731f$var$getCssProperties(prop);
    const styleFromPropValue = $cbfacdd34c3a731f$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $kA5Ko.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $cbfacdd34c3a731f$var$style(props, keys) {
    const transformer = $cbfacdd34c3a731f$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$cbfacdd34c3a731f$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $hjS9n.default), {});
}
function $cbfacdd34c3a731f$export$7ede87f9b603dd3c(props) {
    return $cbfacdd34c3a731f$var$style(props, $cbfacdd34c3a731f$export$aab52a0dde05ad8a);
}
$cbfacdd34c3a731f$export$7ede87f9b603dd3c.propTypes = $cbfacdd34c3a731f$export$aab52a0dde05ad8a.reduce((obj, key)=>{
    obj[key] = (0, $ckzQX.default);
    return obj;
}, {});
$cbfacdd34c3a731f$export$7ede87f9b603dd3c.filterProps = $cbfacdd34c3a731f$export$aab52a0dde05ad8a;
function $cbfacdd34c3a731f$export$6f98e8eaf0be1996(props) {
    return $cbfacdd34c3a731f$var$style(props, $cbfacdd34c3a731f$export$f8397d44f03ab6ad);
}
$cbfacdd34c3a731f$export$6f98e8eaf0be1996.propTypes = $cbfacdd34c3a731f$export$f8397d44f03ab6ad.reduce((obj, key)=>{
    obj[key] = (0, $ckzQX.default);
    return obj;
}, {});
$cbfacdd34c3a731f$export$6f98e8eaf0be1996.filterProps = $cbfacdd34c3a731f$export$f8397d44f03ab6ad;
function $cbfacdd34c3a731f$var$spacing(props) {
    return $cbfacdd34c3a731f$var$style(props, $cbfacdd34c3a731f$var$spacingKeys);
}
$cbfacdd34c3a731f$var$spacing.propTypes = $cbfacdd34c3a731f$var$spacingKeys.reduce((obj, key)=>{
    obj[key] = (0, $ckzQX.default);
    return obj;
}, {});
$cbfacdd34c3a731f$var$spacing.filterProps = $cbfacdd34c3a731f$var$spacingKeys;
var $cbfacdd34c3a731f$export$2e2bcd8739ae039 = $cbfacdd34c3a731f$var$spacing;

});
parcelRegister("ckzQX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa329f92470068a$export$2e2bcd8739ae039; });

var $4yBem = parcelRequire("4yBem");
const $8fa329f92470068a$var$responsivePropType = (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).array
]);
var $8fa329f92470068a$export$2e2bcd8739ae039 = $8fa329f92470068a$var$responsivePropType;

});

parcelRegister("kA5Ko", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $efbba0b8dfa70237$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $efbba0b8dfa70237$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $efbba0b8dfa70237$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $efbba0b8dfa70237$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $efbba0b8dfa70237$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $efbba0b8dfa70237$export$980e6a259d807490; });

var $h4XE0 = parcelRequire("h4XE0");

var $4yBem = parcelRequire("4yBem");

var $gvqxq = parcelRequire("gvqxq");

var $hjS9n = parcelRequire("hjS9n");
const $efbba0b8dfa70237$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $efbba0b8dfa70237$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$efbba0b8dfa70237$export$68c286be0e7e55b7[key]}px)`
};
function $efbba0b8dfa70237$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $efbba0b8dfa70237$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $efbba0b8dfa70237$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $efbba0b8dfa70237$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $efbba0b8dfa70237$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $efbba0b8dfa70237$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $h4XE0.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $hjS9n.default)(base, extended);
    };
    newStyleFunction.propTypes = (0, $h4XE0.default)({}, styleFunction.propTypes, {
        xs: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        sm: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        md: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        lg: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        xl: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    });
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $efbba0b8dfa70237$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $efbba0b8dfa70237$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $efbba0b8dfa70237$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $efbba0b8dfa70237$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $gvqxq.default)(prev, next), {});
    return $efbba0b8dfa70237$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $efbba0b8dfa70237$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $efbba0b8dfa70237$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $efbba0b8dfa70237$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $efbba0b8dfa70237$export$2e2bcd8739ae039 = $efbba0b8dfa70237$var$breakpoints;

});
parcelRegister("hjS9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9be372666649934$export$2e2bcd8739ae039; });

var $gvqxq = parcelRequire("gvqxq");
function $c9be372666649934$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $gvqxq.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $c9be372666649934$export$2e2bcd8739ae039 = $c9be372666649934$var$merge;

});


parcelRegister("78Maz", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $532ea535892156c9$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $532ea535892156c9$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $532ea535892156c9$export$2e2bcd8739ae039; });

var $3Rthm = parcelRequire("3Rthm");

var $ckzQX = parcelRequire("ckzQX");

var $kA5Ko = parcelRequire("kA5Ko");
function $532ea535892156c9$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $532ea535892156c9$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $532ea535892156c9$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $532ea535892156c9$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $532ea535892156c9$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $532ea535892156c9$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $532ea535892156c9$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $3Rthm.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $kA5Ko.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {
        [prop]: (0, $ckzQX.default)
    };
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $532ea535892156c9$export$2e2bcd8739ae039 = $532ea535892156c9$var$style;

});

parcelRegister("f2R1I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af402ce410bed507$export$2e2bcd8739ae039; });
function $af402ce410bed507$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("zC31W", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $06b0c883abd07296$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $06b0c883abd07296$export$2e2bcd8739ae039; });

var $3Rthm = parcelRequire("3Rthm");

var $hjS9n = parcelRequire("hjS9n");

var $78Maz = parcelRequire("78Maz");

var $kA5Ko = parcelRequire("kA5Ko");

var $kgL9n = parcelRequire("kgL9n");
function $06b0c883abd07296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $06b0c883abd07296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $06b0c883abd07296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $78Maz.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $78Maz.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $78Maz.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $3Rthm.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $kA5Ko.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $kgL9n.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $kA5Ko.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $06b0c883abd07296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $hjS9n.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $kA5Ko.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($06b0c883abd07296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $hjS9n.default)(css, breakpointsValues);
                        }
                    } else css = (0, $hjS9n.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $kA5Ko.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $kA5Ko.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $06b0c883abd07296$var$styleFunctionSx = $06b0c883abd07296$export$7d53d8bf2911e013();
$06b0c883abd07296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $06b0c883abd07296$export$2e2bcd8739ae039 = $06b0c883abd07296$var$styleFunctionSx;

});
parcelRegister("kgL9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec19e0572c42e454$export$2e2bcd8739ae039; });

var $hvMj8 = parcelRequire("hvMj8");

var $iqyQc = parcelRequire("iqyQc");

var $NgCnv = parcelRequire("NgCnv");

var $1hXUx = parcelRequire("1hXUx");

var $54sWC = parcelRequire("54sWC");
const $ec19e0572c42e454$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $iqyQc.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $iqyQc.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $iqyQc.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $iqyQc.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $iqyQc.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $iqyQc.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $iqyQc.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $1hXUx.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $1hXUx.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $1hXUx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $hvMj8.padding)
    },
    pt: {
        style: (0, $hvMj8.padding)
    },
    pr: {
        style: (0, $hvMj8.padding)
    },
    pb: {
        style: (0, $hvMj8.padding)
    },
    pl: {
        style: (0, $hvMj8.padding)
    },
    px: {
        style: (0, $hvMj8.padding)
    },
    py: {
        style: (0, $hvMj8.padding)
    },
    padding: {
        style: (0, $hvMj8.padding)
    },
    paddingTop: {
        style: (0, $hvMj8.padding)
    },
    paddingRight: {
        style: (0, $hvMj8.padding)
    },
    paddingBottom: {
        style: (0, $hvMj8.padding)
    },
    paddingLeft: {
        style: (0, $hvMj8.padding)
    },
    paddingX: {
        style: (0, $hvMj8.padding)
    },
    paddingY: {
        style: (0, $hvMj8.padding)
    },
    paddingInline: {
        style: (0, $hvMj8.padding)
    },
    paddingInlineStart: {
        style: (0, $hvMj8.padding)
    },
    paddingInlineEnd: {
        style: (0, $hvMj8.padding)
    },
    paddingBlock: {
        style: (0, $hvMj8.padding)
    },
    paddingBlockStart: {
        style: (0, $hvMj8.padding)
    },
    paddingBlockEnd: {
        style: (0, $hvMj8.padding)
    },
    m: {
        style: (0, $hvMj8.margin)
    },
    mt: {
        style: (0, $hvMj8.margin)
    },
    mr: {
        style: (0, $hvMj8.margin)
    },
    mb: {
        style: (0, $hvMj8.margin)
    },
    ml: {
        style: (0, $hvMj8.margin)
    },
    mx: {
        style: (0, $hvMj8.margin)
    },
    my: {
        style: (0, $hvMj8.margin)
    },
    margin: {
        style: (0, $hvMj8.margin)
    },
    marginTop: {
        style: (0, $hvMj8.margin)
    },
    marginRight: {
        style: (0, $hvMj8.margin)
    },
    marginBottom: {
        style: (0, $hvMj8.margin)
    },
    marginLeft: {
        style: (0, $hvMj8.margin)
    },
    marginX: {
        style: (0, $hvMj8.margin)
    },
    marginY: {
        style: (0, $hvMj8.margin)
    },
    marginInline: {
        style: (0, $hvMj8.margin)
    },
    marginInlineStart: {
        style: (0, $hvMj8.margin)
    },
    marginInlineEnd: {
        style: (0, $hvMj8.margin)
    },
    marginBlock: {
        style: (0, $hvMj8.margin)
    },
    marginBlockStart: {
        style: (0, $hvMj8.margin)
    },
    marginBlockEnd: {
        style: (0, $hvMj8.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $NgCnv.gap)
    },
    rowGap: {
        style: (0, $NgCnv.rowGap)
    },
    columnGap: {
        style: (0, $NgCnv.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $54sWC.sizingTransform)
    },
    maxWidth: {
        style: (0, $54sWC.maxWidth)
    },
    minWidth: {
        transform: (0, $54sWC.sizingTransform)
    },
    height: {
        transform: (0, $54sWC.sizingTransform)
    },
    maxHeight: {
        transform: (0, $54sWC.sizingTransform)
    },
    minHeight: {
        transform: (0, $54sWC.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $ec19e0572c42e454$export$2e2bcd8739ae039 = $ec19e0572c42e454$var$defaultSxConfig;

});
parcelRegister("iqyQc", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $d6a5ae5e7e420955$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $d6a5ae5e7e420955$export$7a57f79000377ca2; });

var $ckzQX = parcelRequire("ckzQX");

var $78Maz = parcelRequire("78Maz");

var $h6PGA = parcelRequire("h6PGA");

var $hvMj8 = parcelRequire("hvMj8");

var $kA5Ko = parcelRequire("kA5Ko");
function $d6a5ae5e7e420955$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $d6a5ae5e7e420955$var$createBorderStyle(prop, transform) {
    return (0, $78Maz.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $d6a5ae5e7e420955$export$1edee58a52776cd9 = $d6a5ae5e7e420955$var$createBorderStyle('border', $d6a5ae5e7e420955$export$34e2febe53ae29cc);
const $d6a5ae5e7e420955$export$f9a7b6bd24892946 = $d6a5ae5e7e420955$var$createBorderStyle('borderTop', $d6a5ae5e7e420955$export$34e2febe53ae29cc);
const $d6a5ae5e7e420955$export$5abca33e6be905d2 = $d6a5ae5e7e420955$var$createBorderStyle('borderRight', $d6a5ae5e7e420955$export$34e2febe53ae29cc);
const $d6a5ae5e7e420955$export$e2ce9f12a980a822 = $d6a5ae5e7e420955$var$createBorderStyle('borderBottom', $d6a5ae5e7e420955$export$34e2febe53ae29cc);
const $d6a5ae5e7e420955$export$47658cca1a909427 = $d6a5ae5e7e420955$var$createBorderStyle('borderLeft', $d6a5ae5e7e420955$export$34e2febe53ae29cc);
const $d6a5ae5e7e420955$export$e7fb0694ba2404fc = $d6a5ae5e7e420955$var$createBorderStyle('borderColor');
const $d6a5ae5e7e420955$export$126a92c968acdb85 = $d6a5ae5e7e420955$var$createBorderStyle('borderTopColor');
const $d6a5ae5e7e420955$export$85cc51cb8fbb8c0e = $d6a5ae5e7e420955$var$createBorderStyle('borderRightColor');
const $d6a5ae5e7e420955$export$340b0327727f6d1a = $d6a5ae5e7e420955$var$createBorderStyle('borderBottomColor');
const $d6a5ae5e7e420955$export$60beef91a985b4bf = $d6a5ae5e7e420955$var$createBorderStyle('borderLeftColor');
const $d6a5ae5e7e420955$export$f9258c55612cbed7 = $d6a5ae5e7e420955$var$createBorderStyle('outline', $d6a5ae5e7e420955$export$34e2febe53ae29cc);
const $d6a5ae5e7e420955$export$621fe586efeb64b9 = $d6a5ae5e7e420955$var$createBorderStyle('outlineColor');
const $d6a5ae5e7e420955$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $hvMj8.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $hvMj8.getValue)(transformer, propValue)
            });
        return (0, $kA5Ko.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$d6a5ae5e7e420955$export$7a57f79000377ca2.propTypes = {
    borderRadius: (0, $ckzQX.default)
};
$d6a5ae5e7e420955$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $d6a5ae5e7e420955$var$borders = (0, $h6PGA.default)($d6a5ae5e7e420955$export$1edee58a52776cd9, $d6a5ae5e7e420955$export$f9a7b6bd24892946, $d6a5ae5e7e420955$export$5abca33e6be905d2, $d6a5ae5e7e420955$export$e2ce9f12a980a822, $d6a5ae5e7e420955$export$47658cca1a909427, $d6a5ae5e7e420955$export$e7fb0694ba2404fc, $d6a5ae5e7e420955$export$126a92c968acdb85, $d6a5ae5e7e420955$export$85cc51cb8fbb8c0e, $d6a5ae5e7e420955$export$340b0327727f6d1a, $d6a5ae5e7e420955$export$60beef91a985b4bf, $d6a5ae5e7e420955$export$7a57f79000377ca2, $d6a5ae5e7e420955$export$f9258c55612cbed7, $d6a5ae5e7e420955$export$621fe586efeb64b9);
var $d6a5ae5e7e420955$export$2e2bcd8739ae039 = $d6a5ae5e7e420955$var$borders;

});
parcelRegister("h6PGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c74b16f7f7f1aa9d$export$2e2bcd8739ae039; });

var $hjS9n = parcelRequire("hjS9n");
function $c74b16f7f7f1aa9d$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $hjS9n.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = styles.reduce((acc, style)=>Object.assign(acc, style.propTypes), {});
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $c74b16f7f7f1aa9d$export$2e2bcd8739ae039 = $c74b16f7f7f1aa9d$var$compose;

});


parcelRegister("NgCnv", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $094177b4e7d0f675$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $094177b4e7d0f675$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $094177b4e7d0f675$export$8a833ffa5f5dbeda; });

var $78Maz = parcelRequire("78Maz");

var $h6PGA = parcelRequire("h6PGA");

var $hvMj8 = parcelRequire("hvMj8");

var $kA5Ko = parcelRequire("kA5Ko");

var $ckzQX = parcelRequire("ckzQX");
const $094177b4e7d0f675$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $hvMj8.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $hvMj8.getValue)(transformer, propValue)
            });
        return (0, $kA5Ko.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$094177b4e7d0f675$export$5df9adcb0db95e1e.propTypes = {
    gap: (0, $ckzQX.default)
};
$094177b4e7d0f675$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $094177b4e7d0f675$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $hvMj8.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $hvMj8.getValue)(transformer, propValue)
            });
        return (0, $kA5Ko.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$094177b4e7d0f675$export$ec60d70ff941a580.propTypes = {
    columnGap: (0, $ckzQX.default)
};
$094177b4e7d0f675$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $094177b4e7d0f675$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $hvMj8.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $hvMj8.getValue)(transformer, propValue)
            });
        return (0, $kA5Ko.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$094177b4e7d0f675$export$8a833ffa5f5dbeda.propTypes = {
    rowGap: (0, $ckzQX.default)
};
$094177b4e7d0f675$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $094177b4e7d0f675$export$baf44164ca3a34e8 = (0, $78Maz.default)({
    prop: 'gridColumn'
});
const $094177b4e7d0f675$export$8f7213a1cd01e832 = (0, $78Maz.default)({
    prop: 'gridRow'
});
const $094177b4e7d0f675$export$b0e0abbc49ba668 = (0, $78Maz.default)({
    prop: 'gridAutoFlow'
});
const $094177b4e7d0f675$export$bcd8b929d4b4142 = (0, $78Maz.default)({
    prop: 'gridAutoColumns'
});
const $094177b4e7d0f675$export$e5039a674e14c828 = (0, $78Maz.default)({
    prop: 'gridAutoRows'
});
const $094177b4e7d0f675$export$42bd9088661ffb03 = (0, $78Maz.default)({
    prop: 'gridTemplateColumns'
});
const $094177b4e7d0f675$export$920682ae05b999bc = (0, $78Maz.default)({
    prop: 'gridTemplateRows'
});
const $094177b4e7d0f675$export$1b88fbdd482fd33a = (0, $78Maz.default)({
    prop: 'gridTemplateAreas'
});
const $094177b4e7d0f675$export$bdb486e40d52d26f = (0, $78Maz.default)({
    prop: 'gridArea'
});
const $094177b4e7d0f675$var$grid = (0, $h6PGA.default)($094177b4e7d0f675$export$5df9adcb0db95e1e, $094177b4e7d0f675$export$ec60d70ff941a580, $094177b4e7d0f675$export$8a833ffa5f5dbeda, $094177b4e7d0f675$export$baf44164ca3a34e8, $094177b4e7d0f675$export$8f7213a1cd01e832, $094177b4e7d0f675$export$b0e0abbc49ba668, $094177b4e7d0f675$export$bcd8b929d4b4142, $094177b4e7d0f675$export$e5039a674e14c828, $094177b4e7d0f675$export$42bd9088661ffb03, $094177b4e7d0f675$export$920682ae05b999bc, $094177b4e7d0f675$export$1b88fbdd482fd33a, $094177b4e7d0f675$export$bdb486e40d52d26f);
var $094177b4e7d0f675$export$2e2bcd8739ae039 = $094177b4e7d0f675$var$grid;

});

parcelRegister("1hXUx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $0f05da099760b9cf$export$dbaffd4420ea0ac6; });

var $78Maz = parcelRequire("78Maz");

var $h6PGA = parcelRequire("h6PGA");
function $0f05da099760b9cf$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $0f05da099760b9cf$export$35e9368ef982300f = (0, $78Maz.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $0f05da099760b9cf$export$dbaffd4420ea0ac6
});
const $0f05da099760b9cf$export$2506f56c10355b33 = (0, $78Maz.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $0f05da099760b9cf$export$dbaffd4420ea0ac6
});
const $0f05da099760b9cf$export$8c5a050822fd698c = (0, $78Maz.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $0f05da099760b9cf$export$dbaffd4420ea0ac6
});
const $0f05da099760b9cf$var$palette = (0, $h6PGA.default)($0f05da099760b9cf$export$35e9368ef982300f, $0f05da099760b9cf$export$2506f56c10355b33, $0f05da099760b9cf$export$8c5a050822fd698c);
var $0f05da099760b9cf$export$2e2bcd8739ae039 = $0f05da099760b9cf$var$palette;

});

parcelRegister("54sWC", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $3b13c73a0f77c56e$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $3b13c73a0f77c56e$export$488fda99655ff65a; });

var $78Maz = parcelRequire("78Maz");

var $h6PGA = parcelRequire("h6PGA");

var $kA5Ko = parcelRequire("kA5Ko");
function $3b13c73a0f77c56e$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $3b13c73a0f77c56e$export$7e3df82ee760448c = (0, $78Maz.default)({
    prop: 'width',
    transform: $3b13c73a0f77c56e$export$8afece71750ec241
});
const $3b13c73a0f77c56e$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $kA5Ko.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $3b13c73a0f77c56e$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $kA5Ko.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$3b13c73a0f77c56e$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $3b13c73a0f77c56e$export$ee148fbbe8357dd2 = (0, $78Maz.default)({
    prop: 'minWidth',
    transform: $3b13c73a0f77c56e$export$8afece71750ec241
});
const $3b13c73a0f77c56e$export$ac607276a8fe9f0a = (0, $78Maz.default)({
    prop: 'height',
    transform: $3b13c73a0f77c56e$export$8afece71750ec241
});
const $3b13c73a0f77c56e$export$dc0d8bd0b94f8570 = (0, $78Maz.default)({
    prop: 'maxHeight',
    transform: $3b13c73a0f77c56e$export$8afece71750ec241
});
const $3b13c73a0f77c56e$export$a43cf604e12f3b17 = (0, $78Maz.default)({
    prop: 'minHeight',
    transform: $3b13c73a0f77c56e$export$8afece71750ec241
});
const $3b13c73a0f77c56e$export$ffed9f14fb65e276 = (0, $78Maz.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $3b13c73a0f77c56e$export$8afece71750ec241
});
const $3b13c73a0f77c56e$export$905076ed6620e671 = (0, $78Maz.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $3b13c73a0f77c56e$export$8afece71750ec241
});
const $3b13c73a0f77c56e$export$6ccc93f785106a58 = (0, $78Maz.default)({
    prop: 'boxSizing'
});
const $3b13c73a0f77c56e$var$sizing = (0, $h6PGA.default)($3b13c73a0f77c56e$export$7e3df82ee760448c, $3b13c73a0f77c56e$export$488fda99655ff65a, $3b13c73a0f77c56e$export$ee148fbbe8357dd2, $3b13c73a0f77c56e$export$ac607276a8fe9f0a, $3b13c73a0f77c56e$export$dc0d8bd0b94f8570, $3b13c73a0f77c56e$export$a43cf604e12f3b17, $3b13c73a0f77c56e$export$6ccc93f785106a58);
var $3b13c73a0f77c56e$export$2e2bcd8739ae039 = $3b13c73a0f77c56e$var$sizing;

});



parcelRegister("hfYj4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9029dfed6422ebb$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $c9029dfed6422ebb$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("8ZYrY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("zC31W")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("zC31W")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("hZDOg")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("kgL9n")).default; });

var $zC31W = parcelRequire("zC31W");

var $hZDOg = parcelRequire("hZDOg");

var $kgL9n = parcelRequire("kgL9n");

});
parcelRegister("hZDOg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1970393a0110f02$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $gvqxq = parcelRequire("gvqxq");

var $kgL9n = parcelRequire("kgL9n");
const $d1970393a0110f02$var$_excluded = [
    "sx"
];
const $d1970393a0110f02$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $kgL9n.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $d1970393a0110f02$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $fbOaB.default)(props, $d1970393a0110f02$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $d1970393a0110f02$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $gvqxq.isPlainObject)(result)) return systemProps;
        return (0, $h4XE0.default)({}, systemProps, result);
    };
    else finalSx = (0, $h4XE0.default)({}, systemProps, inSx);
    return (0, $h4XE0.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("xHBjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0654e76a4d75364b$export$2e2bcd8739ae039; });

var $26mQo = parcelRequire("26mQo");
'use client';
const $0654e76a4d75364b$var$defaultTheme = (0, $26mQo.default)();
var $0654e76a4d75364b$export$2e2bcd8739ae039 = $0654e76a4d75364b$var$defaultTheme;

});
parcelRegister("26mQo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $187ddcaf9120ca0a$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");


var $gvqxq = parcelRequire("gvqxq");

var $zC31W = parcelRequire("zC31W");
var $kgL9n = parcelRequire("kgL9n");

var $kO80n = parcelRequire("kO80n");

var $aBqGi = parcelRequire("aBqGi");

var $358TX = parcelRequire("358TX");

var $kefEi = parcelRequire("kefEi");

var $4Wc0N = parcelRequire("4Wc0N");

var $9Zr0D = parcelRequire("9Zr0D");

var $eUKeD = parcelRequire("eUKeD");

var $3aNqf = parcelRequire("3aNqf");
const $187ddcaf9120ca0a$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $187ddcaf9120ca0a$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $fbOaB.default)(options, $187ddcaf9120ca0a$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error(`MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.`);
    const palette = (0, $kefEi.default)(paletteInput);
    const systemTheme = (0, $kO80n.default)(options);
    let muiTheme = (0, $gvqxq.default)(systemTheme, {
        mixins: (0, $358TX.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $9Zr0D.default).slice(),
        typography: (0, $4Wc0N.default)(palette, typographyInput),
        transitions: (0, $eUKeD.default)(transitionsInput),
        zIndex: (0, $h4XE0.default)({}, (0, $3aNqf.default))
    });
    muiTheme = (0, $gvqxq.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $gvqxq.default)(acc, argument), muiTheme);
    {
        // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
        const stateClasses = [
            'active',
            'checked',
            'completed',
            'disabled',
            'error',
            'expanded',
            'focused',
            'focusVisible',
            'required',
            'selected'
        ];
        const traverse = (node, component)=>{
            let key;
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for(key in node){
                const child = node[key];
                if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
                    {
                        const stateClass = (0, $aBqGi.default)('', key);
                        console.error([
                            `MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`,
                            'You can not override it like this: ',
                            JSON.stringify(node, null, 2),
                            '',
                            `Instead, you need to use the '&.${stateClass}' syntax:`,
                            JSON.stringify({
                                root: {
                                    [`&.${stateClass}`]: child
                                }
                            }, null, 2),
                            '',
                            'https://mui.com/r/state-classes-guide'
                        ].join('\n'));
                    }
                    // Remove the style to prevent global conflicts.
                    node[key] = {};
                }
            }
        };
        Object.keys(muiTheme.components).forEach((component)=>{
            const styleOverrides = muiTheme.components[component].styleOverrides;
            if (styleOverrides && component.indexOf('Mui') === 0) traverse(styleOverrides, component);
        });
    }
    muiTheme.unstable_sxConfig = (0, $h4XE0.default)({}, (0, $kgL9n.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $zC31W.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $187ddcaf9120ca0a$var$warnedOnce = false;
function $187ddcaf9120ca0a$export$c469355549431d9b(...args) {
    if (!$187ddcaf9120ca0a$var$warnedOnce) {
        $187ddcaf9120ca0a$var$warnedOnce = true;
        console.error([
            'MUI: the createMuiTheme function was renamed to createTheme.',
            '',
            "You should use `import { createTheme } from '@mui/material/styles'`"
        ].join('\n'));
    }
    return $187ddcaf9120ca0a$var$createTheme(...args);
}
var $187ddcaf9120ca0a$export$2e2bcd8739ae039 = $187ddcaf9120ca0a$var$createTheme;

});
parcelRegister("aBqGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b820e6877c8091b$export$2e2bcd8739ae039; });

var $4hO9G = parcelRequire("4hO9G");
const $7b820e6877c8091b$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $7b820e6877c8091b$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $7b820e6877c8091b$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $4hO9G.default).generate(componentName)}-${slot}`;
}
function $7b820e6877c8091b$export$34c0130b1f3e8ae3(slot) {
    return $7b820e6877c8091b$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("4hO9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31efa7baf609763e$export$2e2bcd8739ae039; });
const $31efa7baf609763e$var$defaultGenerator = (componentName)=>componentName;
const $31efa7baf609763e$var$createClassNameGenerator = ()=>{
    let generate = $31efa7baf609763e$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $31efa7baf609763e$var$defaultGenerator;
        }
    };
};
const $31efa7baf609763e$var$ClassNameGenerator = $31efa7baf609763e$var$createClassNameGenerator();
var $31efa7baf609763e$export$2e2bcd8739ae039 = $31efa7baf609763e$var$ClassNameGenerator;

});


parcelRegister("358TX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23e8be60df065422$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");
function $23e8be60df065422$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $h4XE0.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("kefEi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba14101d7fae8bf$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");


var $gvqxq = parcelRequire("gvqxq");

var $5YtKS = parcelRequire("5YtKS");

var $2Tlns = parcelRequire("2Tlns");

var $e792z = parcelRequire("e792z");

var $gvKl4 = parcelRequire("gvKl4");

var $i8qTq = parcelRequire("i8qTq");

var $aJ8CV = parcelRequire("aJ8CV");

var $9AdkU = parcelRequire("9AdkU");

var $fjtU1 = parcelRequire("fjtU1");

var $dgUFt = parcelRequire("dgUFt");
const $eba14101d7fae8bf$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $eba14101d7fae8bf$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $2Tlns.default).white,
        default: (0, $2Tlns.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $eba14101d7fae8bf$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $2Tlns.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $2Tlns.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $eba14101d7fae8bf$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $5YtKS.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $5YtKS.darken)(intent.main, tonalOffsetDark);
    }
}
function $eba14101d7fae8bf$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9AdkU.default)[200],
        light: (0, $9AdkU.default)[50],
        dark: (0, $9AdkU.default)[400]
    };
    return {
        main: (0, $9AdkU.default)[700],
        light: (0, $9AdkU.default)[400],
        dark: (0, $9AdkU.default)[800]
    };
}
function $eba14101d7fae8bf$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gvKl4.default)[200],
        light: (0, $gvKl4.default)[50],
        dark: (0, $gvKl4.default)[400]
    };
    return {
        main: (0, $gvKl4.default)[500],
        light: (0, $gvKl4.default)[300],
        dark: (0, $gvKl4.default)[700]
    };
}
function $eba14101d7fae8bf$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $i8qTq.default)[500],
        light: (0, $i8qTq.default)[300],
        dark: (0, $i8qTq.default)[700]
    };
    return {
        main: (0, $i8qTq.default)[700],
        light: (0, $i8qTq.default)[400],
        dark: (0, $i8qTq.default)[800]
    };
}
function $eba14101d7fae8bf$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $fjtU1.default)[400],
        light: (0, $fjtU1.default)[300],
        dark: (0, $fjtU1.default)[700]
    };
    return {
        main: (0, $fjtU1.default)[700],
        light: (0, $fjtU1.default)[500],
        dark: (0, $fjtU1.default)[900]
    };
}
function $eba14101d7fae8bf$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dgUFt.default)[400],
        light: (0, $dgUFt.default)[300],
        dark: (0, $dgUFt.default)[700]
    };
    return {
        main: (0, $dgUFt.default)[800],
        light: (0, $dgUFt.default)[500],
        dark: (0, $dgUFt.default)[900]
    };
}
function $eba14101d7fae8bf$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $aJ8CV.default)[400],
        light: (0, $aJ8CV.default)[300],
        dark: (0, $aJ8CV.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $aJ8CV.default)[500],
        dark: (0, $aJ8CV.default)[900]
    };
}
function $eba14101d7fae8bf$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $fbOaB.default)(palette, $eba14101d7fae8bf$var$_excluded);
    const primary = palette.primary || $eba14101d7fae8bf$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $eba14101d7fae8bf$var$getDefaultSecondary(mode);
    const error = palette.error || $eba14101d7fae8bf$var$getDefaultError(mode);
    const info = palette.info || $eba14101d7fae8bf$var$getDefaultInfo(mode);
    const success = palette.success || $eba14101d7fae8bf$var$getDefaultSuccess(mode);
    const warning = palette.warning || $eba14101d7fae8bf$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $5YtKS.getContrastRatio)(background, $eba14101d7fae8bf$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $eba14101d7fae8bf$export$55ce6f3a06c59543.text.primary : $eba14101d7fae8bf$export$a43af521ac8c3202.text.primary;
        {
            const contrast = (0, $5YtKS.getContrastRatio)(background, contrastText);
            if (contrast < 3) console.error([
                `MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`,
                'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.',
                'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'
            ].join('\n'));
        }
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $h4XE0.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error(`MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.`);
        if (typeof color.main !== 'string') throw new Error(`MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`);
        $eba14101d7fae8bf$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $eba14101d7fae8bf$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $eba14101d7fae8bf$export$55ce6f3a06c59543,
        light: $eba14101d7fae8bf$export$a43af521ac8c3202
    };
    if (!modes[mode]) console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    const paletteOutput = (0, $gvqxq.default)((0, $h4XE0.default)({
        // A collection of common colors.
        common: (0, $h4XE0.default)({}, (0, $2Tlns.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $e792z.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("5YtKS", function(module, exports) {
"use strict";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $4599a3178c1db5d1$var$alpha;
module.exports.blend = $4599a3178c1db5d1$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $4599a3178c1db5d1$var$darken;
module.exports.decomposeColor = $4599a3178c1db5d1$var$decomposeColor;
module.exports.emphasize = $4599a3178c1db5d1$var$emphasize;
module.exports.getContrastRatio = $4599a3178c1db5d1$var$getContrastRatio;
module.exports.getLuminance = $4599a3178c1db5d1$var$getLuminance;
module.exports.hexToRgb = $4599a3178c1db5d1$var$hexToRgb;
module.exports.hslToRgb = $4599a3178c1db5d1$var$hslToRgb;
module.exports.lighten = $4599a3178c1db5d1$var$lighten;
module.exports.private_safeAlpha = $4599a3178c1db5d1$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $4599a3178c1db5d1$var$private_safeDarken;
module.exports.private_safeEmphasize = $4599a3178c1db5d1$var$private_safeEmphasize;
module.exports.private_safeLighten = $4599a3178c1db5d1$var$private_safeLighten;
module.exports.recomposeColor = $4599a3178c1db5d1$var$recomposeColor;
module.exports.rgbToHex = $4599a3178c1db5d1$var$rgbToHex;

var $4599a3178c1db5d1$var$_formatMuiErrorMessage2 = $aoClO((parcelRequire("kiHFy")));

var $4599a3178c1db5d1$var$_clamp = $aoClO((parcelRequire("aLEGc")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $4599a3178c1db5d1$var$clampWrapper(value, min = 0, max = 1) {
    if (value < min || value > max) console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    return (0, $4599a3178c1db5d1$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $4599a3178c1db5d1$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $4599a3178c1db5d1$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $4599a3178c1db5d1$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $4599a3178c1db5d1$var$decomposeColor($4599a3178c1db5d1$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error(`MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`);
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error(`MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`);
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $4599a3178c1db5d1$var$colorChannel = (color)=>{
    const decomposedColor = $4599a3178c1db5d1$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $4599a3178c1db5d1$var$colorChannel;
const $4599a3178c1db5d1$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $4599a3178c1db5d1$var$colorChannel(color);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $4599a3178c1db5d1$var$private_safeColorChannel;
function $4599a3178c1db5d1$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $4599a3178c1db5d1$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $4599a3178c1db5d1$var$decomposeColor(color);
    return `#${values.map((n, i)=>$4599a3178c1db5d1$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $4599a3178c1db5d1$var$hslToRgb(color) {
    color = $4599a3178c1db5d1$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $4599a3178c1db5d1$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $4599a3178c1db5d1$var$getLuminance(color) {
    color = $4599a3178c1db5d1$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $4599a3178c1db5d1$var$decomposeColor($4599a3178c1db5d1$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $4599a3178c1db5d1$var$getContrastRatio(foreground, background) {
    const lumA = $4599a3178c1db5d1$var$getLuminance(foreground);
    const lumB = $4599a3178c1db5d1$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $4599a3178c1db5d1$var$alpha(color, value) {
    color = $4599a3178c1db5d1$var$decomposeColor(color);
    value = $4599a3178c1db5d1$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $4599a3178c1db5d1$var$recomposeColor(color);
}
function $4599a3178c1db5d1$var$private_safeAlpha(color, value, warning) {
    try {
        return $4599a3178c1db5d1$var$alpha(color, value);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $4599a3178c1db5d1$var$darken(color, coefficient) {
    color = $4599a3178c1db5d1$var$decomposeColor(color);
    coefficient = $4599a3178c1db5d1$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $4599a3178c1db5d1$var$recomposeColor(color);
}
function $4599a3178c1db5d1$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $4599a3178c1db5d1$var$darken(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $4599a3178c1db5d1$var$lighten(color, coefficient) {
    color = $4599a3178c1db5d1$var$decomposeColor(color);
    coefficient = $4599a3178c1db5d1$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $4599a3178c1db5d1$var$recomposeColor(color);
}
function $4599a3178c1db5d1$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $4599a3178c1db5d1$var$lighten(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $4599a3178c1db5d1$var$emphasize(color, coefficient = 0.15) {
    return $4599a3178c1db5d1$var$getLuminance(color) > 0.5 ? $4599a3178c1db5d1$var$darken(color, coefficient) : $4599a3178c1db5d1$var$lighten(color, coefficient);
}
function $4599a3178c1db5d1$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $4599a3178c1db5d1$var$emphasize(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $4599a3178c1db5d1$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $4599a3178c1db5d1$var$decomposeColor(background);
    const overlayColor = $4599a3178c1db5d1$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $4599a3178c1db5d1$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("kiHFy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hE90H")).default; });

var $hE90H = parcelRequire("hE90H");

});
parcelRegister("hE90H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd8d295d61ba8a1a$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $cd8d295d61ba8a1a$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("aLEGc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5YyXA")).default; });

var $5YyXA = parcelRequire("5YyXA");

});
parcelRegister("5YyXA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $459dacb245969e47$export$2e2bcd8739ae039; });
function $459dacb245969e47$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $459dacb245969e47$export$2e2bcd8739ae039 = $459dacb245969e47$var$clamp;

});



parcelRegister("2Tlns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21b14cea2973a454$export$2e2bcd8739ae039; });
const $21b14cea2973a454$var$common = {
    black: '#000',
    white: '#fff'
};
var $21b14cea2973a454$export$2e2bcd8739ae039 = $21b14cea2973a454$var$common;

});

parcelRegister("e792z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a468bb638f3fb977$export$2e2bcd8739ae039; });
const $a468bb638f3fb977$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $a468bb638f3fb977$export$2e2bcd8739ae039 = $a468bb638f3fb977$var$grey;

});

parcelRegister("gvKl4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0537c8a2c18072d$export$2e2bcd8739ae039; });
const $c0537c8a2c18072d$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $c0537c8a2c18072d$export$2e2bcd8739ae039 = $c0537c8a2c18072d$var$purple;

});

parcelRegister("i8qTq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d33dd5b74ccf7ca5$export$2e2bcd8739ae039; });
const $d33dd5b74ccf7ca5$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $d33dd5b74ccf7ca5$export$2e2bcd8739ae039 = $d33dd5b74ccf7ca5$var$red;

});

parcelRegister("aJ8CV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf4cc77a48c16bc$export$2e2bcd8739ae039; });
const $7cf4cc77a48c16bc$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $7cf4cc77a48c16bc$export$2e2bcd8739ae039 = $7cf4cc77a48c16bc$var$orange;

});

parcelRegister("9AdkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fa1d22913d0059f$export$2e2bcd8739ae039; });
const $6fa1d22913d0059f$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $6fa1d22913d0059f$export$2e2bcd8739ae039 = $6fa1d22913d0059f$var$blue;

});

parcelRegister("fjtU1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b25fd3667cd9bd71$export$2e2bcd8739ae039; });
const $b25fd3667cd9bd71$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $b25fd3667cd9bd71$export$2e2bcd8739ae039 = $b25fd3667cd9bd71$var$lightBlue;

});

parcelRegister("dgUFt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a98ba0b293b7876$export$2e2bcd8739ae039; });
const $9a98ba0b293b7876$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $9a98ba0b293b7876$export$2e2bcd8739ae039 = $9a98ba0b293b7876$var$green;

});


parcelRegister("4Wc0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3985e582ef0fb1af$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $gvqxq = parcelRequire("gvqxq");
const $3985e582ef0fb1af$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $3985e582ef0fb1af$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3985e582ef0fb1af$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $3985e582ef0fb1af$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3985e582ef0fb1af$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $3985e582ef0fb1af$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $fbOaB.default)(_ref, $3985e582ef0fb1af$var$_excluded);
    if (typeof fontSize !== 'number') console.error('MUI: `fontSize` is required to be a number.');
    if (typeof htmlFontSize !== 'number') console.error('MUI: `htmlFontSize` is required to be a number.');
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $h4XE0.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $3985e582ef0fb1af$var$defaultFontFamily ? {
            letterSpacing: `${$3985e582ef0fb1af$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3985e582ef0fb1af$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3985e582ef0fb1af$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $gvqxq.default)((0, $h4XE0.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("9Zr0D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $745ec302e0578bb4$export$2e2bcd8739ae039; });
const $745ec302e0578bb4$var$shadowKeyUmbraOpacity = 0.2;
const $745ec302e0578bb4$var$shadowKeyPenumbraOpacity = 0.14;
const $745ec302e0578bb4$var$shadowAmbientShadowOpacity = 0.12;
function $745ec302e0578bb4$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$745ec302e0578bb4$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$745ec302e0578bb4$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$745ec302e0578bb4$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $745ec302e0578bb4$var$shadows = [
    'none',
    $745ec302e0578bb4$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $745ec302e0578bb4$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $745ec302e0578bb4$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $745ec302e0578bb4$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $745ec302e0578bb4$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $745ec302e0578bb4$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $745ec302e0578bb4$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $745ec302e0578bb4$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $745ec302e0578bb4$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $745ec302e0578bb4$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $745ec302e0578bb4$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $745ec302e0578bb4$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $745ec302e0578bb4$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $745ec302e0578bb4$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $745ec302e0578bb4$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $745ec302e0578bb4$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $745ec302e0578bb4$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $745ec302e0578bb4$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $745ec302e0578bb4$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $745ec302e0578bb4$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $745ec302e0578bb4$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $745ec302e0578bb4$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $745ec302e0578bb4$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $745ec302e0578bb4$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $745ec302e0578bb4$export$2e2bcd8739ae039 = $745ec302e0578bb4$var$shadows;

});

parcelRegister("eUKeD", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $adba28f425547079$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $adba28f425547079$export$2e2bcd8739ae039; });

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");
const $adba28f425547079$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $adba28f425547079$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $adba28f425547079$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $adba28f425547079$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $adba28f425547079$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $adba28f425547079$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $h4XE0.default)({}, $adba28f425547079$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $h4XE0.default)({}, $adba28f425547079$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $fbOaB.default)(options, $adba28f425547079$var$_excluded);
        {
            const isString = (value)=>typeof value === 'string';
            // IE11 support, replace with Number.isNaN
            // eslint-disable-next-line no-restricted-globals
            const isNumber = (value)=>!isNaN(parseFloat(value));
            if (!isString(props) && !Array.isArray(props)) console.error('MUI: Argument "props" must be a string or Array.');
            if (!isNumber(durationOption) && !isString(durationOption)) console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
            if (!isString(easingOption)) console.error('MUI: Argument "easing" must be a string.');
            if (!isNumber(delay) && !isString(delay)) console.error('MUI: Argument "delay" must be a number or a string.');
            if (typeof options !== 'object') console.error([
                'MUI: Secong argument of transition.create must be an object.',
                "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"
            ].join('\n'));
            if (Object.keys(other).length !== 0) console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);
        }
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $adba28f425547079$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $adba28f425547079$var$formatMs(delay)}`).join(',');
    };
    return (0, $h4XE0.default)({
        getAutoHeightDuration: $adba28f425547079$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("3aNqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f8a47f2e20a6a9$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $24f8a47f2e20a6a9$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $24f8a47f2e20a6a9$export$2e2bcd8739ae039 = $24f8a47f2e20a6a9$var$zIndex;

});



parcelRegister("4hHwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ea8325447835cb$export$2e2bcd8739ae039; });
var $31ea8325447835cb$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("lzlXq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb3de6232070d7dd$export$2e2bcd8739ae039; });

var $jXkrt = parcelRequire("jXkrt");
const $fb3de6232070d7dd$var$rootShouldForwardProp = (prop)=>(0, $jXkrt.default)(prop) && prop !== 'classes';
var $fb3de6232070d7dd$export$2e2bcd8739ae039 = $fb3de6232070d7dd$var$rootShouldForwardProp;

});
parcelRegister("jXkrt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8736261f2958b7c$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $e8736261f2958b7c$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $e8736261f2958b7c$export$2e2bcd8739ae039 = $e8736261f2958b7c$var$slotShouldForwardProp;

});



parcelRegister("hZWMo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $d1a5ba8d5ac5932a$export$c7c50641356bdfa5; });

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d1a5ba8d5ac5932a$export$c7c50641356bdfa5(slot) {
    return (0, $aBqGi.default)('MuiSvgIcon', slot);
}
const $d1a5ba8d5ac5932a$var$svgIconClasses = (0, $cDqLM.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $d1a5ba8d5ac5932a$export$2e2bcd8739ae039 = $d1a5ba8d5ac5932a$var$svgIconClasses;

});
parcelRegister("cDqLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $932de47286e6b0d1$export$2e2bcd8739ae039; });

var $aBqGi = parcelRequire("aBqGi");
function $932de47286e6b0d1$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $aBqGi.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});





parcelRegister("jxkIq", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $e3912b0dce78d865$export$a7c73072b1a182ae; }, function (v) { return $e3912b0dce78d865$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e3912b0dce78d865$export$9f27bc3417b4524d; }, function (v) { return $e3912b0dce78d865$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e3912b0dce78d865$export$db77ccec0bb4ccac; }, function (v) { return $e3912b0dce78d865$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e3912b0dce78d865$export$8392c0c9d3dcbd35; }, function (v) { return $e3912b0dce78d865$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e3912b0dce78d865$export$ffb0004e005737fa; }, function (v) { return $e3912b0dce78d865$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e3912b0dce78d865$export$b624eff549462981; }, function (v) { return $e3912b0dce78d865$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e3912b0dce78d865$export$7897aa7841a5380c; }, function (v) { return $e3912b0dce78d865$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e3912b0dce78d865$export$602eac185826482c; }, function (v) { return $e3912b0dce78d865$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e3912b0dce78d865$export$e2c29f18771995cb; }, function (v) { return $e3912b0dce78d865$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e3912b0dce78d865$export$5f8d39834fd61797; }, function (v) { return $e3912b0dce78d865$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e3912b0dce78d865$export$74bf444e3cd11ea5; }, function (v) { return $e3912b0dce78d865$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $e3912b0dce78d865$export$998bcd577473dd93; }, function (v) { return $e3912b0dce78d865$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e3912b0dce78d865$export$b706b080d889d2c9; }, function (v) { return $e3912b0dce78d865$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e3912b0dce78d865$export$5be5a87408f70ddc; }, function (v) { return $e3912b0dce78d865$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e3912b0dce78d865$export$45a5e7f76e0caa8d; }, function (v) { return $e3912b0dce78d865$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e3912b0dce78d865$export$455c2e768291efa6; }, function (v) { return $e3912b0dce78d865$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e3912b0dce78d865$export$9522e17588c12572; }, function (v) { return $e3912b0dce78d865$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e3912b0dce78d865$export$2110ac352bb060b9; }, function (v) { return $e3912b0dce78d865$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e3912b0dce78d865$export$56885ab8b9c456ab; }, function (v) { return $e3912b0dce78d865$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e3912b0dce78d865$export$d927fcb6adf8f9de; }, function (v) { return $e3912b0dce78d865$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e3912b0dce78d865$export$b82d16f27459e05a; }, function (v) { return $e3912b0dce78d865$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e3912b0dce78d865$export$522c17b4f5e123e8; }, function (v) { return $e3912b0dce78d865$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e3912b0dce78d865$export$1aabd8a0274ecfd6; }, function (v) { return $e3912b0dce78d865$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $e3912b0dce78d865$export$3d6c20d97e46b957; }, function (v) { return $e3912b0dce78d865$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e3912b0dce78d865$export$9b621391a187a31a; }, function (v) { return $e3912b0dce78d865$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e3912b0dce78d865$export$f5bbd400c2f4426f; }, function (v) { return $e3912b0dce78d865$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e3912b0dce78d865$export$a7c73072b1a182ae;
var $e3912b0dce78d865$export$9f27bc3417b4524d;
var $e3912b0dce78d865$export$db77ccec0bb4ccac;
var $e3912b0dce78d865$export$8392c0c9d3dcbd35;
var $e3912b0dce78d865$export$ffb0004e005737fa;
var $e3912b0dce78d865$export$b624eff549462981;
var $e3912b0dce78d865$export$7897aa7841a5380c;
var $e3912b0dce78d865$export$602eac185826482c;
var $e3912b0dce78d865$export$e2c29f18771995cb;
var $e3912b0dce78d865$export$5f8d39834fd61797;
var $e3912b0dce78d865$export$74bf444e3cd11ea5;
var $e3912b0dce78d865$export$998bcd577473dd93;
var $e3912b0dce78d865$export$b706b080d889d2c9;
var $e3912b0dce78d865$export$5be5a87408f70ddc;
var $e3912b0dce78d865$export$45a5e7f76e0caa8d;
var $e3912b0dce78d865$export$455c2e768291efa6;
var $e3912b0dce78d865$export$9522e17588c12572;
var $e3912b0dce78d865$export$2110ac352bb060b9;
var $e3912b0dce78d865$export$56885ab8b9c456ab;
var $e3912b0dce78d865$export$d927fcb6adf8f9de;
var $e3912b0dce78d865$export$b82d16f27459e05a;
var $e3912b0dce78d865$export$522c17b4f5e123e8;
var $e3912b0dce78d865$export$1aabd8a0274ecfd6;
var $e3912b0dce78d865$export$3d6c20d97e46b957;
var $e3912b0dce78d865$export$9b621391a187a31a;
var $e3912b0dce78d865$export$f5bbd400c2f4426f;
"use strict";
(function() {
    function typeOf(object) {
        if ("object" === typeof object && null !== object) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    switch(object = object.type, object){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                        case REACT_VIEW_TRANSITION_TYPE:
                            return object;
                        default:
                            switch(object = object && object.$$typeof, object){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                    return object;
                                case REACT_CONSUMER_TYPE:
                                    return object;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    $e3912b0dce78d865$export$a7c73072b1a182ae = REACT_CONSUMER_TYPE;
    $e3912b0dce78d865$export$9f27bc3417b4524d = REACT_CONTEXT_TYPE;
    $e3912b0dce78d865$export$db77ccec0bb4ccac = REACT_ELEMENT_TYPE;
    $e3912b0dce78d865$export$8392c0c9d3dcbd35 = REACT_FORWARD_REF_TYPE;
    $e3912b0dce78d865$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $e3912b0dce78d865$export$b624eff549462981 = REACT_LAZY_TYPE;
    $e3912b0dce78d865$export$7897aa7841a5380c = REACT_MEMO_TYPE;
    $e3912b0dce78d865$export$602eac185826482c = REACT_PORTAL_TYPE;
    $e3912b0dce78d865$export$e2c29f18771995cb = REACT_PROFILER_TYPE;
    $e3912b0dce78d865$export$5f8d39834fd61797 = REACT_STRICT_MODE_TYPE;
    $e3912b0dce78d865$export$74bf444e3cd11ea5 = REACT_SUSPENSE_TYPE;
    $e3912b0dce78d865$export$998bcd577473dd93 = REACT_SUSPENSE_LIST_TYPE;
    $e3912b0dce78d865$export$b706b080d889d2c9 = function(object) {
        return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    $e3912b0dce78d865$export$5be5a87408f70ddc = function(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    $e3912b0dce78d865$export$45a5e7f76e0caa8d = function(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    $e3912b0dce78d865$export$455c2e768291efa6 = function(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    $e3912b0dce78d865$export$9522e17588c12572 = function(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    $e3912b0dce78d865$export$2110ac352bb060b9 = function(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    };
    $e3912b0dce78d865$export$56885ab8b9c456ab = function(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    };
    $e3912b0dce78d865$export$d927fcb6adf8f9de = function(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    };
    $e3912b0dce78d865$export$b82d16f27459e05a = function(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    };
    $e3912b0dce78d865$export$522c17b4f5e123e8 = function(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    $e3912b0dce78d865$export$1aabd8a0274ecfd6 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    $e3912b0dce78d865$export$3d6c20d97e46b957 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    $e3912b0dce78d865$export$9b621391a187a31a = function(type) {
        return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
    };
    $e3912b0dce78d865$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("7wrxA", function(module, exports) {
module.exports = new URL("logo-light.df1bd14c.svg", import.meta.url).toString();

});

parcelRegister("b7qLs", function(module, exports) {
module.exports = new URL("rocket-logo.af3c998e.svg", import.meta.url).toString();

});

parcelRegister("bIlHR", function(module, exports) {
module.exports = new URL("navbar-profile.876c9cb4.svg", import.meta.url).toString();

});

parcelRegister("khR9j", function(module, exports) {
module.exports = new URL("logo-dark.68c3823e.svg", import.meta.url).toString();

});

parcelRegister("8bMoi", function(module, exports) {
module.exports = new URL("logo-dark-small.1a2a9d82.svg", import.meta.url).toString();

});

parcelRegister("9stpi", function(module, exports) {
module.exports = new URL("facebook.083eecc3.svg", import.meta.url).toString();

});

parcelRegister("Y75fz", function(module, exports) {
module.exports = new URL("twitter.b8b54306.svg", import.meta.url).toString();

});

parcelRegister("762CQ", function(module, exports) {
module.exports = new URL("footer-linkedin.56e84146.svg", import.meta.url).toString();

});

parcelRegister("9wJDx", function(module, exports) {
module.exports = new URL("white-bg-template.fe3b3c87.png", import.meta.url).toString();

});

parcelRegister("jl3Li", function(module, exports) {
module.exports = new URL("expand.e615d568.svg", import.meta.url).toString();

});

parcelRegister("by3Sp", function(module, exports) {
module.exports = new URL("no-website.fffbae5b.svg", import.meta.url).toString();

});

parcelRegister("lSN08", function(module, exports) {
module.exports = new URL("site-setting.e5143146.svg", import.meta.url).toString();

});

parcelRegister("5Ggop", function(module, exports) {
module.exports = new URL("extra-option.a28af855.svg", import.meta.url).toString();

});

parcelRegister("2DfTm", function(module, exports) {
module.exports = new URL("bg-img.fec22d75.svg", import.meta.url).toString();

});

parcelRegister("k11CC", function(module, exports) {
module.exports = new URL("rocketpages-logo.e311c3bc.svg", import.meta.url).toString();

});

parcelRegister("3uxUg", function(module, exports) {
module.exports = new URL("header-illustration-light.37da4125.svg", import.meta.url).toString();

});

parcelRegister("eFNK8", function(module, exports) {
module.exports = new URL("hero-media-illustration-light.c5bde580.svg", import.meta.url).toString();

});

parcelRegister("fvuGF", function(module, exports) {
module.exports = new URL("hero-media-light.f6bb078c.svg", import.meta.url).toString();

});

parcelRegister("1xhds", function(module, exports) {
module.exports = new URL("hero-media-dark.761b0542.svg", import.meta.url).toString();

});

parcelRegister("2QlwY", function(module, exports) {
module.exports = new URL("rocketpages-logo-light.738f3460.svg", import.meta.url).toString();

});

parcelRegister("1V8au", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("9Q4tv", function(module, exports) {
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */ 'use strict';

var $2upBZ = parcelRequire("2upBZ");

var $bs9BZ = parcelRequire("bs9BZ");
// Reasonable defaults
var $729c71011c801dc5$var$PIXEL_STEP = 10;
var $729c71011c801dc5$var$LINE_HEIGHT = 40;
var $729c71011c801dc5$var$PAGE_HEIGHT = 800;
/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */ function $729c71011c801dc5$var$normalizeWheel(/*object*/ event) /*object*/ {
    var sX = 0, sY = 0, pX = 0, pY = 0; // pixelX, pixelY
    // Legacy
    if ('detail' in event) sY = event.detail;
    if ('wheelDelta' in event) sY = -event.wheelDelta / 120;
    if ('wheelDeltaY' in event) sY = -event.wheelDeltaY / 120;
    if ('wheelDeltaX' in event) sX = -event.wheelDeltaX / 120;
    // side scrolling on FF with DOMMouseScroll
    if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
    }
    pX = sX * $729c71011c801dc5$var$PIXEL_STEP;
    pY = sY * $729c71011c801dc5$var$PIXEL_STEP;
    if ('deltaY' in event) pY = event.deltaY;
    if ('deltaX' in event) pX = event.deltaX;
    if ((pX || pY) && event.deltaMode) {
        if (event.deltaMode == 1) {
            pX *= $729c71011c801dc5$var$LINE_HEIGHT;
            pY *= $729c71011c801dc5$var$LINE_HEIGHT;
        } else {
            pX *= $729c71011c801dc5$var$PAGE_HEIGHT;
            pY *= $729c71011c801dc5$var$PAGE_HEIGHT;
        }
    }
    // Fall-back if spin cannot be determined
    if (pX && !sX) sX = pX < 1 ? -1 : 1;
    if (pY && !sY) sY = pY < 1 ? -1 : 1;
    return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
    };
}
/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */ $729c71011c801dc5$var$normalizeWheel.getEventType = function() /*string*/ {
    return $2upBZ.firefox() ? 'DOMMouseScroll' : $bs9BZ('wheel') ? 'wheel' : 'mousewheel';
};
module.exports = $729c71011c801dc5$var$normalizeWheel;

});
parcelRegister("2upBZ", function(module, exports) {
/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */ /**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */ var $1d0240102c18a4da$var$_populated = false;
// Browsers
var $1d0240102c18a4da$var$_ie, $1d0240102c18a4da$var$_firefox, $1d0240102c18a4da$var$_opera, $1d0240102c18a4da$var$_webkit, $1d0240102c18a4da$var$_chrome;
// Actual IE browser for compatibility mode
var $1d0240102c18a4da$var$_ie_real_version;
// Platforms
var $1d0240102c18a4da$var$_osx, $1d0240102c18a4da$var$_windows, $1d0240102c18a4da$var$_linux, $1d0240102c18a4da$var$_android;
// Architectures
var $1d0240102c18a4da$var$_win64;
// Devices
var $1d0240102c18a4da$var$_iphone, $1d0240102c18a4da$var$_ipad, $1d0240102c18a4da$var$_native;
var $1d0240102c18a4da$var$_mobile;
function $1d0240102c18a4da$var$_populate() {
    if ($1d0240102c18a4da$var$_populated) return;
    $1d0240102c18a4da$var$_populated = true;
    // To work around buggy JS libraries that can't handle multi-digit
    // version numbers, Opera 10's user agent string claims it's Opera
    // 9, then later includes a Version/X.Y field:
    //
    // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
    var uas = navigator.userAgent;
    var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
    var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
    $1d0240102c18a4da$var$_iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
    $1d0240102c18a4da$var$_ipad = /\b(iP[ao]d)/.exec(uas);
    $1d0240102c18a4da$var$_android = /Android/i.exec(uas);
    $1d0240102c18a4da$var$_native = /FBAN\/\w+;/i.exec(uas);
    $1d0240102c18a4da$var$_mobile = /Mobile/i.exec(uas);
    // Note that the IE team blog would have you believe you should be checking
    // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
    // from either x64 or ia64;  so ultimately, you should just check for Win64
    // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
    // Windows will send 'WOW64' instead.
    $1d0240102c18a4da$var$_win64 = !!/Win64/.exec(uas);
    if (agent) {
        $1d0240102c18a4da$var$_ie = agent[1] ? parseFloat(agent[1]) : agent[5] ? parseFloat(agent[5]) : NaN;
        // IE compatibility mode
        if ($1d0240102c18a4da$var$_ie && document && document.documentMode) $1d0240102c18a4da$var$_ie = document.documentMode;
        // grab the "true" ie version from the trident token if available
        var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
        $1d0240102c18a4da$var$_ie_real_version = trident ? parseFloat(trident[1]) + 4 : $1d0240102c18a4da$var$_ie;
        $1d0240102c18a4da$var$_firefox = agent[2] ? parseFloat(agent[2]) : NaN;
        $1d0240102c18a4da$var$_opera = agent[3] ? parseFloat(agent[3]) : NaN;
        $1d0240102c18a4da$var$_webkit = agent[4] ? parseFloat(agent[4]) : NaN;
        if ($1d0240102c18a4da$var$_webkit) {
            // We do not add the regexp to the above test, because it will always
            // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
            // the userAgent string.
            agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
            $1d0240102c18a4da$var$_chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
        } else $1d0240102c18a4da$var$_chrome = NaN;
    } else $1d0240102c18a4da$var$_ie = $1d0240102c18a4da$var$_firefox = $1d0240102c18a4da$var$_opera = $1d0240102c18a4da$var$_chrome = $1d0240102c18a4da$var$_webkit = NaN;
    if (os) {
        if (os[1]) {
            // Detect OS X version.  If no version number matches, set _osx to true.
            // Version examples:  10, 10_6_1, 10.7
            // Parses version number as a float, taking only first two sets of
            // digits.  If only one set of digits is found, returns just the major
            // version number.
            var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
            $1d0240102c18a4da$var$_osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
        } else $1d0240102c18a4da$var$_osx = false;
        $1d0240102c18a4da$var$_windows = !!os[2];
        $1d0240102c18a4da$var$_linux = !!os[3];
    } else $1d0240102c18a4da$var$_osx = $1d0240102c18a4da$var$_windows = $1d0240102c18a4da$var$_linux = false;
}
var $1d0240102c18a4da$var$UserAgent_DEPRECATED = {
    /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ ie: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_ie;
    },
    /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */ ieCompatibilityMode: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_ie_real_version > $1d0240102c18a4da$var$_ie;
    },
    /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */ ie64: function() {
        return $1d0240102c18a4da$var$UserAgent_DEPRECATED.ie() && $1d0240102c18a4da$var$_win64;
    },
    /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ firefox: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_firefox;
    },
    /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ opera: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_opera;
    },
    /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ webkit: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_webkit;
    },
    /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */ safari: function() {
        return $1d0240102c18a4da$var$UserAgent_DEPRECATED.webkit();
    },
    /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ chrome: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_chrome;
    },
    /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */ windows: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_windows;
    },
    /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */ osx: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_osx;
    },
    /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */ linux: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_linux;
    },
    /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */ iphone: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_iphone;
    },
    mobile: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_iphone || $1d0240102c18a4da$var$_ipad || $1d0240102c18a4da$var$_android || $1d0240102c18a4da$var$_mobile;
    },
    nativeApp: function() {
        // webviews inside of the native apps
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_native;
    },
    android: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_android;
    },
    ipad: function() {
        return $1d0240102c18a4da$var$_populate() || $1d0240102c18a4da$var$_ipad;
    }
};
module.exports = $1d0240102c18a4da$var$UserAgent_DEPRECATED;

});

parcelRegister("bs9BZ", function(module, exports) {
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */ 'use strict';

var $jkkwP = parcelRequire("jkkwP");
var $8569c3f1c82612d0$var$useHasFeature;
if ($jkkwP.canUseDOM) $8569c3f1c82612d0$var$useHasFeature = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
// @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
document.implementation.hasFeature('', '') !== true;
/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function $8569c3f1c82612d0$var$isEventSupported(eventNameSuffix, capture) {
    if (!$jkkwP.canUseDOM || capture && !('addEventListener' in document)) return false;
    var eventName = 'on' + eventNameSuffix;
    var isSupported = eventName in document;
    if (!isSupported) {
        var element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
    }
    if (!isSupported && $8569c3f1c82612d0$var$useHasFeature && eventNameSuffix === 'wheel') // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
    return isSupported;
}
module.exports = $8569c3f1c82612d0$var$isEventSupported;

});
parcelRegister("jkkwP", function(module, exports) {
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */ /*jslint evil: true */ 'use strict';
var $e11fcf182e781744$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */ var $e11fcf182e781744$var$ExecutionEnvironment = {
    canUseDOM: $e11fcf182e781744$var$canUseDOM,
    canUseWorkers: typeof Worker !== 'undefined',
    canUseEventListeners: $e11fcf182e781744$var$canUseDOM && !!(window.addEventListener || window.attachEvent),
    canUseViewport: $e11fcf182e781744$var$canUseDOM && !!window.screen,
    isInWorker: !$e11fcf182e781744$var$canUseDOM // For now, this is true - might change in the future.
};
module.exports = $e11fcf182e781744$var$ExecutionEnvironment;

});



parcelRegister("5w35B", function(module, exports) {
module.exports = new URL("rotate-left_.a95436b5.svg", import.meta.url).toString();

});

parcelRegister("o1MqC", function(module, exports) {
module.exports = new URL("rotate-right.8d3c0cd9.svg", import.meta.url).toString();

});

parcelRegister("lP7AQ", function(module, exports) {
module.exports = new URL("flip_right.7d85f9d5.svg", import.meta.url).toString();

});

parcelRegister("bS3dc", function(module, exports) {
module.exports = new URL("flip_left.039efc05.svg", import.meta.url).toString();

});

parcelRegister("7OJZE", function(module, exports) {
module.exports = new URL("google.cac6ba5e.svg", import.meta.url).toString();

});

parcelRegister("bL04G", function(module, exports) {
module.exports = new URL("linkedin.e1fd5c1e.svg", import.meta.url).toString();

});

parcelRegister("20V3y", function(module, exports) {
module.exports = new URL("check-icon.5885a3fd.svg", import.meta.url).toString();

});

parcelRegister("ejk8q", function(module, exports) {
module.exports = new URL("no-image.843e7ae4.svg", import.meta.url).toString();

});

parcelRegister("1o8uV", function(module, exports) {
module.exports = new URL("close.3467343a.svg", import.meta.url).toString();

});

parcelRegister("gN0Oc", function(module, exports) {
module.exports = new URL("check-icon.9c694b2b.png", import.meta.url).toString();

});

parcelRegister("etvPu", function(module, exports) {

var $670gj = parcelRequire("670gj");

var $4P2kA = parcelRequire("4P2kA");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $670gj.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $4P2kA;
module.exports = isBuffer;

});
parcelRegister("670gj", function(module, exports) {

var $gGfQ8 = parcelRequire("gGfQ8");
/** Detect free variable `self`. */ var $47339993295539c2$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $47339993295539c2$var$root = $gGfQ8 || $47339993295539c2$var$freeSelf || Function('return this')();
module.exports = $47339993295539c2$var$root;

});
parcelRegister("gGfQ8", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $c24cdb0aeff4a641$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $c24cdb0aeff4a641$var$freeGlobal;

});


parcelRegister("4P2kA", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $382dbbc404564a2c$var$stubFalse() {
    return false;
}
module.exports = $382dbbc404564a2c$var$stubFalse;

});


parcelRegister("jCPbW", function(module, exports) {

var $gGfQ8 = parcelRequire("gGfQ8");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gGfQ8.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("bl8CU", function(module, exports) {

var $670gj = parcelRequire("670gj");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $670gj.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("i04Md", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1abeea3a395a578$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ier4x.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $d1abeea3a395a578$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("ier4x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d45e88c10410afd4$export$2e2bcd8739ae039; });

var $iFBbo = parcelRequire("iFBbo");
/** Detect free variable `self`. */ var $d45e88c10410afd4$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d45e88c10410afd4$var$root = (0, $iFBbo.default) || $d45e88c10410afd4$var$freeSelf || Function('return this')();
var $d45e88c10410afd4$export$2e2bcd8739ae039 = $d45e88c10410afd4$var$root;

});
parcelRegister("iFBbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d978e60cc59c038b$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $d978e60cc59c038b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d978e60cc59c038b$export$2e2bcd8739ae039 = $d978e60cc59c038b$var$freeGlobal;

});



parcelRegister("igoKr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4bceb13546a335b$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");

var $k1Fw9 = parcelRequire("k1Fw9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ier4x.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $k1Fw9.default);
var $d4bceb13546a335b$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("k1Fw9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9441b24891bd46f$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e9441b24891bd46f$var$stubFalse() {
    return false;
}
var $e9441b24891bd46f$export$2e2bcd8739ae039 = $e9441b24891bd46f$var$stubFalse;

});


parcelRegister("85lyy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e2f83048239daf1$export$2e2bcd8739ae039; });

var $iFBbo = parcelRequire("iFBbo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $iFBbo.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $5e2f83048239daf1$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("jyeBD", function(module, exports) {

$parcel$export(module.exports, "handleFocus", function () { return handleFocus; });

var $eeH7J = parcelRequire("eeH7J");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
};

});

parcelRegister("7KrIt", function(module, exports) {
module.exports = new URL("google.617e6344.svg", import.meta.url).toString();

});

parcelRegister("2k6GV", function(module, exports) {
module.exports = new URL("LinkedIn.3090dbf2.svg", import.meta.url).toString();

});

parcelRegister("eeRV7", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("cJRqn", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("cdbbO", function(module, exports) {
module.exports = new URL("edit.0145d912.svg", import.meta.url).toString();

});

parcelRegister("8OUdM", function(module, exports) {
module.exports = new URL("delete.d174d7e5.svg", import.meta.url).toString();

});

parcelRegister("iIIUf", function(module, exports) {
module.exports = new URL("BlogListingThumbnail.839cf68b.png", import.meta.url).toString();

});

var $ec778282dbc2f0c6$exports = {};

(parcelRequire("3ueMA")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"7HVny\",\"index.35265eec.js\",\"kidkT\",\"logo-light.df1bd14c.svg\",\"3q8Gj\",\"rocket-logo.af3c998e.svg\",\"9zI44\",\"navbar-profile.876c9cb4.svg\",\"iRDtM\",\"logo-dark.68c3823e.svg\",\"8uQYu\",\"logo-dark-small.1a2a9d82.svg\",\"ehye2\",\"facebook.083eecc3.svg\",\"dzYJa\",\"twitter.b8b54306.svg\",\"8SdkG\",\"footer-linkedin.56e84146.svg\",\"hjFYt\",\"white-bg-template.fe3b3c87.png\",\"43Haj\",\"expand.e615d568.svg\",\"k4GHa\",\"no-website.fffbae5b.svg\",\"kldUD\",\"site-setting.e5143146.svg\",\"dcvyb\",\"extra-option.a28af855.svg\",\"3Nkh0\",\"bg-img.fec22d75.svg\",\"l0rJ6\",\"rocketpages-logo.e311c3bc.svg\",\"bJtUj\",\"header-illustration-light.37da4125.svg\",\"7DTdZ\",\"hero-media-illustration-light.c5bde580.svg\",\"jotXF\",\"hero-media-light.f6bb078c.svg\",\"bZwDs\",\"hero-media-dark.761b0542.svg\",\"9SZGT\",\"rocketpages-logo-light.738f3460.svg\",\"21wBO\",\"rotate-left_.a95436b5.svg\",\"bEZrW\",\"rotate-right.8d3c0cd9.svg\",\"jKjTQ\",\"flip_right.7d85f9d5.svg\",\"gnmXC\",\"flip_left.039efc05.svg\",\"4METz\",\"eye-open.4ceb8078.svg\",\"8GA23\",\"eye-closed.6711f686.svg\",\"4U98Z\",\"google.cac6ba5e.svg\",\"iMxlL\",\"linkedin.e1fd5c1e.svg\",\"9AOCn\",\"check-icon.5885a3fd.svg\",\"9rShp\",\"no-image.843e7ae4.svg\",\"fSM5b\",\"close.3467343a.svg\",\"jQC23\",\"check-icon.9c694b2b.png\",\"1aWrq\",\"bi_eye.6d8dacc1.svg\",\"24BpK\",\"open_eye.688ef7e6.svg\",\"3Vx0W\",\"google.617e6344.svg\",\"liN5S\",\"LinkedIn.3090dbf2.svg\",\"aUVYy\",\"edit.0145d912.svg\",\"973w5\",\"delete.d174d7e5.svg\",\"hGd9i\",\"BlogListingThumbnail.839cf68b.png\"]"));


var $eeH7J = parcelRequire("eeH7J");
// src/index.tsx

var $eeH7J = parcelRequire("eeH7J");
var $0daa0da0e45174e2$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $0daa0da0e45174e2$var$hasElementType = typeof Element !== 'undefined';
var $0daa0da0e45174e2$var$hasMap = typeof Map === 'function';
var $0daa0da0e45174e2$var$hasSet = typeof Set === 'function';
var $0daa0da0e45174e2$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $0daa0da0e45174e2$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$0daa0da0e45174e2$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($0daa0da0e45174e2$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$0daa0da0e45174e2$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($0daa0da0e45174e2$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($0daa0da0e45174e2$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($0daa0da0e45174e2$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$0daa0da0e45174e2$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$0daa0da0e45174e2$exports = function isEqual(a, b) {
    try {
        return $0daa0da0e45174e2$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $f907e43a5c27e9d7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $f907e43a5c27e9d7$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (format === undefined) throw new Error('invariant requires an error message argument');
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$f907e43a5c27e9d7$exports = $f907e43a5c27e9d7$var$invariant;


var $ccb35001ce2fdda8$exports = {};
//
$ccb35001ce2fdda8$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $0206968a9c2cf7b5$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($0206968a9c2cf7b5$var$TAG_NAMES || {});
var $0206968a9c2cf7b5$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $0206968a9c2cf7b5$var$VALID_TAG_NAMES = Object.values($0206968a9c2cf7b5$var$TAG_NAMES);
var $0206968a9c2cf7b5$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $0206968a9c2cf7b5$var$HTML_TAG_MAP = Object.entries($0206968a9c2cf7b5$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $0206968a9c2cf7b5$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $0206968a9c2cf7b5$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $0206968a9c2cf7b5$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $0206968a9c2cf7b5$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $0206968a9c2cf7b5$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $0206968a9c2cf7b5$var$getInnermostProperty(propsList, $0206968a9c2cf7b5$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $0206968a9c2cf7b5$var$getInnermostProperty(propsList, $0206968a9c2cf7b5$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $0206968a9c2cf7b5$var$getOnChangeClientState = (propsList)=>$0206968a9c2cf7b5$var$getInnermostProperty(propsList, $0206968a9c2cf7b5$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $0206968a9c2cf7b5$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $0206968a9c2cf7b5$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $0206968a9c2cf7b5$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $0206968a9c2cf7b5$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $0206968a9c2cf7b5$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $0206968a9c2cf7b5$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $0206968a9c2cf7b5$var$reducePropsToState = (propsList)=>({
        baseTag: $0206968a9c2cf7b5$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $0206968a9c2cf7b5$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $0206968a9c2cf7b5$var$getInnermostProperty(propsList, $0206968a9c2cf7b5$var$HELMET_PROPS.DEFER),
        encode: $0206968a9c2cf7b5$var$getInnermostProperty(propsList, $0206968a9c2cf7b5$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $0206968a9c2cf7b5$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $0206968a9c2cf7b5$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $0206968a9c2cf7b5$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $0206968a9c2cf7b5$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $0206968a9c2cf7b5$var$getOnChangeClientState(propsList),
        scriptTags: $0206968a9c2cf7b5$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $0206968a9c2cf7b5$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $0206968a9c2cf7b5$var$getTitleFromPropsList(propsList),
        titleAttributes: $0206968a9c2cf7b5$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $0206968a9c2cf7b5$var$getAnyTrueFromPropsList(propsList, $0206968a9c2cf7b5$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $0206968a9c2cf7b5$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $0206968a9c2cf7b5$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $0206968a9c2cf7b5$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($0206968a9c2cf7b5$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $0206968a9c2cf7b5$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $0206968a9c2cf7b5$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $0206968a9c2cf7b5$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $0206968a9c2cf7b5$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $0206968a9c2cf7b5$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $0206968a9c2cf7b5$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $0206968a9c2cf7b5$var$flattenArray(title);
    return attributeString ? `<${type} ${$0206968a9c2cf7b5$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$0206968a9c2cf7b5$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$0206968a9c2cf7b5$var$HELMET_ATTRIBUTE}="true">${$0206968a9c2cf7b5$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $0206968a9c2cf7b5$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$0206968a9c2cf7b5$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $0206968a9c2cf7b5$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$0206968a9c2cf7b5$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $0206968a9c2cf7b5$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $0206968a9c2cf7b5$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $0206968a9c2cf7b5$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$0206968a9c2cf7b5$var$HELMET_ATTRIBUTE]: true
    };
    const props = $0206968a9c2cf7b5$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $0206968a9c2cf7b5$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$0206968a9c2cf7b5$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $0206968a9c2cf7b5$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(type, mappedTag);
    });
var $0206968a9c2cf7b5$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$0206968a9c2cf7b5$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$0206968a9c2cf7b5$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$0206968a9c2cf7b5$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$0206968a9c2cf7b5$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$0206968a9c2cf7b5$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$0206968a9c2cf7b5$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $0206968a9c2cf7b5$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $0206968a9c2cf7b5$var$prioritizer(metaTags, $0206968a9c2cf7b5$var$SEO_PRIORITY_TAGS.meta);
    const link = $0206968a9c2cf7b5$var$prioritizer(linkTags, $0206968a9c2cf7b5$var$SEO_PRIORITY_TAGS.link);
    const script = $0206968a9c2cf7b5$var$prioritizer(scriptTags, $0206968a9c2cf7b5$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$0206968a9c2cf7b5$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$0206968a9c2cf7b5$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$0206968a9c2cf7b5$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$0206968a9c2cf7b5$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$0206968a9c2cf7b5$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$0206968a9c2cf7b5$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $0206968a9c2cf7b5$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $0206968a9c2cf7b5$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $0206968a9c2cf7b5$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $0206968a9c2cf7b5$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $0206968a9c2cf7b5$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $0206968a9c2cf7b5$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $0206968a9c2cf7b5$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $0206968a9c2cf7b5$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $0206968a9c2cf7b5$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $0206968a9c2cf7b5$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $0206968a9c2cf7b5$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $0206968a9c2cf7b5$var$server_default = $0206968a9c2cf7b5$var$mapStateOnServer;
// src/HelmetData.ts
var $0206968a9c2cf7b5$var$instances = [];
var $0206968a9c2cf7b5$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $0206968a9c2cf7b5$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $0206968a9c2cf7b5$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $0206968a9c2cf7b5$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $0206968a9c2cf7b5$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $0206968a9c2cf7b5$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $0206968a9c2cf7b5$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $0206968a9c2cf7b5$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var $0206968a9c2cf7b5$var$defaultValue = {};
var $0206968a9c2cf7b5$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext($0206968a9c2cf7b5$var$defaultValue);
var $0206968a9c2cf7b5$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $eeH7J.Component) {
    static canUseDOM = $0206968a9c2cf7b5$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new $0206968a9c2cf7b5$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0206968a9c2cf7b5$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $0206968a9c2cf7b5$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$0206968a9c2cf7b5$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($0206968a9c2cf7b5$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $0206968a9c2cf7b5$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($0206968a9c2cf7b5$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($0206968a9c2cf7b5$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($0206968a9c2cf7b5$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($0206968a9c2cf7b5$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $0206968a9c2cf7b5$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $0206968a9c2cf7b5$var$flattenArray(title);
    $0206968a9c2cf7b5$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $0206968a9c2cf7b5$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $0206968a9c2cf7b5$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $0206968a9c2cf7b5$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $0206968a9c2cf7b5$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $0206968a9c2cf7b5$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $0206968a9c2cf7b5$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $0206968a9c2cf7b5$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $0206968a9c2cf7b5$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $0206968a9c2cf7b5$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $0206968a9c2cf7b5$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $0206968a9c2cf7b5$var$_helmetCallback = null;
var $0206968a9c2cf7b5$var$handleStateChangeOnClient = (newState)=>{
    if ($0206968a9c2cf7b5$var$_helmetCallback) cancelAnimationFrame($0206968a9c2cf7b5$var$_helmetCallback);
    if (newState.defer) $0206968a9c2cf7b5$var$_helmetCallback = requestAnimationFrame(()=>{
        $0206968a9c2cf7b5$var$commitTagChanges(newState, ()=>{
            $0206968a9c2cf7b5$var$_helmetCallback = null;
        });
    });
    else {
        $0206968a9c2cf7b5$var$commitTagChanges(newState);
        $0206968a9c2cf7b5$var$_helmetCallback = null;
    }
};
var $0206968a9c2cf7b5$var$client_default = $0206968a9c2cf7b5$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $0206968a9c2cf7b5$var$HelmetDispatcher = class extends (0, $eeH7J.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ccb35001ce2fdda8$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $0206968a9c2cf7b5$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if ($0206968a9c2cf7b5$export$4719288a8f5f7e71.canUseDOM) $0206968a9c2cf7b5$var$client_default(state);
        else if ($0206968a9c2cf7b5$var$server_default) serverState = $0206968a9c2cf7b5$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var $0206968a9c2cf7b5$export$dcef8f9bb9a41431 = class extends (0, $eeH7J.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0daa0da0e45174e2$exports)))($0206968a9c2cf7b5$var$without(this.props, "helmetData"), $0206968a9c2cf7b5$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($f907e43a5c27e9d7$exports)))($0206968a9c2cf7b5$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$0206968a9c2cf7b5$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($f907e43a5c27e9d7$exports)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$0206968a9c2cf7b5$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $0206968a9c2cf7b5$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $0206968a9c2cf7b5$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0206968a9c2cf7b5$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0206968a9c2cf7b5$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0206968a9c2cf7b5$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};


var $edca1cc69f99f492$export$882461b6382ed46c;
var $edca1cc69f99f492$export$757ceba2d55c277e;
'use strict';
var $dad018249d59322c$exports = {};
'use strict';
function $dad018249d59322c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

$dad018249d59322c$exports = (parcelRequire("apqNv"));


var $edca1cc69f99f492$var$i = $dad018249d59322c$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$edca1cc69f99f492$export$882461b6382ed46c = function(c, o) {
    $edca1cc69f99f492$var$i.usingClientEntryPoint = true;
    try {
        return $dad018249d59322c$exports.createRoot(c, o);
    } finally{
        $edca1cc69f99f492$var$i.usingClientEntryPoint = false;
    }
};
$edca1cc69f99f492$export$757ceba2d55c277e = function(c, h, o) {
    $edca1cc69f99f492$var$i.usingClientEntryPoint = true;
    try {
        return $dad018249d59322c$exports.hydrateRoot(c, h, o);
    } finally{
        $edca1cc69f99f492$var$i.usingClientEntryPoint = false;
    }
};


/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eeH7J = parcelRequire("eeH7J");

/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $0f13e53339adf17f$var$_extends() {
    return $0f13e53339adf17f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0f13e53339adf17f$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $0f13e53339adf17f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($0f13e53339adf17f$export$e19cd5f9376f8cee || ($0f13e53339adf17f$export$e19cd5f9376f8cee = {}));
const $0f13e53339adf17f$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $0f13e53339adf17f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $0f13e53339adf17f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $0f13e53339adf17f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $0f13e53339adf17f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $0f13e53339adf17f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
    }
    return $0f13e53339adf17f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $0f13e53339adf17f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $0f13e53339adf17f$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $0f13e53339adf17f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $0f13e53339adf17f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $0f13e53339adf17f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $0f13e53339adf17f$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $0f13e53339adf17f$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $0f13e53339adf17f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $0f13e53339adf17f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $0f13e53339adf17f$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $0f13e53339adf17f$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $0f13e53339adf17f$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $0f13e53339adf17f$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $0f13e53339adf17f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $0f13e53339adf17f$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($0f13e53339adf17f$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        let location = $0f13e53339adf17f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $0f13e53339adf17f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        let location = $0f13e53339adf17f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $0f13e53339adf17f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $0f13e53339adf17f$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($0f13e53339adf17f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($0f13e53339adf17f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $0f13e53339adf17f$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($0f13e53339adf17f$var$ResultType || ($0f13e53339adf17f$var$ResultType = {}));
const $0f13e53339adf17f$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $0f13e53339adf17f$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $0f13e53339adf17f$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $0f13e53339adf17f$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $0f13e53339adf17f$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($0f13e53339adf17f$var$isIndexRoute(route)) {
            let indexRoute = $0f13e53339adf17f$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $0f13e53339adf17f$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $0f13e53339adf17f$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $0f13e53339adf17f$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $0f13e53339adf17f$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $0f13e53339adf17f$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $0f13e53339adf17f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $0f13e53339adf17f$var$flattenRoutes(routes);
    $0f13e53339adf17f$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $0f13e53339adf17f$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $0f13e53339adf17f$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $0f13e53339adf17f$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $0f13e53339adf17f$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $0f13e53339adf17f$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $0f13e53339adf17f$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $0f13e53339adf17f$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $0f13e53339adf17f$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $0f13e53339adf17f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $0f13e53339adf17f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $0f13e53339adf17f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $0f13e53339adf17f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $0f13e53339adf17f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $0f13e53339adf17f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $0f13e53339adf17f$var$paramRe = /^:[\w-]+$/;
const $0f13e53339adf17f$var$dynamicSegmentValue = 3;
const $0f13e53339adf17f$var$indexRouteValue = 2;
const $0f13e53339adf17f$var$emptySegmentValue = 1;
const $0f13e53339adf17f$var$staticSegmentValue = 10;
const $0f13e53339adf17f$var$splatPenalty = -2;
const $0f13e53339adf17f$var$isSplat = (s)=>s === "*";
function $0f13e53339adf17f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($0f13e53339adf17f$var$isSplat)) initialScore += $0f13e53339adf17f$var$splatPenalty;
    if (index) initialScore += $0f13e53339adf17f$var$indexRouteValue;
    return segments.filter((s)=>!$0f13e53339adf17f$var$isSplat(s)).reduce((score, segment)=>score + ($0f13e53339adf17f$var$paramRe.test(segment) ? $0f13e53339adf17f$var$dynamicSegmentValue : segment === "" ? $0f13e53339adf17f$var$emptySegmentValue : $0f13e53339adf17f$var$staticSegmentValue), initialScore);
}
function $0f13e53339adf17f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $0f13e53339adf17f$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $0f13e53339adf17f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $0f13e53339adf17f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $0f13e53339adf17f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $0f13e53339adf17f$export$a5c6d149b50c1d86($0f13e53339adf17f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $0f13e53339adf17f$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $0f13e53339adf17f$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $0f13e53339adf17f$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $0f13e53339adf17f$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $0f13e53339adf17f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $0f13e53339adf17f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $0f13e53339adf17f$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $0f13e53339adf17f$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $0f13e53339adf17f$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $0f13e53339adf17f$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $0f13e53339adf17f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $0f13e53339adf17f$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $0f13e53339adf17f$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $0f13e53339adf17f$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $0f13e53339adf17f$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $0f13e53339adf17f$var$normalizeSearch(search),
        hash: $0f13e53339adf17f$var$normalizeHash(hash)
    };
}
function $0f13e53339adf17f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $0f13e53339adf17f$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $0f13e53339adf17f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $0f13e53339adf17f$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $0f13e53339adf17f$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $0f13e53339adf17f$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $0f13e53339adf17f$export$8ccf933b0513f8d0(toArg);
    else {
        to = $0f13e53339adf17f$var$_extends({}, toArg);
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $0f13e53339adf17f$var$getInvalidPathError("?", "pathname", "search", to));
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $0f13e53339adf17f$var$getInvalidPathError("#", "pathname", "hash", to));
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $0f13e53339adf17f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $0f13e53339adf17f$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $0f13e53339adf17f$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $0f13e53339adf17f$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $0f13e53339adf17f$export$86d9a7913e44197e = (paths)=>$0f13e53339adf17f$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $0f13e53339adf17f$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $0f13e53339adf17f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $0f13e53339adf17f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $0f13e53339adf17f$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $0f13e53339adf17f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $0f13e53339adf17f$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $0f13e53339adf17f$export$4051a07651545597(data, init) {
    return new $0f13e53339adf17f$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $0f13e53339adf17f$export$42a99a7a4bc0e76a extends Error {
}
class $0f13e53339adf17f$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $0f13e53339adf17f$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $0f13e53339adf17f$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $0f13e53339adf17f$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $0f13e53339adf17f$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $0f13e53339adf17f$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $0f13e53339adf17f$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $0f13e53339adf17f$var$unwrapTrackedPromise(value) {
    if (!$0f13e53339adf17f$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $0f13e53339adf17f$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $0f13e53339adf17f$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0f13e53339adf17f$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $0f13e53339adf17f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0f13e53339adf17f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $0f13e53339adf17f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0f13e53339adf17f$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $0f13e53339adf17f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $0f13e53339adf17f$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $0f13e53339adf17f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $0f13e53339adf17f$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $0f13e53339adf17f$var$validMutationMethods = new Set($0f13e53339adf17f$var$validMutationMethodsArr);
const $0f13e53339adf17f$var$validRequestMethodsArr = [
    "get",
    ...$0f13e53339adf17f$var$validMutationMethodsArr
];
const $0f13e53339adf17f$var$validRequestMethods = new Set($0f13e53339adf17f$var$validRequestMethodsArr);
const $0f13e53339adf17f$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $0f13e53339adf17f$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $0f13e53339adf17f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0f13e53339adf17f$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0f13e53339adf17f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $0f13e53339adf17f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $0f13e53339adf17f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $0f13e53339adf17f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $0f13e53339adf17f$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0f13e53339adf17f$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $0f13e53339adf17f$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $0f13e53339adf17f$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$0f13e53339adf17f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$0f13e53339adf17f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $0f13e53339adf17f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $0f13e53339adf17f$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $0f13e53339adf17f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $0f13e53339adf17f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$0f13e53339adf17f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($0f13e53339adf17f$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $0f13e53339adf17f$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $0f13e53339adf17f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $0f13e53339adf17f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $0f13e53339adf17f$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $0f13e53339adf17f$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($0f13e53339adf17f$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $0f13e53339adf17f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $0f13e53339adf17f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $0f13e53339adf17f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $0f13e53339adf17f$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $0f13e53339adf17f$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $0f13e53339adf17f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $0f13e53339adf17f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $0f13e53339adf17f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $0f13e53339adf17f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $0f13e53339adf17f$var$findNearestBoundary(matches).route.id,
            {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $0f13e53339adf17f$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($0f13e53339adf17f$var$isErrorResult(result) && $0f13e53339adf17f$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $0f13e53339adf17f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $0f13e53339adf17f$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $0f13e53339adf17f$var$_extends({
            matches: updatedMatches || matches
        }, $0f13e53339adf17f$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $0f13e53339adf17f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $0f13e53339adf17f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $0f13e53339adf17f$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $0f13e53339adf17f$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $0f13e53339adf17f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($0f13e53339adf17f$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $0f13e53339adf17f$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($0f13e53339adf17f$var$isDeferredResult(result)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $0f13e53339adf17f$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $0f13e53339adf17f$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($0f13e53339adf17f$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $0f13e53339adf17f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $0f13e53339adf17f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $0f13e53339adf17f$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $0f13e53339adf17f$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $0f13e53339adf17f$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $0f13e53339adf17f$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $0f13e53339adf17f$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $0f13e53339adf17f$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $0f13e53339adf17f$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$0f13e53339adf17f$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $0f13e53339adf17f$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $0f13e53339adf17f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $0f13e53339adf17f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $0f13e53339adf17f$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0f13e53339adf17f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $0f13e53339adf17f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $0f13e53339adf17f$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($0f13e53339adf17f$var$isRedirectResult(actionResult) || $0f13e53339adf17f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($0f13e53339adf17f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $0f13e53339adf17f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($0f13e53339adf17f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($0f13e53339adf17f$var$isDeferredResult(actionResult)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $0f13e53339adf17f$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $0f13e53339adf17f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $0f13e53339adf17f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $0f13e53339adf17f$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $0f13e53339adf17f$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $0f13e53339adf17f$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $0f13e53339adf17f$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $0f13e53339adf17f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0f13e53339adf17f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $0f13e53339adf17f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $0f13e53339adf17f$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($0f13e53339adf17f$var$isDeferredResult(result)) result = await $0f13e53339adf17f$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($0f13e53339adf17f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $0f13e53339adf17f$export$3e9cee6b33872309(!$0f13e53339adf17f$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $0f13e53339adf17f$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $0f13e53339adf17f$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $0f13e53339adf17f$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($0f13e53339adf17f$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $0f13e53339adf17f$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace : $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $0f13e53339adf17f$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($0f13e53339adf17f$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $0f13e53339adf17f$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $0f13e53339adf17f$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $0f13e53339adf17f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $0f13e53339adf17f$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $0f13e53339adf17f$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($0f13e53339adf17f$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $0f13e53339adf17f$var$ResultType.redirect,
                response: $0f13e53339adf17f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $0f13e53339adf17f$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $0f13e53339adf17f$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $0f13e53339adf17f$var$ResultType.error,
                    error: $0f13e53339adf17f$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $0f13e53339adf17f$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $0f13e53339adf17f$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $0f13e53339adf17f$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $0f13e53339adf17f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $0f13e53339adf17f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $0f13e53339adf17f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $0f13e53339adf17f$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $0f13e53339adf17f$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $0f13e53339adf17f$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $0f13e53339adf17f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$0f13e53339adf17f$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $0f13e53339adf17f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $0f13e53339adf17f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $0f13e53339adf17f$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $0f13e53339adf17f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $0f13e53339adf17f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $0f13e53339adf17f$export$4d0306f8f6a4585b = Symbol("deferred");
function $0f13e53339adf17f$export$3336b097a6fbc59a(routes, opts) {
    $0f13e53339adf17f$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0f13e53339adf17f$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $0f13e53339adf17f$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0f13e53339adf17f$var$createLocation("", $0f13e53339adf17f$export$fe53371bee54353d(url), null, "default");
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0f13e53339adf17f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($0f13e53339adf17f$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $0f13e53339adf17f$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0f13e53339adf17f$var$createLocation("", $0f13e53339adf17f$export$fe53371bee54353d(url), null, "default");
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0f13e53339adf17f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $0f13e53339adf17f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $0f13e53339adf17f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $0f13e53339adf17f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($0f13e53339adf17f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$0f13e53339adf17f$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $0f13e53339adf17f$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($0f13e53339adf17f$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $0f13e53339adf17f$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $0f13e53339adf17f$var$isResponse(result) ? result : $0f13e53339adf17f$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($0f13e53339adf17f$var$isDataStrategyResult(e) && $0f13e53339adf17f$var$isResponse(e.result)) {
                if (e.type === $0f13e53339adf17f$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($0f13e53339adf17f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($0f13e53339adf17f$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($0f13e53339adf17f$var$isDeferredResult(result)) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($0f13e53339adf17f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $0f13e53339adf17f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $0f13e53339adf17f$var$_extends({}, context, {
                statusCode: $0f13e53339adf17f$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $0f13e53339adf17f$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $0f13e53339adf17f$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $0f13e53339adf17f$var$isErrorResult(pendingActionResult[1]) ? $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $0f13e53339adf17f$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $0f13e53339adf17f$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $0f13e53339adf17f$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $0f13e53339adf17f$var$callDataStrategyImpl(dataStrategy || $0f13e53339adf17f$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($0f13e53339adf17f$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $0f13e53339adf17f$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($0f13e53339adf17f$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $0f13e53339adf17f$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $0f13e53339adf17f$export$fec11da027c70692(routes, context, error) {
    let newContext = $0f13e53339adf17f$var$_extends({}, context, {
        statusCode: $0f13e53339adf17f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $0f13e53339adf17f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $0f13e53339adf17f$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $0f13e53339adf17f$export$cae722b0cc860f13(to ? to : ".", $0f13e53339adf17f$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $0f13e53339adf17f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $0f13e53339adf17f$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $0f13e53339adf17f$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $0f13e53339adf17f$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $0f13e53339adf17f$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$0f13e53339adf17f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$0f13e53339adf17f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $0f13e53339adf17f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $0f13e53339adf17f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $0f13e53339adf17f$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$0f13e53339adf17f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$0f13e53339adf17f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $0f13e53339adf17f$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $0f13e53339adf17f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $0f13e53339adf17f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $0f13e53339adf17f$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $0f13e53339adf17f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $0f13e53339adf17f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $0f13e53339adf17f$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $0f13e53339adf17f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $0f13e53339adf17f$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $0f13e53339adf17f$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($0f13e53339adf17f$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $0f13e53339adf17f$var$shouldRevalidateLoader(match, $0f13e53339adf17f$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $0f13e53339adf17f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $0f13e53339adf17f$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $0f13e53339adf17f$var$shouldRevalidateLoader(fetcherMatch, $0f13e53339adf17f$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $0f13e53339adf17f$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $0f13e53339adf17f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $0f13e53339adf17f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $0f13e53339adf17f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $0f13e53339adf17f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $0f13e53339adf17f$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$0f13e53339adf17f$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $0f13e53339adf17f$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$0f13e53339adf17f$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $0f13e53339adf17f$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $0f13e53339adf17f$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $0f13e53339adf17f$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$0f13e53339adf17f$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $0f13e53339adf17f$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $0f13e53339adf17f$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $0f13e53339adf17f$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $0f13e53339adf17f$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $0f13e53339adf17f$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $0f13e53339adf17f$var$ResultType.data,
                result: undefined
            });
        };
        return $0f13e53339adf17f$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $0f13e53339adf17f$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $0f13e53339adf17f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $0f13e53339adf17f$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $0f13e53339adf17f$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $0f13e53339adf17f$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $0f13e53339adf17f$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($0f13e53339adf17f$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: e
            };
        }
        if (type === $0f13e53339adf17f$var$ResultType.error) return {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: new $0f13e53339adf17f$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $0f13e53339adf17f$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $0f13e53339adf17f$var$ResultType.error) {
        if ($0f13e53339adf17f$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $0f13e53339adf17f$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: new $0f13e53339adf17f$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $0f13e53339adf17f$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: result,
            statusCode: $0f13e53339adf17f$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($0f13e53339adf17f$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $0f13e53339adf17f$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($0f13e53339adf17f$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $0f13e53339adf17f$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $0f13e53339adf17f$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $0f13e53339adf17f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $0f13e53339adf17f$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$0f13e53339adf17f$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $0f13e53339adf17f$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $0f13e53339adf17f$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($0f13e53339adf17f$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $0f13e53339adf17f$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $0f13e53339adf17f$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $0f13e53339adf17f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($0f13e53339adf17f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $0f13e53339adf17f$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $0f13e53339adf17f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $0f13e53339adf17f$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $0f13e53339adf17f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $0f13e53339adf17f$export$3e9cee6b33872309(!$0f13e53339adf17f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $0f13e53339adf17f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($0f13e53339adf17f$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $0f13e53339adf17f$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $0f13e53339adf17f$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($0f13e53339adf17f$var$isErrorResult(result)) {
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $0f13e53339adf17f$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($0f13e53339adf17f$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $0f13e53339adf17f$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($0f13e53339adf17f$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $0f13e53339adf17f$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $0f13e53339adf17f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $0f13e53339adf17f$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $0f13e53339adf17f$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $0f13e53339adf17f$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $0f13e53339adf17f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $0f13e53339adf17f$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $0f13e53339adf17f$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $0f13e53339adf17f$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $0f13e53339adf17f$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($0f13e53339adf17f$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $0f13e53339adf17f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(path) : path;
    return $0f13e53339adf17f$export$fe53371bee54353d($0f13e53339adf17f$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $0f13e53339adf17f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $0f13e53339adf17f$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $0f13e53339adf17f$var$ResultType.data || result.type === $0f13e53339adf17f$var$ResultType.error);
}
function $0f13e53339adf17f$var$isRedirectDataStrategyResultResult(result) {
    return $0f13e53339adf17f$var$isResponse(result.result) && $0f13e53339adf17f$var$redirectStatusCodes.has(result.result.status);
}
function $0f13e53339adf17f$var$isDeferredResult(result) {
    return result.type === $0f13e53339adf17f$var$ResultType.deferred;
}
function $0f13e53339adf17f$var$isErrorResult(result) {
    return result.type === $0f13e53339adf17f$var$ResultType.error;
}
function $0f13e53339adf17f$var$isRedirectResult(result) {
    return (result && result.type) === $0f13e53339adf17f$var$ResultType.redirect;
}
function $0f13e53339adf17f$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $0f13e53339adf17f$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $0f13e53339adf17f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $0f13e53339adf17f$var$isRedirectResponse(result) {
    if (!$0f13e53339adf17f$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $0f13e53339adf17f$var$isValidMethod(method) {
    return $0f13e53339adf17f$var$validRequestMethods.has(method.toLowerCase());
}
function $0f13e53339adf17f$var$isMutationMethod(method) {
    return $0f13e53339adf17f$var$validMutationMethods.has(method.toLowerCase());
}
async function $0f13e53339adf17f$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$0f13e53339adf17f$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($0f13e53339adf17f$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $0f13e53339adf17f$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $0f13e53339adf17f$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($0f13e53339adf17f$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $0f13e53339adf17f$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $0f13e53339adf17f$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $0f13e53339adf17f$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $0f13e53339adf17f$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $0f13e53339adf17f$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $0f13e53339adf17f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $0f13e53339adf17f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $0f13e53339adf17f$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $0f13e53339adf17f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $0f13e53339adf17f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $0f13e53339adf17f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $0f13e53339adf17f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $0f13e53339adf17f$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $0f13e53339adf17f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $0f13e53339adf17f$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $0f13e53339adf17f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $0f13e53339adf17f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $0f13e53339adf17f$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eeH7J = parcelRequire("eeH7J");

function $0d4e57672a3dc010$var$_extends() {
    return $0d4e57672a3dc010$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0d4e57672a3dc010$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $0d4e57672a3dc010$export$3add0d5dce533e2e = /*#__PURE__*/ $eeH7J.createContext(null);
$0d4e57672a3dc010$export$3add0d5dce533e2e.displayName = "DataRouter";
const $0d4e57672a3dc010$export$145dfa71566a64dc = /*#__PURE__*/ $eeH7J.createContext(null);
$0d4e57672a3dc010$export$145dfa71566a64dc.displayName = "DataRouterState";
const $0d4e57672a3dc010$var$AwaitContext = /*#__PURE__*/ $eeH7J.createContext(null);
$0d4e57672a3dc010$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $0d4e57672a3dc010$export$26749e8557646306 = /*#__PURE__*/ $eeH7J.createContext(null);
$0d4e57672a3dc010$export$26749e8557646306.displayName = "Navigation";
const $0d4e57672a3dc010$export$c7914228fb69b0f5 = /*#__PURE__*/ $eeH7J.createContext(null);
$0d4e57672a3dc010$export$c7914228fb69b0f5.displayName = "Location";
const $0d4e57672a3dc010$export$9072aa6dd1f93057 = /*#__PURE__*/ $eeH7J.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$0d4e57672a3dc010$export$9072aa6dd1f93057.displayName = "Route";
const $0d4e57672a3dc010$var$RouteErrorContext = /*#__PURE__*/ $eeH7J.createContext(null);
$0d4e57672a3dc010$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $0d4e57672a3dc010$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $0d4e57672a3dc010$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $0f13e53339adf17f$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $0d4e57672a3dc010$export$9c954a9d03d32f4a() {
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $0d4e57672a3dc010$export$45d76561a5302f2b() {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $0d4e57672a3dc010$export$1b3f31771c5d07c() {
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $0d4e57672a3dc010$export$6c330e8992e8a295(pattern) {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    return $eeH7J.useMemo(()=>(0, $0f13e53339adf17f$export$81336c211d5ff295)(pattern, (0, $0f13e53339adf17f$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $0d4e57672a3dc010$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $0d4e57672a3dc010$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $0d4e57672a3dc010$var$useNavigateStable() : $0d4e57672a3dc010$var$useNavigateUnstable();
}
function $0d4e57672a3dc010$var$useNavigateUnstable() {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $0f13e53339adf17f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $eeH7J.useRef(false);
    $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eeH7J.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $0f13e53339adf17f$export$c0e02632e14916fd)(activeRef.current, $0d4e57672a3dc010$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $0f13e53339adf17f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $0f13e53339adf17f$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $0d4e57672a3dc010$var$OutletContext = /*#__PURE__*/ $eeH7J.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $0d4e57672a3dc010$export$4138103a3ae699cc() {
    return $eeH7J.useContext($0d4e57672a3dc010$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $0d4e57672a3dc010$export$a3be3530d8e40d0b(context) {
    let outlet = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $0d4e57672a3dc010$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $0d4e57672a3dc010$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $0f13e53339adf17f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $eeH7J.useMemo(()=>(0, $0f13e53339adf17f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $0d4e57672a3dc010$export$5d3fca4a98652595(routes, locationArg) {
    return $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: parentMatches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $0d4e57672a3dc010$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ("\"" + parentPathname + "\" (under <Route path=\"" + parentPath + "\">) but the ") + "parent route path has no trailing \"*\". This means if you navigate " + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ("Please change the parent <Route path=\"" + parentPath + "\"> to <Route ") + ("path=\"" + (parentPath === "/" ? "*" : parentPath + "/*") + "\">."));
    }
    let locationFromContext = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $0f13e53339adf17f$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ("matched by all parent routes. The current pathname base is \"" + parentPathnameBase + "\" ") + ("but pathname \"" + parsedLocationArg.pathname + "\" was given in the `location` prop."));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $0f13e53339adf17f$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $0f13e53339adf17f$export$c0e02632e14916fd)(parentRoute || matches != null, "No routes matched location \"" + location.pathname + location.search + location.hash + "\" ");
    (0, $0f13e53339adf17f$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, "Matched leaf route at location \"" + location.pathname + location.search + location.hash + "\" " + "does not have an element or Component. This means it will render an <Outlet /> with a " + "null value by default resulting in an \"empty\" page.");
    let renderedMatches = $0d4e57672a3dc010$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $0f13e53339adf17f$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $0f13e53339adf17f$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $0d4e57672a3dc010$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $0f13e53339adf17f$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $0d4e57672a3dc010$var$DefaultErrorComponent() {
    let error = $0d4e57672a3dc010$export$ed527bf60f6e05f2();
    let message = (0, $0f13e53339adf17f$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $eeH7J.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $eeH7J.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $eeH7J.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eeH7J.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eeH7J.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $0d4e57672a3dc010$var$defaultErrorElement = /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$DefaultErrorComponent, null);
class $0d4e57672a3dc010$var$RenderErrorBoundary extends $eeH7J.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $0d4e57672a3dc010$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $0d4e57672a3dc010$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $0d4e57672a3dc010$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $0d4e57672a3dc010$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eeH7J.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $0d4e57672a3dc010$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($0d4e57672a3dc010$var$DataRouterHook || {});
var $0d4e57672a3dc010$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($0d4e57672a3dc010$var$DataRouterStateHook || {});
function $0d4e57672a3dc010$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0d4e57672a3dc010$var$useDataRouterContext(hookName) {
    let ctx = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    !ctx && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, $0d4e57672a3dc010$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $0d4e57672a3dc010$var$useDataRouterState(hookName) {
    let state = $eeH7J.useContext($0d4e57672a3dc010$export$145dfa71566a64dc);
    !state && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, $0d4e57672a3dc010$var$getDataRouterConsoleError(hookName));
    return state;
}
function $0d4e57672a3dc010$var$useRouteContext(hookName) {
    let route = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    !route && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, $0d4e57672a3dc010$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $0d4e57672a3dc010$var$useCurrentRouteId(hookName) {
    let route = $0d4e57672a3dc010$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, hookName + " can only be used on routes that contain a unique \"id\"");
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $0d4e57672a3dc010$export$5fc8298006ad9e58() {
    return $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $0d4e57672a3dc010$export$d0fd4b7106de2769() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $0d4e57672a3dc010$export$600dc272ed516c15() {
    let dataRouterContext = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseRevalidator);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRevalidator);
    return $eeH7J.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $0d4e57672a3dc010$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseMatches);
    return $eeH7J.useMemo(()=>matches.map((m)=>(0, $0f13e53339adf17f$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $0d4e57672a3dc010$export$1448a5050d252c4d() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $0d4e57672a3dc010$export$fd5d37484eab868d(routeId) {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $0d4e57672a3dc010$export$fdc00f3f26066d5e() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseActionData);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $0d4e57672a3dc010$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eeH7J.useContext($0d4e57672a3dc010$var$RouteErrorContext);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteError);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $0d4e57672a3dc010$export$78a72ddb39bdd145() {
    let value = $eeH7J.useContext($0d4e57672a3dc010$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $0d4e57672a3dc010$export$17f53340677d5831() {
    let value = $eeH7J.useContext($0d4e57672a3dc010$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $0d4e57672a3dc010$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $0d4e57672a3dc010$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseBlocker);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eeH7J.useState("");
    let blockerFunction = $eeH7J.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $0d4e57672a3dc010$var$_extends({}, currentLocation, {
                pathname: (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $0d4e57672a3dc010$var$_extends({}, nextLocation, {
                pathname: (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eeH7J.useEffect(()=>{
        let key = String(++$0d4e57672a3dc010$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eeH7J.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $0f13e53339adf17f$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $0d4e57672a3dc010$var$useNavigateStable() {
    let { router: router } = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseNavigateStable);
    let id = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eeH7J.useRef(false);
    $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eeH7J.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $0f13e53339adf17f$export$c0e02632e14916fd)(activeRef.current, $0d4e57672a3dc010$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $0d4e57672a3dc010$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $0d4e57672a3dc010$var$alreadyWarned$1 = {};
function $0d4e57672a3dc010$var$warningOnce(key, cond, message) {
    if (!cond && !$0d4e57672a3dc010$var$alreadyWarned$1[key]) {
        $0d4e57672a3dc010$var$alreadyWarned$1[key] = true;
        (0, $0f13e53339adf17f$export$c0e02632e14916fd)(false, message);
    }
}
const $0d4e57672a3dc010$var$alreadyWarned = {};
function $0d4e57672a3dc010$var$warnOnce(key, message) {
    if (!$0d4e57672a3dc010$var$alreadyWarned[message]) {
        $0d4e57672a3dc010$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $0d4e57672a3dc010$var$logDeprecation = (flag, msg, link)=>$0d4e57672a3dc010$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $0d4e57672a3dc010$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $0d4e57672a3dc010$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $0d4e57672a3dc010$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $0d4e57672a3dc010$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $0d4e57672a3dc010$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $0d4e57672a3dc010$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $0d4e57672a3dc010$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0d4e57672a3dc010$var$START_TRANSITION = "startTransition";
const $0d4e57672a3dc010$var$startTransitionImpl = $eeH7J[$0d4e57672a3dc010$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0d4e57672a3dc010$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eeH7J.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        if (v7_startTransition && $0d4e57672a3dc010$var$startTransitionImpl) $0d4e57672a3dc010$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eeH7J.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eeH7J.useEffect(()=>{
        (0, $0f13e53339adf17f$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eeH7J.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eeH7J.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $eeH7J.useEffect(()=>$0d4e57672a3dc010$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $0d4e57672a3dc010$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $0d4e57672a3dc010$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $0f13e53339adf17f$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $0d4e57672a3dc010$var$startTransitionImpl ? $0d4e57672a3dc010$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eeH7J.useEffect(()=>$0d4e57672a3dc010$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $0d4e57672a3dc010$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    let { future: future, static: isStatic } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    (0, $0f13e53339adf17f$export$c0e02632e14916fd)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let navigate = $0d4e57672a3dc010$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $0f13e53339adf17f$export$cae722b0cc860f13)(to, (0, $0f13e53339adf17f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eeH7J.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $0d4e57672a3dc010$export$910ae8079b2c2852(props) {
    return $0d4e57672a3dc010$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $0d4e57672a3dc010$export$e7b0ac011bb776c6(_props) {
    (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $0d4e57672a3dc010$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $0f13e53339adf17f$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eeH7J.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $0d4e57672a3dc010$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $0f13e53339adf17f$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eeH7J.useMemo(()=>{
        let trailingPathname = (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $0f13e53339adf17f$export$c0e02632e14916fd)(locationContext != null, "<Router basename=\"" + basename + "\"> is not able to match the URL " + ("\"" + pathname + search + hash + "\" because it does not start with the ") + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $0d4e57672a3dc010$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $0d4e57672a3dc010$export$5d3fca4a98652595($0d4e57672a3dc010$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $0d4e57672a3dc010$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$ResolveAwait, null, children));
}
var $0d4e57672a3dc010$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($0d4e57672a3dc010$var$AwaitRenderStatus || {});
const $0d4e57672a3dc010$var$neverSettledPromise = new Promise(()=>{});
class $0d4e57672a3dc010$var$AwaitErrorBoundary extends $eeH7J.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $0d4e57672a3dc010$var$AwaitRenderStatus.error : "_data" in promise ? $0d4e57672a3dc010$var$AwaitRenderStatus.success : $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error && promise._error instanceof (0, $0f13e53339adf17f$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $0d4e57672a3dc010$var$neverSettledPromise;
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $0d4e57672a3dc010$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $0d4e57672a3dc010$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $0d4e57672a3dc010$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eeH7J.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eeH7J.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $0d4e57672a3dc010$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $0d4e57672a3dc010$export$e7b0ac011bb776c6) && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $0d4e57672a3dc010$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $0d4e57672a3dc010$export$daf73786167a7f72(matches) {
    return $0d4e57672a3dc010$var$_renderMatches(matches);
}
function $0d4e57672a3dc010$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $0f13e53339adf17f$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $eeH7J.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, $0f13e53339adf17f$export$c0e02632e14916fd)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ $eeH7J.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $0f13e53339adf17f$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $eeH7J.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $0d4e57672a3dc010$export$f30f7e456d254e83(routes, opts) {
    return (0, $0f13e53339adf17f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0d4e57672a3dc010$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $0f13e53339adf17f$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $0d4e57672a3dc010$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $42e24d1152893e59$var$_extends() {
    return $42e24d1152893e59$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $42e24d1152893e59$var$_extends.apply(null, arguments);
}
function $42e24d1152893e59$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $42e24d1152893e59$var$defaultMethod = "get";
const $42e24d1152893e59$var$defaultEncType = "application/x-www-form-urlencoded";
function $42e24d1152893e59$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $42e24d1152893e59$var$isButtonElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $42e24d1152893e59$var$isFormElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $42e24d1152893e59$var$isInputElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $42e24d1152893e59$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $42e24d1152893e59$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$42e24d1152893e59$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $42e24d1152893e59$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $42e24d1152893e59$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $42e24d1152893e59$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $42e24d1152893e59$var$_formDataSupportsSubmitter = null;
function $42e24d1152893e59$var$isFormDataSubmitterSupported() {
    if ($42e24d1152893e59$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $42e24d1152893e59$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $42e24d1152893e59$var$_formDataSupportsSubmitter = true;
    }
    return $42e24d1152893e59$var$_formDataSupportsSubmitter;
}
const $42e24d1152893e59$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $42e24d1152893e59$var$getFormEncType(encType) {
    if (encType != null && !$42e24d1152893e59$var$supportedFormEncTypes.has(encType)) {
        (0, $0f13e53339adf17f$export$c0e02632e14916fd)(false, "\"" + encType + "\" is not a valid `encType` for `<Form>`/`<fetcher.Form>` " + ("and will default to \"" + $42e24d1152893e59$var$defaultEncType + "\""));
        return null;
    }
    return encType;
}
function $42e24d1152893e59$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($42e24d1152893e59$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $42e24d1152893e59$var$defaultMethod;
        encType = $42e24d1152893e59$var$getFormEncType(target.getAttribute("enctype")) || $42e24d1152893e59$var$defaultEncType;
        formData = new FormData(target);
    } else if ($42e24d1152893e59$var$isButtonElement(target) || $42e24d1152893e59$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $42e24d1152893e59$var$defaultMethod;
        encType = $42e24d1152893e59$var$getFormEncType(target.getAttribute("formenctype")) || $42e24d1152893e59$var$getFormEncType(form.getAttribute("enctype")) || $42e24d1152893e59$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$42e24d1152893e59$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($42e24d1152893e59$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $42e24d1152893e59$var$defaultMethod;
        action = null;
        encType = $42e24d1152893e59$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $42e24d1152893e59$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $42e24d1152893e59$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $42e24d1152893e59$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $42e24d1152893e59$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $42e24d1152893e59$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $42e24d1152893e59$export$1f3f55432a00e06d(routes, opts) {
    return (0, $0f13e53339adf17f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $42e24d1152893e59$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $0f13e53339adf17f$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $42e24d1152893e59$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $0d4e57672a3dc010$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $42e24d1152893e59$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $0f13e53339adf17f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $42e24d1152893e59$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $0f13e53339adf17f$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $42e24d1152893e59$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $0d4e57672a3dc010$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $42e24d1152893e59$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $42e24d1152893e59$var$_extends({}, state, {
        errors: $42e24d1152893e59$var$deserializeErrors(state.errors)
    });
    return state;
}
function $42e24d1152893e59$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $0f13e53339adf17f$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $42e24d1152893e59$export$7ad602f0e94e62d1 = /*#__PURE__*/ $eeH7J.createContext({
    isTransitioning: false
});
$42e24d1152893e59$export$7ad602f0e94e62d1.displayName = "ViewTransition";
const $42e24d1152893e59$export$148fd98d095596d4 = /*#__PURE__*/ $eeH7J.createContext(new Map());
$42e24d1152893e59$export$148fd98d095596d4.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $42e24d1152893e59$var$START_TRANSITION = "startTransition";
const $42e24d1152893e59$var$startTransitionImpl = $eeH7J[$42e24d1152893e59$var$START_TRANSITION];
const $42e24d1152893e59$var$FLUSH_SYNC = "flushSync";
const $42e24d1152893e59$var$flushSyncImpl = $dad018249d59322c$exports[$42e24d1152893e59$var$FLUSH_SYNC];
const $42e24d1152893e59$var$USE_ID = "useId";
const $42e24d1152893e59$var$useIdImpl = $eeH7J[$42e24d1152893e59$var$USE_ID];
function $42e24d1152893e59$var$startTransitionSafe(cb) {
    if ($42e24d1152893e59$var$startTransitionImpl) $42e24d1152893e59$var$startTransitionImpl(cb);
    else cb();
}
function $42e24d1152893e59$var$flushSyncSafe(cb) {
    if ($42e24d1152893e59$var$flushSyncImpl) $42e24d1152893e59$var$flushSyncImpl(cb);
    else cb();
}
class $42e24d1152893e59$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $42e24d1152893e59$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eeH7J.useState(router.state);
    let [pendingState, setPendingState] = $eeH7J.useState();
    let [vtContext, setVtContext] = $eeH7J.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eeH7J.useState();
    let [transition, setTransition] = $eeH7J.useState();
    let [interruption, setInterruption] = $eeH7J.useState();
    let fetcherData = $eeH7J.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $eeH7J.useCallback((cb)=>{
        if (v7_startTransition) $42e24d1152893e59$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $eeH7J.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $42e24d1152893e59$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $42e24d1152893e59$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $42e24d1152893e59$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $42e24d1152893e59$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $42e24d1152893e59$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eeH7J.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $eeH7J.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $42e24d1152893e59$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $eeH7J.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $eeH7J.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $eeH7J.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $eeH7J.useEffect(()=>{
        (0, $0f13e53339adf17f$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eeH7J.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eeH7J.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $eeH7J.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $eeH7J.useEffect(()=>(0, $0d4e57672a3dc010$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $0d4e57672a3dc010$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eeH7J.createElement((0, $0d4e57672a3dc010$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $eeH7J.createElement((0, $0d4e57672a3dc010$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $42e24d1152893e59$var$MemoizedDataRoutes = /*#__PURE__*/ $eeH7J.memo($42e24d1152893e59$var$DataRoutes);
function $42e24d1152893e59$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $0d4e57672a3dc010$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $42e24d1152893e59$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $0f13e53339adf17f$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eeH7J.useEffect(()=>(0, $0d4e57672a3dc010$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $0d4e57672a3dc010$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $42e24d1152893e59$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $0f13e53339adf17f$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eeH7J.useEffect(()=>(0, $0d4e57672a3dc010$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $0d4e57672a3dc010$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $42e24d1152893e59$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eeH7J.useEffect(()=>(0, $0d4e57672a3dc010$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $0d4e57672a3dc010$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
$42e24d1152893e59$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $42e24d1152893e59$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $42e24d1152893e59$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $42e24d1152893e59$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eeH7J.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref7, $42e24d1152893e59$var$_excluded);
    let { basename: basename } = $eeH7J.useContext((0, $0d4e57672a3dc010$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $42e24d1152893e59$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($42e24d1152893e59$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $0f13e53339adf17f$export$c0e02632e14916fd)(false, "<Link to=\"" + to + "\"> contains an invalid URL which will probably break " + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $0d4e57672a3dc010$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $42e24d1152893e59$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eeH7J.createElement("a", $42e24d1152893e59$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$42e24d1152893e59$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $42e24d1152893e59$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eeH7J.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref8, $42e24d1152893e59$var$_excluded2);
    let path = (0, $0d4e57672a3dc010$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    let routerState = $eeH7J.useContext((0, $0d4e57672a3dc010$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $eeH7J.useContext((0, $0d4e57672a3dc010$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $42e24d1152893e59$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$a6c7ac8248d6e38a, $42e24d1152893e59$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$42e24d1152893e59$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $42e24d1152893e59$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eeH7J.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $42e24d1152893e59$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref9, $42e24d1152893e59$var$_excluded3);
    let submit = $42e24d1152893e59$export$47c85c6e3a081d3();
    let formAction = $42e24d1152893e59$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $eeH7J.createElement("form", $42e24d1152893e59$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$42e24d1152893e59$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $42e24d1152893e59$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $42e24d1152893e59$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$42e24d1152893e59$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $42e24d1152893e59$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($42e24d1152893e59$var$DataRouterHook || ($42e24d1152893e59$var$DataRouterHook = {}));
var $42e24d1152893e59$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($42e24d1152893e59$var$DataRouterStateHook || ($42e24d1152893e59$var$DataRouterStateHook = {}));
// Internal hooks
function $42e24d1152893e59$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $42e24d1152893e59$var$useDataRouterContext(hookName) {
    let ctx = $eeH7J.useContext((0, $0d4e57672a3dc010$export$3add0d5dce533e2e));
    !ctx && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, $42e24d1152893e59$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $42e24d1152893e59$var$useDataRouterState(hookName) {
    let state = $eeH7J.useContext((0, $0d4e57672a3dc010$export$145dfa71566a64dc));
    !state && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, $42e24d1152893e59$var$getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $42e24d1152893e59$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    let location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    let path = (0, $0d4e57672a3dc010$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $eeH7J.useCallback((event)=>{
        if ($42e24d1152893e59$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $0f13e53339adf17f$export$fe53371bee54353d)(location) === (0, $0f13e53339adf17f$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $42e24d1152893e59$export$f1a78c17382fe22a(defaultInit) {
    (0, $0f13e53339adf17f$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $eeH7J.useRef($42e24d1152893e59$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eeH7J.useRef(false);
    let location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    let searchParams = $eeH7J.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $42e24d1152893e59$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    let setSearchParams = $eeH7J.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $42e24d1152893e59$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $42e24d1152893e59$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $42e24d1152893e59$var$fetcherId = 0;
let $42e24d1152893e59$var$getUniqueFetcherId = ()=>"__" + String(++$42e24d1152893e59$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $42e24d1152893e59$export$47c85c6e3a081d3() {
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $eeH7J.useContext((0, $0d4e57672a3dc010$export$26749e8557646306));
    let currentRouteId = (0, $0d4e57672a3dc010$export$5fc8298006ad9e58)();
    return $eeH7J.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $42e24d1152893e59$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $42e24d1152893e59$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $42e24d1152893e59$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $42e24d1152893e59$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eeH7J.useContext((0, $0d4e57672a3dc010$export$26749e8557646306));
    let routeContext = $eeH7J.useContext((0, $0d4e57672a3dc010$export$9072aa6dd1f93057));
    !routeContext && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $42e24d1152893e59$var$_extends({}, (0, $0d4e57672a3dc010$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $0f13e53339adf17f$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $0f13e53339adf17f$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $42e24d1152893e59$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseFetcher);
    let state = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $eeH7J.useContext($42e24d1152893e59$export$148fd98d095596d4);
    let route = $eeH7J.useContext((0, $0d4e57672a3dc010$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "useFetcher can only be used on routes that contain a unique \"id\"");
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $42e24d1152893e59$var$useIdImpl ? $42e24d1152893e59$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $eeH7J.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($42e24d1152893e59$var$getUniqueFetcherId());
    // Registration/cleanup
    $eeH7J.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $eeH7J.useCallback((href, opts)=>{
        !routeId && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $42e24d1152893e59$export$47c85c6e3a081d3();
    let submit = $eeH7J.useCallback((target, opts)=>{
        submitImpl(target, $42e24d1152893e59$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $eeH7J.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $eeH7J.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$a7fed597f4b8afd8, $42e24d1152893e59$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $0f13e53339adf17f$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eeH7J.useMemo(()=>$42e24d1152893e59$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $42e24d1152893e59$export$fa996778a3a31087() {
    let state = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $42e24d1152893e59$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $42e24d1152893e59$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $42e24d1152893e59$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $eeH7J.useContext((0, $0d4e57672a3dc010$export$26749e8557646306));
    let location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    let matches = (0, $0d4e57672a3dc010$export$2378eb7f5ff86053)();
    let navigation = (0, $0d4e57672a3dc010$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $eeH7J.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $42e24d1152893e59$var$usePageHide($eeH7J.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $42e24d1152893e59$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($42e24d1152893e59$var$savedScrollPositions));
        } catch (error) {
            (0, $0f13e53339adf17f$export$c0e02632e14916fd)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $42e24d1152893e59$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($42e24d1152893e59$var$_extends({}, location, {
                    pathname: (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($42e24d1152893e59$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $42e24d1152893e59$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eeH7J.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $42e24d1152893e59$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eeH7J.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $42e24d1152893e59$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $0d4e57672a3dc010$export$b273b3273281a049)(when);
    $eeH7J.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eeH7J.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $42e24d1152893e59$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $eeH7J.useContext($42e24d1152893e59$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $0f13e53339adf17f$export$3e9cee6b33872309)(false, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.useViewTransitionState);
    let path = (0, $0d4e57672a3dc010$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $0f13e53339adf17f$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $0f13e53339adf17f$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $0f13e53339adf17f$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $eeH7J = parcelRequire("eeH7J");


var $99435d3d07a9b8ca$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($99435d3d07a9b8ca$exports, "__esModule", {
    value: true
});
$99435d3d07a9b8ca$exports.default = void 0;

var $99435d3d07a9b8ca$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $99435d3d07a9b8ca$var$_default = $99435d3d07a9b8ca$exports.default = (0, $99435d3d07a9b8ca$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $dRzna.jsx)("path", {
        d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75M19 19H5V5h14z"
    }, "0"),
    /*#__PURE__*/ (0, $dRzna.jsx)("path", {
        d: "m15.08 11.03-2.12-2.12L7 14.86V17h2.1zm1.77-1.76c.2-.2.2-.51 0-.71l-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12z"
    }, "1")
], 'NoteAltOutlined');



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $a3026f80917bb629$export$46f01d01378ec5a2(slot) {
    return (0, $aBqGi.default)('MuiDivider', slot);
}
const $a3026f80917bb629$var$dividerClasses = (0, $cDqLM.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $a3026f80917bb629$export$2e2bcd8739ae039 = $a3026f80917bb629$var$dividerClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $549aebd5e339f81b$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $549aebd5e339f81b$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $a3026f80917bb629$export$46f01d01378ec5a2), classes);
};
const $549aebd5e339f81b$var$DividerRoot = (0, $hikmr.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $5YtKS.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $h4XE0.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $h4XE0.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $549aebd5e339f81b$var$DividerWrapper = (0, $hikmr.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $549aebd5e339f81b$var$Divider = /*#__PURE__*/ $eeH7J.forwardRef(function Divider(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $fbOaB.default)(props, $549aebd5e339f81b$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $549aebd5e339f81b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($549aebd5e339f81b$var$DividerRoot, (0, $h4XE0.default)({
        as: component,
        className: (0, $er6YD.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $dRzna.jsx)($549aebd5e339f81b$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $549aebd5e339f81b$var$Divider.muiSkipListHighlight = true;
$549aebd5e339f81b$var$Divider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Absolutely position the element.
   * @default false
   */ absolute: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */ flexItem: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */ light: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The component orientation.
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * @ignore
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The text alignment.
   * @default 'center'
   */ textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'center',
        'left',
        'right'
    ]),
    /**
   * The variant to use.
   * @default 'fullWidth'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'fullWidth',
            'inset',
            'middle'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $549aebd5e339f81b$export$2e2bcd8739ae039 = $549aebd5e339f81b$var$Divider;


var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $4yBem = parcelRequire("4yBem");
function $b2f92e84e131ddaf$export$2e2bcd8739ae039(propType1, propType2) {
    return function validate(...args) {
        return propType1(...args) || propType2(...args);
    };
}


function $542b1840e0c5cf64$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $542b1840e0c5cf64$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$542b1840e0c5cf64$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $542b1840e0c5cf64$export$2e2bcd8739ae039 = (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType, $542b1840e0c5cf64$var$elementTypeAcceptingRef);



var $doIAf = parcelRequire("doIAf");

var $4A7Fh = parcelRequire("4A7Fh");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
'use client';
const $cfa90721d4719ace$var$UNINITIALIZED = {};
function $cfa90721d4719ace$export$2e2bcd8739ae039(init, initArg) {
    const ref = $eeH7J.useRef($cfa90721d4719ace$var$UNINITIALIZED);
    if (ref.current === $cfa90721d4719ace$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $eeH7J = parcelRequire("eeH7J");
'use client';
const $bd2272cebe0f5e41$var$EMPTY = [];
function $bd2272cebe0f5e41$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $eeH7J.useEffect(fn, $bd2272cebe0f5e41$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $b639dfbe5b4dc511$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $b639dfbe5b4dc511$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $b639dfbe5b4dc511$export$2e2bcd8739ae039() {
    const timeout = (0, $cfa90721d4719ace$export$2e2bcd8739ae039)($b639dfbe5b4dc511$export$786b4da70f00938b.create).current;
    (0, $bd2272cebe0f5e41$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $b34b966f85c5a68b$var$hadKeyboardEvent = true;
let $b34b966f85c5a68b$var$hadFocusVisibleRecently = false;
const $b34b966f85c5a68b$var$hadFocusVisibleRecentlyTimeout = new (0, $b639dfbe5b4dc511$export$786b4da70f00938b)();
const $b34b966f85c5a68b$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $b34b966f85c5a68b$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $b34b966f85c5a68b$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $b34b966f85c5a68b$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $b34b966f85c5a68b$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $b34b966f85c5a68b$var$handlePointerDown() {
    $b34b966f85c5a68b$var$hadKeyboardEvent = false;
}
function $b34b966f85c5a68b$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($b34b966f85c5a68b$var$hadFocusVisibleRecently) $b34b966f85c5a68b$var$hadKeyboardEvent = true;
    }
}
function $b34b966f85c5a68b$var$prepare(doc) {
    doc.addEventListener('keydown', $b34b966f85c5a68b$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $b34b966f85c5a68b$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $b34b966f85c5a68b$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $b34b966f85c5a68b$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $b34b966f85c5a68b$var$handleVisibilityChange, true);
}
function $b34b966f85c5a68b$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $b34b966f85c5a68b$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $b34b966f85c5a68b$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $b34b966f85c5a68b$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $b34b966f85c5a68b$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $b34b966f85c5a68b$var$handleVisibilityChange, true);
}
function $b34b966f85c5a68b$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $b34b966f85c5a68b$var$hadKeyboardEvent || $b34b966f85c5a68b$var$focusTriggersKeyboardModality(target);
}
function $b34b966f85c5a68b$export$2e2bcd8739ae039() {
    const ref = $eeH7J.useCallback((node)=>{
        if (node != null) $b34b966f85c5a68b$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $eeH7J.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $b34b966f85c5a68b$var$hadFocusVisibleRecently = true;
            $b34b966f85c5a68b$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $b34b966f85c5a68b$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($b34b966f85c5a68b$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $95ddfd63f1c7ad1b$export$2e2bcd8739ae039 = (0, $b34b966f85c5a68b$export$2e2bcd8739ae039);



var $eeH7J = parcelRequire("eeH7J");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $2836634c7617003b$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $c909b21db041accd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $eeH7J.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $2836634c7617003b$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $9d2e4ebd8f7a919e$export$2e2bcd8739ae039 = (0, $c909b21db041accd$export$2e2bcd8739ae039);



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $hZDOg = parcelRequire("hZDOg");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $4A7Fh = parcelRequire("4A7Fh");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $ea4bfc9119af461b$export$24c1f8f60cbac79e(slot) {
    return (0, $aBqGi.default)('MuiTypography', slot);
}
const $ea4bfc9119af461b$var$typographyClasses = (0, $cDqLM.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $ea4bfc9119af461b$export$2e2bcd8739ae039 = $ea4bfc9119af461b$var$typographyClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $32193c68ed830861$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $32193c68ed830861$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $4A7Fh.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $ea4bfc9119af461b$export$24c1f8f60cbac79e), classes);
};
const $32193c68ed830861$export$140e2f5526d3cad8 = (0, $hikmr.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $4A7Fh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $32193c68ed830861$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $32193c68ed830861$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $32193c68ed830861$var$transformDeprecatedColors = (color)=>{
    return $32193c68ed830861$var$colorTransformations[color] || color;
};
const $32193c68ed830861$var$Typography = /*#__PURE__*/ $eeH7J.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $32193c68ed830861$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $hZDOg.default)((0, $h4XE0.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $32193c68ed830861$var$defaultVariantMapping } = props, other = (0, $fbOaB.default)(props, $32193c68ed830861$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $32193c68ed830861$var$defaultVariantMapping[variant]) || 'span';
    const classes = $32193c68ed830861$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($32193c68ed830861$export$140e2f5526d3cad8, (0, $h4XE0.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $er6YD.default)(classes.root, className)
    }, other));
});
$32193c68ed830861$var$Typography.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the component.
   * @default 'inherit'
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'center',
        'inherit',
        'justify',
        'left',
        'right'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */ gutterBottom: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */ noWrap: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */ paragraph: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'body1'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'body1',
            'body2',
            'button',
            'caption',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'inherit',
            'overline',
            'subtitle1',
            'subtitle2'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */ variantMapping: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).object
};
var $32193c68ed830861$export$2e2bcd8739ae039 = $32193c68ed830861$var$Typography;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $16b9e554e02a9a27$export$d6efab9620b78fec(slot) {
    return (0, $aBqGi.default)('MuiLink', slot);
}
const $16b9e554e02a9a27$var$linkClasses = (0, $cDqLM.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $16b9e554e02a9a27$export$2e2bcd8739ae039 = $16b9e554e02a9a27$var$linkClasses;



var $78Maz = parcelRequire("78Maz");

var $5YtKS = parcelRequire("5YtKS");
const $fd3c7c3c98da6b4f$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $fd3c7c3c98da6b4f$var$transformDeprecatedColors = (color)=>{
    return $fd3c7c3c98da6b4f$export$c4e140d5d351182b[color] || color;
};
const $fd3c7c3c98da6b4f$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $fd3c7c3c98da6b4f$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $78Maz.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $78Maz.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $5YtKS.alpha)(color, 0.4);
};
var $fd3c7c3c98da6b4f$export$2e2bcd8739ae039 = $fd3c7c3c98da6b4f$var$getTextDecoration;



var $dRzna = parcelRequire("dRzna");
'use client';
const $6b6b8319e9394158$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $6b6b8319e9394158$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $4A7Fh.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $16b9e554e02a9a27$export$d6efab9620b78fec), classes);
};
const $6b6b8319e9394158$var$LinkRoot = (0, $hikmr.default)((0, $32193c68ed830861$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $4A7Fh.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $h4XE0.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $h4XE0.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $fd3c7c3c98da6b4f$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $16b9e554e02a9a27$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $6b6b8319e9394158$var$Link = /*#__PURE__*/ $eeH7J.forwardRef(function Link(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $fbOaB.default)(props, $6b6b8319e9394158$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $95ddfd63f1c7ad1b$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $eeH7J.useState(false);
    const handlerRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $6b6b8319e9394158$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($6b6b8319e9394158$var$LinkRoot, (0, $h4XE0.default)({
        color: color,
        className: (0, $er6YD.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $fd3c7c3c98da6b4f$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
$6b6b8319e9394158$var$Link.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the link.
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).any,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $542b1840e0c5cf64$export$2e2bcd8739ae039),
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */ TypographyClasses: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Controls when the link should have an underline.
   * @default 'always'
   */ underline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'always',
        'hover',
        'none'
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'body1',
            'body2',
            'button',
            'caption',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'inherit',
            'overline',
            'subtitle1',
            'subtitle2'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $6b6b8319e9394158$export$2e2bcd8739ae039 = $6b6b8319e9394158$var$Link;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $8hRD1 = parcelRequire("8hRD1");

var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $lNnGW = parcelRequire("lNnGW");

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $4yBem = parcelRequire("4yBem");
const $5da2d8f3003410bd$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
]);
var $5da2d8f3003410bd$export$2e2bcd8739ae039 = $5da2d8f3003410bd$var$refType;




var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");


var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $27c0fbde361ccc36$var$useEnhancedEffect = typeof window !== 'undefined' ? $eeH7J.useLayoutEffect : $eeH7J.useEffect;
var $27c0fbde361ccc36$export$2e2bcd8739ae039 = $27c0fbde361ccc36$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $208bf4215efa66ac$var$useEventCallback(fn) {
    const ref = $eeH7J.useRef(fn);
    (0, $27c0fbde361ccc36$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $eeH7J.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $208bf4215efa66ac$export$2e2bcd8739ae039 = $208bf4215efa66ac$var$useEventCallback;


'use client';
var $6acee5fdb4b8c69c$export$2e2bcd8739ae039 = (0, $208bf4215efa66ac$export$2e2bcd8739ae039);




var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");
function $82205b24576fe54e$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $15ecae95fe777e95$export$2e2bcd8739ae039(t, e) {
    return $15ecae95fe777e95$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $15ecae95fe777e95$export$2e2bcd8739ae039(t, e);
}


function $fa171fa37ae5504e$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $15ecae95fe777e95$export$2e2bcd8739ae039)(t, o);
}



var $4yBem = parcelRequire("4yBem");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
var $efd47b99065a7704$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);



var $eeH7J = parcelRequire("eeH7J");
function $2cf3d475f18f8802$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $eeH7J.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $eeH7J.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2cf3d475f18f8802$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2cf3d475f18f8802$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2cf3d475f18f8802$export$fa71e2345c31d7a2(props, onExited) {
    return $2cf3d475f18f8802$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $eeH7J.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2cf3d475f18f8802$var$getProp(child, 'appear', props),
            enter: $2cf3d475f18f8802$var$getProp(child, 'enter', props),
            exit: $2cf3d475f18f8802$var$getProp(child, 'exit', props)
        });
    });
}
function $2cf3d475f18f8802$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2cf3d475f18f8802$export$bbc8a025727ea824(nextProps.children);
    var children = $2cf3d475f18f8802$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $eeH7J.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $eeH7J.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $eeH7J.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2cf3d475f18f8802$var$getProp(child, 'exit', nextProps),
            enter: $2cf3d475f18f8802$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $eeH7J.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $eeH7J.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $eeH7J.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2cf3d475f18f8802$var$getProp(child, 'exit', nextProps),
            enter: $2cf3d475f18f8802$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $b4437f2626d670ce$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $b4437f2626d670ce$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $b4437f2626d670ce$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $fa171fa37ae5504e$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $82205b24576fe54e$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2cf3d475f18f8802$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2cf3d475f18f8802$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2cf3d475f18f8802$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $h4XE0.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $fbOaB.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $b4437f2626d670ce$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $efd47b99065a7704$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $efd47b99065a7704$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$b4437f2626d670ce$var$TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
};
$b4437f2626d670ce$var$TransitionGroup.defaultProps = $b4437f2626d670ce$var$defaultProps;
var $b4437f2626d670ce$export$2e2bcd8739ae039 = $b4437f2626d670ce$var$TransitionGroup;



var $er6YD = parcelRequire("er6YD");

var $1IdKE = parcelRequire("1IdKE");


var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $dRzna = parcelRequire("dRzna");
'use client';
function $7910b6d9ed12248a$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $eeH7J.useState(false);
    const rippleClassName = (0, $er6YD.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $er6YD.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $eeH7J.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $dRzna.jsx)("span", {
            className: childClassName
        })
    });
}
$7910b6d9ed12248a$var$Ripple.propTypes = {
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore - injected from TransitionGroup
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore - injected from TransitionGroup
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */ pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Diameter of the ripple.
   */ rippleSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Horizontal position of the ripple center.
   */ rippleX: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Vertical position of the ripple center.
   */ rippleY: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * exit delay
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number.isRequired
};
var $7910b6d9ed12248a$export$2e2bcd8739ae039 = $7910b6d9ed12248a$var$Ripple;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $ba27d18dcf86919d$export$b464606f735ab902(slot) {
    return (0, $aBqGi.default)('MuiTouchRipple', slot);
}
const $ba27d18dcf86919d$var$touchRippleClasses = (0, $cDqLM.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $ba27d18dcf86919d$export$2e2bcd8739ae039 = $ba27d18dcf86919d$var$touchRippleClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $fa04479f5ac542a4$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $fa04479f5ac542a4$var$_ = (t)=>t, $fa04479f5ac542a4$var$_t, $fa04479f5ac542a4$var$_t2, $fa04479f5ac542a4$var$_t3, $fa04479f5ac542a4$var$_t4;
const $fa04479f5ac542a4$var$DURATION = 550;
const $fa04479f5ac542a4$export$95d0c9356b2231a3 = 80;
const $fa04479f5ac542a4$var$enterKeyframe = (0, $1IdKE.keyframes)($fa04479f5ac542a4$var$_t || ($fa04479f5ac542a4$var$_t = $fa04479f5ac542a4$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $fa04479f5ac542a4$var$exitKeyframe = (0, $1IdKE.keyframes)($fa04479f5ac542a4$var$_t2 || ($fa04479f5ac542a4$var$_t2 = $fa04479f5ac542a4$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $fa04479f5ac542a4$var$pulsateKeyframe = (0, $1IdKE.keyframes)($fa04479f5ac542a4$var$_t3 || ($fa04479f5ac542a4$var$_t3 = $fa04479f5ac542a4$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $fa04479f5ac542a4$export$f6b7418508c72c25 = (0, $hikmr.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $fa04479f5ac542a4$export$676cfe7b12693c4b = (0, $hikmr.default)((0, $7910b6d9ed12248a$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($fa04479f5ac542a4$var$_t4 || ($fa04479f5ac542a4$var$_t4 = $fa04479f5ac542a4$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).rippleVisible, $fa04479f5ac542a4$var$enterKeyframe, $fa04479f5ac542a4$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).child, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).childLeaving, $fa04479f5ac542a4$var$exitKeyframe, $fa04479f5ac542a4$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).childPulsate, $fa04479f5ac542a4$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $fa04479f5ac542a4$var$TouchRipple = /*#__PURE__*/ $eeH7J.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $fbOaB.default)(props, $fa04479f5ac542a4$var$_excluded);
    const [ripples, setRipples] = $eeH7J.useState([]);
    const nextKey = $eeH7J.useRef(0);
    const rippleCallback = $eeH7J.useRef(null);
    $eeH7J.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $eeH7J.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $b639dfbe5b4dc511$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $eeH7J.useRef(null);
    const container = $eeH7J.useRef(null);
    const startCommit = $eeH7J.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $dRzna.jsx)($fa04479f5ac542a4$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $er6YD.default)(classes.ripple, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $er6YD.default)(classes.rippleVisible, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $er6YD.default)(classes.ripplePulsate, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $er6YD.default)(classes.child, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $er6YD.default)(classes.childLeaving, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $er6YD.default)(classes.childPulsate, (0, $ba27d18dcf86919d$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $fa04479f5ac542a4$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $eeH7J.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($fa04479f5ac542a4$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $eeH7J.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $eeH7J.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $eeH7J.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)($fa04479f5ac542a4$export$f6b7418508c72c25, (0, $h4XE0.default)({
        className: (0, $er6YD.default)((0, $ba27d18dcf86919d$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)((0, $b4437f2626d670ce$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
$fa04479f5ac542a4$var$TouchRipple.propTypes = {
    /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */ center: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
};
var $fa04479f5ac542a4$export$2e2bcd8739ae039 = $fa04479f5ac542a4$var$TouchRipple;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d0011c6615b1ea41$export$fccb0498dcd99783(slot) {
    return (0, $aBqGi.default)('MuiButtonBase', slot);
}
const $d0011c6615b1ea41$var$buttonBaseClasses = (0, $cDqLM.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d0011c6615b1ea41$export$2e2bcd8739ae039 = $d0011c6615b1ea41$var$buttonBaseClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $2a52f24a6713d052$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2a52f24a6713d052$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $d0011c6615b1ea41$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2a52f24a6713d052$export$7ec0dcc5e3cdcd36 = (0, $hikmr.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $d0011c6615b1ea41$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2a52f24a6713d052$var$ButtonBase = /*#__PURE__*/ $eeH7J.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $fbOaB.default)(props, $2a52f24a6713d052$var$_excluded);
    const buttonRef = $eeH7J.useRef(null);
    const rippleRef = $eeH7J.useRef(null);
    const handleRippleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $95ddfd63f1c7ad1b$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $eeH7J.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $eeH7J.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $eeH7J.useState(false);
    $eeH7J.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $eeH7J.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $6acee5fdb4b8c69c$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $6acee5fdb4b8c69c$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $eeH7J.useRef(false);
    const handleKeyDown = (0, $6acee5fdb4b8c69c$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $6acee5fdb4b8c69c$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useEffect(()=>{
        if (enableTouchRipple && !rippleRef.current) console.error([
            'MUI: The `component` prop provided to ButtonBase is invalid.',
            'Please make sure the children prop is rendered in this custom component.'
        ].join('\n'));
    }, [
        enableTouchRipple
    ]);
    const ownerState = (0, $h4XE0.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2a52f24a6713d052$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsxs)($2a52f24a6713d052$export$7ec0dcc5e3cdcd36, (0, $h4XE0.default)({
        as: ComponentProp,
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $dRzna.jsx)((0, $fa04479f5ac542a4$export$2e2bcd8739ae039), (0, $h4XE0.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
$2a52f24a6713d052$var$ButtonBase.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */ action: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */ centerRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $542b1840e0c5cf64$export$2e2bcd8739ae039),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */ disableTouchRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */ focusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).any,
    /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */ LinkComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onContextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */ onFocusVisible: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onTouchEnd: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onTouchMove: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onTouchStart: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * @default 0
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Props applied to the `TouchRipple` element.
   */ TouchRippleProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * A ref that points to the `TouchRipple` element.
   */ touchRippleRef: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
                pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.isRequired,
                start: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.isRequired,
                stop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.isRequired
            })
        })
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'button',
            'reset',
            'submit'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $2a52f24a6713d052$export$2e2bcd8739ae039 = $2a52f24a6713d052$var$ButtonBase;



var $4A7Fh = parcelRequire("4A7Fh");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $fe393c3624ecbbea$export$5a6f9035944c8119(slot) {
    return (0, $aBqGi.default)('MuiButton', slot);
}
const $fe393c3624ecbbea$var$buttonClasses = (0, $cDqLM.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $fe393c3624ecbbea$export$2e2bcd8739ae039 = $fe393c3624ecbbea$var$buttonClasses;



var $eeH7J = parcelRequire("eeH7J");
/**
 * @ignore - internal component.
 */ const $22c83a73e99df4e8$var$ButtonGroupContext = /*#__PURE__*/ $eeH7J.createContext({});
$22c83a73e99df4e8$var$ButtonGroupContext.displayName = 'ButtonGroupContext';
var $22c83a73e99df4e8$export$2e2bcd8739ae039 = $22c83a73e99df4e8$var$ButtonGroupContext;



var $eeH7J = parcelRequire("eeH7J");
/**
 * @ignore - internal component.
 */ const $c85a4dbbb6df3c6a$var$ButtonGroupButtonContext = /*#__PURE__*/ $eeH7J.createContext(undefined);
$c85a4dbbb6df3c6a$var$ButtonGroupButtonContext.displayName = 'ButtonGroupButtonContext';
var $c85a4dbbb6df3c6a$export$2e2bcd8739ae039 = $c85a4dbbb6df3c6a$var$ButtonGroupButtonContext;



var $dRzna = parcelRequire("dRzna");
'use client';
const $45e6ef255fe84fc0$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45e6ef255fe84fc0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $4A7Fh.default)(color)}`,
            `size${(0, $4A7Fh.default)(size)}`,
            `${variant}Size${(0, $4A7Fh.default)(size)}`,
            `color${(0, $4A7Fh.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $4A7Fh.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $4A7Fh.default)(size)}`
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $fe393c3624ecbbea$export$5a6f9035944c8119), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $45e6ef255fe84fc0$var$commonIconStyles = (ownerState)=>(0, $h4XE0.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $45e6ef255fe84fc0$var$ButtonRoot = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $4A7Fh.default)(ownerState.color)}`],
            styles[`size${(0, $4A7Fh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $4A7Fh.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $h4XE0.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $h4XE0.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $h4XE0.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $fe393c3624ecbbea$export$2e2bcd8739ae039).focusVisible}`]: (0, $h4XE0.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $fe393c3624ecbbea$export$2e2bcd8739ae039).disabled}`]: (0, $h4XE0.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $5YtKS.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $fe393c3624ecbbea$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $fe393c3624ecbbea$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $45e6ef255fe84fc0$var$ButtonStartIcon = (0, $hikmr.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $4A7Fh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $45e6ef255fe84fc0$var$commonIconStyles(ownerState)));
const $45e6ef255fe84fc0$var$ButtonEndIcon = (0, $hikmr.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $4A7Fh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $45e6ef255fe84fc0$var$commonIconStyles(ownerState)));
const $45e6ef255fe84fc0$var$Button = /*#__PURE__*/ $eeH7J.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $eeH7J.useContext((0, $22c83a73e99df4e8$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $eeH7J.useContext((0, $c85a4dbbb6df3c6a$export$2e2bcd8739ae039));
    const resolvedProps = (0, $8hRD1.default)(contextProps, inProps);
    const props = (0, $lNnGW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $fbOaB.default)(props, $45e6ef255fe84fc0$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45e6ef255fe84fc0$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $dRzna.jsx)($45e6ef255fe84fc0$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $dRzna.jsx)($45e6ef255fe84fc0$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $dRzna.jsxs)($45e6ef255fe84fc0$var$ButtonRoot, (0, $h4XE0.default)({
        ownerState: ownerState,
        className: (0, $er6YD.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $er6YD.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
$45e6ef255fe84fc0$var$Button.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'inherit',
            'primary',
            'secondary',
            'success',
            'error',
            'info',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, no elevation is used.
   * @default false
   */ disableElevation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Element placed after the children.
   */ endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * @ignore
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Element placed before the children.
   */ startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'button',
            'reset',
            'submit'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'contained',
            'outlined',
            'text'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $45e6ef255fe84fc0$export$2e2bcd8739ae039 = $45e6ef255fe84fc0$var$Button;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");


var $4A7Fh = parcelRequire("4A7Fh");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $dfd82f15a5142ce0$export$5e8702d71474f093(slot) {
    return (0, $aBqGi.default)('MuiIconButton', slot);
}
const $dfd82f15a5142ce0$var$iconButtonClasses = (0, $cDqLM.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $dfd82f15a5142ce0$export$2e2bcd8739ae039 = $dfd82f15a5142ce0$var$iconButtonClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $035814a890448735$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $035814a890448735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $4A7Fh.default)(color)}`,
            edge && `edge${(0, $4A7Fh.default)(edge)}`,
            `size${(0, $4A7Fh.default)(size)}`
        ]
    };
    return (0, $doIAf.default)(slots, (0, $dfd82f15a5142ce0$export$5e8702d71474f093), classes);
};
const $035814a890448735$var$IconButtonRoot = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $4A7Fh.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $4A7Fh.default)(ownerState.edge)}`],
            styles[`size${(0, $4A7Fh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $h4XE0.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $h4XE0.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $h4XE0.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $dfd82f15a5142ce0$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $035814a890448735$var$IconButton = /*#__PURE__*/ $eeH7J.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $fbOaB.default)(props, $035814a890448735$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $035814a890448735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($035814a890448735$var$IconButtonRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
$035814a890448735$var$IconButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The icon to display.
   */ children: (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node, (props)=>{
        const found = $eeH7J.Children.toArray(props.children).some((child)=>/*#__PURE__*/ $eeH7J.isValidElement(child) && child.props.onClick);
        if (found) return new Error([
            'MUI: You are providing an onClick event listener to a child of a button element.',
            'Prefer applying it to the IconButton directly.',
            'This guarantees that the whole <button> will be responsive to click events.'
        ].join('\n'));
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'inherit',
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $035814a890448735$export$2e2bcd8739ae039 = $035814a890448735$var$IconButton;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");
var $631d1dee154373e2$exports = {};
'use strict';

$631d1dee154373e2$exports = (parcelRequire("jxkIq"));



var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");
function $f9be6e8be864268f$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null) return null;
    if (propValue && propValue.nodeType !== 1) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
    return null;
}



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $dRzna = parcelRequire("dRzna");
const $24165880ce40ccbd$var$_excluded = [
    "value"
];
const $24165880ce40ccbd$var$RtlContext = /*#__PURE__*/ $eeH7J.createContext();
function $24165880ce40ccbd$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $fbOaB.default)(_ref, $24165880ce40ccbd$var$_excluded);
    return /*#__PURE__*/ (0, $dRzna.jsx)($24165880ce40ccbd$var$RtlContext.Provider, (0, $h4XE0.default)({
        value: value != null ? value : true
    }, props));
}
$24165880ce40ccbd$var$RtlProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
};
const $24165880ce40ccbd$export$b2dd014b6c321cb = ()=>{
    const value = $eeH7J.useContext($24165880ce40ccbd$var$RtlContext);
    return value != null ? value : false;
};
var $24165880ce40ccbd$export$2e2bcd8739ae039 = $24165880ce40ccbd$var$RtlProvider;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");


var $h4XE0 = parcelRequire("h4XE0");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $1f8e2ead014c8e16$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $1f8e2ead014c8e16$export$2e2bcd8739ae039 = $1f8e2ead014c8e16$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $e33ed803c0944f04$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $h4XE0.default)({}, otherProps, {
        ownerState: (0, $h4XE0.default)({}, otherProps.ownerState, ownerState)
    });
}
var $e33ed803c0944f04$export$2e2bcd8739ae039 = $e33ed803c0944f04$var$appendOwnerState;



var $h4XE0 = parcelRequire("h4XE0");
function $f62dafa2b5548f6b$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f62dafa2b5548f6b$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f62dafa2b5548f6b$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f62dafa2b5548f6b$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f62dafa2b5548f6b$export$2e2bcd8739ae039 = $f62dafa2b5548f6b$export$4f5d2d50c9deca37;


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $be77b66cbdfe23fb$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $be77b66cbdfe23fb$export$2e2bcd8739ae039 = $be77b66cbdfe23fb$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $05e9a150b831dbb6$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $05e9a150b831dbb6$export$2e2bcd8739ae039 = $05e9a150b831dbb6$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $91f63e57c6c48a92$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $f62dafa2b5548f6b$export$2e2bcd8739ae039)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $h4XE0.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $h4XE0.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $be77b66cbdfe23fb$export$2e2bcd8739ae039)((0, $h4XE0.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $05e9a150b831dbb6$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $05e9a150b831dbb6$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $f62dafa2b5548f6b$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $h4XE0.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $h4XE0.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $91f63e57c6c48a92$export$2e2bcd8739ae039 = $91f63e57c6c48a92$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $c8108605d04ea33f$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $c8108605d04ea33f$export$2e2bcd8739ae039 = $c8108605d04ea33f$var$resolveComponentProps;


'use client';
const $d752081878235039$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $d752081878235039$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $fbOaB.default)(parameters, $d752081878235039$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $c8108605d04ea33f$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $91f63e57c6c48a92$export$2e2bcd8739ae039)((0, $h4XE0.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $c909b21db041accd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $e33ed803c0944f04$export$2e2bcd8739ae039)(elementType, (0, $h4XE0.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $d752081878235039$export$2e2bcd8739ae039 = $d752081878235039$var$useSlotProps;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");
function $86ba5fa7ddb82a47$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $420c0ad55da0a5b0$export$2e2bcd8739ae039 = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039);



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $eeH7J = parcelRequire("eeH7J");
'use client';
/**
 * @ignore - internal component.
 */ const $77f199b4f9b0046c$var$ListContext = /*#__PURE__*/ $eeH7J.createContext({});
$77f199b4f9b0046c$var$ListContext.displayName = 'ListContext';
var $77f199b4f9b0046c$export$2e2bcd8739ae039 = $77f199b4f9b0046c$var$ListContext;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $c1e6b56818522546$export$c6bd6795ed6e3203(slot) {
    return (0, $aBqGi.default)('MuiList', slot);
}
const $c1e6b56818522546$var$listClasses = (0, $cDqLM.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $c1e6b56818522546$export$2e2bcd8739ae039 = $c1e6b56818522546$var$listClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $c9acd01e0e055938$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $c9acd01e0e055938$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $c1e6b56818522546$export$c6bd6795ed6e3203), classes);
};
const $c9acd01e0e055938$var$ListRoot = (0, $hikmr.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $c9acd01e0e055938$var$List = /*#__PURE__*/ $eeH7J.forwardRef(function List(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $fbOaB.default)(props, $c9acd01e0e055938$var$_excluded);
    const context = $eeH7J.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $c9acd01e0e055938$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $77f199b4f9b0046c$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $dRzna.jsxs)($c9acd01e0e055938$var$ListRoot, (0, $h4XE0.default)({
            as: component,
            className: (0, $er6YD.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
$c9acd01e0e055938$var$List.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */ disablePadding: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The content of the subheader, normally `ListSubheader`.
   */ subheader: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $c9acd01e0e055938$export$2e2bcd8739ae039 = $c9acd01e0e055938$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $d17a47808c22420b$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $b56e2fa8ec287704$export$2e2bcd8739ae039 = (0, $d17a47808c22420b$export$2e2bcd8739ae039);




'use client';
var $caa7ff66ed2b6d13$export$2e2bcd8739ae039 = (0, $27c0fbde361ccc36$export$2e2bcd8739ae039);



var $dRzna = parcelRequire("dRzna");
'use client';
const $9a10de0c200f1fa1$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9a10de0c200f1fa1$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9a10de0c200f1fa1$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9a10de0c200f1fa1$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $9a10de0c200f1fa1$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$9a10de0c200f1fa1$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9a10de0c200f1fa1$var$MenuList = /*#__PURE__*/ $eeH7J.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $fbOaB.default)(props, $9a10de0c200f1fa1$var$_excluded);
    const listRef = $eeH7J.useRef(null);
    const textCriteriaRef = $eeH7J.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $caa7ff66ed2b6d13$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $eeH7J.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $b56e2fa8ec287704$export$2e2bcd8739ae039)((0, $420c0ad55da0a5b0$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $420c0ad55da0a5b0$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $9a10de0c200f1fa1$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9a10de0c200f1fa1$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $9a10de0c200f1fa1$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9a10de0c200f1fa1$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $9a10de0c200f1fa1$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9a10de0c200f1fa1$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $9a10de0c200f1fa1$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9a10de0c200f1fa1$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9a10de0c200f1fa1$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9a10de0c200f1fa1$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9a10de0c200f1fa1$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $eeH7J.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if ((0, $631d1dee154373e2$exports.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $eeH7J.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $eeH7J.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $c9acd01e0e055938$export$2e2bcd8739ae039), (0, $h4XE0.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
$9a10de0c200f1fa1$var$MenuList.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */ autoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * MenuList contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */ disabledItemsFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */ disableListWrap: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $9a10de0c200f1fa1$export$2e2bcd8739ae039 = $9a10de0c200f1fa1$var$MenuList;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");



function $ec9311ff626ebe07$export$9fd44dd81470cadd(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
// IE 11 support
function $ec9311ff626ebe07$var$ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}
const $ec9311ff626ebe07$var$isInteger = Number.isInteger || $ec9311ff626ebe07$var$ponyfillIsInteger;
function $ec9311ff626ebe07$var$requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !$ec9311ff626ebe07$var$isInteger(propValue)) {
        const propType = $ec9311ff626ebe07$export$9fd44dd81470cadd(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function $ec9311ff626ebe07$var$validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return $ec9311ff626ebe07$var$requiredInteger(props, propName, ...other);
}
function $ec9311ff626ebe07$var$validatorNoop() {
    return null;
}
$ec9311ff626ebe07$var$validator.isRequired = $ec9311ff626ebe07$var$requiredInteger;
$ec9311ff626ebe07$var$validatorNoop.isRequired = $ec9311ff626ebe07$var$validatorNoop;
var $ec9311ff626ebe07$export$2e2bcd8739ae039 = $ec9311ff626ebe07$var$validator;






var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $09427fb55d2cb2eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $c370e859c3c397cd$export$2e2bcd8739ae039 = (0, $09427fb55d2cb2eb$export$2e2bcd8739ae039);




function $2433ad996f7c2542$export$2e2bcd8739ae039(node) {
    const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $e722e67392aff1bf$export$2e2bcd8739ae039 = (0, $2433ad996f7c2542$export$2e2bcd8739ae039);




var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");


var $4yBem = parcelRequire("4yBem");

function $62f35c6df8c2edfd$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $62f35c6df8c2edfd$var$acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !$62f35c6df8c2edfd$var$isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
const $62f35c6df8c2edfd$var$elementAcceptingRef = (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element, $62f35c6df8c2edfd$var$acceptingRef);
$62f35c6df8c2edfd$var$elementAcceptingRef.isRequired = (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element.isRequired, $62f35c6df8c2edfd$var$acceptingRef);
var $62f35c6df8c2edfd$export$2e2bcd8739ae039 = $62f35c6df8c2edfd$var$elementAcceptingRef;



var $eeH7J = parcelRequire("eeH7J");
function $4b19d09ce79e7470$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($eeH7J.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $fbOaB = parcelRequire("fbOaB");


var $4yBem = parcelRequire("4yBem");

var $eeH7J = parcelRequire("eeH7J");

var $9e9e7bae783ed0bd$export$2e2bcd8739ae039 = {
    disabled: false
};



var $4yBem = parcelRequire("4yBem");
var $2877b7d3d33ff6b9$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    }).isRequired
]);
var $2877b7d3d33ff6b9$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    })
]);



var $c1099c01480d60c0$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $9a7789c95be58aaf$export$bb38bb9a1161268 = 'unmounted';
var $9a7789c95be58aaf$export$84cbff306f539230 = 'exited';
var $9a7789c95be58aaf$export$df38205c966be359 = 'entering';
var $9a7789c95be58aaf$export$78e9e6e3e014d60a = 'entered';
var $9a7789c95be58aaf$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9a7789c95be58aaf$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $fa171fa37ae5504e$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9a7789c95be58aaf$export$84cbff306f539230;
                _this.appearStatus = $9a7789c95be58aaf$export$df38205c966be359;
            } else initialStatus = $9a7789c95be58aaf$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9a7789c95be58aaf$export$bb38bb9a1161268;
        else initialStatus = $9a7789c95be58aaf$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9a7789c95be58aaf$export$bb38bb9a1161268) return {
            status: $9a7789c95be58aaf$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9a7789c95be58aaf$export$df38205c966be359 && status !== $9a7789c95be58aaf$export$78e9e6e3e014d60a) nextStatus = $9a7789c95be58aaf$export$df38205c966be359;
            } else if (status === $9a7789c95be58aaf$export$df38205c966be359 || status === $9a7789c95be58aaf$export$78e9e6e3e014d60a) nextStatus = $9a7789c95be58aaf$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9a7789c95be58aaf$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($dad018249d59322c$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $c1099c01480d60c0$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9a7789c95be58aaf$export$84cbff306f539230) this.setState({
            status: $9a7789c95be58aaf$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($dad018249d59322c$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9e9e7bae783ed0bd$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9a7789c95be58aaf$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9a7789c95be58aaf$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9a7789c95be58aaf$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($dad018249d59322c$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9e9e7bae783ed0bd$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9a7789c95be58aaf$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9a7789c95be58aaf$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9a7789c95be58aaf$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($dad018249d59322c$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9a7789c95be58aaf$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $fbOaB.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $efd47b99065a7704$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$9a7789c95be58aaf$var$Transition.contextType = (0, $efd47b99065a7704$export$2e2bcd8739ae039);
$9a7789c95be58aaf$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $2877b7d3d33ff6b9$export$3458ee1082941f5e);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
}; // Name the function so it is clearer in the documentation
function $9a7789c95be58aaf$var$noop() {}
$9a7789c95be58aaf$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9a7789c95be58aaf$var$noop,
    onEntering: $9a7789c95be58aaf$var$noop,
    onEntered: $9a7789c95be58aaf$var$noop,
    onExit: $9a7789c95be58aaf$var$noop,
    onExiting: $9a7789c95be58aaf$var$noop,
    onExited: $9a7789c95be58aaf$var$noop
};
$9a7789c95be58aaf$var$Transition.UNMOUNTED = $9a7789c95be58aaf$export$bb38bb9a1161268;
$9a7789c95be58aaf$var$Transition.EXITED = $9a7789c95be58aaf$export$84cbff306f539230;
$9a7789c95be58aaf$var$Transition.ENTERING = $9a7789c95be58aaf$export$df38205c966be359;
$9a7789c95be58aaf$var$Transition.ENTERED = $9a7789c95be58aaf$export$78e9e6e3e014d60a;
$9a7789c95be58aaf$var$Transition.EXITING = $9a7789c95be58aaf$export$4aacc83d4d59139f;
var $9a7789c95be58aaf$export$2e2bcd8739ae039 = $9a7789c95be58aaf$var$Transition;



var $eeH7J = parcelRequire("eeH7J");

var $kO80n = parcelRequire("kO80n");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("1IdKE");
var $kHakb = parcelRequire("kHakb");
'use client';
function $867cd157dee718e1$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $867cd157dee718e1$var$useTheme(defaultTheme = null) {
    const contextTheme = $eeH7J.useContext((0, $kHakb.T));
    return !contextTheme || $867cd157dee718e1$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $867cd157dee718e1$export$2e2bcd8739ae039 = $867cd157dee718e1$var$useTheme;


'use client';
const $f08d602dd3ba2736$export$35e57303dbd8a66 = (0, $kO80n.default)();
function $f08d602dd3ba2736$var$useTheme(defaultTheme = $f08d602dd3ba2736$export$35e57303dbd8a66) {
    return (0, $867cd157dee718e1$export$2e2bcd8739ae039)(defaultTheme);
}
var $f08d602dd3ba2736$export$2e2bcd8739ae039 = $f08d602dd3ba2736$var$useTheme;



var $xHBjO = parcelRequire("xHBjO");

var $4hHwC = parcelRequire("4hHwC");
'use client';
function $c7b8a7ef63736600$export$2e2bcd8739ae039() {
    const theme = (0, $f08d602dd3ba2736$export$2e2bcd8739ae039)((0, $xHBjO.default));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useDebugValue(theme);
    return theme[0, $4hHwC.default] || theme;
}


const $e895d67c3ebfecb1$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $e895d67c3ebfecb1$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $dRzna = parcelRequire("dRzna");
'use client';
const $4c8c31ccdcef51f4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4c8c31ccdcef51f4$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $4c8c31ccdcef51f4$var$styles = {
    entering: {
        opacity: 1,
        transform: $4c8c31ccdcef51f4$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $4c8c31ccdcef51f4$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4c8c31ccdcef51f4$var$Grow = /*#__PURE__*/ $eeH7J.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $9a7789c95be58aaf$export$2e2bcd8739ae039) } = props, other = (0, $fbOaB.default)(props, $4c8c31ccdcef51f4$var$_excluded);
    const timer = (0, $b639dfbe5b4dc511$export$2e2bcd8739ae039)();
    const autoTimeout = $eeH7J.useRef();
    const theme = (0, $c7b8a7ef63736600$export$2e2bcd8739ae039)();
    const nodeRef = $eeH7J.useRef(null);
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(nodeRef, (0, $4b19d09ce79e7470$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $e895d67c3ebfecb1$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $e895d67c3ebfecb1$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $4c8c31ccdcef51f4$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $e895d67c3ebfecb1$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $4c8c31ccdcef51f4$var$isWebKit154 ? duration : duration * 0.666,
                delay: $4c8c31ccdcef51f4$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $4c8c31ccdcef51f4$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $dRzna.jsx)(TransitionComponent, (0, $h4XE0.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eeH7J.cloneElement(children, (0, $h4XE0.default)({
                style: (0, $h4XE0.default)({
                    opacity: 0,
                    transform: $4c8c31ccdcef51f4$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $4c8c31ccdcef51f4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$4c8c31ccdcef51f4$var$Grow.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A single child content element.
   */ children: (0, $62f35c6df8c2edfd$export$2e2bcd8739ae039).isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        })
    ])
};
$4c8c31ccdcef51f4$var$Grow.muiSupportAuto = true;
var $4c8c31ccdcef51f4$export$2e2bcd8739ae039 = $4c8c31ccdcef51f4$var$Grow;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");



var $doIAf = parcelRequire("doIAf");


var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $h4XE0 = parcelRequire("h4XE0");
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $b11fa6e7a8da4552$var$specialProperty = 'exact-prop: \u200b';
function $b11fa6e7a8da4552$export$2e2bcd8739ae039(propTypes) {
    return (0, $h4XE0.default)({}, propTypes, {
        [$b11fa6e7a8da4552$var$specialProperty]: (props)=>{
            const unsupportedProps = Object.keys(props).filter((prop)=>!propTypes.hasOwnProperty(prop));
            if (unsupportedProps.length > 0) return new Error(`The following props are not supported: ${unsupportedProps.map((prop)=>`\`${prop}\``).join(', ')}. Please remove them.`);
            return null;
        }
    });
}



var $dRzna = parcelRequire("dRzna");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $54b4bd374d437ee7$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $54b4bd374d437ee7$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $54b4bd374d437ee7$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $54b4bd374d437ee7$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $54b4bd374d437ee7$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $54b4bd374d437ee7$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($54b4bd374d437ee7$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $54b4bd374d437ee7$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$54b4bd374d437ee7$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $54b4bd374d437ee7$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $54b4bd374d437ee7$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $54b4bd374d437ee7$var$defaultGetTabbable, isEnabled: isEnabled = $54b4bd374d437ee7$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $eeH7J.useRef(false);
    const sentinelStart = $eeH7J.useRef(null);
    const sentinelEnd = $eeH7J.useRef(null);
    const nodeToRestore = $eeH7J.useRef(null);
    const reactFocusEventTarget = $eeH7J.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $eeH7J.useRef(false);
    const rootRef = $eeH7J.useRef(null);
    const handleRef = (0, $c909b21db041accd$export$2e2bcd8739ae039)((0, $4b19d09ce79e7470$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $eeH7J.useRef(null);
    $eeH7J.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $eeH7J.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) {
                console.error([
                    'MUI: The modal content node does not accept focus.',
                    'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'
                ].join('\n'));
                rootRef.current.setAttribute('tabIndex', '-1');
            }
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $eeH7J.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $eeH7J.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $dRzna.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
$54b4bd374d437ee7$var$FocusTrap.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A single child content element.
   */ children: (0, $62f35c6df8c2edfd$export$2e2bcd8739ae039),
    /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */ getTabbable: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */ isEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, focus is locked.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool.isRequired
};
// eslint-disable-next-line
$54b4bd374d437ee7$var$FocusTrap["propTypes"] = (0, $b11fa6e7a8da4552$export$2e2bcd8739ae039)($54b4bd374d437ee7$var$FocusTrap.propTypes);
var $54b4bd374d437ee7$export$2e2bcd8739ae039 = $54b4bd374d437ee7$var$FocusTrap;



var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");


var $dRzna = parcelRequire("dRzna");
'use client';
function $d36a11618746ea9a$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $d36a11618746ea9a$var$Portal = /*#__PURE__*/ $eeH7J.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $eeH7J.useState(null);
    const handleRef = (0, $c909b21db041accd$export$2e2bcd8739ae039)(/*#__PURE__*/ $eeH7J.isValidElement(children) ? (0, $4b19d09ce79e7470$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $27c0fbde361ccc36$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($d36a11618746ea9a$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $27c0fbde361ccc36$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $2836634c7617003b$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $2836634c7617003b$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $eeH7J.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $eeH7J.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $dRzna.jsx)($eeH7J.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $dRzna.jsx)($eeH7J.Fragment, {
        children: mountNode ? /*#__PURE__*/ $dad018249d59322c$exports.createPortal(children, mountNode) : mountNode
    });
});
$d36a11618746ea9a$var$Portal.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The children to render into the `container`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $f9be6e8be864268f$export$2e2bcd8739ae039),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
};
// eslint-disable-next-line
$d36a11618746ea9a$var$Portal["propTypes"] = (0, $b11fa6e7a8da4552$export$2e2bcd8739ae039)($d36a11618746ea9a$var$Portal.propTypes);
var $d36a11618746ea9a$export$2e2bcd8739ae039 = $d36a11618746ea9a$var$Portal;



var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");







var $dRzna = parcelRequire("dRzna");
'use client';
const $cc46c16f051631ac$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $cc46c16f051631ac$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $cc46c16f051631ac$var$Fade = /*#__PURE__*/ $eeH7J.forwardRef(function Fade(props, ref) {
    const theme = (0, $c7b8a7ef63736600$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $9a7789c95be58aaf$export$2e2bcd8739ae039) } = props, other = (0, $fbOaB.default)(props, $cc46c16f051631ac$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $eeH7J.useRef(null);
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(nodeRef, (0, $4b19d09ce79e7470$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $e895d67c3ebfecb1$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $e895d67c3ebfecb1$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $e895d67c3ebfecb1$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $dRzna.jsx)(TransitionComponent, (0, $h4XE0.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eeH7J.cloneElement(children, (0, $h4XE0.default)({
                style: (0, $h4XE0.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $cc46c16f051631ac$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$cc46c16f051631ac$var$Fade.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A single child content element.
   */ children: (0, $62f35c6df8c2edfd$export$2e2bcd8739ae039).isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        })
    ])
};
var $cc46c16f051631ac$export$2e2bcd8739ae039 = $cc46c16f051631ac$var$Fade;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $ecc3ffcdc0ced54b$export$9927a91fd93152bd(slot) {
    return (0, $aBqGi.default)('MuiBackdrop', slot);
}
const $ecc3ffcdc0ced54b$var$backdropClasses = (0, $cDqLM.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $ecc3ffcdc0ced54b$export$2e2bcd8739ae039 = $ecc3ffcdc0ced54b$var$backdropClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $b55830ff5efafe0e$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $b55830ff5efafe0e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $ecc3ffcdc0ced54b$export$9927a91fd93152bd), classes);
};
const $b55830ff5efafe0e$var$BackdropRoot = (0, $hikmr.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $b55830ff5efafe0e$var$Backdrop = /*#__PURE__*/ $eeH7J.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $cc46c16f051631ac$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $fbOaB.default)(props, $b55830ff5efafe0e$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $b55830ff5efafe0e$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $dRzna.jsx)(TransitionComponent, (0, $h4XE0.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)($b55830ff5efafe0e$var$BackdropRoot, (0, $h4XE0.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $er6YD.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $h4XE0.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
$b55830ff5efafe0e$var$Backdrop.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */ invisible: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool.isRequired,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        })
    ])
};
var $b55830ff5efafe0e$export$2e2bcd8739ae039 = $b55830ff5efafe0e$var$Backdrop;



var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $3cba5361c5650826$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $5f988174882aa190$var$isOverflowing(container) {
    const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $2433ad996f7c2542$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $5f988174882aa190$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $5f988174882aa190$var$getPaddingRight(element) {
    return parseInt((0, $2433ad996f7c2542$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $5f988174882aa190$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $5f988174882aa190$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$5f988174882aa190$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $5f988174882aa190$export$e1bd0c6150f13d96(element, show);
    });
}
function $5f988174882aa190$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $5f988174882aa190$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($5f988174882aa190$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $d17a47808c22420b$export$2e2bcd8739ae039)((0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$5f988174882aa190$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$5f988174882aa190$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $2433ad996f7c2542$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $5f988174882aa190$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $5f988174882aa190$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $5f988174882aa190$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $5f988174882aa190$var$getHiddenSiblings(container);
        $5f988174882aa190$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $5f988174882aa190$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $5f988174882aa190$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $5f988174882aa190$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $5f988174882aa190$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $5f988174882aa190$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $5f988174882aa190$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $5f988174882aa190$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $0615cbdeb32dae0b$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $0615cbdeb32dae0b$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $0615cbdeb32dae0b$var$defaultManager = new (0, $5f988174882aa190$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $0615cbdeb32dae0b$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $0615cbdeb32dae0b$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $eeH7J.useRef({});
    const mountNodeRef = $eeH7J.useRef(null);
    const modalRef = $eeH7J.useRef(null);
    const handleRef = (0, $c909b21db041accd$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $eeH7J.useState(!open);
    const hasTransition = $0615cbdeb32dae0b$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $208bf4215efa66ac$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $0615cbdeb32dae0b$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $eeH7J.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $208bf4215efa66ac$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $5f988174882aa190$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $eeH7J.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $eeH7J.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $eeH7J.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $be77b66cbdfe23fb$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $h4XE0.default)({}, propsEventHandlers, otherHandlers);
        return (0, $h4XE0.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $h4XE0.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $3cba5361c5650826$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $3cba5361c5650826$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $0615cbdeb32dae0b$export$2e2bcd8739ae039 = $0615cbdeb32dae0b$var$useModal;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $41ba7664dd59a528$export$67960e22b12a638d(slot) {
    return (0, $aBqGi.default)('MuiModal', slot);
}
const $41ba7664dd59a528$var$modalClasses = (0, $cDqLM.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $41ba7664dd59a528$export$2e2bcd8739ae039 = $41ba7664dd59a528$var$modalClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $12701cbbecd35d9f$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $12701cbbecd35d9f$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $41ba7664dd59a528$export$67960e22b12a638d), classes);
};
const $12701cbbecd35d9f$var$ModalRoot = (0, $hikmr.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $12701cbbecd35d9f$var$ModalBackdrop = (0, $hikmr.default)((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $12701cbbecd35d9f$var$Modal = /*#__PURE__*/ $eeH7J.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $lNnGW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $12701cbbecd35d9f$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $fbOaB.default)(props, $12701cbbecd35d9f$var$_excluded);
    const propsWithDefaults = (0, $h4XE0.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $0615cbdeb32dae0b$export$2e2bcd8739ae039)((0, $h4XE0.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $h4XE0.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $12701cbbecd35d9f$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $12701cbbecd35d9f$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $er6YD.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $h4XE0.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $er6YD.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $d36a11618746ea9a$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $dRzna.jsxs)(RootSlot, (0, $h4XE0.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $dRzna.jsx)(BackdropSlot, (0, $h4XE0.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $dRzna.jsx)((0, $54b4bd374d437ee7$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $eeH7J.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
$12701cbbecd35d9f$var$Modal.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * A single child content element.
   */ children: (0, $62f35c6df8c2edfd$export$2e2bcd8739ae039).isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */ closeAfterTransition: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        Backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    }),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $f9be6e8be864268f$export$2e2bcd8739ae039),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ]),
    /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */ hideBackdrop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * A function called when a transition enters.
   */ onTransitionEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * A function called when a transition has exited.
   */ onTransitionExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool.isRequired,
    /**
   * The props used for each slot inside the Modal.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    }),
    /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $12701cbbecd35d9f$export$2e2bcd8739ae039 = $12701cbbecd35d9f$var$Modal;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");



var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $hikmr = parcelRequire("hikmr");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $cdec26871b5601b6$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $cdec26871b5601b6$export$2e2bcd8739ae039 = $cdec26871b5601b6$var$getOverlayAlpha;



var $lNnGW = parcelRequire("lNnGW");


var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $b364c2acc9b8d7e9$export$29cdb466b9b6f20b(slot) {
    return (0, $aBqGi.default)('MuiPaper', slot);
}
const $b364c2acc9b8d7e9$var$paperClasses = (0, $cDqLM.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $b364c2acc9b8d7e9$export$2e2bcd8739ae039 = $b364c2acc9b8d7e9$var$paperClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $d3bbaaf68436ce97$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $d3bbaaf68436ce97$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $doIAf.default)(slots, (0, $b364c2acc9b8d7e9$export$29cdb466b9b6f20b), classes);
};
const $d3bbaaf68436ce97$var$PaperRoot = (0, $hikmr.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $h4XE0.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $h4XE0.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $5YtKS.alpha)('#fff', (0, $cdec26871b5601b6$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $5YtKS.alpha)('#fff', (0, $cdec26871b5601b6$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $d3bbaaf68436ce97$var$Paper = /*#__PURE__*/ $eeH7J.forwardRef(function Paper(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $fbOaB.default)(props, $d3bbaaf68436ce97$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $d3bbaaf68436ce97$var$useUtilityClasses(ownerState);
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const theme = (0, $c7b8a7ef63736600$export$2e2bcd8739ae039)();
        if (theme.shadows[elevation] === undefined) console.error([
            `MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`,
            `Please make sure that \`theme.shadows[${elevation}]\` is defined.`
        ].join('\n'));
    }
    return /*#__PURE__*/ (0, $dRzna.jsx)($d3bbaaf68436ce97$var$PaperRoot, (0, $h4XE0.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref
    }, other));
});
$d3bbaaf68436ce97$var$Paper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */ elevation: (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, $ec9311ff626ebe07$export$2e2bcd8739ae039), (props)=>{
        const { elevation: elevation, variant: variant } = props;
        if (elevation > 0 && variant === 'outlined') return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
        return null;
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The variant to use.
   * @default 'elevation'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'elevation',
            'outlined'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $d3bbaaf68436ce97$export$2e2bcd8739ae039 = $d3bbaaf68436ce97$var$Paper;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $8082b06cb7838445$export$88f455dd56c95edb(slot) {
    return (0, $aBqGi.default)('MuiPopover', slot);
}
const $8082b06cb7838445$var$popoverClasses = (0, $cDqLM.default)('MuiPopover', [
    'root',
    'paper'
]);
var $8082b06cb7838445$export$2e2bcd8739ae039 = $8082b06cb7838445$var$popoverClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $af5802b6a593ca9f$var$_excluded = [
    "onEntering"
], $af5802b6a593ca9f$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $af5802b6a593ca9f$var$_excluded3 = [
    "slotProps"
];
function $af5802b6a593ca9f$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $af5802b6a593ca9f$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $af5802b6a593ca9f$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $af5802b6a593ca9f$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $af5802b6a593ca9f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $8082b06cb7838445$export$88f455dd56c95edb), classes);
};
const $af5802b6a593ca9f$export$bcce13685275fc99 = (0, $hikmr.default)((0, $12701cbbecd35d9f$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $af5802b6a593ca9f$export$821346c38a2d9390 = (0, $hikmr.default)((0, $d3bbaaf68436ce97$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $af5802b6a593ca9f$var$Popover = /*#__PURE__*/ $eeH7J.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $4c8c31ccdcef51f4$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $fbOaB.default)(props.TransitionProps, $af5802b6a593ca9f$var$_excluded), other = (0, $fbOaB.default)(props, $af5802b6a593ca9f$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $eeH7J.useRef();
    const handlePaperRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $h4XE0.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $af5802b6a593ca9f$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $eeH7J.useCallback(()=>{
        if (anchorReference === 'anchorPosition') {
            if (!anchorPosition) console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.');
            return anchorPosition;
        }
        const resolvedAnchorEl = $af5802b6a593ca9f$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $420c0ad55da0a5b0$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        {
            const box = anchorElement.getBoundingClientRect();
            if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                'The anchor element should be part of the document layout.',
                "Make sure the element is present in the document or that it's not display none."
            ].join('\n'));
        }
        return {
            top: anchorRect.top + $af5802b6a593ca9f$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $af5802b6a593ca9f$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $eeH7J.useCallback((elemRect)=>{
        return {
            vertical: $af5802b6a593ca9f$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $af5802b6a593ca9f$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $eeH7J.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $af5802b6a593ca9f$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $e722e67392aff1bf$export$2e2bcd8739ae039)($af5802b6a593ca9f$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) console.error([
            'MUI: The popover component is too tall.',
            `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`,
            'Please consider adding a `max-height` to improve the user-experience.'
        ].join('\n'));
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $af5802b6a593ca9f$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $eeH7J.useState(open);
    const setPositioningStyles = $eeH7J.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $eeH7J.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $eeH7J.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $eeH7J.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $eeH7J.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $c370e859c3c397cd$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $e722e67392aff1bf$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $420c0ad55da0a5b0$export$2e2bcd8739ae039)($af5802b6a593ca9f$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $af5802b6a593ca9f$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $af5802b6a593ca9f$export$821346c38a2d9390;
    const paperProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $h4XE0.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $h4XE0.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $er6YD.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $er6YD.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $fbOaB.default)(_useSlotProps, $af5802b6a593ca9f$var$_excluded3);
    return /*#__PURE__*/ (0, $dRzna.jsx)(RootSlot, (0, $h4XE0.default)({}, rootProps, !(0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)(TransitionComponent, (0, $h4XE0.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $dRzna.jsx)(PaperSlot, (0, $h4XE0.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
$af5802b6a593ca9f$var$Popover.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */ action: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */ anchorEl: (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, $f9be6e8be864268f$export$2e2bcd8739ae039),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ]), (props)=>{
        if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
            const resolvedAnchorEl = $af5802b6a593ca9f$var$resolveAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
                const box = resolvedAnchorEl.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'MUI: The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else return new Error([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`
            ].join('\n'));
        }
        return null;
    }),
    /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                'center',
                'left',
                'right'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                'bottom',
                'center',
                'top'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        ]).isRequired
    }),
    /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */ anchorPosition: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        left: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number.isRequired,
        top: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number.isRequired
    }),
    /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */ anchorReference: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'anchorEl',
        'anchorPosition',
        'none'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $f9be6e8be864268f$export$2e2bcd8739ae039),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ]),
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The elevation of the popover.
   * @default 8
   */ elevation: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */ marginThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool.isRequired,
    /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).shape({
        component: (0, $542b1840e0c5cf64$export$2e2bcd8739ae039)
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                'center',
                'left',
                'right'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                'bottom',
                'center',
                'top'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        ]).isRequired
    }),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
var $af5802b6a593ca9f$export$2e2bcd8739ae039 = $af5802b6a593ca9f$var$Popover;



var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $82a3a67300fa8529$export$2cf86a63a84fe23d(slot) {
    return (0, $aBqGi.default)('MuiMenu', slot);
}
const $82a3a67300fa8529$var$menuClasses = (0, $cDqLM.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $82a3a67300fa8529$export$2e2bcd8739ae039 = $82a3a67300fa8529$var$menuClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $e81d86cc7ed08456$var$_excluded = [
    "onEntering"
], $e81d86cc7ed08456$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $e81d86cc7ed08456$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $e81d86cc7ed08456$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $e81d86cc7ed08456$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $82a3a67300fa8529$export$2cf86a63a84fe23d), classes);
};
const $e81d86cc7ed08456$var$MenuRoot = (0, $hikmr.default)((0, $af5802b6a593ca9f$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $e81d86cc7ed08456$export$4f7c51a5920c9f33 = (0, $hikmr.default)((0, $af5802b6a593ca9f$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $e81d86cc7ed08456$var$MenuMenuList = (0, $hikmr.default)((0, $9a10de0c200f1fa1$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $e81d86cc7ed08456$var$Menu = /*#__PURE__*/ $eeH7J.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $fbOaB.default)(props.TransitionProps, $e81d86cc7ed08456$var$_excluded), other = (0, $fbOaB.default)(props, $e81d86cc7ed08456$var$_excluded2);
    const isRtl = (0, $24165880ce40ccbd$export$b2dd014b6c321cb)();
    const ownerState = (0, $h4XE0.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $e81d86cc7ed08456$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $eeH7J.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $eeH7J.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(child)) return;
        if ((0, $631d1dee154373e2$exports.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $e81d86cc7ed08456$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $dRzna.jsx)($e81d86cc7ed08456$var$MenuRoot, (0, $h4XE0.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $e81d86cc7ed08456$var$RTL_ORIGIN : $e81d86cc7ed08456$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $h4XE0.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($e81d86cc7ed08456$var$MenuMenuList, (0, $h4XE0.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $er6YD.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
$e81d86cc7ed08456$var$Menu.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */ anchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $f9be6e8be864268f$export$2e2bcd8739ae039),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ]),
    /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Menu contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */ disableAutoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */ MenuListProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool.isRequired,
    /**
   * @ignore
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */ PopoverClasses: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $e81d86cc7ed08456$export$2e2bcd8739ae039 = $e81d86cc7ed08456$var$Menu;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $lNnGW = parcelRequire("lNnGW");






var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $0a822e517a36bc5e$export$81478e24460c57f2(slot) {
    return (0, $aBqGi.default)('MuiListItemIcon', slot);
}
const $0a822e517a36bc5e$var$listItemIconClasses = (0, $cDqLM.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $0a822e517a36bc5e$export$2e2bcd8739ae039 = $0a822e517a36bc5e$var$listItemIconClasses;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $6652200be24fc00f$export$1061006a0db3aeb5(slot) {
    return (0, $aBqGi.default)('MuiListItemText', slot);
}
const $6652200be24fc00f$var$listItemTextClasses = (0, $cDqLM.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $6652200be24fc00f$export$2e2bcd8739ae039 = $6652200be24fc00f$var$listItemTextClasses;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $005e886899b8f435$export$515f8c67b5305377(slot) {
    return (0, $aBqGi.default)('MuiMenuItem', slot);
}
const $005e886899b8f435$var$menuItemClasses = (0, $cDqLM.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $005e886899b8f435$export$2e2bcd8739ae039 = $005e886899b8f435$var$menuItemClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $3cdaf87b331b5faf$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $3cdaf87b331b5faf$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3cdaf87b331b5faf$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $005e886899b8f435$export$515f8c67b5305377), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $3cdaf87b331b5faf$var$MenuItemRoot = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $3cdaf87b331b5faf$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $005e886899b8f435$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $5YtKS.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $005e886899b8f435$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $5YtKS.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $005e886899b8f435$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $5YtKS.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $5YtKS.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $005e886899b8f435$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $005e886899b8f435$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $a3026f80917bb629$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $a3026f80917bb629$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $6652200be24fc00f$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $6652200be24fc00f$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $0a822e517a36bc5e$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $h4XE0.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $0a822e517a36bc5e$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $3cdaf87b331b5faf$var$MenuItem = /*#__PURE__*/ $eeH7J.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $fbOaB.default)(props, $3cdaf87b331b5faf$var$_excluded);
    const context = $eeH7J.useContext((0, $77f199b4f9b0046c$export$2e2bcd8739ae039));
    const childContext = $eeH7J.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $eeH7J.useRef(null);
    (0, $caa7ff66ed2b6d13$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
            else console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $h4XE0.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $3cdaf87b331b5faf$var$useUtilityClasses(props);
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $77f199b4f9b0046c$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($3cdaf87b331b5faf$var$MenuItemRoot, (0, $h4XE0.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $er6YD.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $er6YD.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
$3cdaf87b331b5faf$var$MenuItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * If `true`, the component is selected.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * @default 0
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
};
var $3cdaf87b331b5faf$export$2e2bcd8739ae039 = $3cdaf87b331b5faf$var$MenuItem;


// Generated file. Do not edit
var $08396fcc01c9bf85$export$efd5569f873811b1;
(function(StatusCodes) {
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.1
     *
     * This interim response indicates that everything so far is OK and that the client should continue with the request or ignore it if it is already finished.
     */ StatusCodes[StatusCodes["CONTINUE"] = 100] = "CONTINUE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.2
     *
     * This code is sent in response to an Upgrade request header by the client, and indicates the protocol the server is switching too.
     */ StatusCodes[StatusCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.1
     *
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     */ StatusCodes[StatusCodes["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Official Documentation @ https://www.rfc-editor.org/rfc/rfc8297#page-3
     *
     * This code indicates to the client that the server is likely to send a final response with the header fields included in the informational response.
     */ StatusCodes[StatusCodes["EARLY_HINTS"] = 103] = "EARLY_HINTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.1
     *
     * The request has succeeded. The meaning of a success varies depending on the HTTP method:
     * GET: The resource has been fetched and is transmitted in the message body.
     * HEAD: The entity headers are in the message body.
     * POST: The resource describing the result of the action is transmitted in the message body.
     * TRACE: The message body contains the request message as received by the server
     */ StatusCodes[StatusCodes["OK"] = 200] = "OK";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.2
     *
     * The request has succeeded and a new resource has been created as a result of it. This is typically the response sent after a PUT request.
     */ StatusCodes[StatusCodes["CREATED"] = 201] = "CREATED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.3
     *
     * The request has been received but not yet acted upon. It is non-committal, meaning that there is no way in HTTP to later send an asynchronous response indicating the outcome of processing the request. It is intended for cases where another process or server handles the request, or for batch processing.
     */ StatusCodes[StatusCodes["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.4
     *
     * This response code means returned meta-information set is not exact set as available from the origin server, but collected from a local or a third party copy. Except this condition, 200 OK response should be preferred instead of this response.
     */ StatusCodes[StatusCodes["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.5
     *
     * There is no content to send for this request, but the headers may be useful. The user-agent may update its cached headers for this resource with the new ones.
     */ StatusCodes[StatusCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.6
     *
     * This response code is sent after accomplishing request to tell user agent reset document view which sent this request.
     */ StatusCodes[StatusCodes["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.1
     *
     * This response code is used because of range header sent by the client to separate download into multiple streams.
     */ StatusCodes[StatusCodes["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.2
     *
     * A Multi-Status response conveys information about multiple resources in situations where multiple status codes might be appropriate.
     */ StatusCodes[StatusCodes["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.1
     *
     * The request has more than one possible responses. User-agent or user should choose one of them. There is no standardized way to choose one of the responses.
     */ StatusCodes[StatusCodes["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.2
     *
     * This response code means that URI of requested resource has been changed. Probably, new URI would be given in the response.
     */ StatusCodes[StatusCodes["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.3
     *
     * This response code means that URI of requested resource has been changed temporarily. New changes in the URI might be made in the future. Therefore, this same URI should be used by the client in future requests.
     */ StatusCodes[StatusCodes["MOVED_TEMPORARILY"] = 302] = "MOVED_TEMPORARILY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.4
     *
     * Server sent this response to directing client to get requested resource to another URI with an GET request.
     */ StatusCodes[StatusCodes["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.1
     *
     * This is used for caching purposes. It is telling to client that response has not been modified. So, client can continue to use same cached version of response.
     */ StatusCodes[StatusCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.6
     *
     * Was defined in a previous version of the HTTP specification to indicate that a requested response must be accessed by a proxy. It has been deprecated due to security concerns regarding in-band configuration of a proxy.
     */ StatusCodes[StatusCodes["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.7
     *
     * Server sent this response to directing client to get requested resource to another URI with same method that used prior request. This has the same semantic than the 302 Found HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7538#section-3
     *
     * This means that the resource is now permanently located at another URI, specified by the Location: HTTP Response header. This has the same semantics as the 301 Moved Permanently HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.1
     *
     * This response means that server could not understand the request due to invalid syntax.
     */ StatusCodes[StatusCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.1
     *
     * Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated". That is, the client must authenticate itself to get the requested response.
     */ StatusCodes[StatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.2
     *
     * This response code is reserved for future use. Initial aim for creating this code was using it for digital payment systems however this is not used currently.
     */ StatusCodes[StatusCodes["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.3
     *
     * The client does not have access rights to the content, i.e. they are unauthorized, so server is rejecting to give proper response. Unlike 401, the client's identity is known to the server.
     */ StatusCodes[StatusCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.4
     *
     * The server can not find requested resource. In the browser, this means the URL is not recognized. In an API, this can also mean that the endpoint is valid but the resource itself does not exist. Servers may also send this response instead of 403 to hide the existence of a resource from an unauthorized client. This response code is probably the most famous one due to its frequent occurence on the web.
     */ StatusCodes[StatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.5
     *
     * The request method is known by the server but has been disabled and cannot be used. For example, an API may forbid DELETE-ing a resource. The two mandatory methods, GET and HEAD, must never be disabled and should not return this error code.
     */ StatusCodes[StatusCodes["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.6
     *
     * This response is sent when the web server, after performing server-driven content negotiation, doesn't find any content following the criteria given by the user agent.
     */ StatusCodes[StatusCodes["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.2
     *
     * This is similar to 401 but authentication is needed to be done by a proxy.
     */ StatusCodes[StatusCodes["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.7
     *
     * This response is sent on an idle connection by some servers, even without any previous request by the client. It means that the server would like to shut down this unused connection. This response is used much more since some browsers, like Chrome, Firefox 27+, or IE9, use HTTP pre-connection mechanisms to speed up surfing. Also note that some servers merely shut down the connection without sending this message.
     */ StatusCodes[StatusCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.8
     *
     * This response is sent when a request conflicts with the current state of the server.
     */ StatusCodes[StatusCodes["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.9
     *
     * This response would be sent when the requested content has been permenantly deleted from server, with no forwarding address. Clients are expected to remove their caches and links to the resource. The HTTP specification intends this status code to be used for "limited-time, promotional services". APIs should not feel compelled to indicate resources that have been deleted with this status code.
     */ StatusCodes[StatusCodes["GONE"] = 410] = "GONE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.10
     *
     * The server rejected the request because the Content-Length header field is not defined and the server requires it.
     */ StatusCodes[StatusCodes["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.2
     *
     * The client has indicated preconditions in its headers which the server does not meet.
     */ StatusCodes[StatusCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.11
     *
     * Request entity is larger than limits defined by server; the server might close the connection or return an Retry-After header field.
     */ StatusCodes[StatusCodes["REQUEST_TOO_LONG"] = 413] = "REQUEST_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.12
     *
     * The URI requested by the client is longer than the server is willing to interpret.
     */ StatusCodes[StatusCodes["REQUEST_URI_TOO_LONG"] = 414] = "REQUEST_URI_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.13
     *
     * The media format of the requested data is not supported by the server, so the server is rejecting the request.
     */ StatusCodes[StatusCodes["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.4
     *
     * The range specified by the Range header field in the request can't be fulfilled; it's possible that the range is outside the size of the target URI's data.
     */ StatusCodes[StatusCodes["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.14
     *
     * This response code means the expectation indicated by the Expect request header field can't be met by the server.
     */ StatusCodes[StatusCodes["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2324#section-2.3.2
     *
     * Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.
     */ StatusCodes[StatusCodes["IM_A_TEAPOT"] = 418] = "IM_A_TEAPOT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The 507 (Insufficient Storage) status code means the method could not be performed on the resource because the server is unable to store the representation needed to successfully complete the request. This condition is considered to be temporary. If the request which received this status code was the result of a user action, the request MUST NOT be repeated until it is requested by a separate user action.
     */ StatusCodes[StatusCodes["INSUFFICIENT_SPACE_ON_RESOURCE"] = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/rfcdiff?difftype=--hwdiff&url2=draft-ietf-webdav-protocol-06.txt
     *
     * A deprecated response used by the Spring Framework when a method has failed.
     */ StatusCodes[StatusCodes["METHOD_FAILURE"] = 420] = "METHOD_FAILURE";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7540#section-9.1.2
     *
     * Defined in the specification of HTTP/2 to indicate that a server is not able to produce a response for the combination of scheme and authority that are included in the request URI.
     */ StatusCodes[StatusCodes["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.3
     *
     * The request was well-formed but was unable to be followed due to semantic errors.
     */ StatusCodes[StatusCodes["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.4
     *
     * The resource that is being accessed is locked.
     */ StatusCodes[StatusCodes["LOCKED"] = 423] = "LOCKED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.5
     *
     * The request failed due to failure of a previous request.
     */ StatusCodes[StatusCodes["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7231#section-6.5.15
     *
     * The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.
     */ StatusCodes[StatusCodes["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-3
     *
     * The origin server requires the request to be conditional. Intended to prevent the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict.
     */ StatusCodes[StatusCodes["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-4
     *
     * The user has sent too many requests in a given amount of time ("rate limiting").
     */ StatusCodes[StatusCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-5
     *
     * The server is unwilling to process the request because its header fields are too large. The request MAY be resubmitted after reducing the size of the request header fields.
     */ StatusCodes[StatusCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7725
     *
     * The user-agent requested a resource that cannot legally be provided, such as a web page censored by a government.
     */ StatusCodes[StatusCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.1
     *
     * The server encountered an unexpected condition that prevented it from fulfilling the request.
     */ StatusCodes[StatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.2
     *
     * The request method is not supported by the server and cannot be handled. The only methods that servers are required to support (and therefore that must not return this code) are GET and HEAD.
     */ StatusCodes[StatusCodes["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.3
     *
     * This error response means that the server, while working as a gateway to get a response needed to handle the request, got an invalid response.
     */ StatusCodes[StatusCodes["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.4
     *
     * The server is not ready to handle the request. Common causes are a server that is down for maintenance or that is overloaded. Note that together with this response, a user-friendly page explaining the problem should be sent. This responses should be used for temporary conditions and the Retry-After: HTTP header should, if possible, contain the estimated time before the recovery of the service. The webmaster must also take care about the caching-related headers that are sent along with this response, as these temporary condition responses should usually not be cached.
     */ StatusCodes[StatusCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.5
     *
     * This error response is given when the server is acting as a gateway and cannot get a response in time.
     */ StatusCodes[StatusCodes["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.6
     *
     * The HTTP version used in the request is not supported by the server.
     */ StatusCodes[StatusCodes["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The server has an internal configuration error: the chosen variant resource is configured to engage in transparent content negotiation itself, and is therefore not a proper end point in the negotiation process.
     */ StatusCodes[StatusCodes["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-6
     *
     * The 511 status code indicates that the client needs to authenticate to gain network access.
     */ StatusCodes[StatusCodes["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})($08396fcc01c9bf85$export$efd5569f873811b1 || ($08396fcc01c9bf85$export$efd5569f873811b1 = {}));



var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $de684d5f5a3d8d1f$export$98e6a39c04603d36;
var $de684d5f5a3d8d1f$export$dfdc1655ccc5b9cb;
'use strict';
$de684d5f5a3d8d1f$export$98e6a39c04603d36 = $de684d5f5a3d8d1f$var$parse;
$de684d5f5a3d8d1f$export$dfdc1655ccc5b9cb = $de684d5f5a3d8d1f$var$serialize;
/**
 * Module variables.
 * @private
 */ var $de684d5f5a3d8d1f$var$decode = decodeURIComponent;
var $de684d5f5a3d8d1f$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $de684d5f5a3d8d1f$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $de684d5f5a3d8d1f$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $de684d5f5a3d8d1f$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $de684d5f5a3d8d1f$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $de684d5f5a3d8d1f$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $de684d5f5a3d8d1f$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$de684d5f5a3d8d1f$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$de684d5f5a3d8d1f$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$de684d5f5a3d8d1f$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$de684d5f5a3d8d1f$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $de684d5f5a3d8d1f$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $a31d46eab44b4ee0$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $a31d46eab44b4ee0$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $a31d46eab44b4ee0$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $de684d5f5a3d8d1f$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $a31d46eab44b4ee0$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $a31d46eab44b4ee0$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $a31d46eab44b4ee0$var$cleanupCookieValue(value);
    if ($a31d46eab44b4ee0$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $a31d46eab44b4ee0$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}


var $2926698d06c6e319$var$__assign = undefined && undefined.__assign || function() {
    $2926698d06c6e319$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2926698d06c6e319$var$__assign.apply(this, arguments);
};
var $2926698d06c6e319$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $a31d46eab44b4ee0$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $a31d46eab44b4ee0$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $de684d5f5a3d8d1f$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $a31d46eab44b4ee0$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $a31d46eab44b4ee0$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $2926698d06c6e319$var$__assign($2926698d06c6e319$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $de684d5f5a3d8d1f$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $2926698d06c6e319$var$__assign($2926698d06c6e319$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $2926698d06c6e319$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $de684d5f5a3d8d1f$export$dfdc1655ccc5b9cb(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $2926698d06c6e319$export$2e2bcd8739ae039 = $2926698d06c6e319$var$Cookies;


var $145dbbcf71e58b86$export$2e2bcd8739ae039 = (0, $2926698d06c6e319$export$2e2bcd8739ae039);


var $275df9008d4e0d6a$export$2e2bcd8739ae039 = (0, $145dbbcf71e58b86$export$2e2bcd8739ae039);


var $ee5eb3b2ac845186$var$CookiesContext = $eeH7J.createContext(new (0, $275df9008d4e0d6a$export$2e2bcd8739ae039)());
var $ee5eb3b2ac845186$export$2881499e37b75b9a = $ee5eb3b2ac845186$var$CookiesContext.Provider, $ee5eb3b2ac845186$export$b3bffd4bb7da6b8f = $ee5eb3b2ac845186$var$CookiesContext.Consumer;
var $ee5eb3b2ac845186$export$2e2bcd8739ae039 = $ee5eb3b2ac845186$var$CookiesContext;


function $3b603b67cd9ac9c0$export$23b68da80b41ce8c() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}


function $695d41f3aa343730$export$2e2bcd8739ae039(dependencies) {
    var cookies = (0, $eeH7J.useContext)((0, $ee5eb3b2ac845186$export$2e2bcd8739ae039));
    if (!cookies) throw new Error('Missing <CookiesProvider>');
    var initialCookies = cookies.getAll();
    var _a = (0, $eeH7J.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0, $eeH7J.useRef)(allCookies);
    if ((0, $3b603b67cd9ac9c0$export$23b68da80b41ce8c)()) (0, $eeH7J.useLayoutEffect)(function() {
        function onChange() {
            var newCookies = cookies.getAll();
            if ($695d41f3aa343730$var$shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) setCookies(newCookies);
            previousCookiesRef.current = newCookies;
        }
        cookies.addChangeListener(onChange);
        return function() {
            cookies.removeChangeListener(onChange);
        };
    }, [
        cookies
    ]);
    var setCookie = (0, $eeH7J.useMemo)(function() {
        return cookies.set.bind(cookies);
    }, [
        cookies
    ]);
    var removeCookie = (0, $eeH7J.useMemo)(function() {
        return cookies.remove.bind(cookies);
    }, [
        cookies
    ]);
    return [
        allCookies,
        setCookie,
        removeCookie
    ];
}
function $695d41f3aa343730$var$shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) return true;
    for(var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++){
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) return true;
    }
    return false;
}



var $697efec4692ba881$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($697efec4692ba881$exports, "__esModule", {
    value: true
});
$697efec4692ba881$exports.default = void 0;

var $697efec4692ba881$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $697efec4692ba881$var$_default = $697efec4692ba881$exports.default = (0, $697efec4692ba881$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');


var $68b84ea65a9d38b0$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($68b84ea65a9d38b0$exports, "__esModule", {
    value: true
});
$68b84ea65a9d38b0$exports.default = void 0;

var $68b84ea65a9d38b0$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $68b84ea65a9d38b0$var$_default = $68b84ea65a9d38b0$exports.default = (0, $68b84ea65a9d38b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5"
}), 'RemoveRedEyeOutlined');


'use strict';
function $073c673664b8e57b$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $1fbc3a1ae3c79101$exports = {};
// shim for using process in browser
var $1fbc3a1ae3c79101$var$process = $1fbc3a1ae3c79101$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $1fbc3a1ae3c79101$var$cachedSetTimeout;
var $1fbc3a1ae3c79101$var$cachedClearTimeout;
function $1fbc3a1ae3c79101$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $1fbc3a1ae3c79101$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $1fbc3a1ae3c79101$var$cachedSetTimeout = setTimeout;
        else $1fbc3a1ae3c79101$var$cachedSetTimeout = $1fbc3a1ae3c79101$var$defaultSetTimout;
    } catch (e) {
        $1fbc3a1ae3c79101$var$cachedSetTimeout = $1fbc3a1ae3c79101$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $1fbc3a1ae3c79101$var$cachedClearTimeout = clearTimeout;
        else $1fbc3a1ae3c79101$var$cachedClearTimeout = $1fbc3a1ae3c79101$var$defaultClearTimeout;
    } catch (e) {
        $1fbc3a1ae3c79101$var$cachedClearTimeout = $1fbc3a1ae3c79101$var$defaultClearTimeout;
    }
})();
function $1fbc3a1ae3c79101$var$runTimeout(fun) {
    if ($1fbc3a1ae3c79101$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($1fbc3a1ae3c79101$var$cachedSetTimeout === $1fbc3a1ae3c79101$var$defaultSetTimout || !$1fbc3a1ae3c79101$var$cachedSetTimeout) && setTimeout) {
        $1fbc3a1ae3c79101$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1fbc3a1ae3c79101$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $1fbc3a1ae3c79101$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $1fbc3a1ae3c79101$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $1fbc3a1ae3c79101$var$runClearTimeout(marker) {
    if ($1fbc3a1ae3c79101$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($1fbc3a1ae3c79101$var$cachedClearTimeout === $1fbc3a1ae3c79101$var$defaultClearTimeout || !$1fbc3a1ae3c79101$var$cachedClearTimeout) && clearTimeout) {
        $1fbc3a1ae3c79101$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1fbc3a1ae3c79101$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $1fbc3a1ae3c79101$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $1fbc3a1ae3c79101$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $1fbc3a1ae3c79101$var$queue = [];
var $1fbc3a1ae3c79101$var$draining = false;
var $1fbc3a1ae3c79101$var$currentQueue;
var $1fbc3a1ae3c79101$var$queueIndex = -1;
function $1fbc3a1ae3c79101$var$cleanUpNextTick() {
    if (!$1fbc3a1ae3c79101$var$draining || !$1fbc3a1ae3c79101$var$currentQueue) return;
    $1fbc3a1ae3c79101$var$draining = false;
    if ($1fbc3a1ae3c79101$var$currentQueue.length) $1fbc3a1ae3c79101$var$queue = $1fbc3a1ae3c79101$var$currentQueue.concat($1fbc3a1ae3c79101$var$queue);
    else $1fbc3a1ae3c79101$var$queueIndex = -1;
    if ($1fbc3a1ae3c79101$var$queue.length) $1fbc3a1ae3c79101$var$drainQueue();
}
function $1fbc3a1ae3c79101$var$drainQueue() {
    if ($1fbc3a1ae3c79101$var$draining) return;
    var timeout = $1fbc3a1ae3c79101$var$runTimeout($1fbc3a1ae3c79101$var$cleanUpNextTick);
    $1fbc3a1ae3c79101$var$draining = true;
    var len = $1fbc3a1ae3c79101$var$queue.length;
    while(len){
        $1fbc3a1ae3c79101$var$currentQueue = $1fbc3a1ae3c79101$var$queue;
        $1fbc3a1ae3c79101$var$queue = [];
        while(++$1fbc3a1ae3c79101$var$queueIndex < len)if ($1fbc3a1ae3c79101$var$currentQueue) $1fbc3a1ae3c79101$var$currentQueue[$1fbc3a1ae3c79101$var$queueIndex].run();
        $1fbc3a1ae3c79101$var$queueIndex = -1;
        len = $1fbc3a1ae3c79101$var$queue.length;
    }
    $1fbc3a1ae3c79101$var$currentQueue = null;
    $1fbc3a1ae3c79101$var$draining = false;
    $1fbc3a1ae3c79101$var$runClearTimeout(timeout);
}
$1fbc3a1ae3c79101$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $1fbc3a1ae3c79101$var$queue.push(new $1fbc3a1ae3c79101$var$Item(fun, args));
    if ($1fbc3a1ae3c79101$var$queue.length === 1 && !$1fbc3a1ae3c79101$var$draining) $1fbc3a1ae3c79101$var$runTimeout($1fbc3a1ae3c79101$var$drainQueue);
};
// v8 likes predictible objects
function $1fbc3a1ae3c79101$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$1fbc3a1ae3c79101$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$1fbc3a1ae3c79101$var$process.title = 'browser';
$1fbc3a1ae3c79101$var$process.browser = true;
$1fbc3a1ae3c79101$var$process.env = {};
$1fbc3a1ae3c79101$var$process.argv = [];
$1fbc3a1ae3c79101$var$process.version = ''; // empty string to avoid regexp issues
$1fbc3a1ae3c79101$var$process.versions = {};
function $1fbc3a1ae3c79101$var$noop() {}
$1fbc3a1ae3c79101$var$process.on = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.addListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.once = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.off = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.removeListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.removeAllListeners = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.emit = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.prependListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.prependOnceListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.listeners = function(name) {
    return [];
};
$1fbc3a1ae3c79101$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$1fbc3a1ae3c79101$var$process.cwd = function() {
    return '/';
};
$1fbc3a1ae3c79101$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$1fbc3a1ae3c79101$var$process.umask = function() {
    return 0;
};


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $1ff77a601530de1d$var$toString } = Object.prototype;
const { getPrototypeOf: $1ff77a601530de1d$var$getPrototypeOf } = Object;
const { iterator: $1ff77a601530de1d$var$iterator, toStringTag: $1ff77a601530de1d$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $1ff77a601530de1d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $1ff77a601530de1d$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $1ff77a601530de1d$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $1ff77a601530de1d$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($1ff77a601530de1d$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $1ff77a601530de1d$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $1ff77a601530de1d$var$getPrototypeOf(obj);
        if ($1ff77a601530de1d$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($1ff77a601530de1d$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $1ff77a601530de1d$var$getSafeProp = (obj, prop)=>obj != null && $1ff77a601530de1d$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $1ff77a601530de1d$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $1ff77a601530de1d$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $1ff77a601530de1d$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $1ff77a601530de1d$var$getPrototypeOf(current);
        if ($1ff77a601530de1d$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($1ff77a601530de1d$var$isUnsafeObjectKey(prop)) continue;
            if (!$1ff77a601530de1d$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $1ff77a601530de1d$var$kindOf = ((cache)=>(thing)=>{
        const str = $1ff77a601530de1d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $1ff77a601530de1d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$1ff77a601530de1d$var$kindOf(thing) === type;
};
const $1ff77a601530de1d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $1ff77a601530de1d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $1ff77a601530de1d$var$isUndefined = $1ff77a601530de1d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $1ff77a601530de1d$var$isBuffer(val) {
    return val !== null && !$1ff77a601530de1d$var$isUndefined(val) && val.constructor !== null && !$1ff77a601530de1d$var$isUndefined(val.constructor) && $1ff77a601530de1d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $1ff77a601530de1d$var$isArrayBuffer = $1ff77a601530de1d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $1ff77a601530de1d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $1ff77a601530de1d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $1ff77a601530de1d$var$isString = $1ff77a601530de1d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $1ff77a601530de1d$var$isFunction = $1ff77a601530de1d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $1ff77a601530de1d$var$isNumber = $1ff77a601530de1d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $1ff77a601530de1d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $1ff77a601530de1d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $1ff77a601530de1d$var$isPlainObject = (val)=>{
    if (!$1ff77a601530de1d$var$isObject(val)) return false;
    const prototype = $1ff77a601530de1d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $1ff77a601530de1d$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$1ff77a601530de1d$var$hasOwnInPrototypeChain(val, $1ff77a601530de1d$var$toStringTag) && !$1ff77a601530de1d$var$hasOwnInPrototypeChain(val, $1ff77a601530de1d$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $1ff77a601530de1d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$1ff77a601530de1d$var$isObject(val) || $1ff77a601530de1d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $1ff77a601530de1d$var$isDate = $1ff77a601530de1d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $1ff77a601530de1d$var$isFile = $1ff77a601530de1d$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $1ff77a601530de1d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $1ff77a601530de1d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $1ff77a601530de1d$var$isBlob = $1ff77a601530de1d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $1ff77a601530de1d$var$isFileList = $1ff77a601530de1d$var$kindOfTest('FileList');
const $1ff77a601530de1d$var$isSet = $1ff77a601530de1d$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $1ff77a601530de1d$var$isStream = (val)=>$1ff77a601530de1d$var$isObject(val) && $1ff77a601530de1d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $1ff77a601530de1d$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $1ff77a601530de1d$var$G = $1ff77a601530de1d$var$getGlobal();
const $1ff77a601530de1d$var$FormDataCtor = typeof $1ff77a601530de1d$var$G.FormData !== 'undefined' ? $1ff77a601530de1d$var$G.FormData : undefined;
const $1ff77a601530de1d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($1ff77a601530de1d$var$FormDataCtor && thing instanceof $1ff77a601530de1d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $1ff77a601530de1d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$1ff77a601530de1d$var$isFunction(thing.append)) return false;
    const kind = $1ff77a601530de1d$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $1ff77a601530de1d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $1ff77a601530de1d$var$isURLSearchParams = $1ff77a601530de1d$var$kindOfTest('URLSearchParams');
const [$1ff77a601530de1d$var$isReadableStream, $1ff77a601530de1d$var$isRequest, $1ff77a601530de1d$var$isResponse, $1ff77a601530de1d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($1ff77a601530de1d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $1ff77a601530de1d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $1ff77a601530de1d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($1ff77a601530de1d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($1ff77a601530de1d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $1ff77a601530de1d$var$findKey(obj, key) {
    if ($1ff77a601530de1d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $1ff77a601530de1d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $1ff77a601530de1d$var$isContextDefined = (context)=>!$1ff77a601530de1d$var$isUndefined(context) && context !== $1ff77a601530de1d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $1ff77a601530de1d$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $1ff77a601530de1d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $1ff77a601530de1d$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $1ff77a601530de1d$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($1ff77a601530de1d$var$isPlainObject(existing) && $1ff77a601530de1d$var$isPlainObject(val)) result[targetKey] = $1ff77a601530de1d$var$merge(existing, val);
        else if ($1ff77a601530de1d$var$isPlainObject(val)) result[targetKey] = $1ff77a601530de1d$var$merge({}, val);
        else if ($1ff77a601530de1d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$1ff77a601530de1d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $1ff77a601530de1d$var$isBuffer(source)) continue;
        $1ff77a601530de1d$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $1ff77a601530de1d$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($1ff77a601530de1d$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $1ff77a601530de1d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $1ff77a601530de1d$var$forEach(b, (val, key)=>{
        if (thisArg && $1ff77a601530de1d$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $073c673664b8e57b$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $1ff77a601530de1d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $1ff77a601530de1d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $1ff77a601530de1d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $1ff77a601530de1d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $1ff77a601530de1d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $1ff77a601530de1d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($1ff77a601530de1d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$1ff77a601530de1d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $1ff77a601530de1d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $1ff77a601530de1d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $1ff77a601530de1d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$1ff77a601530de1d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $1ff77a601530de1d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $1ff77a601530de1d$var$isHTMLForm = $1ff77a601530de1d$var$kindOfTest('HTMLFormElement');
const $1ff77a601530de1d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $1ff77a601530de1d$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $1ff77a601530de1d$var$isRegExp = $1ff77a601530de1d$var$kindOfTest('RegExp');
const $1ff77a601530de1d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $1ff77a601530de1d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $1ff77a601530de1d$var$freezeMethods = (obj)=>{
    $1ff77a601530de1d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($1ff77a601530de1d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$1ff77a601530de1d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $1ff77a601530de1d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $1ff77a601530de1d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $1ff77a601530de1d$var$noop = ()=>{};
const $1ff77a601530de1d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $1ff77a601530de1d$var$isSpecCompliantForm(thing) {
    return !!(thing && $1ff77a601530de1d$var$isFunction(thing.append) && thing[$1ff77a601530de1d$var$toStringTag] === 'FormData' && thing[$1ff77a601530de1d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $1ff77a601530de1d$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($1ff77a601530de1d$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($1ff77a601530de1d$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($1ff77a601530de1d$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$1ff77a601530de1d$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $1ff77a601530de1d$var$isArray(source) ? [] : {};
                    $1ff77a601530de1d$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$1ff77a601530de1d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $1ff77a601530de1d$var$isAsyncFn = $1ff77a601530de1d$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $1ff77a601530de1d$var$isThenable = (thing)=>thing && ($1ff77a601530de1d$var$isObject(thing) || $1ff77a601530de1d$var$isFunction(thing)) && $1ff77a601530de1d$var$isFunction(thing.then) && $1ff77a601530de1d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $1ff77a601530de1d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $1ff77a601530de1d$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $1ff77a601530de1d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $1ff77a601530de1d$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $1ff77a601530de1d$var$isFunction($1ff77a601530de1d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $1ff77a601530de1d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($1ff77a601530de1d$var$_global) : typeof $1fbc3a1ae3c79101$exports !== 'undefined' && $1fbc3a1ae3c79101$exports.nextTick || $1ff77a601530de1d$var$_setImmediate;
// *********************
const $1ff77a601530de1d$var$isIterable = (thing)=>thing != null && $1ff77a601530de1d$var$isFunction(thing[$1ff77a601530de1d$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $1ff77a601530de1d$var$isSafeIterable = (thing)=>thing != null && $1ff77a601530de1d$var$hasOwnInPrototypeChain(thing, $1ff77a601530de1d$var$iterator) && $1ff77a601530de1d$var$isIterable(thing);
var $1ff77a601530de1d$export$2e2bcd8739ae039 = {
    isArray: $1ff77a601530de1d$var$isArray,
    isArrayBuffer: $1ff77a601530de1d$var$isArrayBuffer,
    isBuffer: $1ff77a601530de1d$var$isBuffer,
    isFormData: $1ff77a601530de1d$var$isFormData,
    isArrayBufferView: $1ff77a601530de1d$var$isArrayBufferView,
    isString: $1ff77a601530de1d$var$isString,
    isNumber: $1ff77a601530de1d$var$isNumber,
    isBoolean: $1ff77a601530de1d$var$isBoolean,
    isObject: $1ff77a601530de1d$var$isObject,
    isPlainObject: $1ff77a601530de1d$var$isPlainObject,
    isEmptyObject: $1ff77a601530de1d$var$isEmptyObject,
    isReadableStream: $1ff77a601530de1d$var$isReadableStream,
    isRequest: $1ff77a601530de1d$var$isRequest,
    isResponse: $1ff77a601530de1d$var$isResponse,
    isHeaders: $1ff77a601530de1d$var$isHeaders,
    isUndefined: $1ff77a601530de1d$var$isUndefined,
    isDate: $1ff77a601530de1d$var$isDate,
    isFile: $1ff77a601530de1d$var$isFile,
    isReactNativeBlob: $1ff77a601530de1d$var$isReactNativeBlob,
    isReactNative: $1ff77a601530de1d$var$isReactNative,
    isBlob: $1ff77a601530de1d$var$isBlob,
    isRegExp: $1ff77a601530de1d$var$isRegExp,
    isFunction: $1ff77a601530de1d$var$isFunction,
    isStream: $1ff77a601530de1d$var$isStream,
    isURLSearchParams: $1ff77a601530de1d$var$isURLSearchParams,
    isTypedArray: $1ff77a601530de1d$var$isTypedArray,
    isFileList: $1ff77a601530de1d$var$isFileList,
    forEach: $1ff77a601530de1d$var$forEach,
    merge: $1ff77a601530de1d$var$merge,
    extend: $1ff77a601530de1d$var$extend,
    trim: $1ff77a601530de1d$var$trim,
    stripBOM: $1ff77a601530de1d$var$stripBOM,
    inherits: $1ff77a601530de1d$var$inherits,
    toFlatObject: $1ff77a601530de1d$var$toFlatObject,
    kindOf: $1ff77a601530de1d$var$kindOf,
    kindOfTest: $1ff77a601530de1d$var$kindOfTest,
    endsWith: $1ff77a601530de1d$var$endsWith,
    toArray: $1ff77a601530de1d$var$toArray,
    forEachEntry: $1ff77a601530de1d$var$forEachEntry,
    matchAll: $1ff77a601530de1d$var$matchAll,
    isHTMLForm: $1ff77a601530de1d$var$isHTMLForm,
    hasOwnProperty: $1ff77a601530de1d$var$hasOwnProperty,
    hasOwnProp: $1ff77a601530de1d$var$hasOwnProperty,
    hasOwnInPrototypeChain: $1ff77a601530de1d$var$hasOwnInPrototypeChain,
    getSafeProp: $1ff77a601530de1d$var$getSafeProp,
    toSafeFlatObject: $1ff77a601530de1d$var$toSafeFlatObject,
    reduceDescriptors: $1ff77a601530de1d$var$reduceDescriptors,
    freezeMethods: $1ff77a601530de1d$var$freezeMethods,
    toObjectSet: $1ff77a601530de1d$var$toObjectSet,
    toCamelCase: $1ff77a601530de1d$var$toCamelCase,
    noop: $1ff77a601530de1d$var$noop,
    toFiniteNumber: $1ff77a601530de1d$var$toFiniteNumber,
    findKey: $1ff77a601530de1d$var$findKey,
    global: $1ff77a601530de1d$var$_global,
    isContextDefined: $1ff77a601530de1d$var$isContextDefined,
    isSpecCompliantForm: $1ff77a601530de1d$var$isSpecCompliantForm,
    toJSONObject: $1ff77a601530de1d$var$toJSONObject,
    isAsyncFn: $1ff77a601530de1d$var$isAsyncFn,
    isThenable: $1ff77a601530de1d$var$isThenable,
    setImmediate: $1ff77a601530de1d$var$_setImmediate,
    asap: $1ff77a601530de1d$var$asap,
    isIterable: $1ff77a601530de1d$var$isIterable,
    isSafeIterable: $1ff77a601530de1d$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $a8a95140619505af$var$ignoreDuplicateOf = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $a8a95140619505af$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp($a8a95140619505af$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $5a454e9adbd27562$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $5a454e9adbd27562$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $5a454e9adbd27562$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $5a454e9adbd27562$var$sanitizeValue(value, invalidChars) {
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$5a454e9adbd27562$var$sanitizeValue(item, invalidChars));
    return $5a454e9adbd27562$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $5a454e9adbd27562$export$9e344cffce061a22 = (value)=>$5a454e9adbd27562$var$sanitizeValue(value, $5a454e9adbd27562$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $5a454e9adbd27562$export$59dd66c2a12d8f62 = (value)=>$5a454e9adbd27562$var$sanitizeValue(value, $5a454e9adbd27562$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $5a454e9adbd27562$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $5a454e9adbd27562$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $024894015d2d35e1$var$$internals = Symbol('internals');
function $024894015d2d35e1$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $024894015d2d35e1$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(value) ? value.map($024894015d2d35e1$var$normalizeValue) : (0, $5a454e9adbd27562$export$9e344cffce061a22)(String(value));
}
function $024894015d2d35e1$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $024894015d2d35e1$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $024894015d2d35e1$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $024894015d2d35e1$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $024894015d2d35e1$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $024894015d2d35e1$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $024894015d2d35e1$var$trimOWS(part.slice(0, equals));
        if (!$024894015d2d35e1$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $024894015d2d35e1$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $024894015d2d35e1$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $024894015d2d35e1$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $024894015d2d35e1$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $024894015d2d35e1$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $024894015d2d35e1$var$buildAccessors(obj, header) {
    const accessorName = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $024894015d2d35e1$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $024894015d2d35e1$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $024894015d2d35e1$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$024894015d2d35e1$var$isValidHeaderName(header)) setHeaders((0, $a8a95140619505af$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isObject(header) && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $024894015d2d35e1$var$normalizeHeader(header);
        if (header) {
            const key = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $024894015d2d35e1$var$parseTokens(value);
                if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $024894015d2d35e1$var$normalizeHeader(header);
        if (header) {
            const key = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $024894015d2d35e1$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $024894015d2d35e1$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $024894015d2d35e1$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $024894015d2d35e1$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $024894015d2d35e1$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $024894015d2d35e1$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $024894015d2d35e1$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $024894015d2d35e1$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$024894015d2d35e1$var$$internals] = this[$024894015d2d35e1$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $024894015d2d35e1$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $024894015d2d35e1$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$024894015d2d35e1$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $1ff77a601530de1d$export$2e2bcd8739ae039).reduceDescriptors($024894015d2d35e1$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $1ff77a601530de1d$export$2e2bcd8739ae039).freezeMethods($024894015d2d35e1$var$AxiosHeaders);
var $024894015d2d35e1$export$2e2bcd8739ae039 = $024894015d2d35e1$var$AxiosHeaders;


'use strict';
const $fc5a4f1bbeec67a0$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $fc5a4f1bbeec67a0$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $fc5a4f1bbeec67a0$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $024894015d2d35e1$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(source) && $fc5a4f1bbeec67a0$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $fc5a4f1bbeec67a0$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $fc5a4f1bbeec67a0$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $fc5a4f1bbeec67a0$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $fc5a4f1bbeec67a0$var$stringifySafely(entry.message) : $fc5a4f1bbeec67a0$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $fc5a4f1bbeec67a0$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $fc5a4f1bbeec67a0$var$aggregateErrorMessage(error);
        const axiosError = new $fc5a4f1bbeec67a0$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $fc5a4f1bbeec67a0$var$redactConfig(config, redactKeys) : (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$fc5a4f1bbeec67a0$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$fc5a4f1bbeec67a0$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$fc5a4f1bbeec67a0$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$fc5a4f1bbeec67a0$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$fc5a4f1bbeec67a0$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $fc5a4f1bbeec67a0$export$2e2bcd8739ae039 = $fc5a4f1bbeec67a0$var$AxiosError;


// eslint-disable-next-line strict
var $2e668e86497372bd$export$2e2bcd8739ae039 = null;



'use strict';
const $5d338df60e600bf1$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5d338df60e600bf1$var$isVisitable(thing) {
    return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5d338df60e600bf1$var$removeBrackets(key) {
    return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5d338df60e600bf1$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5d338df60e600bf1$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5d338df60e600bf1$var$isFlatArray(arr) {
    return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5d338df60e600bf1$var$isVisitable);
}
const $5d338df60e600bf1$var$predicates = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toFlatObject((0, $1ff77a601530de1d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5d338df60e600bf1$var$toFormData(obj, formData, options) {
    if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $2e668e86497372bd$export$2e2bcd8739ae039) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $5d338df60e600bf1$export$659081b45d03227d);
    const useBlob = _Blob && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $2e668e86497372bd$export$2e2bcd8739ae039) && (0, $2e668e86497372bd$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $2e668e86497372bd$export$2e2bcd8739ae039).from(value);
            throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isReactNative(formData) && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($5d338df60e600bf1$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(value) && $5d338df60e600bf1$var$isFlatArray(value) || ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFileList(value) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5d338df60e600bf1$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5d338df60e600bf1$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($5d338df60e600bf1$var$isVisitable(value)) return true;
        formData.append($5d338df60e600bf1$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($5d338df60e600bf1$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5d338df60e600bf1$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $5d338df60e600bf1$export$2e2bcd8739ae039 = $5d338df60e600bf1$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $e7ef93bcf415ee75$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $e7ef93bcf415ee75$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5d338df60e600bf1$export$2e2bcd8739ae039)(params, this, options);
}
const $e7ef93bcf415ee75$var$prototype = $e7ef93bcf415ee75$var$AxiosURLSearchParams.prototype;
$e7ef93bcf415ee75$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$e7ef93bcf415ee75$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $e7ef93bcf415ee75$var$encode) : $e7ef93bcf415ee75$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $e7ef93bcf415ee75$export$2e2bcd8739ae039 = $e7ef93bcf415ee75$var$AxiosURLSearchParams;


'use strict';
function $a6f70ff99505f9b3$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $a6f70ff99505f9b3$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $a6f70ff99505f9b3$export$c564cdbbe6da493;
    const serializeFn = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $e7ef93bcf415ee75$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
const $416377109db7a9d5$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $416377109db7a9d5$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $416377109db7a9d5$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $416377109db7a9d5$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $416377109db7a9d5$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $416377109db7a9d5$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$416377109db7a9d5$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$416377109db7a9d5$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $416377109db7a9d5$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$416377109db7a9d5$var$$internals];
        $416377109db7a9d5$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $416377109db7a9d5$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $416377109db7a9d5$var$syncHandlerEntries(this, this[$416377109db7a9d5$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$416377109db7a9d5$var$$internals];
        $416377109db7a9d5$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $416377109db7a9d5$var$syncHandlerEntries(this, internals);
                $416377109db7a9d5$var$trimHandlers(this.handlers);
                internals.handlersLength = $416377109db7a9d5$var$countHandlers(this.handlers);
            }
        }
    }
}
var $416377109db7a9d5$export$2e2bcd8739ae039 = $416377109db7a9d5$var$InterceptorManager;





'use strict';
var $bc9be82a91ff9fe3$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $afdd2547b73bc465$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $e7ef93bcf415ee75$export$2e2bcd8739ae039);


'use strict';
var $ab5657a1374e043b$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $a1223b7801a5d0bb$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $de058264ee7c4c7e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $afdd2547b73bc465$export$2e2bcd8739ae039,
        FormData: $ab5657a1374e043b$export$2e2bcd8739ae039,
        Blob: $a1223b7801a5d0bb$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $4bb065280fe88790$exports = {};

$parcel$export($4bb065280fe88790$exports, "hasBrowserEnv", function () { return $4bb065280fe88790$export$c4996c4b7b93b0bf; });
$parcel$export($4bb065280fe88790$exports, "navigator", function () { return $4bb065280fe88790$export$ec7c8efa7f5790ae; });
$parcel$export($4bb065280fe88790$exports, "hasStandardBrowserEnv", function () { return $4bb065280fe88790$export$c0bcc9250309d66; });
$parcel$export($4bb065280fe88790$exports, "hasStandardBrowserWebWorkerEnv", function () { return $4bb065280fe88790$export$c81692cf5af97dac; });
$parcel$export($4bb065280fe88790$exports, "origin", function () { return $4bb065280fe88790$export$f710a83a91838a36; });
const $4bb065280fe88790$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $4bb065280fe88790$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $4bb065280fe88790$export$c0bcc9250309d66 = $4bb065280fe88790$export$c4996c4b7b93b0bf && (!$4bb065280fe88790$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($4bb065280fe88790$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $4bb065280fe88790$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $4bb065280fe88790$export$f710a83a91838a36 = $4bb065280fe88790$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $168c3f1b28052987$export$2e2bcd8739ae039 = {
    ...$4bb065280fe88790$exports,
    ...(0, $de058264ee7c4c7e$export$2e2bcd8739ae039)
};


'use strict';
function $12af839eae913d7e$export$2e2bcd8739ae039(data, options) {
    return (0, $5d338df60e600bf1$export$2e2bcd8739ae039)(data, new (0, $168c3f1b28052987$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $168c3f1b28052987$export$2e2bcd8739ae039).isNode && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $d3f8f588c1738735$var$MAX_DEPTH = (0, $5d338df60e600bf1$export$659081b45d03227d);
function $d3f8f588c1738735$var$throwIfDepthExceeded(index) {
    if (index > $d3f8f588c1738735$var$MAX_DEPTH) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $d3f8f588c1738735$var$MAX_DEPTH, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $d3f8f588c1738735$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $d3f8f588c1738735$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $d3f8f588c1738735$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $d3f8f588c1738735$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $d3f8f588c1738735$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $d3f8f588c1738735$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFormData(formData) && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($d3f8f588c1738735$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $d3f8f588c1738735$export$2e2bcd8739ae039 = $d3f8f588c1738735$var$formDataToJSON;


'use strict';
const $5c9a82e0e741c4a5$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $5c9a82e0e741c4a5$export$2e2bcd8739ae039 = $5c9a82e0e741c4a5$var$methodList;


'use strict';
const $1d0ba6bc9d1798d5$var$own = (obj, key)=>obj != null && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $1d0ba6bc9d1798d5$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $1d0ba6bc9d1798d5$var$defaults = {
    transitional: (0, $bc9be82a91ff9fe3$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $d3f8f588c1738735$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isBuffer(data) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isStream(data) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFile(data) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isBlob(data) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $1d0ba6bc9d1798d5$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $12af839eae913d7e$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $1d0ba6bc9d1798d5$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $5d338df60e600bf1$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $1d0ba6bc9d1798d5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $1d0ba6bc9d1798d5$var$own(this, 'transitional') || $1d0ba6bc9d1798d5$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $1d0ba6bc9d1798d5$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isResponse(data) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $1d0ba6bc9d1798d5$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).from(e, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $1d0ba6bc9d1798d5$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $168c3f1b28052987$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $168c3f1b28052987$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach((0, $5c9a82e0e741c4a5$export$2e2bcd8739ae039), (method)=>{
    $1d0ba6bc9d1798d5$var$defaults.headers[method] = {};
});
var $1d0ba6bc9d1798d5$export$2e2bcd8739ae039 = $1d0ba6bc9d1798d5$var$defaults;



'use strict';
function $1b3623da1e3123d8$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $1d0ba6bc9d1798d5$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $876d296ccb6629a5$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $b1983f36ca907598$var$CanceledError extends (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $b1983f36ca907598$export$2e2bcd8739ae039 = $b1983f36ca907598$var$CanceledError;







'use strict';
function $22ea0b2f5ec1ea9c$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
const $a06c2bc44e400798$var$urlParserControlCharacters = /[\t\n\r]/g;
function $a06c2bc44e400798$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($a06c2bc44e400798$var$urlParserControlCharacters, '');
}


'use strict';
function $47c8581bd96d95df$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3633225163f80d9a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3633225163f80d9a$export$2e2bcd8739ae039 = $3633225163f80d9a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $41fa2a3ea110d0ab$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $41fa2a3ea110d0ab$export$2e2bcd8739ae039 = $41fa2a3ea110d0ab$var$throttle;



const $540702b7b6a7c636$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $3633225163f80d9a$export$2e2bcd8739ae039)(50, 250);
    return (0, $41fa2a3ea110d0ab$export$2e2bcd8739ae039)((e)=>{
        if (!e || !(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $540702b7b6a7c636$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $540702b7b6a7c636$export$5d35863c355a22a9 = (fn, scheduler = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $371d168f903f3f49$export$2e2bcd8739ae039 = (0, $168c3f1b28052987$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $168c3f1b28052987$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $168c3f1b28052987$export$2e2bcd8739ae039).origin), (0, $168c3f1b28052987$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $168c3f1b28052987$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $ca3dc449c31f9647$export$2e2bcd8739ae039 = (0, $168c3f1b28052987$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $0775766a032c30e7$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $9934c08ba797875e$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
const $4bbba5796d5acd0b$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $4bbba5796d5acd0b$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $fc5a4f1bbeec67a0$export$6acd2efa8ac62a1b}`;
    });
}
function $4bbba5796d5acd0b$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $fc5a4f1bbeec67a0$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $fc5a4f1bbeec67a0$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$4bbba5796d5acd0b$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $4bbba5796d5acd0b$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $a06c2bc44e400798$export$2e2bcd8739ae039)(url);
        if ($4bbba5796d5acd0b$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($4bbba5796d5acd0b$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $4bbba5796d5acd0b$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $4bbba5796d5acd0b$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $0775766a032c30e7$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $4bbba5796d5acd0b$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $9934c08ba797875e$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $5bb14fb847f33f02$var$headersToObject = (thing)=>thing instanceof (0, $024894015d2d35e1$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $5bb14fb847f33f02$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $5bb14fb847f33f02$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($5bb14fb847f33f02$var$headersToObject(a), $5bb14fb847f33f02$var$headersToObject(b), prop, true)
    };
    (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach($5bb14fb847f33f02$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $2c41bd36c3ef713c$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $2c41bd36c3ef713c$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($2c41bd36c3ef713c$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ee67845d8fe44470$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ee67845d8fe44470$var$resolveConfig(config) {
    const newConfig = (0, $5bb14fb847f33f02$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $a6f70ff99505f9b3$export$2e2bcd8739ae039)((0, $4bbba5796d5acd0b$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ee67845d8fe44470$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).from(e, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFormData(data)) {
        const getHeaders = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $168c3f1b28052987$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $168c3f1b28052987$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $2c41bd36c3ef713c$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $168c3f1b28052987$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $371d168f903f3f49$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $ca3dc449c31f9647$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ee67845d8fe44470$export$2e2bcd8739ae039 = $ee67845d8fe44470$var$resolveConfig;



const $85dda5e8e7aad359$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $85dda5e8e7aad359$export$2e2bcd8739ae039 = $85dda5e8e7aad359$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ee67845d8fe44470$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $47c8581bd96d95df$export$2e2bcd8739ae039)((0, $a06c2bc44e400798$export$2e2bcd8739ae039)(_config.url)) || (0, $47c8581bd96d95df$export$2e2bcd8739ae039)((0, $168c3f1b28052987$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Request aborted', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $22ea0b2f5ec1ea9c$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Request aborted', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(msg, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $bc9be82a91ff9fe3$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ETIMEDOUT : (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach((0, $5a454e9adbd27562$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $540702b7b6a7c636$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $540702b7b6a7c636$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $b1983f36ca907598$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $47c8581bd96d95df$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $168c3f1b28052987$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $bd91f97971921cad$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039) ? err : new (0, $b1983f36ca907598$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $1ff77a601530de1d$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $bd91f97971921cad$export$2e2bcd8739ae039 = $bd91f97971921cad$var$composeSignals;


const $9ecac0f4c6ddd9d0$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $9ecac0f4c6ddd9d0$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $9ecac0f4c6ddd9d0$var$readStream(iterable))yield* $9ecac0f4c6ddd9d0$export$71b051935044bd5d(chunk, chunkSize);
};
const $9ecac0f4c6ddd9d0$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $9ecac0f4c6ddd9d0$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $9ecac0f4c6ddd9d0$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $e5d7ef3d62aa3b38$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $e5d7ef3d62aa3b38$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $e5d7ef3d62aa3b38$var$isHexDigit(str.charCodeAt(i + 1)) && $e5d7ef3d62aa3b38$var$isHexDigit(str.charCodeAt(i + 2));
const $e5d7ef3d62aa3b38$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $e5d7ef3d62aa3b38$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $e5d7ef3d62aa3b38$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $e5d7ef3d62aa3b38$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $e5d7ef3d62aa3b38$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $e5d7ef3d62aa3b38$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $e5d7ef3d62aa3b38$var$isPercentEncodedByte(body, i, len)) {
            code = $e5d7ef3d62aa3b38$var$hexValue(body.charCodeAt(i + 1)) * 16 + $e5d7ef3d62aa3b38$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($e5d7ef3d62aa3b38$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$e5d7ef3d62aa3b38$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $e5d7ef3d62aa3b38$var$estimateBase64BufferAllocation(body);
    return $e5d7ef3d62aa3b38$var$base64Bytes(significant);
};
const $e5d7ef3d62aa3b38$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $e5d7ef3d62aa3b38$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $e5d7ef3d62aa3b38$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $e5d7ef3d62aa3b38$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $e5d7ef3d62aa3b38$var$estimatePercentDecodedBase64Bytes);
}
function $e5d7ef3d62aa3b38$export$1f39e64b554a246f(url) {
    return $e5d7ef3d62aa3b38$var$estimateDataURLBytes(url, $e5d7ef3d62aa3b38$var$estimateBase64BufferAllocation);
}


const $6795b5f025102ba7$export$a4ad2735b021c132 = "1.20.0";



const $0f5983e4658a0d5c$var$DEFAULT_CHUNK_SIZE = 65536;
const $0f5983e4658a0d5c$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $0f5983e4658a0d5c$var$isFunction } = (0, $1ff77a601530de1d$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $0f5983e4658a0d5c$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $0f5983e4658a0d5c$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $0f5983e4658a0d5c$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $0f5983e4658a0d5c$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $0f5983e4658a0d5c$var$factory = (env)=>{
    const globalObject = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).global !== undefined && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).global !== null ? (0, $1ff77a601530de1d$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $0f5983e4658a0d5c$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $0f5983e4658a0d5c$var$isFunction(Request);
    const isResponseSupported = $0f5983e4658a0d5c$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $0f5983e4658a0d5c$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $0f5983e4658a0d5c$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $168c3f1b28052987$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $0f5983e4658a0d5c$var$test(()=>(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $168c3f1b28052987$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $ee67845d8fe44470$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $bd91f97971921cad$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($0f5983e4658a0d5c$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $168c3f1b28052987$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $0f5983e4658a0d5c$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $0f5983e4658a0d5c$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($0f5983e4658a0d5c$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $e5d7ef3d62aa3b38$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isReadableStream(data) || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $9ecac0f4c6ddd9d0$export$b0119225647bd83)(stream, $0f5983e4658a0d5c$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $540702b7b6a7c636$export$d9fadd12586c18d6)(requestContentLength, (0, $540702b7b6a7c636$export$c1b28109d46c3592)((0, $540702b7b6a7c636$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $6795b5f025102ba7$export$a4ad2735b021c132), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $5a454e9adbd27562$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach($0f5983e4658a0d5c$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $540702b7b6a7c636$export$d9fadd12586c18d6)(responseContentLength, (0, $540702b7b6a7c636$export$c1b28109d46c3592)((0, $540702b7b6a7c636$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $9ecac0f4c6ddd9d0$export$b0119225647bd83)(response.body, $0f5983e4658a0d5c$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $1ff77a601530de1d$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $22ea0b2f5ec1ea9c$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $024894015d2d35e1$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Network Error', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $0f5983e4658a0d5c$var$seedCache = new Map();
const $0f5983e4658a0d5c$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $0f5983e4658a0d5c$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $0f5983e4658a0d5c$var$factory(env));
        map = target;
    }
    return target;
};
const $0f5983e4658a0d5c$var$adapter = $0f5983e4658a0d5c$export$3105c6651375d4fa();
var $0f5983e4658a0d5c$export$2e2bcd8739ae039 = $0f5983e4658a0d5c$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $0d3b1d1ad4add172$var$knownAdapters = {
    http: (0, $2e668e86497372bd$export$2e2bcd8739ae039),
    xhr: (0, $85dda5e8e7aad359$export$2e2bcd8739ae039),
    fetch: {
        get: $0f5983e4658a0d5c$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach($0d3b1d1ad4add172$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $0d3b1d1ad4add172$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $0d3b1d1ad4add172$var$isResolvedHandle = (adapter)=>(0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $0d3b1d1ad4add172$var$getAdapter(adapters, config) {
    adapters = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$0d3b1d1ad4add172$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $0d3b1d1ad4add172$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($0d3b1d1ad4add172$var$renderReason).join('\n') : ' ' + $0d3b1d1ad4add172$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $0d3b1d1ad4add172$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $0d3b1d1ad4add172$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $0d3b1d1ad4add172$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $c2c3c15127693a2c$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $b1983f36ca907598$export$2e2bcd8739ae039)(null, config);
}
function $c2c3c15127693a2c$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $1ff77a601530de1d$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $c2c3c15127693a2c$var$throwIfCancellationRequested(config);
    config.headers = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from((0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $1b3623da1e3123d8$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $0d3b1d1ad4add172$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $1d0ba6bc9d1798d5$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $c2c3c15127693a2c$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $1b3623da1e3123d8$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $876d296ccb6629a5$export$2e2bcd8739ae039)(reason)) {
            $c2c3c15127693a2c$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $1b3623da1e3123d8$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $024894015d2d35e1$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
const $1a5f1c55da0af048$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1a5f1c55da0af048$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1a5f1c55da0af048$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1a5f1c55da0af048$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $6795b5f025102ba7$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1a5f1c55da0af048$var$deprecatedWarnings[opt]) {
            $1a5f1c55da0af048$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1a5f1c55da0af048$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1a5f1c55da0af048$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('options must be an object', (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1a5f1c55da0af048$export$2e2bcd8739ae039 = {
    assertOptions: $1a5f1c55da0af048$var$assertOptions,
    validators: $1a5f1c55da0af048$var$validators
};




'use strict';
const $8520570c8f9f60ca$var$validators = (0, $1a5f1c55da0af048$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $8520570c8f9f60ca$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $416377109db7a9d5$export$2e2bcd8739ae039)(),
            response: new (0, $416377109db7a9d5$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $5bb14fb847f33f02$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1a5f1c55da0af048$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $8520570c8f9f60ca$var$validators.transitional($8520570c8f9f60ca$var$validators.boolean),
            forcedJSONParsing: $8520570c8f9f60ca$var$validators.transitional($8520570c8f9f60ca$var$validators.boolean),
            clarifyTimeoutError: $8520570c8f9f60ca$var$validators.transitional($8520570c8f9f60ca$var$validators.boolean),
            legacyInterceptorReqResOrdering: $8520570c8f9f60ca$var$validators.transitional($8520570c8f9f60ca$var$validators.boolean),
            advertiseZstdAcceptEncoding: $8520570c8f9f60ca$var$validators.transitional($8520570c8f9f60ca$var$validators.boolean),
            validateStatusUndefinedResolves: $8520570c8f9f60ca$var$validators.transitional($8520570c8f9f60ca$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1a5f1c55da0af048$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $8520570c8f9f60ca$var$validators.function,
                serialize: $8520570c8f9f60ca$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1a5f1c55da0af048$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $8520570c8f9f60ca$var$validators.spelling('baseURL'),
            withXsrfToken: $8520570c8f9f60ca$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $1ff77a601530de1d$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach((0, $5c9a82e0e741c4a5$export$2e2bcd8739ae039).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $024894015d2d35e1$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $bc9be82a91ff9fe3$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $c2c3c15127693a2c$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $c2c3c15127693a2c$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $c2c3c15127693a2c$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $5bb14fb847f33f02$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $4bbba5796d5acd0b$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $a6f70ff99505f9b3$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $8520570c8f9f60ca$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $5bb14fb847f33f02$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $1ff77a601530de1d$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $1ff77a601530de1d$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $5bb14fb847f33f02$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $8520570c8f9f60ca$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $8520570c8f9f60ca$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $8520570c8f9f60ca$export$2e2bcd8739ae039 = $8520570c8f9f60ca$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $242595f87ce027dd$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $b1983f36ca907598$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $242595f87ce027dd$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $242595f87ce027dd$export$2e2bcd8739ae039 = $242595f87ce027dd$var$CancelToken;






'use strict';
function $d2ab4a92cae383e2$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $e9c1288fddd4dda2$export$2e2bcd8739ae039(payload) {
    return (0, $1ff77a601530de1d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $e60df275258f0e04$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($e60df275258f0e04$var$HttpStatusCode).forEach(([key, value])=>{
    if ($e60df275258f0e04$var$HttpStatusCode[value] === undefined) $e60df275258f0e04$var$HttpStatusCode[value] = key;
});
var $e60df275258f0e04$export$2e2bcd8739ae039 = $e60df275258f0e04$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $33a3fff7c402f495$var$createInstance(defaultConfig) {
    const context = new (0, $8520570c8f9f60ca$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $073c673664b8e57b$export$2e2bcd8739ae039)((0, $8520570c8f9f60ca$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $1ff77a601530de1d$export$2e2bcd8739ae039).extend(instance, (0, $8520570c8f9f60ca$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $1ff77a601530de1d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $33a3fff7c402f495$var$createInstance((0, $5bb14fb847f33f02$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $33a3fff7c402f495$var$axios = $33a3fff7c402f495$var$createInstance((0, $1d0ba6bc9d1798d5$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$33a3fff7c402f495$var$axios.Axios = (0, $8520570c8f9f60ca$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$33a3fff7c402f495$var$axios.CanceledError = (0, $b1983f36ca907598$export$2e2bcd8739ae039);
$33a3fff7c402f495$var$axios.CancelToken = (0, $242595f87ce027dd$export$2e2bcd8739ae039);
$33a3fff7c402f495$var$axios.isCancel = (0, $876d296ccb6629a5$export$2e2bcd8739ae039);
$33a3fff7c402f495$var$axios.VERSION = (0, $6795b5f025102ba7$export$a4ad2735b021c132);
$33a3fff7c402f495$var$axios.toFormData = (0, $5d338df60e600bf1$export$2e2bcd8739ae039);
// Expose AxiosError class
$33a3fff7c402f495$var$axios.AxiosError = (0, $fc5a4f1bbeec67a0$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$33a3fff7c402f495$var$axios.Cancel = $33a3fff7c402f495$var$axios.CanceledError;
// Expose all/spread
$33a3fff7c402f495$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$33a3fff7c402f495$var$axios.spread = (0, $d2ab4a92cae383e2$export$2e2bcd8739ae039);
// Expose isAxiosError
$33a3fff7c402f495$var$axios.isAxiosError = (0, $e9c1288fddd4dda2$export$2e2bcd8739ae039);
// Expose mergeConfig
$33a3fff7c402f495$var$axios.mergeConfig = (0, $5bb14fb847f33f02$export$2e2bcd8739ae039);
$33a3fff7c402f495$var$axios.AxiosHeaders = (0, $024894015d2d35e1$export$2e2bcd8739ae039);
$33a3fff7c402f495$var$axios.formToJSON = (thing)=>(0, $d3f8f588c1738735$export$2e2bcd8739ae039)((0, $1ff77a601530de1d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$33a3fff7c402f495$var$axios.getAdapter = (0, $0d3b1d1ad4add172$export$2e2bcd8739ae039).getAdapter;
$33a3fff7c402f495$var$axios.HttpStatusCode = (0, $e60df275258f0e04$export$2e2bcd8739ae039);
$33a3fff7c402f495$var$axios.default = $33a3fff7c402f495$var$axios;
var // this module should only have a default export
$33a3fff7c402f495$export$2e2bcd8739ae039 = $33a3fff7c402f495$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $d4d1b74a4b5d0f82$export$1c00760e9e5a4e95, AxiosError: $d4d1b74a4b5d0f82$export$c1fbed17c2f6a328, CanceledError: $d4d1b74a4b5d0f82$export$1ab0c6b20d94fa14, isCancel: $d4d1b74a4b5d0f82$export$3b22524397b493c6, CancelToken: $d4d1b74a4b5d0f82$export$fd08e3cb425f0d61, VERSION: $d4d1b74a4b5d0f82$export$a4ad2735b021c132, all: $d4d1b74a4b5d0f82$export$84bf76cd7afc7469, Cancel: $d4d1b74a4b5d0f82$export$848c9b7ead0df967, isAxiosError: $d4d1b74a4b5d0f82$export$fbafdbe06a5b5a9a, spread: $d4d1b74a4b5d0f82$export$3ae0fd4797ed47c8, toFormData: $d4d1b74a4b5d0f82$export$10ae0d317ea97f8b, AxiosHeaders: $d4d1b74a4b5d0f82$export$4e7d6ff0f3e6520, HttpStatusCode: $d4d1b74a4b5d0f82$export$a972f69c851492b3, formToJSON: $d4d1b74a4b5d0f82$export$86d7c59254d6a2c9, getAdapter: $d4d1b74a4b5d0f82$export$17ddc20a97d669e2, mergeConfig: $d4d1b74a4b5d0f82$export$7ec1ebcfa9d8bd6a, create: $d4d1b74a4b5d0f82$export$185802fd694ee1f5 } = (0, $33a3fff7c402f495$export$2e2bcd8739ae039);


const $d71ae8ab9a4e1251$var$axiosInstance = (0, $33a3fff7c402f495$export$2e2bcd8739ae039).create({
    baseURL: "https://apistage.rocketpages.io",
    withCredentials: true
});
// Add an interceptor to include the access token in the request headers
$d71ae8ab9a4e1251$var$axiosInstance.interceptors.request.use((config)=>{
    // console.log("axios instance". config)
    // const accessToken = localStorage.getItem("accessToken");
    // if (accessToken) {
    //   config.headers["Authorization"] = `Bearer ${accessToken}`;
    // }
    // config.headers["Access-Control-Allow-Origin"] = `*`;
    return config;
}, (error)=>{
    return Promise.reject(error);
});
let $d71ae8ab9a4e1251$var$isRefreshing = false;
let $d71ae8ab9a4e1251$var$pendingRequests = [];
function $d71ae8ab9a4e1251$var$onRefreshed() {
    $d71ae8ab9a4e1251$var$pendingRequests.forEach((cb)=>cb());
    $d71ae8ab9a4e1251$var$pendingRequests = [];
}
function $d71ae8ab9a4e1251$var$addPendingRequest(cb) {
    $d71ae8ab9a4e1251$var$pendingRequests.push(cb);
}
$d71ae8ab9a4e1251$var$axiosInstance.interceptors.response.use((response)=>{
    return response;
}, async (error)=>{
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes("/check-cookies")) {
        originalRequest._retry = true;
        if ($d71ae8ab9a4e1251$var$isRefreshing) return new Promise((resolve)=>{
            $d71ae8ab9a4e1251$var$addPendingRequest(()=>resolve($d71ae8ab9a4e1251$var$axiosInstance(originalRequest)));
        });
        $d71ae8ab9a4e1251$var$isRefreshing = true;
        try {
            await $d71ae8ab9a4e1251$var$axiosInstance.post("/api/check-cookies");
            $d71ae8ab9a4e1251$var$onRefreshed();
            return $d71ae8ab9a4e1251$var$axiosInstance(originalRequest);
        } catch (refreshErr) {
            $d71ae8ab9a4e1251$var$pendingRequests = [];
            return Promise.reject(refreshErr);
        } finally{
            $d71ae8ab9a4e1251$var$isRefreshing = false;
        }
    }
    return Promise.reject(error);
});
var $d71ae8ab9a4e1251$export$2e2bcd8739ae039 = $d71ae8ab9a4e1251$var$axiosInstance;



var $eeH7J = parcelRequire("eeH7J");

const $faedc0f301f1f18e$var$PasswordModal = (props)=>{
    const [isOpen, setIsOpen] = (0, $eeH7J.useState)(props.isOpen);
    const [password, setPassword] = (0, $eeH7J.useState)("");
    const [error, setError] = (0, $eeH7J.useState)("");
    const validPasswords = "rpdevs@123,rptesters@123".split(",").map((p)=>p.trim());
    const handlePasswordChange = (e)=>{
        setPassword(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (validPasswords.includes(password)) {
            setIsOpen(false);
            props.onSuccess();
        } else setError("Invalid password. Please try again.");
    };
    if (!isOpen) return null; // Modal is closed
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-100 z-50"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-white p-6 rounded-lg shadow-lg w-full max-w-sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "password",
        className: "block text-sm font-medium text-gray-700"
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        type: "password",
        id: "password",
        value: password,
        onChange: handlePasswordChange,
        className: "mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
        required: true
    })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-red-500 text-sm"
    }, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        type: "submit",
        className: "bg-catelina-blue hover:bg-catelina-blue text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-catelina-blue focus:ring-opacity-50"
    }, "Submit"))));
};
var $faedc0f301f1f18e$export$2e2bcd8739ae039 = $faedc0f301f1f18e$var$PasswordModal;






const $c534a300000c6175$export$42cfbb80f7861e77 = (props)=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const [searchParams, setSearchParams] = (0, $42e24d1152893e59$export$f1a78c17382fe22a)();
    const currentPath = location.pathname;
    const [cookies, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data",
        "rp_user_id",
        "rp_loggedin",
        "rp_internal_login"
    ]);
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    $eeH7J.useEffect(()=>{
        async function checkCookies() {
            try {
                let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/check-cookies`);
                // console.log(response);
                if (response.status === (0, $08396fcc01c9bf85$export$efd5569f873811b1).OK) {
                    setCookie("rp_user_data", JSON.stringify(response.data.userData), {
                        maxAge: 604800,
                        domain: ".rocketpages.io"
                    });
                    setCookie("rp_loggedin", true, {
                        maxAge: 604800,
                        domain: window.location.hostname.split(".").slice(1).join("."),
                        sameSite: "none",
                        secure: true,
                        path: "/"
                    });
                    setCookie("rp_user_id", response.data.userData.userId, {
                        maxAge: 604800,
                        domain: ".rocketpages.io"
                    });
                } else navigate("/login", {
                    state: {
                        removeCookies: true
                    }
                });
            } catch (err) {
                navigate("/login", {
                    state: {
                        removeCookies: true
                    }
                });
            }
        }
        if (props.skipCheckCookies === true) ;
        else if (currentPath.includes("admin")) {
            if (cookies.rp_user_data?.role !== "admin") navigate(`/404?msgType=UnAuthorizedAdmin`);
        } else if (!currentPath.includes("choose-template") && !currentPath.includes("preview")) checkCookies();
    // console.log(
    //   "currentPath",
    //   currentPath,
    //   !currentPath.includes("choose-template") &&
    //     !currentPath.includes("preview")
    // );
    }, []);
    const [anchorEl, setAnchorEl] = $eeH7J.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleLogout = ()=>{
        setAnchorEl(null);
        async function logoutUser() {
            try {
                // console.log("before.remove.cookies");
                // removeCookie("rp_user_data");
                // console.log("remove.rp_user_data",)
                // removeCookie("rp_user_id");
                // console.log("remove.rp_user_id",)
                setCookie("rp_user_data", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                setCookie("rp_loggedin", false, {
                    maxAge: 0,
                    domain: window.location.hostname.split(".").slice(1).join(".")
                });
                setCookie("rp_user_id", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/logout", {}, {
                    withCredentials: true
                });
            } catch (err) {
                console.log(err);
            }
        }
        logoutUser();
        // removeCookie("rp_access_token");
        navigate("/login", {
            state: {
                removeCookies: true
            }
        });
    // removeCookie_userData("rp_user_data");
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex h-[72px] sm:h-[64px] border-b border-neutral-300 top-0 bg-white py-2 px-2 items-center justify-between z-40 fixed w-full"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $faedc0f301f1f18e$export$2e2bcd8739ae039), {
        isOpen: cookies.rp_internal_login !== "true" && true,
        onSuccess: ()=>{
            setCookie("rp_internal_login", "true", {
                maxAge: 604800,
                domain: ".rocketpages.io"
            });
        }
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full flex flex-row justify-between"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "app-header flex flex-row items-center w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "w-[172px] mr-5 hover:cursor-pointer hidden md:block site-logo-lg",
        src: (parcelRequire("7wrxA")),
        alt: "",
        onClick: ()=>{
            navigate("/dashboard");
        }
    }), /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "mr-2 md:mr-5 hover:cursor-pointer block md:hidden site-logo-sm",
        src: (parcelRequire("b7qLs")),
        alt: "",
        onClick: ()=>{
            navigate("/dashboard");
        }
    }), props.title !== undefined && /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), {
        orientation: "vertical",
        flexItem: true
    }), props.title && props.title.startsWith("Preview") && /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            borderRadius: "4px",
            height: "32px",
            width: "32px",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>navigate("/choose-template"),
        className: "ml-2 back-to-templates"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($697efec4692ba881$exports))), {
        sx: {
            height: "20px",
            width: "20px"
        }
    })), props.title && props.title.startsWith("Choose template") && /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            borderRadius: "4px",
            height: "32px",
            width: "32px",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>navigate("/dashboard"),
        className: `ml-2 back-to-dashboard ${!cookies.rp_user_data ? "hidden" : ""}`,
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($697efec4692ba881$exports))), {
            sx: {
                height: "20px",
                width: "20px"
            }
        })
    }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        variant: "body2",
        sx: {
            fontWeight: "bold"
        }
    }, "Dashboard")), currentPath.startsWith("/account/") && /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            borderRadius: "4px",
            height: "32px",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>navigate("/dashboard"),
        className: `ml-2 back-to-dashboard ${!cookies.rp_user_data ? "hidden" : ""}`,
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($697efec4692ba881$exports))), {
            sx: {
                height: "20px",
                width: "20px"
            }
        })
    }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        variant: "body2",
        sx: {
            fontWeight: "bold"
        }
    }, "Dashboard")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex  site-name-wrapper items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("h1", {
        className: `${props.title === "Choose template" ? "choose-temp" : ""} ml-2 md:ml-5 text-catelina-blue text-lg truncate mb-0 mt-0 site-title-name `
    }, props.title), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mr-2"
    }, !props.isPreview && !!props.siteId && /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            minWidth: "unset",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            let _pageId = getQueryParam("pageId");
            let _url = `${"https://editorstage.rocketpages.io"}/${props.siteId}`;
            if (_pageId) _url += `/${_pageId}`;
            window.open(_url, "_self")?.focus();
        },
        className: "ml-2 mr-2 editsite",
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99435d3d07a9b8ca$exports))), null)
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "hidden lg:block"
    }, "Edit site")), props.isPublished && /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            minWidth: "unset",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            const url = currentPath.includes("site-settings") ? props.siteUrl : `/preview/${props.siteId}`;
            window.open(url, "_blank");
        },
        className: "previewsite",
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($68b84ea65a9d38b0$exports))), null)
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "hidden lg:block"
    }, "Preview")))), props.isPreview && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, props.colorPallets && props.selectedColorPallet && props.colorPallets.map((row)=>{
        let colorPallet = props.colorPallets.length > 0 && props.colorPallets.find((oo)=>oo.id === row.id) || null;
        // console.log("for each", colorPallet.colors);
        return colorPallet ? /*#__PURE__*/ $eeH7J.createElement("div", {
            onClick: ()=>props.onColorPaletteChange(row),
            key: row.id,
            className: `flex flex-row  hover:cursor-pointer`,
            "data-test": "pallete-button",
            "data-colors": row.colors
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `h-g w-3 md:h-6 md:w-3 block rounded-l-full ${props.selectedColorPallet.id === row.id ? "border-y border-l border-black" : "border-y border-l border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[0].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `h-3 w-3 block rounded-tr-full ${props.selectedColorPallet.id === row.id ? "border-t border-r border-black" : "border-t border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[1].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `h-3 w-3 block rounded-br-full ${props.selectedColorPallet.id === row.id ? "border-b border-r border-black" : "border-b border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[3].toLowerCase() : ""
            }
        }))) : null;
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mx-1 md:mx-2 flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            window.location.href = props.editUrl;
        // window.location.reload();
        },
        className: "hidden lg:flex edit-site",
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99435d3d07a9b8ca$exports))), null)
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "Edit site")), /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        color: "primary",
        size: "small",
        onClick: ()=>{
            window.location.href = props.editUrl;
        // window.location.reload();
        },
        className: "p-0"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99435d3d07a9b8ca$exports))), {
        sx: {
            color: "#243060",
            fontSize: 30
        },
        className: "flex lg:hidden"
    })))), /*#__PURE__*/ $eeH7J.createElement("div", {
        onClick: handleClick,
        className: `w-[30px] md:w-[36px] self-center hover:cursor-pointer ${!cookies.rp_user_data ? "hidden" : ""}`
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "userprofile",
        src: (parcelRequire("bIlHR")),
        alt: ""
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        onClick: handleClick,
        className: `self-center ${cookies.rp_user_data ? "hidden" : ""}`
    }, /*#__PURE__*/ $eeH7J.createElement((0, $6b6b8319e9394158$export$2e2bcd8739ae039), {
        onClick: ()=>{
            navigate("/login");
        },
        className: "md:flex hidden no-user",
        sx: {
            fontSize: "14px",
            color: "#243060",
            textDecoration: "none",
            cursor: "pointer",
            "&:hover": {
                color: "#fe7165",
                textDecoration: "none"
            }
        }
    }, "LOGIN"), /*#__PURE__*/ $eeH7J.createElement((0, $6b6b8319e9394158$export$2e2bcd8739ae039), {
        onClick: ()=>{
            navigate("/login");
        }
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        style: {
            width: "30px",
            maxWidth: "30px"
        },
        className: "userprofile md:hidden",
        src: (parcelRequire("bIlHR")),
        alt: ""
    })))))), /*#__PURE__*/ $eeH7J.createElement((0, $e81d86cc7ed08456$export$2e2bcd8739ae039), {
        id: "demo-positioned-menu",
        "aria-labelledby": "demo-positioned-button",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        className: "app-header-menu w-60, p-0",
        sx: {
            "& .MuiPaper-root": {
                minWidth: "258px",
                width: "258px",
                border: "1px solid rgba(36, 48, 96, 0.20)",
                boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.25)"
            },
            "& .MuiList-root": {
                padding: 0
            }
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        className: "app-header-menu-email",
        sx: {
            fontSize: "14px",
            padding: "10px",
            borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
            backgroundColor: "#e9eaef",
            whiteSpace: "break-spaces",
            lineBreak: "anywhere",
            color: "#243060",
            lineHeight: "28px",
            "&:hover": {
                color: "#243060",
                fontWeight: 700,
                backgroundColor: "#e9eaef"
            },
            "&:focus": {
                backgroundColor: "#e9eaef"
            },
            cursor: "auto"
        }
    }, cookies.rp_user_data ? cookies.rp_user_data.email : ""), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: ()=>{
            navigate("/dashboard");
        },
        className: currentPath === "/dashboard" ? "active app-header-menu-dashboard" : "app-header-menu-dashboard"
    }, "My websites"), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: ()=>{
            navigate("/account/account-settings");
        },
        className: currentPath.startsWith("/account/") ? "active app-header-menu-account" : "app-header-menu-account"
    }, "Account settings"), cookies.rp_user_data?.role === "admin" && /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: ()=>{
            navigate("/admin");
        },
        className: currentPath === "/admin" ? "active" : ""
    }, "Admin Panel"), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        className: "app-header-menu-signout",
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: handleLogout
    }, "Sign out"))));
};




var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $1IdKE = parcelRequire("1IdKE");

var $4A7Fh = parcelRequire("4A7Fh");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $e68ab388ee0cfa0f$export$29cad1383b3f235d(slot) {
    return (0, $aBqGi.default)('MuiCircularProgress', slot);
}
const $e68ab388ee0cfa0f$var$circularProgressClasses = (0, $cDqLM.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $e68ab388ee0cfa0f$export$2e2bcd8739ae039 = $e68ab388ee0cfa0f$var$circularProgressClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $1a0ab4a0aedbac74$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $1a0ab4a0aedbac74$var$_ = (t)=>t, $1a0ab4a0aedbac74$var$_t, $1a0ab4a0aedbac74$var$_t2, $1a0ab4a0aedbac74$var$_t3, $1a0ab4a0aedbac74$var$_t4;
const $1a0ab4a0aedbac74$var$SIZE = 44;
const $1a0ab4a0aedbac74$var$circularRotateKeyframe = (0, $1IdKE.keyframes)($1a0ab4a0aedbac74$var$_t || ($1a0ab4a0aedbac74$var$_t = $1a0ab4a0aedbac74$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $1a0ab4a0aedbac74$var$circularDashKeyframe = (0, $1IdKE.keyframes)($1a0ab4a0aedbac74$var$_t2 || ($1a0ab4a0aedbac74$var$_t2 = $1a0ab4a0aedbac74$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $1a0ab4a0aedbac74$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $4A7Fh.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $4A7Fh.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $e68ab388ee0cfa0f$export$29cad1383b3f235d), classes);
};
const $1a0ab4a0aedbac74$var$CircularProgressRoot = (0, $hikmr.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $4A7Fh.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $h4XE0.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $1IdKE.css)($1a0ab4a0aedbac74$var$_t3 || ($1a0ab4a0aedbac74$var$_t3 = $1a0ab4a0aedbac74$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $1a0ab4a0aedbac74$var$circularRotateKeyframe));
const $1a0ab4a0aedbac74$var$CircularProgressSVG = (0, $hikmr.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $1a0ab4a0aedbac74$var$CircularProgressCircle = (0, $hikmr.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $4A7Fh.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $h4XE0.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $1IdKE.css)($1a0ab4a0aedbac74$var$_t4 || ($1a0ab4a0aedbac74$var$_t4 = $1a0ab4a0aedbac74$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $1a0ab4a0aedbac74$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $1a0ab4a0aedbac74$var$CircularProgress = /*#__PURE__*/ $eeH7J.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $fbOaB.default)(props, $1a0ab4a0aedbac74$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $1a0ab4a0aedbac74$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($1a0ab4a0aedbac74$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $dRzna.jsx)($1a0ab4a0aedbac74$var$CircularProgressRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        style: (0, $h4XE0.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)($1a0ab4a0aedbac74$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$1a0ab4a0aedbac74$var$SIZE / 2} ${$1a0ab4a0aedbac74$var$SIZE / 2} ${$1a0ab4a0aedbac74$var$SIZE} ${$1a0ab4a0aedbac74$var$SIZE}`,
            children: /*#__PURE__*/ (0, $dRzna.jsx)($1a0ab4a0aedbac74$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $1a0ab4a0aedbac74$var$SIZE,
                cy: $1a0ab4a0aedbac74$var$SIZE,
                r: ($1a0ab4a0aedbac74$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
$1a0ab4a0aedbac74$var$CircularProgress.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'inherit',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */ disableShrink: (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool, (props)=>{
        if (props.disableShrink && props.variant && props.variant !== 'indeterminate') return new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
        return null;
    }),
    /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The thickness of the circle.
   * @default 3.6
   */ thickness: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'determinate',
        'indeterminate'
    ])
};
var $1a0ab4a0aedbac74$export$2e2bcd8739ae039 = $1a0ab4a0aedbac74$var$CircularProgress;




var $eeH7J = parcelRequire("eeH7J");

var $565dc97da8a86871$exports = {};

$parcel$export($565dc97da8a86871$exports, "container", function () { return $565dc97da8a86871$export$34e0f9847d4c02dd; }, function (v) { return $565dc97da8a86871$export$34e0f9847d4c02dd = v; });
$parcel$export($565dc97da8a86871$exports, "content", function () { return $565dc97da8a86871$export$a7db06668cad9adb; }, function (v) { return $565dc97da8a86871$export$a7db06668cad9adb = v; });
$parcel$export($565dc97da8a86871$exports, "contentContaienr", function () { return $565dc97da8a86871$export$e1d13a6871dc315e; }, function (v) { return $565dc97da8a86871$export$e1d13a6871dc315e = v; });
$parcel$export($565dc97da8a86871$exports, "desktopHeader", function () { return $565dc97da8a86871$export$4c1406428c28b179; }, function (v) { return $565dc97da8a86871$export$4c1406428c28b179 = v; });
$parcel$export($565dc97da8a86871$exports, "dontHaveAccount", function () { return $565dc97da8a86871$export$f8fc567f5297adca; }, function (v) { return $565dc97da8a86871$export$f8fc567f5297adca = v; });
$parcel$export($565dc97da8a86871$exports, "emailRow", function () { return $565dc97da8a86871$export$bc43f15dd5cb8a0f; }, function (v) { return $565dc97da8a86871$export$bc43f15dd5cb8a0f = v; });
$parcel$export($565dc97da8a86871$exports, "errorLabelForm", function () { return $565dc97da8a86871$export$3f39c3e5ae9bc769; }, function (v) { return $565dc97da8a86871$export$3f39c3e5ae9bc769 = v; });
$parcel$export($565dc97da8a86871$exports, "errorLabels", function () { return $565dc97da8a86871$export$91543e1095df11db; }, function (v) { return $565dc97da8a86871$export$91543e1095df11db = v; });
$parcel$export($565dc97da8a86871$exports, "footer", function () { return $565dc97da8a86871$export$adb608be33961c98; }, function (v) { return $565dc97da8a86871$export$adb608be33961c98 = v; });
$parcel$export($565dc97da8a86871$exports, "footerContent", function () { return $565dc97da8a86871$export$a65ca8467dbb209e; }, function (v) { return $565dc97da8a86871$export$a65ca8467dbb209e = v; });
$parcel$export($565dc97da8a86871$exports, "footerLogo", function () { return $565dc97da8a86871$export$185e4800edb7da70; }, function (v) { return $565dc97da8a86871$export$185e4800edb7da70 = v; });
$parcel$export($565dc97da8a86871$exports, "footerText", function () { return $565dc97da8a86871$export$28ad24793e431919; }, function (v) { return $565dc97da8a86871$export$28ad24793e431919 = v; });
$parcel$export($565dc97da8a86871$exports, "forgotPassword", function () { return $565dc97da8a86871$export$66791fb2cfeec3e; }, function (v) { return $565dc97da8a86871$export$66791fb2cfeec3e = v; });
$parcel$export($565dc97da8a86871$exports, "formContainer", function () { return $565dc97da8a86871$export$231ba5fc42c01d86; }, function (v) { return $565dc97da8a86871$export$231ba5fc42c01d86 = v; });
$parcel$export($565dc97da8a86871$exports, "googleIcon", function () { return $565dc97da8a86871$export$51f021792e6b0ae7; }, function (v) { return $565dc97da8a86871$export$51f021792e6b0ae7 = v; });
$parcel$export($565dc97da8a86871$exports, "googleIframeOverlay", function () { return $565dc97da8a86871$export$93477d4076a6e41d; }, function (v) { return $565dc97da8a86871$export$93477d4076a6e41d = v; });
$parcel$export($565dc97da8a86871$exports, "headerMobile", function () { return $565dc97da8a86871$export$e8d3a92df831420a; }, function (v) { return $565dc97da8a86871$export$e8d3a92df831420a = v; });
$parcel$export($565dc97da8a86871$exports, "heading", function () { return $565dc97da8a86871$export$46e4a324ac90507f; }, function (v) { return $565dc97da8a86871$export$46e4a324ac90507f = v; });
$parcel$export($565dc97da8a86871$exports, "iframecontainer", function () { return $565dc97da8a86871$export$c90f26f7157563c6; }, function (v) { return $565dc97da8a86871$export$c90f26f7157563c6 = v; });
$parcel$export($565dc97da8a86871$exports, "inputMessage", function () { return $565dc97da8a86871$export$e5d20dbf71f30862; }, function (v) { return $565dc97da8a86871$export$e5d20dbf71f30862 = v; });
$parcel$export($565dc97da8a86871$exports, "leftContent", function () { return $565dc97da8a86871$export$4efd386ebdb1e61c; }, function (v) { return $565dc97da8a86871$export$4efd386ebdb1e61c = v; });
$parcel$export($565dc97da8a86871$exports, "loginBtn", function () { return $565dc97da8a86871$export$6167bc8f980fa2a0; }, function (v) { return $565dc97da8a86871$export$6167bc8f980fa2a0 = v; });
$parcel$export($565dc97da8a86871$exports, "loginForm", function () { return $565dc97da8a86871$export$56c2ba9e13461f38; }, function (v) { return $565dc97da8a86871$export$56c2ba9e13461f38 = v; });
$parcel$export($565dc97da8a86871$exports, "loginHeading", function () { return $565dc97da8a86871$export$275c58be776b131a; }, function (v) { return $565dc97da8a86871$export$275c58be776b131a = v; });
$parcel$export($565dc97da8a86871$exports, "loginPage", function () { return $565dc97da8a86871$export$fb614e1a95434ae; }, function (v) { return $565dc97da8a86871$export$fb614e1a95434ae = v; });
$parcel$export($565dc97da8a86871$exports, "logoDark", function () { return $565dc97da8a86871$export$806275bf4bba79fb; }, function (v) { return $565dc97da8a86871$export$806275bf4bba79fb = v; });
$parcel$export($565dc97da8a86871$exports, "logoLight", function () { return $565dc97da8a86871$export$a664e2c7f2d9e237; }, function (v) { return $565dc97da8a86871$export$a664e2c7f2d9e237 = v; });
$parcel$export($565dc97da8a86871$exports, "nopadding", function () { return $565dc97da8a86871$export$c87af986af1e6201; }, function (v) { return $565dc97da8a86871$export$c87af986af1e6201 = v; });
$parcel$export($565dc97da8a86871$exports, "normalLink", function () { return $565dc97da8a86871$export$29b013babe0a235d; }, function (v) { return $565dc97da8a86871$export$29b013babe0a235d = v; });
$parcel$export($565dc97da8a86871$exports, "passwordEye", function () { return $565dc97da8a86871$export$afbd2570c0232e96; }, function (v) { return $565dc97da8a86871$export$afbd2570c0232e96 = v; });
$parcel$export($565dc97da8a86871$exports, "passwordRow", function () { return $565dc97da8a86871$export$d345983e88cc494a; }, function (v) { return $565dc97da8a86871$export$d345983e88cc494a = v; });
$parcel$export($565dc97da8a86871$exports, "primaryBtn", function () { return $565dc97da8a86871$export$1ffc6f0e16fd19e; }, function (v) { return $565dc97da8a86871$export$1ffc6f0e16fd19e = v; });
$parcel$export($565dc97da8a86871$exports, "rememberMeRow", function () { return $565dc97da8a86871$export$1d39e4c3f850a90a; }, function (v) { return $565dc97da8a86871$export$1d39e4c3f850a90a = v; });
$parcel$export($565dc97da8a86871$exports, "seperatorLine", function () { return $565dc97da8a86871$export$f9e47c0b06da0081; }, function (v) { return $565dc97da8a86871$export$f9e47c0b06da0081 = v; });
$parcel$export($565dc97da8a86871$exports, "seperatorText", function () { return $565dc97da8a86871$export$6bfc5a75cf565371; }, function (v) { return $565dc97da8a86871$export$6bfc5a75cf565371 = v; });
$parcel$export($565dc97da8a86871$exports, "signUpBtn", function () { return $565dc97da8a86871$export$b27644354e184a81; }, function (v) { return $565dc97da8a86871$export$b27644354e184a81 = v; });
$parcel$export($565dc97da8a86871$exports, "signUpText", function () { return $565dc97da8a86871$export$1c64df6ef9dd6fff; }, function (v) { return $565dc97da8a86871$export$1c64df6ef9dd6fff = v; });
$parcel$export($565dc97da8a86871$exports, "signup", function () { return $565dc97da8a86871$export$7200a869094fec36; }, function (v) { return $565dc97da8a86871$export$7200a869094fec36 = v; });
$parcel$export($565dc97da8a86871$exports, "socialIcons", function () { return $565dc97da8a86871$export$fc1c8ad213f4f5c0; }, function (v) { return $565dc97da8a86871$export$fc1c8ad213f4f5c0 = v; });
$parcel$export($565dc97da8a86871$exports, "socialSection", function () { return $565dc97da8a86871$export$fafcfcc0f83b9fbc; }, function (v) { return $565dc97da8a86871$export$fafcfcc0f83b9fbc = v; });
$parcel$export($565dc97da8a86871$exports, "subHeading", function () { return $565dc97da8a86871$export$628dc1c0324367d; }, function (v) { return $565dc97da8a86871$export$628dc1c0324367d = v; });
var $565dc97da8a86871$export$34e0f9847d4c02dd;
var $565dc97da8a86871$export$a7db06668cad9adb;
var $565dc97da8a86871$export$e1d13a6871dc315e;
var $565dc97da8a86871$export$4c1406428c28b179;
var $565dc97da8a86871$export$f8fc567f5297adca;
var $565dc97da8a86871$export$bc43f15dd5cb8a0f;
var $565dc97da8a86871$export$3f39c3e5ae9bc769;
var $565dc97da8a86871$export$91543e1095df11db;
var $565dc97da8a86871$export$adb608be33961c98;
var $565dc97da8a86871$export$a65ca8467dbb209e;
var $565dc97da8a86871$export$185e4800edb7da70;
var $565dc97da8a86871$export$28ad24793e431919;
var $565dc97da8a86871$export$66791fb2cfeec3e;
var $565dc97da8a86871$export$231ba5fc42c01d86;
var $565dc97da8a86871$export$51f021792e6b0ae7;
var $565dc97da8a86871$export$93477d4076a6e41d;
var $565dc97da8a86871$export$e8d3a92df831420a;
var $565dc97da8a86871$export$46e4a324ac90507f;
var $565dc97da8a86871$export$c90f26f7157563c6;
var $565dc97da8a86871$export$e5d20dbf71f30862;
var $565dc97da8a86871$export$4efd386ebdb1e61c;
var $565dc97da8a86871$export$6167bc8f980fa2a0;
var $565dc97da8a86871$export$56c2ba9e13461f38;
var $565dc97da8a86871$export$275c58be776b131a;
var $565dc97da8a86871$export$fb614e1a95434ae;
var $565dc97da8a86871$export$806275bf4bba79fb;
var $565dc97da8a86871$export$a664e2c7f2d9e237;
var $565dc97da8a86871$export$c87af986af1e6201;
var $565dc97da8a86871$export$29b013babe0a235d;
var $565dc97da8a86871$export$afbd2570c0232e96;
var $565dc97da8a86871$export$d345983e88cc494a;
var $565dc97da8a86871$export$1ffc6f0e16fd19e;
var $565dc97da8a86871$export$1d39e4c3f850a90a;
var $565dc97da8a86871$export$f9e47c0b06da0081;
var $565dc97da8a86871$export$6bfc5a75cf565371;
var $565dc97da8a86871$export$b27644354e184a81;
var $565dc97da8a86871$export$1c64df6ef9dd6fff;
var $565dc97da8a86871$export$7200a869094fec36;
var $565dc97da8a86871$export$fc1c8ad213f4f5c0;
var $565dc97da8a86871$export$fafcfcc0f83b9fbc;
var $565dc97da8a86871$export$628dc1c0324367d;
$565dc97da8a86871$export$34e0f9847d4c02dd = `GWlAxG_container`;
$565dc97da8a86871$export$a7db06668cad9adb = `GWlAxG_content`;
$565dc97da8a86871$export$e1d13a6871dc315e = `GWlAxG_contentContaienr`;
$565dc97da8a86871$export$4c1406428c28b179 = `GWlAxG_desktopHeader`;
$565dc97da8a86871$export$f8fc567f5297adca = `GWlAxG_dontHaveAccount`;
$565dc97da8a86871$export$bc43f15dd5cb8a0f = `GWlAxG_emailRow`;
$565dc97da8a86871$export$3f39c3e5ae9bc769 = `GWlAxG_errorLabelForm`;
$565dc97da8a86871$export$91543e1095df11db = `GWlAxG_errorLabels`;
$565dc97da8a86871$export$adb608be33961c98 = `GWlAxG_footer`;
$565dc97da8a86871$export$a65ca8467dbb209e = `GWlAxG_footerContent`;
$565dc97da8a86871$export$185e4800edb7da70 = `GWlAxG_footerLogo`;
$565dc97da8a86871$export$28ad24793e431919 = `GWlAxG_footerText`;
$565dc97da8a86871$export$66791fb2cfeec3e = `GWlAxG_forgotPassword`;
$565dc97da8a86871$export$231ba5fc42c01d86 = `GWlAxG_formContainer`;
$565dc97da8a86871$export$51f021792e6b0ae7 = `GWlAxG_googleIcon`;
$565dc97da8a86871$export$93477d4076a6e41d = `GWlAxG_googleIframeOverlay`;
$565dc97da8a86871$export$e8d3a92df831420a = `GWlAxG_headerMobile`;
$565dc97da8a86871$export$46e4a324ac90507f = `GWlAxG_heading`;
$565dc97da8a86871$export$c90f26f7157563c6 = `GWlAxG_iframecontainer`;
$565dc97da8a86871$export$e5d20dbf71f30862 = `GWlAxG_inputMessage`;
$565dc97da8a86871$export$4efd386ebdb1e61c = `GWlAxG_leftContent`;
$565dc97da8a86871$export$6167bc8f980fa2a0 = `GWlAxG_loginBtn`;
$565dc97da8a86871$export$56c2ba9e13461f38 = `GWlAxG_loginForm`;
$565dc97da8a86871$export$275c58be776b131a = `GWlAxG_loginHeading`;
$565dc97da8a86871$export$fb614e1a95434ae = `GWlAxG_loginPage`;
$565dc97da8a86871$export$806275bf4bba79fb = `GWlAxG_logoDark`;
$565dc97da8a86871$export$a664e2c7f2d9e237 = `GWlAxG_logoLight`;
$565dc97da8a86871$export$c87af986af1e6201 = `GWlAxG_nopadding`;
$565dc97da8a86871$export$29b013babe0a235d = `GWlAxG_normalLink`;
$565dc97da8a86871$export$afbd2570c0232e96 = `GWlAxG_passwordEye`;
$565dc97da8a86871$export$d345983e88cc494a = `GWlAxG_passwordRow`;
$565dc97da8a86871$export$1ffc6f0e16fd19e = `GWlAxG_primaryBtn`;
$565dc97da8a86871$export$1d39e4c3f850a90a = `GWlAxG_rememberMeRow`;
$565dc97da8a86871$export$f9e47c0b06da0081 = `GWlAxG_seperatorLine`;
$565dc97da8a86871$export$6bfc5a75cf565371 = `GWlAxG_seperatorText`;
$565dc97da8a86871$export$b27644354e184a81 = `GWlAxG_signUpBtn`;
$565dc97da8a86871$export$1c64df6ef9dd6fff = `GWlAxG_signUpText`;
$565dc97da8a86871$export$7200a869094fec36 = `GWlAxG_signup`;
$565dc97da8a86871$export$fc1c8ad213f4f5c0 = `GWlAxG_socialIcons`;
$565dc97da8a86871$export$fafcfcc0f83b9fbc = `GWlAxG_socialSection`;
$565dc97da8a86871$export$628dc1c0324367d = `GWlAxG_subHeading`;


function $a33a1bed5691b2ee$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}





const $a33a1bed5691b2ee$var$Footer = ()=>{
    const isInIframe = $a33a1bed5691b2ee$var$checkIsInFrame();
    const date = new Date();
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("footer", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).footer}`
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).footerContent} flex justify-between flex-col`
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `flex justify-between items-center mb-4 lg:mb-0 flex-row`
    }, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "/",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).footerLogo}`,
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("/", "_blank");
            }
        }
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("khR9j")),
        alt: "",
        className: "hidden sm:block"
    }), /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("8bMoi")),
        alt: "",
        className: "block sm:hidden w-full h-full"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).footerText} hidden lg:block px-4`
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, " ", "\xa9 ", date.getFullYear(), " RocketPages. All Rights Reserved"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "hidden md:inline mx-2"
    }, "|"), /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/terms-and-conditions",
        className: "text-white no-underline",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/terms-and-conditions", "_blank");
            }
        }
    }, "Terms And Conditions"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "hidden md:inline mx-2"
    }, "|"), /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/privacy-policy",
        className: "text-white no-underline",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/privacy-policy", "_blank");
            }
        }
    }, "Privacy Policy")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).footerSocials} flex`
    }, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://www.facebook.com/RocketPagesIO",
        target: "_blank",
        className: "mr-2"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("9stpi")),
        className: "h-[16px]",
        alt: "facebook"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://twitter.com/RocketPagesIO",
        target: "_blank",
        className: "mr-2"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("Y75fz")),
        className: "h-[16px]",
        alt: "twitter"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://www.linkedin.com/company/rocketpages",
        target: "_blank"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("762CQ")),
        className: "h-[16px]",
        alt: "linkedin"
    })))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `GWlAxG_footerText flex justify-center items-center flex-wrap footer-div lg:hidden md:flex`
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "\xa9 ", date.getFullYear(), " RocketPages. All Rights Reserved"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "mx-2 pipe-1"
    }, "|"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "flex justify-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/terms-and-conditions",
        className: "text-white",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/terms-and-conditions", "_blank");
            }
        }
    }, "Terms And Conditions"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "mx-2"
    }, "|"), /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/privacy-policy",
        className: "text-white",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/privacy-policy", "_blank");
            }
        }
    }, "Privacy Policy"))))));
};
var $a33a1bed5691b2ee$export$2e2bcd8739ae039 = $a33a1bed5691b2ee$var$Footer;



var $eeH7J = parcelRequire("eeH7J");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $doIAf = parcelRequire("doIAf");

var $er6YD = parcelRequire("er6YD");
function $e521f0af82ff26b4$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
/**
 * @ignore - internal component.
 */ const $1a83cd45c3caaab4$var$FormControlContext = /*#__PURE__*/ $eeH7J.createContext(undefined);
$1a83cd45c3caaab4$var$FormControlContext.displayName = 'FormControlContext';
var $1a83cd45c3caaab4$export$2e2bcd8739ae039 = $1a83cd45c3caaab4$var$FormControlContext;


'use client';
function $09caf452de208040$export$2e2bcd8739ae039() {
    return $eeH7J.useContext((0, $1a83cd45c3caaab4$export$2e2bcd8739ae039));
}



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");



var $4A7Fh = parcelRequire("4A7Fh");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $b7b7e9b77840ba26$export$f7d501e40371cd17(slot) {
    return (0, $aBqGi.default)('MuiFormLabel', slot);
}
const $b7b7e9b77840ba26$var$formLabelClasses = (0, $cDqLM.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $b7b7e9b77840ba26$export$2e2bcd8739ae039 = $b7b7e9b77840ba26$var$formLabelClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $faae92272120b083$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $faae92272120b083$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4A7Fh.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $b7b7e9b77840ba26$export$f7d501e40371cd17), classes);
};
const $faae92272120b083$export$aa5bc7f8a4705b27 = (0, $hikmr.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $h4XE0.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $b7b7e9b77840ba26$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $b7b7e9b77840ba26$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $b7b7e9b77840ba26$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $faae92272120b083$var$AsteriskComponent = (0, $hikmr.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $b7b7e9b77840ba26$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $faae92272120b083$var$FormLabel = /*#__PURE__*/ $eeH7J.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $fbOaB.default)(props, $faae92272120b083$var$_excluded);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $faae92272120b083$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsxs)($faae92272120b083$export$aa5bc7f8a4705b27, (0, $h4XE0.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $dRzna.jsxs)($faae92272120b083$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
$faae92272120b083$var$FormLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'error',
            'info',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the label should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $faae92272120b083$export$2e2bcd8739ae039 = $faae92272120b083$var$FormLabel;



var $lNnGW = parcelRequire("lNnGW");

var $4A7Fh = parcelRequire("4A7Fh");

var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $93b6d89cd6c4aa39$export$c1c4b4545ad2ea5f(slot) {
    return (0, $aBqGi.default)('MuiInputLabel', slot);
}
const $93b6d89cd6c4aa39$var$inputLabelClasses = (0, $cDqLM.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $93b6d89cd6c4aa39$export$2e2bcd8739ae039 = $93b6d89cd6c4aa39$var$inputLabelClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $d2dab3d7ad9c072d$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $d2dab3d7ad9c072d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $4A7Fh.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $93b6d89cd6c4aa39$export$c1c4b4545ad2ea5f), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $d2dab3d7ad9c072d$var$InputLabelRoot = (0, $hikmr.default)((0, $faae92272120b083$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $b7b7e9b77840ba26$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $h4XE0.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $h4XE0.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $h4XE0.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $d2dab3d7ad9c072d$var$InputLabel = /*#__PURE__*/ $eeH7J.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $fbOaB.default)(props, $d2dab3d7ad9c072d$var$_excluded);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $h4XE0.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $d2dab3d7ad9c072d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($d2dab3d7ad9c072d$var$InputLabelRoot, (0, $h4XE0.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $er6YD.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
$d2dab3d7ad9c072d$var$InputLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'error',
            'info',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, the transition animation is disabled.
   * @default false
   */ disableAnimation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` of this label is focused.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense'
    ]),
    /**
   * if `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is shrunk.
   */ shrink: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The size of the component.
   * @default 'normal'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'normal',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $d2dab3d7ad9c072d$export$2e2bcd8739ae039 = $d2dab3d7ad9c072d$var$InputLabel;




var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $8cf7c1bf494d1a32$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $8cf7c1bf494d1a32$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($8cf7c1bf494d1a32$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $8cf7c1bf494d1a32$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $8cf7c1bf494d1a32$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $4A7Fh = parcelRequire("4A7Fh");

var $eeH7J = parcelRequire("eeH7J");
function $35512b8bc3b3845d$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $eeH7J.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $05fb9323992d79ee$export$2e2bcd8739ae039 = (0, $35512b8bc3b3845d$export$2e2bcd8739ae039);




var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $be02e7f91a61462c$export$149c8b8bab2289d1(slot) {
    return (0, $aBqGi.default)('MuiFormControl', slot);
}
const $be02e7f91a61462c$var$formControlClasses = (0, $cDqLM.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $be02e7f91a61462c$export$2e2bcd8739ae039 = $be02e7f91a61462c$var$formControlClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $4eba357c98d07975$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $4eba357c98d07975$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $4A7Fh.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $be02e7f91a61462c$export$149c8b8bab2289d1), classes);
};
const $4eba357c98d07975$var$FormControlRoot = (0, $hikmr.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $h4XE0.default)({}, styles.root, styles[`margin${(0, $4A7Fh.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $4eba357c98d07975$var$FormControl = /*#__PURE__*/ $eeH7J.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $fbOaB.default)(props, $4eba357c98d07975$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $4eba357c98d07975$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $eeH7J.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $eeH7J.Children.forEach(children, (child)=>{
            if (!(0, $05fb9323992d79ee$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $05fb9323992d79ee$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $8cf7c1bf494d1a32$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $eeH7J.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $eeH7J.Children.forEach(children, (child)=>{
            if (!(0, $05fb9323992d79ee$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $8cf7c1bf494d1a32$export$d652b828d7fdeff8)(child.props, true) || (0, $8cf7c1bf494d1a32$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $eeH7J.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const registeredInput = $eeH7J.useRef(false);
        registerEffect = ()=>{
            if (registeredInput.current) console.error([
                'MUI: There are multiple `InputBase` components inside a FormControl.',
                'This creates visual inconsistencies, only use one `InputBase`.'
            ].join('\n'));
            registeredInput.current = true;
            return ()=>{
                registeredInput.current = false;
            };
        };
    }
    const childContext = $eeH7J.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $1a83cd45c3caaab4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($4eba357c98d07975$var$FormControlRoot, (0, $h4XE0.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $er6YD.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
$4eba357c98d07975$var$FormControl.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is displayed in focused state.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $4eba357c98d07975$export$2e2bcd8739ae039 = $4eba357c98d07975$var$FormControl;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $gvqxq = parcelRequire("gvqxq");


var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");


var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $eeH7J = parcelRequire("eeH7J");
'use client';
let $cb6186ed251df147$var$globalId = 0;
function $cb6186ed251df147$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $eeH7J.useState(idOverride);
    const id = idOverride || defaultId;
    $eeH7J.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $cb6186ed251df147$var$globalId += 1;
            setDefaultId(`mui-${$cb6186ed251df147$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $cb6186ed251df147$var$maybeReactUseId = $eeH7J['useId'.toString()];
function $cb6186ed251df147$export$2e2bcd8739ae039(idOverride) {
    if ($cb6186ed251df147$var$maybeReactUseId !== undefined) {
        const reactId = $cb6186ed251df147$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $cb6186ed251df147$var$useGlobalId(idOverride);
}





var $4A7Fh = parcelRequire("4A7Fh");


var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $4A7Fh = parcelRequire("4A7Fh");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $503c61a2f914be3d$export$1ee13051fd9e2ab5(slot) {
    return (0, $aBqGi.default)('MuiNativeSelect', slot);
}
const $503c61a2f914be3d$var$nativeSelectClasses = (0, $cDqLM.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $503c61a2f914be3d$export$2e2bcd8739ae039 = $503c61a2f914be3d$var$nativeSelectClasses;



var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $dRzna = parcelRequire("dRzna");
'use client';
const $758e2234047994ae$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $758e2234047994ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $4A7Fh.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $503c61a2f914be3d$export$1ee13051fd9e2ab5), classes);
};
const $758e2234047994ae$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $h4XE0.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $h4XE0.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $503c61a2f914be3d$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $758e2234047994ae$var$NativeSelectSelect = (0, $hikmr.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $lzlXq.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $503c61a2f914be3d$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($758e2234047994ae$export$c1eccd1617458c87);
const $758e2234047994ae$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $h4XE0.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $503c61a2f914be3d$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $758e2234047994ae$var$NativeSelectIcon = (0, $hikmr.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4A7Fh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($758e2234047994ae$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $758e2234047994ae$var$NativeSelectInput = /*#__PURE__*/ $eeH7J.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $fbOaB.default)(props, $758e2234047994ae$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $758e2234047994ae$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)($758e2234047994ae$var$NativeSelectSelect, (0, $h4XE0.default)({
                ownerState: ownerState,
                className: (0, $er6YD.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $dRzna.jsx)($758e2234047994ae$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
$758e2234047994ae$var$NativeSelectInput.propTypes = {
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the select is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType.isRequired,
    /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * @ignore
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $758e2234047994ae$export$2e2bcd8739ae039 = $758e2234047994ae$var$NativeSelectInput;




var $hikmr = parcelRequire("hikmr");
var $jXkrt = parcelRequire("jXkrt");


var $eeH7J = parcelRequire("eeH7J");
'use client';
function $bcd4f903766661d9$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $eeH7J.useRef(controlled !== undefined);
    const [valueState, setValue] = $eeH7J.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    {
        $eeH7J.useEffect(()=>{
            if (isControlled !== (controlled !== undefined)) console.error([
                `MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`,
                'Elements should not switch from uncontrolled to controlled (or vice versa).',
                `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.',
                "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
                'More info: https://fb.me/react-controlled-components'
            ].join('\n'));
        }, [
            state,
            name,
            controlled
        ]);
        const { current: defaultValue } = $eeH7J.useRef(defaultProp);
        $eeH7J.useEffect(()=>{
            if (!isControlled && !Object.is(defaultValue, defaultProp)) console.error([
                `MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`
            ].join('\n'));
        }, [
            JSON.stringify(defaultProp)
        ]);
    }
    const setValueIfUncontrolled = $eeH7J.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $7a2443d826ebcf5f$export$2e2bcd8739ae039 = (0, $bcd4f903766661d9$export$2e2bcd8739ae039);



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $7a2ed5c3522b8252$export$2c0c1ee5a3392e(slot) {
    return (0, $aBqGi.default)('MuiSelect', slot);
}
const $7a2ed5c3522b8252$var$selectClasses = (0, $cDqLM.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $7a2ed5c3522b8252$export$2e2bcd8739ae039 = $7a2ed5c3522b8252$var$selectClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
var $ef07c8ab706bbfac$var$_span;
const $ef07c8ab706bbfac$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $ef07c8ab706bbfac$var$SelectSelect = (0, $hikmr.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $7a2ed5c3522b8252$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $7a2ed5c3522b8252$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $7a2ed5c3522b8252$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $7a2ed5c3522b8252$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $758e2234047994ae$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $7a2ed5c3522b8252$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $ef07c8ab706bbfac$var$SelectIcon = (0, $hikmr.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4A7Fh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $758e2234047994ae$export$e7a817afd12a40d0));
const $ef07c8ab706bbfac$var$SelectNativeInput = (0, $hikmr.default)('input', {
    shouldForwardProp: (prop)=>(0, $jXkrt.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $ef07c8ab706bbfac$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $ef07c8ab706bbfac$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $ef07c8ab706bbfac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $4A7Fh.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $7a2ed5c3522b8252$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $ef07c8ab706bbfac$var$SelectInput = /*#__PURE__*/ $eeH7J.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $fbOaB.default)(props, $ef07c8ab706bbfac$var$_excluded);
    const [value, setValueState] = (0, $7a2443d826ebcf5f$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $7a2443d826ebcf5f$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $eeH7J.useRef(null);
    const displayRef = $eeH7J.useRef(null);
    const [displayNode, setDisplayNode] = $eeH7J.useState(null);
    const { current: isOpenControlled } = $eeH7J.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $eeH7J.useState();
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $eeH7J.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $eeH7J.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $eeH7J.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $eeH7J.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $eeH7J.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $420c0ad55da0a5b0$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $eeH7J.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $8cf7c1bf494d1a32$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(child)) return null;
        if ((0, $631d1dee154373e2$exports.isFragment)(child)) console.error([
            "MUI: The Select component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error(`MUI: The \`value\` prop must be an array when using the \`Select\` component with \`multiple\`.`);
            selected = value.some((v)=>$ef07c8ab706bbfac$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $ef07c8ab706bbfac$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $eeH7J.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useEffect(()=>{
        if (!foundMatch && !multiple && value !== '') {
            const values = childrenArray.map((child)=>child.props.value);
            console.warn([
                `MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ''}component.`,
                "Consider providing a value that matches one of the available options or ''.",
                `The available values are ${values.filter((x)=>x != null).map((x)=>`\`${x}\``).join(', ') || '""'}.`
            ].join('\n'));
        }
    }, [
        foundMatch,
        childrenArray,
        multiple,
        name,
        value
    ]);
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $h4XE0.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $ef07c8ab706bbfac$var$useUtilityClasses(ownerState);
    const paperProps = (0, $h4XE0.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $cb6186ed251df147$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)($ef07c8ab706bbfac$var$SelectSelect, (0, $h4XE0.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $er6YD.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $ef07c8ab706bbfac$var$isEmpty(display) ? $ef07c8ab706bbfac$var$_span || ($ef07c8ab706bbfac$var$_span = /*#__PURE__*/ (0, $dRzna.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $dRzna.jsx)($ef07c8ab706bbfac$var$SelectNativeInput, (0, $h4XE0.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $dRzna.jsx)($ef07c8ab706bbfac$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $dRzna.jsx)((0, $e81d86cc7ed08456$export$2e2bcd8739ae039), (0, $h4XE0.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $h4XE0.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $h4XE0.default)({}, MenuProps.slotProps, {
                    paper: (0, $h4XE0.default)({}, paperProps, {
                        style: (0, $h4XE0.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
$ef07c8ab706bbfac$var$SelectInput.propTypes = {
    /**
   * @ignore
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * If `true`, the select is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the selected item is displayed even if its value is empty.
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType.isRequired,
    /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $ef07c8ab706bbfac$export$2e2bcd8739ae039 = $ef07c8ab706bbfac$var$SelectInput;




parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $bf88178f405e8e9c$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $doIAf = parcelRequire("doIAf");

var $gvqxq = parcelRequire("gvqxq");


var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");


var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");



var $doIAf = parcelRequire("doIAf");


var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");


var $dRzna = parcelRequire("dRzna");
'use client';
const $307aaf083a1f80fb$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $307aaf083a1f80fb$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $307aaf083a1f80fb$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $307aaf083a1f80fb$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $307aaf083a1f80fb$var$isEmpty(obj) {
    return $307aaf083a1f80fb$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $307aaf083a1f80fb$var$TextareaAutosize = /*#__PURE__*/ $eeH7J.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $fbOaB.default)(props, $307aaf083a1f80fb$var$_excluded);
    const { current: isControlled } = $eeH7J.useRef(value != null);
    const textareaRef = $eeH7J.useRef(null);
    const handleRef = (0, $c909b21db041accd$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $eeH7J.useRef(null);
    const hiddenTextareaRef = $eeH7J.useRef(null);
    const calculateTextareaStyles = $eeH7J.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $2433ad996f7c2542$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $307aaf083a1f80fb$var$getStyleValue(computedStyle.paddingBottom) + $307aaf083a1f80fb$var$getStyleValue(computedStyle.paddingTop);
        const border = $307aaf083a1f80fb$var$getStyleValue(computedStyle.borderBottomWidth) + $307aaf083a1f80fb$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $208bf4215efa66ac$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $307aaf083a1f80fb$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $eeH7J.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $307aaf083a1f80fb$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $eeH7J.useRef(-1);
    (0, $27c0fbde361ccc36$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $09427fb55d2cb2eb$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $2433ad996f7c2542$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $27c0fbde361ccc36$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)("textarea", (0, $h4XE0.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $dRzna.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $h4XE0.default)({}, $307aaf083a1f80fb$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
$307aaf083a1f80fb$var$TextareaAutosize.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Maximum number of rows to display.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Minimum number of rows to display.
   * @default 1
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $307aaf083a1f80fb$export$2e2bcd8739ae039 = $307aaf083a1f80fb$var$TextareaAutosize;






var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $4A7Fh = parcelRequire("4A7Fh");



var $h4XE0 = parcelRequire("h4XE0");
parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");
parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $hNMeS = parcelRequire("hNMeS");
var $jKjg1 = parcelRequire("jKjg1");


var $dRzna = parcelRequire("dRzna");
'use client';
function $00048fed6c8dfb5f$var$wrapGlobalLayer(styles) {
    const serialized = (0, $jKjg1.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $00048fed6c8dfb5f$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $f08d602dd3ba2736$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $00048fed6c8dfb5f$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $00048fed6c8dfb5f$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $00048fed6c8dfb5f$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $hNMeS.default), {
        styles: globalStyles
    });
}
$00048fed6c8dfb5f$var$GlobalStyles.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ defaultTheme: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ]),
    /**
   * @ignore
   */ themeId: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
};
var $00048fed6c8dfb5f$export$2e2bcd8739ae039 = $00048fed6c8dfb5f$var$GlobalStyles;



var $xHBjO = parcelRequire("xHBjO");

var $4hHwC = parcelRequire("4hHwC");

var $dRzna = parcelRequire("dRzna");
'use client';
function $13952113bf83de66$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $00048fed6c8dfb5f$export$2e2bcd8739ae039), (0, $h4XE0.default)({}, props, {
        defaultTheme: (0, $xHBjO.default),
        themeId: (0, $4hHwC.default)
    }));
}
$13952113bf83de66$var$GlobalStyles.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The styles you want to apply globally.
   */ styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ])
};
var $13952113bf83de66$export$2e2bcd8739ae039 = $13952113bf83de66$var$GlobalStyles;




var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d9e977ec13806e5b$export$ef57d5c8ca2278f6(slot) {
    return (0, $aBqGi.default)('MuiInputBase', slot);
}
const $d9e977ec13806e5b$var$inputBaseClasses = (0, $cDqLM.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $d9e977ec13806e5b$export$2e2bcd8739ae039 = $d9e977ec13806e5b$var$inputBaseClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $c4e46cd08af6d9f1$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $c4e46cd08af6d9f1$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $4A7Fh.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $c4e46cd08af6d9f1$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $c4e46cd08af6d9f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4A7Fh.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $4A7Fh.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $d9e977ec13806e5b$export$ef57d5c8ca2278f6), classes);
};
const $c4e46cd08af6d9f1$export$298a043133d72a38 = (0, $hikmr.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $c4e46cd08af6d9f1$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $d9e977ec13806e5b$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $h4XE0.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $c4e46cd08af6d9f1$export$a1ad29c901026019 = (0, $hikmr.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $c4e46cd08af6d9f1$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $h4XE0.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $h4XE0.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $d9e977ec13806e5b$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $d9e977ec13806e5b$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $c4e46cd08af6d9f1$var$inputGlobalStyles = /*#__PURE__*/ (0, $dRzna.jsx)((0, $13952113bf83de66$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $c4e46cd08af6d9f1$var$InputBase = /*#__PURE__*/ $eeH7J.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $fbOaB.default)(props, $c4e46cd08af6d9f1$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $eeH7J.useRef(value != null);
    const inputRef = $eeH7J.useRef();
    const handleInputRefWarning = $eeH7J.useCallback((instance)=>{
        if (instance && instance.nodeName !== 'INPUT' && !instance.focus) console.error([
            'MUI: You have provided a `inputComponent` to the input component',
            'that does not correctly handle the `ref` prop.',
            'Make sure the `ref` prop is called with a HTMLInputElement.'
        ].join('\n'));
    }, []);
    const handleInputRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $eeH7J.useState(false);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useEffect(()=>{
        if (muiFormControl) return muiFormControl.registerEffect();
        return undefined;
    }, [
        muiFormControl
    ]);
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $eeH7J.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $eeH7J.useCallback((obj)=>{
        if ((0, $8cf7c1bf494d1a32$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $caa7ff66ed2b6d13$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error(`MUI: Expected valid input target. Did you use a custom \`inputComponent\` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.`);
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $eeH7J.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) {
            if (minRows || maxRows) console.warn('MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
            inputProps = (0, $h4XE0.default)({
                type: undefined,
                minRows: rows,
                maxRows: rows
            }, inputProps);
        } else inputProps = (0, $h4XE0.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $307aaf083a1f80fb$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $eeH7J.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $c4e46cd08af6d9f1$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $c4e46cd08af6d9f1$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $c4e46cd08af6d9f1$export$a1ad29c901026019;
    inputProps = (0, $h4XE0.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $c4e46cd08af6d9f1$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $dRzna.jsxs)(Root, (0, $h4XE0.default)({}, rootProps, !(0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $h4XE0.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $er6YD.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $dRzna.jsx)((0, $1a83cd45c3caaab4$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $dRzna.jsx)(Input, (0, $h4XE0.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $h4XE0.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $er6YD.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $h4XE0.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
$c4e46cd08af6d9f1$var$InputBase.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */ disableInjectingGlobalStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, $542b1840e0c5cf64$export$2e2bcd8739ae039),
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */ onInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ renderSuffix: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The size of the component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
var $c4e46cd08af6d9f1$export$2e2bcd8739ae039 = $c4e46cd08af6d9f1$var$InputBase;



var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $lNnGW = parcelRequire("lNnGW");

var $h4XE0 = parcelRequire("h4XE0");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");

function $4daf76d563854cac$export$cdb270390122322b(slot) {
    return (0, $aBqGi.default)('MuiInput', slot);
}
const $4daf76d563854cac$var$inputClasses = (0, $h4XE0.default)({}, (0, $d9e977ec13806e5b$export$2e2bcd8739ae039), (0, $cDqLM.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $4daf76d563854cac$export$2e2bcd8739ae039 = $4daf76d563854cac$var$inputClasses;




var $dRzna = parcelRequire("dRzna");
'use client';
const $efff8c52466ed18b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $efff8c52466ed18b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $4daf76d563854cac$export$cdb270390122322b), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $efff8c52466ed18b$var$InputRoot = (0, $hikmr.default)((0, $c4e46cd08af6d9f1$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $c4e46cd08af6d9f1$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $h4XE0.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $4daf76d563854cac$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $4daf76d563854cac$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $4daf76d563854cac$export$2e2bcd8739ae039).disabled}, .${(0, $4daf76d563854cac$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $4daf76d563854cac$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $efff8c52466ed18b$var$InputInput = (0, $hikmr.default)((0, $c4e46cd08af6d9f1$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $c4e46cd08af6d9f1$export$cf507b112810e72d)
})({});
const $efff8c52466ed18b$var$Input = /*#__PURE__*/ $eeH7J.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $fbOaB.default)(props, $efff8c52466ed18b$var$_excluded);
    const classes = $efff8c52466ed18b$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $gvqxq.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $efff8c52466ed18b$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $efff8c52466ed18b$var$InputInput;
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $c4e46cd08af6d9f1$export$2e2bcd8739ae039), (0, $h4XE0.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$efff8c52466ed18b$var$Input.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
$efff8c52466ed18b$var$Input.muiName = 'Input';
var $efff8c52466ed18b$export$2e2bcd8739ae039 = $efff8c52466ed18b$var$Input;




var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $gvqxq = parcelRequire("gvqxq");


var $4yBem = parcelRequire("4yBem");

var $doIAf = parcelRequire("doIAf");


var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $lNnGW = parcelRequire("lNnGW");

var $h4XE0 = parcelRequire("h4XE0");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");

function $27c0ad4049c378c0$export$3331e419f1a48437(slot) {
    return (0, $aBqGi.default)('MuiFilledInput', slot);
}
const $27c0ad4049c378c0$var$filledInputClasses = (0, $h4XE0.default)({}, (0, $d9e977ec13806e5b$export$2e2bcd8739ae039), (0, $cDqLM.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $27c0ad4049c378c0$export$2e2bcd8739ae039 = $27c0ad4049c378c0$var$filledInputClasses;




var $dRzna = parcelRequire("dRzna");
'use client';
const $1452bd953890770b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $1452bd953890770b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $27c0ad4049c378c0$export$3331e419f1a48437), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $1452bd953890770b$var$FilledInputRoot = (0, $hikmr.default)((0, $c4e46cd08af6d9f1$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $c4e46cd08af6d9f1$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $h4XE0.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $27c0ad4049c378c0$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $27c0ad4049c378c0$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $27c0ad4049c378c0$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $27c0ad4049c378c0$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $27c0ad4049c378c0$export$2e2bcd8739ae039).disabled}, .${(0, $27c0ad4049c378c0$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $27c0ad4049c378c0$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $h4XE0.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $1452bd953890770b$var$FilledInputInput = (0, $hikmr.default)((0, $c4e46cd08af6d9f1$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $c4e46cd08af6d9f1$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $1452bd953890770b$var$FilledInput = /*#__PURE__*/ $eeH7J.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $fbOaB.default)(props, $1452bd953890770b$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $1452bd953890770b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $gvqxq.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $1452bd953890770b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $1452bd953890770b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $c4e46cd08af6d9f1$export$2e2bcd8739ae039), (0, $h4XE0.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$1452bd953890770b$var$FilledInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the input will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
$1452bd953890770b$var$FilledInput.muiName = 'Input';
var $1452bd953890770b$export$2e2bcd8739ae039 = $1452bd953890770b$var$FilledInput;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");


var $doIAf = parcelRequire("doIAf");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");
parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $dRzna = parcelRequire("dRzna");
'use client';
var $f1e2296d416f0162$var$_span;
const $f1e2296d416f0162$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $f1e2296d416f0162$var$NotchedOutlineRoot = (0, $hikmr.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $lzlXq.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $f1e2296d416f0162$var$NotchedOutlineLegend = (0, $hikmr.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $lzlXq.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $h4XE0.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $h4XE0.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $f1e2296d416f0162$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $fbOaB.default)(props, $f1e2296d416f0162$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $h4XE0.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $dRzna.jsx)($f1e2296d416f0162$var$NotchedOutlineRoot, (0, $h4XE0.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)($f1e2296d416f0162$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $dRzna.jsx)("span", {
                children: label
            }) : $f1e2296d416f0162$var$_span || ($f1e2296d416f0162$var$_span = /*#__PURE__*/ (0, $dRzna.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}
$f1e2296d416f0162$export$2e2bcd8739ae039.propTypes = {
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The label.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool.isRequired,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};





var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $h4XE0 = parcelRequire("h4XE0");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");

function $3b2a6c76c6ae101a$export$89922944c7227687(slot) {
    return (0, $aBqGi.default)('MuiOutlinedInput', slot);
}
const $3b2a6c76c6ae101a$var$outlinedInputClasses = (0, $h4XE0.default)({}, (0, $d9e977ec13806e5b$export$2e2bcd8739ae039), (0, $cDqLM.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $3b2a6c76c6ae101a$export$2e2bcd8739ae039 = $3b2a6c76c6ae101a$var$outlinedInputClasses;




var $lNnGW = parcelRequire("lNnGW");

var $dRzna = parcelRequire("dRzna");
'use client';
const $b1e7c35c0ae18844$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $b1e7c35c0ae18844$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $3b2a6c76c6ae101a$export$89922944c7227687), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $b1e7c35c0ae18844$var$OutlinedInputRoot = (0, $hikmr.default)((0, $c4e46cd08af6d9f1$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $c4e46cd08af6d9f1$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $h4XE0.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).focused} .${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).error} .${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).disabled} .${(0, $3b2a6c76c6ae101a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $h4XE0.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $b1e7c35c0ae18844$var$NotchedOutlineRoot = (0, $hikmr.default)((0, $f1e2296d416f0162$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $b1e7c35c0ae18844$var$OutlinedInputInput = (0, $hikmr.default)((0, $c4e46cd08af6d9f1$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $c4e46cd08af6d9f1$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $b1e7c35c0ae18844$var$OutlinedInput = /*#__PURE__*/ $eeH7J.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $fbOaB.default)(props, $b1e7c35c0ae18844$var$_excluded);
    const classes = $b1e7c35c0ae18844$var$useUtilityClasses(props);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $b1e7c35c0ae18844$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $b1e7c35c0ae18844$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $c4e46cd08af6d9f1$export$2e2bcd8739ae039), (0, $h4XE0.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $dRzna.jsx)($b1e7c35c0ae18844$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $h4XE0.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$b1e7c35c0ae18844$var$OutlinedInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
$b1e7c35c0ae18844$var$OutlinedInput.muiName = 'Input';
var $b1e7c35c0ae18844$export$2e2bcd8739ae039 = $b1e7c35c0ae18844$var$OutlinedInput;



var $lNnGW = parcelRequire("lNnGW");


var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $dRzna = parcelRequire("dRzna");
'use client';
const $79a0d4fc41924020$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $79a0d4fc41924020$var$_excluded2 = [
    "root"
];
const $79a0d4fc41924020$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $79a0d4fc41924020$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $79a0d4fc41924020$var$StyledInput = (0, $hikmr.default)((0, $efff8c52466ed18b$export$2e2bcd8739ae039), $79a0d4fc41924020$var$styledRootConfig)('');
const $79a0d4fc41924020$var$StyledOutlinedInput = (0, $hikmr.default)((0, $b1e7c35c0ae18844$export$2e2bcd8739ae039), $79a0d4fc41924020$var$styledRootConfig)('');
const $79a0d4fc41924020$var$StyledFilledInput = (0, $hikmr.default)((0, $1452bd953890770b$export$2e2bcd8739ae039), $79a0d4fc41924020$var$styledRootConfig)('');
const $79a0d4fc41924020$var$Select = /*#__PURE__*/ $eeH7J.forwardRef(function Select(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $bf88178f405e8e9c$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $fbOaB.default)(props, $79a0d4fc41924020$var$_excluded);
    const inputComponent = native ? (0, $758e2234047994ae$export$2e2bcd8739ae039) : (0, $ef07c8ab706bbfac$export$2e2bcd8739ae039);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $h4XE0.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $79a0d4fc41924020$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $fbOaB.default)(classes, $79a0d4fc41924020$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $dRzna.jsx)($79a0d4fc41924020$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $dRzna.jsx)($79a0d4fc41924020$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $dRzna.jsx)($79a0d4fc41924020$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(ref, (0, $4b19d09ce79e7470$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $dRzna.jsx)($eeH7J.Fragment, {
        children: /*#__PURE__*/ $eeH7J.cloneElement(InputComponent, (0, $h4XE0.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $h4XE0.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $h4XE0.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $gvqxq.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $er6YD.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$79a0d4fc41924020$var$Select.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   * @default {}
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */ input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */ native: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            ''
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
$79a0d4fc41924020$var$Select.muiName = 'Select';
var $79a0d4fc41924020$export$2e2bcd8739ae039 = $79a0d4fc41924020$var$Select;


function $3fb1cc9123a3eb67$export$2e2bcd8739ae039(props) {
    const handleChange = (event)=>{
        const { target: { value: value } } = event;
        props.handleChange(value);
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", null, /*#__PURE__*/ $eeH7J.createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        sx: {
            width: 280
        },
        size: "small"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $d2dab3d7ad9c072d$export$2e2bcd8739ae039), {
        id: "demo-simple-select-label",
        className: "text-catelina-blue text-base"
    }, "Sections"), /*#__PURE__*/ $eeH7J.createElement((0, $79a0d4fc41924020$export$2e2bcd8739ae039), {
        labelId: "demo-simple-select-label",
        id: "demo-simple-select",
        label: "Sections",
        value: props.category,
        onChange: handleChange,
        className: "text-base text-sm"
    }, props.items.map((item, index)=>/*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
            sx: {
                fontSize: '16px'
            },
            value: item,
            key: index
        }, item)))));
}



var $eeH7J = parcelRequire("eeH7J");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $eeH7J = parcelRequire("eeH7J");
'use client';
/**
 * @ignore - internal component.
 */ const $a2c30165fea5a178$var$TableContext = /*#__PURE__*/ $eeH7J.createContext();
$a2c30165fea5a178$var$TableContext.displayName = 'TableContext';
var $a2c30165fea5a178$export$2e2bcd8739ae039 = $a2c30165fea5a178$var$TableContext;



var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $bc0a383256c63f7f$export$315cb19215f77ce0(slot) {
    return (0, $aBqGi.default)('MuiTable', slot);
}
const $bc0a383256c63f7f$var$tableClasses = (0, $cDqLM.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $bc0a383256c63f7f$export$2e2bcd8739ae039 = $bc0a383256c63f7f$var$tableClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $b1559ea0fc0c104d$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $b1559ea0fc0c104d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $bc0a383256c63f7f$export$315cb19215f77ce0), classes);
};
const $b1559ea0fc0c104d$var$TableRoot = (0, $hikmr.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $h4XE0.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $b1559ea0fc0c104d$var$defaultComponent = 'table';
const $b1559ea0fc0c104d$var$Table = /*#__PURE__*/ $eeH7J.forwardRef(function Table(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $b1559ea0fc0c104d$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $fbOaB.default)(props, $b1559ea0fc0c104d$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $b1559ea0fc0c104d$var$useUtilityClasses(ownerState);
    const table = $eeH7J.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $a2c30165fea5a178$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($b1559ea0fc0c104d$var$TableRoot, (0, $h4XE0.default)({
            as: component,
            role: component === $b1559ea0fc0c104d$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $er6YD.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
$b1559ea0fc0c104d$var$Table.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */ padding: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'checkbox',
        'none',
        'normal'
    ]),
    /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */ stickyHeader: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $b1559ea0fc0c104d$export$2e2bcd8739ae039 = $b1559ea0fc0c104d$var$Table;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $eeH7J = parcelRequire("eeH7J");
/**
 * @ignore - internal component.
 */ const $fc7f7430de2993f8$var$Tablelvl2Context = /*#__PURE__*/ $eeH7J.createContext();
$fc7f7430de2993f8$var$Tablelvl2Context.displayName = 'Tablelvl2Context';
var $fc7f7430de2993f8$export$2e2bcd8739ae039 = $fc7f7430de2993f8$var$Tablelvl2Context;



var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $8ee3748ee5b5a917$export$98bd2a9b566ec665(slot) {
    return (0, $aBqGi.default)('MuiTableBody', slot);
}
const $8ee3748ee5b5a917$var$tableBodyClasses = (0, $cDqLM.default)('MuiTableBody', [
    'root'
]);
var $8ee3748ee5b5a917$export$2e2bcd8739ae039 = $8ee3748ee5b5a917$var$tableBodyClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $3b671b494e02bd1f$var$_excluded = [
    "className",
    "component"
];
const $3b671b494e02bd1f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $8ee3748ee5b5a917$export$98bd2a9b566ec665), classes);
};
const $3b671b494e02bd1f$var$TableBodyRoot = (0, $hikmr.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $3b671b494e02bd1f$var$tablelvl2 = {
    variant: 'body'
};
const $3b671b494e02bd1f$var$defaultComponent = 'tbody';
const $3b671b494e02bd1f$var$TableBody = /*#__PURE__*/ $eeH7J.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $3b671b494e02bd1f$var$defaultComponent } = props, other = (0, $fbOaB.default)(props, $3b671b494e02bd1f$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component
    });
    const classes = $3b671b494e02bd1f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $fc7f7430de2993f8$export$2e2bcd8739ae039).Provider, {
        value: $3b671b494e02bd1f$var$tablelvl2,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($3b671b494e02bd1f$var$TableBodyRoot, (0, $h4XE0.default)({
            className: (0, $er6YD.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $3b671b494e02bd1f$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
$3b671b494e02bd1f$var$TableBody.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $3b671b494e02bd1f$export$2e2bcd8739ae039 = $3b671b494e02bd1f$var$TableBody;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $4A7Fh = parcelRequire("4A7Fh");



var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $56e4da359d46102a$export$33a0f07a16a10b1b(slot) {
    return (0, $aBqGi.default)('MuiTableCell', slot);
}
const $56e4da359d46102a$var$tableCellClasses = (0, $cDqLM.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $56e4da359d46102a$export$2e2bcd8739ae039 = $56e4da359d46102a$var$tableCellClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $aae95013bbaee822$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $aae95013bbaee822$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $4A7Fh.default)(align)}`,
            padding !== 'normal' && `padding${(0, $4A7Fh.default)(padding)}`,
            `size${(0, $4A7Fh.default)(size)}`
        ]
    };
    return (0, $doIAf.default)(slots, (0, $56e4da359d46102a$export$33a0f07a16a10b1b), classes);
};
const $aae95013bbaee822$var$TableCellRoot = (0, $hikmr.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $4A7Fh.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $4A7Fh.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $4A7Fh.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $5YtKS.lighten)((0, $5YtKS.alpha)(theme.palette.divider, 1), 0.88) : (0, $5YtKS.darken)((0, $5YtKS.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $56e4da359d46102a$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $aae95013bbaee822$var$TableCell = /*#__PURE__*/ $eeH7J.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $fbOaB.default)(props, $aae95013bbaee822$var$_excluded);
    const table = $eeH7J.useContext((0, $a2c30165fea5a178$export$2e2bcd8739ae039));
    const tablelvl2 = $eeH7J.useContext((0, $fc7f7430de2993f8$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $h4XE0.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $aae95013bbaee822$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $dRzna.jsx)($aae95013bbaee822$var$TableCellRoot, (0, $h4XE0.default)({
        as: component,
        ref: ref,
        className: (0, $er6YD.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
$aae95013bbaee822$var$TableCell.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'center',
        'inherit',
        'justify',
        'left',
        'right'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */ padding: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'checkbox',
        'none',
        'normal'
    ]),
    /**
   * Set scope attribute.
   */ scope: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Set aria-sort direction.
   */ sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'asc',
        'desc',
        false
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'body',
            'footer',
            'head'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $aae95013bbaee822$export$2e2bcd8739ae039 = $aae95013bbaee822$var$TableCell;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $6965180563f7ad3f$export$eed427986a7abdf9(slot) {
    return (0, $aBqGi.default)('MuiTableContainer', slot);
}
const $6965180563f7ad3f$var$tableContainerClasses = (0, $cDqLM.default)('MuiTableContainer', [
    'root'
]);
var $6965180563f7ad3f$export$2e2bcd8739ae039 = $6965180563f7ad3f$var$tableContainerClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $70cd81359a2961cc$var$_excluded = [
    "className",
    "component"
];
const $70cd81359a2961cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $6965180563f7ad3f$export$eed427986a7abdf9), classes);
};
const $70cd81359a2961cc$var$TableContainerRoot = (0, $hikmr.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $70cd81359a2961cc$var$TableContainer = /*#__PURE__*/ $eeH7J.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $fbOaB.default)(props, $70cd81359a2961cc$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component
    });
    const classes = $70cd81359a2961cc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($70cd81359a2961cc$var$TableContainerRoot, (0, $h4XE0.default)({
        ref: ref,
        as: component,
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
$70cd81359a2961cc$var$TableContainer.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Table`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $70cd81359a2961cc$export$2e2bcd8739ae039 = $70cd81359a2961cc$var$TableContainer;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");


var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $bab1db0e73db3842$export$2e731cea2d1c2392(slot) {
    return (0, $aBqGi.default)('MuiTableHead', slot);
}
const $bab1db0e73db3842$var$tableHeadClasses = (0, $cDqLM.default)('MuiTableHead', [
    'root'
]);
var $bab1db0e73db3842$export$2e2bcd8739ae039 = $bab1db0e73db3842$var$tableHeadClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $9875ccd06eebee4b$var$_excluded = [
    "className",
    "component"
];
const $9875ccd06eebee4b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $bab1db0e73db3842$export$2e731cea2d1c2392), classes);
};
const $9875ccd06eebee4b$var$TableHeadRoot = (0, $hikmr.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $9875ccd06eebee4b$var$tablelvl2 = {
    variant: 'head'
};
const $9875ccd06eebee4b$var$defaultComponent = 'thead';
const $9875ccd06eebee4b$var$TableHead = /*#__PURE__*/ $eeH7J.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $9875ccd06eebee4b$var$defaultComponent } = props, other = (0, $fbOaB.default)(props, $9875ccd06eebee4b$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component
    });
    const classes = $9875ccd06eebee4b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $fc7f7430de2993f8$export$2e2bcd8739ae039).Provider, {
        value: $9875ccd06eebee4b$var$tablelvl2,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($9875ccd06eebee4b$var$TableHeadRoot, (0, $h4XE0.default)({
            as: component,
            className: (0, $er6YD.default)(classes.root, className),
            ref: ref,
            role: component === $9875ccd06eebee4b$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
$9875ccd06eebee4b$var$TableHead.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $9875ccd06eebee4b$export$2e2bcd8739ae039 = $9875ccd06eebee4b$var$TableHead;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");


var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d30678ee4508d074$export$ba0a6d6c28940107(slot) {
    return (0, $aBqGi.default)('MuiTableRow', slot);
}
const $d30678ee4508d074$var$tableRowClasses = (0, $cDqLM.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $d30678ee4508d074$export$2e2bcd8739ae039 = $d30678ee4508d074$var$tableRowClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $99390616b17525fb$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $99390616b17525fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $d30678ee4508d074$export$ba0a6d6c28940107), classes);
};
const $99390616b17525fb$var$TableRowRoot = (0, $hikmr.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $d30678ee4508d074$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $d30678ee4508d074$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $5YtKS.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $5YtKS.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $99390616b17525fb$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $99390616b17525fb$var$TableRow = /*#__PURE__*/ $eeH7J.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $99390616b17525fb$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $fbOaB.default)(props, $99390616b17525fb$var$_excluded);
    const tablelvl2 = $eeH7J.useContext((0, $fc7f7430de2993f8$export$2e2bcd8739ae039));
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $99390616b17525fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($99390616b17525fb$var$TableRowRoot, (0, $h4XE0.default)({
        as: component,
        ref: ref,
        className: (0, $er6YD.default)(classes.root, className),
        role: component === $99390616b17525fb$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
$99390616b17525fb$var$TableRow.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Should be valid `<tr>` children such as `TableCell`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the table row will shade on hover.
   * @default false
   */ hover: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $99390616b17525fb$export$2e2bcd8739ae039 = $99390616b17525fb$var$TableRow;






var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");
function $de137779e6107095$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $de137779e6107095$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $de137779e6107095$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $de137779e6107095$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $de137779e6107095$export$2e2bcd8739ae039 = $de137779e6107095$export$4f5d2d50c9deca37;



var $jKjg1 = parcelRequire("jKjg1");

var $zC31W = parcelRequire("zC31W");
var $hZDOg = parcelRequire("hZDOg");


var $dRzna = parcelRequire("dRzna");
'use client';
const $666a96d2040382dd$var$_excluded = [
    "className",
    "component"
];
function $666a96d2040382dd$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $jKjg1.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $zC31W.default));
    const Box = /*#__PURE__*/ $eeH7J.forwardRef(function Box(inProps, ref) {
        const theme = (0, $f08d602dd3ba2736$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $hZDOg.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $fbOaB.default)(_extendSxProp, $666a96d2040382dd$var$_excluded);
        return /*#__PURE__*/ (0, $dRzna.jsx)(BoxRoot, (0, $h4XE0.default)({
            as: component,
            ref: ref,
            className: (0, $de137779e6107095$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}



var $4yBem = parcelRequire("4yBem");

var $4hO9G = parcelRequire("4hO9G");

var $26mQo = parcelRequire("26mQo");

var $4hHwC = parcelRequire("4hHwC");

var $cDqLM = parcelRequire("cDqLM");
const $1c2835a4cbf1d5ea$var$boxClasses = (0, $cDqLM.default)('MuiBox', [
    'root'
]);
var $1c2835a4cbf1d5ea$export$2e2bcd8739ae039 = $1c2835a4cbf1d5ea$var$boxClasses;


'use client';
const $7ec185bb4d6c4f83$var$defaultTheme = (0, $26mQo.default)();
const $7ec185bb4d6c4f83$var$Box = (0, $666a96d2040382dd$export$2e2bcd8739ae039)({
    themeId: (0, $4hHwC.default),
    defaultTheme: $7ec185bb4d6c4f83$var$defaultTheme,
    defaultClassName: (0, $1c2835a4cbf1d5ea$export$2e2bcd8739ae039).root,
    generateClassName: (0, $4hO9G.default).generate
});
$7ec185bb4d6c4f83$var$Box.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $7ec185bb4d6c4f83$export$2e2bcd8739ae039 = $7ec185bb4d6c4f83$var$Box;





var $eeH7J = parcelRequire("eeH7J");

function $8247dc0908a27868$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $8247dc0908a27868$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $8247dc0908a27868$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $8247dc0908a27868$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8247dc0908a27868$export$2e2bcd8739ae039 = $8247dc0908a27868$export$4f5d2d50c9deca37;


let $4897c7cff1037b66$var$e = {
    data: ""
}, $4897c7cff1037b66$var$t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || $4897c7cff1037b66$var$e;
}, $4897c7cff1037b66$export$54aba348a7896325 = (e)=>{
    let r = $4897c7cff1037b66$var$t(e), a = r.data;
    return r.data = "", a;
}, $4897c7cff1037b66$var$a = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $4897c7cff1037b66$var$l = /\/\*[^]*?\*\/|  +/g, $4897c7cff1037b66$var$n = /\n+/g, $4897c7cff1037b66$var$o = (e, t)=>{
    let r = "", a = "", l = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : a += "f" == n[1] ? $4897c7cff1037b66$var$o(c, n) : n + "{" + $4897c7cff1037b66$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? a += $4897c7cff1037b66$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = "-" == n[1] ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), l += $4897c7cff1037b66$var$o.p ? $4897c7cff1037b66$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && l ? t + "{" + l + "}" : l) + a;
}, $4897c7cff1037b66$var$c = {}, $4897c7cff1037b66$var$i = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $4897c7cff1037b66$var$i(e[r]);
        return t;
    }
    return e;
}, $4897c7cff1037b66$var$s = (e, t, r, s, p)=>{
    let u = $4897c7cff1037b66$var$i(e), d = $4897c7cff1037b66$var$c[u] || ($4897c7cff1037b66$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$4897c7cff1037b66$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $4897c7cff1037b66$var$a.exec(e.replace($4897c7cff1037b66$var$l, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($4897c7cff1037b66$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($4897c7cff1037b66$var$n, " ").trim();
            return o[0];
        })(e);
        $4897c7cff1037b66$var$c[d] = $4897c7cff1037b66$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $4897c7cff1037b66$var$c.g;
    return r && ($4897c7cff1037b66$var$c.g = $4897c7cff1037b66$var$c[d]), ((e, t, r, a)=>{
        a ? t.data = t.data.replace(a, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($4897c7cff1037b66$var$c[d], t, s, f), d;
}, $4897c7cff1037b66$var$p = (e, t, r)=>e.reduce((e, a, l)=>{
        let n = t[l];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $4897c7cff1037b66$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + a + (null == n ? "" : n);
    }, "");
function $4897c7cff1037b66$export$dbf350e5966cf602(e) {
    let r = this || {}, a = e.call ? e(r.p) : e;
    return $4897c7cff1037b66$var$s(a.unshift ? a.raw ? $4897c7cff1037b66$var$p(a, [].slice.call(arguments, 1), r.p) : a.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : a, $4897c7cff1037b66$var$t(r.target), r.g, r.o, r.k);
}
let $4897c7cff1037b66$var$d, $4897c7cff1037b66$var$f, $4897c7cff1037b66$var$g, $4897c7cff1037b66$export$442f1a04865e4790 = $4897c7cff1037b66$export$dbf350e5966cf602.bind({
    g: 1
}), $4897c7cff1037b66$export$d25ddfdf17c3ad3e = $4897c7cff1037b66$export$dbf350e5966cf602.bind({
    k: 1
});
function $4897c7cff1037b66$export$de27182ff8187d6c(e, t, r, a) {
    $4897c7cff1037b66$var$o.p = t, $4897c7cff1037b66$var$d = e, $4897c7cff1037b66$var$f = r, $4897c7cff1037b66$var$g = a;
}
function $4897c7cff1037b66$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let a = arguments;
        function l(n, o) {
            let c = Object.assign({}, n), i = c.className || l.className;
            r.p = Object.assign({
                theme: $4897c7cff1037b66$var$f && $4897c7cff1037b66$var$f()
            }, c), r.o = /go\d/.test(i), c.className = $4897c7cff1037b66$export$dbf350e5966cf602.apply(r, a) + (i ? " " + i : ""), t && (c.ref = o);
            let s = e;
            return e[0] && (s = c.as || e, delete c.as), $4897c7cff1037b66$var$g && s[0] && $4897c7cff1037b66$var$g(c), $4897c7cff1037b66$var$d(s, c);
        }
        return t ? t(l) : l;
    };
}


function $4ff4ed24117608da$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4ff4ed24117608da$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4ff4ed24117608da$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4ff4ed24117608da$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4ff4ed24117608da$var$_extends() {
    $4ff4ed24117608da$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4ff4ed24117608da$var$_extends.apply(this, arguments);
}
function $4ff4ed24117608da$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $4ff4ed24117608da$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4ff4ed24117608da$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $4ff4ed24117608da$var$noOp = function noOp() {
    return '';
};
var $4ff4ed24117608da$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext({
    enqueueSnackbar: $4ff4ed24117608da$var$noOp,
    closeSnackbar: $4ff4ed24117608da$var$noOp
});
var $4ff4ed24117608da$var$breakpoints = {
    downXs: '@media (max-width:599.95px)',
    upSm: '@media (min-width:600px)'
};
var $4ff4ed24117608da$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $4ff4ed24117608da$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $4ff4ed24117608da$var$capitalise(anchor.vertical) + $4ff4ed24117608da$var$capitalise(anchor.horizontal);
};
var $4ff4ed24117608da$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $4ff4ed24117608da$var$UNMOUNTED = 'unmounted';
var $4ff4ed24117608da$var$EXITED = 'exited';
var $4ff4ed24117608da$var$ENTERING = 'entering';
var $4ff4ed24117608da$var$ENTERED = 'entered';
var $4ff4ed24117608da$var$EXITING = 'exiting';
var $4ff4ed24117608da$export$be58926105124dd4 = /*#__PURE__*/ function(_React$Component) {
    $4ff4ed24117608da$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $4ff4ed24117608da$var$EXITED;
                _this.appearStatus = $4ff4ed24117608da$var$ENTERING;
            } else initialStatus = $4ff4ed24117608da$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $4ff4ed24117608da$var$UNMOUNTED;
        else initialStatus = $4ff4ed24117608da$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $4ff4ed24117608da$var$UNMOUNTED) return {
            status: $4ff4ed24117608da$var$EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $4ff4ed24117608da$var$ENTERING && status !== $4ff4ed24117608da$var$ENTERED) nextStatus = $4ff4ed24117608da$var$ENTERING;
            } else if (status === $4ff4ed24117608da$var$ENTERING || status === $4ff4ed24117608da$var$ENTERED) nextStatus = $4ff4ed24117608da$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === $4ff4ed24117608da$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $4ff4ed24117608da$var$EXITED) this.setState({
            status: $4ff4ed24117608da$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: $4ff4ed24117608da$var$ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: $4ff4ed24117608da$var$ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: $4ff4ed24117608da$var$ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $4ff4ed24117608da$var$EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: $4ff4ed24117608da$var$EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $4ff4ed24117608da$var$EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $4ff4ed24117608da$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $4ff4ed24117608da$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    $4ff4ed24117608da$var$_createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error('notistack - Custom snackbar is not refForwarding');
                return node;
            }
        }
    ]);
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
function $4ff4ed24117608da$var$noop() {}
$4ff4ed24117608da$export$be58926105124dd4.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $4ff4ed24117608da$var$noop,
    onEntering: $4ff4ed24117608da$var$noop,
    onEntered: $4ff4ed24117608da$var$noop,
    onExit: $4ff4ed24117608da$var$noop,
    onExiting: $4ff4ed24117608da$var$noop,
    onExited: $4ff4ed24117608da$var$noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $4ff4ed24117608da$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $4ff4ed24117608da$var$useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, $eeH7J.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            $4ff4ed24117608da$var$setRef(refA, refValue);
            $4ff4ed24117608da$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $4ff4ed24117608da$var$getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $4ff4ed24117608da$var$defaultEasing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */ var $4ff4ed24117608da$var$reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var $4ff4ed24117608da$var$formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function $4ff4ed24117608da$var$createTransition(props, options) {
    if (props === void 0) props = [
        'all'
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? $4ff4ed24117608da$var$defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === 'string' ? duration : $4ff4ed24117608da$var$formatMs(duration);
        var formattedDelay = typeof delay === 'string' ? delay : $4ff4ed24117608da$var$formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(',');
}
function $4ff4ed24117608da$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function $4ff4ed24117608da$var$ownerWindow(node) {
    var doc = $4ff4ed24117608da$var$ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function $4ff4ed24117608da$var$debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function $4ff4ed24117608da$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = $4ff4ed24117608da$var$ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case 'left':
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case 'right':
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case 'up':
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function $4ff4ed24117608da$var$setTranslateValue(direction, node) {
    if (!node) return;
    var transform = $4ff4ed24117608da$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $4ff4ed24117608da$var$Slide = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = $4ff4ed24117608da$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, $eeH7J.useRef)(null);
    var handleRefIntermediary = $4ff4ed24117608da$var$useForkRef(children.ref, nodeRef);
    var handleRef = $4ff4ed24117608da$var$useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        $4ff4ed24117608da$var$setTranslateValue(direction, node);
        $4ff4ed24117608da$var$reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $4ff4ed24117608da$var$defaultEasing.easeOut;
        var transitionProps = $4ff4ed24117608da$var$getTransitionProps({
            timeout: timeout,
            mode: 'enter',
            style: $4ff4ed24117608da$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $4ff4ed24117608da$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $4ff4ed24117608da$var$createTransition('transform', transitionProps);
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $4ff4ed24117608da$var$defaultEasing.sharp;
        var transitionProps = $4ff4ed24117608da$var$getTransitionProps({
            timeout: timeout,
            mode: 'exit',
            style: $4ff4ed24117608da$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $4ff4ed24117608da$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $4ff4ed24117608da$var$createTransition('transform', transitionProps);
        $4ff4ed24117608da$var$setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    };
    var updatePosition = (0, $eeH7J.useCallback)(function() {
        if (nodeRef.current) $4ff4ed24117608da$var$setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, $eeH7J.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = $4ff4ed24117608da$var$debounce(function() {
            if (nodeRef.current) $4ff4ed24117608da$var$setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = $4ff4ed24117608da$var$ownerWindow(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, $eeH7J.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, $eeH7J.createElement)($4ff4ed24117608da$export$be58926105124dd4, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, $eeH7J.cloneElement)(children, $4ff4ed24117608da$var$_extends({
            ref: handleRef,
            style: $4ff4ed24117608da$var$_extends({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
$4ff4ed24117608da$var$Slide.displayName = 'Slide';
var $4ff4ed24117608da$var$SvgIcon = function SvgIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0
        }
    }, props));
};
var $4ff4ed24117608da$var$CheckIcon = function CheckIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $4ff4ed24117608da$var$WarningIcon = function WarningIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $4ff4ed24117608da$var$ErrorIcon = function ErrorIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $4ff4ed24117608da$var$InfoIcon = function InfoIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $4ff4ed24117608da$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$CheckIcon, null),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$WarningIcon, null),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$ErrorIcon, null),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$InfoIcon, null)
};
var $4ff4ed24117608da$var$defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: 'default',
    autoHideDuration: 5000,
    iconVariant: $4ff4ed24117608da$var$defaultIconVariants,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    TransitionComponent: $4ff4ed24117608da$var$Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $4ff4ed24117608da$var$getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === 'number' || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return $4ff4ed24117608da$var$defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $4ff4ed24117608da$var$getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        'string',
        'number'
    ])) return optionsDuration;
    if (is(optionsDuration, [
        'object'
    ])) return $4ff4ed24117608da$var$_extends({}, $4ff4ed24117608da$var$defaults.transitionDuration, {}, is(propsDuration, [
        'object'
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        'string',
        'number'
    ])) return propsDuration;
    if (is(propsDuration, [
        'object'
    ])) return $4ff4ed24117608da$var$_extends({}, $4ff4ed24117608da$var$defaults.transitionDuration, {}, propsDuration);
    return $4ff4ed24117608da$var$defaults.transitionDuration;
};
var $4ff4ed24117608da$var$merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return $4ff4ed24117608da$var$_extends({}, $4ff4ed24117608da$var$defaults[name], {}, props[name], {}, options[name]);
        if (name === 'autoHideDuration') return $4ff4ed24117608da$var$getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === 'transitionDuration') return $4ff4ed24117608da$var$getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || $4ff4ed24117608da$var$defaults[name];
    };
};
function $4ff4ed24117608da$var$makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return $4ff4ed24117608da$var$_extends({}, acc, (_extends2 = {}, _extends2[key] = (0, $4897c7cff1037b66$export$dbf350e5966cf602)(value), _extends2));
    }, {});
}
var $4ff4ed24117608da$var$ComponentClasses = {
    SnackbarContainer: 'notistack-SnackbarContainer',
    Snackbar: 'notistack-Snackbar',
    CollapseWrapper: 'notistack-CollapseWrapper',
    MuiContent: 'notistack-MuiContent',
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var $4ff4ed24117608da$var$classes = /*#__PURE__*/ $4ff4ed24117608da$var$makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: 'auto'
    }
});
var $4ff4ed24117608da$var$collapsedSize = '0px';
var $4ff4ed24117608da$var$timeout = 175;
var $4ff4ed24117608da$var$Collapse = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, $eeH7J.useRef)(null);
    var nodeRef = (0, $eeH7J.useRef)(null);
    var handleRef = $4ff4ed24117608da$var$useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = $4ff4ed24117608da$var$collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = $4ff4ed24117608da$var$getTransitionProps({
            timeout: $4ff4ed24117608da$var$timeout,
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || '';
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = 'auto';
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        $4ff4ed24117608da$var$reflow(node);
        var _getTransitionProps2 = $4ff4ed24117608da$var$getTransitionProps({
            timeout: $4ff4ed24117608da$var$timeout,
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = $4ff4ed24117608da$var$collapsedSize;
        node.style.transitionTimingFunction = easing || '';
    };
    return (0, $eeH7J.createElement)($4ff4ed24117608da$export$be58926105124dd4, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: $4ff4ed24117608da$var$timeout
    }, function(state, childProps) {
        return (0, $eeH7J.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)($4ff4ed24117608da$var$classes.root, state === 'entered' && $4ff4ed24117608da$var$classes.entered),
            style: $4ff4ed24117608da$var$_extends({
                pointerEvents: 'all',
                overflow: 'hidden',
                minHeight: $4ff4ed24117608da$var$collapsedSize,
                transition: $4ff4ed24117608da$var$createTransition('height')
            }, state === 'entered' && {
                overflow: 'visible'
            }, {}, state === 'exited' && !inProp && {
                visibility: 'hidden'
            })
        }, childProps), (0, $eeH7J.createElement)("div", {
            ref: wrapperRef,
            className: $4ff4ed24117608da$var$ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: 'flex',
                width: '100%'
            }
        }, children));
    });
});
$4ff4ed24117608da$var$Collapse.displayName = 'Collapse';
var $4ff4ed24117608da$var$direction = {
    right: 'left',
    left: 'right',
    bottom: 'up',
    top: 'down'
};
var $4ff4ed24117608da$var$getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== 'center') return $4ff4ed24117608da$var$direction[anchorOrigin.horizontal];
    return $4ff4ed24117608da$var$direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var $4ff4ed24117608da$var$toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + $4ff4ed24117608da$var$originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $4ff4ed24117608da$var$keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $4ff4ed24117608da$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $4ff4ed24117608da$var$noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $4ff4ed24117608da$var$createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, $4ff4ed24117608da$var$noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var $4ff4ed24117608da$var$useEnhancedEffect = typeof window !== 'undefined' ? (0, $eeH7J.useLayoutEffect) : (0, $eeH7J.useEffect);
function $4ff4ed24117608da$var$useEventCallback(fn) {
    var ref = (0, $eeH7J.useRef)(fn);
    $4ff4ed24117608da$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $eeH7J.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $4ff4ed24117608da$var$Snackbar = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, $eeH7J.useRef)();
    var handleClose = $4ff4ed24117608da$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $4ff4ed24117608da$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, 'timeout', id);
        }, autoHideDurationParam);
    });
    (0, $eeH7J.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $eeH7J.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, $eeH7J.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $eeH7J.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)($4ff4ed24117608da$var$ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
$4ff4ed24117608da$var$Snackbar.displayName = 'Snackbar';
var $4ff4ed24117608da$var$_root;
var $4ff4ed24117608da$var$classes$1 = /*#__PURE__*/ $4ff4ed24117608da$var$makeStyles({
    root: ($4ff4ed24117608da$var$_root = {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 1
    }, $4ff4ed24117608da$var$_root[$4ff4ed24117608da$var$breakpoints.upSm] = {
        flexGrow: 'initial',
        minWidth: '288px'
    }, $4ff4ed24117608da$var$_root)
});
var $4ff4ed24117608da$export$860cef82710cac7 = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = $4ff4ed24117608da$var$_objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)($4ff4ed24117608da$var$classes$1.root, className)
    }, props));
});
$4ff4ed24117608da$export$860cef82710cac7.displayName = 'SnackbarContent';
var $4ff4ed24117608da$var$classes$2 = /*#__PURE__*/ $4ff4ed24117608da$var$makeStyles({
    root: {
        backgroundColor: '#313131',
        fontSize: '0.875rem',
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
        color: '#fff',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: '4px',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: '#313131'
    },
    success: {
        backgroundColor: '#43a047'
    },
    error: {
        backgroundColor: '#d32f2f'
    },
    warning: {
        backgroundColor: '#ff9800'
    },
    info: {
        backgroundColor: '#2196f3'
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 0'
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '-8px'
    }
});
var $4ff4ed24117608da$var$ariaDescribedby = 'notistack-snackbar';
var $4ff4ed24117608da$var$MaterialDesignContent = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === 'function') action = action(id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$export$860cef82710cac7, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": $4ff4ed24117608da$var$ariaDescribedby,
        style: style,
        className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)($4ff4ed24117608da$var$ComponentClasses.MuiContent, $4ff4ed24117608da$var$ComponentClasses.MuiContentVariant(variant), $4ff4ed24117608da$var$classes$2.root, $4ff4ed24117608da$var$classes$2[variant], className, !hideIconVariant && icon && $4ff4ed24117608da$var$classes$2.lessPadding)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        id: $4ff4ed24117608da$var$ariaDescribedby,
        className: $4ff4ed24117608da$var$classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: $4ff4ed24117608da$var$classes$2.action
    }, action));
});
$4ff4ed24117608da$var$MaterialDesignContent.displayName = 'MaterialDesignContent';
var $4ff4ed24117608da$export$407b0b907b65dfeb = /*#__PURE__*/ (0, $eeH7J.memo)($4ff4ed24117608da$var$MaterialDesignContent);
var $4ff4ed24117608da$var$styles = /*#__PURE__*/ $4ff4ed24117608da$var$makeStyles({
    wrappedRoot: {
        width: '100%',
        position: 'relative',
        transform: 'translateX(0)',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: '288px'
    }
});
var $4ff4ed24117608da$var$SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, $eeH7J.useRef)();
    var _useState = (0, $eeH7J.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = $4ff4ed24117608da$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, 'instructed', props.snack.id);
    };
    var handleExitedScreen = (0, $eeH7J.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, $eeH7J.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? $4ff4ed24117608da$export$407b0b907b65dfeb : _props$Component;
    var classes = (0, $eeH7J.useMemo)(function() {
        return $4ff4ed24117608da$var$keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = $4ff4ed24117608da$var$_objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = $4ff4ed24117608da$var$_extends({
        direction: $4ff4ed24117608da$var$getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === 'function') content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        'onEnter',
        'onEntered',
        'onExit',
        'onExited'
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $4ff4ed24117608da$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $4ff4ed24117608da$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)($4ff4ed24117608da$var$styles.wrappedRoot, classes.root, classes[$4ff4ed24117608da$var$toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $4ff4ed24117608da$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, Object.assign({}, otherSnack)))));
};
var $4ff4ed24117608da$var$_root$1, $4ff4ed24117608da$var$_rootDense, $4ff4ed24117608da$var$_left, $4ff4ed24117608da$var$_right, $4ff4ed24117608da$var$_center;
var $4ff4ed24117608da$var$indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $4ff4ed24117608da$var$collapseWrapper = "." + $4ff4ed24117608da$var$ComponentClasses.CollapseWrapper;
var $4ff4ed24117608da$var$xsWidthMargin = 16;
var $4ff4ed24117608da$var$styles$1 = /*#__PURE__*/ $4ff4ed24117608da$var$makeStyles({
    root: ($4ff4ed24117608da$var$_root$1 = {
        boxSizing: 'border-box',
        display: 'flex',
        maxHeight: '100%',
        position: 'fixed',
        zIndex: 1400,
        height: 'auto',
        width: 'auto',
        transition: /*#__PURE__*/ $4ff4ed24117608da$var$createTransition([
            'top',
            'right',
            'bottom',
            'left',
            'max-width'
        ], {
            duration: 300,
            easing: 'ease'
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: 'none'
    }, $4ff4ed24117608da$var$_root$1[$4ff4ed24117608da$var$collapseWrapper] = {
        padding: $4ff4ed24117608da$var$indents.snackbar["default"] + "px 0px",
        transition: 'padding 300ms ease 0ms'
    }, $4ff4ed24117608da$var$_root$1.maxWidth = "calc(100% - " + $4ff4ed24117608da$var$indents.view["default"] * 2 + "px)", $4ff4ed24117608da$var$_root$1[$4ff4ed24117608da$var$breakpoints.downXs] = {
        width: '100%',
        maxWidth: "calc(100% - " + $4ff4ed24117608da$var$xsWidthMargin * 2 + "px)"
    }, $4ff4ed24117608da$var$_root$1),
    rootDense: ($4ff4ed24117608da$var$_rootDense = {}, $4ff4ed24117608da$var$_rootDense[$4ff4ed24117608da$var$collapseWrapper] = {
        padding: $4ff4ed24117608da$var$indents.snackbar.dense + "px 0px"
    }, $4ff4ed24117608da$var$_rootDense),
    top: {
        top: $4ff4ed24117608da$var$indents.view["default"] - $4ff4ed24117608da$var$indents.snackbar["default"] + "px",
        flexDirection: 'column'
    },
    bottom: {
        bottom: $4ff4ed24117608da$var$indents.view["default"] - $4ff4ed24117608da$var$indents.snackbar["default"] + "px",
        flexDirection: 'column-reverse'
    },
    left: ($4ff4ed24117608da$var$_left = {
        left: $4ff4ed24117608da$var$indents.view["default"] + "px"
    }, $4ff4ed24117608da$var$_left[$4ff4ed24117608da$var$breakpoints.upSm] = {
        alignItems: 'flex-start'
    }, $4ff4ed24117608da$var$_left[$4ff4ed24117608da$var$breakpoints.downXs] = {
        left: $4ff4ed24117608da$var$xsWidthMargin + "px"
    }, $4ff4ed24117608da$var$_left),
    right: ($4ff4ed24117608da$var$_right = {
        right: $4ff4ed24117608da$var$indents.view["default"] + "px"
    }, $4ff4ed24117608da$var$_right[$4ff4ed24117608da$var$breakpoints.upSm] = {
        alignItems: 'flex-end'
    }, $4ff4ed24117608da$var$_right[$4ff4ed24117608da$var$breakpoints.downXs] = {
        right: $4ff4ed24117608da$var$xsWidthMargin + "px"
    }, $4ff4ed24117608da$var$_right),
    center: ($4ff4ed24117608da$var$_center = {
        left: '50%',
        transform: 'translateX(-50%)'
    }, $4ff4ed24117608da$var$_center[$4ff4ed24117608da$var$breakpoints.upSm] = {
        alignItems: 'center'
    }, $4ff4ed24117608da$var$_center)
});
var $4ff4ed24117608da$var$SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, $8247dc0908a27868$export$2e2bcd8739ae039)($4ff4ed24117608da$var$ComponentClasses.SnackbarContainer, $4ff4ed24117608da$var$styles$1[anchorOrigin.vertical], $4ff4ed24117608da$var$styles$1[anchorOrigin.horizontal], $4ff4ed24117608da$var$styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + $4ff4ed24117608da$var$originKeyExtractor(anchorOrigin)], dense && $4ff4ed24117608da$var$styles$1.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: combinedClassname
    }, children);
};
var $4ff4ed24117608da$var$SnackbarContainer$1 = /*#__PURE__*/ (0, $eeH7J.memo)($4ff4ed24117608da$var$SnackbarContainer);
/* eslint-disable */ var $4ff4ed24117608da$var$__DEV__ = true;
var $4ff4ed24117608da$var$messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var $4ff4ed24117608da$var$warning = function(messageKey) {
    if (!$4ff4ed24117608da$var$__DEV__) return;
    var message = $4ff4ed24117608da$var$messages[messageKey];
    if (typeof console !== 'undefined') console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $4ff4ed24117608da$var$isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === 'string' || (0, $eeH7J.isValidElement)(messageOrOptions);
    return !isMessage;
};
var $4ff4ed24117608da$export$9d70c354f0150b1b;
var $4ff4ed24117608da$export$823cdc5238933767;
var $4ff4ed24117608da$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $4ff4ed24117608da$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error('enqueueSnackbar called with invalid argument');
            var opts = $4ff4ed24117608da$var$isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = $4ff4ed24117608da$var$isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = $4ff4ed24117608da$var$_objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $4ff4ed24117608da$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $4ff4ed24117608da$var$merge(options, _this.props);
            var snack = $4ff4ed24117608da$var$_extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger('persist'),
                action: merger('action'),
                content: merger('content'),
                variant: merger('variant'),
                anchorOrigin: merger('anchorOrigin'),
                disableWindowBlurListener: merger('disableWindowBlurListener'),
                autoHideDuration: merger('autoHideDuration'),
                hideIconVariant: merger('hideIconVariant'),
                TransitionComponent: merger('TransitionComponent'),
                transitionDuration: merger('transitionDuration'),
                TransitionProps: merger('TransitionProps', true),
                iconVariant: merger('iconVariant', true),
                style: merger('style', true),
                SnackbarProps: merger('SnackbarProps', true),
                className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($4ff4ed24117608da$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $4ff4ed24117608da$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) {
                $4ff4ed24117608da$var$warning('NO_PERSIST_ALL');
                ignore = true;
            }
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $4ff4ed24117608da$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, 'maxsnack', item.id);
                    if (_this.props.onClose) _this.props.onClose(null, 'maxsnack', item.id);
                    return $4ff4ed24117608da$var$_extends({}, item, {
                        open: false
                    });
                }
                return $4ff4ed24117608da$var$_extends({}, item);
            });
            return $4ff4ed24117608da$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$4ff4ed24117608da$var$isDefined(key)) throw new Error('handleEnteredSnack Cannot be called with undefined key');
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? $4ff4ed24117608da$var$_extends({}, item, {
                            entered: true
                        }) : $4ff4ed24117608da$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return $4ff4ed24117608da$var$_extends({}, item);
                        return item.entered ? $4ff4ed24117608da$var$_extends({}, item, {
                            open: false
                        }) : $4ff4ed24117608da$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if ($4ff4ed24117608da$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, 'instructed', key);
            _this.handleCloseSnack(null, 'instructed', key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!$4ff4ed24117608da$var$isDefined(key)) throw new Error('handleExitedSnack Cannot be called with undefined key');
            _this.setState(function(state) {
                var newState = _this.processQueue($4ff4ed24117608da$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        $4ff4ed24117608da$export$9d70c354f0150b1b = _this.enqueueSnackbar;
        $4ff4ed24117608da$export$823cdc5238933767 = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind($4ff4ed24117608da$var$_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind($4ff4ed24117608da$var$_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $4ff4ed24117608da$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $4ff4ed24117608da$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: $4ff4ed24117608da$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: $4ff4ed24117608da$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($4ff4ed24117608da$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $dad018249d59322c$exports.createPortal)(snackbars, domRoot) : snackbars);
    };
    $4ff4ed24117608da$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $4ff4ed24117608da$var$defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $eeH7J.Component));
var $4ff4ed24117608da$export$1c97ac2c9a6e7c09 = function() {
    return (0, $eeH7J.useContext)($4ff4ed24117608da$var$SnackbarContext);
};



var $eeH7J = parcelRequire("eeH7J");


const $4feb4bd7a36e5dfe$var$AddEditColorPallets = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [isEditMode] = $eeH7J.useState(props.currFormData ? true : false);
    const [formData, setFormData] = $eeH7J.useState(props.currFormData || {
        id: "",
        category: "",
        colors: [
            "",
            "",
            "",
            "",
            "",
            ""
        ]
    });
    const [errors, setErrors] = $eeH7J.useState({
        colors: [
            false,
            false,
            false,
            false,
            false,
            false
        ]
    });
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleColorChange = (index, value)=>{
        const newColors = [
            ...formData.colors
        ];
        newColors[index] = value;
        const newErrors = [
            ...errors.colors
        ];
        newErrors[index] = !isValidHexColor(value);
        setFormData({
            ...formData,
            colors: newColors
        });
        setErrors({
            ...errors,
            colors: newErrors
        });
    };
    const handleSave = async ()=>{
        // Handle save logic here
        if (formData.id === "" || formData.id === null || formData.id === undefined) {
            enqueueSnackbar("Id can't be empty", {
                variant: "error"
            });
            return;
        }
        if (formData.category === "" || formData.category === null || formData.category === undefined) {
            enqueueSnackbar("Category can't be empty", {
                variant: "error"
            });
            return;
        }
        let hasEmptyColors = false;
        formData.colors.map((oo, idx)=>{
            if (oo === "" || oo === undefined || oo === null) hasEmptyColors = true;
        });
        const hasErrors = errors.colors.some((error)=>error);
        if (hasErrors || hasEmptyColors) {
            enqueueSnackbar("Color codes can't be empty or invalid", {
                variant: "error"
            });
            return;
        }
        if (!isEditMode && props.data.find((jj)=>jj.id === formData.id)) {
            enqueueSnackbar("Id already exists. please enter unique one", {
                variant: "error"
            });
            return;
        }
        try {
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/template-color-theme", formData);
            if (res.status === 200) props.onSave();
            else enqueueSnackbar("something went wrong...!", {
                variant: "error"
            });
        } catch (err) {
            console.log(err);
        }
    };
    const handleCancel = ()=>{
        // Handle cancel logic here
        setFormData({
            id: "",
            category: "",
            colors: [
                "",
                "",
                "",
                "",
                "",
                ""
            ]
        });
        setErrors({
            colors: [
                false,
                false,
                false,
                false,
                false,
                false
            ]
        });
        props.onCancel();
    };
    const isValidHexColor = (hex)=>{
        const hexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
        return hexRegex.test(hex);
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "max-w-md mx-auto p-4"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-4  flex flex-row justify-between"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2 w-40",
        htmlFor: "id"
    }, "ID"), /*#__PURE__*/ $eeH7J.createElement("input", {
        type: "text",
        name: "id",
        disabled: isEditMode,
        value: formData.id,
        onChange: handleInputChange,
        className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "id"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-4 flex flex-row justify-between"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2 w-40",
        htmlFor: "category"
    }, "Category"), /*#__PURE__*/ $eeH7J.createElement("select", {
        name: "category",
        value: formData.category,
        onChange: handleInputChange,
        className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "category"
    }, /*#__PURE__*/ $eeH7J.createElement("option", {
        value: ""
    }, "Select a category"), /*#__PURE__*/ $eeH7J.createElement("option", {
        value: "Bright"
    }, "Bright"), /*#__PURE__*/ $eeH7J.createElement("option", {
        value: "Dark"
    }, "Dark"), /*#__PURE__*/ $eeH7J.createElement("option", {
        value: "Pastel"
    }, "Pastel"))), formData.colors.map((color, index)=>/*#__PURE__*/ $eeH7J.createElement("div", {
            className: "mb-4 flex flex-row",
            key: index
        }, /*#__PURE__*/ $eeH7J.createElement("label", {
            className: "block text-gray-700 text-sm font-bold mb-2 w-40",
            htmlFor: `color-${index}`
        }, "Color ", index + 1), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-col w-full"
        }, /*#__PURE__*/ $eeH7J.createElement("input", {
            type: "text",
            value: color,
            onChange: (e)=>handleColorChange(index, e.target.value),
            className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
            id: `color-${index}`
        }), errors.colors[index] && /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "text-red-500 text-sm italic"
        }, "Invalid hex color code.")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex items-center justify-end"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        onClick: handleCancel,
        className: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-4",
        type: "button"
    }, "Cancel"), /*#__PURE__*/ $eeH7J.createElement("button", {
        onClick: handleSave,
        className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        type: "button"
    }, "Save")));
};
var $4feb4bd7a36e5dfe$export$2e2bcd8739ae039 = $4feb4bd7a36e5dfe$var$AddEditColorPallets;


const $9071317febea67fb$var$ColorPalletsList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $eeH7J.useState([]);
    const [loading, setLoading] = $eeH7J.useState(false);
    const [open, setOpen] = $eeH7J.useState(false);
    const [currFormData, setCurrFormData] = $eeH7J.useState(null);
    async function fetchData() {
        setLoading(true);
        try {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`);
            // console.log("//", response.data.data);
            setData(response.data.data);
        } catch (err) {} finally{
            setLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData();
    }, []);
    const handleCancel = ()=>{
        setOpen(false);
    };
    const handleSave = ()=>{
        fetchData();
        setOpen(false);
    };
    const handleDelete = async (id)=>{
        let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).delete(`/api/configs/template-color-theme?id=${id}`, id);
        if (res.status === 200) fetchData();
        else enqueueSnackbar("something went wrong...!", {
            variant: "error"
        });
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "p-4 bg-white w-full"
    }, open && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 flex items-center justify-center z-50"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-900 opacity-50",
        onClick: ()=>setOpen(false)
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white rounded-lg shadow-lg max-w-md w-full p-6 z-50"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $4feb4bd7a36e5dfe$export$2e2bcd8739ae039), {
        data: data,
        currFormData: currFormData,
        onCancel: handleCancel,
        onSave: handleSave
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "List of color pallets"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>{
            setCurrFormData(null);
            setOpen(true);
        }
    }, "Add new color pallet")), loading ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 4,
            gap: 1
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "#666"
        }
    }, "Loading color pallets...")) : data.length === 0 ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            mt: 4,
            color: "#666"
        }
    }, "No color pallets found.") : /*#__PURE__*/ $eeH7J.createElement((0, $70cd81359a2961cc$export$2e2bcd8739ae039), {
        component: (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b1559ea0fc0c104d$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $9875ccd06eebee4b$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
        className: "p-2 "
    }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "id"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Category"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Colors"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $eeH7J.createElement((0, $3b671b494e02bd1f$export$2e2bcd8739ae039), null, data.map((row)=>/*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
            key: row.id,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.id), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.category), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, row.colors.map((ii)=>{
            return /*#__PURE__*/ $eeH7J.createElement("div", {
                key: ii,
                className: `h-8 w-8 rounded-md mr-1 border border-grey`,
                style: {
                    backgroundColor: ii
                }
            }, " ");
        }), " ")), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                setCurrFormData(row);
                setOpen(true);
            }
        }, "Edit"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            color: "error",
            onClick: ()=>{
                handleDelete(row.id);
            }
        }, "Delete")))))))));
};
var $9071317febea67fb$export$2e2bcd8739ae039 = $9071317febea67fb$var$ColorPalletsList;



var $eeH7J = parcelRequire("eeH7J");













var $eeH7J = parcelRequire("eeH7J");


const $93376536a98afb1f$var$AddEdittemplateCategory = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [isEditMode] = $eeH7J.useState(props.currCategory ? true : false);
    const [formData, setFormData] = $eeH7J.useState({
        name: props.currCategory || ""
    });
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleSave = async ()=>{
        // Handle save logic here
        if (formData.name === "" || formData.name === null || formData.name === undefined) {
            enqueueSnackbar("Category name can't be empty", {
                variant: "error"
            });
            return;
        }
        // if (!isEditMode && props.data.find((jj) => jj.name === formData.name)) {
        //   enqueueSnackbar("Duplicate category name.", {
        //     variant: "error",
        //   });
        //   return;
        // }
        // if (isEditMode && props.data.find((jj) => jj.name === formData.name)) {
        //   enqueueSnackbar("Duplicate category name.", {
        //     variant: "error",
        //   });
        //   return;
        // }
        // return;
        try {
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).delete(`/api/configs/site-categories?name=${props.currCategory}`);
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/site-categories", formData);
            if (res.status === 200) props.onSave();
            else enqueueSnackbar("something went wrong...!", {
                variant: "error"
            });
        } catch (err) {
            console.log(err);
        }
    };
    const handleCancel = ()=>{
        // Handle cancel logic here
        setFormData({
            name: ""
        });
        props.onCancel();
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "max-w-md mx-auto p-4"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-4  flex flex-row justify-between"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2 w-40",
        htmlFor: "id"
    }, "Category Name"), /*#__PURE__*/ $eeH7J.createElement("input", {
        type: "text",
        name: "name",
        // disabled={isEditMode}
        value: formData.name,
        onChange: handleInputChange,
        className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "name"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex items-center justify-end"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        onClick: handleCancel,
        className: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-4",
        type: "button"
    }, "Cancel"), /*#__PURE__*/ $eeH7J.createElement("button", {
        onClick: handleSave,
        className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        type: "button"
    }, "Save")));
};
var $93376536a98afb1f$export$2e2bcd8739ae039 = $93376536a98afb1f$var$AddEdittemplateCategory;


const $a428063360cac1df$var$TemplateCategoryList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [open, setOpen] = $eeH7J.useState(false);
    const [currCategory, setCurrCategory] = $eeH7J.useState(null);
    const [data, setData] = $eeH7J.useState([]);
    const [loading, setLoading] = $eeH7J.useState(false);
    async function fetchData() {
        setLoading(true);
        try {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/all-site-category`);
            setData(response.data.data.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: "base"
                })));
        } catch (err) {} finally{
            setLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData();
    }, []);
    const handleCancel = ()=>{
        setOpen(false);
    };
    const handleSave = ()=>{
        fetchData();
        setOpen(false);
    };
    const handleDelete = async (id)=>{
        let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).delete(`/api/configs/site-categories?name=${id}`);
        if (res.status === 200) fetchData();
        else enqueueSnackbar("something went wrong...!", {
            variant: "error"
        });
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "p-4 bg-white w-full"
    }, open && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 flex items-center justify-center z-50"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-900 opacity-50",
        onClick: ()=>setOpen(false)
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white rounded-lg shadow-lg max-w-md w-full p-6 z-50"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $93376536a98afb1f$export$2e2bcd8739ae039), {
        data: data,
        currCategory: currCategory,
        onCancel: handleCancel,
        onSave: handleSave
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "List of template categories"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>{
            setCurrCategory(null);
            setOpen(true);
        }
    }, "Add template category")), loading ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 4,
            gap: 1
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "#666"
        }
    }, "Loading template categories...")) : data.length === 0 ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            mt: 4,
            color: "#666"
        }
    }, "No template categories found.") : /*#__PURE__*/ $eeH7J.createElement((0, $70cd81359a2961cc$export$2e2bcd8739ae039), {
        component: (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b1559ea0fc0c104d$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $9875ccd06eebee4b$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
        className: "p-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Category Name"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $eeH7J.createElement((0, $3b671b494e02bd1f$export$2e2bcd8739ae039), null, data.map((row, idx)=>/*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
            key: idx,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.name), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                setCurrCategory(row.name);
                setOpen(true);
            }
        }, "Edit"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            color: "error",
            onClick: ()=>{
                handleDelete(row.name);
            }
        }, "Delete")))))))));
};
var $a428063360cac1df$export$2e2bcd8739ae039 = $a428063360cac1df$var$TemplateCategoryList;



var $eeH7J = parcelRequire("eeH7J");







var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $4A7Fh = parcelRequire("4A7Fh");

var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");




var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $31aa5aa2ec492c3d$export$baa0faa0c7ad8085(slot) {
    return (0, $aBqGi.default)('PrivateSwitchBase', slot);
}
const $31aa5aa2ec492c3d$var$switchBaseClasses = (0, $cDqLM.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $31aa5aa2ec492c3d$export$2e2bcd8739ae039 = $31aa5aa2ec492c3d$var$switchBaseClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $2e099faf6f4f0cd0$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $2e099faf6f4f0cd0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $4A7Fh.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $31aa5aa2ec492c3d$export$baa0faa0c7ad8085), classes);
};
const $2e099faf6f4f0cd0$var$SwitchBaseRoot = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $2e099faf6f4f0cd0$var$SwitchBaseInput = (0, $hikmr.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $lzlXq.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $2e099faf6f4f0cd0$var$SwitchBase = /*#__PURE__*/ $eeH7J.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $fbOaB.default)(props, $2e099faf6f4f0cd0$var$_excluded);
    const [checked, setCheckedState] = (0, $7a2443d826ebcf5f$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $h4XE0.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $2e099faf6f4f0cd0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsxs)($2e099faf6f4f0cd0$var$SwitchBaseRoot, (0, $h4XE0.default)({
        component: "span",
        className: (0, $er6YD.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)($2e099faf6f4f0cd0$var$SwitchBaseInput, (0, $h4XE0.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
$2e099faf6f4f0cd0$var$SwitchBase.propTypes = {
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node.isRequired,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /*
   * @ignore
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the `input` element is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The input component prop `type`.
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string.isRequired,
    /**
   * The value of the component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
var $2e099faf6f4f0cd0$export$2e2bcd8739ae039 = $2e099faf6f4f0cd0$var$SwitchBase;


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $95cf53deb2abaffe$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $c1f6e63280c3c81f$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $f9786f2020bba5c3$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $4A7Fh = parcelRequire("4A7Fh");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $9e6d6770ae4c6e4a$export$6c57c6e16b4063b(slot) {
    return (0, $aBqGi.default)('MuiCheckbox', slot);
}
const $9e6d6770ae4c6e4a$var$checkboxClasses = (0, $cDqLM.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $9e6d6770ae4c6e4a$export$2e2bcd8739ae039 = $9e6d6770ae4c6e4a$var$checkboxClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $46e23713790889f2$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $46e23713790889f2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $4A7Fh.default)(color)}`,
            `size${(0, $4A7Fh.default)(size)}`
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $9e6d6770ae4c6e4a$export$6c57c6e16b4063b), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $46e23713790889f2$var$CheckboxRoot = (0, $hikmr.default)((0, $2e099faf6f4f0cd0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $4A7Fh.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $4A7Fh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $9e6d6770ae4c6e4a$export$2e2bcd8739ae039).checked}, &.${(0, $9e6d6770ae4c6e4a$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $9e6d6770ae4c6e4a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $46e23713790889f2$var$defaultCheckedIcon = /*#__PURE__*/ (0, $dRzna.jsx)((0, $c1f6e63280c3c81f$export$2e2bcd8739ae039), {});
const $46e23713790889f2$var$defaultIcon = /*#__PURE__*/ (0, $dRzna.jsx)((0, $95cf53deb2abaffe$export$2e2bcd8739ae039), {});
const $46e23713790889f2$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $dRzna.jsx)((0, $f9786f2020bba5c3$export$2e2bcd8739ae039), {});
const $46e23713790889f2$var$Checkbox = /*#__PURE__*/ $eeH7J.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $46e23713790889f2$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $46e23713790889f2$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $46e23713790889f2$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $fbOaB.default)(props, $46e23713790889f2$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $46e23713790889f2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($46e23713790889f2$var$CheckboxRoot, (0, $h4XE0.default)({
        type: "checkbox",
        inputProps: (0, $h4XE0.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $eeH7J.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $eeH7J.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $er6YD.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
$46e23713790889f2$var$Checkbox.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */ indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */ indeterminateIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
var $46e23713790889f2$export$2e2bcd8739ae039 = $46e23713790889f2$var$Checkbox;









// import Modal from "@mui/material/Modal";
// import AddEditColorPallets from "./AddEditColorPallets";
const $bab3eb00c9824b97$var$PublishableTemplatesList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $eeH7J.useState([]);
    const [selectAll, setSelectAll] = $eeH7J.useState(false);
    const [loading, setLoading] = $eeH7J.useState(false);
    async function fetchData() {
        setLoading(true);
        try {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/template-site-configs`);
            console.log("//", response.data.data);
            setData(response.data.data);
        } catch (err) {} finally{
            setLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData();
    }, []);
    const handlePublish = async (id)=>{
        let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/publish`, {
            siteId: id,
            publishAllPages: true
        });
        if (res.status === 200) enqueueSnackbar("Publishing in progress!", {
            variant: "warning"
        });
        else enqueueSnackbar("something went wrong...!", {
            variant: "error"
        });
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "p-4 bg-white w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "List of templates"), /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            gap: 1
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        disabled: !data.filter((kk)=>kk.selected === true).length > 0,
        size: "small",
        variant: "contained",
        onClick: async ()=>{
            try {
                const promises = [];
                data.filter((kk)=>kk.selected === true).forEach((row)=>{
                    promises.push((0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/update-page-count`, {
                        siteId: row.siteId
                    }));
                });
                let res = await Promise.all(promises);
                enqueueSnackbar(`Updating page count for ${res.length} site(s)!`, {
                    variant: "success"
                });
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    for(let ii = 0; ii < _old.length; ii++)_old[ii].selected = false;
                    return _old;
                });
                setSelectAll(false);
                fetchData();
            } catch (error) {
                console.error("Error updating page count", error);
                enqueueSnackbar("Something went wrong!", {
                    variant: "error"
                });
            }
        }
    }, data.filter((kk)=>kk.selected === true).length === 0 ? "Update Page Count" : `Update Page Count (${data.filter((kk)=>kk.selected === true).length})`), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        disabled: !data.filter((kk)=>kk.selected === true).length > 0,
        size: "small",
        variant: "contained",
        onClick: async ()=>{
            try {
                const promises = [];
                data.filter((kk)=>kk.selected === true).forEach((row)=>{
                    // Push promises without awaiting them individually
                    promises.push((0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/publish`, {
                        siteId: row.siteId,
                        publishAllPages: true
                    }));
                });
                // Await Promise.all to resolve all promises
                let res = await Promise.all(promises);
                enqueueSnackbar(`Publishing ${res.length} sites in progress!`, {
                    variant: "warning"
                });
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    for(let ii = 0; ii < _old.length; ii++)_old[ii].selected = false;
                    return _old;
                });
                setSelectAll(false);
                console.log("ressss", res); // You can now access the resolved promises
            } catch (error) {
                console.error("Error during publishing", error);
            }
        }
    }, data.filter((kk)=>kk.selected === true).length === 0 ? "Publish Site" : `Publish ${data.filter((kk)=>kk.selected === true).length} sites`))), loading ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 4,
            gap: 1
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "#666"
        }
    }, "Loading templates...")) : data.length === 0 ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            mt: 4,
            color: "#666"
        }
    }, "No templates found.") : /*#__PURE__*/ $eeH7J.createElement((0, $70cd81359a2961cc$export$2e2bcd8739ae039), {
        component: (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b1559ea0fc0c104d$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $9875ccd06eebee4b$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
        className: "p-2 "
    }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
        checked: selectAll,
        size: "small",
        onChange: (event)=>{
            setData((old)=>{
                let _old = [
                    ...old
                ];
                for(let ii = 0; ii < _old.length; ii++)_old[ii].selected = event.target.checked ? true : false; // Fix this line to toggle selected
                return _old;
            });
            setSelectAll(!selectAll);
        }
    })), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Sr.No."), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Site Id"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Template Name (Site Name)"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Page Count"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Last modified on"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $eeH7J.createElement((0, $3b671b494e02bd1f$export$2e2bcd8739ae039), null, data.map((row, _idx)=>/*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
            key: row.siteId,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
            checked: row?.selected === true ? true : false,
            size: "small",
            onChange: (event)=>{
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let ii = _old.findIndex((kk)=>kk.siteId === row.siteId); // Corrected
                    if (ii !== -1) _old[ii].selected = event.target.checked ? true : false; // Fix this line to toggle selected
                    return _old;
                });
            }
        })), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, _idx), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.siteId), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.templateName, " (", row.siteName, ")"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "right"
        }, row.pageCount), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "left"
        }, new Date(row.updatedAt).toLocaleString()), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                handlePublish(row.siteId);
            }
        }, "Publish")))))))));
};
var $bab3eb00c9824b97$export$2e2bcd8739ae039 = $bab3eb00c9824b97$var$PublishableTemplatesList;



var $eeH7J = parcelRequire("eeH7J");












const $d034b94394599c12$var$UserAcquisitionLogs = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $eeH7J.useState([]);
    const [showSiteData, setShowSiteData] = $eeH7J.useState([]);
    const [loading, setLoading] = $eeH7J.useState(false);
    async function fetchData() {
        setLoading(true);
        try {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/admin/user-acqusition-logs`);
            setData(response.data.data);
        // console.log(response.data);
        } catch (err) {} finally{
            setLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full p-4 flex flex-row"
    }, loading ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 4,
            gap: 1,
            width: "100%"
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "#666"
        }
    }, "Loading user logs...")) : data.length === 0 ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            mt: 4,
            color: "#666",
            width: "100%"
        }
    }, "No user acquisition logs found.") : /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: " bg-white w-7/12 overflow-x-auto h-[calc(100vh-100px)]"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $70cd81359a2961cc$export$2e2bcd8739ae039), {
        component: (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b1559ea0fc0c104d$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $9875ccd06eebee4b$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
        className: "p-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "User email"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Source"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Created On"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $eeH7J.createElement((0, $3b671b494e02bd1f$export$2e2bcd8739ae039), null, data.map((row, idx)=>{
        const date = new Date(row.createdOn);
        return /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
            key: idx,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row",
            className: "break-all"
        }, row.email), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.googleSource === true ? "Google" : row.linkedInSource === true ? "LinkedIn" : "-"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, date.toLocaleString()), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                setShowSiteData(row.sites);
            }
        }, "View Sites"))));
    }))))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-5/12 pl-4"
    }, showSiteData && showSiteData.map((ee)=>{
        const _date = new Date(ee.updatedAt);
        const { siteUrl: siteUrl, subDomain: subDomain } = ee;
        let updatedUrl = siteUrl;
        // if (siteUrl && subDomain) {
        //   const parts = siteUrl.split(".");
        //   if (parts.length >= 1 && parts[0] !== subDomain) {
        //     parts[0] = subDomain;
        //     updatedUrl = parts.join(".");
        //   }
        // }
        return /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "bg-white p-2 m-1 rounded-lg",
            key: ee.siteId
        }, /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "pr-2"
        }, "Site Name: "), /*#__PURE__*/ $eeH7J.createElement("span", null, ee.siteName)), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "pr-2"
        }, "Last modified On: "), /*#__PURE__*/ $eeH7J.createElement("span", null, _date.toLocaleString())), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "pr-2"
        }, "Publish Status: "), /*#__PURE__*/ $eeH7J.createElement("span", null, ee.isPublished ? "true" : "false")), ee.source && /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "pr-2"
        }, "AI Source: "), /*#__PURE__*/ $eeH7J.createElement("span", null, ee.source)), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "pr-2"
        }, "Site URL: "), /*#__PURE__*/ $eeH7J.createElement("a", {
            href: `https://${updatedUrl}`,
            target: "_blank"
        }, updatedUrl)), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "pr-2"
        }, "Editor URL: "), /*#__PURE__*/ $eeH7J.createElement("a", {
            href: `${"https://editorstage.rocketpages.io"}/${ee.siteId}`,
            target: "_blank"
        }, `${"https://editorstage.rocketpages.io"}/${ee.siteId}`)));
    }))));
};
var $d034b94394599c12$export$2e2bcd8739ae039 = $d034b94394599c12$var$UserAcquisitionLogs;



var $eeH7J = parcelRequire("eeH7J");











const $e483083e346763c8$var$SitesList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $eeH7J.useState([]);
    const [showSiteData, setShowSiteData] = $eeH7J.useState([]);
    const [loading, setLoading] = $eeH7J.useState(false);
    async function fetchData() {
        setLoading(true);
        try {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/admin/all-sites`);
            setData(response.data.data);
        // console.log(response.data);
        } catch (err) {} finally{
            setLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full p-4 flex flex-row"
    }, loading ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 4,
            gap: 1,
            width: "100%"
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "#666"
        }
    }, "Loading sites...")) : data.length === 0 ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            mt: 4,
            color: "#666",
            width: "100%"
        }
    }, "No sites found.") : /*#__PURE__*/ $eeH7J.createElement("div", {
        className: " font-medium bg-white overflow-x-auto h-[calc(100vh-100px)]"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $70cd81359a2961cc$export$2e2bcd8739ae039), {
        component: (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b1559ea0fc0c104d$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $9875ccd06eebee4b$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
        className: "p-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Site Id"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Site Url"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "User"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Custom Code"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Subscription"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Created On"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Updategd On"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "isPublished"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $eeH7J.createElement((0, $3b671b494e02bd1f$export$2e2bcd8739ae039), null, data.map((row, idx)=>{
        const created_date = new Date(row.createdAt);
        const updated_date = new Date(row.updatedAt);
        const { siteUrl: siteUrl, subDomain: subDomain } = row;
        let updatedUrl = siteUrl;
        if (siteUrl && subDomain) {
            const parts = siteUrl.split(".");
            if (parts.length >= 1 && parts[0] !== subDomain) {
                parts[0] = subDomain;
                updatedUrl = parts.join(".");
            }
        }
        return /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
            key: idx,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.siteId), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, /*#__PURE__*/ $eeH7J.createElement("a", {
            href: `https://${updatedUrl}`,
            target: "_blank"
        }, updatedUrl)), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.email), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.customCode), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.subscriptionStatus), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, created_date.toLocaleString()), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, updated_date.toLocaleString()), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.isPublished ? "true" : "false"));
    }))))));
};
var $e483083e346763c8$export$2e2bcd8739ae039 = $e483083e346763c8$var$SitesList;



var $eeH7J = parcelRequire("eeH7J");












// import Modal from "@mui/material/Modal";
// import AddEditColorPallets from "./AddEditColorPallets";
const $bdaf1fd5e429426c$var$AITemplates = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $eeH7J.useState([]);
    const [selectAll, setSelectAll] = $eeH7J.useState(false);
    const [loading, setLoading] = $eeH7J.useState(false);
    async function fetchData() {
        setLoading(true);
        try {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/aiTemplates`);
            console.log("//", response.data.data);
            setData(response.data.data);
        } catch (err) {} finally{
            setLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "p-4 bg-white w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "List of templates")), loading ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 4,
            gap: 1
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "#666"
        }
    }, "Loading AI templates...")) : data.length === 0 ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            mt: 4,
            color: "#666"
        }
    }, "No AI templates found.") : /*#__PURE__*/ $eeH7J.createElement((0, $70cd81359a2961cc$export$2e2bcd8739ae039), {
        component: (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b1559ea0fc0c104d$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $9875ccd06eebee4b$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
        className: "p-2 "
    }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Template Name (Site Name)"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Page Count"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Last modified on"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $eeH7J.createElement((0, $3b671b494e02bd1f$export$2e2bcd8739ae039), null, data.map((row)=>/*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
            key: row.siteId,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.templateName, " (", row.siteName, ")"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "right"
        }, row.pageCount), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            align: "left"
        }, new Date(row.updatedAt).toLocaleString())))))));
};
var $bdaf1fd5e429426c$export$2e2bcd8739ae039 = $bdaf1fd5e429426c$var$AITemplates;



var $eeH7J = parcelRequire("eeH7J");








var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");



var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");






var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");



var $hikmr = parcelRequire("hikmr");

var $4A7Fh = parcelRequire("4A7Fh");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $9d30d39e9e746846$export$a394fa61b1d583a9(slot) {
    return (0, $aBqGi.default)('MuiFormHelperText', slot);
}
const $9d30d39e9e746846$var$formHelperTextClasses = (0, $cDqLM.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $9d30d39e9e746846$export$2e2bcd8739ae039 = $9d30d39e9e746846$var$formHelperTextClasses;



var $lNnGW = parcelRequire("lNnGW");

var $dRzna = parcelRequire("dRzna");
'use client';
var $ef37ff1c97d5411a$var$_span;
const $ef37ff1c97d5411a$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $ef37ff1c97d5411a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $4A7Fh.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $9d30d39e9e746846$export$a394fa61b1d583a9), classes);
};
const $ef37ff1c97d5411a$var$FormHelperTextRoot = (0, $hikmr.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $4A7Fh.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $9d30d39e9e746846$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $9d30d39e9e746846$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $ef37ff1c97d5411a$var$FormHelperText = /*#__PURE__*/ $eeH7J.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $fbOaB.default)(props, $ef37ff1c97d5411a$var$_excluded);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $ef37ff1c97d5411a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($ef37ff1c97d5411a$var$FormHelperTextRoot, (0, $h4XE0.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $ef37ff1c97d5411a$var$_span || ($ef37ff1c97d5411a$var$_span = /*#__PURE__*/ (0, $dRzna.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
$ef37ff1c97d5411a$var$FormHelperText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the helper text should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, helper text should be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the helper text should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the helper text should use focused classes key.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense'
    ]),
    /**
   * If `true`, the helper text should use required classes key.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'filled',
            'outlined',
            'standard'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $ef37ff1c97d5411a$export$2e2bcd8739ae039 = $ef37ff1c97d5411a$var$FormHelperText;




var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $78af2bd603059ad2$export$c1bdcbaf0596aeda(slot) {
    return (0, $aBqGi.default)('MuiTextField', slot);
}
const $78af2bd603059ad2$var$textFieldClasses = (0, $cDqLM.default)('MuiTextField', [
    'root'
]);
var $78af2bd603059ad2$export$2e2bcd8739ae039 = $78af2bd603059ad2$var$textFieldClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $b26788a1fbff39fd$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $b26788a1fbff39fd$var$variantComponent = {
    standard: (0, $efff8c52466ed18b$export$2e2bcd8739ae039),
    filled: (0, $1452bd953890770b$export$2e2bcd8739ae039),
    outlined: (0, $b1e7c35c0ae18844$export$2e2bcd8739ae039)
};
const $b26788a1fbff39fd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $78af2bd603059ad2$export$c1bdcbaf0596aeda), classes);
};
const $b26788a1fbff39fd$var$TextFieldRoot = (0, $hikmr.default)((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $b26788a1fbff39fd$var$TextField = /*#__PURE__*/ $eeH7J.forwardRef(function TextField(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $fbOaB.default)(props, $b26788a1fbff39fd$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $b26788a1fbff39fd$var$useUtilityClasses(ownerState);
    if (select && !children) console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $cb6186ed251df147$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $b26788a1fbff39fd$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $dRzna.jsx)(InputComponent, (0, $h4XE0.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $dRzna.jsxs)($b26788a1fbff39fd$var$TextFieldRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $dRzna.jsx)((0, $d2dab3d7ad9c072d$export$2e2bcd8739ae039), (0, $h4XE0.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $dRzna.jsx)((0, $79a0d4fc41924020$export$2e2bcd8739ae039), (0, $h4XE0.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $dRzna.jsx)((0, $ef37ff1c97d5411a$export$2e2bcd8739ae039), (0, $h4XE0.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
$b26788a1fbff39fd$var$TextField.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */ FormHelperTextProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The helper text content.
   */ helperText: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */ InputLabelProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */ InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */ select: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */ SelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The size of the component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $b26788a1fbff39fd$export$2e2bcd8739ae039 = $b26788a1fbff39fd$var$TextField;









const $bdc91bd954d694d3$var$UserManagement = ()=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [users, setUsers] = $eeH7J.useState([]);
    const [search, setSearch] = $eeH7J.useState("");
    const [roleFilter, setRoleFilter] = $eeH7J.useState("all");
    const [loading, setLoading] = $eeH7J.useState(false);
    const debounceRef = $eeH7J.useRef(null);
    const fetchUsers = $eeH7J.useCallback(async (searchVal, role)=>{
        setLoading(true);
        try {
            const params = {};
            if (searchVal) params.search = searchVal;
            if (role !== "all") params.role = role;
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get("/api/admin/all-users", {
                params: params
            });
            setUsers(response.data.data);
        } catch (err) {
            enqueueSnackbar("Failed to fetch users", {
                variant: "error"
            });
        } finally{
            setLoading(false);
        }
    }, [
        enqueueSnackbar
    ]);
    $eeH7J.useEffect(()=>{
        fetchUsers("", "all");
    }, [
        fetchUsers
    ]);
    const handleSearchChange = (e)=>{
        const val = e.target.value;
        setSearch(val);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = window.setTimeout(()=>{
            fetchUsers(val, roleFilter);
        }, 400);
    };
    const handleRoleFilterChange = (e)=>{
        const val = e.target.value;
        setRoleFilter(val);
        fetchUsers(search, val);
    };
    const handleToggleRole = async (email, currentRole)=>{
        const newRole = currentRole === "admin" ? null : "admin";
        try {
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/admin/update-user-role", {
                email: email,
                role: newRole
            });
            enqueueSnackbar(newRole === "admin" ? `${email} is now an admin` : `Admin role removed from ${email}`, {
                variant: "success"
            });
            fetchUsers(search, roleFilter);
        } catch (err) {
            if (err.response?.status === 409) enqueueSnackbar("Cannot remove your own admin role", {
                variant: "error"
            });
            else enqueueSnackbar("Failed to update user role", {
                variant: "error"
            });
        }
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full p-4"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            gap: 2,
            mb: 2
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        size: "small",
        placeholder: "Search by email",
        value: search,
        onChange: handleSearchChange,
        sx: {
            minWidth: 300
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, $79a0d4fc41924020$export$2e2bcd8739ae039), {
        size: "small",
        value: roleFilter,
        onChange: handleRoleFilterChange,
        sx: {
            minWidth: 150
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        value: "all"
    }, "All Roles"), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        value: "admin"
    }, "Admin"), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        value: "none"
    }, "Non-Admin"))), loading ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 4,
            gap: 1
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "#666"
        }
    }, "Loading users...")) : users.length === 0 ? /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            mt: 4,
            color: "#666"
        }
    }, "No users found.") : /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white overflow-x-auto"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $70cd81359a2961cc$export$2e2bcd8739ae039), {
        component: (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b1559ea0fc0c104d$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "user management table"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $9875ccd06eebee4b$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Email"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Name"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Role"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Site Count"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Created On"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, "Actions"))), /*#__PURE__*/ $eeH7J.createElement((0, $3b671b494e02bd1f$export$2e2bcd8739ae039), null, users.map((user)=>{
        const date = user.createdOn ? new Date(user.createdOn).toLocaleString() : "-";
        return /*#__PURE__*/ $eeH7J.createElement((0, $99390616b17525fb$export$2e2bcd8739ae039), {
            key: user.email,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row",
            className: "break-all"
        }, user.email), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, user.name || "-"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, user.role === "admin" ? "Admin" : "-"), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, user.siteCount ?? 0), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, date), /*#__PURE__*/ $eeH7J.createElement((0, $aae95013bbaee822$export$2e2bcd8739ae039), null, user.role === "admin" ? /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            color: "error",
            sx: {
                textTransform: "none"
            },
            onClick: ()=>handleToggleRole(user.email, user.role)
        }, "Remove Admin") : /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            sx: {
                textTransform: "none"
            },
            onClick: ()=>handleToggleRole(user.email, user.role)
        }, "Make Admin")));
    }))))));
};
var $bdc91bd954d694d3$export$2e2bcd8739ae039 = $bdc91bd954d694d3$var$UserManagement;




const $3e95173fd5aea333$var$STATUS_KEYS = [
    "status",
    "publishStatus",
    "pageStatus",
    "publishingStatus"
];
const $3e95173fd5aea333$var$isObjectLike = (value)=>value !== null && typeof value === "object";
const $3e95173fd5aea333$var$hasStatusKey = (value)=>$3e95173fd5aea333$var$isObjectLike(value) && $3e95173fd5aea333$var$STATUS_KEYS.some((key)=>value[key] !== undefined && value[key] !== null);
const $3e95173fd5aea333$export$f00a55a332eb5e99 = (response)=>{
    const queue = [
        response
    ];
    const seen = new Set();
    while(queue.length > 0){
        const current = queue.shift();
        if (!$3e95173fd5aea333$var$isObjectLike(current) || seen.has(current)) continue;
        seen.add(current);
        if ($3e95173fd5aea333$var$hasStatusKey(current)) return current;
        if (current.data !== undefined) queue.push(current.data);
        if (current.result !== undefined) queue.push(current.result);
        if (current.payload !== undefined) queue.push(current.payload);
    }
    return {};
};
const $3e95173fd5aea333$export$2fec6246253ef2cb = (value)=>String(value || "").trim().toLowerCase();


const $d468fc43ddb3813e$var$NAV_ITEMS = [
    {
        key: "colorPallets",
        label: "Color Pallets"
    },
    {
        key: "templateCategory",
        label: "Template Category"
    },
    {
        key: "publishTemplates",
        label: "Publish Templates"
    },
    {
        key: "userLogs",
        label: "User Acquisition Logs"
    },
    {
        key: "allSites",
        label: "Sites List"
    },
    {
        key: "aiTemplates",
        label: "AI Templates"
    },
    {
        key: "userManagement",
        label: "User Management"
    }
];
const $d468fc43ddb3813e$var$AdminPage = ()=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    // Marketing site id (fixed)
    const marketingSiteId = "2e2b85c5-1b76-4e74-8e39-c82749386c53";
    // Publish status for smart button
    const [publishInfo, setPublishInfo] = (0, $eeH7J.useState)({
        status: "Unknown",
        stuck: false,
        publishBatchStart: 0
    });
    const query = (0, $eeH7J.useMemo)(()=>new URLSearchParams(location.search), [
        location.search
    ]);
    const l_menu = query.get("menu");
    const activeMenu = l_menu || "colorPallets";
    const activeLabel = $d468fc43ddb3813e$var$NAV_ITEMS.find((item)=>item.key === activeMenu)?.label || "";
    // Polling interval ref so we can stop polling when publish is terminal
    const pollRef = (0, $eeH7J.useRef)(null);
    const fetchPublishInfo = async ()=>{
        try {
            const resp = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get("/api/configs/check-publish-status", {
                params: {
                    siteId: marketingSiteId
                }
            });
            const statusPayload = (0, $3e95173fd5aea333$export$f00a55a332eb5e99)(resp);
            setPublishInfo({
                status: (0, $3e95173fd5aea333$export$2fec6246253ef2cb)(statusPayload?.status ?? statusPayload?.publishStatus ?? statusPayload?.pageStatus ?? statusPayload?.publishingStatus) || "unknown",
                stuck: !!statusPayload?.stuck,
                publishBatchStart: Number(statusPayload?.publishBatchStart || 0)
            });
        } catch (e) {
        // Best effort. Don't spam errors in admin UI.
        // Keep previous publishInfo so button doesn't flicker.
        }
    };
    (0, $eeH7J.useEffect)(()=>{
        fetchPublishInfo();
        // Start polling
        pollRef.current = window.setInterval(fetchPublishInfo, 15000);
        return ()=>{
            if (pollRef.current !== null) {
                window.clearInterval(pollRef.current);
                pollRef.current = null;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        // Stop polling once publish reaches a terminal state
        const terminal = publishInfo.status === "completed" || publishInfo.status === "failed";
        if (terminal && pollRef.current !== null) {
            window.clearInterval(pollRef.current);
            pollRef.current = null;
        }
    }, [
        publishInfo.status
    ]);
    const handleMarketingSiteRepublish = async ()=>{
        setIsLoading(true);
        try {
            // Refresh current status just before action
            const statusRes = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get("/api/configs/check-publish-status", {
                params: {
                    siteId: marketingSiteId
                }
            });
            const statusPayload = (0, $3e95173fd5aea333$export$f00a55a332eb5e99)(statusRes);
            const status = (0, $3e95173fd5aea333$export$2fec6246253ef2cb)(statusPayload?.status ?? statusPayload?.publishStatus ?? statusPayload?.pageStatus ?? statusPayload?.publishingStatus);
            const stuck = !!statusPayload?.stuck;
            const publishBatchStart = Number(statusPayload?.publishBatchStart || 0);
            // If stuck -> resume
            if (status === "running" && stuck) {
                // Resume continues from the server's last saved batch/progress (publishBatchStart from status API),
                // not from any client-side split/halve calculation.
                await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/configs/publish/resume", {
                    siteId: marketingSiteId
                });
                (0, $4ff4ed24117608da$export$9d70c354f0150b1b)(`Publish was stuck. Resuming from batch ${Number(publishBatchStart || 0)}\u{2026}`, {
                    variant: "warning"
                });
                fetchPublishInfo();
                return;
            }
            // If running (fresh) -> do nothing
            if (status === "running") {
                (0, $4ff4ed24117608da$export$9d70c354f0150b1b)("Publish is already running\u2026", {
                    variant: "info"
                });
                return;
            }
            // Otherwise -> start publish
            const res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/configs/publish", {
                siteId: marketingSiteId,
                publishAllPages: true
            });
            if (res.status === 200) {
                (0, $4ff4ed24117608da$export$9d70c354f0150b1b)("Publishing in progress!", {
                    variant: "warning"
                });
                fetchPublishInfo();
            } else (0, $4ff4ed24117608da$export$9d70c354f0150b1b)("Could not start publish.", {
                variant: "error"
            });
        } catch (error) {
            console.error("Marketing republish/resume error", error);
            (0, $4ff4ed24117608da$export$9d70c354f0150b1b)("Something went wrong while publishing.", {
                variant: "error"
            });
        } finally{
            setIsLoading(false);
        }
    };
    const marketingButtonText = publishInfo.status === "running" && publishInfo.stuck ? `Resume Marketing Publish (batch ${publishInfo.publishBatchStart})` : publishInfo.status === "running" ? "Publishing\u2026" : "Republish Marketing Site";
    const marketingButtonDisabled = publishInfo.status === "running" && !publishInfo.stuck;
    const handleCategoryChange = (value)=>{
        const item = $d468fc43ddb3813e$var$NAV_ITEMS.find((i)=>i.label === value);
        if (item) navigate(`/admin?menu=${item.key}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $0206968a9c2cf7b5$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("title", null, "RocketPages - Admin Panel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        title: `Admin Panel${activeLabel ? ` | ${activeLabel}` : ""}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 top-[64px] hidden md:flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "left-navbar-tabs w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, $d468fc43ddb3813e$var$NAV_ITEMS.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
            className: `px-6 hover:cursor-pointer py-2 left-sidebar-tab-${item.key} ${activeMenu === item.key ? "bg-white-smoke text-catelina-blue" : ""}`,
            key: item.key,
            onClick: ()=>navigate(`/admin?menu=${item.key}`)
        }, item.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "mt-auto px-3 py-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        className: `w-full text-sm px-3 py-2 rounded ${marketingButtonDisabled ? "bg-gray-400 text-gray-200 cursor-not-allowed" : "bg-white text-catelina-blue hover:bg-gray-100 cursor-pointer"}`,
        disabled: marketingButtonDisabled,
        onClick: handleMarketingSiteRepublish
    }, marketingButtonText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "left-navbar-tab-contents min-h-screen w-full my-4 px-4 md:pl-[280px] pb-10 pt-[64px] bg-white-smoke flex flex-col overflow-x-auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex md:hidden py-2 items-center gap-3 flex-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $3fb1cc9123a3eb67$export$2e2bcd8739ae039), {
        items: $d468fc43ddb3813e$var$NAV_ITEMS.map((i)=>i.label),
        handleChange: handleCategoryChange,
        category: activeLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        className: `text-sm px-3 py-2 rounded whitespace-nowrap ${marketingButtonDisabled ? "bg-gray-400 text-gray-200 cursor-not-allowed" : "bg-catelina-blue text-white hover:bg-opacity-90 cursor-pointer"}`,
        disabled: marketingButtonDisabled,
        onClick: handleMarketingSiteRepublish
    }, marketingButtonText)), activeMenu === "colorPallets" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $9071317febea67fb$export$2e2bcd8739ae039), null), activeMenu === "templateCategory" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a428063360cac1df$export$2e2bcd8739ae039), null), activeMenu === "publishTemplates" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bab3eb00c9824b97$export$2e2bcd8739ae039), null), activeMenu === "userLogs" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d034b94394599c12$export$2e2bcd8739ae039), null), activeMenu === "allSites" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $e483083e346763c8$export$2e2bcd8739ae039), null), activeMenu === "aiTemplates" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bdaf1fd5e429426c$export$2e2bcd8739ae039), null), activeMenu === "userManagement" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bdc91bd954d694d3$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)));
};
var $d468fc43ddb3813e$export$2e2bcd8739ae039 = $d468fc43ddb3813e$var$AdminPage;


var $b6dd623e8e0959ca$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($b6dd623e8e0959ca$exports, "__esModule", {
    value: true
});
$b6dd623e8e0959ca$exports.default = void 0;

var $b6dd623e8e0959ca$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $b6dd623e8e0959ca$var$_default = $b6dd623e8e0959ca$exports.default = (0, $b6dd623e8e0959ca$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');





var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");
var $e0f87babb4ef1247$exports = {};
'use strict';
function $e0f87babb4ef1247$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $eeH7J = parcelRequire("eeH7J");
var $e0f87babb4ef1247$var$React__default = $e0f87babb4ef1247$var$_interopDefault($eeH7J);
function $e0f87babb4ef1247$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e0f87babb4ef1247$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e0f87babb4ef1247$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $e0f87babb4ef1247$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $e0f87babb4ef1247$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $e0f87babb4ef1247$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($eeH7J.PureComponent);
        $e0f87babb4ef1247$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $e0f87babb4ef1247$var$_defineProperty(SideEffect, "canUseDOM", $e0f87babb4ef1247$var$canUseDOM);
        return SideEffect;
    };
}
$e0f87babb4ef1247$exports = $e0f87babb4ef1247$var$withSideEffect;




var $eeH7J = parcelRequire("eeH7J");

var $eVtLI = parcelRequire("eVtLI");
var $a25478a9e2cddd17$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $a25478a9e2cddd17$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $a25478a9e2cddd17$var$VALID_TAG_NAMES = Object.keys($a25478a9e2cddd17$var$TAG_NAMES).map(function(name) {
    return $a25478a9e2cddd17$var$TAG_NAMES[name];
});
var $a25478a9e2cddd17$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $a25478a9e2cddd17$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $a25478a9e2cddd17$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $a25478a9e2cddd17$var$HTML_TAG_MAP = Object.keys($a25478a9e2cddd17$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$a25478a9e2cddd17$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $a25478a9e2cddd17$var$SELF_CLOSING_TAGS = [
    $a25478a9e2cddd17$var$TAG_NAMES.NOSCRIPT,
    $a25478a9e2cddd17$var$TAG_NAMES.SCRIPT,
    $a25478a9e2cddd17$var$TAG_NAMES.STYLE
];
var $a25478a9e2cddd17$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $a25478a9e2cddd17$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $a25478a9e2cddd17$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $a25478a9e2cddd17$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $a25478a9e2cddd17$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a25478a9e2cddd17$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $a25478a9e2cddd17$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $a25478a9e2cddd17$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $a25478a9e2cddd17$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $a25478a9e2cddd17$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $a25478a9e2cddd17$var$getInnermostProperty(propsList, $a25478a9e2cddd17$var$TAG_NAMES.TITLE);
    var innermostTemplate = $a25478a9e2cddd17$var$getInnermostProperty(propsList, $a25478a9e2cddd17$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $a25478a9e2cddd17$var$getInnermostProperty(propsList, $a25478a9e2cddd17$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $a25478a9e2cddd17$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $a25478a9e2cddd17$var$getInnermostProperty(propsList, $a25478a9e2cddd17$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $a25478a9e2cddd17$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $a25478a9e2cddd17$var$_extends({}, tagAttrs, current);
    }, {});
};
var $a25478a9e2cddd17$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$a25478a9e2cddd17$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$a25478a9e2cddd17$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $a25478a9e2cddd17$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $a25478a9e2cddd17$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $a25478a9e2cddd17$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $a25478a9e2cddd17$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $a25478a9e2cddd17$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $a25478a9e2cddd17$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $a25478a9e2cddd17$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $a25478a9e2cddd17$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($eVtLI)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $a25478a9e2cddd17$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $a25478a9e2cddd17$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $a25478a9e2cddd17$var$getBaseTagFromPropsList([
            $a25478a9e2cddd17$var$TAG_PROPERTIES.HREF,
            $a25478a9e2cddd17$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $a25478a9e2cddd17$var$getAttributesFromPropsList($a25478a9e2cddd17$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $a25478a9e2cddd17$var$getInnermostProperty(propsList, $a25478a9e2cddd17$var$HELMET_PROPS.DEFER),
        encode: $a25478a9e2cddd17$var$getInnermostProperty(propsList, $a25478a9e2cddd17$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $a25478a9e2cddd17$var$getAttributesFromPropsList($a25478a9e2cddd17$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $a25478a9e2cddd17$var$getTagsFromPropsList($a25478a9e2cddd17$var$TAG_NAMES.LINK, [
            $a25478a9e2cddd17$var$TAG_PROPERTIES.REL,
            $a25478a9e2cddd17$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $a25478a9e2cddd17$var$getTagsFromPropsList($a25478a9e2cddd17$var$TAG_NAMES.META, [
            $a25478a9e2cddd17$var$TAG_PROPERTIES.NAME,
            $a25478a9e2cddd17$var$TAG_PROPERTIES.CHARSET,
            $a25478a9e2cddd17$var$TAG_PROPERTIES.HTTPEQUIV,
            $a25478a9e2cddd17$var$TAG_PROPERTIES.PROPERTY,
            $a25478a9e2cddd17$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $a25478a9e2cddd17$var$getTagsFromPropsList($a25478a9e2cddd17$var$TAG_NAMES.NOSCRIPT, [
            $a25478a9e2cddd17$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $a25478a9e2cddd17$var$getOnChangeClientState(propsList),
        scriptTags: $a25478a9e2cddd17$var$getTagsFromPropsList($a25478a9e2cddd17$var$TAG_NAMES.SCRIPT, [
            $a25478a9e2cddd17$var$TAG_PROPERTIES.SRC,
            $a25478a9e2cddd17$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $a25478a9e2cddd17$var$getTagsFromPropsList($a25478a9e2cddd17$var$TAG_NAMES.STYLE, [
            $a25478a9e2cddd17$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $a25478a9e2cddd17$var$getTitleFromPropsList(propsList),
        titleAttributes: $a25478a9e2cddd17$var$getAttributesFromPropsList($a25478a9e2cddd17$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $a25478a9e2cddd17$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $a25478a9e2cddd17$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $a25478a9e2cddd17$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $a25478a9e2cddd17$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $a25478a9e2cddd17$var$rafPolyfill : $parcel$global.requestAnimationFrame || $a25478a9e2cddd17$var$rafPolyfill;
var $a25478a9e2cddd17$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $a25478a9e2cddd17$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $a25478a9e2cddd17$var$cafPolyfill;
var $a25478a9e2cddd17$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $a25478a9e2cddd17$var$_helmetCallback = null;
var $a25478a9e2cddd17$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($a25478a9e2cddd17$var$_helmetCallback) $a25478a9e2cddd17$var$cancelAnimationFrame($a25478a9e2cddd17$var$_helmetCallback);
    if (newState.defer) $a25478a9e2cddd17$var$_helmetCallback = $a25478a9e2cddd17$var$requestAnimationFrame(function() {
        $a25478a9e2cddd17$var$commitTagChanges(newState, function() {
            $a25478a9e2cddd17$var$_helmetCallback = null;
        });
    });
    else {
        $a25478a9e2cddd17$var$commitTagChanges(newState);
        $a25478a9e2cddd17$var$_helmetCallback = null;
    }
};
var $a25478a9e2cddd17$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $a25478a9e2cddd17$var$updateAttributes($a25478a9e2cddd17$var$TAG_NAMES.BODY, bodyAttributes);
    $a25478a9e2cddd17$var$updateAttributes($a25478a9e2cddd17$var$TAG_NAMES.HTML, htmlAttributes);
    $a25478a9e2cddd17$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $a25478a9e2cddd17$var$updateTags($a25478a9e2cddd17$var$TAG_NAMES.BASE, baseTag),
        linkTags: $a25478a9e2cddd17$var$updateTags($a25478a9e2cddd17$var$TAG_NAMES.LINK, linkTags),
        metaTags: $a25478a9e2cddd17$var$updateTags($a25478a9e2cddd17$var$TAG_NAMES.META, metaTags),
        noscriptTags: $a25478a9e2cddd17$var$updateTags($a25478a9e2cddd17$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $a25478a9e2cddd17$var$updateTags($a25478a9e2cddd17$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $a25478a9e2cddd17$var$updateTags($a25478a9e2cddd17$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $a25478a9e2cddd17$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $a25478a9e2cddd17$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $a25478a9e2cddd17$var$flattenArray(title);
    $a25478a9e2cddd17$var$updateAttributes($a25478a9e2cddd17$var$TAG_NAMES.TITLE, attributes);
};
var $a25478a9e2cddd17$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($a25478a9e2cddd17$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($a25478a9e2cddd17$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($a25478a9e2cddd17$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($a25478a9e2cddd17$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $a25478a9e2cddd17$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($a25478a9e2cddd17$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $a25478a9e2cddd17$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $a25478a9e2cddd17$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $a25478a9e2cddd17$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($a25478a9e2cddd17$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $a25478a9e2cddd17$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $a25478a9e2cddd17$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $a25478a9e2cddd17$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $a25478a9e2cddd17$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $a25478a9e2cddd17$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $a25478a9e2cddd17$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $a25478a9e2cddd17$var$HELMET_ATTRIBUTE + "=\"true\">" + $a25478a9e2cddd17$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $a25478a9e2cddd17$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $a25478a9e2cddd17$var$TAG_PROPERTIES.INNER_HTML || attribute === $a25478a9e2cddd17$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $a25478a9e2cddd17$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $a25478a9e2cddd17$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $a25478a9e2cddd17$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $a25478a9e2cddd17$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$a25478a9e2cddd17$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $a25478a9e2cddd17$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$a25478a9e2cddd17$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $a25478a9e2cddd17$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$a25478a9e2cddd17$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $a25478a9e2cddd17$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a25478a9e2cddd17$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $a25478a9e2cddd17$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$a25478a9e2cddd17$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $a25478a9e2cddd17$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $a25478a9e2cddd17$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $a25478a9e2cddd17$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(type, mappedTag);
    });
};
var $a25478a9e2cddd17$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $a25478a9e2cddd17$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $a25478a9e2cddd17$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $a25478a9e2cddd17$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $a25478a9e2cddd17$var$ATTRIBUTE_NAMES.BODY:
        case $a25478a9e2cddd17$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $a25478a9e2cddd17$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $a25478a9e2cddd17$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $a25478a9e2cddd17$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $a25478a9e2cddd17$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $a25478a9e2cddd17$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$TAG_NAMES.META, metaTags, encode),
        noscript: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $a25478a9e2cddd17$var$getMethodsForTag($a25478a9e2cddd17$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $a25478a9e2cddd17$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $a25478a9e2cddd17$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $a25478a9e2cddd17$var$classCallCheck(this, HelmetWrapper);
            return $a25478a9e2cddd17$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($0daa0da0e45174e2$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $a25478a9e2cddd17$var$TAG_NAMES.SCRIPT:
                case $a25478a9e2cddd17$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $a25478a9e2cddd17$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $a25478a9e2cddd17$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $a25478a9e2cddd17$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $a25478a9e2cddd17$var$TAG_NAMES.TITLE:
                    return $a25478a9e2cddd17$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $a25478a9e2cddd17$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $a25478a9e2cddd17$var$TAG_NAMES.BODY:
                    return $a25478a9e2cddd17$var$_extends({}, newProps, {
                        bodyAttributes: $a25478a9e2cddd17$var$_extends({}, newChildProps)
                    });
                case $a25478a9e2cddd17$var$TAG_NAMES.HTML:
                    return $a25478a9e2cddd17$var$_extends({}, newProps, {
                        htmlAttributes: $a25478a9e2cddd17$var$_extends({}, newChildProps)
                    });
            }
            return $a25478a9e2cddd17$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $a25478a9e2cddd17$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $a25478a9e2cddd17$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $a25478a9e2cddd17$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (!$a25478a9e2cddd17$var$VALID_TAG_NAMES.some(function(name) {
                return child.type === name;
            })) {
                if (typeof child.type === "function") return $a25478a9e2cddd17$var$warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                return $a25478a9e2cddd17$var$warn("Only elements types " + $a25478a9e2cddd17$var$VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
            }
            if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function(nestedChild) {
                return typeof nestedChild !== "string";
            }))) throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $a25478a9e2cddd17$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $a25478a9e2cddd17$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $a25478a9e2cddd17$var$TAG_NAMES.LINK:
                    case $a25478a9e2cddd17$var$TAG_NAMES.META:
                    case $a25478a9e2cddd17$var$TAG_NAMES.NOSCRIPT:
                    case $a25478a9e2cddd17$var$TAG_NAMES.SCRIPT:
                    case $a25478a9e2cddd17$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $a25478a9e2cddd17$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $a25478a9e2cddd17$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, newProps);
        };
        $a25478a9e2cddd17$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $a25478a9e2cddd17$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $a25478a9e2cddd17$var$NullComponent = function NullComponent() {
    return null;
};
var $a25478a9e2cddd17$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($e0f87babb4ef1247$exports)))($a25478a9e2cddd17$var$reducePropsToState, $a25478a9e2cddd17$var$handleClientStateChange, $a25478a9e2cddd17$var$mapStateOnServer)($a25478a9e2cddd17$var$NullComponent);
var $a25478a9e2cddd17$export$dcef8f9bb9a41431 = $a25478a9e2cddd17$var$Helmet($a25478a9e2cddd17$var$HelmetSideEffects);
$a25478a9e2cddd17$export$dcef8f9bb9a41431.renderStatic = $a25478a9e2cddd17$export$dcef8f9bb9a41431.rewind;
var $a25478a9e2cddd17$export$2e2bcd8739ae039 = $a25478a9e2cddd17$export$dcef8f9bb9a41431;




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5e4029a0026c7a4d$export$a143d493d941bafc;
var $5e4029a0026c7a4d$export$e4cf37d7f6fb9e0a;
var $5e4029a0026c7a4d$export$f99ded8fe4b79145;
var $5e4029a0026c7a4d$export$599f31c3813fae4d;
'use strict';
var $e99855b80474511a$export$a48f0734ac7c2329;
var $e99855b80474511a$export$d622b2ad8d90c771;
var $e99855b80474511a$export$6100ba28696e12de;
'use strict';
$e99855b80474511a$export$a48f0734ac7c2329 = $e99855b80474511a$var$byteLength;
$e99855b80474511a$export$d622b2ad8d90c771 = $e99855b80474511a$var$toByteArray;
$e99855b80474511a$export$6100ba28696e12de = $e99855b80474511a$var$fromByteArray;
var $e99855b80474511a$var$lookup = [];
var $e99855b80474511a$var$revLookup = [];
var $e99855b80474511a$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e99855b80474511a$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e99855b80474511a$var$i = 0, $e99855b80474511a$var$len = $e99855b80474511a$var$code.length; $e99855b80474511a$var$i < $e99855b80474511a$var$len; ++$e99855b80474511a$var$i){
    $e99855b80474511a$var$lookup[$e99855b80474511a$var$i] = $e99855b80474511a$var$code[$e99855b80474511a$var$i];
    $e99855b80474511a$var$revLookup[$e99855b80474511a$var$code.charCodeAt($e99855b80474511a$var$i)] = $e99855b80474511a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e99855b80474511a$var$revLookup['-'.charCodeAt(0)] = 62;
$e99855b80474511a$var$revLookup['_'.charCodeAt(0)] = 63;
function $e99855b80474511a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e99855b80474511a$var$byteLength(b64) {
    var lens = $e99855b80474511a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e99855b80474511a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e99855b80474511a$var$toByteArray(b64) {
    var tmp;
    var lens = $e99855b80474511a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e99855b80474511a$var$Arr($e99855b80474511a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e99855b80474511a$var$revLookup[b64.charCodeAt(i)] << 18 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e99855b80474511a$var$revLookup[b64.charCodeAt(i)] << 2 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e99855b80474511a$var$revLookup[b64.charCodeAt(i)] << 10 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e99855b80474511a$var$tripletToBase64(num) {
    return $e99855b80474511a$var$lookup[num >> 18 & 0x3F] + $e99855b80474511a$var$lookup[num >> 12 & 0x3F] + $e99855b80474511a$var$lookup[num >> 6 & 0x3F] + $e99855b80474511a$var$lookup[num & 0x3F];
}
function $e99855b80474511a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e99855b80474511a$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e99855b80474511a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e99855b80474511a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e99855b80474511a$var$lookup[tmp >> 2] + $e99855b80474511a$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e99855b80474511a$var$lookup[tmp >> 10] + $e99855b80474511a$var$lookup[tmp >> 4 & 0x3F] + $e99855b80474511a$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $97f2cbef79bb903e$export$aafa59e2e03f2942;
var $97f2cbef79bb903e$export$68d8715fc104d294;
$97f2cbef79bb903e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$97f2cbef79bb903e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $5e4029a0026c7a4d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$5e4029a0026c7a4d$export$a143d493d941bafc = $5e4029a0026c7a4d$var$Buffer;
$5e4029a0026c7a4d$export$e4cf37d7f6fb9e0a = $5e4029a0026c7a4d$var$SlowBuffer;
$5e4029a0026c7a4d$export$f99ded8fe4b79145 = 50;
const $5e4029a0026c7a4d$var$K_MAX_LENGTH = 0x7fffffff;
$5e4029a0026c7a4d$export$599f31c3813fae4d = $5e4029a0026c7a4d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5e4029a0026c7a4d$var$Buffer.TYPED_ARRAY_SUPPORT = $5e4029a0026c7a4d$var$typedArraySupport();
if (!$5e4029a0026c7a4d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5e4029a0026c7a4d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5e4029a0026c7a4d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5e4029a0026c7a4d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5e4029a0026c7a4d$var$createBuffer(length) {
    if (length > $5e4029a0026c7a4d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5e4029a0026c7a4d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5e4029a0026c7a4d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5e4029a0026c7a4d$var$allocUnsafe(arg);
    }
    return $5e4029a0026c7a4d$var$from(arg, encodingOrOffset, length);
}
$5e4029a0026c7a4d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5e4029a0026c7a4d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $5e4029a0026c7a4d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5e4029a0026c7a4d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5e4029a0026c7a4d$var$isInstance(value, ArrayBuffer) || value && $5e4029a0026c7a4d$var$isInstance(value.buffer, ArrayBuffer)) return $5e4029a0026c7a4d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($5e4029a0026c7a4d$var$isInstance(value, SharedArrayBuffer) || value && $5e4029a0026c7a4d$var$isInstance(value.buffer, SharedArrayBuffer))) return $5e4029a0026c7a4d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5e4029a0026c7a4d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5e4029a0026c7a4d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $5e4029a0026c7a4d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5e4029a0026c7a4d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5e4029a0026c7a4d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5e4029a0026c7a4d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5e4029a0026c7a4d$var$Buffer, Uint8Array);
function $5e4029a0026c7a4d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5e4029a0026c7a4d$var$alloc(size, fill, encoding) {
    $5e4029a0026c7a4d$var$assertSize(size);
    if (size <= 0) return $5e4029a0026c7a4d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $5e4029a0026c7a4d$var$createBuffer(size).fill(fill, encoding) : $5e4029a0026c7a4d$var$createBuffer(size).fill(fill);
    return $5e4029a0026c7a4d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5e4029a0026c7a4d$var$Buffer.alloc = function(size, fill, encoding) {
    return $5e4029a0026c7a4d$var$alloc(size, fill, encoding);
};
function $5e4029a0026c7a4d$var$allocUnsafe(size) {
    $5e4029a0026c7a4d$var$assertSize(size);
    return $5e4029a0026c7a4d$var$createBuffer(size < 0 ? 0 : $5e4029a0026c7a4d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5e4029a0026c7a4d$var$Buffer.allocUnsafe = function(size) {
    return $5e4029a0026c7a4d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5e4029a0026c7a4d$var$Buffer.allocUnsafeSlow = function(size) {
    return $5e4029a0026c7a4d$var$allocUnsafe(size);
};
function $5e4029a0026c7a4d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$5e4029a0026c7a4d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $5e4029a0026c7a4d$var$byteLength(string, encoding) | 0;
    let buf = $5e4029a0026c7a4d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5e4029a0026c7a4d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5e4029a0026c7a4d$var$checked(array.length) | 0;
    const buf = $5e4029a0026c7a4d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5e4029a0026c7a4d$var$fromArrayView(arrayView) {
    if ($5e4029a0026c7a4d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5e4029a0026c7a4d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5e4029a0026c7a4d$var$fromArrayLike(arrayView);
}
function $5e4029a0026c7a4d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5e4029a0026c7a4d$var$Buffer.prototype);
    return buf;
}
function $5e4029a0026c7a4d$var$fromObject(obj) {
    if ($5e4029a0026c7a4d$var$Buffer.isBuffer(obj)) {
        const len = $5e4029a0026c7a4d$var$checked(obj.length) | 0;
        const buf = $5e4029a0026c7a4d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $5e4029a0026c7a4d$var$numberIsNaN(obj.length)) return $5e4029a0026c7a4d$var$createBuffer(0);
        return $5e4029a0026c7a4d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $5e4029a0026c7a4d$var$fromArrayLike(obj.data);
}
function $5e4029a0026c7a4d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5e4029a0026c7a4d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5e4029a0026c7a4d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $5e4029a0026c7a4d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5e4029a0026c7a4d$var$Buffer.alloc(+length);
}
$5e4029a0026c7a4d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5e4029a0026c7a4d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5e4029a0026c7a4d$var$Buffer.compare = function compare(a, b) {
    if ($5e4029a0026c7a4d$var$isInstance(a, Uint8Array)) a = $5e4029a0026c7a4d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5e4029a0026c7a4d$var$isInstance(b, Uint8Array)) b = $5e4029a0026c7a4d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(a) || !$5e4029a0026c7a4d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5e4029a0026c7a4d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$5e4029a0026c7a4d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5e4029a0026c7a4d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5e4029a0026c7a4d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5e4029a0026c7a4d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(buf)) buf = $5e4029a0026c7a4d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5e4029a0026c7a4d$var$byteLength(string, encoding) {
    if ($5e4029a0026c7a4d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5e4029a0026c7a4d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $5e4029a0026c7a4d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $5e4029a0026c7a4d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5e4029a0026c7a4d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5e4029a0026c7a4d$var$Buffer.byteLength = $5e4029a0026c7a4d$var$byteLength;
function $5e4029a0026c7a4d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $5e4029a0026c7a4d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $5e4029a0026c7a4d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $5e4029a0026c7a4d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $5e4029a0026c7a4d$var$latin1Slice(this, start, end);
        case 'base64':
            return $5e4029a0026c7a4d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5e4029a0026c7a4d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5e4029a0026c7a4d$var$Buffer.prototype._isBuffer = true;
function $5e4029a0026c7a4d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5e4029a0026c7a4d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$5e4029a0026c7a4d$var$swap(this, i, i + 1);
    return this;
};
$5e4029a0026c7a4d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $5e4029a0026c7a4d$var$swap(this, i, i + 3);
        $5e4029a0026c7a4d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5e4029a0026c7a4d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $5e4029a0026c7a4d$var$swap(this, i, i + 7);
        $5e4029a0026c7a4d$var$swap(this, i + 1, i + 6);
        $5e4029a0026c7a4d$var$swap(this, i + 2, i + 5);
        $5e4029a0026c7a4d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5e4029a0026c7a4d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $5e4029a0026c7a4d$var$utf8Slice(this, 0, length);
    return $5e4029a0026c7a4d$var$slowToString.apply(this, arguments);
};
$5e4029a0026c7a4d$var$Buffer.prototype.toLocaleString = $5e4029a0026c7a4d$var$Buffer.prototype.toString;
$5e4029a0026c7a4d$var$Buffer.prototype.equals = function equals(b) {
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $5e4029a0026c7a4d$var$Buffer.compare(this, b) === 0;
};
$5e4029a0026c7a4d$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $5e4029a0026c7a4d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($5e4029a0026c7a4d$var$customInspectSymbol) $5e4029a0026c7a4d$var$Buffer.prototype[$5e4029a0026c7a4d$var$customInspectSymbol] = $5e4029a0026c7a4d$var$Buffer.prototype.inspect;
$5e4029a0026c7a4d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5e4029a0026c7a4d$var$isInstance(target, Uint8Array)) target = $5e4029a0026c7a4d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5e4029a0026c7a4d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5e4029a0026c7a4d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $5e4029a0026c7a4d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5e4029a0026c7a4d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5e4029a0026c7a4d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5e4029a0026c7a4d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $5e4029a0026c7a4d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5e4029a0026c7a4d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5e4029a0026c7a4d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5e4029a0026c7a4d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5e4029a0026c7a4d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5e4029a0026c7a4d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5e4029a0026c7a4d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5e4029a0026c7a4d$var$utf8Write(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5e4029a0026c7a4d$var$asciiWrite(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$asciiToBytes(string), buf, offset, length);
}
function $5e4029a0026c7a4d$var$base64Write(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$base64ToBytes(string), buf, offset, length);
}
function $5e4029a0026c7a4d$var$ucs2Write(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5e4029a0026c7a4d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $5e4029a0026c7a4d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $5e4029a0026c7a4d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $5e4029a0026c7a4d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $5e4029a0026c7a4d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5e4029a0026c7a4d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5e4029a0026c7a4d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5e4029a0026c7a4d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e99855b80474511a$export$6100ba28696e12de(buf);
    else return $e99855b80474511a$export$6100ba28696e12de(buf.slice(start, end));
}
function $5e4029a0026c7a4d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5e4029a0026c7a4d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5e4029a0026c7a4d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5e4029a0026c7a4d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5e4029a0026c7a4d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5e4029a0026c7a4d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5e4029a0026c7a4d$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5e4029a0026c7a4d$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5e4029a0026c7a4d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $5e4029a0026c7a4d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5e4029a0026c7a4d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5e4029a0026c7a4d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5e4029a0026c7a4d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5e4029a0026c7a4d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$5e4029a0026c7a4d$var$Buffer.prototype.readUintLE = $5e4029a0026c7a4d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUintBE = $5e4029a0026c7a4d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint8 = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint16LE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint16BE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint32LE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint32BE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readBigUInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5e4029a0026c7a4d$var$Buffer.prototype.readBigUInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5e4029a0026c7a4d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5e4029a0026c7a4d$var$Buffer.prototype.readBigInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5e4029a0026c7a4d$var$Buffer.prototype.readBigInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5e4029a0026c7a4d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return $97f2cbef79bb903e$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return $97f2cbef79bb903e$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 8, this.length);
    return $97f2cbef79bb903e$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 8, this.length);
    return $97f2cbef79bb903e$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $5e4029a0026c7a4d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeUintLE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUintBE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint8 = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint16LE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint16BE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint32LE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint32BE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5e4029a0026c7a4d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5e4029a0026c7a4d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5e4029a0026c7a4d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5e4029a0026c7a4d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigUInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigUInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$5e4029a0026c7a4d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $5e4029a0026c7a4d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $5e4029a0026c7a4d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $97f2cbef79bb903e$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeFloat(this, value, offset, true, noAssert);
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeFloat(this, value, offset, false, noAssert);
};
function $5e4029a0026c7a4d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $97f2cbef79bb903e$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeDouble(this, value, offset, true, noAssert);
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5e4029a0026c7a4d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5e4029a0026c7a4d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$5e4029a0026c7a4d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5e4029a0026c7a4d$var$Buffer.isBuffer(val) ? val : $5e4029a0026c7a4d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5e4029a0026c7a4d$var$errors = {};
function $5e4029a0026c7a4d$var$E(sym, getMessage, Base) {
    $5e4029a0026c7a4d$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5e4029a0026c7a4d$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$5e4029a0026c7a4d$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5e4029a0026c7a4d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5e4029a0026c7a4d$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5e4029a0026c7a4d$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5e4029a0026c7a4d$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5e4029a0026c7a4d$var$checkBounds(buf, offset, byteLength) {
    $5e4029a0026c7a4d$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5e4029a0026c7a4d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5e4029a0026c7a4d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5e4029a0026c7a4d$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $5e4029a0026c7a4d$var$checkBounds(buf, offset, byteLength);
}
function $5e4029a0026c7a4d$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $5e4029a0026c7a4d$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $5e4029a0026c7a4d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5e4029a0026c7a4d$var$validateNumber(value, type);
        throw new $5e4029a0026c7a4d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $5e4029a0026c7a4d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5e4029a0026c7a4d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5e4029a0026c7a4d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5e4029a0026c7a4d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5e4029a0026c7a4d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $5e4029a0026c7a4d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $5e4029a0026c7a4d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5e4029a0026c7a4d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5e4029a0026c7a4d$var$base64ToBytes(str) {
    return $e99855b80474511a$export$d622b2ad8d90c771($5e4029a0026c7a4d$var$base64clean(str));
}
function $5e4029a0026c7a4d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5e4029a0026c7a4d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5e4029a0026c7a4d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5e4029a0026c7a4d$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5e4029a0026c7a4d$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $5e4029a0026c7a4d$var$BufferBigIntNotDefined : fn;
}
function $5e4029a0026c7a4d$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}



var $eeH7J = parcelRequire("eeH7J");

const $526468a3beeb20e6$var$CategoryItem = (props)=>{
    // const [isChecked, setIsChecked] = React.useState(props.isChecked);
    const onCheckChange = ()=>{
        // setIsChecked(!isChecked);
        props.onCheckChanged(!props.isChecked);
    };
    const screenWidth = screen.width;
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex w-full flex-row md:text-white text-sm font-body",
        "data-test": props['data-test']
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: ""
    }, /*#__PURE__*/ $eeH7J.createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
        className: "md:hidden",
        checked: props.isChecked,
        onChange: onCheckChange,
        size: "small",
        sx: {
            color: '#3B3B3B',
            fontSize: "14px",
            "&.Mui-checked": {
                color: '#3B3B3B'
            }
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
        className: "hidden md:inline-flex",
        checked: props.isChecked,
        onChange: (e)=>{
            onCheckChange();
        },
        size: "small",
        sx: {
            color: 'white',
            fontSize: "14px",
            "&.Mui-checked": {
                color: 'white'
            }
        }
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full self-center hover:cursor-pointer text-grey-primary md:text-white",
        onClick: ()=>onCheckChange()
    }, props.item.category), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-8 self-center"
    }, props.item.cnt));
};
var $526468a3beeb20e6$export$2e2bcd8739ae039 = $526468a3beeb20e6$var$CategoryItem;



var $eeH7J = parcelRequire("eeH7J");

const $fe2aebb6bc6e27f2$var$TemplateTypeItem = (props)=>{
    // const [isChecked, setIsChecked] = React.useState(props.isChecked);
    const onCheckFilterTypeChange = ()=>{
        // setIsChecked(!isChecked);
        props.onCheckFilterTypeChanged(!props.isChecked);
    };
    // console.log(props.item)
    const screenWidth = screen.width;
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex w-full flex-row md:text-white text-sm font-body",
        "data-test": props['data-test']
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: ""
    }, /*#__PURE__*/ $eeH7J.createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
        className: "md:hidden",
        checked: props.isChecked,
        onChange: (e)=>{
            onCheckFilterTypeChange();
        },
        size: "small",
        sx: {
            color: '#3B3B3B',
            fontSize: "14px",
            "&.Mui-checked": {
                color: '#3B3B3B'
            }
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
        className: "hidden md:inline-flex",
        checked: props.isChecked,
        onChange: (e)=>{
            onCheckFilterTypeChange();
        },
        size: "small",
        sx: {
            color: 'white',
            fontSize: "14px",
            "&.Mui-checked": {
                color: 'white'
            }
        }
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full self-center hover:cursor-pointer text-grey-primary md:text-white",
        onClick: ()=>onCheckFilterTypeChange()
    }, props.item.category), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-8 self-center hidden"
    }, props.item.cnt));
};
var $fe2aebb6bc6e27f2$export$2e2bcd8739ae039 = $fe2aebb6bc6e27f2$var$TemplateTypeItem;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $kA5Ko = parcelRequire("kA5Ko");

var $hZDOg = parcelRequire("hZDOg");

var $doIAf = parcelRequire("doIAf");

var $h4XE0 = parcelRequire("h4XE0");
function $afd69acea0363b0f$export$2e2bcd8739ae039(componentNameInError, Component) {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    const prevPropTypes = Component ? (0, $h4XE0.default)({}, Component.propTypes) : null;
    const requireProp = (requiredProp)=>(props, propName, componentName, location, propFullName, ...args)=>{
            const propFullNameSafe = propFullName || propName;
            const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
            if (defaultTypeChecker) {
                const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
                if (typeCheckerResult) return typeCheckerResult;
            }
            if (typeof props[propName] !== 'undefined' && !props[requiredProp]) return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
            return null;
        };
    return requireProp;
}


var $97f6aac9c3fdf6ef$export$2e2bcd8739ae039 = (0, $afd69acea0363b0f$export$2e2bcd8739ae039);



var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");


var $eeH7J = parcelRequire("eeH7J");
'use client';
/**
 * @ignore - internal component.
 */ const $0d4e5f1f31dd10ec$var$GridContext = /*#__PURE__*/ $eeH7J.createContext();
$0d4e5f1f31dd10ec$var$GridContext.displayName = 'GridContext';
var $0d4e5f1f31dd10ec$export$2e2bcd8739ae039 = $0d4e5f1f31dd10ec$var$GridContext;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $f716bb213d426f7b$export$9973ac5fd0181f33(slot) {
    return (0, $aBqGi.default)('MuiGrid', slot);
}
const $f716bb213d426f7b$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f716bb213d426f7b$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f716bb213d426f7b$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f716bb213d426f7b$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f716bb213d426f7b$var$gridClasses = (0, $cDqLM.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$f716bb213d426f7b$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f716bb213d426f7b$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f716bb213d426f7b$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f716bb213d426f7b$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f716bb213d426f7b$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f716bb213d426f7b$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f716bb213d426f7b$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f716bb213d426f7b$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f716bb213d426f7b$export$2e2bcd8739ae039 = $f716bb213d426f7b$var$gridClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $bb7a4364933bd727$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $bb7a4364933bd727$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $bb7a4364933bd727$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $kA5Ko.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$bb7a4364933bd727$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $h4XE0.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $bb7a4364933bd727$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $kA5Ko.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $kA5Ko.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $f716bb213d426f7b$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $bb7a4364933bd727$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $bb7a4364933bd727$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $kA5Ko.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $bb7a4364933bd727$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $kA5Ko.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$bb7a4364933bd727$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f716bb213d426f7b$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $bb7a4364933bd727$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f716bb213d426f7b$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $bb7a4364933bd727$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $kA5Ko.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $bb7a4364933bd727$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $kA5Ko.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$bb7a4364933bd727$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$bb7a4364933bd727$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f716bb213d426f7b$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $bb7a4364933bd727$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $f716bb213d426f7b$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $bb7a4364933bd727$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $bb7a4364933bd727$var$GridRoot = (0, $hikmr.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $bb7a4364933bd727$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $bb7a4364933bd727$export$71d4225eeb1bc13e, $bb7a4364933bd727$export$380604d7c79f9e8f, $bb7a4364933bd727$export$4315fba5128fb4a1, $bb7a4364933bd727$export$ca2a698f6020fda);
function $bb7a4364933bd727$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $bb7a4364933bd727$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $bb7a4364933bd727$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $doIAf.default)(slots, (0, $f716bb213d426f7b$export$9973ac5fd0181f33), classes);
};
const $bb7a4364933bd727$var$Grid = /*#__PURE__*/ $eeH7J.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $c7b8a7ef63736600$export$2e2bcd8739ae039)();
    const props = (0, $hZDOg.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $fbOaB.default)(props, $bb7a4364933bd727$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $eeH7J.useContext((0, $0d4e5f1f31dd10ec$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $h4XE0.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $h4XE0.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $bb7a4364933bd727$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $0d4e5f1f31dd10ec$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($bb7a4364933bd727$var$GridRoot, (0, $h4XE0.default)({
            ownerState: ownerState,
            className: (0, $er6YD.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
$bb7a4364933bd727$var$Grid.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The number of columns.
   * @default 12
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ columnSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ item: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */ lg: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */ md: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ]),
    /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ rowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */ sm: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ]),
    /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */ wrap: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'nowrap',
        'wrap-reverse',
        'wrap'
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */ xl: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */ xs: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ]),
    /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */ zeroMinWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
};
{
    const requireProp = (0, $97f6aac9c3fdf6ef$export$2e2bcd8739ae039)('Grid', $bb7a4364933bd727$var$Grid);
    // eslint-disable-next-line no-useless-concat
    $bb7a4364933bd727$var$Grid["propTypes"] = (0, $h4XE0.default)({}, $bb7a4364933bd727$var$Grid.propTypes, {
        direction: requireProp('container'),
        lg: requireProp('item'),
        md: requireProp('item'),
        sm: requireProp('item'),
        spacing: requireProp('container'),
        wrap: requireProp('container'),
        xs: requireProp('item'),
        zeroMinWidth: requireProp('item')
    });
}var $bb7a4364933bd727$export$2e2bcd8739ae039 = $bb7a4364933bd727$var$Grid;




var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");






var $4yBem = parcelRequire("4yBem");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");


var $gvqxq = parcelRequire("gvqxq");

var $aBqGi = parcelRequire("aBqGi");

var $doIAf = parcelRequire("doIAf");

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $jKjg1 = parcelRequire("jKjg1");

var $gvqxq = parcelRequire("gvqxq");

var $3Rthm = parcelRequire("3Rthm");

var $cXju3 = parcelRequire("cXju3");

var $kO80n = parcelRequire("kO80n");

var $zC31W = parcelRequire("zC31W");
const $8a92a5fb337350c2$var$_excluded = [
    "ownerState"
], $8a92a5fb337350c2$var$_excluded2 = [
    "variants"
], $8a92a5fb337350c2$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $8a92a5fb337350c2$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $8a92a5fb337350c2$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $8a92a5fb337350c2$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $8a92a5fb337350c2$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $8a92a5fb337350c2$export$35e57303dbd8a66 = (0, $kO80n.default)();
const $8a92a5fb337350c2$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $8a92a5fb337350c2$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $8a92a5fb337350c2$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $8a92a5fb337350c2$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $8a92a5fb337350c2$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $fbOaB.default)(_ref, $8a92a5fb337350c2$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $h4XE0.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$8a92a5fb337350c2$var$processStyleArg(resolvedStyle, (0, $h4XE0.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $fbOaB.default)(resolvedStylesArg, $8a92a5fb337350c2$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $h4XE0.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $h4XE0.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $8a92a5fb337350c2$var$shallowLayer((0, $jKjg1.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $8a92a5fb337350c2$var$shallowLayer((0, $jKjg1.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $8a92a5fb337350c2$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $8a92a5fb337350c2$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $8a92a5fb337350c2$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $8a92a5fb337350c2$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $zC31W.default)((0, $h4XE0.default)({}, props, {
            theme: $8a92a5fb337350c2$var$resolveTheme((0, $h4XE0.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $jKjg1.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $8a92a5fb337350c2$var$defaultOverridesResolver($8a92a5fb337350c2$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $fbOaB.default)(inputOptions, $8a92a5fb337350c2$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        if (componentName) // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${$8a92a5fb337350c2$var$lowercaseFirstLetter(componentSlot || 'Root')}`;
        let shouldForwardPropOption = $8a92a5fb337350c2$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($8a92a5fb337350c2$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $jKjg1.default)(tag, (0, $h4XE0.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $gvqxq.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $8a92a5fb337350c2$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $8a92a5fb337350c2$var$processStyleArg(stylesArg, (0, $h4XE0.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $8a92a5fb337350c2$var$resolveTheme((0, $h4XE0.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $8a92a5fb337350c2$var$processStyleArg(slotStyle, (0, $h4XE0.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $8a92a5fb337350c2$var$resolveTheme((0, $h4XE0.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $8a92a5fb337350c2$var$processStyleArg({
                    variants: themeVariants
                }, (0, $h4XE0.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            {
                let displayName;
                if (componentName) displayName = `${componentName}${(0, $3Rthm.default)(componentSlot || '')}`;
                if (displayName === undefined) displayName = `Styled(${(0, $cXju3.default)(tag)})`;
                Component.displayName = displayName;
            }
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $24e3fd750d7cd7c6$var$styled = (0, $8a92a5fb337350c2$export$2e2bcd8739ae039)();
var $24e3fd750d7cd7c6$export$2e2bcd8739ae039 = $24e3fd750d7cd7c6$var$styled;



var $8hRD1 = parcelRequire("8hRD1");
function $6adaeb2a03c030f8$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $8hRD1.default)(theme.components[name].defaultProps, props);
}



'use client';
function $8c1ba3299ee127fd$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $f08d602dd3ba2736$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $6adaeb2a03c030f8$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $hZDOg = parcelRequire("hZDOg");

var $kO80n = parcelRequire("kO80n");

var $kA5Ko = parcelRequire("kA5Ko");

var $hvMj8 = parcelRequire("hvMj8");

var $dRzna = parcelRequire("dRzna");
const $8ea6430efc1df41a$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $8ea6430efc1df41a$var$defaultTheme = (0, $kO80n.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $8ea6430efc1df41a$var$defaultCreateStyledComponent = (0, $24e3fd750d7cd7c6$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $8ea6430efc1df41a$var$useThemePropsDefault(props) {
    return (0, $8c1ba3299ee127fd$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $8ea6430efc1df41a$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $8ea6430efc1df41a$var$joinChildren(children, separator) {
    const childrenArray = $eeH7J.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $eeH7J.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $8ea6430efc1df41a$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $8ea6430efc1df41a$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $h4XE0.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $kA5Ko.handleBreakpoints)({
        theme: theme
    }, (0, $kA5Ko.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $hvMj8.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $kA5Ko.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $kA5Ko.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $hvMj8.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$8ea6430efc1df41a$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $hvMj8.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $gvqxq.default)(styles, (0, $kA5Ko.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $kA5Ko.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $8ea6430efc1df41a$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $8ea6430efc1df41a$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $8ea6430efc1df41a$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $doIAf.default)(slots, (slot)=>(0, $aBqGi.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($8ea6430efc1df41a$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $eeH7J.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $hZDOg.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $fbOaB.default)(props, $8ea6430efc1df41a$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $dRzna.jsx)(StackRoot, (0, $h4XE0.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $de137779e6107095$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            children: divider ? $8ea6430efc1df41a$var$joinChildren(children, divider) : children
        }));
    });
    Stack.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        divider: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
        spacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        ]),
        sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    };
    return Stack;
}



var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");
'use client';
const $b764c91e8a13a465$var$Stack = (0, $8ea6430efc1df41a$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $hikmr.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $lNnGW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
$b764c91e8a13a465$var$Stack.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Add an element between each child.
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Defines the space between immediate children.
   * @default 0
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */ useFlexGap: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
};
var $b764c91e8a13a465$export$2e2bcd8739ae039 = $b764c91e8a13a465$var$Stack;



const $e9986a730e2f735d$var$TemplateItem = (props)=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    // console.log("TemplateItem", props);
    const [showOption, setShowOption] = $eeH7J.useState(false);
    const [isLoading, setIsLoading] = $eeH7J.useState(true);
    const [selectedColorPallet, setSelectedColorPallet] = $eeH7J.useState({
        ...props.templateColorPalettes[0],
        initial: true
    });
    $eeH7J.useEffect(()=>{}, [
        selectedColorPallet
    ]);
    const handleImageLoad = ()=>{
        setIsLoading(false);
    };
    return /*#__PURE__*/ $eeH7J.createElement((0, $bb7a4364933bd727$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        item: true,
        lg: 4,
        md: 6,
        sm: 6,
        xs: 12,
        "data-test": "template",
        "data-page-count": props.pageCount,
        "data-categories": props.templateCategories
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row justify-between items-center text-black text-sm py-2"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, props.templateName), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row items-center"
    }, props.templateColorPalettes.map((row)=>{
        let colorPallet = props.colorPallets.length > 0 && props.colorPallets.find((oo)=>oo.id === row.id) || null;
        // console.log("for each", colorPallet.colors);
        return colorPallet ? /*#__PURE__*/ $eeH7J.createElement("div", {
            onClick: ()=>setSelectedColorPallet(row),
            key: row.id,
            className: `flex flex-row  color-icon relative  hover:cursor-pointer`
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `h-6 w-3 block rounded-l-full ${selectedColorPallet.id === row.id ? "border-y border-l border-black" : "border-y border-l border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[0].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "icon-tooltip-text brand-color-tooltip"
        }, "Select brand colors"), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `h-3 w-3 block rounded-tr-full ${selectedColorPallet.id === row.id ? "border-t border-r border-black" : "border-t border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[1].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `h-3 w-3 block rounded-br-full ${selectedColorPallet.id === row.id ? "border-b border-r border-black" : "border-b border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[3].toLowerCase() : ""
            }
        }))) : /*#__PURE__*/ $eeH7J.createElement("div", {
            key: row.id,
            className: `flex flex-row relative`
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `h-6 w-3 block rounded-l-full`
        }));
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col hover:cursor-pointer relative shadow-lg",
        "data-test": "template-image",
        onMouseOver: ()=>setShowOption(true),
        onMouseLeave: ()=>setShowOption(false)
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "upper-block flex flex-col "
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("9wJDx"))
    }), isLoading && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "inner-block flex flex-col"
    }), selectedColorPallet.imageUrl ? /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: `${showOption && !isLoading ? "bg-black opacity-30" : ""} ${isLoading ? "hidden" : "block"} image-template`,
        src: `${selectedColorPallet.imageUrl}?w=162&auto=format`,
        srcSet: `${selectedColorPallet.imageUrl}?w=162&auto=format&dpr=2 2x`,
        alt: props.templateName,
        loading: "lazy",
        onLoad: handleImageLoad,
        onError: handleImageLoad,
        style: {
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            display: "block",
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.2)"
        }
    })) : /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "min-h-96 flex items-center justify-center",
        style: {
            minHeight: "700px"
        }
    }, /*#__PURE__*/ $eeH7J.createElement("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-red",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ $eeH7J.createElement("circle", {
        className: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        strokeWidth: "4"
    }), /*#__PURE__*/ $eeH7J.createElement("path", {
        className: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })), " ", "Loading"), showOption && !isLoading && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute w-full h-full  flex justify-center items-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b764c91e8a13a465$export$2e2bcd8739ae039), {
        direction: "column",
        spacing: 1
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#fff",
            color: "#243060",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>{
            // console.log("on edit", props);
            window.location.href = `${"https://editorstage.rocketpages.io"}/?tid=${props.siteId}&theme=${selectedColorPallet ? selectedColorPallet.id : ""}`;
        // window.location.reload();
        },
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99435d3d07a9b8ca$exports))), null)
    }, "Edit site"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#fff",
            color: "#243060",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>{
            // window.location.href = props.previewUrl
            // navigate(`/preview/${props.siteId}`, {
            //   state: { selectedColorPallet },
            // });
            const url = `/preview/${props.siteId}?id=${selectedColorPallet.id}`;
            window.open(url, "_blank");
        },
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($68b84ea65a9d38b0$exports))), null)
    }, "Preview"))))));
};
var $e9986a730e2f735d$export$2e2bcd8739ae039 = $e9986a730e2f735d$var$TemplateItem;


const $9b212d1933b28659$var$TemplateBody = (props)=>{
    // console.log('TemplateBody',props);
    const heights = [
        150,
        30,
        90,
        70,
        110,
        150,
        130,
        80,
        50,
        90,
        100,
        150,
        30,
        50,
        80
    ];
    return /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            minHeight: 829
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $bb7a4364933bd727$export$2e2bcd8739ae039), {
        container: true,
        rowSpacing: {
            lg: 8,
            md: 6,
            sm: 6,
            xs: 5
        },
        columnSpacing: 2.5,
        style: {
            marginTop: 0
        },
        sx: {
            '& .MuiGrid-root': {
                paddingTop: 0,
                marginTop: 0,
                marginBottom: '64px',
                // Add media queries here
                '@media (max-width: 600px)': {
                    marginBottom: '32px'
                }
            },
            '& .MuiGrid-container': {
                marginTop: 0
            }
        }
    }, props.templateData.map((item, index)=>/*#__PURE__*/ $eeH7J.createElement((0, $e9986a730e2f735d$export$2e2bcd8739ae039), {
            key: item.siteId,
            ...item,
            colorPallets: props.colorPallets,
            sx: {
                height: heights[index]
            },
            index: index
        }))));
};
const $9b212d1933b28659$var$itemData = [
    {
        img: "https://images.unsplash.com/photo-1518756131217-31eb79b20e8f",
        title: "Fern"
    },
    {
        img: "https://images.unsplash.com/photo-1627308595229-7830a5c91f9f",
        title: "Snacks"
    },
    {
        img: "https://images.unsplash.com/photo-1597645587822-e99fa5d45d25",
        title: "Mushrooms"
    },
    {
        img: "https://images.unsplash.com/photo-1529655683826-aba9b3e77383",
        title: "Tower"
    },
    {
        img: "https://images.unsplash.com/photo-1471357674240-e1a485acb3e1",
        title: "Sea star"
    },
    {
        img: "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62",
        title: "Honey"
    },
    {
        img: "https://images.unsplash.com/photo-1516802273409-68526ee1bdd6",
        title: "Basketball"
    },
    {
        img: "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e",
        title: "Breakfast"
    },
    {
        img: "https://images.unsplash.com/photo-1627328715728-7bcc1b5db87d",
        title: "Tree"
    },
    {
        img: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d",
        title: "Burger"
    },
    {
        img: "https://images.unsplash.com/photo-1522770179533-24471fcdba45",
        title: "Camera"
    },
    {
        img: "https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c",
        title: "Coffee"
    },
    {
        img: "https://images.unsplash.com/photo-1627000086207-76eabf23aa2e",
        title: "Camping Car"
    },
    {
        img: "https://images.unsplash.com/photo-1533827432537-70133748f5c8",
        title: "Hats"
    },
    {
        img: "https://images.unsplash.com/photo-1567306301408-9b74779a11af",
        title: "Tomato basil"
    },
    {
        img: "https://images.unsplash.com/photo-1627328561499-a3584d4ee4f7",
        title: "Mountain"
    },
    {
        img: "https://images.unsplash.com/photo-1589118949245-7d38baf380d6",
        title: "Bike"
    }
];
var $9b212d1933b28659$export$2e2bcd8739ae039 = $9b212d1933b28659$var$TemplateBody;




var $eeH7J = parcelRequire("eeH7J");


const $ce7c1502b62fe5cb$var$CookieConsent = (props)=>{
    const [cookies, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_consent"
    ]);
    const acceptCookieConsent = ()=>{
        removeCookie('rp_consent');
        const datestamp = new Date().toString();
        const cookieValue = JSON.stringify({
            consent: true,
            datestamp: datestamp
        });
        setCookie('rp_consent', cookieValue, {
            maxAge: 2592000
        }); // expires in 30 days
        document.getElementById("cookieNotice").style.display = "none";
    };
    const deniedCookieConsent = ()=>{
        removeCookie('rp_consent');
        const datestamp = new Date().toString();
        const cookieValue = JSON.stringify({
            consent: false,
            datestamp: datestamp
        });
        setCookie('rp_consent', cookieValue, {
            maxAge: 2592000
        }); // expires in 30 days
        document.getElementById("cookieNotice").style.display = "none";
    };
    (0, $eeH7J.useEffect)(()=>{
        initCookieConsent();
    }, []);
    const initCookieConsent = ()=>{
        const cookieConsent = cookies.rp_consent;
        const cookieNotice = document.getElementById("cookieNotice");
        if (cookieConsent !== undefined) cookieNotice.style.display = "none";
        else cookieNotice.style.display = "flex";
    };
    const cookieConsentTemplate = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            id: "cookieNotice",
            className: "cookieNotice fixed bottom-0 left-0 right-0 mx-auto z-50 px-5 py-5 text-white"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "w-full flex flex-col md:flex-row justify-between gap-4 mx-auto",
            style: {
                maxWidth: '1440px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "title-wrap text-base font-semibold"
        }, "Your privacy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "content-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "msg-wrap justify-between flex gap-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
            className: "text-sm"
        }, 'By clicking "Accept all cookies", you agree RocketPages can store cookies on your device and disclose information in accordance with our ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("a", {
            href: "https://rocketpages.io/privacy-policy",
            className: "underline text-white"
        }, "Cookie Policy"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "btn-wrap items-center gap-15 flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
            className: "btn-accept btn cursor-pointer rounded inline-block font-semibold text-sm leading-4 bg-white",
            onClick: acceptCookieConsent
        }, "Accept all cookies"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
            className: "btn-denied btn cursor-pointer rounded inline-block font-semibold text-sm leading-4 text-white",
            onClick: deniedCookieConsent
        }, "Cancel"))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, cookieConsentTemplate());
};
var $ce7c1502b62fe5cb$export$2e2bcd8739ae039 = $ce7c1502b62fe5cb$var$CookieConsent;



var $eeH7J = parcelRequire("eeH7J");

const $14e6855d8f24a58e$var$GoogleAnalytics = ()=>{
    const trackingId = "G-JKFEGWE2DT";
    if (!trackingId) {
        console.warn("Google Analytics tracking ID is missing.");
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("script", {
        async: true,
        src: `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("script", null, `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${trackingId}');
        `));
};
var $14e6855d8f24a58e$export$2e2bcd8739ae039 = $14e6855d8f24a58e$var$GoogleAnalytics;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $er6YD = parcelRequire("er6YD");

var $4yBem = parcelRequire("4yBem");




var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $eUKeD = parcelRequire("eUKeD");




var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $6983482e38ca2971$export$5162da8f798e0959(slot) {
    return (0, $aBqGi.default)('MuiCollapse', slot);
}
const $6983482e38ca2971$var$collapseClasses = (0, $cDqLM.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $6983482e38ca2971$export$2e2bcd8739ae039 = $6983482e38ca2971$var$collapseClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $20db8e088def4369$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $20db8e088def4369$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $doIAf.default)(slots, (0, $6983482e38ca2971$export$5162da8f798e0959), classes);
};
const $20db8e088def4369$var$CollapseRoot = (0, $hikmr.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $h4XE0.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $20db8e088def4369$var$CollapseWrapper = (0, $hikmr.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $20db8e088def4369$var$CollapseWrapperInner = (0, $hikmr.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $20db8e088def4369$var$Collapse = /*#__PURE__*/ $eeH7J.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $eUKeD.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $9a7789c95be58aaf$export$2e2bcd8739ae039) } = props, other = (0, $fbOaB.default)(props, $20db8e088def4369$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $20db8e088def4369$var$useUtilityClasses(ownerState);
    const theme = (0, $c7b8a7ef63736600$export$2e2bcd8739ae039)();
    const timer = (0, $b639dfbe5b4dc511$export$2e2bcd8739ae039)();
    const wrapperRef = $eeH7J.useRef(null);
    const autoTransitionDuration = $eeH7J.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $eeH7J.useRef(null);
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $e895d67c3ebfecb1$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $e895d67c3ebfecb1$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $dRzna.jsx)(TransitionComponent, (0, $h4XE0.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $dRzna.jsx)($20db8e088def4369$var$CollapseRoot, (0, $h4XE0.default)({
                as: component,
                className: (0, $er6YD.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $h4XE0.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $h4XE0.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $dRzna.jsx)($20db8e088def4369$var$CollapseWrapper, {
                    ownerState: (0, $h4XE0.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $dRzna.jsx)($20db8e088def4369$var$CollapseWrapperInner, {
                        ownerState: (0, $h4XE0.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$20db8e088def4369$var$Collapse.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The content node to be collapsed.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */ collapsedSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $542b1840e0c5cf64$export$2e2bcd8739ae039),
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The transition orientation.
   * @default 'vertical'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        })
    ])
};
$20db8e088def4369$var$Collapse.muiSupportAuto = true;
var $20db8e088def4369$export$2e2bcd8739ae039 = $20db8e088def4369$var$Collapse;




var $eeH7J = parcelRequire("eeH7J");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $7aa9e5db8f1d4e91$var$AccordionContext = /*#__PURE__*/ $eeH7J.createContext({});
$7aa9e5db8f1d4e91$var$AccordionContext.displayName = 'AccordionContext';
var $7aa9e5db8f1d4e91$export$2e2bcd8739ae039 = $7aa9e5db8f1d4e91$var$AccordionContext;




var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");




'use client';
const $eb194b2190eef764$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $eb194b2190eef764$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $eb194b2190eef764$var$_excluded3 = [
    "component"
];
function $eb194b2190eef764$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $fbOaB.default)(parameters, $eb194b2190eef764$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $fbOaB.default)(externalForwardedProps, $eb194b2190eef764$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $c8108605d04ea33f$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $91f63e57c6c48a92$export$2e2bcd8739ae039)((0, $h4XE0.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $fbOaB.default)(_mergeSlotProps.props, $eb194b2190eef764$var$_excluded3);
    const ref = (0, $c909b21db041accd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $h4XE0.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $e33ed803c0944f04$export$2e2bcd8739ae039)(elementType, (0, $h4XE0.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $35f3eb61080c4e70$export$80fb6a2cb3f13b8b(slot) {
    return (0, $aBqGi.default)('MuiAccordion', slot);
}
const $35f3eb61080c4e70$var$accordionClasses = (0, $cDqLM.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $35f3eb61080c4e70$export$2e2bcd8739ae039 = $35f3eb61080c4e70$var$accordionClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $0b319ead0cb2c362$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $0b319ead0cb2c362$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $35f3eb61080c4e70$export$80fb6a2cb3f13b8b), classes);
};
const $0b319ead0cb2c362$var$AccordionRoot = (0, $hikmr.default)((0, $d3bbaaf68436ce97$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $35f3eb61080c4e70$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $35f3eb61080c4e70$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $35f3eb61080c4e70$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $35f3eb61080c4e70$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $0b319ead0cb2c362$var$Accordion = /*#__PURE__*/ $eeH7J.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $fbOaB.default)(props, $0b319ead0cb2c362$var$_excluded);
    const [expanded, setExpandedState] = (0, $7a2443d826ebcf5f$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $eeH7J.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $eeH7J.Children.toArray(childrenProp);
    const contextValue = $eeH7J.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $h4XE0.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $0b319ead0cb2c362$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $h4XE0.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $h4XE0.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $eb194b2190eef764$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $20db8e088def4369$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $dRzna.jsxs)($0b319ead0cb2c362$var$AccordionRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)((0, $7aa9e5db8f1d4e91$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $dRzna.jsx)(TransitionSlot, (0, $h4XE0.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $dRzna.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
$0b319ead0cb2c362$var$Accordion.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node.isRequired, (props)=>{
        const summary = $eeH7J.Children.toArray(props.children)[0];
        if ((0, $631d1dee154373e2$exports.isFragment)(summary)) return new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.");
        if (!/*#__PURE__*/ $eeH7J.isValidElement(summary)) return new Error('MUI: Expected the first child of Accordion to be a valid element.');
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, expands the accordion by default.
   * @default false
   */ defaultExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */ expanded: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
var $0b319ead0cb2c362$export$2e2bcd8739ae039 = $0b319ead0cb2c362$var$Accordion;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $c5ee7b8de147019a$export$282216ad123d6580(slot) {
    return (0, $aBqGi.default)('MuiAccordionSummary', slot);
}
const $c5ee7b8de147019a$var$accordionSummaryClasses = (0, $cDqLM.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $c5ee7b8de147019a$export$2e2bcd8739ae039 = $c5ee7b8de147019a$var$accordionSummaryClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $8365fa8cbfae3efe$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $8365fa8cbfae3efe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $c5ee7b8de147019a$export$282216ad123d6580), classes);
};
const $8365fa8cbfae3efe$var$AccordionSummaryRoot = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $c5ee7b8de147019a$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $c5ee7b8de147019a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $c5ee7b8de147019a$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $c5ee7b8de147019a$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $8365fa8cbfae3efe$var$AccordionSummaryContent = (0, $hikmr.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $c5ee7b8de147019a$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $8365fa8cbfae3efe$var$AccordionSummaryExpandIconWrapper = (0, $hikmr.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $c5ee7b8de147019a$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $8365fa8cbfae3efe$var$AccordionSummary = /*#__PURE__*/ $eeH7J.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $fbOaB.default)(props, $8365fa8cbfae3efe$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $eeH7J.useContext((0, $7aa9e5db8f1d4e91$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $h4XE0.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $8365fa8cbfae3efe$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsxs)($8365fa8cbfae3efe$var$AccordionSummaryRoot, (0, $h4XE0.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $er6YD.default)(classes.root, className),
        focusVisibleClassName: (0, $er6YD.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)($8365fa8cbfae3efe$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $dRzna.jsx)($8365fa8cbfae3efe$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
$8365fa8cbfae3efe$var$AccordionSummary.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The icon to display as the expand indicator.
   */ expandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $8365fa8cbfae3efe$export$2e2bcd8739ae039 = $8365fa8cbfae3efe$var$AccordionSummary;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $9e3be6bfef5ea584$export$a6afb527becfac26(slot) {
    return (0, $aBqGi.default)('MuiAccordionDetails', slot);
}
const $9e3be6bfef5ea584$var$accordionDetailsClasses = (0, $cDqLM.default)('MuiAccordionDetails', [
    'root'
]);
var $9e3be6bfef5ea584$export$2e2bcd8739ae039 = $9e3be6bfef5ea584$var$accordionDetailsClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $e75e0180dfcf8f2f$var$_excluded = [
    "className"
];
const $e75e0180dfcf8f2f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $9e3be6bfef5ea584$export$a6afb527becfac26), classes);
};
const $e75e0180dfcf8f2f$var$AccordionDetailsRoot = (0, $hikmr.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $e75e0180dfcf8f2f$var$AccordionDetails = /*#__PURE__*/ $eeH7J.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $fbOaB.default)(props, $e75e0180dfcf8f2f$var$_excluded);
    const ownerState = props;
    const classes = $e75e0180dfcf8f2f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($e75e0180dfcf8f2f$var$AccordionDetailsRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$e75e0180dfcf8f2f$var$AccordionDetails.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $e75e0180dfcf8f2f$export$2e2bcd8739ae039 = $e75e0180dfcf8f2f$var$AccordionDetails;


var $a9a37ff2c25189b1$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($a9a37ff2c25189b1$exports, "__esModule", {
    value: true
});
$a9a37ff2c25189b1$exports.default = void 0;

var $a9a37ff2c25189b1$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $a9a37ff2c25189b1$var$_default = $a9a37ff2c25189b1$exports.default = (0, $a9a37ff2c25189b1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');




const $23ddb206e2f3cb85$export$d26f610c9dea7073 = ()=>{
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [categoryData, setCategoryData] = (0, $eeH7J.useState)([]);
    const [templateData, setTemplateData] = (0, $eeH7J.useState)([]);
    const [templateDataFiltered, setTemplateDataFiltered] = (0, $eeH7J.useState)([]);
    const [selectedTemplateFilter, setSelectedTemplateFilter] = (0, $eeH7J.useState)("all");
    const [filterToggle, setFilterToggle] = (0, $eeH7J.useState)(false);
    const [colorPallets, setColorPallets] = (0, $eeH7J.useState)([]);
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const [cookies, setCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "userSelectedFilters"
    ]);
    const encodeData = (data)=>(0, $5e4029a0026c7a4d$export$a143d493d941bafc).from(JSON.stringify(data), 'utf8').toString('base64');
    const decodeData = (encodedData)=>JSON.parse((0, $5e4029a0026c7a4d$export$a143d493d941bafc).from(encodedData, 'base64').toString('utf8'));
    const setSortedCategoryData = (data, action = '')=>{
        let tTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        const updateCategoryCount = (pageCondition)=>{
            return data.map((cat)=>{
                let tmpCount = 0;
                if (templateData.length > 0) {
                    templateData.forEach((row)=>{
                        if (row.templateCategories.includes(cat.category) && pageCondition(row.pageCount)) tmpCount++;
                    });
                    return {
                        ...cat,
                        cnt: tmpCount
                    };
                }
            });
        };
        if (tTypes.length === 1) {
            if (tTypes[0].category === "Single Page") data = updateCategoryCount((pageCount)=>pageCount < 2);
            else if (tTypes[0].category === "Multi Page") data = updateCategoryCount((pageCount)=>pageCount > 1);
        } else if (tTypes.length === 2 || tTypes.length === 0) // console.log('tTypes, templateData, data', tTypes, templateData, data);
        {
            if (templateData.length > 0) data = data.map((cat)=>{
                const tmpCount = templateData.reduce((count, row)=>{
                    if (cat.category === 'Blank') return 1;
                    else return row.templateCategories.includes(cat.category) ? count + 1 : count;
                }, 0);
                return {
                    ...cat,
                    cnt: tmpCount
                };
            });
        }
        // Now `data` has been correctly updated, so you can proceed with filtering and sorting.
        const blankCat = data.filter((c)=>c.category.toLowerCase() === "blank");
        const nonBlankCat = data.filter((c)=>c.category.trim().toLowerCase() !== "blank").sort((a, b)=>a.category.trim().toLowerCase().localeCompare(b.category.trim().toLowerCase()));
        let allCategories = [
            ...blankCat,
            ...nonBlankCat
        ];
        setCategoryData(allCategories);
        if (action === 'reset') setCookie("userSelectedFilters", "", {
            path: "/",
            expires: new Date(0)
        });
        if (action === 'click' || action === 'param') {
            const encoded = encodeData(allCategories);
            setCookie("userSelectedFilters", encoded, {
                path: "/",
                maxAge: 3600 // 1 hr
            });
        }
    };
    (0, $eeH7J.useEffect)(()=>{
        async function fetchData() {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/template-site-configs`);
            setTemplateData(response.data.data);
            //console.log("all data", response.data.data);
            let _singlePageSitesCount = 0;
            let _multiPageSitesCount = 0;
            let tmpData = [];
            response.data.data.forEach((row)=>{
                row.templateCategories.forEach((cat)=>{
                    let ii = tmpData.findIndex((oo)=>oo.category === cat);
                    if (ii >= 0) {
                        if (cat === 'Blank') // For Blank count should be always be 1
                        tmpData[ii].cnt = tmpData[ii].cnt;
                        else tmpData[ii].cnt = tmpData[ii].cnt + 1;
                    } else tmpData.push({
                        type: "cat",
                        category: cat,
                        cnt: 1,
                        isChecked: false
                    });
                });
                if (row.pageCount > 1) _multiPageSitesCount += 1;
                else _singlePageSitesCount += 1;
            });
            tmpData.push({
                type: "main",
                category: "Single Page",
                cnt: _singlePageSitesCount,
                isChecked: true
            });
            tmpData.push({
                type: "main",
                category: "Multi Page",
                cnt: _multiPageSitesCount,
                isChecked: true
            });
            const categoryQuery = getQueryVariable("cat");
            let decoded = cookies.userSelectedFilters && cookies.userSelectedFilters.length > 0 ? decodeData(cookies.userSelectedFilters) : null;
            let finalData = decoded || tmpData; // by default
            let catParam = '';
            if (categoryQuery) {
                // Split multiple comma-separated categories and normalize to lowercase
                const categoryList = categoryQuery.split(',').map((cat)=>cat.trim().toLowerCase());
                tmpData.forEach((obj)=>{
                    const encodedCategory = encodeURIComponent(obj.category.toLowerCase());
                    if (categoryList.includes(encodedCategory) || categoryList.includes(obj.category.toLowerCase())) {
                        obj.isChecked = true;
                        setFilterToggle(true);
                    }
                });
                if (decoded) {
                    decoded.forEach((obj)=>{
                        const encodedCategory = encodeURIComponent(obj.category.toLowerCase());
                        if (categoryList.includes(encodedCategory) || categoryList.includes(obj.category.toLowerCase())) obj.isChecked = true;
                    });
                    finalData = decoded;
                } else finalData = tmpData;
                catParam = 'param';
            }
            // Set data only once
            setSortedCategoryData(finalData, catParam);
            let responseAllPallets = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`);
            setColorPallets(responseAllPallets.data.data);
            setIsLoading(false);
        }
        setIsLoading(true);
        fetchData();
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        let gg = [];
        let cats = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "cat");
        let typeMains = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        //console.log(cats);
        if (cats.length === 0) gg = [
            ...templateData
        ];
        templateData.forEach((row)=>{
            let inc = false;
            cats.forEach((cat)=>{
                if (row.templateCategories.includes(cat.category)) inc = true;
            });
            if (inc) gg.push(row);
        });
        const blankTemplates = gg.filter((t)=>t.templateCategories.includes("Blank"));
        // Prevent two blank templates
        if (typeMains.length == 2 || typeMains.length == 0) {
            if (blankTemplates.length > 1) blankTemplates.splice(-1, 1);
        }
        // const nonBlankTemplates = gg
        //   .filter((t) => !t.templateCategories.includes("Blank"))
        //   .sort((a, b) => {
        //     if (a.templateName < b.templateName) return -1;
        //     return 0;
        //   });
        const nonBlankTemplates = gg.filter((t)=>!t.templateCategories.includes("Blank")).sort((a, b)=>a.templateName.localeCompare(b.templateName));
        let filteredTemplates = [
            ...blankTemplates,
            ...nonBlankTemplates
        ];
        let tTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        if (tTypes.length === 1) {
            //   //gg = [...templateData];
            // }
            // else {
            let filteredSinglePageTemplates = [];
            let filteredMultiPageTemplates = [];
            let selectedType;
            filteredTemplates.forEach((row)=>{
                tTypes.forEach((tType)=>{
                    // filteredTypeTemplates[tType.category].push(row);
                    selectedType = tType.category;
                    if (tType.category === "Multi Page" && row.pageCount > 1) filteredMultiPageTemplates.push(row);
                    if (tType.category === "Single Page" && (row.pageCount === 1 || row.pageCount === 0)) filteredSinglePageTemplates.push(row);
                });
            });
            filteredTemplates = selectedType === "Multi Page" ? filteredMultiPageTemplates : filteredSinglePageTemplates;
        }
        setTemplateDataFiltered(filteredTemplates);
        //setTemplateDataFiltered([...blankTemplates, ...nonBlankTemplates]);
        handleSetFilterToggle(categoryData, "cat");
        handleSetFilterToggle(categoryData, "main");
    }, [
        categoryData
    ]);
    const handleSetFilterToggle = (newArray, type)=>{
        //let isAllPagesTrue = true;
        let tTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        let cTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "cat");
        if (tTypes.length == 2 && cTypes.length == 0) setFilterToggle(false);
        else if (tTypes.length == 0 && cTypes.length == 0) setFilterToggle(false);
        else setFilterToggle(true);
    };
    const getQueryVariable = (variable)=>{
        var query = window.location.search.substring(1);
        // console.log(query)//"app=article&act=news_content&aid=160990"
        var vars = query.split("&");
        // console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
        for(var i = 0; i < vars.length; i++){
            var pair = vars[i].split("=");
            //console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]
            if (pair[0] == variable) return pair[1];
        }
        return false;
    };
    const catQuery = getQueryVariable("cat");
    // Build meta info dynamically
    const title = catQuery ? `RocketPages - ${catQuery} templates` : "RocketPages - Choose Template";
    const description = catQuery ? `Discover customizable ${catQuery} website templates on RocketPages. Build, launch & grow your site with designs made for ${catQuery} communities.` : "Build and Launch Your Free Website in Just 15 Minutes";
    const canonical = catQuery ? `https://app.rocketpages.io/choose-template?cat=${catQuery}` : "https://app.rocketpages.io/choose-template";
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, title), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: description
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preload",
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        as: "font",
        type: "font/woff2"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "canonical",
        href: canonical
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        title: "Choose template"
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 xl:w-64 top-[64px] hidden md:flex"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "pb-16 overflow-y-auto w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "px-2"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "sticky top-0 bg-catelina-blue z-10"
    }, " ", /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "px-2 py-2 flex"
    }, "Page(s):"), categoryData.filter((obj)=>obj.type == "main").map((row)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $fe2aebb6bc6e27f2$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckFilterTypeChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                setSortedCategoryData(newArray, 'click');
                handleSetFilterToggle(newArray, "main");
            // setFilterToggle(true)
            },
            "data-test": "page-checkbox"
        });
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "border-b border-white mx-2 mt-4 mb-3 flex"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "overflow-y-auto max-h-[calc(100vh-200px)]"
    }, " ", /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "px-2 py-2 flex"
    }, "Categories:"), categoryData.filter((obj)=>obj.type == "cat").map((row)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $526468a3beeb20e6$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                setSortedCategoryData(newArray, 'click');
                handleSetFilterToggle(newArray, "cat");
            //removeQueryParam();
            // setFilterToggle(true)
            },
            "data-test": "category-checkbox"
        });
    }))))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col w-full my-4 pl-[20px] md:pl-[260px] xl:pl-[340px] pb-10 pt-[64px] bg-white-smoke pr-[20px]"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "md:hidden"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $0b319ead0cb2c362$export$2e2bcd8739ae039), {
        disableGutters: true
    }, /*#__PURE__*/ $eeH7J.createElement((0, $8365fa8cbfae3efe$export$2e2bcd8739ae039), {
        expandIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a37ff2c25189b1$exports))), null),
        "aria-controls": "panel2-content",
        id: "panel2-header",
        sx: {
            p: 0,
            mx: 1.2,
            mb: 0,
            "& .MuiAccordionSummary-content": {
                alignItems: "center"
            }
        },
        style: {
            alignItems: "center"
        },
        "data-test": "filters"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("jl3Li")),
        alt: "",
        className: "px-2"
    }), "Filters"), /*#__PURE__*/ $eeH7J.createElement((0, $e75e0180dfcf8f2f$export$2e2bcd8739ae039), {
        sx: {
            p: 0
        }
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "border-b border-gray flex mx-2 mt-1 mb-1.5"
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "pb-2 text-catelina-blue pt-1"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "px-2 py-2",
        style: {
            color: "#3B3B3B66"
        }
    }, "Page(s):"), categoryData.filter((obj)=>obj.type == "main").map((row)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $fe2aebb6bc6e27f2$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckFilterTypeChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                // console.log(newArray);
                setSortedCategoryData(newArray, 'click');
            },
            "data-test": "page-checkbox-mobile"
        });
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "border-b border-gray flex mx-2 mt-1 mb-1.5"
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "px-2 py-2 ",
        style: {
            color: "#3B3B3B66"
        }
    }, "Categories:"), categoryData.filter((obj)=>obj.type == "cat").map((row)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $526468a3beeb20e6$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                setSortedCategoryData(newArray, 'click');
            },
            "data-test": "category-checkbox-mobile"
        });
    }))))), !filterToggle ? /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row mb-2"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-catelina-blue py-1"
    }, "All Templates (", templateDataFiltered.length, ")")) : /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "template-filter"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $0b319ead0cb2c362$export$2e2bcd8739ae039), {
        disableGutters: true
    }, /*#__PURE__*/ $eeH7J.createElement((0, $8365fa8cbfae3efe$export$2e2bcd8739ae039), {
        expandIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a37ff2c25189b1$exports))), null),
        "aria-controls": "panel2-content",
        id: "panel2-header",
        sx: {
            "& .MuiAccordionSummary-content": {
                alignItems: "center"
            }
        },
        style: {
            alignItems: "center"
        }
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("jl3Li")),
        alt: "",
        className: "pr-2"
    }), "Filters"), /*#__PURE__*/ $eeH7J.createElement((0, $e75e0180dfcf8f2f$export$2e2bcd8739ae039), {
        sx: {
            pt: 0
        }
    }, /*#__PURE__*/ $eeH7J.createElement("div", null, categoryData.filter((kk)=>kk.isChecked === true && kk.type === "main").length > 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row flex-wrap  pt-2 border-grey-500 border-t"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "py-2 font-normal pageLabel"
    }, "Page(s):"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-wrap pageValue"
    }, categoryData.filter((kk)=>kk.isChecked === true && kk.type === "main").map((jjj)=>{
        return /*#__PURE__*/ $eeH7J.createElement("div", {
            key: jjj.category,
            className: "border border-slate-300 rounded tex-grey-primary flex items-center pr-1 mr-2 mt-1 mb-2 font-normal grey-primary",
            style: {
                backgroundColor: "#FAFAFA"
            },
            "data-test": "page-filter",
            "data-filter": jjj.category
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "px-2"
        }, jjj.category), /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b6dd623e8e0959ca$exports))), {
            onClick: ()=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === jjj.category);
                newArray[idx].isChecked = false;
                setSortedCategoryData(newArray, 'reset');
            },
            className: "hover:cursor-pointer",
            fontSize: "small",
            sx: {
                color: "#3B3B3B66"
            }
        }));
    }))), categoryData.filter((kk)=>kk.isChecked === true && kk.type === "cat").length > 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "py-2 font-normal pageLabel"
    }, "Categories:"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-wrap pageValue"
    }, categoryData.filter((kk)=>kk.isChecked === true && kk.type === "cat").map((jjj)=>{
        return /*#__PURE__*/ $eeH7J.createElement("div", {
            key: jjj.category,
            className: "border border-slate-300 rounded flex items-center pr-1 mr-2 mt-1 mb-2 font-normal tex-grey-primary",
            style: {
                backgroundColor: "#FAFAFA"
            },
            "data-test": "category-filter",
            "data-filter": jjj.category
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "px-2"
        }, jjj.category), /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b6dd623e8e0959ca$exports))), {
            onClick: ()=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === jjj.category);
                newArray[idx].isChecked = false;
                setSortedCategoryData(newArray, 'reset');
            },
            className: "hover:cursor-pointer",
            fontSize: "small",
            sx: {
                color: "#3B3B3B66"
            }
        }));
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-catelina-blue py-1 pl-1 hover:cursor-pointer self-center underline font-normal",
        onClick: ()=>{
            let newArray = [
                ...categoryData
            ];
            for(let iii = 0; iii < newArray.length; iii++)// console.log(newArray[iii]);
            if (newArray[iii].type === "cat") newArray[iii].isChecked = false;
            setSortedCategoryData(newArray, 'reset');
        }
    }, "Clear all"), " ")))))), /*#__PURE__*/ $eeH7J.createElement((0, $9b212d1933b28659$export$2e2bcd8739ae039), {
        templateData: templateDataFiltered,
        colorPallets: colorPallets
    }))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");

var $37bc6bb2c48d369a$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($37bc6bb2c48d369a$exports, "__esModule", {
    value: true
});
$37bc6bb2c48d369a$exports.default = void 0;

var $37bc6bb2c48d369a$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $37bc6bb2c48d369a$var$_default = $37bc6bb2c48d369a$exports.default = (0, $37bc6bb2c48d369a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), 'AddCircle');



const $bbf05946fe7aec77$var$NoSiteExists = (props)=>{
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-center py-24 flex-col items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "h-20",
        src: (parcelRequire("by3Sp"))
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-center"
    }, "You don\u2019t have any website yet"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-center py-4"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        variant: "contained",
        sx: {
            backgroundColor: "#243060",
            textTransform: "none"
        },
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($37bc6bb2c48d369a$exports))), {
            sx: {
                color: "#fff"
            }
        }),
        onClick: props.onNewWebsiteClick
    }, "Create new website")));
};
var $bbf05946fe7aec77$export$2e2bcd8739ae039 = $bbf05946fe7aec77$var$NoSiteExists;





var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");


var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $cd8c06a8a86d7938$export$f3b76d2cce458caa(slot) {
    return (0, $aBqGi.default)('MuiCard', slot);
}
const $cd8c06a8a86d7938$var$cardClasses = (0, $cDqLM.default)('MuiCard', [
    'root'
]);
var $cd8c06a8a86d7938$export$2e2bcd8739ae039 = $cd8c06a8a86d7938$var$cardClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $9cd9945bb4eead3d$var$_excluded = [
    "className",
    "raised"
];
const $9cd9945bb4eead3d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $cd8c06a8a86d7938$export$f3b76d2cce458caa), classes);
};
const $9cd9945bb4eead3d$var$CardRoot = (0, $hikmr.default)((0, $d3bbaaf68436ce97$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $9cd9945bb4eead3d$var$Card = /*#__PURE__*/ $eeH7J.forwardRef(function Card(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $fbOaB.default)(props, $9cd9945bb4eead3d$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        raised: raised
    });
    const classes = $9cd9945bb4eead3d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($9cd9945bb4eead3d$var$CardRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
$9cd9945bb4eead3d$var$Card.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the card will use raised styling.
   * @default false
   */ raised: (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool, (props)=>{
        if (props.raised && props.variant === 'outlined') return new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.');
        return null;
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $9cd9945bb4eead3d$export$2e2bcd8739ae039 = $9cd9945bb4eead3d$var$Card;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $e62205a41a19d5a5$export$2a5c27c211442e3c(slot) {
    return (0, $aBqGi.default)('MuiCardActions', slot);
}
const $e62205a41a19d5a5$var$cardActionsClasses = (0, $cDqLM.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $e62205a41a19d5a5$export$2e2bcd8739ae039 = $e62205a41a19d5a5$var$cardActionsClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $64f662c6a0feea4f$var$_excluded = [
    "disableSpacing",
    "className"
];
const $64f662c6a0feea4f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $e62205a41a19d5a5$export$2a5c27c211442e3c), classes);
};
const $64f662c6a0feea4f$var$CardActionsRoot = (0, $hikmr.default)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $64f662c6a0feea4f$var$CardActions = /*#__PURE__*/ $eeH7J.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $fbOaB.default)(props, $64f662c6a0feea4f$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $64f662c6a0feea4f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($64f662c6a0feea4f$var$CardActionsRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$64f662c6a0feea4f$var$CardActions.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */ disableSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $64f662c6a0feea4f$export$2e2bcd8739ae039 = $64f662c6a0feea4f$var$CardActions;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $2ed2bed675ba14ee$export$964336739a8c7119(slot) {
    return (0, $aBqGi.default)('MuiCardContent', slot);
}
const $2ed2bed675ba14ee$var$cardContentClasses = (0, $cDqLM.default)('MuiCardContent', [
    'root'
]);
var $2ed2bed675ba14ee$export$2e2bcd8739ae039 = $2ed2bed675ba14ee$var$cardContentClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $e769f4d48b989a5f$var$_excluded = [
    "className",
    "component"
];
const $e769f4d48b989a5f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $2ed2bed675ba14ee$export$964336739a8c7119), classes);
};
const $e769f4d48b989a5f$var$CardContentRoot = (0, $hikmr.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $e769f4d48b989a5f$var$CardContent = /*#__PURE__*/ $eeH7J.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $fbOaB.default)(props, $e769f4d48b989a5f$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component
    });
    const classes = $e769f4d48b989a5f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($e769f4d48b989a5f$var$CardContentRoot, (0, $h4XE0.default)({
        as: component,
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$e769f4d48b989a5f$var$CardContent.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $e769f4d48b989a5f$export$2e2bcd8739ae039 = $e769f4d48b989a5f$var$CardContent;






var $eeH7J = parcelRequire("eeH7J");

var $9927ad39f12d4a98$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($9927ad39f12d4a98$exports, "__esModule", {
    value: true
});
$9927ad39f12d4a98$exports.default = void 0;

var $9927ad39f12d4a98$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $9927ad39f12d4a98$var$_default = $9927ad39f12d4a98$exports.default = (0, $9927ad39f12d4a98$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');


var $e49618aca7747886$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($e49618aca7747886$exports, "__esModule", {
    value: true
});
$e49618aca7747886$exports.default = void 0;

var $e49618aca7747886$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $e49618aca7747886$var$_default = $e49618aca7747886$exports.default = (0, $e49618aca7747886$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'CloseOutlined');


var $d660f2eec4f22fb9$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($d660f2eec4f22fb9$exports, "__esModule", {
    value: true
});
$d660f2eec4f22fb9$exports.default = void 0;

var $d660f2eec4f22fb9$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $d660f2eec4f22fb9$var$_default = $d660f2eec4f22fb9$exports.default = (0, $d660f2eec4f22fb9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M15 20H5V7c0-.55-.45-1-1-1s-1 .45-1 1v13c0 1.1.9 2 2 2h10c.55 0 1-.45 1-1s-.45-1-1-1m5-4V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2m-2 0H9V4h9z"
}), 'ContentCopyRounded');


var $04943e88a6b167d3$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($04943e88a6b167d3$exports, "__esModule", {
    value: true
});
$04943e88a6b167d3$exports.default = void 0;

var $04943e88a6b167d3$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $04943e88a6b167d3$var$_default = $04943e88a6b167d3$exports.default = (0, $04943e88a6b167d3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutlineOutlined');


var $aab8b5e9246ef85c$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($aab8b5e9246ef85c$exports, "__esModule", {
    value: true
});
$aab8b5e9246ef85c$exports.default = void 0;

var $aab8b5e9246ef85c$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $aab8b5e9246ef85c$var$_default = $aab8b5e9246ef85c$exports.default = (0, $aab8b5e9246ef85c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "m15 16-4 4h10v-4zm-2.94-8.81L3 16.25V20h3.75l9.06-9.06zM5.92 18H5v-.92l7.06-7.06.92.92zm12.79-9.96c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75z"
}), 'DriveFileRenameOutlineOutlined');


var $c42d73f72f61789d$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($c42d73f72f61789d$exports, "__esModule", {
    value: true
});
$c42d73f72f61789d$exports.default = void 0;

var $c42d73f72f61789d$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $c42d73f72f61789d$var$_default = $c42d73f72f61789d$exports.default = (0, $c42d73f72f61789d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), 'VisibilityOutlined');



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");



var $dRzna = parcelRequire("dRzna");
'use client';
const $7d9fc2b31a97881e$var$_excluded = [
    "className"
];
const $7d9fc2b31a97881e$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $0a822e517a36bc5e$export$81478e24460c57f2), classes);
};
const $7d9fc2b31a97881e$var$ListItemIconRoot = (0, $hikmr.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $7d9fc2b31a97881e$var$ListItemIcon = /*#__PURE__*/ $eeH7J.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $fbOaB.default)(props, $7d9fc2b31a97881e$var$_excluded);
    const context = $eeH7J.useContext((0, $77f199b4f9b0046c$export$2e2bcd8739ae039));
    const ownerState = (0, $h4XE0.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $7d9fc2b31a97881e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($7d9fc2b31a97881e$var$ListItemIconRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$7d9fc2b31a97881e$var$ListItemIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $7d9fc2b31a97881e$export$2e2bcd8739ae039 = $7d9fc2b31a97881e$var$ListItemIcon;






const $afb063dffe111db3$var$SanitizeTextboxInput = (input)=>{
    let sanitized = input;
    // 1. Remove non-printable/control characters
    sanitized = sanitized.replace(/[\u0000-\u001F\u007F-\u009F]/g, "");
    // 2. Decode percent-encoded octets like %3C, %7B, etc.
    sanitized = sanitized.replace(/%[a-f0-9]{2}/gi, "");
    // 3. Strip all HTML tags
    sanitized = sanitized.replace(/<\/?[^>]+(>|$)/g, "");
    // 4. Remove angle brackets
    sanitized = sanitized.replace(/</g, "");
    sanitized = sanitized.replace(/>/g, "");
    // 5. Remove line breaks and tabs
    sanitized = sanitized.replace(/[\r\n\t]/g, " ");
    // 6. Replace multiple spaces with a single space
    // sanitized = sanitized.replace(/\s+/g, " ");
    // 7. Trim leading and trailing whitespace
    sanitized = sanitized.replace(/^\s+/, "");
    return sanitized;
};
var $afb063dffe111db3$export$2e2bcd8739ae039 = $afb063dffe111db3$var$SanitizeTextboxInput;





const $f4c6588ca71f4ee3$var$SiteItem = (props)=>{
    // --- DEBUG HELPERS ---
    const __DBG__ = (msg, data)=>{
        // Toggle verbose logs by setting window.__RP_DEBUG__ = true in DevTools console
        const enabled = typeof window !== "undefined" && window.__RP_DEBUG__ === true;
        if (!enabled) return;
        try {
            // eslint-disable-next-line no-console
            console.log(`[SiteItem] ${msg}`, data ?? "");
        } catch  {
        // ignore
        }
    };
    __DBG__("render", {
        siteId: props?.data?.siteId,
        pageId: props?.data?.pageId,
        siteUrl: props?.data?.siteUrl
    });
    const { enqueueSnackbar: enqueueSnackbar, closeSnackbar: closeSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const publishingSnackKeyRef = $eeH7J.useRef(null);
    const [anchorEl, setAnchorEl] = $eeH7J.useState(null);
    const open = Boolean(anchorEl);
    const [showConfirmation, setShowConfirmation] = $eeH7J.useState(false);
    const [showPublishConfirmation, setShowPublishConfirmation] = $eeH7J.useState(false);
    const [showRename, setShowRename] = $eeH7J.useState(false);
    const [renameError, setRenameError] = $eeH7J.useState("");
    const [newSiteName, setNewSiteName] = $eeH7J.useState("");
    const [isLoading, setIsLoading] = $eeH7J.useState(false);
    const [isPublishing, setIsPublishing] = $eeH7J.useState(false);
    const [cookie_userData, setCookie_userData, removeCookie_userData] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    // --- Publish status polling (singleton) ---
    const publishPollRef = $eeH7J.useRef({
        intervalId: null,
        timeoutId: null,
        inFlight: false
    });
    const stopPublishPolling = $eeH7J.useCallback(()=>{
        // Stop any active publish status polling
        __DBG__("stopPublishPolling");
        if (publishPollRef.current.intervalId) clearInterval(publishPollRef.current.intervalId);
        if (publishPollRef.current.timeoutId) clearTimeout(publishPollRef.current.timeoutId);
        publishPollRef.current.intervalId = null;
        publishPollRef.current.timeoutId = null;
        publishPollRef.current.inFlight = false;
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        return ()=>{
            // Cleanup on unmount
            stopPublishPolling();
        };
    }, [
        stopPublishPolling
    ]);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const [textClassObj] = $eeH7J.useState([
        {
            fontSize: "14px",
            color: "#243060",
            minHeight: "auto"
        },
        {
            "&:hover": {
                fontWeight: 700
            }
        }
    ]);
    function calculateTimeRemaining(timestamp) {
        // Convert the timestamp to a Date object
        const originalDate = new Date(timestamp);
        // Add 72 hours (72 * 60 * 60 * 1000 milliseconds)
        const futureDate = new Date(originalDate.getTime() + 259200000);
        // Get the current time
        const currentDate = new Date();
        // Calculate the difference in milliseconds
        const diffMs = futureDate.getTime() - currentDate.getTime();
        // If the future date has passed, return that it's already deleted
        if (diffMs <= 0) return "The site will be deleted soon.";
        // Calculate the difference in days and hours
        const diffDays = Math.floor(diffMs / 86400000);
        const diffHours = Math.floor(diffMs % 86400000 / 3600000);
        // Return the remaining time in a readable format
        if (diffDays > 0) return `Update or save with in ${diffDays} day(s) to avoid deletion.`;
        else return `Update or save with in ${diffHours} hour(s) to avoid deletion.`;
    }
    const handleDelete = ()=>{
        // onCancelSubs(existingSubs[0].subscriptionId); // Call the delete function passed as a prop
        setShowConfirmation(false); // Close the confirmation dialog after delete
        props.onSiteDelete(props.data.siteId);
    };
    const publishSite = async ()=>{
        setIsLoading(true);
        try {
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/configs/publish", {
                siteId: props.data.siteId,
                fullSite: true,
                pageId: null,
                publishAllPages: true
            });
            __DBG__("publish API success", {
                status: response?.status,
                data: response?.data
            });
            setIsLoading(false);
            publishingSnackKeyRef.current = enqueueSnackbar("Your website is being published. We'll notify you when it's ready.", {
                variant: "success",
                className: "bg-catelina-blue",
                persist: true
            });
            if (typeof window.__RP_DEBUG__ !== "undefined" && window.__RP_DEBUG__) {
                console.log("[publish] starting status poll", {
                    siteId: props?.data?.siteId,
                    pageId: props?.data?.pageId,
                    siteUrl: props?.data?.siteUrl
                });
                enqueueSnackbar("DEBUG: started publish polling", {
                    variant: "info"
                });
            }
            checkPublishStatus();
            return response;
        } catch (error) {
            console.error("Error while publishing site:", error);
            __DBG__("publish API error", error);
            setIsLoading(false);
        }
    };
    const onPublishViewClick = async ()=>{
        __DBG__("onPublishViewClick", {
            isPublished: props?.data?.isPublished,
            isPublishing: isPublishing
        });
        setShowPublishConfirmation(false);
        if (!props.data.isPublished) {
            setIsPublishing(true);
            const resp = await publishSite();
        // if (!!resp?.data?.data?.url) {
        //   window.open(`https://${resp?.data?.data?.url}`, '_blank')?.focus();
        // } else {
        //   console.log('Error while publishing site');
        // }
        } else window.open(props.data.siteUrl, "_blank")?.focus();
    };
    const getPublishStatus = async ()=>{
        try {
            const siteId = props?.data?.siteId;
            const pageId = props?.data?.pageId;
            if (!pageId && !siteId) {
                console.error("getPublishStatus: missing pageId/siteId", props?.data);
                return null;
            }
            /**
     * Constructs a query string parameter based on the presence of pageId.
     * If pageId exists, creates a pageId query parameter; otherwise, creates a siteId query parameter.
     * Both values are URL-encoded to ensure safe transmission.
     * 
     * @remarks
     * The query string will be in the format "pageId=<encoded-value>" or "siteId=<encoded-value>".
     */ const qs = pageId ? `pageId=${encodeURIComponent(pageId)}` : `siteId=${encodeURIComponent(siteId)}`;
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/check-publish-status?${qs}`);
            return response.data;
        } catch (error) {
            console.error("Error while getting publish status:", error);
            setIsLoading(false);
            return null;
        }
    };
    const checkSSL = async (url)=>{
        try {
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/check-ssl?url=${url}`);
            return response.status;
        } catch (error) {
            console.error("Error while checking SSL:", error);
            setIsLoading(false);
        }
    };
    /**
 * Initiates polling to check the publish status of a site.
 * 
 * Polls the publish status every 5 seconds until the status is either "completed" or "failed",
 * or until a 5-minute timeout is reached. Ensures only one poller instance is active at a time
 * by stopping any existing polling before starting.
 * 
 * @remarks
 * - On successful completion, unblocks the UI, triggers the parent's `onPublishComplete` callback,
 *   and shows a success notification.
 * - For custom domains (not ending with `SERVER_DOMAIN`), initiates a separate SSL readiness check
 *   that polls every 5 seconds up to 60 times (5 minutes).
 * - On failure or timeout, stops polling, unblocks the UI, and displays an error notification.
 * - Uses a ref-based flag (`publishPollRef.current.inFlight`) to prevent concurrent poll requests.
 * 
 * @throws Does not throw directly, but catches and handles exceptions internally by stopping the
 * poller and showing an error notification.
 */ const checkPublishStatus = ()=>{
        __DBG__("checkPublishStatus START");
        // Ensure there is only one active poller at a time.
        stopPublishPolling();
        publishPollRef.current.intervalId = setInterval(async ()=>{
            if (publishPollRef.current.inFlight) return;
            publishPollRef.current.inFlight = true;
            try {
                __DBG__("poll tick", {
                    inFlight: publishPollRef.current.inFlight
                });
                const publishResponse = await getPublishStatus();
                const statusPayload = (0, $3e95173fd5aea333$export$f00a55a332eb5e99)(publishResponse);
                __DBG__("statusPayload", {
                    keys: statusPayload && typeof statusPayload === "object" ? Object.keys(statusPayload) : null,
                    statusPayload: statusPayload
                });
                const status = (0, $3e95173fd5aea333$export$2fec6246253ef2cb)(statusPayload?.status ?? statusPayload?.publishStatus ?? statusPayload?.pageStatus ?? statusPayload?.publishingStatus);
                if (status === "completed") {
                    __DBG__("status=completed");
                    stopPublishPolling();
                    // Unblock UI immediately
                    setIsLoading(false);
                    setIsPublishing(false);
                    setShowPublishConfirmation(false);
                    // Let parent refresh its data so "Published" flips in the list.
                    if (typeof props?.onPublishComplete === "function") props.onPublishComplete(props.data.siteId);
                    // Show completion immediately (do NOT wait for SSL).
                    showPublishNotification(props.data.siteUrl);
                    // For custom domains, check SSL readiness separately and notify (optional)
                    if (!props.data.siteUrl.endsWith(".rocketpagesstage.com")) {
                        let sslTries = 0;
                        const sslInterval = setInterval(async ()=>{
                            sslTries += 1;
                            const sslResponse = await checkSSL(`${props.data.siteUrl}`);
                            if (sslResponse === 200) {
                                clearInterval(sslInterval);
                                enqueueSnackbar("SSL is ready for your domain.", {
                                    variant: "success",
                                    className: "bg-catelina-blue"
                                });
                            } else if (sslResponse === 500 || sslTries >= 60) {
                                clearInterval(sslInterval);
                                enqueueSnackbar("Your site is published, but SSL is still being provisioned for the domain.", {
                                    variant: "info"
                                });
                            }
                        }, 5000);
                    }
                } else if (status === "failed") {
                    __DBG__("status=failed", statusPayload);
                    stopPublishPolling();
                    setIsLoading(false);
                    setIsPublishing(false);
                    setShowPublishConfirmation(false);
                    showErrorNotification(statusPayload?.publishError || undefined);
                }
            } catch (e) {
                __DBG__("poller exception", e);
                stopPublishPolling();
                setIsLoading(false);
                setIsPublishing(false);
                setShowPublishConfirmation(false);
                showErrorNotification("Failed while checking publish status.");
            } finally{
                publishPollRef.current.inFlight = false;
            }
        }, 5000);
        publishPollRef.current.timeoutId = setTimeout(()=>{
            __DBG__("poller timeout");
            if (publishPollRef.current.intervalId) {
                stopPublishPolling();
                setIsLoading(false);
                setIsPublishing(false);
                setShowPublishConfirmation(false);
                showErrorNotification();
            }
        }, 300000);
    };
    /**
 * Displays a success notification when publishing is completed.
 * 
 * The notification includes a link to visit the published website and persists
 * until manually dismissed. This function also handles cleanup of any existing
 * snackbars, including the "publishing..." notification.
 * 
 * @param domain - The URL of the published website. Defaults to an empty string.
 * 
 * @remarks
 * - Sets `isPublishing` state to `false`
 * - Closes all existing snackbars before showing the new one
 * - Clears the `publishingSnackKeyRef` reference
 * - The notification can be dismissed by clicking anywhere on it
 * - The notification uses a persistent variant that won't auto-dismiss
 */ const showPublishNotification = (domain = "")=>{
        __DBG__("showPublishNotification", {
            domain: domain
        });
        setIsPublishing(false);
        // Close the earlier "publishing..." snackbar (if any)
        if (publishingSnackKeyRef.current) {
            closeSnackbar(publishingSnackKeyRef.current);
            publishingSnackKeyRef.current = null;
        }
        enqueueSnackbar(/*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-col",
            onClick: ()=>{
                closeSnackbar();
            }
        }, /*#__PURE__*/ $eeH7J.createElement("span", null, "Publishing Completed!"), /*#__PURE__*/ $eeH7J.createElement("a", {
            className: "text-white underline",
            href: `${domain}`,
            target: "_blank",
            rel: "noreferrer"
        }, "Visit website")), {
            variant: "success",
            className: "bg-catelina-blue",
            persist: true
        });
    };
    /**
 * Displays an error notification to the user when site publishing fails.
 * 
 * This function performs the following actions:
 * 1. Sets the publishing state to false
 * 2. Logs the error message for debugging
 * 3. Closes the specific "publishing..." snackbar if it exists
 * 4. Displays a new error snackbar with the provided message
 * 
 * @param msg - The error message to display. Defaults to "Something went wrong while publishing your site"
 * @returns void
 */ const showErrorNotification = (msg = "Something went wrong while publishing your site")=>{
        setIsPublishing(false);
        __DBG__("showErrorNotification", {
            msg: msg
        });
        // Close the earlier "publishing..." snackbar (if any)
        if (publishingSnackKeyRef.current) {
            closeSnackbar(publishingSnackKeyRef.current);
            publishingSnackKeyRef.current = null;
        }
        enqueueSnackbar(msg, {
            variant: "error"
        });
    };
    /**
 * Handles the site rename operation.
 * Validates the new site name by checking if it's not blank and doesn't already exist
 * (case-insensitive comparison) among other sites.
 * If validation passes, hides the rename dialog and triggers the rename callback.
 * 
 * @remarks
 * - Sets a "Site name can't be blank" error if the new name is empty
 * - Sets an "Entered site name already exists" error if the name conflicts with another site
 * - Excludes the current site from the duplicate name check using siteId comparison
 * 
 * @returns {void}
 */ const handleRename = ()=>{
        // console.log("rename", props.sitesData, newSiteName);
        if (newSiteName === "") {
            setRenameError("Site name can't be blank");
            return;
        } else {
            let idx = props.sitesData.findIndex((kk)=>kk.siteName.toLowerCase() === newSiteName.toLowerCase() && kk.siteId !== props.data.siteId);
            if (idx >= 0) {
                setRenameError("Entered site name already exists");
                return;
            }
        }
        setShowRename(false);
        props.onSiteRename(props.data.siteId, newSiteName);
    };
    /**
 * Array of menu items for site actions.
 * 
 * @remarks
 * Contains two menu items:
 * 1. Publish & View - Conditionally publishes and/or views the site
 *    - If site is published: navigates to view
 *    - If site is not published and not currently publishing: shows publish confirmation dialog
 *    - If publishing is in progress: shows a warning notification
 * 
 * 2. Rename - Opens the rename dialog for the site
 *    - Disabled for site with ID "2e2b85c5-1b76-4e74-8e39-c82749386c53"
 *    - Resets the new site name state before showing the dialog
 * 
 * @see {@link onPublishViewClick} - Handler for viewing published sites
 * @see {@link setShowPublishConfirmation} - State setter for publish confirmation dialog
 * @see {@link setShowRename} - State setter for rename dialog
 */ const menuItems = [
        /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
            key: "publish-view",
            onClick: ()=>{
                if (props.data.isPublished) onPublishViewClick();
                else {
                    if (isPublishing) {
                        enqueueSnackbar("Publishing already in progress!", {
                            variant: "warning"
                        });
                        return;
                    }
                    setShowPublishConfirmation(true);
                }
            },
            sx: textClassObj
        }, /*#__PURE__*/ $eeH7J.createElement((0, $7d9fc2b31a97881e$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c42d73f72f61789d$exports))), {
            sx: textClassObj
        })), !props.data.isPublished && "Publish & ", "View"),
        /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
            key: "rename",
            onClick: ()=>{
                setNewSiteName("");
                setShowRename(true);
            },
            sx: textClassObj,
            disabled: props.data.siteId === "2e2b85c5-1b76-4e74-8e39-c82749386c53"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $7d9fc2b31a97881e$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aab8b5e9246ef85c$exports))), {
            fontSize: "small",
            sx: textClassObj
        })), "Rename")
    ];
    if (cookie_userData?.rp_user_data?.userId && props.data.siteOwnerUserId === cookie_userData.rp_user_data.userId) menuItems.push(/*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        key: "duplicate",
        onClick: ()=>{
            props.onSiteDuplicate(props.data.siteId);
        },
        sx: textClassObj
    }, /*#__PURE__*/ $eeH7J.createElement((0, $7d9fc2b31a97881e$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d660f2eec4f22fb9$exports))), {
        sx: textClassObj
    })), "Duplicate"), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        key: "delete",
        onClick: ()=>setShowConfirmation(true),
        sx: [
            ...textClassObj,
            {
                color: "#F00"
            }
        ],
        disabled: props.data.isTemplate === "true" || props.data.siteId === "2e2b85c5-1b76-4e74-8e39-c82749386c53"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $7d9fc2b31a97881e$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($04943e88a6b167d3$exports))), {
        sx: [
            ...textClassObj,
            {
                color: "#F00"
            }
        ]
    })), "Delete"));
    props.data.isDirty || props.data.disabled;
    return /*#__PURE__*/ $eeH7J.createElement((0, $9cd9945bb4eead3d$export$2e2bcd8739ae039), {
        className: `relative site-card ${props.data.isDirty === "true" ? "bg-[#FFF3F6]" : "bg-white"}`
    }, showConfirmation && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white rounded card-delete p-8 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-800 mb-4"
    }, "Are you sure you want to delete this website?"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: "bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2 focus:outline-none focus:shadow-outline w-full sm:w-auto mb-2.5 sm:mb-0",
        onClick: ()=>setShowConfirmation(false)
    }, "Cancel"), /*#__PURE__*/ $eeH7J.createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: handleDelete
    }, "Delete")))), showPublishConfirmation && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10 card-publish"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white rounded p-8 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-800 mb-4"
    }, "This will publish all the pages. Are you sure?"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: "bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2 focus:outline-none focus:shadow-outline w-full sm:w-auto mb-2.5 sm:mb-0",
        onClick: ()=>setShowPublishConfirmation(false)
    }, "Cancel"), /*#__PURE__*/ $eeH7J.createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: onPublishViewClick
    }, "Publish")))), showRename && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white card-rename rounded p-2 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e49618aca7747886$exports))), {
        className: "hover:cursor-pointer",
        onClick: ()=>setShowRename(false)
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex pt-2 px-4 sm:px-8 pb-4 flex-col justify-between md:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        id: "outlined-basic",
        // label={renameError !== "" ? renameError : "New website name"}
        label: "New website name",
        variant: "outlined",
        size: "small",
        defaultValue: props.data.siteName,
        onChange: (e)=>{
            const sanitizedValue = (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value);
            setRenameError("");
            setNewSiteName(sanitizedValue);
        },
        onKeyDown: (e)=>{
            if ([
                "<",
                ">"
            ].includes(e.key)) {
                e.preventDefault();
                setRenameError("Characters < and > are not allowed.");
            }
        },
        onBlur: (e)=>{
            const sanitizedValue = (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value);
            setNewSiteName(sanitizedValue);
        },
        // error={renameError !== ""}
        className: "w-full mb-4 md:w-64 md:mb-0"
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "self-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            height: 44,
            width: 144
        },
        className: "w-20 mr-2 capitalize",
        onClick: handleRename
    }, "Save"))), renameError !== "" ? /*#__PURE__*/ $eeH7J.createElement("p", {
        className: `text-red-500 pl-3`
    }, renameError) : null)), /*#__PURE__*/ $eeH7J.createElement("img", {
        onClick: ()=>window.open(`${"https://editorstage.rocketpages.io"}/${props.data.siteId}`, "_self"),
        className: "w-full siteImageUrl md:min-h-0 md:h-[200px] object-cover cursor-pointer",
        src: props.data.siteImageURL
    }), /*#__PURE__*/ $eeH7J.createElement((0, $e769f4d48b989a5f$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        gutterBottom: true,
        component: "div",
        className: "text-base-2",
        display: "inline"
    }), props.data.siteName, props.data.isTemplate === "true" ? " (Template)" : "", (props.data?.isDirty === "true" || props.data?.disabled === "true") && /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        display: "inline",
        whiteSpace: "nowrap",
        sx: {
            fontSize: "0.7rem",
            color: "#fff",
            background: "#f94343",
            borderRadius: "0.75rem",
            overflowWrap: "break-word",
            paddingX: "0.4rem",
            paddingY: "0.06125rem",
            marginLeft: "0.4rem"
        }
    }, props.data.isDirty ? "Expires soon" : "Disabled")), /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        sx: {
            fontSize: "0.7rem",
            color: "#243060",
            opacity: props.data.isPublished ? 1 : 0.6,
            overflowWrap: "break-word"
        }
    }, props.data.isPublished ? /*#__PURE__*/ $eeH7J.createElement((0, $6b6b8319e9394158$export$2e2bcd8739ae039), {
        href: props.data.siteUrl,
        underline: "none",
        target: "_blank"
    }, props.data.siteUrl.replace(/^https?:\/\//, "")) : "Not published"), props.data.isDirty === "true" && /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        sx: {
            fontSize: "0.7rem",
            color: "red",
            marginTop: "6px",
            opacity: props.data.isPublished ? 1 : 0.6,
            overflowWrap: "break-word"
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        fontSize: "small",
        sx: {
            marginRight: "6px"
        }
    }), calculateTimeRemaining(props.data.createdAt))), /*#__PURE__*/ $eeH7J.createElement((0, $64f662c6a0feea4f$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full flex flex-row justify-between"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        variant: "outlined",
        sx: {
            textTransform: "none",
            marginRight: "6px",
            backgroundColor: "white"
        },
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99435d3d07a9b8ca$exports))), null),
        onClick: props.onEditSite
    }, "Edit site"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "relative setting-icon"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        onClick: // props.data.siteId === "2e2b85c5-1b76-4e74-8e39-c82749386c53"
        //   ? null
        //   :
        props.onSettingClick,
        className: "w-[36px] hover:cursor-pointer",
        src: (parcelRequire("lSN08")),
        alt: ""
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "icon-tooltip-text"
    }, "Site Setting"))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "relative site-menu",
        onClick: handleClick
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        onClick: props.onMoreOptionClick,
        className: "w-[36px] hover:cursor-pointer",
        src: (parcelRequire("5Ggop")),
        alt: ""
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "icon-tooltip-text"
    }, "Site Menu")))), /*#__PURE__*/ $eeH7J.createElement((0, $e81d86cc7ed08456$export$2e2bcd8739ae039), {
        className: "siteMenuOptions",
        anchorEl: anchorEl,
        id: "account-menu",
        open: open,
        onClose: handleClose,
        onClick: handleClose,
        PaperProps: {
            elevation: 0,
            sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                },
                "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0
                }
            }
        },
        transformOrigin: {
            horizontal: "right",
            vertical: "top"
        },
        anchorOrigin: {
            horizontal: "right",
            vertical: "bottom"
        }
    }, menuItems));
};
var $f4c6588ca71f4ee3$export$2e2bcd8739ae039 = $f4c6588ca71f4ee3$var$SiteItem;













const $5526b3720844f590$export$fedd53519a0e2bce = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const [showIsDirtySites, setShowIsDirtySites] = (0, $eeH7J.useState)(false);
    const [sitesData, setSitesData] = (0, $eeH7J.useState)([]);
    const [cookie_userData, setCookie_userData, removeCookie_userData] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    async function fetchData() {
        // let user: any = localStorage.getItem("userData") || "";
        // console.log('fetchData', ,cookie_userData.rp_user_data)
        setIsLoading(true);
        try {
            let user = cookie_userData.rp_user_data || location.state && location.state.user.data;
            // user = JSON.parse(user);
            if (user) {
                let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/users-site-configs?userId=${user.userId}`);
                setSitesData(response.data.data);
                setShowIsDirtySites(response.data.data.filter((oo)=>oo.isDirty === "true").length > 0 || response.data.data.filter((oo)=>oo.disabled).length > 0);
            // console.log("response", response.data.data);
            }
        } catch (e) {} finally{
            setIsLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData();
    }, []);
    const onCreateNewWebsite = ()=>{
        navigate(`/choose-template`);
    };
    const onSiteRename = async (siteId, newSiteName)=>{
        try {
            setIsLoading(true);
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/append-site-config`, {
                siteId: siteId,
                siteName: newSiteName
            });
            fetchData();
        } catch (e) {
            console.error("onSiteRename", e);
            const errorMessage = e.response?.data?.message || "Failed to rename site.";
            enqueueSnackbar(errorMessage, {
                variant: "error"
            });
            fetchData();
        } finally{
            setIsLoading(false);
        }
    };
    const onSiteDelete = async (siteId)=>{
        try {
            setIsLoading(true);
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/delete-site`, {
                siteId: siteId
            });
            enqueueSnackbar("Site deleted successfully!", {
                variant: "info",
                className: "bg-grey-400"
            });
            fetchData();
        } catch (e) {
            console.error("onSiteDelete", e);
        } finally{
            setIsLoading(false);
        }
    };
    const onSiteDuplicate = async (siteId)=>{
        setIsLoading(true);
        try {
            setIsLoading(true);
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/duplicate-site`, {
                siteId: siteId
            });
            enqueueSnackbar("Site duplicated successfully!", {
                variant: "success",
                className: "bg-grey-400"
            });
            fetchData();
        } catch (e) {
            console.error("onSiteDuplicate", e);
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Dashboard"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        title: "My websites"
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-gray-100 flex absolute flex-col top-[64px] w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full"
    }, sitesData.length > 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-3 px-4 flex md:justify-end"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        variant: "contained",
        sx: {
            backgroundColor: "#243060",
            textTransform: "none"
        },
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($37bc6bb2c48d369a$exports))), {
            sx: {
                color: "#fff"
            }
        }),
        onClick: onCreateNewWebsite
    }, "Create new website")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-gray-100 min-h-screen p-4"
    }, showIsDirtySites && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed action-popup inset-0 overflow-y-auto flex justify-center items-center z-10 "
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-[#FAFAFA] rounded-xl p-2 w-11/12 mx-auto z-50 border-2 border-red-600 m-4 absolute lg:top-auto top-20 "
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e49618aca7747886$exports))), {
        className: "hover:cursor-pointer absolute",
        onClick: ()=>setShowIsDirtySites(false)
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex pt-2 px-4 sm:px-2 pb-4 flex-col justify-center text-black items-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-red-500 font-medium mt-1.5 mb-1.5"
    }, "Actions Required"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base font-normal text-center"
    }, "Some of your sites need your immediate attention."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex h-[60vh] w-full mt-4 lg:flex-row flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `border md:h-full unsaved-sites  h-1/2 overflow-y-auto border-color-red w-full lg:w-1/2 lg:mr-2 mr-0 p-2 mb-4 rounded-md bg-white flex-1 ${sitesData.filter((oo)=>oo.isDirty === "true").length === 0 ? "hidden" : ""}`
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row items-center justify-between w-full mt-1"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-red-500"
    }, sitesData.filter((oo)=>oo.isDirty === "true").length, " ", sitesData.filter((oo)=>oo.isDirty === "true").length === 1 ? "Site" : "Sites", " ", "at Risk of Deletion:"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        variant: "contained",
        className: "",
        sx: {
            backgroundColor: "#243060",
            textTransform: "none",
            width: "85px"
        },
        onClick: async ()=>{
            setIsLoading(true);
            let _jjjj = [];
            sitesData.filter((oo)=>oo.isDirty === "true").map((oo)=>_jjjj.push(oo.siteId));
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/retain-sites`, {
                siteIds: _jjjj
            });
            if (res.status === 200) fetchData();
        }
    }, "Save all")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col rounded-md h-8/12 overflow-y-auto w-full mt-4"
    }, sitesData.filter((oo)=>oo.isDirty === "true").map((itm, _idx)=>{
        return /*#__PURE__*/ $eeH7J.createElement("div", {
            className: `flex flex-row items-center md:gap-0 gap-2 justify-between md:mx-4 mx-1 py-2 border-b`,
            key: itm.siteId
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "flex items-center"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "mr-4"
        }, _idx + 1), /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "text-left"
        }, itm.siteName)), /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "flex"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            sx: {
                // backgroundColor: "#243060",
                marginRight: "8px",
                textTransform: "none"
            },
            onClick: async ()=>{
                let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/retain-sites`, {
                    siteIds: [
                        itm.siteId
                    ]
                });
                if (res.status === 200) fetchData();
            }
        }, "Save"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            sx: {
                // backgroundColor: "#243060",
                textTransform: "none"
            },
            onClick: ()=>{
                let _url = `${"https://editorstage.rocketpages.io"}/${itm.siteId}`;
                window.open(_url, "_self")?.focus();
            }
        }, "Edit")));
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `border md:h-full visitor-limit-exide-sites  h-1/2 overflow-y-auto border-color-red w-full lg:w-1/2 lg:ml-2 ml-0 p-2 rounded-md bg-white flex-1 ${sitesData.filter((oo)=>oo.disabled).length === 0 ? "hidden" : ""}`
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row md:text-left justify-between w-full mt-2.5"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-red-500"
    }, sitesData.filter((oo)=>oo.disabled === "true").length, " ", sitesData.filter((oo)=>oo.disabled === "true").length === 1 ? "Site" : "Sites", " ", "hit visitor limit and are now disabled. Upgrade to keep live.")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col  rounded-md h-8/12 overflow-y-auto w-full mt-6"
    }, sitesData.filter((oo)=>oo.disabled).map((itm, _idx)=>{
        return /*#__PURE__*/ $eeH7J.createElement("div", {
            key: itm.siteId,
            className: `flex flex-row items-center md:gap-0 gap-2 justify-between md:mx-4 mx-1 py-2 border-b`
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "flex"
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "mr-4 items-center flex"
        }, _idx + 1), /*#__PURE__*/ $eeH7J.createElement("span", null, itm.siteName)), /*#__PURE__*/ $eeH7J.createElement("span", null, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            className: "w-max ",
            sx: {
                // backgroundColor: "#243060",
                textTransform: "none"
            },
            onClick: ()=>{
                navigate(`/site-settings/${itm.siteId}?section=Subscriptions&tab=pricing`);
            }
        }, "Upgrade Plan")));
    }))))))), sitesData.length === 0 && /*#__PURE__*/ $eeH7J.createElement((0, $bbf05946fe7aec77$export$2e2bcd8739ae039), {
        onNewWebsiteClick: onCreateNewWebsite
    }), sitesData.filter((oo)=>oo.isDirty === "true").length > 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-[#FFD970] flex justify-center py-2 text-black mx-4"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "ml-2 flex items-center"
    }, "Your websites will be deleted if not saved or updated within 3 days.")), sitesData.length > 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "px-4 grid grid-cols-1 gap-8 py-4 md:grid-cols-2 lg:grid-cols-3"
    }, sitesData.map((item)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $f4c6588ca71f4ee3$export$2e2bcd8739ae039), {
            key: item.siteId,
            data: item,
            sitesData: sitesData,
            onSettingClick: ()=>{
                navigate(`/site-settings/${item.siteId}`);
            },
            onEditSite: ()=>{
                window.location.href = `${"https://editorstage.rocketpages.io"}/${item.siteId}/`;
            // window.location.reload();
            },
            onSiteRename: (siteId, newSiteName)=>{
                onSiteRename(siteId, newSiteName);
            // console.log(`Rename ${siteId} to ${newSiteName}`);
            },
            onSiteDelete: (siteId)=>{
                onSiteDelete(siteId);
            // console.log(`delete ${siteId}`);
            },
            onSiteDuplicate: (siteId)=>{
                onSiteDuplicate(siteId);
            // console.log(`duplicate ${siteId}`);
            }
        });
    })))))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");





const $afb3ca3d5bab8141$export$a76a49cc6daba0ed = (props)=>{
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - DNS Service Providers"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium dns-service-providers"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        title: "DNS Service Providers"
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "my-4 pl-[20px]  pb-10 pt-[64px] bg-white-smoke pr-[20px] text-black font-normal"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "lg:w-auto xl:w-8/12 m-auto bg-white px-4 lg:px-24 py-8"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", null, "GoDaddy"), /*#__PURE__*/ $eeH7J.createElement("ol", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Sign In to GoDaddy:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Log in to your GoDaddy account."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Access Domain Settings:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Navigate to "My Products."'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Find your domain and click on "DNS" or "Manage."'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Scroll down to the "Records" section.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Add" to create a new DNS record.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Name:"), ' "[YourDomainName]"'), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Value:"), " 146.190.156.136"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "TTL:"), " Default"))))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $eeH7J.createElement("li", null, "Click the pencil icon next to the record to edit it."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Value" field to 146.190.156.136).'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $eeH7J.createElement("h3", null, "Cloudflare"), /*#__PURE__*/ $eeH7J.createElement("ol", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Sign In to Cloudflare:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Log in to your Cloudflare account."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Access DNS Settings:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Select the domain you want to manage."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click on the "DNS" tab.'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Add record."'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Name:"), " [YourDomainName]"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "IPv4 address:"), " 146.190.156.136"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "TTL:"), " Auto"))))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $eeH7J.createElement("li", null, "Click on the record to edit it."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "IPv4 address" field to 146.190.156.136).'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $eeH7J.createElement("h3", null, "Amazon Route 53"), /*#__PURE__*/ $eeH7J.createElement("ol", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Sign In to AWS Management Console:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Go to the AWS Management Console and log in."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Access Route 53:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Navigate to Amazon Route 53."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click on "Hosted Zones."'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Select Domain:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Choose the domain you want to manage."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Create Record Set."'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Name:"), " [YourDomainName]"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Type:"), " A - IPv4 address"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Value:"), " 146.190.156.136"))))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $eeH7J.createElement("li", null, "Click on the record to edit it."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Value" field to 146.190.156.136).'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save Record Set."')))), /*#__PURE__*/ $eeH7J.createElement("h3", null, "Google Domains"), /*#__PURE__*/ $eeH7J.createElement("ol", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Sign In to Google Domains:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Go to Google Domains and log in to your account."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Manage Domain:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Locate your domain and click on "Manage" or "DNS."'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Scroll down to the "Custom resource records" section.'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Name:"), " [YourDomainName]"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Type:"), " A"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "TTL:"), " 1h"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Data:"), " 146.190.156.136"))))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $eeH7J.createElement("li", null, "Click on the pencil icon next to the record to edit it."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Data" field to 146.190.156.136).'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $eeH7J.createElement("h3", null, "Namecheap"), /*#__PURE__*/ $eeH7J.createElement("ol", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Sign In to Namecheap:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Log in to your Namecheap account."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Manage Domain:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Select the domain you want to manage."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click on "Manage" next to the domain.'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Access Advanced DNS:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click on the "Advanced DNS" tab.'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Scroll down to the "Host Records" section.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Add New Record."'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Select "A Record" as the type.'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Host Record:"), " [YourDomainName]"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Points To:"), " 146.190.156.136"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "TTL:"), " Automatic"))), /*#__PURE__*/ $eeH7J.createElement("li", null, "Click the checkmark to save."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $eeH7J.createElement("li", null, "Click on the pencil icon next to the record to edit it."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "IP Address" field to 146.190.156.136).'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Click the checkmark to save.")))), /*#__PURE__*/ $eeH7J.createElement("h3", null, "Bluehost"), /*#__PURE__*/ $eeH7J.createElement("ol", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Sign In to Namecheap:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Log in to your Bluehost account."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Access Domain Manager:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'From the Bluehost dashboard, click on "Domains" and then "My Domains."'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Manage DNS:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click the "Manage" button next to the domain you want to update.'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Go to the "DNS" tab.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Scroll down to the "Add DNS Record" section.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Host Record:"), " [YourDomainName]"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Points To:"), " 146.190.156.136"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "TTL:"), " Default"))), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save."'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Edit" next to the record.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Points To" field to 146.190.156.136).'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $eeH7J.createElement("h3", null, "HostGator"), /*#__PURE__*/ $eeH7J.createElement("ol", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Sign In to HostGator:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Log in to your HostGator account."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Access Domain Manager:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'From the HostGator dashboard, click on "Domains" and then "My Domains."'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Manage DNS:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click the "Manage" button next to the domain you want to update.'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, 'Go to the "DNS" tab.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Scroll down to the "Add DNS Record" section.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $eeH7J.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Host Record:"), " [YourDomainName]"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Points To:"), " 146.190.156.136"), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "TTL:"), " Default"))), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save."'))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Edit" next to the record.'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Points To" field to 146.190.156.136).'), /*#__PURE__*/ $eeH7J.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $eeH7J.createElement("h3", null, "Final Steps for All Providers"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Wait for Propagation:"), /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, "Allow up to 24-48 hours for DNS changes to propagate."))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement("b", null, "Test Your Domain:"), /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, "Visit your domain to ensure it is correctly pointing to your hosting provider."))))))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $4A7Fh = parcelRequire("4A7Fh");


var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d41687ad4f0bfec0$export$47a2da616e55e8e9(slot) {
    return (0, $aBqGi.default)('MuiAppBar', slot);
}
const $d41687ad4f0bfec0$var$appBarClasses = (0, $cDqLM.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $d41687ad4f0bfec0$export$2e2bcd8739ae039 = $d41687ad4f0bfec0$var$appBarClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $432ddb46a3a89dc6$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $432ddb46a3a89dc6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4A7Fh.default)(color)}`,
            `position${(0, $4A7Fh.default)(position)}`
        ]
    };
    return (0, $doIAf.default)(slots, (0, $d41687ad4f0bfec0$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $432ddb46a3a89dc6$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $432ddb46a3a89dc6$var$AppBarRoot = (0, $hikmr.default)((0, $d3bbaaf68436ce97$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $4A7Fh.default)(ownerState.position)}`],
            styles[`color${(0, $4A7Fh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $h4XE0.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $h4XE0.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $h4XE0.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $h4XE0.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $432ddb46a3a89dc6$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $432ddb46a3a89dc6$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $432ddb46a3a89dc6$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $432ddb46a3a89dc6$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $432ddb46a3a89dc6$var$AppBar = /*#__PURE__*/ $eeH7J.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $fbOaB.default)(props, $432ddb46a3a89dc6$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $432ddb46a3a89dc6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($432ddb46a3a89dc6$var$AppBarRoot, (0, $h4XE0.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $er6YD.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
$432ddb46a3a89dc6$var$AppBar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'default',
            'inherit',
            'primary',
            'secondary',
            'transparent',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */ enableColorOnDark: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'absolute',
        'fixed',
        'relative',
        'static',
        'sticky'
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $432ddb46a3a89dc6$export$2e2bcd8739ae039 = $432ddb46a3a89dc6$var$AppBar;




var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $9f4ab9b13f0018d1$export$b12cb262231eef32(slot) {
    return (0, $aBqGi.default)('MuiToolbar', slot);
}
const $9f4ab9b13f0018d1$var$toolbarClasses = (0, $cDqLM.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $9f4ab9b13f0018d1$export$2e2bcd8739ae039 = $9f4ab9b13f0018d1$var$toolbarClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $a3334c017ed5a6a5$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $a3334c017ed5a6a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $doIAf.default)(slots, (0, $9f4ab9b13f0018d1$export$b12cb262231eef32), classes);
};
const $a3334c017ed5a6a5$var$ToolbarRoot = (0, $hikmr.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $a3334c017ed5a6a5$var$Toolbar = /*#__PURE__*/ $eeH7J.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $fbOaB.default)(props, $a3334c017ed5a6a5$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $a3334c017ed5a6a5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($a3334c017ed5a6a5$var$ToolbarRoot, (0, $h4XE0.default)({
        as: component,
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$a3334c017ed5a6a5$var$Toolbar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, disables gutter padding.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The variant to use.
   * @default 'regular'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'dense',
            'regular'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $a3334c017ed5a6a5$export$2e2bcd8739ae039 = $a3334c017ed5a6a5$var$Toolbar;





var $036f658210ee9701$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($036f658210ee9701$exports, "__esModule", {
    value: true
});
$036f658210ee9701$exports.default = void 0;

var $036f658210ee9701$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $036f658210ee9701$var$_default = $036f658210ee9701$exports.default = (0, $036f658210ee9701$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');



var $4yBem = parcelRequire("4yBem");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");


var $aBqGi = parcelRequire("aBqGi");

var $doIAf = parcelRequire("doIAf");

var $3Rthm = parcelRequire("3Rthm");



var $kO80n = parcelRequire("kO80n");

var $dRzna = parcelRequire("dRzna");
const $952a3d2464017b41$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $952a3d2464017b41$var$defaultTheme = (0, $kO80n.default)();
const $952a3d2464017b41$var$defaultCreateStyledComponent = (0, $24e3fd750d7cd7c6$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $3Rthm.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $952a3d2464017b41$var$useThemePropsDefault = (inProps)=>(0, $8c1ba3299ee127fd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $952a3d2464017b41$var$defaultTheme
    });
const $952a3d2464017b41$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $aBqGi.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $3Rthm.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $doIAf.default)(slots, getContainerUtilityClass, classes);
};
function $952a3d2464017b41$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $952a3d2464017b41$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $952a3d2464017b41$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $eeH7J.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $fbOaB.default)(props, $952a3d2464017b41$var$_excluded);
        const ownerState = (0, $h4XE0.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $952a3d2464017b41$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $dRzna.jsx)(ContainerRoot, (0, $h4XE0.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $de137779e6107095$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other)));
    });
    Container.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
        classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
        fixed: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
        maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                false
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        ]),
        sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
                (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    };
    return Container;
}



var $4A7Fh = parcelRequire("4A7Fh");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");
'use client';
const $0d84922cca4f4d37$var$Container = (0, $952a3d2464017b41$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $hikmr.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $4A7Fh.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $lNnGW.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
$0d84922cca4f4d37$var$Container.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */ fixed: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */ maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            false
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $0d84922cca4f4d37$export$2e2bcd8739ae039 = $0d84922cca4f4d37$var$Container;






function $a1776588e7982209$var$useQuery() {
    const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    return $eeH7J.useMemo(()=>new URLSearchParams(search), [
        search
    ]);
}


const $a1776588e7982209$export$8b251419efc915eb = ()=>{
    const [anchorElNav, setAnchorElNav] = $eeH7J.useState(null);
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const { pathname: pathname, search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const pages = [
        "TEMPLATES",
        "PRICING",
        "CONTACT",
        "SIGN UP"
    ];
    const pageRoutes = {
        TEMPLATES: "/choose-template",
        PRICING: "https://rocketpages.io/pricing",
        CONTACT: "https://rocketpages.io/contact",
        "SIGN UP": `/signup${search}`
    };
    const handleOpenNavMenu = (event)=>{
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = ()=>{
        setAnchorElNav(null);
    };
    const handlePageNavigation = (page)=>{
        const route = pageRoutes[page];
        if (route.startsWith("http")) window.open(route, "_blank"); // For external links
        else navigate(route); // For internal links
        handleCloseNavMenu();
    };
    const checkIsInFrame = ()=>{
        try {
            return window.self !== window.top; // Returns true if in an iframe
        } catch (e) {
            return true; // Fallback in case of security restrictions
        }
    };
    const isLoginPage = pathname === "/login"; // Check if on the signup page
    const isInIframe = checkIsInFrame();
    let query = $a1776588e7982209$var$useQuery();
    let l_userId = query.get("userId");
    let l_siteId = query.get("siteId");
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex items-center sm:justify-between justify-center py-2 px-5 sticky top-0 z-50 bg-white/80 backdrop-blur-sm"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $432ddb46a3a89dc6$export$2e2bcd8739ae039), {
        position: "sticky",
        className: `bg-transparent flex justify-between items-center shadow-none px-0`
    }, /*#__PURE__*/ $eeH7J.createElement((0, $0d84922cca4f4d37$export$2e2bcd8739ae039), {
        disableGutters: true,
        maxWidth: false,
        sx: {
            maxWidth: '1470px'
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $a3334c017ed5a6a5$export$2e2bcd8739ae039), {
        disableGutters: true,
        className: `flex justify-between`
    }, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).logoLight} mr-2 md:mr-5 w-8 md:w-52`,
        to: "/",
        onClick: (e)=>{
            e.preventDefault();
            window.open("/", "_blank");
        }
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "w-full hover:cursor-pointer hidden md:block",
        src: (parcelRequire("7wrxA")),
        alt: "Log In"
    }), /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "w-full hover:cursor-pointer md:hidden",
        src: (parcelRequire("b7qLs")),
        alt: "Log In"
    })), !isInIframe && /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            flexGrow: 1,
            justifyContent: "flex-end",
            display: {
                xs: "flex",
                lg: "none"
            }
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        size: "large",
        "aria-label": "account of current user",
        "aria-controls": "menu-appbar",
        "aria-haspopup": "true",
        onClick: handleOpenNavMenu,
        sx: {
            color: "#243460"
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($036f658210ee9701$exports))), null)), /*#__PURE__*/ $eeH7J.createElement((0, $e81d86cc7ed08456$export$2e2bcd8739ae039), {
        id: "menu-appbar",
        anchorEl: anchorElNav,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        keepMounted: true,
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        open: Boolean(anchorElNav),
        onClose: handleCloseNavMenu,
        sx: {
            display: {
                xs: "block",
                lg: "none"
            }
        },
        PaperProps: {
            sx: {
                backgroundColor: "#fff",
                width: "336px",
                height: "unset",
                boxShadow: "1px 1px 12.3px 0px #00000040",
                padding: "24px 8px",
                top: "85px !important",
                right: "0px !important",
                left: "unset !important"
            }
        }
    }, pages.slice(0, 3).map((page)=>/*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
            key: page,
            onClick: ()=>handlePageNavigation(page),
            sx: {
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: "transparent"
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
            sx: {
                textAlign: "center",
                fontSize: "14px",
                lineHeight: "28px",
                color: "#243060",
                fontWeight: 600,
                "&:hover": {
                    color: "#FE7165",
                    backgroundColor: "transparent"
                }
            }
        }, page))), /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), {
        sx: {
            margin: "30px 16px !important"
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            paddingX: "16px"
        }
    }, isInIframe ? /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: {
            pathname: isLoginPage ? `/signup` : "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        }
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN")) : /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: isLoginPage ? `/signup${search}` : "/login"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN"))))), /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            alignItems: "center",
            justifyContent: "center",
            gap: "54px",
            flexGrow: 1,
            display: {
                xs: "none",
                lg: "flex"
            }
        }
    }, !isInIframe && pages.slice(0, 3).map((page)=>/*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
            key: page,
            onClick: ()=>handlePageNavigation(page),
            sx: {
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: "transparent"
                }
            }
        }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
            sx: {
                textAlign: "center",
                fontSize: "14px",
                lineHeight: "28px",
                color: "#243060",
                fontWeight: 600,
                "&:hover": {
                    color: "#FE7165",
                    backgroundColor: "transparent"
                }
            }
        }, page)))), /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            flexGrow: 0,
            marginRight: "4px",
            display: {
                xs: "none",
                lg: "flex"
            }
        }
    }, isInIframe ? /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: {
            pathname: isLoginPage ? `/signup` : "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        }
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN")) : /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: isLoginPage ? `/signup${search}` : "/login"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN"))), /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            flexGrow: 0,
            display: "flex",
            alignItems: "center",
            gap: "25px"
        }
    }, isInIframe ? /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: isLoginPage ? `/signup${search}` : `/login${search}`
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).signUpBtn}`
    }, isLoginPage ? "SIGNUP" : "LOGIN")) : /*#__PURE__*/ $eeH7J.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).signUpBtn}`,
        onClick: ()=>{
            navigate(`/choose-template`);
        }
    }, "GET STARTED"))))));
};






const $88c2b77535cb4f6d$var$MAX_EMAIL_LENGTH = 254;
function $88c2b77535cb4f6d$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}


const $88c2b77535cb4f6d$var$ForgotPassword = ()=>{
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_loggedin"
    ]); // Access cookies
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const isInIframe = $88c2b77535cb4f6d$var$checkIsInFrame();
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState("");
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        email: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        email: ""
    });
    const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const query = new URLSearchParams(location.search);
    const l_userId = query.get("userId");
    const l_siteId = query.get("siteId");
    function handleChange(event) {
        setFormErrors({
            email: ""
        });
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value
            };
        });
        setErrorMessage("");
    }
    function isValidEmail(email) {
        // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    function validateForm(formData) {
        try {
            setFormErrors({
                email: ""
            });
            if (formData.email === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Email can not be empty."
                    };
                });
                return false;
            }
            if (!isValidEmail(formData.email)) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Invalid email address."
                    };
                });
                return false;
            }
            if (formData.email.length > $88c2b77535cb4f6d$var$MAX_EMAIL_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: `Email cannot exceed ${$88c2b77535cb4f6d$var$MAX_EMAIL_LENGTH} characters.`
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onSubmit(event) {
        event.preventDefault();
        if (!validateForm(formData)) return;
        try {
            setIsLoading(true);
            let data = {
                email: formData.email
            };
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/gen-reset-password-link", data);
            localStorage.setItem("rp_reset_email", formData.email);
            setIsLoading(false);
            enqueueSnackbar("Password reset link sent to your email address!", {
                variant: "info",
                className: "bg-grey-400"
            });
            navigate("/login", {
                state: {
                    userId: l_userId,
                    siteId: l_siteId
                }
            });
        } catch (err) {
            setIsLoading(false);
            const message = err.response?.data?.message || err.message || "Unable to send reset link.";
            setErrorMessage(message);
            enqueueSnackbar(message, {
                variant: "error"
            });
        }
    }
    const isFormInvalid = formErrors.email !== "" || formData.email === "";
    (0, $eeH7J.useEffect)(()=>{
        // Redirect if user is already logged in
        if (cookies.rp_loggedin) navigate("/choose-template"); // Redirect to the dashboard
    }, [
        cookies.rp_loggedin,
        navigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).forgotPassword}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a1776588e7982209$export$8b251419efc915eb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).contentContaienr} flex justify-start`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).content} md:flex md:flex-col ${isInIframe ? (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).nopadding : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).formContainer}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).heading} mt-1 md:mt-8 lg:mt-16 mb-2`
    }, "Forgot password?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h4", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).subHeading} mt-0.5`
    }, "Enter your email address and we\u2019ll send you a link to reset your password."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginForm}`,
        onSubmit: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "email"
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        type: "email",
        id: "email",
        value: formData.email,
        onChange: handleChange,
        placeholder: "Enter email address",
        maxLength: $88c2b77535cb4f6d$var$MAX_EMAIL_LENGTH,
        className: `${formErrors.email !== "" ? "border-red-500" : ""}`
    }), formErrors.email !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.email)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        type: "submit",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginBtn} ${isFormInvalid ? "opacity-50 cursor-not-allowed" : ""} `,
        disabled: isFormInvalid
    }, "Send Link"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: {
            textAlign: "center",
            marginTop: "16px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: isInIframe ? {
            pathname: "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        } : `/login${search}`,
        className: "text-sm text-[#243460] font-semibold",
        style: {
            textDecoration: "none"
        }
    }, "Try a different login method"))))))), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};
var $88c2b77535cb4f6d$export$2e2bcd8739ae039 = $88c2b77535cb4f6d$var$ForgotPassword;



const $3c846f88b10cc416$export$c7a55480dba6f1f1 = ()=>{
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Forgot Password"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement((0, $88c2b77535cb4f6d$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");



var $eeH7J = parcelRequire("eeH7J");

// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper/
// https://swr.vercel.app/docs/error-handling
// import { signOut } from "next-auth/react"
function $0949f4e5bf0067a7$export$2e2bcd8739ae039(endpoint, customConfig = {}) {
    const { body: body, form: form, ...configWithoutBody } = customConfig;
    const headers = form ? {} : {
        "content-type": "application/json"
    };
    const config = {
        ...configWithoutBody,
        method: configWithoutBody.method || (body || form ? "POST" : "GET"),
        headers: {
            ...headers,
            ...customConfig.headers
        }
    };
    if (body) config.body = JSON.stringify(body);
    else if (form) config.body = form;
    return window.fetch(endpoint, config).then(async (res)=>{
        if (res.status === 401) return;
        if (res.ok) return await res.json();
        // If the status code is not in the range 200-299,
        // we still try to parse and throw it.
        const error = new Error("An error occurred while fetching the data.");
        // Attach extra info to the error object.
        error.info = await res.json();
        error.status = res.status;
        throw error;
    });
}
const $0949f4e5bf0067a7$export$ef8ee90e6d704faf = (endpoint, customConfig)=>$0949f4e5bf0067a7$export$2e2bcd8739ae039(endpoint, customConfig).catch((error)=>({
            error: error
        }));


const $3491dbe16d2700e4$export$adaa4cf7ef1b65be = async (key, value)=>{
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error(`error setting localstorage ${key}: ${e}`);
    }
};
const $3491dbe16d2700e4$export$3988ae62b71be9a3 = async (key)=>{
    try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch (e) {
        console.error(`error getting localstorage ${key}: ${e}`);
    }
};
const $3491dbe16d2700e4$export$cd7f480d6b8286c3 = async (key)=>{
    try {
        return window.localStorage.removeItem(key);
    } catch (e) {
        console.error(`error deleting localstorage ${key}: ${e}`);
    }
};


var $51a43064f3c84c06$exports = {};
Object.defineProperty($51a43064f3c84c06$exports, '__esModule', {
    value: true
});

var $eeH7J = parcelRequire("eeH7J");
function $51a43064f3c84c06$var$_interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n.default = e;
    return Object.freeze(n);
}
var $51a43064f3c84c06$var$React__namespace = /*#__PURE__*/ $51a43064f3c84c06$var$_interopNamespaceDefault($eeH7J);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $51a43064f3c84c06$var$__assign = function() {
    $51a43064f3c84c06$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $51a43064f3c84c06$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
function $51a43064f3c84c06$var$ProgressBar(_a) {
    var _b = _a.bgColor, bgColor = _b === void 0 ? "#6a1b9a" : _b, _c = _a.height, height = _c === void 0 ? "20px" : _c, _d = _a.width, width = _d === void 0 ? "100%" : _d, _e = _a.borderRadius, borderRadius = _e === void 0 ? "50px" : _e, _f = _a.labelAlignment, labelAlignment = _f === void 0 ? "right" : _f, _g = _a.baseBgColor, baseBgColor = _g === void 0 ? "#e0e0de" : _g, _h = _a.labelColor, labelColor = _h === void 0 ? "#fff" : _h, _j = _a.labelSize, labelSize = _j === void 0 ? "15px" : _j, _k = _a.isLabelVisible, isLabelVisible = _k === void 0 ? true : _k, _l = _a.dir, dir = _l === void 0 ? "ltr" : _l, _m = _a.ariaValuemin, ariaValuemin = _m === void 0 ? 0 : _m, _o = _a.ariaValuemax, ariaValuemax = _o === void 0 ? 100 : _o, _p = _a.ariaValuetext, ariaValuetext = _p === void 0 ? null : _p, _q = _a.maxCompleted, maxCompleted = _q === void 0 ? 100 : _q, _r = _a.animateOnRender, animateOnRender = _r === void 0 ? false : _r, _s = _a.initCompletedOnAnimation, initCompletedOnAnimation = _s === void 0 ? 0 : _s, _t = _a.isIndeterminate, isIndeterminate = _t === void 0 ? false : _t, completed = _a.completed, margin = _a.margin, padding = _a.padding, customLabelStyles = _a.customLabelStyles, transitionDuration = _a.transitionDuration, transitionTimingFunction = _a.transitionTimingFunction, className = _a.className, customLabel = _a.customLabel, barContainerClassName = _a.barContainerClassName, completedClassName = _a.completedClassName, labelClassName = _a.labelClassName;
    var getAlignment = function(alignmentOption) {
        if (alignmentOption === "left") return "flex-start";
        else if (alignmentOption === "center") return "center";
        else if (alignmentOption === "right") return "flex-end";
        else return null;
    };
    var alignment = getAlignment(labelAlignment);
    var initCompletedOnAnimationStr = typeof initCompletedOnAnimation === "number" ? "".concat(initCompletedOnAnimation, "%") : initCompletedOnAnimation;
    var getFillerWidth = function(maxCompletedValue, completedValue) {
        if (maxCompletedValue) {
            var ratio = Number(completedValue) / maxCompletedValue;
            return ratio > 1 ? "100%" : "".concat(ratio * 100, "%");
        }
        return initCompletedOnAnimationStr;
    };
    var fillerWidth = getFillerWidth(maxCompleted, completed);
    var _u = $51a43064f3c84c06$var$React__namespace.useState(initCompletedOnAnimationStr), initWidth = _u[0], setInitWidth = _u[1];
    var containerStyles = {
        height: height,
        background: baseBgColor,
        borderRadius: borderRadius,
        padding: padding,
        width: width,
        margin: margin,
        overflow: "hidden"
    };
    var fillerStyles = {
        height: height,
        width: isIndeterminate ? "100%" : animateOnRender ? initWidth : fillerWidth,
        background: bgColor,
        transition: isIndeterminate ? "none" : "width ".concat(transitionDuration || "1s", " ").concat(transitionTimingFunction || "ease-in-out"),
        borderRadius: "inherit",
        display: "flex",
        alignItems: "center",
        justifyContent: labelAlignment !== "outside" && alignment ? alignment : "normal",
        animation: isIndeterminate ? "indeterminate 1.5s infinite linear" : "none"
    };
    var labelStyles = $51a43064f3c84c06$var$__assign({
        padding: labelAlignment === "outside" ? "0 0 0 5px" : "5px",
        color: labelColor,
        fontWeight: "bold",
        fontSize: labelSize,
        display: !isLabelVisible ? "none" : "initial"
    }, customLabelStyles);
    var outsideStyles = {
        display: labelAlignment === "outside" ? "flex" : "initial",
        alignItems: labelAlignment === "outside" ? "center" : "initial"
    };
    var completedStr = typeof completed === "number" ? "".concat(completed, "%") : "".concat(completed);
    var labelStr = customLabel ? customLabel : completedStr;
    $51a43064f3c84c06$var$React__namespace.useEffect(function() {
        if (animateOnRender && !isIndeterminate) requestAnimationFrame(function() {
            return setInitWidth(fillerWidth);
        });
    }, [
        fillerWidth,
        animateOnRender,
        isIndeterminate
    ]);
    return $51a43064f3c84c06$var$React__namespace.createElement("div", {
        style: className ? undefined : outsideStyles,
        className: className,
        dir: dir,
        role: "progressbar",
        "aria-valuenow": isIndeterminate ? undefined : parseFloat(labelStr),
        "aria-valuemin": ariaValuemin,
        "aria-valuemax": ariaValuemax,
        "aria-valuetext": "".concat(ariaValuetext === null ? labelStr : ariaValuetext)
    }, $51a43064f3c84c06$var$React__namespace.createElement("div", {
        style: barContainerClassName ? undefined : containerStyles,
        className: barContainerClassName
    }, $51a43064f3c84c06$var$React__namespace.createElement("div", {
        style: completedClassName ? undefined : fillerStyles,
        className: completedClassName
    }, labelAlignment !== "outside" && $51a43064f3c84c06$var$React__namespace.createElement("span", {
        style: labelClassName ? undefined : labelStyles,
        className: labelClassName
    }, labelStr))), labelAlignment === "outside" && $51a43064f3c84c06$var$React__namespace.createElement("span", {
        style: labelClassName ? undefined : labelStyles,
        className: labelClassName
    }, labelStr), $51a43064f3c84c06$var$React__namespace.createElement("style", null, "\n          @keyframes indeterminate {\n            0% {\n              width: 30%;\n              transform: translateX(-50%);\n            }\n            50% {\n              width: 30%;\n              transform: translateX(250%);\n            }\n            100% {\n              width: 30%;\n              transform: translateX(-50%);\n            }\n          }\n        "));
}
$51a43064f3c84c06$exports.default = $51a43064f3c84c06$var$ProgressBar;


const $c7d83fe1199d44e2$var$PROGRESS_TIME = 120 //SECONDS
;
const $c7d83fe1199d44e2$var$FORM_ID = "queryForm";
const $c7d83fe1199d44e2$var$StepForm = ({ toggleForm: toggleForm })=>{
    // const router = useRouter()
    const [activeStep, setActiveStep] = (0, $eeH7J.useState)(0);
    const [errorMessage, setErrorMessage] = (0, $eeH7J.useState)("");
    const [formData, setFormData] = (0, $eeH7J.useState)({
        name: "",
        business_type: "",
        customer_type: "",
        products: "",
        purpose: "",
        services: ""
    });
    const [isFormSubmitted, setIsFormSubmitted] = (0, $eeH7J.useState)(false);
    const [progress, setProgress] = (0, $eeH7J.useState)(0);
    const handleInputChange = (e, name)=>{
        setFormData((formData)=>{
            return {
                ...formData,
                [name]: e.target.value
            };
        });
    };
    const nextPrev = (n)=>{
        if (n === 1 && activeStep < 2) {
            const isValidated = validateFields(activeStep);
            if (!isValidated) return false;
        }
        if (activeStep + n > 2) {
            setIsFormSubmitted(true);
            startProgress();
            submitForm();
        }
        setActiveStep(activeStep + n);
    };
    const validateFields = (step)=>{
        if (step == 0) {
            if (formData.name === "" || formData.business_type === "") {
                setErrorMessage("Please answer all queries.");
                return false;
            } else {
                setErrorMessage("");
                return true;
            }
        }
        if (step == 1) {
            if (formData.purpose === "" || formData.customer_type === "") {
                setErrorMessage("Please answer all queries.");
                return false;
            } else {
                setErrorMessage("");
                return true;
            }
        }
    };
    const startProgress = ()=>{
        let intervalHandle = window.setInterval(()=>{
            setProgress((progress)=>{
                if (progress === $c7d83fe1199d44e2$var$PROGRESS_TIME) window.clearInterval(intervalHandle);
                return Math.min(progress + 1, $c7d83fe1199d44e2$var$PROGRESS_TIME);
            });
        }, 1000);
    };
    const submitForm = async ()=>{
        const websiteInfo = {
            name: formData.name.trim(),
            organization: formData.business_type === "organization",
            objective: formData.purpose?.trim(),
            target: formData.customer_type?.trim(),
            services: formData.services?.trim(),
            products: formData.products?.trim()
        };
        const websiteCopy = await (0, $0949f4e5bf0067a7$export$2e2bcd8739ae039)("/api/generate-copy", {
            body: websiteInfo
        });
        (0, $3491dbe16d2700e4$export$adaa4cf7ef1b65be)("websiteInfo", websiteInfo);
        (0, $3491dbe16d2700e4$export$adaa4cf7ef1b65be)("websiteCopy", websiteCopy);
    // router.push("/editor")
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("form", {
        id: $c7d83fe1199d44e2$var$FORM_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("i", {
        className: "fa-solid fa-xmark text-[24px] font-bold closeForm",
        onClick: toggleForm
    }), !isFormSubmitted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)("step", {
            active: activeStep == 0
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)("step", {
            active: activeStep == 1
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: (0, $8247dc0908a27868$export$2e2bcd8739ae039)("step", {
            active: activeStep == 2
        })
    })), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "error-message"
    }, errorMessage), activeStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "What is the name of your website?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        placeholder: "Type here...",
        name: "name",
        type: "text",
        value: formData?.name,
        onChange: (e)=>handleInputChange(e, "name")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Are you operating as an individual or an organization?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        id: "individual",
        value: "individual",
        type: "radio",
        checked: formData?.business_type === "individual",
        name: "business_type",
        onChange: (e)=>handleInputChange(e, "business_type")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "individual"
    }, "Individual")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        id: "organization",
        value: "organization",
        type: "radio",
        checked: formData?.business_type === "organization",
        name: "business_type",
        onChange: (e)=>handleInputChange(e, "business_type")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "organization"
    }, "Organization")))), activeStep === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "What is the main purpose or objective of your website?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("textarea", {
        placeholder: "Type here...",
        name: "purpose",
        value: formData?.purpose,
        onChange: (e)=>handleInputChange(e, "purpose"),
        rows: 5
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Who is your target audience? Please describe your ideal customer or visitor?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("textarea", {
        placeholder: "Type here...",
        name: "customer_type",
        value: formData?.customer_type,
        onChange: (e)=>handleInputChange(e, "customer_type"),
        rows: 5
    })))), activeStep === 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Do you offer any services? If yes, please describe them."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("textarea", {
        placeholder: "Type here...",
        name: "services",
        value: formData?.services,
        onChange: (e)=>handleInputChange(e, "services"),
        rows: 5
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Do you offer any products? If yes, please describe them"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("textarea", {
        placeholder: "Type here...",
        name: "products",
        value: formData?.products,
        onChange: (e)=>handleInputChange(e, "products"),
        rows: 5
    })))), !isFormSubmitted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "flex-end"
        }
    }, activeStep > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        className: "btn-info",
        type: "button",
        id: "prevBtn",
        onClick: ()=>nextPrev(-1)
    }, "Previous"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        className: "btn-info",
        type: "button",
        id: "nextBtn",
        onClick: ()=>nextPrev(1)
    }, activeStep === 2 ? "Submit" : "Next"))), isFormSubmitted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "info-message"
    }, "Generating your website..."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51a43064f3c84c06$exports))), {
        completed: Math.round(progress / $c7d83fe1199d44e2$var$PROGRESS_TIME * 100)
    }))));
};
var $c7d83fe1199d44e2$export$2e2bcd8739ae039 = $c7d83fe1199d44e2$var$StepForm;










const $26a7f59851190964$export$74ba1212fd768fa5 = ()=>{
    let [isFormVisible, setIsFormVisible] = (0, $eeH7J.useState)(false);
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    // Get the current year dynamically
    const currentYear = new Date().getFullYear();
    (0, $eeH7J.useEffect)(()=>{
        navigate("/choose-template");
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "is-boxed has-animations is-loaded",
        style: {
            height: "100%"
        }
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `body-wrap boxed-container ${isFormVisible ? "wrapper-blur" : ""}`
    }, /*#__PURE__*/ $eeH7J.createElement("header", {
        className: "site-header"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "site-header-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "brand header-brand"
    }, /*#__PURE__*/ $eeH7J.createElement("h1", {
        className: "m-0"
    }, /*#__PURE__*/ $eeH7J.createElement("a", {
        href: "#"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "header-logo-image asset-light",
        src: (parcelRequire("k11CC")),
        width: 200,
        height: 30,
        alt: "Logo"
    }))))))), /*#__PURE__*/ $eeH7J.createElement("main", null, /*#__PURE__*/ $eeH7J.createElement("section", {
        className: "hero"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "hero-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "hero-copy"
    }, /*#__PURE__*/ $eeH7J.createElement("h1", {
        className: "hero-title mt-0"
    }, "Build and Launch Your Free Website in Just 15 Minutes"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "hero-paragraph"
    }, "With our free website building platform, you can create a stunning website Rocket fast, complete with high-quality content generated automatically by our powerful ChatGPT integration."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "hero-cta"
    }, /*#__PURE__*/ $eeH7J.createElement("a", {
        className: "button button-primary",
        onClick: ()=>setIsFormVisible(!isFormVisible)
    }, "Build My Free Website Now!"), /*#__PURE__*/ $eeH7J.createElement("a", {
        className: "button button-primary",
        href: "/choose-template"
    }, "Choose Template"))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "hero-media"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "header-illustration"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "header-illustration-image asset-light",
        src: (parcelRequire("3uxUg")),
        width: 1440,
        height: 324,
        alt: "Header illustration"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "hero-media-illustration"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "hero-media-illustration-image asset-light",
        src: (parcelRequire("eFNK8")),
        width: 733,
        height: 749,
        alt: "Hero media illustration"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "hero-media-container"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "hero-media-image asset-light",
        src: (parcelRequire("fvuGF")),
        width: 1,
        height: 1,
        alt: "Hero media"
    }), /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "hero-media-image asset-dark",
        src: (parcelRequire("1xhds")),
        width: 1,
        height: 1,
        alt: "Hero media"
    })))))), /*#__PURE__*/ $eeH7J.createElement("section", {
        className: "features section"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "features-inner section-inner has-bottom-divider"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "features-header text-center"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "container-sm"
    }, /*#__PURE__*/ $eeH7J.createElement("h2", {
        className: "section-title mt-0"
    }, "Simple 2-Step Process"), /*#__PURE__*/ $eeH7J.createElement("ul", null, /*#__PURE__*/ $eeH7J.createElement("li", {
        className: "step-list"
    }, /*#__PURE__*/ $eeH7J.createElement("p", null, "Fill in the 5 question Wizard and click on \u201CGenerate Website\u201D")), /*#__PURE__*/ $eeH7J.createElement("li", {
        className: "step-list"
    }, /*#__PURE__*/ $eeH7J.createElement("p", null, "Customize the website template to your needs"))))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "features-header section-inner second-feature-header text-center"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "container-sm"
    }, /*#__PURE__*/ $eeH7J.createElement("h2", {
        className: "section-title mt-0"
    }, "The Easiest Way to Build a Website for Free"))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "features-wrap"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "feature-title mt-0"
    }, "Easy to Use"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0"
    }, "It's no rocket science! Create your website quickly with our user-friendly editor & ChatGPT integration that generates content fast.", " ")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "feature-title mt-0"
    }, "Rocket Fast"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0"
    }, "Create your website in no time - our platform promises fast loading speed and a hassle-free website building process.")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "feature-title mt-0"
    }, "Unique Automated Content"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0"
    }, "Say goodbye to generic website content. Our platform creates unique content every time, ensuring that your site stands out!")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "feature-title mt-0"
    }, "SEO Optimized"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0"
    }, "Get discovered easily on search engines! Our platform creates websites that are optimized for SEO.")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "feature-title mt-0"
    }, "Customizable Templates"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0"
    }, "Choose from a wide range of customizable templates to create a website that truly reflects your brand and personality.")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "feature-title mt-0"
    }, "Mobile-Optimized Design"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0"
    }, "Our templates are optimized for mobile devices, ensuring that your website looks great on any device, anywhere, anytime.")))))))), /*#__PURE__*/ $eeH7J.createElement("section", {
        className: "cta section"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "container-sm"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "cta-inner section-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "cta-header text-center"
    }, /*#__PURE__*/ $eeH7J.createElement("h2", {
        className: "section-title mt-0"
    }, "Ready to Start?"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "section-paragraph"
    }, "Don't wait any longer to create your online presence. Start building your website for free now!"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "cta-cta"
    }, /*#__PURE__*/ $eeH7J.createElement("a", {
        className: "button button-primary",
        onClick: ()=>setIsFormVisible(!isFormVisible)
    }, "Start Building My Free Website Now!"))))))), /*#__PURE__*/ $eeH7J.createElement("footer", {
        className: "site-footer has-top-divider"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "site-footer-inner"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "brand footer-brand"
    }, /*#__PURE__*/ $eeH7J.createElement("a", {
        href: "#"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "asset-light",
        src: (parcelRequire("2QlwY")),
        width: 200,
        height: 30,
        alt: "RocketPages"
    }))), /*#__PURE__*/ $eeH7J.createElement("ul", {
        className: "footer-social-links list-reset"
    }, /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://www.facebook.com/RocketPagesIO",
        target: "_blank",
        className: "mx-2"
    }, /*#__PURE__*/ $eeH7J.createElement("i", {
        className: "fa-brands fa-square-facebook text-[20px] text-[white]"
    }))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://twitter.com/RocketPagesIO",
        target: "_blank",
        className: "mx-2"
    }, /*#__PURE__*/ $eeH7J.createElement("i", {
        className: "fa-brands fa-twitter text-[20px] text-[white]"
    }))), /*#__PURE__*/ $eeH7J.createElement("li", null, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://www.linkedin.com/company/rocketpages",
        target: "_blank",
        className: "mx-2"
    }, /*#__PURE__*/ $eeH7J.createElement("i", {
        className: "fa-brands fa-linkedin text-[20px] text-[white]"
    })))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "footer-copyright"
    }, "\xa9 ", currentYear, " RocketPages. All Rights Reserved.")))))), isFormVisible && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "stepform-wrapper"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $c7d83fe1199d44e2$export$2e2bcd8739ae039), {
        toggleForm: ()=>{
            setIsFormVisible(!isFormVisible);
        }
    })), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");


var $48be597dabffb880$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($48be597dabffb880$exports, "__esModule", {
    value: true
});
$48be597dabffb880$exports.default = void 0;

var $48be597dabffb880$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $48be597dabffb880$var$_default = $48be597dabffb880$exports.default = (0, $48be597dabffb880$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


var $eec45c1bd37e4a90$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($eec45c1bd37e4a90$exports, "__esModule", {
    value: true
});
$eec45c1bd37e4a90$exports.default = void 0;

var $eec45c1bd37e4a90$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $eec45c1bd37e4a90$var$_default = $eec45c1bd37e4a90$exports.default = (0, $eec45c1bd37e4a90$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');


var $3aeb16233e51b8e7$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($3aeb16233e51b8e7$exports, "__esModule", {
    value: true
});
$3aeb16233e51b8e7$exports.default = void 0;

var $3aeb16233e51b8e7$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $3aeb16233e51b8e7$var$_default = $3aeb16233e51b8e7$exports.default = (0, $3aeb16233e51b8e7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M3 10h11v2H3zm0-2h11V6H3zm0 8h7v-2H3zm15.01-3.13.71-.71c.39-.39 1.02-.39 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71zm-.71.71-5.3 5.3V21h2.12l5.3-5.3z"
}), 'EditNoteOutlined');


var $75fad4645059238f$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($75fad4645059238f$exports, "__esModule", {
    value: true
});
$75fad4645059238f$exports.default = void 0;

var $75fad4645059238f$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $75fad4645059238f$var$_default = $75fad4645059238f$exports.default = (0, $75fad4645059238f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "m21.9 21.9-8.49-8.49-9.82-9.82L2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31zM5 18l3.5-4.5 2.5 3.01L12.17 15l3 3zm16 .17L5.83 3H19c1.1 0 2 .9 2 2z"
}), 'ImageNotSupported');









var $1V8au = parcelRequire("1V8au");

var $eeH7J = parcelRequire("eeH7J");


var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5df189dad2b9134b$var$extendStatics = function(d, b) {
    $5df189dad2b9134b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5df189dad2b9134b$var$extendStatics(d, b);
};
function $5df189dad2b9134b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5df189dad2b9134b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5df189dad2b9134b$export$18ce0697a983be9b = function() {
    $5df189dad2b9134b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5df189dad2b9134b$export$18ce0697a983be9b.apply(this, arguments);
};
function $5df189dad2b9134b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5df189dad2b9134b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5df189dad2b9134b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5df189dad2b9134b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5df189dad2b9134b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5df189dad2b9134b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5df189dad2b9134b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5df189dad2b9134b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5df189dad2b9134b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5df189dad2b9134b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5df189dad2b9134b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5df189dad2b9134b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5df189dad2b9134b$export$45d3717a4c69092e(o, m, p);
}
function $5df189dad2b9134b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5df189dad2b9134b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5df189dad2b9134b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5df189dad2b9134b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5df189dad2b9134b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5df189dad2b9134b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5df189dad2b9134b$export$10c90e4f7922046c(v) {
    return this instanceof $5df189dad2b9134b$export$10c90e4f7922046c ? (this.v = v, this) : new $5df189dad2b9134b$export$10c90e4f7922046c(v);
}
function $5df189dad2b9134b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5df189dad2b9134b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5df189dad2b9134b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5df189dad2b9134b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5df189dad2b9134b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5df189dad2b9134b$export$19a8beecd37a4c45 === "function" ? $5df189dad2b9134b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5df189dad2b9134b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5df189dad2b9134b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5df189dad2b9134b$var$ownKeys = function(o) {
    $5df189dad2b9134b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5df189dad2b9134b$var$ownKeys(o);
};
function $5df189dad2b9134b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5df189dad2b9134b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5df189dad2b9134b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5df189dad2b9134b$var$__setModuleDefault(result, mod);
    return result;
}
function $5df189dad2b9134b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5df189dad2b9134b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5df189dad2b9134b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5df189dad2b9134b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5df189dad2b9134b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5df189dad2b9134b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5df189dad2b9134b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5df189dad2b9134b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5df189dad2b9134b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5df189dad2b9134b$export$2e2bcd8739ae039 = {
    __extends: $5df189dad2b9134b$export$a8ba968b8961cb8a,
    __assign: $5df189dad2b9134b$export$18ce0697a983be9b,
    __rest: $5df189dad2b9134b$export$3c9a16f847548506,
    __decorate: $5df189dad2b9134b$export$29e00dfd3077644b,
    __param: $5df189dad2b9134b$export$d5ad3fd78186038f,
    __esDecorate: $5df189dad2b9134b$export$3a84e1ae4e97e9b0,
    __runInitializers: $5df189dad2b9134b$export$d831c04e792af3d,
    __propKey: $5df189dad2b9134b$export$6a2a36740a146cb8,
    __setFunctionName: $5df189dad2b9134b$export$d1a06452d3489bc7,
    __metadata: $5df189dad2b9134b$export$f1db080c865becb9,
    __awaiter: $5df189dad2b9134b$export$1050f835b63b671e,
    __generator: $5df189dad2b9134b$export$67ebef60e6f28a6,
    __createBinding: $5df189dad2b9134b$export$45d3717a4c69092e,
    __exportStar: $5df189dad2b9134b$export$f33643c0debef087,
    __values: $5df189dad2b9134b$export$19a8beecd37a4c45,
    __read: $5df189dad2b9134b$export$8d051b38c9118094,
    __spread: $5df189dad2b9134b$export$afc72e2116322959,
    __spreadArrays: $5df189dad2b9134b$export$6388937ca91ccae8,
    __spreadArray: $5df189dad2b9134b$export$1216008129fb82ed,
    __await: $5df189dad2b9134b$export$10c90e4f7922046c,
    __asyncGenerator: $5df189dad2b9134b$export$e427f37a30a4de9b,
    __asyncDelegator: $5df189dad2b9134b$export$bbd80228419bb833,
    __asyncValues: $5df189dad2b9134b$export$e3b29a3d6162315f,
    __makeTemplateObject: $5df189dad2b9134b$export$4fb47efe1390b86f,
    __importStar: $5df189dad2b9134b$export$c21735bcef00d192,
    __importDefault: $5df189dad2b9134b$export$da59b14a69baef04,
    __classPrivateFieldGet: $5df189dad2b9134b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5df189dad2b9134b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5df189dad2b9134b$export$81fdc39f203e4e04,
    __addDisposableResource: $5df189dad2b9134b$export$88ac25d8e944e405,
    __disposeResources: $5df189dad2b9134b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5df189dad2b9134b$export$889dfb5d17574b0b
};


const $8612adef92c21096$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function $8612adef92c21096$export$8cc09085015f0dc7(file, path, h) {
    const f = $8612adef92c21096$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') $8612adef92c21096$var$setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $8612adef92c21096$var$setObjProp(f, 'relativePath', p);
    return f;
}
function $8612adef92c21096$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = $8612adef92c21096$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $8612adef92c21096$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}


const $8744516636edfdb0$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $8744516636edfdb0$export$a36e16046ae8f1bb(evt) {
    return (0, $5df189dad2b9134b$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        if ($8744516636edfdb0$var$isObject(evt) && $8744516636edfdb0$var$isDataTransfer(evt.dataTransfer)) return $8744516636edfdb0$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($8744516636edfdb0$var$isChangeEvt(evt)) return $8744516636edfdb0$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return $8744516636edfdb0$var$getFsHandleFiles(evt);
        return [];
    });
}
function $8744516636edfdb0$var$isDataTransfer(value) {
    return $8744516636edfdb0$var$isObject(value);
}
function $8744516636edfdb0$var$isChangeEvt(value) {
    return $8744516636edfdb0$var$isObject(value) && $8744516636edfdb0$var$isObject(value.target);
}
function $8744516636edfdb0$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $8744516636edfdb0$var$getInputFiles(evt) {
    return $8744516636edfdb0$var$fromList(evt.target.files).map((file)=>(0, $8612adef92c21096$export$8cc09085015f0dc7)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $8744516636edfdb0$var$getFsHandleFiles(handles) {
    return (0, $5df189dad2b9134b$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $8612adef92c21096$export$8cc09085015f0dc7)(file));
    });
}
function $8744516636edfdb0$var$getDataTransferFiles(dt, type) {
    return (0, $5df189dad2b9134b$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $8744516636edfdb0$var$fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map($8744516636edfdb0$var$toFilePromises));
            return $8744516636edfdb0$var$noIgnoredFiles($8744516636edfdb0$var$flatten(files));
        }
        return $8744516636edfdb0$var$noIgnoredFiles($8744516636edfdb0$var$fromList(dt.files).map((file)=>(0, $8612adef92c21096$export$8cc09085015f0dc7)(file)));
    });
}
function $8744516636edfdb0$var$noIgnoredFiles(files) {
    return files.filter((file)=>$8744516636edfdb0$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $8744516636edfdb0$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $8744516636edfdb0$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $8744516636edfdb0$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $8744516636edfdb0$var$fromDirEntry(entry);
    return $8744516636edfdb0$var$fromDataTransferItem(item, entry);
}
function $8744516636edfdb0$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $8744516636edfdb0$var$flatten(files) : [
                files
            ]
        ], []);
}
function $8744516636edfdb0$var$fromDataTransferItem(item, entry) {
    return (0, $5df189dad2b9134b$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, $8612adef92c21096$export$8cc09085015f0dc7)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, $8612adef92c21096$export$8cc09085015f0dc7)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $8744516636edfdb0$var$fromEntry(entry) {
    return (0, $5df189dad2b9134b$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $8744516636edfdb0$var$fromDirEntry(entry) : $8744516636edfdb0$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $8744516636edfdb0$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $5df189dad2b9134b$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($8744516636edfdb0$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $8744516636edfdb0$var$fromFileEntry(entry) {
    return (0, $5df189dad2b9134b$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $8612adef92c21096$export$8cc09085015f0dc7)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}




var $7c22efe499fb7e9c$export$1e511d4a378977f5;
var $7c22efe499fb7e9c$export$2e2bcd8739ae039;
"use strict";
$7c22efe499fb7e9c$export$1e511d4a378977f5 = true;
$7c22efe499fb7e9c$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $165b93986d353951$var$_toConsumableArray(arr) {
    return $165b93986d353951$var$_arrayWithoutHoles(arr) || $165b93986d353951$var$_iterableToArray(arr) || $165b93986d353951$var$_unsupportedIterableToArray(arr) || $165b93986d353951$var$_nonIterableSpread();
}
function $165b93986d353951$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $165b93986d353951$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $165b93986d353951$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $165b93986d353951$var$_arrayLikeToArray(arr);
}
function $165b93986d353951$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $165b93986d353951$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $165b93986d353951$var$ownKeys(Object(source), !0).forEach(function(key) {
            $165b93986d353951$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $165b93986d353951$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $165b93986d353951$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $165b93986d353951$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $165b93986d353951$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $165b93986d353951$var$_typeof(obj);
}
function $165b93986d353951$var$_slicedToArray(arr, i) {
    return $165b93986d353951$var$_arrayWithHoles(arr) || $165b93986d353951$var$_iterableToArrayLimit(arr, i) || $165b93986d353951$var$_unsupportedIterableToArray(arr, i) || $165b93986d353951$var$_nonIterableRest();
}
function $165b93986d353951$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $165b93986d353951$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $165b93986d353951$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $165b93986d353951$var$_arrayLikeToArray(o, minLen);
}
function $165b93986d353951$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $165b93986d353951$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $165b93986d353951$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $165b93986d353951$var$accepts = typeof (0, $7c22efe499fb7e9c$export$2e2bcd8739ae039) === "function" ? (0, $7c22efe499fb7e9c$export$2e2bcd8739ae039) : (0, $7c22efe499fb7e9c$export$2e2bcd8739ae039).default; // Error codes
var $165b93986d353951$export$d2c35cc369247232 = "file-invalid-type";
var $165b93986d353951$export$d7bd1185abe1e87c = "file-too-large";
var $165b93986d353951$export$8bd5ec6ed990dc9 = "file-too-small";
var $165b93986d353951$export$3271ef1d2dd155f9 = "too-many-files";
var $165b93986d353951$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $165b93986d353951$export$d2c35cc369247232,
    FileTooLarge: $165b93986d353951$export$d7bd1185abe1e87c,
    FileTooSmall: $165b93986d353951$export$8bd5ec6ed990dc9,
    TooManyFiles: $165b93986d353951$export$3271ef1d2dd155f9
};
var $165b93986d353951$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $165b93986d353951$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $165b93986d353951$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $165b93986d353951$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $165b93986d353951$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $165b93986d353951$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $165b93986d353951$export$1e1e1b6120329fe = {
    code: $165b93986d353951$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $165b93986d353951$export$2a44042abbda425f(file) {
    return file.type === "" && typeof file.getAsFile === "function";
}
function $165b93986d353951$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $165b93986d353951$var$accepts(file, accept) || $165b93986d353951$export$2a44042abbda425f(file);
    return [
        isAcceptable,
        isAcceptable ? null : $165b93986d353951$export$bc0bbda045f09b5a(accept)
    ];
}
function $165b93986d353951$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($165b93986d353951$var$isDefined(file.size)) {
        if ($165b93986d353951$var$isDefined(minSize) && $165b93986d353951$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $165b93986d353951$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $165b93986d353951$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($165b93986d353951$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $165b93986d353951$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($165b93986d353951$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $165b93986d353951$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $165b93986d353951$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $165b93986d353951$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $165b93986d353951$export$b511db3632effe58(file, accept), _fileAccepted2 = $165b93986d353951$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $165b93986d353951$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $165b93986d353951$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $165b93986d353951$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $165b93986d353951$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $165b93986d353951$export$f9006bf02b243736(item) {
    return $165b93986d353951$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $165b93986d353951$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $165b93986d353951$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $165b93986d353951$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $165b93986d353951$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $165b93986d353951$var$isIe(userAgent) || $165b93986d353951$var$isEdge(userAgent);
}
function $165b93986d353951$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$165b93986d353951$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $165b93986d353951$export$8d6d6472146de265(event);
        });
    };
}
function $165b93986d353951$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $165b93986d353951$export$8ce4bd13c494743e(accept) {
    if ($165b93986d353951$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $165b93986d353951$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$165b93986d353951$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($165b93986d353951$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $165b93986d353951$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $165b93986d353951$var$_objectSpread($165b93986d353951$var$_objectSpread({}, agg), {}, $165b93986d353951$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $165b93986d353951$export$1278288bcefb97b9(accept) {
    if ($165b93986d353951$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $165b93986d353951$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($165b93986d353951$var$_toConsumableArray(a), [
            mimeType
        ], $165b93986d353951$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $165b93986d353951$export$69c8ec3250e1cfbf(v) || $165b93986d353951$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $165b93986d353951$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $165b93986d353951$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $165b93986d353951$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $165b93986d353951$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 


var $902654ddcf2304ad$var$_excluded = [
    "children"
], $902654ddcf2304ad$var$_excluded2 = [
    "open"
], $902654ddcf2304ad$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $902654ddcf2304ad$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $902654ddcf2304ad$var$_toConsumableArray(arr) {
    return $902654ddcf2304ad$var$_arrayWithoutHoles(arr) || $902654ddcf2304ad$var$_iterableToArray(arr) || $902654ddcf2304ad$var$_unsupportedIterableToArray(arr) || $902654ddcf2304ad$var$_nonIterableSpread();
}
function $902654ddcf2304ad$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $902654ddcf2304ad$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $902654ddcf2304ad$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $902654ddcf2304ad$var$_arrayLikeToArray(arr);
}
function $902654ddcf2304ad$var$_slicedToArray(arr, i) {
    return $902654ddcf2304ad$var$_arrayWithHoles(arr) || $902654ddcf2304ad$var$_iterableToArrayLimit(arr, i) || $902654ddcf2304ad$var$_unsupportedIterableToArray(arr, i) || $902654ddcf2304ad$var$_nonIterableRest();
}
function $902654ddcf2304ad$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $902654ddcf2304ad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $902654ddcf2304ad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $902654ddcf2304ad$var$_arrayLikeToArray(o, minLen);
}
function $902654ddcf2304ad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $902654ddcf2304ad$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $902654ddcf2304ad$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $902654ddcf2304ad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $902654ddcf2304ad$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $902654ddcf2304ad$var$ownKeys(Object(source), !0).forEach(function(key) {
            $902654ddcf2304ad$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $902654ddcf2304ad$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $902654ddcf2304ad$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $902654ddcf2304ad$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $902654ddcf2304ad$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $902654ddcf2304ad$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $902654ddcf2304ad$var$Dropzone = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $902654ddcf2304ad$var$_objectWithoutProperties(_ref, $902654ddcf2304ad$var$_excluded);
    var _useDropzone = $902654ddcf2304ad$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $902654ddcf2304ad$var$_objectWithoutProperties(_useDropzone, $902654ddcf2304ad$var$_excluded2);
    (0, $eeH7J.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $eeH7J.Fragment), null, children($902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$902654ddcf2304ad$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $902654ddcf2304ad$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $8744516636edfdb0$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$902654ddcf2304ad$var$Dropzone.defaultProps = $902654ddcf2304ad$var$defaultProps;
$902654ddcf2304ad$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
};
var $902654ddcf2304ad$export$2e2bcd8739ae039 = $902654ddcf2304ad$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {boolean} isDragGlobal Files are being dragged anywhere on the document
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $902654ddcf2304ad$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    isDragGlobal: false,
    acceptedFiles: [],
    fileRejections: []
};
function $902654ddcf2304ad$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, $902654ddcf2304ad$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $eeH7J.useMemo)(function() {
        return (0, $165b93986d353951$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $eeH7J.useMemo)(function() {
        return (0, $165b93986d353951$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $eeH7J.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $902654ddcf2304ad$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $eeH7J.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $902654ddcf2304ad$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $eeH7J.useRef)(null);
    var inputRef = (0, $eeH7J.useRef)(null);
    var _useReducer = (0, $eeH7J.useReducer)($902654ddcf2304ad$var$reducer, $902654ddcf2304ad$var$initialState), _useReducer2 = $902654ddcf2304ad$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $eeH7J.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $165b93986d353951$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $eeH7J.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $eeH7J.useRef)([]);
    var globalDragTargetsRef = (0, $eeH7J.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $eeH7J.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $165b93986d353951$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $165b93986d353951$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Track global drag state for document-level drag events
    (0, $eeH7J.useEffect)(function() {
        var onDocumentDragEnter = function onDocumentDragEnter(event) {
            globalDragTargetsRef.current = [].concat($902654ddcf2304ad$var$_toConsumableArray(globalDragTargetsRef.current), [
                event.target
            ]);
            if ((0, $165b93986d353951$export$52f1fc875a1e5986)(event)) dispatch({
                isDragGlobal: true,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragLeave = function onDocumentDragLeave(event) {
            // Only deactivate once we've left all children
            globalDragTargetsRef.current = globalDragTargetsRef.current.filter(function(el) {
                return el !== event.target && el !== null;
            });
            if (globalDragTargetsRef.current.length > 0) return;
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragEnd = function onDocumentDragEnd() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDropGlobal = function onDocumentDropGlobal() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        document.addEventListener("dragenter", onDocumentDragEnter, false);
        document.addEventListener("dragleave", onDocumentDragLeave, false);
        document.addEventListener("dragend", onDocumentDragEnd, false);
        document.addEventListener("drop", onDocumentDropGlobal, false);
        return function() {
            document.removeEventListener("dragenter", onDocumentDragEnter);
            document.removeEventListener("dragleave", onDocumentDragLeave);
            document.removeEventListener("dragend", onDocumentDragEnd);
            document.removeEventListener("drop", onDocumentDropGlobal);
        };
    }, [
        rootRef
    ]); // Auto focus the root when autoFocus is true
    (0, $eeH7J.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $eeH7J.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($902654ddcf2304ad$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $165b93986d353951$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $165b93986d353951$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $165b93986d353951$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $165b93986d353951$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $165b93986d353951$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $eeH7J.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $165b93986d353951$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $902654ddcf2304ad$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $165b93986d353951$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $902654ddcf2304ad$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $165b93986d353951$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $165b93986d353951$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $165b93986d353951$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $eeH7J.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $165b93986d353951$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $165b93986d353951$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $eeH7J.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $eeH7J.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $eeH7J.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $eeH7J.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $165b93986d353951$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $eeH7J.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $902654ddcf2304ad$var$_objectWithoutProperties(_ref2, $902654ddcf2304ad$var$_excluded3);
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $eeH7J.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $eeH7J.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $902654ddcf2304ad$var$_objectWithoutProperties(_ref3, $902654ddcf2304ad$var$_excluded4);
            var inputProps = $902654ddcf2304ad$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $165b93986d353951$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $902654ddcf2304ad$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, $902654ddcf2304ad$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "setDragGlobal":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isDragGlobal: action.isDragGlobal
            });
        case "reset":
            return $902654ddcf2304ad$var$_objectSpread({}, $902654ddcf2304ad$var$initialState);
        default:
            return state;
    }
}
function $902654ddcf2304ad$var$noop() {}


var $1e3f3a9d43e19420$exports = {};

(()=>{
    var e = {
        296: (e, t, r)=>{
            var o = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, c = /^0o[0-7]+$/i, u = parseInt, s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, l = "object" == typeof self && self && self.Object === Object && self, a = s || l || Function("return this")(), f = Object.prototype.toString, p = Math.max, y = Math.min, b = function() {
                return a.Date.now();
            };
            function d(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function h(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == f.call(e);
                }(e)) return NaN;
                if (d(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = d(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var r = i.test(e);
                return r || c.test(e) ? u(e.slice(2), r ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var o, n, i, c, u, s, l = 0, a = !1, f = !1, v = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function m(t) {
                    var r = o, i = n;
                    return o = n = void 0, l = t, c = e.apply(i, r);
                }
                function O(e) {
                    var r = e - s;
                    return void 0 === s || r >= t || r < 0 || f && e - l >= i;
                }
                function w() {
                    var e = b();
                    if (O(e)) return g(e);
                    u = setTimeout(w, function(e) {
                        var r = t - (e - s);
                        return f ? y(r, i - (e - l)) : r;
                    }(e));
                }
                function g(e) {
                    return u = void 0, v && o ? m(e) : (o = n = void 0, c);
                }
                function P() {
                    var e = b(), r = O(e);
                    if (o = arguments, n = this, s = e, r) {
                        if (void 0 === u) return function(e) {
                            return l = e, u = setTimeout(w, t), a ? m(e) : c;
                        }(s);
                        if (f) return u = setTimeout(w, t), m(s);
                    }
                    return void 0 === u && (u = setTimeout(w, t)), c;
                }
                return t = h(t) || 0, d(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function() {
                    void 0 !== u && clearTimeout(u), l = 0, o = s = n = u = void 0;
                }, P.flush = function() {
                    return void 0 === u ? c : g(b());
                }, P;
            };
        },
        96: (e, t, r)=>{
            var o = "Expected a function", n = NaN, i = "[object Symbol]", c = /^\s+|\s+$/g, u = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, a = parseInt, f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, p = "object" == typeof self && self && self.Object === Object && self, y = f || p || Function("return this")(), b = Object.prototype.toString, d = Math.max, h = Math.min, v = function() {
                return y.Date.now();
            };
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function O(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && b.call(e) == i;
                }(e)) return n;
                if (m(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(c, "");
                var r = s.test(e);
                return r || l.test(e) ? a(e.slice(2), r ? 2 : 8) : u.test(e) ? n : +e;
            }
            e.exports = function(e, t, r) {
                var n = !0, i = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
                    var n, i, c, u, s, l, a = 0, f = !1, p = !1, y = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function b(t) {
                        var r = n, o = i;
                        return n = i = void 0, a = t, u = e.apply(o, r);
                    }
                    function w(e) {
                        var r = e - l;
                        return void 0 === l || r >= t || r < 0 || p && e - a >= c;
                    }
                    function g() {
                        var e = v();
                        if (w(e)) return P(e);
                        s = setTimeout(g, function(e) {
                            var r = t - (e - l);
                            return p ? h(r, c - (e - a)) : r;
                        }(e));
                    }
                    function P(e) {
                        return s = void 0, y && n ? b(e) : (n = i = void 0, u);
                    }
                    function j() {
                        var e = v(), r = w(e);
                        if (n = arguments, i = this, l = e, r) {
                            if (void 0 === s) return function(e) {
                                return a = e, s = setTimeout(g, t), f ? b(e) : u;
                            }(l);
                            if (p) return s = setTimeout(g, t), b(l);
                        }
                        return void 0 === s && (s = setTimeout(g, t)), u;
                    }
                    return t = O(t) || 0, m(r) && (f = !!r.leading, c = (p = "maxWait" in r) ? d(O(r.maxWait) || 0, t) : c, y = "trailing" in r ? !!r.trailing : y), j.cancel = function() {
                        void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
                    }, j.flush = function() {
                        return void 0 === s ? u : P(v());
                    }, j;
                }(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: i
                });
            };
        },
        703: (e, t, r)=>{
            "use strict";
            var o = r(414);
            function n() {}
            function i() {}
            i.resetWarningCache = n, e.exports = function() {
                function e(e, t, r, n, i, c) {
                    if (c !== o) {
                        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw u.name = "Invariant Violation", u;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                };
                return r.PropTypes = r, r;
            };
        },
        697: (e, t, r)=>{
            e.exports = r(703)();
        },
        414: (e)=>{
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, t = {};
    function r(o) {
        var n = t[o];
        if (void 0 !== n) return n.exports;
        var i = t[o] = {
            exports: {}
        };
        return e[o](i, i.exports, r), i.exports;
    }
    r.n = (e)=>{
        var t = e && e.__esModule ? ()=>e.default : ()=>e;
        return r.d(t, {
            a: t
        }), t;
    }, r.d = (e, t)=>{
        for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
        });
    }, r.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var o = {};
    (()=>{
        "use strict";
        r.r(o), r.d(o, {
            LazyLoadComponent: ()=>Y,
            LazyLoadImage: ()=>ne,
            trackWindowScroll: ()=>D
        });
        const e = (parcelRequire("eeH7J"));
        var t = r.n(e), n = r(697);
        function i() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        }
        function c(e) {
            return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, c(e);
        }
        function u(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function s(e, t, r) {
            return (t = a(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function l(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, a(o.key), o);
            }
        }
        function a(e) {
            var t = function(e, t) {
                if ("object" !== c(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== c(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === c(t) ? t : String(t);
        }
        function f(e, t) {
            return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, f(e, t);
        }
        function p(e) {
            return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, p(e);
        }
        var y = function(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, b = {}, d = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && f(e, t);
            }(h, e);
            var r, o, n, a, d = (n = h, a = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = p(n);
                if (a) {
                    var r = p(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === c(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function h(e) {
                var t;
                if (function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, h), (t = d.call(this, e)).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && i(), t.supportsObserver) {
                    var r = e.threshold;
                    t.observer = function(e) {
                        return b[e] = b[e] || new IntersectionObserver(y, {
                            rootMargin: e + "px"
                        }), b[e];
                    }(r);
                }
                return t;
            }
            return r = h, o = [
                {
                    key: "componentDidMount",
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), r = this.placeholder.style, o = parseInt(r.getPropertyValue("margin-left"), 10) || 0, n = parseInt(r.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: e.y + t.bottom + n,
                            left: e.x + t.left + o,
                            right: e.x + t.right + o,
                            top: e.y + t.top + n
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var e = this.props, t = e.scrollPosition, r = e.threshold, o = this.getPlaceholderBoundingBox(t), n = t.y + window.innerHeight, i = t.x, c = t.x + window.innerWidth, u = t.y;
                        return Boolean(u - r <= o.bottom && n + r >= o.top && i - r <= o.right && c + r >= o.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, r = this.props, o = r.className, n = r.height, i = r.placeholder, c = r.style, l = r.width;
                        if (i && "function" != typeof i.type) return t().cloneElement(i, {
                            ref: function(t) {
                                return e.placeholder = t;
                            }
                        });
                        var a = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? u(Object(r), !0).forEach(function(t) {
                                    s(e, t, r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function(t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                            }
                            return e;
                        }({
                            display: "inline-block"
                        }, c);
                        return void 0 !== l && (a.width = l), void 0 !== n && (a.height = n), t().createElement("span", {
                            className: o,
                            ref: function(t) {
                                return e.placeholder = t;
                            },
                            style: a
                        }, i);
                    }
                }
            ], o && l(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), h;
        }(t().Component);
        d.propTypes = {
            onVisible: n.PropTypes.func.isRequired,
            className: n.PropTypes.string,
            height: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ]),
            placeholder: n.PropTypes.element,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            scrollPosition: n.PropTypes.shape({
                x: n.PropTypes.number.isRequired,
                y: n.PropTypes.number.isRequired
            }),
            width: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ])
        }, d.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        const h = d;
        var v = r(296), m = r.n(v), O = r(96), w = r.n(O), g = function(e) {
            var t = getComputedStyle(e, null);
            return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
        };
        const P = function(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t instanceof HTMLElement;){
                if (/(scroll|auto)/.test(g(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
        function j(e) {
            return j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, j(e);
        }
        var T = [
            "delayMethod",
            "delayTime"
        ];
        function S() {
            return S = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, S.apply(this, arguments);
        }
        function E(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== j(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== j(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === j(n) ? n : String(n)), o);
            }
            var n;
        }
        function L(e, t) {
            return L = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, L(e, t);
        }
        function _(e, t) {
            if (t && ("object" === j(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return I(e);
        }
        function I(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function x(e) {
            return x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, x(e);
        }
        var R = function() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, k = function() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        const D = function(e) {
            var r = function(r) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && L(e, t);
                }(l, r);
                var o, n, c, u, s = (c = l, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, t = x(c);
                    if (u) {
                        var r = x(this).constructor;
                        e = Reflect.construct(t, arguments, r);
                    } else e = t.apply(this, arguments);
                    return _(this, e);
                });
                function l(e) {
                    var r;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, l), (r = s.call(this, e)).useIntersectionObserver = e.useIntersectionObserver && i(), r.useIntersectionObserver) return _(r);
                    var o = r.onChangeScroll.bind(I(r));
                    return "debounce" === e.delayMethod ? r.delayedScroll = m()(o, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = w()(o, e.delayTime)), r.state = {
                        scrollPosition: {
                            x: R(),
                            y: k()
                        }
                    }, r.baseComponentRef = t().createRef(), r;
                }
                return o = l, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || P(this.baseComponentRef.current) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = P(this.baseComponentRef.current), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: R(),
                                    y: k()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var r = this.props, o = (r.delayMethod, r.delayTime, function(e, t) {
                                if (null == e) return {};
                                var r, o, n = function(e, t) {
                                    if (null == e) return {};
                                    var r, o, n = {}, i = Object.keys(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                    return n;
                                }(e, t);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                                }
                                return n;
                            }(r, T)), n = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return t().createElement(e, S({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: n
                            }, o));
                        }
                    }
                ], E(o.prototype, n), Object.defineProperty(o, "prototype", {
                    writable: !1
                }), l;
            }(t().Component);
            return r.propTypes = {
                delayMethod: n.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: n.PropTypes.number,
                useIntersectionObserver: n.PropTypes.bool
            }, r.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, r;
        };
        function C(e) {
            return C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, C(e);
        }
        function B(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== C(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== C(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === C(n) ? n : String(n)), o);
            }
            var n;
        }
        function M(e, t) {
            return M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, M(e, t);
        }
        function N(e) {
            return N = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, N(e);
        }
        var V = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && M(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = N(n);
                if (i) {
                    var r = N(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === C(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), c.call(this, e);
            }
            return r = u, o = [
                {
                    key: "render",
                    value: function() {
                        return t().createElement(h, this.props);
                    }
                }
            ], B(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        const W = D(V);
        function z(e) {
            return z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, z(e);
        }
        function $(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== z(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== z(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === z(n) ? n : String(n)), o);
            }
            var n;
        }
        function U(e, t) {
            return U = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, U(e, t);
        }
        function F(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function q(e) {
            return q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, q(e);
        }
        var H = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && U(e, t);
            }(s, e);
            var r, o, n, c, u = (n = s, c = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = q(n);
                if (c) {
                    var r = q(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === z(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return F(e);
                }(this, e);
            });
            function s(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, s), t = u.call(this, e);
                var r = e.afterLoad, o = e.beforeLoad, n = e.scrollPosition, i = e.visibleByDefault;
                return t.state = {
                    visible: i
                }, i && (o(), r()), t.onVisible = t.onVisible.bind(F(t)), t.isScrollTracked = Boolean(n && Number.isFinite(n.x) && n.x >= 0 && Number.isFinite(n.y) && n.y >= 0), t;
            }
            return r = s, o = [
                {
                    key: "componentDidUpdate",
                    value: function(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var e = this.props, r = e.className, o = e.delayMethod, n = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.width;
                        return this.isScrollTracked || f && i() ? t().createElement(h, {
                            className: r,
                            height: c,
                            onVisible: this.onVisible,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            width: p
                        }) : t().createElement(W, {
                            className: r,
                            delayMethod: o,
                            delayTime: n,
                            height: c,
                            onVisible: this.onVisible,
                            placeholder: u,
                            style: l,
                            threshold: a,
                            width: p
                        });
                    }
                }
            ], $(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), s;
        }(t().Component);
        H.propTypes = {
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool
        }, H.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        const Y = H;
        function X(e) {
            return X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, X(e);
        }
        var A = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function G(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function J(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? G(Object(r), !0).forEach(function(t) {
                    K(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function K(e, t, r) {
            return (t = ee(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function Q() {
            return Q = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, Q.apply(this, arguments);
        }
        function Z(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ee(o.key), o);
            }
        }
        function ee(e) {
            var t = function(e, t) {
                if ("object" !== X(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== X(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === X(t) ? t : String(t);
        }
        function te(e, t) {
            return te = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, te(e, t);
        }
        function re(e) {
            return re = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, re(e);
        }
        var oe = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && te(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = re(n);
                if (i) {
                    var r = re(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === X(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                var t;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (t = c.call(this, e)).state = {
                    loaded: !1
                }, t;
            }
            return r = u, o = [
                {
                    key: "onImageLoad",
                    value: function() {
                        var e = this;
                        return this.state.loaded ? null : function(t) {
                            e.props.onLoad(t), e.props.afterLoad(), e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function() {
                        var e = this.props, r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function(e, t) {
                            if (null == e) return {};
                            var r, o, n = function(e, t) {
                                if (null == e) return {};
                                var r, o, n = {}, i = Object.keys(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                return n;
                            }(e, t);
                            if (Object.getOwnPropertySymbols) {
                                var i = Object.getOwnPropertySymbols(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                            }
                            return n;
                        }(e, A));
                        return t().createElement("img", Q({}, r, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function() {
                        var e = this.props, r = e.beforeLoad, o = e.className, n = e.delayMethod, i = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.visibleByDefault, y = e.width;
                        return t().createElement(Y, {
                            beforeLoad: r,
                            className: o,
                            delayMethod: n,
                            delayTime: i,
                            height: c,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            visibleByDefault: p,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function(e) {
                        var r = this.props, o = r.effect, n = r.height, i = r.placeholderSrc, c = r.width, u = r.wrapperClassName, s = r.wrapperProps, l = this.state.loaded, a = l ? " lazy-load-image-loaded" : "", f = l || !i ? {} : {
                            backgroundImage: "url(".concat(i, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return t().createElement("span", Q({
                            className: u + " lazy-load-image-background " + o + a,
                            style: J(J({}, f), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: n,
                                width: c
                            })
                        }, s), e);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.effect, r = e.placeholderSrc, o = e.visibleByDefault, n = e.wrapperClassName, i = e.wrapperProps, c = this.getLazyLoadImage();
                        return (t || r) && !o || n || i ? this.getWrappedLazyLoadImage(c) : c;
                    }
                }
            ], Z(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        oe.propTypes = {
            onLoad: n.PropTypes.func,
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            delayMethod: n.PropTypes.string,
            delayTime: n.PropTypes.number,
            effect: n.PropTypes.string,
            placeholderSrc: n.PropTypes.string,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool,
            wrapperClassName: n.PropTypes.string,
            wrapperProps: n.PropTypes.object
        }, oe.defaultProps = {
            onLoad: function() {},
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        const ne = oe;
    })(), $1e3f3a9d43e19420$exports = o;
})();




const $40ac8f30f06b5caa$var$DEFAULT_API_BASE_URL = "http://localhost:3000";
const $40ac8f30f06b5caa$var$DEFAULT_IMAGE_UPLOAD_PATH = "dev/image";
const $40ac8f30f06b5caa$var$trimSlashes = (value)=>value.replace(/^\/+|\/+$/g, "");
const $40ac8f30f06b5caa$export$4d28219d42798a75 = ()=>{
    const configuredBaseUrl = "https://apistage.rocketpages.io"?.trim();
    return configuredBaseUrl ? configuredBaseUrl : $40ac8f30f06b5caa$var$DEFAULT_API_BASE_URL;
};
const $40ac8f30f06b5caa$export$1e3950dd8ffe88d9 = ()=>{
    const configuredPath = "upload/image"?.trim();
    return $40ac8f30f06b5caa$var$trimSlashes(configuredPath || $40ac8f30f06b5caa$var$DEFAULT_IMAGE_UPLOAD_PATH);
};
const $40ac8f30f06b5caa$export$c3ae438a4aaf614e = ()=>{
    const configuredPath = undefined?.trim();
    if (configuredPath) return $40ac8f30f06b5caa$var$trimSlashes(configuredPath);
    const imageUploadPath = $40ac8f30f06b5caa$export$1e3950dd8ffe88d9();
    if (imageUploadPath.endsWith("/image")) return `${imageUploadPath.slice(0, -6)}/signed-url`;
    if (imageUploadPath === "image") return "signed-url";
    return imageUploadPath;
};



var $eeH7J = parcelRequire("eeH7J");


var $eeH7J = parcelRequire("eeH7J");
var $74bfd7f882bd895a$exports = {};

$74bfd7f882bd895a$exports = (parcelRequire("9Q4tv"));


/**
 * Compute the dimension of the crop area based on media size,
 * aspect ratio and optionally rotation
 */ function $40cd2604c5853100$var$getCropSize(mediaWidth, mediaHeight, containerWidth, containerHeight, aspect, rotation) {
    if (rotation === void 0) rotation = 0;
    var _a = $40cd2604c5853100$var$rotateSize(mediaWidth, mediaHeight, rotation), width = _a.width, height = _a.height;
    var fittingWidth = Math.min(width, containerWidth);
    var fittingHeight = Math.min(height, containerHeight);
    if (fittingWidth > fittingHeight * aspect) return {
        width: fittingHeight * aspect,
        height: fittingHeight
    };
    return {
        width: fittingWidth,
        height: fittingWidth / aspect
    };
}
/**
 * Compute media zoom.
 * We fit the media into the container with "max-width: 100%; max-height: 100%;"
 */ function $40cd2604c5853100$var$getMediaZoom(mediaSize) {
    // Take the axis with more pixels to improve accuracy
    return mediaSize.width > mediaSize.height ? mediaSize.width / mediaSize.naturalWidth : mediaSize.height / mediaSize.naturalHeight;
}
/**
 * Ensure a new media position stays in the crop area.
 */ function $40cd2604c5853100$var$restrictPosition(position, mediaSize, cropSize, zoom, rotation) {
    if (rotation === void 0) rotation = 0;
    var _a = $40cd2604c5853100$var$rotateSize(mediaSize.width, mediaSize.height, rotation), width = _a.width, height = _a.height;
    return {
        x: $40cd2604c5853100$var$restrictPositionCoord(position.x, width, cropSize.width, zoom),
        y: $40cd2604c5853100$var$restrictPositionCoord(position.y, height, cropSize.height, zoom)
    };
}
function $40cd2604c5853100$var$restrictPositionCoord(position, mediaSize, cropSize, zoom) {
    var maxPosition = Math.abs(mediaSize * zoom / 2 - cropSize / 2);
    return $40cd2604c5853100$var$clamp(position, -maxPosition, maxPosition);
}
function $40cd2604c5853100$var$getDistanceBetweenPoints(pointA, pointB) {
    return Math.sqrt(Math.pow(pointA.y - pointB.y, 2) + Math.pow(pointA.x - pointB.x, 2));
}
function $40cd2604c5853100$var$getRotationBetweenPoints(pointA, pointB) {
    return Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x) * 180 / Math.PI;
}
/**
 * Compute the output cropped area of the media in percentages and pixels.
 * x/y are the top-left coordinates on the src media
 */ function $40cd2604c5853100$var$computeCroppedArea(crop, mediaSize, cropSize, aspect, zoom, rotation, restrictPosition) {
    if (rotation === void 0) rotation = 0;
    if (restrictPosition === void 0) restrictPosition = true;
    // if the media is rotated by the user, we cannot limit the position anymore
    // as it might need to be negative.
    var limitAreaFn = restrictPosition ? $40cd2604c5853100$var$limitArea : $40cd2604c5853100$var$noOp;
    var mediaBBoxSize = $40cd2604c5853100$var$rotateSize(mediaSize.width, mediaSize.height, rotation);
    var mediaNaturalBBoxSize = $40cd2604c5853100$var$rotateSize(mediaSize.naturalWidth, mediaSize.naturalHeight, rotation);
    // calculate the crop area in percentages
    // in the rotated space
    var croppedAreaPercentages = {
        x: limitAreaFn(100, ((mediaBBoxSize.width - cropSize.width / zoom) / 2 - crop.x / zoom) / mediaBBoxSize.width * 100),
        y: limitAreaFn(100, ((mediaBBoxSize.height - cropSize.height / zoom) / 2 - crop.y / zoom) / mediaBBoxSize.height * 100),
        width: limitAreaFn(100, cropSize.width / mediaBBoxSize.width * 100 / zoom),
        height: limitAreaFn(100, cropSize.height / mediaBBoxSize.height * 100 / zoom)
    };
    // we compute the pixels size naively
    var widthInPixels = Math.round(limitAreaFn(mediaNaturalBBoxSize.width, croppedAreaPercentages.width * mediaNaturalBBoxSize.width / 100));
    var heightInPixels = Math.round(limitAreaFn(mediaNaturalBBoxSize.height, croppedAreaPercentages.height * mediaNaturalBBoxSize.height / 100));
    var isImgWiderThanHigh = mediaNaturalBBoxSize.width >= mediaNaturalBBoxSize.height * aspect;
    // then we ensure the width and height exactly match the aspect (to avoid rounding approximations)
    // if the media is wider than high, when zoom is 0, the crop height will be equals to image height
    // thus we want to compute the width from the height and aspect for accuracy.
    // Otherwise, we compute the height from width and aspect.
    var sizePixels = isImgWiderThanHigh ? {
        width: Math.round(heightInPixels * aspect),
        height: heightInPixels
    } : {
        width: widthInPixels,
        height: Math.round(widthInPixels / aspect)
    };
    var croppedAreaPixels = (0, $5df189dad2b9134b$export$18ce0697a983be9b)((0, $5df189dad2b9134b$export$18ce0697a983be9b)({}, sizePixels), {
        x: Math.round(limitAreaFn(mediaNaturalBBoxSize.width - sizePixels.width, croppedAreaPercentages.x * mediaNaturalBBoxSize.width / 100)),
        y: Math.round(limitAreaFn(mediaNaturalBBoxSize.height - sizePixels.height, croppedAreaPercentages.y * mediaNaturalBBoxSize.height / 100))
    });
    return {
        croppedAreaPercentages: croppedAreaPercentages,
        croppedAreaPixels: croppedAreaPixels
    };
}
/**
 * Ensure the returned value is between 0 and max
 */ function $40cd2604c5853100$var$limitArea(max, value) {
    return Math.min(max, Math.max(0, value));
}
function $40cd2604c5853100$var$noOp(_max, value) {
    return value;
}
/**
 * Compute crop and zoom from the croppedAreaPercentages.
 */ function $40cd2604c5853100$export$387444de890e570c(croppedAreaPercentages, mediaSize, rotation, cropSize, minZoom, maxZoom) {
    var mediaBBoxSize = $40cd2604c5853100$var$rotateSize(mediaSize.width, mediaSize.height, rotation);
    // This is the inverse process of computeCroppedArea
    var zoom = $40cd2604c5853100$var$clamp(cropSize.width / mediaBBoxSize.width * (100 / croppedAreaPercentages.width), minZoom, maxZoom);
    var crop = {
        x: zoom * mediaBBoxSize.width / 2 - cropSize.width / 2 - mediaBBoxSize.width * zoom * (croppedAreaPercentages.x / 100),
        y: zoom * mediaBBoxSize.height / 2 - cropSize.height / 2 - mediaBBoxSize.height * zoom * (croppedAreaPercentages.y / 100)
    };
    return {
        crop: crop,
        zoom: zoom
    };
}
/**
 * Compute zoom from the croppedAreaPixels
 */ function $40cd2604c5853100$var$getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize) {
    var mediaZoom = $40cd2604c5853100$var$getMediaZoom(mediaSize);
    return cropSize.height > cropSize.width ? cropSize.height / (croppedAreaPixels.height * mediaZoom) : cropSize.width / (croppedAreaPixels.width * mediaZoom);
}
/**
 * Compute crop and zoom from the croppedAreaPixels
 */ function $40cd2604c5853100$export$4d2e47bf20e431bb(croppedAreaPixels, mediaSize, rotation, cropSize, minZoom, maxZoom) {
    if (rotation === void 0) rotation = 0;
    var mediaNaturalBBoxSize = $40cd2604c5853100$var$rotateSize(mediaSize.naturalWidth, mediaSize.naturalHeight, rotation);
    var zoom = $40cd2604c5853100$var$clamp($40cd2604c5853100$var$getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize), minZoom, maxZoom);
    var cropZoom = cropSize.height > cropSize.width ? cropSize.height / croppedAreaPixels.height : cropSize.width / croppedAreaPixels.width;
    var crop = {
        x: ((mediaNaturalBBoxSize.width - croppedAreaPixels.width) / 2 - croppedAreaPixels.x) * cropZoom,
        y: ((mediaNaturalBBoxSize.height - croppedAreaPixels.height) / 2 - croppedAreaPixels.y) * cropZoom
    };
    return {
        crop: crop,
        zoom: zoom
    };
}
/**
 * Return the point that is the center of point a and b
 */ function $40cd2604c5853100$var$getCenter(a, b) {
    return {
        x: (b.x + a.x) / 2,
        y: (b.y + a.y) / 2
    };
}
function $40cd2604c5853100$var$getRadianAngle(degreeValue) {
    return degreeValue * Math.PI / 180;
}
/**
 * Returns the new bounding area of a rotated rectangle.
 */ function $40cd2604c5853100$var$rotateSize(width, height, rotation) {
    var rotRad = $40cd2604c5853100$var$getRadianAngle(rotation);
    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
    };
}
/**
 * Clamp value between min and max
 */ function $40cd2604c5853100$var$clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
/**
 * Combine multiple class names into a single string.
 */ function $40cd2604c5853100$var$classNames() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.filter(function(value) {
        if (typeof value === 'string' && value.length > 0) return true;
        return false;
    }).join(' ').trim();
}
var $40cd2604c5853100$var$css_248z = ".reactEasyCrop_Container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  user-select: none;\n  touch-action: none;\n  cursor: move;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.reactEasyCrop_Image,\n.reactEasyCrop_Video {\n  will-change: transform; /* this improves performances and prevent painting issues on iOS Chrome */\n}\n\n.reactEasyCrop_Contain {\n  max-width: 100%;\n  max-height: 100%;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.reactEasyCrop_Cover_Horizontal {\n  width: 100%;\n  height: auto;\n}\n.reactEasyCrop_Cover_Vertical {\n  width: auto;\n  height: 100%;\n}\n\n.reactEasyCrop_CropArea {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-sizing: border-box;\n  box-shadow: 0 0 0 9999em;\n  color: rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.reactEasyCrop_CropAreaRound {\n  border-radius: 50%;\n}\n\n.reactEasyCrop_CropAreaGrid::before {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 0;\n  bottom: 0;\n  left: 33.33%;\n  right: 33.33%;\n  border-top: 0;\n  border-bottom: 0;\n}\n\n.reactEasyCrop_CropAreaGrid::after {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 33.33%;\n  bottom: 33.33%;\n  left: 0;\n  right: 0;\n  border-left: 0;\n  border-right: 0;\n}\n";
var $40cd2604c5853100$var$MIN_ZOOM = 1;
var $40cd2604c5853100$var$MAX_ZOOM = 3;
var $40cd2604c5853100$var$KEYBOARD_STEP = 1;
var $40cd2604c5853100$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    (0, $5df189dad2b9134b$export$a8ba968b8961cb8a)(Cropper, _super);
    function Cropper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cropperRef = $eeH7J.createRef();
        _this.imageRef = $eeH7J.createRef();
        _this.videoRef = $eeH7J.createRef();
        _this.containerPosition = {
            x: 0,
            y: 0
        };
        _this.containerRef = null;
        _this.styleRef = null;
        _this.containerRect = null;
        _this.mediaSize = {
            width: 0,
            height: 0,
            naturalWidth: 0,
            naturalHeight: 0
        };
        _this.dragStartPosition = {
            x: 0,
            y: 0
        };
        _this.dragStartCrop = {
            x: 0,
            y: 0
        };
        _this.gestureZoomStart = 0;
        _this.gestureRotationStart = 0;
        _this.isTouching = false;
        _this.lastPinchDistance = 0;
        _this.lastPinchRotation = 0;
        _this.rafDragTimeout = null;
        _this.rafPinchTimeout = null;
        _this.wheelTimer = null;
        _this.currentDoc = typeof document !== 'undefined' ? document : null;
        _this.currentWindow = typeof window !== 'undefined' ? window : null;
        _this.resizeObserver = null;
        _this.previousCropSize = null;
        _this.isInitialized = false;
        _this.state = {
            cropSize: null,
            hasWheelJustStarted: false,
            mediaObjectFit: undefined
        };
        _this.initResizeObserver = function() {
            if (typeof window.ResizeObserver === 'undefined' || !_this.containerRef) return;
            var isFirstResize = true;
            _this.resizeObserver = new window.ResizeObserver(function(entries) {
                if (isFirstResize) {
                    isFirstResize = false; // observe() is called on mount, we don't want to trigger a recompute on mount
                    return;
                }
                _this.computeSizes();
            });
            _this.resizeObserver.observe(_this.containerRef);
        };
        // this is to prevent Safari on iOS >= 10 to zoom the page
        _this.preventZoomSafari = function(e) {
            return e.preventDefault();
        };
        _this.cleanEvents = function() {
            if (!_this.currentDoc) return;
            _this.currentDoc.removeEventListener('mousemove', _this.onMouseMove);
            _this.currentDoc.removeEventListener('mouseup', _this.onDragStopped);
            _this.currentDoc.removeEventListener('touchmove', _this.onTouchMove);
            _this.currentDoc.removeEventListener('touchend', _this.onDragStopped);
            _this.currentDoc.removeEventListener('gesturechange', _this.onGestureChange);
            _this.currentDoc.removeEventListener('gestureend', _this.onGestureEnd);
            _this.currentDoc.removeEventListener('scroll', _this.onScroll);
        };
        _this.clearScrollEvent = function() {
            if (_this.containerRef) _this.containerRef.removeEventListener('wheel', _this.onWheel);
            if (_this.wheelTimer) clearTimeout(_this.wheelTimer);
        };
        _this.onMediaLoad = function() {
            var cropSize = _this.computeSizes();
            if (cropSize) {
                _this.previousCropSize = cropSize;
                _this.emitCropData();
                _this.setInitialCrop(cropSize);
                _this.isInitialized = true;
            }
            if (_this.props.onMediaLoaded) _this.props.onMediaLoaded(_this.mediaSize);
        };
        _this.setInitialCrop = function(cropSize) {
            if (_this.props.initialCroppedAreaPercentages) {
                var _a = $40cd2604c5853100$export$387444de890e570c(_this.props.initialCroppedAreaPercentages, _this.mediaSize, _this.props.rotation, cropSize, _this.props.minZoom, _this.props.maxZoom), crop = _a.crop, zoom = _a.zoom;
                _this.props.onCropChange(crop);
                _this.props.onZoomChange && _this.props.onZoomChange(zoom);
            } else if (_this.props.initialCroppedAreaPixels) {
                var _b = $40cd2604c5853100$export$4d2e47bf20e431bb(_this.props.initialCroppedAreaPixels, _this.mediaSize, _this.props.rotation, cropSize, _this.props.minZoom, _this.props.maxZoom), crop = _b.crop, zoom = _b.zoom;
                _this.props.onCropChange(crop);
                _this.props.onZoomChange && _this.props.onZoomChange(zoom);
            }
        };
        _this.computeSizes = function() {
            var _a, _b, _c, _d, _e, _f;
            var mediaRef = _this.imageRef.current || _this.videoRef.current;
            if (mediaRef && _this.containerRef) {
                _this.containerRect = _this.containerRef.getBoundingClientRect();
                _this.saveContainerPosition();
                var containerAspect = _this.containerRect.width / _this.containerRect.height;
                var naturalWidth = ((_a = _this.imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || ((_b = _this.videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) || 0;
                var naturalHeight = ((_c = _this.imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) || ((_d = _this.videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) || 0;
                var isMediaScaledDown = mediaRef.offsetWidth < naturalWidth || mediaRef.offsetHeight < naturalHeight;
                var mediaAspect = naturalWidth / naturalHeight;
                // We do not rely on the offsetWidth/offsetHeight if the media is scaled down
                // as the values they report are rounded. That will result in precision losses
                // when calculating zoom. We use the fact that the media is positionned relative
                // to the container. That allows us to use the container's dimensions
                // and natural aspect ratio of the media to calculate accurate media size.
                // However, for this to work, the container should not be rotated
                var renderedMediaSize = void 0;
                if (isMediaScaledDown) switch(_this.state.mediaObjectFit){
                    default:
                    case 'contain':
                        renderedMediaSize = containerAspect > mediaAspect ? {
                            width: _this.containerRect.height * mediaAspect,
                            height: _this.containerRect.height
                        } : {
                            width: _this.containerRect.width,
                            height: _this.containerRect.width / mediaAspect
                        };
                        break;
                    case 'horizontal-cover':
                        renderedMediaSize = {
                            width: _this.containerRect.width,
                            height: _this.containerRect.width / mediaAspect
                        };
                        break;
                    case 'vertical-cover':
                        renderedMediaSize = {
                            width: _this.containerRect.height * mediaAspect,
                            height: _this.containerRect.height
                        };
                        break;
                }
                else renderedMediaSize = {
                    width: mediaRef.offsetWidth,
                    height: mediaRef.offsetHeight
                };
                _this.mediaSize = (0, $5df189dad2b9134b$export$18ce0697a983be9b)((0, $5df189dad2b9134b$export$18ce0697a983be9b)({}, renderedMediaSize), {
                    naturalWidth: naturalWidth,
                    naturalHeight: naturalHeight
                });
                // set media size in the parent
                if (_this.props.setMediaSize) _this.props.setMediaSize(_this.mediaSize);
                var cropSize = _this.props.cropSize ? _this.props.cropSize : $40cd2604c5853100$var$getCropSize(_this.mediaSize.width, _this.mediaSize.height, _this.containerRect.width, _this.containerRect.height, _this.props.aspect, _this.props.rotation);
                if (((_e = _this.state.cropSize) === null || _e === void 0 ? void 0 : _e.height) !== cropSize.height || ((_f = _this.state.cropSize) === null || _f === void 0 ? void 0 : _f.width) !== cropSize.width) _this.props.onCropSizeChange && _this.props.onCropSizeChange(cropSize);
                _this.setState({
                    cropSize: cropSize
                }, _this.recomputeCropPosition);
                // pass crop size to parent
                if (_this.props.setCropSize) _this.props.setCropSize(cropSize);
                return cropSize;
            }
        };
        _this.saveContainerPosition = function() {
            if (_this.containerRef) {
                var bounds = _this.containerRef.getBoundingClientRect();
                _this.containerPosition = {
                    x: bounds.left,
                    y: bounds.top
                };
            }
        };
        _this.onMouseDown = function(e) {
            if (!_this.currentDoc) return;
            e.preventDefault();
            _this.currentDoc.addEventListener('mousemove', _this.onMouseMove);
            _this.currentDoc.addEventListener('mouseup', _this.onDragStopped);
            _this.saveContainerPosition();
            _this.onDragStart(Cropper.getMousePoint(e));
        };
        _this.onMouseMove = function(e) {
            return _this.onDrag(Cropper.getMousePoint(e));
        };
        _this.onScroll = function(e) {
            if (!_this.currentDoc) return;
            e.preventDefault();
            _this.saveContainerPosition();
        };
        _this.onTouchStart = function(e) {
            if (!_this.currentDoc) return;
            _this.isTouching = true;
            if (_this.props.onTouchRequest && !_this.props.onTouchRequest(e)) return;
            _this.currentDoc.addEventListener('touchmove', _this.onTouchMove, {
                passive: false
            }); // iOS 11 now defaults to passive: true
            _this.currentDoc.addEventListener('touchend', _this.onDragStopped);
            _this.saveContainerPosition();
            if (e.touches.length === 2) _this.onPinchStart(e);
            else if (e.touches.length === 1) _this.onDragStart(Cropper.getTouchPoint(e.touches[0]));
        };
        _this.onTouchMove = function(e) {
            // Prevent whole page from scrolling on iOS.
            e.preventDefault();
            if (e.touches.length === 2) _this.onPinchMove(e);
            else if (e.touches.length === 1) _this.onDrag(Cropper.getTouchPoint(e.touches[0]));
        };
        _this.onGestureStart = function(e) {
            if (!_this.currentDoc) return;
            e.preventDefault();
            _this.currentDoc.addEventListener('gesturechange', _this.onGestureChange);
            _this.currentDoc.addEventListener('gestureend', _this.onGestureEnd);
            _this.gestureZoomStart = _this.props.zoom;
            _this.gestureRotationStart = _this.props.rotation;
        };
        _this.onGestureChange = function(e) {
            e.preventDefault();
            if (_this.isTouching) // this is to avoid conflict between gesture and touch events
            return;
            var point = Cropper.getMousePoint(e);
            var newZoom = _this.gestureZoomStart - 1 + e.scale;
            _this.setNewZoom(newZoom, point, {
                shouldUpdatePosition: true
            });
            if (_this.props.onRotationChange) {
                var newRotation = _this.gestureRotationStart + e.rotation;
                _this.props.onRotationChange(newRotation);
            }
        };
        _this.onGestureEnd = function(e) {
            _this.cleanEvents();
        };
        _this.onDragStart = function(_a) {
            var _b, _c;
            var x = _a.x, y = _a.y;
            _this.dragStartPosition = {
                x: x,
                y: y
            };
            _this.dragStartCrop = (0, $5df189dad2b9134b$export$18ce0697a983be9b)({}, _this.props.crop);
            (_c = (_b = _this.props).onInteractionStart) === null || _c === void 0 || _c.call(_b);
        };
        _this.onDrag = function(_a) {
            var x = _a.x, y = _a.y;
            if (!_this.currentWindow) return;
            if (_this.rafDragTimeout) _this.currentWindow.cancelAnimationFrame(_this.rafDragTimeout);
            _this.rafDragTimeout = _this.currentWindow.requestAnimationFrame(function() {
                if (!_this.state.cropSize) return;
                if (x === undefined || y === undefined) return;
                var offsetX = x - _this.dragStartPosition.x;
                var offsetY = y - _this.dragStartPosition.y;
                var requestedPosition = {
                    x: _this.dragStartCrop.x + offsetX,
                    y: _this.dragStartCrop.y + offsetY
                };
                var newPosition = _this.props.restrictPosition ? $40cd2604c5853100$var$restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : requestedPosition;
                _this.props.onCropChange(newPosition);
            });
        };
        _this.onDragStopped = function() {
            var _a, _b;
            _this.isTouching = false;
            _this.cleanEvents();
            _this.emitCropData();
            (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 || _b.call(_a);
        };
        _this.onWheel = function(e) {
            if (!_this.currentWindow) return;
            if (_this.props.onWheelRequest && !_this.props.onWheelRequest(e)) return;
            e.preventDefault();
            var point = Cropper.getMousePoint(e);
            var pixelY = (0, (/*@__PURE__*/$parcel$interopDefault($74bfd7f882bd895a$exports)))(e).pixelY;
            var newZoom = _this.props.zoom - pixelY * _this.props.zoomSpeed / 200;
            _this.setNewZoom(newZoom, point, {
                shouldUpdatePosition: true
            });
            if (!_this.state.hasWheelJustStarted) _this.setState({
                hasWheelJustStarted: true
            }, function() {
                var _a, _b;
                return (_b = (_a = _this.props).onInteractionStart) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
            if (_this.wheelTimer) clearTimeout(_this.wheelTimer);
            _this.wheelTimer = _this.currentWindow.setTimeout(function() {
                return _this.setState({
                    hasWheelJustStarted: false
                }, function() {
                    var _a, _b;
                    return (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
                });
            }, 250);
        };
        _this.getPointOnContainer = function(_a, containerTopLeft) {
            var x = _a.x, y = _a.y;
            if (!_this.containerRect) throw new Error('The Cropper is not mounted');
            return {
                x: _this.containerRect.width / 2 - (x - containerTopLeft.x),
                y: _this.containerRect.height / 2 - (y - containerTopLeft.y)
            };
        };
        _this.getPointOnMedia = function(_a) {
            var x = _a.x, y = _a.y;
            var _b = _this.props, crop = _b.crop, zoom = _b.zoom;
            return {
                x: (x + crop.x) / zoom,
                y: (y + crop.y) / zoom
            };
        };
        _this.setNewZoom = function(zoom, point, _a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.shouldUpdatePosition, shouldUpdatePosition = _c === void 0 ? true : _c;
            if (!_this.state.cropSize || !_this.props.onZoomChange) return;
            var newZoom = $40cd2604c5853100$var$clamp(zoom, _this.props.minZoom, _this.props.maxZoom);
            if (shouldUpdatePosition) {
                var zoomPoint = _this.getPointOnContainer(point, _this.containerPosition);
                var zoomTarget = _this.getPointOnMedia(zoomPoint);
                var requestedPosition = {
                    x: zoomTarget.x * newZoom - zoomPoint.x,
                    y: zoomTarget.y * newZoom - zoomPoint.y
                };
                var newPosition = _this.props.restrictPosition ? $40cd2604c5853100$var$restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, newZoom, _this.props.rotation) : requestedPosition;
                _this.props.onCropChange(newPosition);
            }
            _this.props.onZoomChange(newZoom);
        };
        _this.getCropData = function() {
            if (!_this.state.cropSize) return null;
            // this is to ensure the crop is correctly restricted after a zoom back (https://github.com/ValentinH/react-easy-crop/issues/6)
            var restrictedPosition = _this.props.restrictPosition ? $40cd2604c5853100$var$restrictPosition(_this.props.crop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : _this.props.crop;
            return $40cd2604c5853100$var$computeCroppedArea(restrictedPosition, _this.mediaSize, _this.state.cropSize, _this.getAspect(), _this.props.zoom, _this.props.rotation, _this.props.restrictPosition);
        };
        _this.emitCropData = function() {
            var cropData = _this.getCropData();
            if (!cropData) return;
            var croppedAreaPercentages = cropData.croppedAreaPercentages, croppedAreaPixels = cropData.croppedAreaPixels;
            if (_this.props.onCropComplete) _this.props.onCropComplete(croppedAreaPercentages, croppedAreaPixels);
            if (_this.props.onCropAreaChange) _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
        };
        _this.emitCropAreaChange = function() {
            var cropData = _this.getCropData();
            if (!cropData) return;
            var croppedAreaPercentages = cropData.croppedAreaPercentages, croppedAreaPixels = cropData.croppedAreaPixels;
            if (_this.props.onCropAreaChange) _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
        };
        _this.recomputeCropPosition = function() {
            var _a, _b;
            if (!_this.state.cropSize) return;
            var adjustedCrop = _this.props.crop;
            // Only scale if we're initialized and this is a legitimate resize
            if (_this.isInitialized && ((_a = _this.previousCropSize) === null || _a === void 0 ? void 0 : _a.width) && ((_b = _this.previousCropSize) === null || _b === void 0 ? void 0 : _b.height)) {
                var sizeChanged = Math.abs(_this.previousCropSize.width - _this.state.cropSize.width) > 1e-6 || Math.abs(_this.previousCropSize.height - _this.state.cropSize.height) > 1e-6;
                if (sizeChanged) {
                    var scaleX = _this.state.cropSize.width / _this.previousCropSize.width;
                    var scaleY = _this.state.cropSize.height / _this.previousCropSize.height;
                    adjustedCrop = {
                        x: _this.props.crop.x * scaleX,
                        y: _this.props.crop.y * scaleY
                    };
                }
            }
            var newPosition = _this.props.restrictPosition ? $40cd2604c5853100$var$restrictPosition(adjustedCrop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : adjustedCrop;
            _this.previousCropSize = _this.state.cropSize;
            _this.props.onCropChange(newPosition);
            _this.emitCropData();
        };
        _this.onKeyDown = function(event) {
            var _a, _b;
            var _c = _this.props, crop = _c.crop, onCropChange = _c.onCropChange, keyboardStep = _c.keyboardStep, zoom = _c.zoom, rotation = _c.rotation;
            var step = keyboardStep;
            if (!_this.state.cropSize) return;
            // if the shift key is pressed, reduce the step to allow finer control
            if (event.shiftKey) step *= 0.2;
            var newCrop = (0, $5df189dad2b9134b$export$18ce0697a983be9b)({}, crop);
            switch(event.key){
                case 'ArrowUp':
                    newCrop.y -= step;
                    event.preventDefault();
                    break;
                case 'ArrowDown':
                    newCrop.y += step;
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    newCrop.x -= step;
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    newCrop.x += step;
                    event.preventDefault();
                    break;
                default:
                    return;
            }
            if (_this.props.restrictPosition) newCrop = $40cd2604c5853100$var$restrictPosition(newCrop, _this.mediaSize, _this.state.cropSize, zoom, rotation);
            if (!event.repeat) (_b = (_a = _this.props).onInteractionStart) === null || _b === void 0 || _b.call(_a);
            onCropChange(newCrop);
        };
        _this.onKeyUp = function(event) {
            var _a, _b;
            switch(event.key){
                case 'ArrowUp':
                case 'ArrowDown':
                case 'ArrowLeft':
                case 'ArrowRight':
                    event.preventDefault();
                    break;
                default:
                    return;
            }
            _this.emitCropData();
            (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 || _b.call(_a);
        };
        return _this;
    }
    Cropper.prototype.componentDidMount = function() {
        if (!this.currentDoc || !this.currentWindow) return;
        if (this.containerRef) {
            if (this.containerRef.ownerDocument) this.currentDoc = this.containerRef.ownerDocument;
            if (this.currentDoc.defaultView) this.currentWindow = this.currentDoc.defaultView;
            this.initResizeObserver();
            // only add window resize listener if ResizeObserver is not supported. Otherwise, it would be redundant
            if (typeof window.ResizeObserver === 'undefined') this.currentWindow.addEventListener('resize', this.computeSizes);
            this.props.zoomWithScroll && this.containerRef.addEventListener('wheel', this.onWheel, {
                passive: false
            });
            this.containerRef.addEventListener('gesturestart', this.onGestureStart);
        }
        this.currentDoc.addEventListener('scroll', this.onScroll);
        if (!this.props.disableAutomaticStylesInjection) {
            this.styleRef = this.currentDoc.createElement('style');
            this.styleRef.setAttribute('type', 'text/css');
            if (this.props.nonce) this.styleRef.setAttribute('nonce', this.props.nonce);
            this.styleRef.innerHTML = $40cd2604c5853100$var$css_248z;
            this.currentDoc.head.appendChild(this.styleRef);
        }
        // when rendered via SSR, the image can already be loaded and its onLoad callback will never be called
        if (this.imageRef.current && this.imageRef.current.complete) this.onMediaLoad();
        // set image and video refs in the parent if the callbacks exist
        if (this.props.setImageRef) this.props.setImageRef(this.imageRef);
        if (this.props.setVideoRef) this.props.setVideoRef(this.videoRef);
        if (this.props.setCropperRef) this.props.setCropperRef(this.cropperRef);
    };
    Cropper.prototype.componentWillUnmount = function() {
        var _a, _b;
        if (!this.currentDoc || !this.currentWindow) return;
        if (typeof window.ResizeObserver === 'undefined') this.currentWindow.removeEventListener('resize', this.computeSizes);
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
        if (this.containerRef) this.containerRef.removeEventListener('gesturestart', this.preventZoomSafari);
        if (this.styleRef) (_b = this.styleRef.parentNode) === null || _b === void 0 || _b.removeChild(this.styleRef);
        this.cleanEvents();
        this.props.zoomWithScroll && this.clearScrollEvent();
    };
    Cropper.prototype.componentDidUpdate = function(prevProps) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (prevProps.rotation !== this.props.rotation) {
            this.computeSizes();
            this.recomputeCropPosition();
        } else if (prevProps.aspect !== this.props.aspect) this.computeSizes();
        else if (prevProps.objectFit !== this.props.objectFit) this.computeSizes();
        else if (prevProps.zoom !== this.props.zoom) this.recomputeCropPosition();
        else if (((_a = prevProps.cropSize) === null || _a === void 0 ? void 0 : _a.height) !== ((_b = this.props.cropSize) === null || _b === void 0 ? void 0 : _b.height) || ((_c = prevProps.cropSize) === null || _c === void 0 ? void 0 : _c.width) !== ((_d = this.props.cropSize) === null || _d === void 0 ? void 0 : _d.width)) this.computeSizes();
        else if (((_e = prevProps.crop) === null || _e === void 0 ? void 0 : _e.x) !== ((_f = this.props.crop) === null || _f === void 0 ? void 0 : _f.x) || ((_g = prevProps.crop) === null || _g === void 0 ? void 0 : _g.y) !== ((_h = this.props.crop) === null || _h === void 0 ? void 0 : _h.y)) this.emitCropAreaChange();
        if (prevProps.zoomWithScroll !== this.props.zoomWithScroll && this.containerRef) this.props.zoomWithScroll ? this.containerRef.addEventListener('wheel', this.onWheel, {
            passive: false
        }) : this.clearScrollEvent();
        if (prevProps.video !== this.props.video) (_j = this.videoRef.current) === null || _j === void 0 || _j.load();
        var objectFit = this.getObjectFit();
        if (objectFit !== this.state.mediaObjectFit) this.setState({
            mediaObjectFit: objectFit
        }, this.computeSizes);
    };
    Cropper.prototype.getAspect = function() {
        var _a = this.props, cropSize = _a.cropSize, aspect = _a.aspect;
        if (cropSize) return cropSize.width / cropSize.height;
        return aspect;
    };
    Cropper.prototype.getObjectFit = function() {
        var _a, _b, _c, _d;
        if (this.props.objectFit === 'cover') {
            var mediaRef = this.imageRef.current || this.videoRef.current;
            if (mediaRef && this.containerRef) {
                this.containerRect = this.containerRef.getBoundingClientRect();
                var containerAspect = this.containerRect.width / this.containerRect.height;
                var naturalWidth = ((_a = this.imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || ((_b = this.videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) || 0;
                var naturalHeight = ((_c = this.imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) || ((_d = this.videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) || 0;
                var mediaAspect = naturalWidth / naturalHeight;
                return mediaAspect < containerAspect ? 'horizontal-cover' : 'vertical-cover';
            }
            return 'horizontal-cover';
        }
        return this.props.objectFit;
    };
    Cropper.prototype.onPinchStart = function(e) {
        var pointA = Cropper.getTouchPoint(e.touches[0]);
        var pointB = Cropper.getTouchPoint(e.touches[1]);
        this.lastPinchDistance = $40cd2604c5853100$var$getDistanceBetweenPoints(pointA, pointB);
        this.lastPinchRotation = $40cd2604c5853100$var$getRotationBetweenPoints(pointA, pointB);
        this.onDragStart($40cd2604c5853100$var$getCenter(pointA, pointB));
    };
    Cropper.prototype.onPinchMove = function(e) {
        var _this = this;
        if (!this.currentDoc || !this.currentWindow) return;
        var pointA = Cropper.getTouchPoint(e.touches[0]);
        var pointB = Cropper.getTouchPoint(e.touches[1]);
        var center = $40cd2604c5853100$var$getCenter(pointA, pointB);
        this.onDrag(center);
        if (this.rafPinchTimeout) this.currentWindow.cancelAnimationFrame(this.rafPinchTimeout);
        this.rafPinchTimeout = this.currentWindow.requestAnimationFrame(function() {
            var distance = $40cd2604c5853100$var$getDistanceBetweenPoints(pointA, pointB);
            var newZoom = _this.props.zoom * (distance / _this.lastPinchDistance);
            _this.setNewZoom(newZoom, center, {
                shouldUpdatePosition: false
            });
            _this.lastPinchDistance = distance;
            var rotation = $40cd2604c5853100$var$getRotationBetweenPoints(pointA, pointB);
            var newRotation = _this.props.rotation + (rotation - _this.lastPinchRotation);
            _this.props.onRotationChange && _this.props.onRotationChange(newRotation);
            _this.lastPinchRotation = rotation;
        });
    };
    Cropper.prototype.render = function() {
        var _this = this;
        var _a;
        var _b = this.props, image = _b.image, video = _b.video, mediaProps = _b.mediaProps, cropperProps = _b.cropperProps, transform = _b.transform, _c = _b.crop, x = _c.x, y = _c.y, rotation = _b.rotation, zoom = _b.zoom, cropShape = _b.cropShape, showGrid = _b.showGrid, roundCropAreaPixels = _b.roundCropAreaPixels, _d = _b.style, containerStyle = _d.containerStyle, cropAreaStyle = _d.cropAreaStyle, mediaStyle = _d.mediaStyle, _e = _b.classes, containerClassName = _e.containerClassName, cropAreaClassName = _e.cropAreaClassName, mediaClassName = _e.mediaClassName;
        var objectFit = (_a = this.state.mediaObjectFit) !== null && _a !== void 0 ? _a : this.getObjectFit();
        return $eeH7J.createElement("div", {
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart,
            ref: function ref(el) {
                return _this.containerRef = el;
            },
            "data-testid": "container",
            style: containerStyle,
            className: $40cd2604c5853100$var$classNames('reactEasyCrop_Container', containerClassName)
        }, image ? $eeH7J.createElement("img", (0, $5df189dad2b9134b$export$18ce0697a983be9b)({
            alt: "",
            className: $40cd2604c5853100$var$classNames('reactEasyCrop_Image', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
        }, mediaProps, {
            src: image,
            ref: this.imageRef,
            style: (0, $5df189dad2b9134b$export$18ce0697a983be9b)((0, $5df189dad2b9134b$export$18ce0697a983be9b)({}, mediaStyle), {
                transform: transform || "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "deg) scale(").concat(zoom, ")")
            }),
            onLoad: this.onMediaLoad
        })) : video && $eeH7J.createElement("video", (0, $5df189dad2b9134b$export$18ce0697a983be9b)({
            autoPlay: true,
            playsInline: true,
            loop: true,
            muted: true,
            className: $40cd2604c5853100$var$classNames('reactEasyCrop_Video', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
        }, mediaProps, {
            ref: this.videoRef,
            onLoadedMetadata: this.onMediaLoad,
            style: (0, $5df189dad2b9134b$export$18ce0697a983be9b)((0, $5df189dad2b9134b$export$18ce0697a983be9b)({}, mediaStyle), {
                transform: transform || "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "deg) scale(").concat(zoom, ")")
            }),
            controls: false
        }), (Array.isArray(video) ? video : [
            {
                src: video
            }
        ]).map(function(item) {
            return $eeH7J.createElement("source", (0, $5df189dad2b9134b$export$18ce0697a983be9b)({
                key: item.src
            }, item));
        })), this.state.cropSize && $eeH7J.createElement("div", (0, $5df189dad2b9134b$export$18ce0697a983be9b)({
            ref: this.cropperRef,
            style: (0, $5df189dad2b9134b$export$18ce0697a983be9b)((0, $5df189dad2b9134b$export$18ce0697a983be9b)({}, cropAreaStyle), {
                width: roundCropAreaPixels ? Math.round(this.state.cropSize.width) : this.state.cropSize.width,
                height: roundCropAreaPixels ? Math.round(this.state.cropSize.height) : this.state.cropSize.height
            }),
            tabIndex: 0,
            onKeyDown: this.onKeyDown,
            onKeyUp: this.onKeyUp,
            "data-testid": "cropper",
            className: $40cd2604c5853100$var$classNames('reactEasyCrop_CropArea', cropShape === 'round' && 'reactEasyCrop_CropAreaRound', showGrid && 'reactEasyCrop_CropAreaGrid', cropAreaClassName)
        }, cropperProps)));
    };
    Cropper.defaultProps = {
        zoom: 1,
        rotation: 0,
        aspect: 4 / 3,
        maxZoom: $40cd2604c5853100$var$MAX_ZOOM,
        minZoom: $40cd2604c5853100$var$MIN_ZOOM,
        cropShape: 'rect',
        objectFit: 'contain',
        showGrid: true,
        style: {},
        classes: {},
        mediaProps: {},
        cropperProps: {},
        zoomSpeed: 1,
        restrictPosition: true,
        zoomWithScroll: true,
        keyboardStep: $40cd2604c5853100$var$KEYBOARD_STEP
    };
    Cropper.getMousePoint = function(e) {
        return {
            x: Number(e.clientX),
            y: Number(e.clientY)
        };
    };
    Cropper.getTouchPoint = function(touch) {
        return {
            x: Number(touch.clientX),
            y: Number(touch.clientY)
        };
    };
    return Cropper;
}($eeH7J.Component);



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");




var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $5YyXA = parcelRequire("5YyXA");const $a6b48bd43990f673$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $a6b48bd43990f673$export$2e2bcd8739ae039 = $a6b48bd43990f673$var$visuallyHidden;



function $97216d5d62f7597f$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $97216d5d62f7597f$export$2e2bcd8739ae039 = $97216d5d62f7597f$var$areArraysEqual;


'use client';
const $35b60a3f2e3a0c9e$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $35b60a3f2e3a0c9e$var$asc(a, b) {
    return a - b;
}
function $35b60a3f2e3a0c9e$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $35b60a3f2e3a0c9e$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $35b60a3f2e3a0c9e$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $35b60a3f2e3a0c9e$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $35b60a3f2e3a0c9e$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $35b60a3f2e3a0c9e$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($35b60a3f2e3a0c9e$var$getDecimalPrecision(step)));
}
function $35b60a3f2e3a0c9e$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($35b60a3f2e3a0c9e$var$asc);
}
function $35b60a3f2e3a0c9e$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $35b60a3f2e3a0c9e$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $97216d5d62f7597f$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $35b60a3f2e3a0c9e$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $35b60a3f2e3a0c9e$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $35b60a3f2e3a0c9e$var$cachedSupportsTouchActionNone;
function $35b60a3f2e3a0c9e$var$doesSupportTouchActionNone() {
    if ($35b60a3f2e3a0c9e$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $35b60a3f2e3a0c9e$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $35b60a3f2e3a0c9e$var$cachedSupportsTouchActionNone = true;
    }
    return $35b60a3f2e3a0c9e$var$cachedSupportsTouchActionNone;
}
function $35b60a3f2e3a0c9e$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $35b60a3f2e3a0c9e$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $eeH7J.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $eeH7J.useState(-1);
    const [open, setOpen] = $eeH7J.useState(-1);
    const [dragging, setDragging] = $eeH7J.useState(false);
    const moveCount = $eeH7J.useRef(0);
    const [valueDerived, setValueState] = (0, $bcd4f903766661d9$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($35b60a3f2e3a0c9e$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $5YyXA.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $b34b966f85c5a68b$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $eeH7J.useState(-1);
    const sliderRef = $eeH7J.useRef(null);
    const handleFocusRef = (0, $c909b21db041accd$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $c909b21db041accd$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute('data-index'));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue > maxMarksValue) newValue = maxMarksValue;
            else if (newValue < marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $5YyXA.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $5YyXA.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $35b60a3f2e3a0c9e$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $35b60a3f2e3a0c9e$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$35b60a3f2e3a0c9e$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
            // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
            if (step !== null) {
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                if ((event.key === 'ArrowLeft' || event.key === 'ArrowDown') && event.shiftKey || event.key === 'PageDown') newValue = Math.max(value - shiftStep, min);
                else if ((event.key === 'ArrowRight' || event.key === 'ArrowUp') && event.shiftKey || event.key === 'PageUp') newValue = Math.min(value + shiftStep, max);
                if (newValue !== null) {
                    changeValue(event, newValue);
                    event.preventDefault();
                }
            }
            otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
        };
    (0, $27c0fbde361ccc36$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $eeH7J.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        let newValue;
        newValue = $35b60a3f2e3a0c9e$var$percentToValue(percent, min, max);
        if (step) newValue = $35b60a3f2e3a0c9e$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $35b60a3f2e3a0c9e$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $5YyXA.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $35b60a3f2e3a0c9e$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $5YyXA.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $35b60a3f2e3a0c9e$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $208bf4215efa66ac$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $35b60a3f2e3a0c9e$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $35b60a3f2e3a0c9e$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $35b60a3f2e3a0c9e$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$35b60a3f2e3a0c9e$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $208bf4215efa66ac$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $35b60a3f2e3a0c9e$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $208bf4215efa66ac$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$35b60a3f2e3a0c9e$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $35b60a3f2e3a0c9e$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $35b60a3f2e3a0c9e$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$35b60a3f2e3a0c9e$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $eeH7J.useCallback(()=>{
        const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $eeH7J.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $35b60a3f2e3a0c9e$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $eeH7J.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $35b60a3f2e3a0c9e$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $35b60a3f2e3a0c9e$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$35b60a3f2e3a0c9e$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $86ba5fa7ddb82a47$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $35b60a3f2e3a0c9e$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $35b60a3f2e3a0c9e$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $be77b66cbdfe23fb$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $h4XE0.default)({}, externalHandlers, ownEventHandlers);
        return (0, $h4XE0.default)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $be77b66cbdfe23fb$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $h4XE0.default)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $be77b66cbdfe23fb$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $h4XE0.default)({}, externalHandlers, ownEventHandlers);
        return (0, $h4XE0.default)({
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $h4XE0.default)({}, (0, $a6b48bd43990f673$export$2e2bcd8739ae039), {
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%'
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $35b60a3f2e3a0c9e$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $jXkrt = parcelRequire("jXkrt");

const $18302d449f552e87$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(Slot);
};
var $18302d449f552e87$export$2e2bcd8739ae039 = $18302d449f552e87$var$shouldSpreadAdditionalProps;



var $4A7Fh = parcelRequire("4A7Fh");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d57722dcd55d8cab$export$9f59f2622d5cbc2a(slot) {
    return (0, $aBqGi.default)('MuiSlider', slot);
}
const $d57722dcd55d8cab$var$sliderClasses = (0, $cDqLM.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $d57722dcd55d8cab$export$2e2bcd8739ae039 = $d57722dcd55d8cab$var$sliderClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $df8abdbdd29dbf35$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $er6YD.default)(open && (0, $d57722dcd55d8cab$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $d57722dcd55d8cab$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $d57722dcd55d8cab$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $df8abdbdd29dbf35$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $df8abdbdd29dbf35$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $eeH7J.cloneElement(children, {
        className: (0, $er6YD.default)(children.props.className)
    }, /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $dRzna.jsx)("span", {
                className: (0, $er6YD.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $dRzna.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $dRzna.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}
$df8abdbdd29dbf35$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node
};




var $dRzna = parcelRequire("dRzna");
'use client';
const $29832fb5ec27af69$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "shiftStep",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
function $29832fb5ec27af69$var$Identity(x) {
    return x;
}
const $29832fb5ec27af69$export$c1a21b3b4da66aa1 = (0, $hikmr.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $4A7Fh.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $4A7Fh.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).thumb}, & .${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    };
});
const $29832fb5ec27af69$export$b02fde61a3559c2 = (0, $hikmr.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $29832fb5ec27af69$export$105594979f116971 = (0, $hikmr.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>{
    var _theme$vars3;
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter((key)=>{
                var _theme$vars4;
                return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: (0, $h4XE0.default)({}, theme.vars ? {
                        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                        borderColor: theme.vars.palette.Slider[`${color}Track`]
                    } : (0, $h4XE0.default)({
                        backgroundColor: (0, $5YtKS.lighten)(theme.palette[color].main, 0.62),
                        borderColor: (0, $5YtKS.lighten)(theme.palette[color].main, 0.62)
                    }, theme.applyStyles('dark', {
                        backgroundColor: (0, $5YtKS.darken)(theme.palette[color].main, 0.5)
                    }), theme.applyStyles('dark', {
                        borderColor: (0, $5YtKS.darken)(theme.palette[color].main, 0.5)
                    })))
                }))
        ]
    };
});
const $29832fb5ec27af69$export$2c1b491743890dec = (0, $hikmr.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $4A7Fh.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $4A7Fh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars5;
    return {
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter((key)=>{
                var _theme$vars6;
                return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).focusVisible}`]: (0, $h4XE0.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 8px ${(0, $5YtKS.alpha)(theme.palette[color].main, 0.16)}`
                        }, {
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        }),
                        [`&.${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).active}`]: (0, $h4XE0.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 14px ${(0, $5YtKS.alpha)(theme.palette[color].main, 0.16)}`
                        })
                    }
                }))
        ]
    };
});
const $29832fb5ec27af69$export$6453176f504d54f0 = (0, $hikmr.default)((0, $df8abdbdd29dbf35$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme })=>(0, $h4XE0.default)({
        zIndex: 1,
        whiteSpace: 'nowrap'
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $d57722dcd55d8cab$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    }));
const $29832fb5ec27af69$export$6f85f6a3c5da6f62 = (0, $hikmr.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $jXkrt.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    }));
const $29832fb5ec27af69$export$e6cd369965e5aa95 = (0, $hikmr.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $jXkrt.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme })=>(0, $h4XE0.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    }));
const $29832fb5ec27af69$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $4A7Fh.default)(color)}`,
            size && `size${(0, $4A7Fh.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $4A7Fh.default)(size)}`,
            color && `thumbColor${(0, $4A7Fh.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $d57722dcd55d8cab$export$9f59f2622d5cbc2a), classes);
};
const $29832fb5ec27af69$var$Forward = ({ children: children })=>children;
const $29832fb5ec27af69$var$Slider = /*#__PURE__*/ $eeH7J.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $24165880ce40ccbd$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $29832fb5ec27af69$var$Identity, slotProps: slotProps, slots: slots, track: track = 'normal', valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $29832fb5ec27af69$var$Identity } = props, other = (0, $fbOaB.default)(props, $29832fb5ec27af69$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $35b60a3f2e3a0c9e$export$56b2c08e277f365)((0, $h4XE0.default)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $29832fb5ec27af69$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $29832fb5ec27af69$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $29832fb5ec27af69$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $29832fb5ec27af69$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $29832fb5ec27af69$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $29832fb5ec27af69$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $29832fb5ec27af69$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $29832fb5ec27af69$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $h4XE0.default)({}, (0, $18302d449f552e87$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $h4XE0.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $h4XE0.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $h4XE0.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $h4XE0.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $h4XE0.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $dRzna.jsxs)(RootSlot, (0, $h4XE0.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)(RailSlot, (0, $h4XE0.default)({}, railProps)),
            /*#__PURE__*/ (0, $dRzna.jsx)(TrackSlot, (0, $h4XE0.default)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $35b60a3f2e3a0c9e$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $dRzna.jsx)(MarkSlot, (0, $h4XE0.default)({
                            "data-index": index
                        }, markProps, !(0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $h4XE0.default)({}, style, markProps.style),
                            className: (0, $er6YD.default)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $dRzna.jsx)(MarkLabelSlot, (0, $h4XE0.default)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $h4XE0.default)({}, style, markLabelProps.style),
                            className: (0, $er6YD.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $35b60a3f2e3a0c9e$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $29832fb5ec27af69$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $dRzna.jsx)(ValueLabelComponent, (0, $h4XE0.default)({}, !(0, $1f8e2ead014c8e16$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === 'on',
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $dRzna.jsx)(ThumbSlot, (0, $h4XE0.default)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $er6YD.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $h4XE0.default)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $dRzna.jsx)(InputSlot, (0, $h4XE0.default)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
$29832fb5ec27af69$var$Slider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The label of the slider.
   */ 'aria-label': (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string, (props)=>{
        const range = Array.isArray(props.value || props.defaultValue);
        if (range && props['aria-label'] != null) return new Error('MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
        return null;
    }),
    /**
   * The id of the element containing a label for the slider.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */ 'aria-valuetext': (0, $b2f92e84e131ddaf$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string, (props)=>{
        const range = Array.isArray(props.value || props.defaultValue);
        if (range && props['aria-valuetext'] != null) return new Error('MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
        return null;
    }),
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Mark: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        MarkLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Rail: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Thumb: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        Track: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        ValueLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        mark: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        markLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        rail: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        track: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        valueLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
                children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
                open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
                style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
                valueLabelDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                    'auto',
                    'off',
                    'on'
                ])
            })
        ])
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */ disableSwap: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */ getAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */ getAriaValueText: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */ marks: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number.isRequired
        })),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
    ]),
    /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */ max: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */ min: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Name attribute of the hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */ onChangeCommitted: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The component orientation.
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */ scale: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */ shiftStep: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * The size of the slider.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'small',
            'medium'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The props used for each slot inside the Slider.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        mark: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        markLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        rail: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        track: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        valueLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
                children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
                open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
                style: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
                value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
                valueLabelDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
                    'auto',
                    'off',
                    'on'
                ])
            })
        ])
    }),
    /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        mark: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        markLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        rail: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        track: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        valueLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */ step: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Tab index attribute of the hidden `input` element.
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */ track: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'inverted',
        'normal',
        false
    ]),
    /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */ valueLabelDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'auto',
        'off',
        'on'
    ]),
    /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */ valueLabelFormat: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $29832fb5ec27af69$export$2e2bcd8739ae039 = $29832fb5ec27af69$var$Slider;




const $636421b172f627f8$var$createImage = (url)=>new Promise((resolve, reject)=>{
        const image = new Image();
        image.addEventListener("load", ()=>resolve(image));
        image.addEventListener("error", (error)=>reject(error));
        image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
        // Optionally append cache-busting param to avoid weird caching issues
        image.src = url + (url.includes("?") ? "&" : "?") + "t=" + Date.now();
    });
function $636421b172f627f8$var$getRadianAngle(degreeValue) {
    return degreeValue * Math.PI / 180;
}
async function $636421b172f627f8$export$2e2bcd8739ae039(imageSrc, pixelCrop, rotation = 0, horizontal, vertical, contentType) {
    const image = await $636421b172f627f8$var$createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const radians = $636421b172f627f8$var$getRadianAngle(rotation);
    let flip = {
        horizontal: horizontal,
        vertical: vertical
    };
    // console.log(
    //   "inputParam",
    //   imageSrc,
    //   pixelCrop,
    //   rotation,
    //   horizontal,
    //   vertical,
    //   contentType
    // );
    // Calculate bounding box of the rotated image
    const rotatedWidth = Math.abs(image.width * Math.cos(radians)) + Math.abs(image.height * Math.sin(radians));
    const rotatedHeight = Math.abs(image.width * Math.sin(radians)) + Math.abs(image.height * Math.cos(radians));
    // Set canvas dimensions to rotated image dimensions
    canvas.width = rotatedWidth;
    canvas.height = rotatedHeight;
    // Apply flip transformations
    ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
    // Rotate the image around its center
    ctx.rotate(radians);
    ctx.translate(-image.width / 2, -image.height / 2);
    // Draw the transformed image
    ctx.drawImage(image, 0, 0);
    // Create a second canvas to draw the cropped portion
    const croppedCanvas = document.createElement("canvas");
    const croppedCtx = croppedCanvas.getContext("2d");
    // Set dimensions of cropped canvas
    croppedCanvas.width = pixelCrop.width;
    croppedCanvas.height = pixelCrop.height;
    // Draw the cropped area from the rotated and flipped image
    croppedCtx.drawImage(canvas, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height // draw the cropped area to fit the canvas height
    );
    // Extract the file type from the original image source
    //  const fileType = imageSrc.substring(imageSrc.lastIndexOf('.') + 1).toLowerCase();
    let _contentType = contentType;
    //  console.log('fileType: ' + fileType);
    if (_contentType === "image/gif") _contentType = "image/jpeg";
    // setFileType(contentType);
    // console.log('contentType: ' + contentType);
    // Convert cropped canvas to a Blob
    return new Promise((resolve)=>{
        croppedCanvas.toBlob((file)=>{
            resolve(file);
        }, _contentType, 0.80);
    });
}



var $e26e82c1baede67b$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($e26e82c1baede67b$exports, "__esModule", {
    value: true
});
$e26e82c1baede67b$exports.default = void 0;

var $e26e82c1baede67b$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $e26e82c1baede67b$var$_default = $e26e82c1baede67b$exports.default = (0, $e26e82c1baede67b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9"
}), 'SettingsBackupRestoreSharp');






const $7cc92e6826c09370$var$ImageCropper = ({ imageSrc: imageSrc, imageName: imageName, onClose: onClose, onSave: onSave })=>{
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const [isImageLoading, setIsImageLoading] = (0, $eeH7J.useState)(true);
    const [contentType, setContentType] = (0, $eeH7J.useState)("");
    const [crop, setCrop] = (0, $eeH7J.useState)({
        x: 0,
        y: 0
    });
    const [zoom, setZoom] = (0, $eeH7J.useState)(1);
    const [imageDimensions, setImageDimensions] = (0, $eeH7J.useState)({
        width: 0,
        height: 0
    });
    const [rotation, setRotation] = (0, $eeH7J.useState)(0);
    const [aspectRatio, setAspectRatio] = (0, $eeH7J.useState)(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = (0, $eeH7J.useState)(null);
    const [flipHorizontal, setFlipHorizontal] = (0, $eeH7J.useState)(false);
    const [flipVertical, setFlipVertical] = (0, $eeH7J.useState)(false);
    const onCropComplete = (0, $eeH7J.useCallback)((croppedArea, croppedAreaPixels)=>{
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useEffect(()=>{
        // Load the image and get its dimensions
        if (imageSrc) {
            const img = new Image();
            img.src = imageSrc;
            img.onload = ()=>{
                const width = img.width;
                const height = img.height;
                setImageDimensions({
                    width: width,
                    height: height
                });
                // Match image ratio to the closest predefined aspect ratio option
                const imageRatio = width / height;
                const predefinedRatios = [
                    1,
                    4 / 3,
                    1.5,
                    16 / 9,
                    5 / 4,
                    2,
                    1.6
                ];
                const closestRatio = predefinedRatios.reduce((prev, curr)=>Math.abs(curr - imageRatio) < Math.abs(prev - imageRatio) ? curr : prev);
                setAspectRatio(closestRatio);
                setIsImageLoading(false);
            };
        }
    }, [
        imageSrc
    ]);
    const showCroppedImage = (0, $eeH7J.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const croppedImage = await (0, $636421b172f627f8$export$2e2bcd8739ae039)(imageSrc, croppedAreaPixels, rotation, flipHorizontal, flipVertical, contentType);
            onSave(croppedImage);
        } catch (e) {
            console.error(e);
        } finally{
            setIsLoading(false);
        }
    }, [
        croppedAreaPixels,
        rotation,
        flipHorizontal,
        flipVertical
    ]);
    const handleFlipHorizontal = ()=>{
        setFlipHorizontal(!flipHorizontal);
    };
    const handleFlipVertical = ()=>{
        setFlipVertical(!flipVertical);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col h-full "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-catelina-blue text-sm font-medium"
    }, imageName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col md:flex-row w-full h-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        id: "image-cropper-v2",
        className: "relative w-full md:w-9/12 h-48 md:h-full bg-gray-200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $40cd2604c5853100$export$2e2bcd8739ae039), {
        image: imageSrc,
        crop: crop,
        zoom: zoom,
        rotation: rotation,
        aspect: aspectRatio,
        onCropChange: setCrop,
        onZoomChange: setZoom,
        onCropComplete: onCropComplete,
        transform: `translate(${crop.x}px, ${crop.y}px) rotate(${rotation}deg) scale(${zoom}) scaleX(${flipHorizontal ? -1 : 1}) scaleY(${flipVertical ? -1 : 1})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `w-full md:w-3/12 md:mx-2 bg-[#FAFAFA] px-2 border rounded-lg border-dashed border-light-purple text-base text-catelina-blue flex flex-col overflow-auto pb-4 md:mt-0 md:mb-0 mt-4 mb-4`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "font-semibold text-sm text-catelina-blue mb-4"
    }, "Image Editing Options"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full flex flex-col sm:flex-row mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "block text-sm font-medium text-catelina-blue"
    }, "Crop ratio"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("select", {
        id: "aspect-ratio",
        className: "block w-full p-1 text-xsm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
        value: aspectRatio,
        onChange: (event)=>{
            setAspectRatio(parseFloat(event.target.value));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("option", {
        value: 1
    }, "1:1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("option", {
        value: 4 / 3
    }, "4:3"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("option", {
        value: 1.5
    }, "3:2"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("option", {
        value: 16 / 9
    }, "16:9"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("option", {
        value: 5 / 4
    }, "5:4"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("option", {
        value: 2
    }, "2:1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("option", {
        value: 1.6
    }, "16:10")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full flex flex-col mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "block text-sm font-medium text-catelina-blue"
    }, "Rotate & Flip"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-row justify-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("5w35B")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: ()=>{
            setRotation(rotation + 90);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("o1MqC")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: ()=>{
            setRotation(rotation - 90);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("lP7AQ")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: handleFlipHorizontal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("bS3dc")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: handleFlipVertical
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "mt-2 w-full px-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "font-medium text-sm"
    }, "Zoom"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $29832fb5ec27af69$export$2e2bcd8739ae039), {
        value: zoom,
        min: 1,
        max: 3,
        step: 0.1,
        "aria-labelledby": "Zoom",
        onChange: (e, zoom)=>setZoom(zoom),
        style: {
            '& .MuiSlider-thumb': {
                transform: 'translate(-50%, -50%)'
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-1 mt-6",
        component: "label",
        size: "small",
        variant: "contained",
        tabIndex: -1,
        disabled: isImageLoading,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        },
        // startIcon={<EditNoteOutlinedIcon />}
        onClick: showCroppedImage
    }, "Save"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-1 mt-2",
        component: "label",
        size: "small",
        // color="error"
        variant: "outlined",
        tabIndex: -1,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 0,
            paddingLeft: 0
        },
        startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e26e82c1baede67b$exports))), null),
        onClick: ()=>{
            setZoom(1);
            setRotation(0);
            setAspectRatio(1);
            setFlipHorizontal(false);
            setFlipVertical(false);
        }
    }, "Revert to orignal")))));
};
var $7cc92e6826c09370$export$2e2bcd8739ae039 = $7cc92e6826c09370$var$ImageCropper;


const $162e110d4fb932a6$var$ImageUploader = (props)=>{
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const [showConfirmation, setShowConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const [showEdit, setShowEdit] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const [data, setData] = (0, $eeH7J.useState)([]);
    const [subsData, setSubsData] = (0, $eeH7J.useState)();
    const [selected, setSelected] = (0, $eeH7J.useState)();
    const [totalSize, setTotalSize] = (0, $eeH7J.useState)();
    const [currentPageImage, setCurrentPageImage] = (0, $eeH7J.useState)();
    // const [imageRefs, setImageRefs] = useState<any>([]);
    const [tab, setTab] = (0, $eeH7J.useState)("upload");
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_id"
    ]);
    const onDrop = (0, $eeH7J.useCallback)(async (acceptedFiles)=>{
        // Handle the files
        const fileNames = Array.from(acceptedFiles).map((file)=>file.name);
        const contentTypes = Array.from(acceptedFiles).map((file)=>file.type);
        const fileSizes = Array.from(acceptedFiles).map((file)=>file.size);
        if (contentTypes.length === 0) // console.log('file types', contentTypes)
        return;
        const response = await (0, $33a3fff7c402f495$export$2e2bcd8739ae039).get(`${(0, $40ac8f30f06b5caa$export$4d28219d42798a75)()}/${(0, $40ac8f30f06b5caa$export$c3ae438a4aaf614e)()}`, {
            params: {
                fileNames: fileNames,
                contentTypes: contentTypes,
                fileSizes: fileSizes,
                siteId: props.siteId
            }
        });
        const signedUrls = response.data;
        // console.log("signedUrls", signedUrls);
        setData((old)=>{
            let _old = [
                ...old
            ];
            signedUrls.map((rr)=>{
                _old.unshift({
                    ...rr,
                    isUploading: true,
                    ref: [],
                    refCount: 0,
                    created_at: Date.now()
                });
            });
            setSelected(_old[0]);
            // reCalculate(_old);
            return _old;
        });
        setTab("library");
        // Upload each file to S3 using the signed URLs
        signedUrls.map((signedUrl, index)=>{
            let _sizeInMegabytes = signedUrl.size / 1024 / 1024;
            // console.log("Uploading size", _sizeInMegabytes)
            let image_name = signedUrl.imageName;
            // Regex to check for special characters except - _ .
            let specialCharRegex = /[^a-zA-Z0-9._-]/;
            if (specialCharRegex.test(image_name)) {
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].hasError = true;
                    _old[idx].errorTitle = `Upload Upload Failed!`;
                    _old[idx].errorDescription = `Image name has special chars.`;
                    _old[idx].thumbnailUrl = ``;
                    return _old;
                });
                return;
            }
            if (_sizeInMegabytes > 200) {
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].hasError = true;
                    _old[idx].errorTitle = `Upload Size limit!`;
                    _old[idx].errorDescription = `Maximum upload limit is 200 MB.`;
                    _old[idx].thumbnailUrl = ``;
                    return _old;
                });
                return;
            }
            let _totalSize = totalSize + signedUrl.size;
            let _totalSizeLimit = 0;
            if (subsData?.storage?.indexOf("GB") >= 0) {
                let _ttt = subsData.storage.split("GB");
                _totalSizeLimit = _ttt[0] * 1073741824;
            } else if (subsData?.storage?.indexOf("MB") >= 0) {
                let _ttt = subsData.storage.split("MB");
                _totalSizeLimit = _ttt[0] * 1048576;
            }
            if (_totalSizeLimit < _totalSize) {
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].hasError = true;
                    _old[idx].errorTitle = `Storage alert!`;
                    _old[idx].errorDescription = `Upload limit reached. Please consider upgrading your plan.`;
                    _old[idx].thumbnailUrl = ``;
                    return _old;
                });
                console.log(`Uploading`, _totalSize, _totalSizeLimit);
                return;
            }
            (0, $33a3fff7c402f495$export$2e2bcd8739ae039).put(signedUrl.uploadURL, acceptedFiles[index], {
                headers: {
                    "Content-Type": acceptedFiles[index].type
                }
            }).then(async (res)=>{
                try {
                    delete signedUrl["uploadURL"];
                    await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/assets/add-site-assets`, {
                        userId: cookies.rp_user_id,
                        thumbnailsize: props.thumbnailsize,
                        data: [
                            signedUrl
                        ]
                    });
                } catch (err) {
                    console.log("after upload", err);
                }
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].thumbnailUrl = `${_old[idx].imageUrl}_thumbnail`;
                    reCalculate(_old);
                    return _old;
                });
            }).catch((err)=>{});
        });
    }, []);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $902654ddcf2304ad$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        accept: {
            "image/png": [],
            "image/jpeg": [],
            "image/jpg": [],
            "image/svg+xml": [],
            "image/webp": [],
            "image/gif": []
        }
    });
    const loadGalleryImages = async ()=>{
        try {
            setIsLoading(true);
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/assets/site-assets?siteId=${props.siteId}&userId=${cookies.rp_user_id}`);
            let _data = response.data;
            // let _data = imageData; //|| response.data
            // setSelected(_data.data[4]);
            // setShowEdit(true);
            reCalculate(_data.data);
            setData(_data.data);
            setSubsData({
                ..._data.subsDetails
            });
            let data = [];
            _data.data.map((image)=>{
                let _imagesRef = [];
                deepScanFindImageRef(_data.site.header, image.imageUrl, "header~header~Site Header", _imagesRef);
                deepScanFindImageRef(_data.site.footer, image.imageUrl, "footer~footer~Site Footer", _imagesRef);
                for(let iii = 0; iii < _data.pages.length; iii++)if (_data.pages[iii].pageId !== props.pageId) deepScanFindImageRef(_data.pages[iii].configs, image.imageUrl, `page~${_data.pages[iii].pageId}~${_data.pages[iii].pageName}`, _imagesRef);
                let jjj = 0;
                _imagesRef.forEach((lklk)=>jjj += lklk.count);
                data.push({
                    ...image,
                    ref: _imagesRef,
                    refCount: jjj
                });
            });
            // setImageRefs(_imagesRef)
            // console.log("sssss", data);
            setData(data);
        // setIsLoading(false);
        } catch (err) {
            console.error("loadGalleryImages", err);
        } finally{
            setIsLoading(false);
        }
    };
    const reCalculate = (data)=>{
        let _sum = 0;
        let _count = 0;
        data.forEach((rr)=>{
            _sum += rr.size;
            _count += 1;
        });
        setTotalSize(_sum);
    };
    function deepScanFindImageRef(element, imageUrl, type, _items) {
        if (Array.isArray(element)) // console.log("Array found:", element);
        for(let i = 0; i < element.length; i++)deepScanFindImageRef(element[i], imageUrl, type, _items);
        else if (typeof element === "object" && element !== null) {
            // console.log("Object found:", element);
            if (element.i && element.i.id === imageUrl) {
                let _ttt = type.split("~");
                let _index = _items.findIndex((kk)=>kk.imageUrl === imageUrl && kk.type === _ttt[0] && kk.name === _ttt[2]);
                if (_index !== -1) _items[_index].count += 1;
                else _items.push({
                    imageUrl: imageUrl,
                    type: _ttt[0],
                    id: _ttt[1],
                    name: _ttt[2],
                    count: 1
                });
            // element.i.id = newImageUrl;
            }
            for(let key in element)if (element.hasOwnProperty(key)) deepScanFindImageRef(element[key], imageUrl, type, _items);
        }
    }
    (0, $eeH7J.useEffect)(()=>{
        inIframe();
        loadGalleryImages();
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        if (selected) {
            // Function to handle the message event
            const handleMessage = (event)=>{
                const editorOrigin = "https://editorstage.rocketpages.io";
                if (editorOrigin && event.origin !== new URL(editorOrigin).origin) return;
                if (event.data.type === "imageCount") {
                    if (event.data.count > 0 && event.data.count !== undefined && event.data.count !== "") setCurrentPageImage({
                        id: event.data.id,
                        ref: "Current page",
                        refCount: event.data.count
                    });
                    else setCurrentPageImage({
                        id: ""
                    }); // Reset if no valid count
                }
            };
            // Post the message to the parent window
            parent.postMessage({
                msgType: "uploader:getCount",
                imgUrl: selected.imageUrl,
                id: selected.id
            }, "https://editorstage.rocketpages.io");
            // Add the event listener
            window.addEventListener("message", handleMessage);
            // Cleanup function to remove the event listener
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        }
    }, [
        selected
    ]);
    const formatSize = (sizeInBytes)=>{
        if (sizeInBytes < 1024) return `${sizeInBytes} Bytes`;
        else if (sizeInBytes < 1048576) return `${(sizeInBytes / 1024).toFixed(2)} KB`;
        else if (sizeInBytes < 1073741824) return `${(sizeInBytes / 1048576).toFixed(2)} MB`;
        else return `${(sizeInBytes / 1073741824).toFixed(2)} GB`;
    };
    const handleImageDelete = async ()=>{
        setShowConfirmation(false);
        setIsLoading(true);
        try {
            console.log("delete", selected);
            let data = {
                id: selected.id
            };
            if (selected.key) data["key"] = selected.key;
            else data["key"] = `${selected.id}-${selected.imageName}`;
            data["userId"] = cookies.rp_user_id;
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/assets/delete-site-asset`, data);
            // console.log("res", response);
            if (response.status === 200) {
                setData((old)=>{
                    let _old = [
                        ...old.filter((oo)=>oo.id !== selected.id)
                    ];
                    reCalculate(_old);
                    return _old;
                });
                setSelected(null);
            // loadGalleryImages();
            }
        } catch (err) {
            console.log(err);
        } finally{
            setIsLoading(false);
        }
    };
    const [isIniFrame, setIsInIFrame] = (0, $eeH7J.useState)();
    function inIframe() {
        try {
            setIsInIFrame(window.self !== window.top);
        // return window.self !== window.top;
        } catch (e) {
            setIsInIFrame(true);
        // return true;
        }
    }
    const onClose = ()=>{
        // console.log("onClose", isIniFrame);
        if (isIniFrame && !props.isBlog) {
            parent.postMessage({
                msgType: "uploader:close"
            }, "https://editorstage.rocketpages.io");
            return;
        } else props.onClose && props.onClose();
    };
    const onSelect = ()=>{
        // console.log("onSelect", isIniFrame);
        var image_upload_popup = checkIfButtonIsInIframe();
        if (isIniFrame && !props.isBlog && image_upload_popup === true) {
            parent.postMessage({
                msgType: "uploader:select",
                imgUrl: selected.imageUrl,
                siteId: props.siteId,
                eid: props.eid
            }, "https://editorstage.rocketpages.io");
            return;
        } else {
            props.onSelect && props.onSelect(selected.imageUrl);
            props.onChange && props.onChange(selected.imageUrl);
        }
    };
    function checkIfButtonIsInIframe() {
        return window.self.location.href.includes("image-uploder");
    }
    const showHistory = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, selected.ref && selected.ref.map((rr, idx)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                key: rr.id,
                className: "flex flex-row justify-between leading-relaxed "
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, rr.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
                className: "pr-2"
            }, `(${rr.count})`));
        }), currentPageImage && currentPageImage.id !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            key: currentPageImage.id,
            className: "flex flex-row justify-between leading-relaxed"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, "Current Page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
            className: "pr-2"
        }, `(${currentPageImage.refCount})`)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "h-full flex flex-col justify-between bg-white shadow-lg px-2 pt-2 pb-6 font-body image-upload"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), showConfirmation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-white rounded p-8 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, (selected.ref && selected.ref.length > 0 || currentPageImage && currentPageImage.id !== "") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "text-gray-800 mb-4 text-sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Images used on the following pages: ")), showHistory()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-gray-800 mb-4"
    }, "Are you sure you want to delete this image?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        className: "bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2 focus:outline-none focus:shadow-outline w-full sm:w-auto mb-2.5 sm:mb-0",
        onClick: ()=>setShowConfirmation(false)
    }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: handleImageDelete
    }, "Delete")))), selected && showEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col flex-1 justify-center h-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "text-sm font-medium text-center text-gray-500  border-gray-200 dark:text-gray-400 dark:border-gray-700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-wrap -mb-px md:mt-0 mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `hover:cursor-pointer text-catelina-blue text-sm`,
        onClick: ()=>setShowEdit(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($697efec4692ba881$exports))), {
        sx: {
            fontSize: 18
        }
    }), "Back"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-row justify-between flex-1 items-center relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "absolute flex flex-row justify-between top-0 right-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": "close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48be597dabffb880$exports))), {
        fontSize: "inherit"
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7cc92e6826c09370$export$2e2bcd8739ae039), {
        imageSrc: selected.imageUrl,
        imageName: selected.imageName,
        onClose: ()=>{
            setShowEdit(false);
        },
        onSave: (img)=>{
            setShowEdit(false);
            const originalName = selected.imageName;
            const extension = originalName.substring(originalName.lastIndexOf('.'));
            const baseName = originalName.substring(0, originalName.lastIndexOf('.'));
            const file = new File([
                img
            ], `${baseName}-${Date.now()}${extension}`, {
                type: img.type
            });
            onDrop([
                file
            ]);
        }
    })), !showEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `flex flex-col mb-2`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "text-sm font-medium text-center text-gray-500  border-gray-200 dark:text-gray-400 dark:border-gray-700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-wrap -mb-px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `inline-block px-4 py-1 ${tab === "upload" ? "text-catelina-blue border-b-2 border-catelina-blue active rounded-t-lg  dark:text-catelina-blue dark:border-catelina-blue" : "border-b-2 border-gray-300 rounded-t-lg hover:text-gray-600 hover:border-gray-400 dark:hover:text-gray-300"}  hover:cursor-pointer`,
        onClick: ()=>setTab("upload")
    }, "Upload files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `inline-block px-4 py-1 ${tab === "library" ? "text-catelina-blue border-b-2 border-catelina-blue active rounded-t-lg  dark:text-catelina-blue dark:border-catelina-blue" : "border-b-2 border-gray-300 rounded-t-lg hover:text-gray-600 hover:border-gray-400 dark:hover:text-gray-300"} hover:cursor-pointer`,
        onClick: ()=>setTab("library")
    }, "Media library"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-row justify-between flex-1 items-center relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "absolute flex flex-row justify-between top-2 right-2"
    }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "px-4 text-xxsm font-semibold text-catelina-blue hidden sm:block"
    }, formatSize(totalSize), " /", " ", subsData?.storage?.replace("GB", " GB")?.replace("MB", " MB"), props.thumbnailsize ? `Thumbnail size: ${props.thumbnailsize} px` : ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": "close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48be597dabffb880$exports))), {
        fontSize: "inherit"
    }))))))), !showEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col flex-1 h-[calc(100%-32px)] image-library"
    }, tab === "library" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, data && data.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-row justify-center relative md:h-full h-[calc(100%-40px)]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full overflow-auto h-full "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 mb-4 p-2"
    }, data && data.map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            key: _.id,
            className: `w-full relative max-h-36 lg:max-h-24 bg-gray-200 hover:cursor-pointer border ${selected && _.id === selected.id ? "ring-offset-2 ring-4 ring-catelina-blue" : ""} `,
            onClick: ()=>{
                // console.log("selected", _);
                setSelected(_);
            }
        }, _.isUploading && _.isUploading === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                padding: "16px",
                justifyContent: "center"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null)) : // <img
        //   src={_.imageUrl}
        //   alt={_.imageName}
        //   className="inset-0 w-full h-full object-cover"
        // />
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1e3f3a9d43e19420$exports.LazyLoadImage), {
            src: _.thumbnailUrl || _.imageUrl,
            alt: _.imageName,
            // effect="blur"
            wrapperProps: {
                // If you need to, you can tweak the effect transition using the wrapper style.
                style: {
                    transitionDelay: "1s"
                }
            },
            className: "inset-0 w-full h-full object-cover"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex md:hidden flex-col mx-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "w-full my-2",
        component: "label",
        size: "small",
        disabled: !selected || selected.isUploading || selected.hasError,
        role: undefined,
        variant: "contained",
        onClick: onSelect,
        tabIndex: -1,
        sx: {
            textTransform: "none",
            paddingRight: 4,
            paddingLeft: 4
        }
    }, "Use media"))), selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col justify-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `w-48 h-[90%] md:h-[100%] md:mx-2 bg-[#FAFAFA] px-2 border border-light-purple rounded-lg border-dashed absolute inset-y-0 left-0 top-0 md:static md:w-64 transform transition-transform duration-300 ease-in-out text-base text-catelina-blue flex flex-col overflow-auto md:shadow-none shadow-lg shadow-gray-300`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "absolute flex flex-row justify-between top-0 right-2 md:hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": "close",
        onClick: ()=>setSelected(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48be597dabffb880$exports))), {
        fontSize: "inherit"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "font-bold text-xsm text-catelina-blue"
    }, "Media details"), selected.hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("svg", {
        className: "flex-shrink-0 inline w-4 h-4 me-3",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("path", {
        d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "sr-only"
    }, "Info"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "font-medium"
    }, selected.errorTitle, " "), selected.errorDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "border-2 max-h-48 w-full bg-grey-300 flex justify-center blank-image-bg"
    }, selected.isUploading && selected.isUploading === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            padding: "16px",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1e3f3a9d43e19420$exports.LazyLoadImage), {
        src: selected.thumbnailUrl || selected.imageUrl,
        alt: selected.imageName,
        className: "inset-0  object-cover max-h-40",
        // effect="blur"
        wrapperProps: {
            // If you need to, you can tweak the effect transition using the wrapper style.
            style: {
                transitionDelay: "1s"
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-xsm leading-normal md:text-sm pt-2 w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "break-words mb-2"
    }, selected.imageName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-xxsm leading-normal md:text-xsm"
    }, formatSize(selected.size)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-xxsm leading-normal md:text-xsm flex flex-row justify-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($1V8au)))(selected.created_at).format("MMMM, DD YYYY")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($1V8au)))(selected.created_at).format("HH:mm"))), !selected.hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "md:mx-4 flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-2 mt-6",
        component: "label",
        size: "small",
        variant: "contained",
        tabIndex: -1,
        disabled: selected.isUploading,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        },
        startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3aeb16233e51b8e7$exports))), null),
        onClick: ()=>{
            setShowEdit(true);
        // console.log(selected);
        }
    }, "Edit image"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-2 mt-2",
        component: "label",
        size: "small",
        color: "error",
        variant: "outlined",
        disabled: selected.isUploading,
        tabIndex: -1,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        },
        startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eec45c1bd37e4a90$exports))), null),
        onClick: ()=>setShowConfirmation(true)
    }, "Delete image")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-xxsm leading-normal md:text-xsm mb-4 mt-2"
    }, selected.refCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-catelina-blue font-bold leading-normal "
    }, "Image history ", "(", selected.refCount, ")", " ") : null, showHistory())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "md:flex hidden flex-col mx-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "w-full my-2",
        component: "label",
        size: "small",
        disabled: !selected || selected.isUploading || selected.hasError,
        role: undefined,
        variant: "contained",
        onClick: onSelect,
        tabIndex: -1,
        sx: {
            textTransform: "none",
            paddingRight: 4,
            paddingLeft: 4
        }
    }, "Use media")))), !data || data.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-center h-full items-center border rounded-lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75fad4645059238f$exports))), {
        fontSize: "large"
    }))), tab === "upload" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-row justify-center h-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        ...getRootProps(),
        className: `flex items-center justify-center w-full h-full border-2 border-dotted border-gray-300 rounded-lg p-4 ${isDragActive ? "bg-gray-100" : "bg-[#FAFAFA]"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", getInputProps()), isDragActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-gray-500"
    }, "Drop the files here ...") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col items-center  justify-center text-lg text-catelina-blue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "font-bold"
    }, "Drag & Drop files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "font-bold"
    }, "Or"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-2 mt-2 mb-4",
        component: "label",
        size: "small",
        variant: "contained",
        tabIndex: -1,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        }
    }, "Choose a local file"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-xsm"
    }, "Maximum upload file size: 200mb"))))));
};
var $162e110d4fb932a6$export$2e2bcd8739ae039 = $162e110d4fb932a6$var$ImageUploader;


const $6caf9b45167927de$var$ImageUploaderPage = ()=>{
    const [searchParams] = (0, $42e24d1152893e59$export$f1a78c17382fe22a)();
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-center justify-center min-h-screen bg-slate-400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full h-screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $162e110d4fb932a6$export$2e2bcd8739ae039), {
        siteId: getQueryParam("siteId"),
        eid: getQueryParam("eid"),
        thumbnailsize: getQueryParam("thumbnailsize"),
        pageId: getQueryParam("pageId")
    })));
};
var $6caf9b45167927de$export$2e2bcd8739ae039 = $6caf9b45167927de$var$ImageUploaderPage;



var $eeH7J = parcelRequire("eeH7J");






var $eeH7J = parcelRequire("eeH7J");
function $0964ed3e14b7bf9e$var$useLoadGsiScript(options = {}) {
    const { nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0, $eeH7J.useState)(false);
    const onScriptLoadSuccessRef = (0, $eeH7J.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0, $eeH7J.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0, $eeH7J.useEffect)(()=>{
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = ()=>{
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 || _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = ()=>{
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 || _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return ()=>{
            document.body.removeChild(scriptTag);
        };
    }, [
        nonce
    ]);
    return scriptLoadedSuccessfully;
}
const $0964ed3e14b7bf9e$var$GoogleOAuthContext = (0, $eeH7J.createContext)(null);
function $0964ed3e14b7bf9e$export$a325976a38f291f5({ clientId: clientId, nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError, children: children }) {
    const scriptLoadedSuccessfully = $0964ed3e14b7bf9e$var$useLoadGsiScript({
        nonce: nonce,
        onScriptLoadSuccess: onScriptLoadSuccess,
        onScriptLoadError: onScriptLoadError
    });
    const contextValue = (0, $eeH7J.useMemo)(()=>({
            clientId: clientId,
            scriptLoadedSuccessfully: scriptLoadedSuccessfully
        }), [
        clientId,
        scriptLoadedSuccessfully
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0964ed3e14b7bf9e$var$GoogleOAuthContext.Provider, {
        value: contextValue
    }, children);
}
function $0964ed3e14b7bf9e$var$useGoogleOAuth() {
    const context = (0, $eeH7J.useContext)($0964ed3e14b7bf9e$var$GoogleOAuthContext);
    if (!context) throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    return context;
}
function $0964ed3e14b7bf9e$var$extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}
const $0964ed3e14b7bf9e$var$containerHeightMap = {
    large: 40,
    medium: 32,
    small: 20
};
function $0964ed3e14b7bf9e$export$a795a627e512102a({ onSuccess: onSuccess, onError: onError, useOneTap: useOneTap, promptMomentNotification: promptMomentNotification, type: type = 'standard', theme: theme = 'outline', size: size = 'large', text: text, shape: shape, logo_alignment: logo_alignment, width: width, locale: locale, click_listener: click_listener, containerProps: containerProps, ...props }) {
    const btnContainerRef = (0, $eeH7J.useRef)(null);
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $0964ed3e14b7bf9e$var$useGoogleOAuth();
    const onSuccessRef = (0, $eeH7J.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $eeH7J.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $eeH7J.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $0964ed3e14b7bf9e$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            ...props
        });
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.renderButton(btnContainerRef.current, {
            type: type,
            theme: theme,
            size: size,
            text: text,
            shape: shape,
            logo_alignment: logo_alignment,
            width: width,
            locale: locale,
            click_listener: click_listener
        });
        if (useOneTap) (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            if (useOneTap) (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        ...containerProps,
        ref: btnContainerRef,
        style: {
            height: $0964ed3e14b7bf9e$var$containerHeightMap[size],
            ...containerProps === null || containerProps === void 0 ? void 0 : containerProps.style
        }
    });
}
function $0964ed3e14b7bf9e$export$64c51800d55c1202() {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.disableAutoSelect();
}
/* eslint-disable import/export */ function $0964ed3e14b7bf9e$export$6ca4c5d94f9e170b({ flow: flow = 'implicit', scope: scope = '', onSuccess: onSuccess, onError: onError, onNonOAuthError: onNonOAuthError, overrideScope: overrideScope, state: state, ...props }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $0964ed3e14b7bf9e$var$useGoogleOAuth();
    const clientRef = (0, $eeH7J.useRef)();
    const onSuccessRef = (0, $eeH7J.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $eeH7J.useRef)(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = (0, $eeH7J.useRef)(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (!scriptLoadedSuccessfully) return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response)=>{
                var _a, _b;
                if (response.error) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 || _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError)=>{
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 || _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state: state,
            ...props
        });
        clientRef.current = client;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        flow,
        scope,
        state
    ]);
    const loginImplicitFlow = (0, $eeH7J.useCallback)((overrideConfig)=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig);
    }, []);
    const loginAuthCodeFlow = (0, $eeH7J.useCallback)(()=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode();
    }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}
function $0964ed3e14b7bf9e$export$7ab2d3f76b55c251({ onSuccess: onSuccess, onError: onError, promptMomentNotification: promptMomentNotification, cancel_on_tap_outside: cancel_on_tap_outside, prompt_parent_id: prompt_parent_id, state_cookie_domain: state_cookie_domain, hosted_domain: hosted_domain, disabled: disabled }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $0964ed3e14b7bf9e$var$useGoogleOAuth();
    const onSuccessRef = (0, $eeH7J.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $eeH7J.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $eeH7J.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        if (disabled) {
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
            return;
        }
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $0964ed3e14b7bf9e$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            hosted_domain: hosted_domain,
            cancel_on_tap_outside: cancel_on_tap_outside,
            prompt_parent_id: prompt_parent_id,
            state_cookie_domain: state_cookie_domain
        });
        (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        prompt_parent_id,
        state_cookie_domain,
        hosted_domain,
        disabled
    ]);
}
/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */ function $0964ed3e14b7bf9e$export$dfe7cd07eac17bc5(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes)) || false;
}
/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */ function $0964ed3e14b7bf9e$export$3413c85423c3f1d0(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes)) || false;
}



var $eeH7J = parcelRequire("eeH7J");


var $eeH7J = parcelRequire("eeH7J");

var $dRzna = parcelRequire("dRzna");
const $5e832946007203dd$var$a = `linkedin_oauth2_state`;
function $5e832946007203dd$var$o(e = 32) {
    let t = new Uint8Array(e);
    window.crypto.getRandomValues(t);
    let n = ``;
    for(let e = 0; e < t.length; e += 1){
        let r = t[e].toString(16);
        n += r.length === 1 ? `0${r}` : r;
    }
    return n;
}
function $5e832946007203dd$var$s({ clientId: e, redirectUri: t, scope: n, state: r }) {
    let i = new URL(`https://www.linkedin.com/oauth/v2/authorization`);
    return i.searchParams.set(`response_type`, `code`), i.searchParams.set(`client_id`, e), i.searchParams.set(`redirect_uri`, t), i.searchParams.set(`scope`, n), i.searchParams.set(`state`, r), i.toString();
}
function $5e832946007203dd$var$c(e) {
    let t = {};
    return new URLSearchParams(e.charAt(0) === `?` ? e.substring(1) : e).forEach((e, n)=>{
        t[n] = e;
    }), t;
}
const $5e832946007203dd$var$l = [
    `r_emailaddress`,
    `r_liteprofile`
];
let $5e832946007203dd$var$u = !1;
const $5e832946007203dd$var$d = ({ width: e = 600, height: t = 600 })=>`left=${screen.width / 2 - e / 2},top=${screen.height / 2 - t / 2},width=${e},height=${t}`, $5e832946007203dd$var$f = (e)=>{
    let t = e.split(/\s+/);
    $5e832946007203dd$var$l.some((e)=>t.includes(e)) && !$5e832946007203dd$var$u && (console.warn(`[react-linkedin-login-oauth2] LinkedIn deprecated the legacy Sign In with LinkedIn flow on August 1, 2023. Legacy scopes remain supported by this 2.x release for existing applications. Plan to migrate to Sign In with LinkedIn using OpenID Connect.`), $5e832946007203dd$var$u = !0);
};
function $5e832946007203dd$export$798996ac402ec5d0({ redirectUri: r, clientId: i, onSuccess: c, onError: l, scope: u = `r_emailaddress`, state: p = ``, closePopupMessage: m = `User closed the popup`, popupWidth: h = 600, popupHeight: g = 600 }) {
    let _ = (0, $eeH7J.useRef)(null), v = (0, $eeH7J.useRef)(null), y = (0, $eeH7J.useCallback)(()=>{
        v.current && (window.clearInterval(v.current), v.current = null);
    }, []), b = (0, $eeH7J.useCallback)(()=>{
        y();
        try {
            localStorage.removeItem($5e832946007203dd$var$a);
        } catch (e) {}
        _.current && (_.current.close(), _.current = null);
    }, [
        y
    ]), x = (0, $eeH7J.useCallback)((e)=>{
        if (e.origin !== window.location.origin || e.source !== _.current || !e.data || e.data.from !== `Linked In`) return;
        let t = localStorage.getItem($5e832946007203dd$var$a);
        if (!t || e.data.state !== t) {
            b(), l && l({
                error: `state_mismatch`,
                errorMessage: `State does not match`
            });
            return;
        }
        if (e.data.error) b(), l && l(e.data);
        else if (e.data.code) {
            let t = e.data.code;
            b(), c(t);
        }
    }, [
        b,
        l,
        c
    ]);
    (0, $eeH7J.useEffect)(()=>()=>{
            b();
        }, [
        b
    ]), (0, $eeH7J.useEffect)(()=>(window.addEventListener(`message`, x, !1), ()=>{
            window.removeEventListener(`message`, x, !1);
        }), [
        x
    ]);
    let S = ()=>{
        $5e832946007203dd$var$f(u);
        let e = p || $5e832946007203dd$var$o();
        return localStorage.setItem($5e832946007203dd$var$a, e), $5e832946007203dd$var$s({
            clientId: i,
            redirectUri: r,
            scope: u,
            state: e
        });
    };
    return {
        linkedInLogin: ()=>{
            b();
            let e;
            try {
                e = S();
            } catch (e) {
                b(), l && l({
                    error: `authorization_request_failed`,
                    errorMessage: e instanceof Error ? e.message : `Unable to create the LinkedIn authorization request`
                });
                return;
            }
            try {
                _.current = window.open(e, `_blank`, $5e832946007203dd$var$d({
                    width: h,
                    height: g
                }));
            } catch (e) {
                b(), l && l({
                    error: `popup_open_failed`,
                    errorMessage: e instanceof Error ? e.message : `Unable to open the LinkedIn login popup`
                });
                return;
            }
            if (!_.current) {
                b(), l && l({
                    error: `popup_blocked`,
                    errorMessage: `The LinkedIn login popup was blocked`
                });
                return;
            }
            v.current = window.setInterval(()=>{
                try {
                    _.current && _.current.closed && (b(), l && l({
                        error: `user_closed_popup`,
                        errorMessage: m
                    }));
                } catch (e) {
                    b(), l && l({
                        error: `popup_status_check_failed`,
                        errorMessage: e instanceof Error ? e.message : `Unable to check the LinkedIn login popup status`
                    });
                }
            }, 1e3);
        }
    };
}
function $5e832946007203dd$export$60f7169f5ee875bc({ children: e, redirectUri: t, clientId: n, onSuccess: r, onError: i, state: a, scope: o, closePopupMessage: s, popupWidth: c, popupHeight: l }) {
    let { linkedInLogin: u } = $5e832946007203dd$export$798996ac402ec5d0({
        redirectUri: t,
        clientId: n,
        onSuccess: r,
        onError: i,
        state: a,
        scope: o,
        closePopupMessage: s,
        popupWidth: c,
        popupHeight: l
    });
    return e({
        linkedInLogin: u
    });
}
function $5e832946007203dd$export$4eba75a127a285cf() {
    let [e, n] = (0, $eeH7J.useState)(``);
    return (0, $eeH7J.useEffect)(()=>{
        let e = $5e832946007203dd$var$c(window.location.search), t = localStorage.getItem($5e832946007203dd$var$a), r = (e)=>window.opener ? (window.opener.postMessage(e, window.location.origin), window.close(), !0) : (n(`Unable to complete login because the original window is unavailable.`), !1);
        if (!t || e.state !== t) {
            let e = `State does not match`;
            n(e), r({
                error: `state_mismatch`,
                state: t,
                errorMessage: e,
                from: `Linked In`
            });
        } else if (e.error) {
            let t = e.error_description || `Login failed. Please try again.`;
            n(t), r({
                error: e.error,
                state: e.state,
                errorMessage: t,
                from: `Linked In`
            });
        } else if (e.code) r({
            code: e.code,
            state: e.state,
            from: `Linked In`
        });
        else {
            let e = `LinkedIn did not return an authorization code.`;
            n(e), r({
                error: `invalid_response`,
                state: t,
                errorMessage: e,
                from: `Linked In`
            });
        }
    }, []), (0, $dRzna.jsx)(`div`, {
        children: e
    });
}







var $a9a8f55969fffb7a$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($a9a8f55969fffb7a$exports, "__esModule", {
    value: true
});
$a9a8f55969fffb7a$exports.default = void 0;

var $a9a8f55969fffb7a$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $a9a8f55969fffb7a$var$_default = $a9a8f55969fffb7a$exports.default = (0, $a9a8f55969fffb7a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');





var $8174d76e71ef3130$exports = {};
$8174d76e71ef3130$exports = new URL("eye-open.4ceb8078.svg", import.meta.url).toString();


var $1f00f2e4814332a8$exports = {};
$1f00f2e4814332a8$exports = new URL("eye-closed.6711f686.svg", import.meta.url).toString();




function $fa67dd48d657d168$var$useQuery() {
    const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useMemo(()=>new URLSearchParams(search), [
        search
    ]);
}
function $fa67dd48d657d168$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
function $fa67dd48d657d168$var$isSafeRedirectUrl(url) {
    if (!url) return false;
    if (url.startsWith("/")) return true;
    try {
        const parsed = new URL(url);
        const allowedOrigins = [
            window.location.origin,
            "https://editorstage.rocketpages.io",
            "https://apistage.rocketpages.io"
        ].filter(Boolean);
        return allowedOrigins.some((origin)=>{
            try {
                return new URL(origin).origin === parsed.origin;
            } catch  {
                return false;
            }
        });
    } catch  {
        return false;
    }
}
const $fa67dd48d657d168$var$MAX_EMAIL_LENGTH = 254;





const $fa67dd48d657d168$var$Login = (props)=>{
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const isInIframe = $fa67dd48d657d168$var$checkIsInFrame();
    const [errorMessage, setErrorMessage] = (0, $eeH7J.useState)("");
    const [errorMessageSocial, setErrorMessageSocial] = (0, $eeH7J.useState)("");
    const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    let query = $fa67dd48d657d168$var$useQuery();
    let l_redirecturl = query.get("redirecturl");
    const l_userIdFromQuery = query.get("userId");
    const l_siteIdFromQuery = query.get("siteId");
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const { userId: userId, siteId: siteId } = location.state || {};
    // Use either query or state data based on preference
    const l_userId = l_userIdFromQuery || userId;
    const l_siteId = l_siteIdFromQuery || siteId;
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const [cookies, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_access_token",
        "rp_refresh_token"
    ]);
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const { linkedInLogin: linkedInLogin } = (0, $5e832946007203dd$export$798996ac402ec5d0)({
        clientId: "86q0502we7bi54",
        scope: "email profile openid",
        redirectUri: "https://appstage.rocketpages.io/linkedin",
        onSuccess: (code)=>{
            onLoginViaLinkedIn(code);
        },
        onError: (error)=>{
            console.log(error);
        }
    });
    const googleLogin = (0, $0964ed3e14b7bf9e$export$6ca4c5d94f9e170b)({
        onSuccess: (tokenResponse)=>{
            onLoginViaGoogle(tokenResponse);
        },
        onError: ()=>{
            console.log("Login Failed");
        }
    });
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        email: "",
        password: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        email: "",
        password: ""
    });
    function isValidEmail(email) {
        // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    function validateForm(formData) {
        try {
            // console.log("formData", formData);
            setFormErrors({
                email: "",
                password: ""
            });
            if (formData.email === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Email can not be empty."
                    };
                });
                return false;
            }
            if (formData.email.length > $fa67dd48d657d168$var$MAX_EMAIL_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: `Email cannot exceed ${$fa67dd48d657d168$var$MAX_EMAIL_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (!isValidEmail(formData.email)) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Invalid email address."
                    };
                });
                return false;
            }
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "Password is empty."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onLogin(e) {
        e.preventDefault();
        if (!validateForm(formData)) return;
        setIsLoading(true);
        try {
            let data = {
                email: formData.email,
                password: formData.password,
                rp_site_id: l_siteId,
                rp_user_id: l_userId
            };
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/login", data);
            setIsLoading(false);
            // send reload message to parent
            if (isInIframe) {
                parent.postMessage("auth:reload", "https://editorstage.rocketpages.io");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = $fa67dd48d657d168$var$isSafeRedirectUrl(l_redirecturl) ? l_redirecturl : "/dashboard";
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err.response.data.message);
        }
    }
    async function onLoginViaGoogle(googleCred) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "google",
                token: googleCred.credential,
                accessToken: googleCred.access_token,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/signup", data, {
                withCredentials: true
            });
            // console.log("on login", res);
            setIsLoading(false);
            // console.log('rp_site_id', cookies.rp_page_id)
            if (isInIframe) {
                parent.postMessage("auth:reload", "https://editorstage.rocketpages.io");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = $fa67dd48d657d168$var$isSafeRedirectUrl(l_redirecturl) ? l_redirecturl : "/dashboard";
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    async function onLoginViaLinkedIn(authCode) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "linkedIn",
                authCode: authCode,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "https://editorstage.rocketpages.io");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = $fa67dd48d657d168$var$isSafeRedirectUrl(l_redirecturl) ? l_redirecturl : "/dashboard";
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setErrorMessage("");
        setErrorMessageSocial("");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginPage}`
    }, isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading,
        invisible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "info"
    })), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a1776588e7982209$export$8b251419efc915eb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).contentContaienr} login-section flex justify-start`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).content} md:flex md:flex-col max-w-full ${isInIframe ? (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).nopadding : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).formContainer}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginHeading} mt-1 md:mt-8 lg:mt-16 mb-8`
    }, "Log into RocketPages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginForm}`,
        onSubmit: onLogin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "email"
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        type: "email",
        id: "email",
        placeholder: "Enter email address",
        value: formData.email,
        onChange: handleChange,
        className: `${formErrors.email !== "" ? "border-red-500" : ""}`
    }), formErrors.email !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.email)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "password"
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
        type: showPassword ? "text" : "password",
        id: "password",
        placeholder: "Enter password",
        value: formData.password,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showPassword ? "hide the password" : "display the password",
            onClick: handleClickShowPassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showPassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1f00f2e4814332a8$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8174d76e71ef3130$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.password !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.password)), errorMessage !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "flex text-center mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a8f55969fffb7a$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabelForm} `
    }, errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        type: "submit",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginBtn}`
    }, "Login")), isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: {
            pathname: "/forgot-password",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        },
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).normalLink} inline-block my-1 text-[16px] font-semibold`
    }, "Forgot password?") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "/forgot-password",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).normalLink} inline-block my-1 text-[16px] font-semibold`
    }, "Forgot password?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperator} flex items-center pt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperatorLine}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperatorText}`
    }, "Or Login with", " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperatorLine}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).socialSection} flex justify-center gap-8`
    }, isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).googleIcon,
        onClick: ()=>googleLogin()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("7OJZE")),
        alt: "Google",
        style: {
            width: 32,
            height: 32
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).googleIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("7OJZE")),
        alt: "Google",
        style: {
            width: 32,
            height: 32,
            pointerEvents: "none"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).googleIframeOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $0964ed3e14b7bf9e$export$a795a627e512102a), {
        onSuccess: async (credentialResponse)=>{
            onLoginViaGoogle(credentialResponse);
        },
        onError: ()=>{
            console.log("Login Failed");
        },
        type: "icon"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).socialIcons}`,
        onClick: linkedInLogin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("bL04G"))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-center py-2"
    }, errorMessageSocial !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "flex text-center mb-2 items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a8f55969fffb7a$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabelForm} `
    }, errorMessageSocial))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            justifyContent: "center",
            display: {
                xs: "flex",
                lg: "none"
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).dontHaveAccount} font-normal mr-1`
    }, "Don't have an account?"), isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: {
            pathname: "/signup",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        },
        className: "text-sm text-[#243460] font-semibold"
    }, "Signup") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: `/signup${search}`,
        className: "text-sm text-[#243460] font-semibold"
    }, "Signup"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).dontHaveAccount} font-normal ml-1`
    }, "for free!")))))), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};
var $fa67dd48d657d168$export$2e2bcd8739ae039 = $fa67dd48d657d168$var$Login;



const $b6e6fe27e9740546$export$f14c0e3f98d164c0 = (props)=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const [cookie, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    (0, $eeH7J.useEffect)(()=>{
        // console.log('env API_ENDPOINT', process.env.API_ENDPOINT)
        // console.log('env LINKEDIN_CLIENT_ID', process.env.LINKEDIN_CLIENT_ID)
        // console.log('env LINKEDIN_REDIRECT_URI', process.env.LINKEDIN_REDIRECT_URI)
        // console.log('env GOOGLE_CLEINT_ID', process.env.GOOGLE_CLEINT_ID)
        // console.log('env STRIPE_KEY', process.env.STRIPE_KEY)
        if (location.state && location.state.removeCookies) removeCookie("rp_user_data");
        else if (cookie.rp_user_data) navigate("/dashboard");
    // console.log('LoginPage -> props.removeCookies',location.state)
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Login"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement((0, $fa67dd48d657d168$export$2e2bcd8739ae039), null));
};


var $493e8c9724a450f6$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($493e8c9724a450f6$exports, "__esModule", {
    value: true
});
$493e8c9724a450f6$exports.default = void 0;

var $493e8c9724a450f6$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $493e8c9724a450f6$var$_default = $493e8c9724a450f6$exports.default = (0, $493e8c9724a450f6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');





var $42055956c96f1824$var$V3_URL = 'https://js.stripe.com/v3';
var $42055956c96f1824$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $42055956c96f1824$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $42055956c96f1824$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($42055956c96f1824$var$V3_URL, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$42055956c96f1824$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $42055956c96f1824$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($42055956c96f1824$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $42055956c96f1824$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "1.54.2",
        startTime: startTime
    });
};
var $42055956c96f1824$var$stripePromise = null;
var $42055956c96f1824$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($42055956c96f1824$var$stripePromise !== null) return $42055956c96f1824$var$stripePromise;
    $42055956c96f1824$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($42055956c96f1824$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $42055956c96f1824$var$findScript();
            if (script && params) console.warn($42055956c96f1824$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $42055956c96f1824$var$injectScript(params);
            script.addEventListener('load', function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error('Stripe.js not available'));
            });
            script.addEventListener('error', function() {
                reject(new Error('Failed to load Stripe.js'));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $42055956c96f1824$var$stripePromise;
};
var $42055956c96f1824$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $42055956c96f1824$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $42055956c96f1824$var$stripePromise$1 = Promise.resolve().then(function() {
    return $42055956c96f1824$var$loadScript(null);
});
var $42055956c96f1824$var$loadCalled = false;
$42055956c96f1824$var$stripePromise$1["catch"](function(err) {
    if (!$42055956c96f1824$var$loadCalled) console.warn(err);
});
var $42055956c96f1824$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $42055956c96f1824$var$loadCalled = true;
    var startTime = Date.now();
    return $42055956c96f1824$var$stripePromise$1.then(function(maybeStripe) {
        return $42055956c96f1824$var$initStripe(maybeStripe, args, startTime);
    });
};





var $eeH7J = parcelRequire("eeH7J");




const $3d9d6900c354ceba$var$stripePromise = (0, $42055956c96f1824$export$de80f7562c3fd6b1)("pk_test_51NY0p7H46TpgZNWbmag72Jg49hDMFFwx2nzIo2302UWypkQ6DRHL8G8sqLElnyvgtxvIU1JolosEIv9YliAaRoQy00lQJMGEeW");

const $3d9d6900c354ceba$export$d1fd69b62921db79 = ()=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const { siteId: siteId } = (0, $0d4e57672a3dc010$export$99eaa27ddbbb95ef)();
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    // const [data, setData] = useState();
    const [subsRes, setSubsRes] = (0, $eeH7J.useState)(null);
    const search = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)().search;
    const session_id = new URLSearchParams(search).get("session_id");
    $eeH7J.useEffect(()=>{
        async function fetchData() {
            setIsLoading(true);
            try {
                let config = {
                    method: "get",
                    url: `${"https://apistage.rocketpages.io"}/api/configs/stripe-subscription-from-session?sessionId=${session_id}`,
                    withCredentials: true
                };
                let res = await (0, $33a3fff7c402f495$export$2e2bcd8739ae039).request(config);
                // console.log("kk", res.data);
                if (!res.data.subscription && res.data.error) {
                    enqueueSnackbar(res.data.error, {
                        variant: "error",
                        className: "bg-catelina-blue"
                    });
                    setIsLoading(false);
                    return;
                }
                setSubsRes(res.data.subscription);
                // setData(rs.data);
                setIsLoading(false);
            } catch (err) {
                console.log(err);
                setIsLoading(false);
            }
        // console.log("session_id", session_id);
        // window.location.href = res.data.sessionUrl
        }
        // setIsLoading(true);
        fetchData();
    // setIsLoading(false);
    }, []);
    // Function to convert timestamp to month/date/year format
    function timestampToDateString(timestamp) {
        // Create a new Date object using the timestamp
        const date = new Date(timestamp);
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        // Get the individual components (month, day, year)
        const month = monthNames[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        // Create the formatted string
        const formattedDate = `${month} ${day}, ${year}`;
        return formattedDate;
    }
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Dashboard"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), null), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-[#FAFAFA] absolute top-[64px] w-full h-screen"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: " max-w-2xl bg-white my-12 m-auto rounded-lg px-2 md:px-16 py-6"
    }, subsRes && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-grey-primary"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col justify-center text-xl font-semibold mb-10 text-center md:mx-20 items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "mb-4",
        src: (parcelRequire("20V3y")),
        width: 64,
        alt: ""
    }), "You\u2019ve successfully subscribed to the", " ", subsRes.plan_desc && subsRes.plan_desc.replace("Rocket Pages IO", ""), "!"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base"
    }, "Subscription ID"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-sm"
    }, subsRes.subscription ?? subsRes.subscriptionId)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base"
    }, "Plan Desc"), " ", /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-sm"
    }, subsRes.plan_desc)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base"
    }, "Subscription Start"), " ", /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-sm"
    }, timestampToDateString(subsRes.subscription_start * 1000))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base"
    }, "Subscription End"), " ", /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-sm"
    }, timestampToDateString(subsRes.subscription_end * 1000))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-between my-2"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base"
    }, "Invoice URL ", /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($493e8c9724a450f6$exports))), {
        onClick: ()=>{
            navigator.clipboard.writeText(subsRes.invoice_url);
            enqueueSnackbar("Invoice url copied", {
                variant: "info",
                className: "bg-catelina-blue"
            });
        },
        className: "mx-2 cursor-pointer",
        sx: {
            color: "#243060",
            fontSize: "16px"
        }
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>navigate(`/site-settings/${siteId}?section=General`),
        className: "ml-2"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "lg:block"
    }, "Site Dashboard")), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            window.location.href = `${"https://editorstage.rocketpages.io"}/${siteId}`;
        // window.location.reload();
        },
        className: "ml-2"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "lg:block"
    }, "Edit site"))))))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");








const $ad55af00a8571df0$export$2d07bc60194ed90c = ()=>{
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    // const stateData = location.state;
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const { id: id } = (0, $0d4e57672a3dc010$export$99eaa27ddbbb95ef)();
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const search = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)().search;
    const [previewData, setPreviewData] = (0, $eeH7J.useState)();
    const [colorPallets, setColorPallets] = (0, $eeH7J.useState)([]);
    // console.log("asasasasa", location.state.selectedColorPallet);
    const [selectedColorPallet, setSelectedColorPallet] = $eeH7J.useState();
    const [searchParams] = (0, $42e24d1152893e59$export$f1a78c17382fe22a)();
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    $eeH7J.useEffect(()=>{
        async function fetchData() {
            try {
                let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/preview?siteId=${id}`);
                // Redirect to /choose-template if response.data is blank
                if (!response.data) {
                    navigate("/choose-template");
                    return;
                }
                setPreviewData(response.data.data);
                let responseAllPallets = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`);
                let rrr = [];
                response.data.data.templateColorPalettes.forEach((row)=>{
                    let gg = responseAllPallets.data.data.find((kk)=>kk.id === row.id);
                    if (gg) rrr.push(gg);
                });
                setColorPallets(rrr);
                let _tmplId = getQueryParam("id");
                // console.log('location.state.selectedColorPallet', location.state.selectedColorPallet)
                if (!location.state?.selectedColorPallet && !_tmplId) setSelectedColorPallet(rrr[0]);
                else {
                    let pp = responseAllPallets.data.data.find((kk)=>kk.id === _tmplId ? _tmplId : location.state?.selectedColorPallet?.id);
                    // console.log('debug4.state.selectedColorPallet', pp)
                    setSelectedColorPallet(pp);
                    // setTimeout(() => {
                    let iframe = document.getElementById("previewFrame");
                    if (iframe) {
                        let iframeWindow = iframe.contentWindow;
                        // let documentElement = iframeWindow.document.documentElement;
                        // Wildcard origin is acceptable: iframe loads user sites on varying domains,
                        // and the data sent is non-sensitive color palette configuration.
                        iframeWindow.postMessage({
                            msgType: "colorPalleteChange",
                            color: pp
                        }, "*");
                    }
                // }, 500);
                }
            } catch (err) {
                console.log(err);
            }
        }
        setIsLoading(true);
        fetchData();
        setIsLoading(false);
    }, []);
    $eeH7J.useEffect(()=>{
        let iframe = document.getElementById("previewFrame");
        if (iframe) {
            let iframeWindow = iframe.contentWindow;
            // let documentElement = iframeWindow.document.documentElement;
            // Wildcard origin is acceptable: iframe loads user sites on varying domains,
            // and the data sent is non-sensitive color palette configuration.
            iframeWindow.postMessage({
                msgType: "colorPalleteChange",
                color: selectedColorPallet
            }, "*");
        }
    // console.log("sss", selectedColorPallet);
    }, [
        selectedColorPallet
    ]);
    // To hide sitename of preview on mobile view
    const useMobileView = ()=>{
        const [isMobileView, setIsMobile] = (0, $eeH7J.useState)(window.innerWidth <= 601);
        $eeH7J.useEffect(()=>{
            const mediaQuery = window.matchMedia("(max-width: 601px)");
            const handleMediaChange = ()=>setIsMobile(mediaQuery.matches);
            handleMediaChange(); // Initial check
            mediaQuery.addEventListener("change", handleMediaChange); // Listen for changes
            return ()=>mediaQuery.removeEventListener("change", handleMediaChange); // Cleanup
        }, []);
        return isMobileView;
    };
    let isMobile = useMobileView();
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Preview"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), previewData && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        title: `Preview${!isMobile ? ` : ${previewData.templateName}` : ""}`,
        colorPallets: colorPallets,
        selectedColorPallet: selectedColorPallet,
        editUrl: `${"https://editorstage.rocketpages.io"}?tid=${previewData.siteId}&theme=${selectedColorPallet ? selectedColorPallet.id : ""}`,
        isPreview: true,
        onColorPaletteChange: (color)=>{
            setSelectedColorPallet(color);
        // let iframe = document.getElementById("previewFrame");
        // let iframeWindow = iframe.contentWindow;
        // // let documentElement = iframeWindow.document.documentElement;
        // iframeWindow.postMessage(
        //   {
        //     msgType: "colorPalleteChange",
        //     color,
        //   },
        //   "*"
        // );
        }
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-[#FAFAFA] absolute top-[64px] w-full h-screen"
    }, /*#__PURE__*/ $eeH7J.createElement("iframe", {
        id: "previewFrame",
        className: "w-full h-[96%]",
        src: previewData.previewUrl,
        // src="https://preview-test-1.rocketpages.io"
        onLoad: (e)=>{
            // console.log("onLoad.iframe.", selectedColorPallet);
            let iframe = document.getElementById("previewFrame");
            let iframeWindow = iframe.contentWindow;
            // Wildcard origin is acceptable: iframe loads user sites on varying domains,
            // and the data sent is non-sensitive color palette configuration.
            iframeWindow.postMessage({
                msgType: "colorPalleteChange",
                color: selectedColorPallet
            }, "*");
        }
    }))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");


var $30a2a61f5e92bc64$exports = {};

$parcel$export($30a2a61f5e92bc64$exports, "contentWrapper", function () { return $30a2a61f5e92bc64$export$2a82ddc22e8c7fbb; }, function (v) { return $30a2a61f5e92bc64$export$2a82ddc22e8c7fbb = v; });
$parcel$export($30a2a61f5e92bc64$exports, "description", function () { return $30a2a61f5e92bc64$export$6d59db4903f20f7d; }, function (v) { return $30a2a61f5e92bc64$export$6d59db4903f20f7d = v; });
$parcel$export($30a2a61f5e92bc64$exports, "fsmd", function () { return $30a2a61f5e92bc64$export$d0a6875c18a6e138; }, function (v) { return $30a2a61f5e92bc64$export$d0a6875c18a6e138 = v; });
$parcel$export($30a2a61f5e92bc64$exports, "h1", function () { return $30a2a61f5e92bc64$export$448e4850cad7c7b0; }, function (v) { return $30a2a61f5e92bc64$export$448e4850cad7c7b0 = v; });
$parcel$export($30a2a61f5e92bc64$exports, "spacing", function () { return $30a2a61f5e92bc64$export$5458b64234d1333c; }, function (v) { return $30a2a61f5e92bc64$export$5458b64234d1333c = v; });
$parcel$export($30a2a61f5e92bc64$exports, "title", function () { return $30a2a61f5e92bc64$export$fb184b623420d9be; }, function (v) { return $30a2a61f5e92bc64$export$fb184b623420d9be = v; });
var $30a2a61f5e92bc64$export$2a82ddc22e8c7fbb;
var $30a2a61f5e92bc64$export$6d59db4903f20f7d;
var $30a2a61f5e92bc64$export$d0a6875c18a6e138;
var $30a2a61f5e92bc64$export$448e4850cad7c7b0;
var $30a2a61f5e92bc64$export$5458b64234d1333c;
var $30a2a61f5e92bc64$export$fb184b623420d9be;
$30a2a61f5e92bc64$export$2a82ddc22e8c7fbb = `Uxi7mG_contentWrapper`;
$30a2a61f5e92bc64$export$6d59db4903f20f7d = `Uxi7mG_description`;
$30a2a61f5e92bc64$export$d0a6875c18a6e138 = `Uxi7mG_fsmd`;
$30a2a61f5e92bc64$export$448e4850cad7c7b0 = `Uxi7mG_h1`;
$30a2a61f5e92bc64$export$5458b64234d1333c = `Uxi7mG_spacing`;
$30a2a61f5e92bc64$export$fb184b623420d9be = `Uxi7mG_title`;


const $1fb652433b432751$var$PrivacyPolicy = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("main", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).contentWrapper}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).spacing} mt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).h1}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "RocketPages Privacy Policy"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Last updated: May 17, 2024")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, 'RocketPages ("us", "we", or "our") operates ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, '[your website URL] (the "Site"). '), "This page informs you of our policies regarding the collection, use, and disclosure of Personal Information we receive from users of the Site.We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Information Collection and Use"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include but is not limited to your name ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, '("Personal Information")'), ".")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Log Data"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Like many site operators, we collect information that your browser sends whenever you visit our Site ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, '("Log Data")'), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "This Log Data may include information such as your computer's Internet Protocol ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, '("IP")'), " address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages, and other statistics."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "In addition, we may use third-party services such as Google Analytics that collect, monitor, and analyze this data.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Communications"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "We may use your Personal Information to contact you with newsletters, marketing, or promotional materials and other information that may be of interest to you. You may opt-out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Cookies"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Like many sites, we use ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, '"cookies"'), " to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Security"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Changes to This Privacy Policy"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "This Privacy Policy is effective as of [Date] and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "We reserve the right to update or change our Privacy Policy at any time, and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us or by placing a prominent notice on our website.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Contact Us"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "If you have any questions about this Privacy Policy, please contact us at ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("a", {
        href: "mailto:info@rocketpages.io",
        target: "_blank",
        className: "editor-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "info@rocketpages.io")), "."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};
var $1fb652433b432751$export$2e2bcd8739ae039 = $1fb652433b432751$var$PrivacyPolicy;




const $94f55d04ae492c0a$export$d5a29154259e944d = (props)=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [cookie, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Privacy policy"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        skipCheckCookies: true
    }), /*#__PURE__*/ $eeH7J.createElement((0, $1fb652433b432751$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");


var $eeH7J = parcelRequire("eeH7J");
















const $73f8100a4bf13ad8$var$MIN_PASSWORD_LENGTH = 8;
const $73f8100a4bf13ad8$var$MAX_PASSWORD_LENGTH = 72;
function $73f8100a4bf13ad8$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
function $73f8100a4bf13ad8$var$getResetEmail() {
    try {
        return localStorage.getItem("rp_reset_email") || "";
    } catch  {
        return "";
    }
}


const $73f8100a4bf13ad8$var$ResetPassword = ()=>{
    const isInIframe = $73f8100a4bf13ad8$var$checkIsInFrame();
    const [errorMessage, setErrorMessage] = $eeH7J.useState("");
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const userEmail = $73f8100a4bf13ad8$var$getResetEmail();
    const [cookies, setCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_access_token"
    ]);
    const [isLoading, setIsLoading] = $eeH7J.useState(false);
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [formData, setFormData] = $eeH7J.useState({
        password: "",
        rePassword: ""
    });
    const [formErrors, setFormErrors] = $eeH7J.useState({
        password: "",
        rePassword: ""
    });
    const isFormInvalid = formErrors.password !== "" || formErrors.rePassword !== "" || formData.password === "" || formData.rePassword === "";
    function validateForm(formData) {
        try {
            setFormErrors({
                password: "",
                rePassword: ""
            });
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "New password can not be empty"
                    };
                });
                return false;
            }
            if (formData.rePassword === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password can not be empty"
                    };
                });
                return false;
            }
            if (formData.password.length < $73f8100a4bf13ad8$var$MIN_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: `New password must be at least ${$73f8100a4bf13ad8$var$MIN_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.password.length > $73f8100a4bf13ad8$var$MAX_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: `New password cannot exceed ${$73f8100a4bf13ad8$var$MAX_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.rePassword.length < $73f8100a4bf13ad8$var$MIN_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: `Confirm password must be at least ${$73f8100a4bf13ad8$var$MIN_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.rePassword.length > $73f8100a4bf13ad8$var$MAX_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: `Confirm password cannot exceed ${$73f8100a4bf13ad8$var$MAX_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.password !== formData.rePassword) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password does not match password."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onUpdatePassword(e, formData) {
        e.preventDefault();
        if (!validateForm(formData)) return;
        setIsLoading(true);
        let accessToken = cookies.rp_access_token || token;
        try {
            let data = {
                password: formData.password
            };
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/update-password", data, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            localStorage.removeItem("rp_reset_email");
            setIsLoading(true);
            enqueueSnackbar("Password has been updated! Please login again", {
                variant: "info",
                className: "bg-grey-400"
            });
            navigate("/login", {
                state: {
                    token: res.data.token
                }
            });
        } catch (err) {
            setErrorMessage(err.response?.data?.message || err.message);
            setIsLoading(false);
        }
    }
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setFormErrors({
            password: "",
            rePassword: ""
        });
        setErrorMessage("");
    }
    const [showPassword, setShowPassword] = $eeH7J.useState(false);
    const [showRePassword, setShowRePassword] = $eeH7J.useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleClickShowRePassword = ()=>setShowRePassword((show)=>!show);
    (0, $eeH7J.useEffect)(()=>{
        // Redirect if user is already logged in
        if (cookies.rp_loggedin) navigate("/choose-template"); // Redirect to the dashboard
    }, [
        cookies.rp_loggedin,
        navigate
    ]);
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).forgotPassword}`
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $a1776588e7982209$export$8b251419efc915eb), null), /*#__PURE__*/ $eeH7J.createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).contentContaienr} flex justify-start`
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).content} md:flex md:flex-col`
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).formContainer}`
    }, /*#__PURE__*/ $eeH7J.createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginHeading} mt-1 md:mt-8 lg:mt-16 mb-8`
    }, "Reset password", " "), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-base font-normal max-w-80"
    }, "Enter a new password for your account", userEmail ? ` ${userEmail}` : "."), /*#__PURE__*/ $eeH7J.createElement("div", null, /*#__PURE__*/ $eeH7J.createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginForm}`,
        onSubmit: (e)=>{
            onUpdatePassword(e, formData);
        }
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        htmlFor: "email"
    }, "Password"), /*#__PURE__*/ $eeH7J.createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
        type: showPassword ? "text" : "password",
        id: "password",
        placeholder: "Enter password",
        value: formData.password,
        onChange: handleChange,
        inputProps: {
            maxLength: $73f8100a4bf13ad8$var$MAX_PASSWORD_LENGTH
        },
        endAdornment: /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showPassword ? "hide the password" : "display the password",
            onClick: handleClickShowPassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showPassword ? /*#__PURE__*/ $eeH7J.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1f00f2e4814332a8$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ $eeH7J.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8174d76e71ef3130$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.password !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.password !== "" && /*#__PURE__*/ $eeH7J.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.password)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        htmlFor: "email"
    }, "Confirm password"), /*#__PURE__*/ $eeH7J.createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
        type: showRePassword ? "text" : "password",
        id: "rePassword",
        placeholder: "Enter password",
        value: formData.rePassword,
        onChange: handleChange,
        inputProps: {
            maxLength: $73f8100a4bf13ad8$var$MAX_PASSWORD_LENGTH
        },
        endAdornment: /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showRePassword ? "hide the password" : "display the password",
            onClick: handleClickShowRePassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showRePassword ? /*#__PURE__*/ $eeH7J.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1f00f2e4814332a8$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ $eeH7J.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8174d76e71ef3130$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.rePassword !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.rePassword !== "" && /*#__PURE__*/ $eeH7J.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.rePassword)), errorMessage !== "" && /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "flex text-center mb-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a8f55969fffb7a$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ $eeH7J.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabelForm} `
    }, errorMessage)), /*#__PURE__*/ $eeH7J.createElement("button", {
        // onClick={onUpdatePassword}
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginBtn} ${isFormInvalid ? "opacity-50 cursor-not-allowed" : ""}`,
        disabled: isFormInvalid
    }, "RESET PASSWORD"), /*#__PURE__*/ $eeH7J.createElement("div", {
        style: {
            textAlign: "center",
            marginTop: "16px"
        }
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).dontHaveAccount} font-normal mr-1`
    }, "Do you remember your password?"), /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "/login",
        className: "text-sm text-[#243460] font-semibold",
        style: {
            textDecoration: "none"
        }
    }, "Login"))))))), !isInIframe && /*#__PURE__*/ $eeH7J.createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)), !isInIframe && /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};
var $73f8100a4bf13ad8$export$2e2bcd8739ae039 = $73f8100a4bf13ad8$var$ResetPassword;



const $b9910f44309337ac$export$da4433e8d8a5678 = ()=>{
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Reset Password"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement((0, $73f8100a4bf13ad8$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");







var $eeH7J = parcelRequire("eeH7J");















function $4711a951f96a8ba0$var$useQuery() {
    const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useMemo(()=>new URLSearchParams(search), [
        search
    ]);
}
function $4711a951f96a8ba0$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
function $4711a951f96a8ba0$var$isSafeRedirectUrl(url) {
    if (!url) return false;
    if (url.startsWith("/")) return true;
    try {
        const parsed = new URL(url);
        const allowedOrigins = [
            window.location.origin,
            "https://editorstage.rocketpages.io",
            "https://apistage.rocketpages.io"
        ].filter(Boolean);
        return allowedOrigins.some((origin)=>{
            try {
                return new URL(origin).origin === parsed.origin;
            } catch  {
                return false;
            }
        });
    } catch  {
        return false;
    }
}
const $4711a951f96a8ba0$var$MIN_PASSWORD_LENGTH = 8;
const $4711a951f96a8ba0$var$MAX_PASSWORD_LENGTH = 72;
const $4711a951f96a8ba0$var$MAX_EMAIL_LENGTH = 254;





const $4711a951f96a8ba0$var$Signup = ()=>{
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const [showRePassword, setShowRePassword] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleClickShowRePassword = ()=>setShowRePassword((show)=>!show);
    const isInIframe = $4711a951f96a8ba0$var$checkIsInFrame();
    const [errorMessage, setErrorMessage] = (0, $eeH7J.useState)("");
    const [errorMessageSocial, setErrorMessageSocial] = (0, $eeH7J.useState)("");
    const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    let query = $4711a951f96a8ba0$var$useQuery();
    let l_redirecturl = query.get("redirecturl");
    let l_userId = query.get("userId");
    let l_siteId = query.get("siteId");
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const [cookies, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_access_token"
    ]);
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const { linkedInLogin: linkedInLogin } = (0, $5e832946007203dd$export$798996ac402ec5d0)({
        clientId: "86q0502we7bi54",
        scope: "email profile openid",
        redirectUri: "https://appstage.rocketpages.io/linkedin",
        onSuccess: (code)=>{
            onCreateAccountLinkedIn(code);
        // console.log("onSuccess", code);
        },
        onError: (error)=>{
            console.log(error);
        }
    });
    const googleLogin = (0, $0964ed3e14b7bf9e$export$6ca4c5d94f9e170b)({
        onSuccess: (tokenResponse)=>{
            onCreateAccountGoogle(tokenResponse);
        },
        onError: ()=>{
            console.log("Login Failed");
        }
    });
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        email: "",
        password: "",
        rePassword: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        email: "",
        password: "",
        rePassword: ""
    });
    function isValidEmail(email) {
        // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    function validateForm(formData) {
        try {
            setFormErrors({
                email: "",
                password: "",
                rePassword: ""
            });
            if (formData.email === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Email can not be empty."
                    };
                });
                return false;
            }
            if (formData.email.length > $4711a951f96a8ba0$var$MAX_EMAIL_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: `Email cannot exceed ${$4711a951f96a8ba0$var$MAX_EMAIL_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (!isValidEmail(formData.email)) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Invalid email address."
                    };
                });
                return false;
            }
            if (formData.password.length < $4711a951f96a8ba0$var$MIN_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: `Password must be at least ${$4711a951f96a8ba0$var$MIN_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.password.length > $4711a951f96a8ba0$var$MAX_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: `Password cannot exceed ${$4711a951f96a8ba0$var$MAX_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "Password can not be empty."
                    };
                });
                return false;
            }
            if (formData.rePassword === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password can not be empty."
                    };
                });
                return false;
            }
            if (formData.password !== formData.rePassword) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password does not match password."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onCreateAccountEmail(e) {
        e.preventDefault();
        if (!validateForm(formData)) return;
        setIsLoading(true);
        try {
            let data = {
                signupMode: "email",
                email: formData.email,
                password: formData.password,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "https://editorstage.rocketpages.io".replace(/^http:\/\/(?!localhost)/, "https://"));
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = $4711a951f96a8ba0$var$isSafeRedirectUrl(l_redirecturl) ? l_redirecturl : "/dashboard";
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err.response.data.message);
        }
    }
    async function onCreateAccountGoogle(googleCred) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "google",
                token: googleCred.credential,
                accessToken: googleCred.access_token,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "https://editorstage.rocketpages.io".replace(/^http:\/\/(?!localhost)/, "https://"));
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = $4711a951f96a8ba0$var$isSafeRedirectUrl(l_redirecturl) ? l_redirecturl : "/dashboard";
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    async function onCreateAccountLinkedIn(authCode) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "linkedIn",
                authCode: authCode,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "https://editorstage.rocketpages.io".replace(/^http:\/\/(?!localhost)/, "https://"));
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = $4711a951f96a8ba0$var$isSafeRedirectUrl(l_redirecturl) ? l_redirecturl : "/dashboard";
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setErrorMessage("");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).signup}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading,
        invisible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "info"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a1776588e7982209$export$8b251419efc915eb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).contentContaienr} flex justify-start`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("2DfTm")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).content} md:flex md:flex-col ${isInIframe ? (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).nopadding : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).formContainer}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h2", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginHeading} mt-1 md:mt-8 lg:mt-16 mb-8`
    }, "Create your account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginForm}`,
        onSubmit: onCreateAccountEmail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "email"
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        type: "email",
        id: "email",
        placeholder: "Enter email address",
        value: formData.email,
        onChange: handleChange,
        className: `${formErrors.email !== "" ? "border-red-500" : ""}`
    }), formErrors.email !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.email)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "password"
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
        type: showPassword ? "text" : "password",
        id: "password",
        placeholder: "Enter password",
        value: formData.password,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showPassword ? "hide the password" : "display the password",
            onClick: handleClickShowPassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showPassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1f00f2e4814332a8$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8174d76e71ef3130$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.password !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).inputMessage} text-[12px] leading-[14px] mb-0`
    }, "Must be between ", $4711a951f96a8ba0$var$MIN_PASSWORD_LENGTH, " and ", $4711a951f96a8ba0$var$MAX_PASSWORD_LENGTH, " characters"), formErrors.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.password)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        htmlFor: "rePassword"
    }, "Confirm password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
        type: showRePassword ? "text" : "password",
        id: "rePassword",
        placeholder: "Enter password",
        value: formData.rePassword,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showRePassword ? "hide the password" : "display the password",
            onClick: handleClickShowRePassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showRePassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1f00f2e4814332a8$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8174d76e71ef3130$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.rePassword !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.rePassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, formErrors.rePassword)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).inputMessage} text-[12px] leading-[14px] mb-1`
    }, "*By signing up, you agree to the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/terms-and-conditions",
        target: "_blank",
        className: "underline text-black"
    }, "terms of service"), " ", "and", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/privacy-policy",
        target: "_blank",
        className: "underline text-black"
    }, "privacy policy")), errorMessage !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "flex text-center mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a8f55969fffb7a$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabelForm} `
    }, errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        type: "submit",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).loginBtn}`
    }, "Create Account")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperator} flex items-center pt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperatorLine}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperatorText}`
    }, "Or Login with", " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).seperatorLine}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).socialSection} flex justify-center gap-8`
    }, isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).googleIcon,
        onClick: ()=>googleLogin()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("7OJZE")),
        alt: "Google",
        style: {
            width: 32,
            height: 32
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).googleIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("7OJZE")),
        alt: "Google",
        style: {
            width: 32,
            height: 32,
            pointerEvents: "none"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).googleIframeOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $0964ed3e14b7bf9e$export$a795a627e512102a), {
        onSuccess: async (credentialResponse)=>onCreateAccountGoogle(credentialResponse),
        type: "icon",
        shape: "square",
        size: "large",
        width: "40",
        onError: ()=>{
            console.log("Login Failed");
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).socialIcons}`,
        onClick: linkedInLogin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: (parcelRequire("bL04G"))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-center py-2"
    }, errorMessageSocial !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "flex text-center mb-2 items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a8f55969fffb7a$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabelForm} `
    }, errorMessageSocial))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            justifyContent: "center",
            display: {
                xs: "flex",
                lg: "none"
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).dontHaveAccount} font-normal mr-1`
    }, "Have an account?"), isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: {
            pathname: "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        },
        className: "text-sm text-[#243460] font-semibold"
    }, "Login") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $42e24d1152893e59$export$a6c7ac8248d6e38a), {
        to: `/login${search}`,
        className: "text-sm text-[#243460] font-semibold"
    }, "Login"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).dontHaveAccount} font-normal`
    }, ".")))))), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};
var $4711a951f96a8ba0$export$2e2bcd8739ae039 = $4711a951f96a8ba0$var$Signup;



const $a8e122dcd7d8cd95$export$a2f4b65ede167ce5 = ()=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const [cookie, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (location.state && location.state.removeCookies) removeCookie("rp_user_data");
        else if (cookie.rp_user_data) navigate("/dashboard");
    // console.log('LoginPage -> props.removeCookies',location.state)
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Signup"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement((0, $4711a951f96a8ba0$export$2e2bcd8739ae039), null));
};







var $eeH7J = parcelRequire("eeH7J");



var $188ff129cb2c0207$exports = {};
/**
 * Created by Samuel on 6/4/2016.
 * Simple wrapper functions to produce shorter UUIDs for cookies, maybe everything?
 */ const $390d2bb43880bed0$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $390d2bb43880bed0$export$2e2bcd8739ae039 = {
    randomUUID: $390d2bb43880bed0$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $ac761bc26cafc6c5$var$getRandomValues;
const $ac761bc26cafc6c5$var$rnds8 = new Uint8Array(16);
function $ac761bc26cafc6c5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ac761bc26cafc6c5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $ac761bc26cafc6c5$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$ac761bc26cafc6c5$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $ac761bc26cafc6c5$var$getRandomValues($ac761bc26cafc6c5$var$rnds8);
}


var $b14e1195d6a35c07$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $f4504ed462a60e9d$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $b14e1195d6a35c07$export$2e2bcd8739ae039).test(uuid);
}
var $f4504ed462a60e9d$export$2e2bcd8739ae039 = $f4504ed462a60e9d$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $c9518ba92fa242e9$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$c9518ba92fa242e9$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $c9518ba92fa242e9$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $c9518ba92fa242e9$var$byteToHex[arr[offset + 0]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 1]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 2]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 3]] + '-' + $c9518ba92fa242e9$var$byteToHex[arr[offset + 4]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 5]] + '-' + $c9518ba92fa242e9$var$byteToHex[arr[offset + 6]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 7]] + '-' + $c9518ba92fa242e9$var$byteToHex[arr[offset + 8]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 9]] + '-' + $c9518ba92fa242e9$var$byteToHex[arr[offset + 10]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 11]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 12]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 13]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 14]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 15]];
}
function $c9518ba92fa242e9$var$stringify(arr, offset = 0) {
    const uuid = $c9518ba92fa242e9$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $f4504ed462a60e9d$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $c9518ba92fa242e9$export$2e2bcd8739ae039 = $c9518ba92fa242e9$var$stringify;


function $a72deaa1b71be5bc$var$v4(options, buf, offset) {
    if ((0, $390d2bb43880bed0$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $390d2bb43880bed0$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $ac761bc26cafc6c5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $c9518ba92fa242e9$export$8fb373d660548968)(rnds);
}
var $a72deaa1b71be5bc$export$2e2bcd8739ae039 = $a72deaa1b71be5bc$var$v4;


var $188ff129cb2c0207$require$uuidV4 = $a72deaa1b71be5bc$export$2e2bcd8739ae039;
var $188ff129cb2c0207$require$uuidValidate = $f4504ed462a60e9d$export$2e2bcd8739ae039;
var $6a7a773a09983504$exports = {};
var $c9a8f9b4c68a2b34$exports = {};
'use strict';
/**
 * Converter
 *
 * @param {string|Array} srcAlphabet
 * @param {string|Array} dstAlphabet
 * @constructor
 */ function $c9a8f9b4c68a2b34$var$Converter(srcAlphabet, dstAlphabet) {
    if (!srcAlphabet || !dstAlphabet || !srcAlphabet.length || !dstAlphabet.length) throw new Error('Bad alphabet');
    this.srcAlphabet = srcAlphabet;
    this.dstAlphabet = dstAlphabet;
}
/**
 * Convert number from source alphabet to destination alphabet
 *
 * @param {string|Array} number - number represented as a string or array of points
 *
 * @returns {string|Array}
 */ $c9a8f9b4c68a2b34$var$Converter.prototype.convert = function(number) {
    var i, divide, newlen, numberMap = {}, fromBase = this.srcAlphabet.length, toBase = this.dstAlphabet.length, length = number.length, result = typeof number === 'string' ? '' : [];
    if (!this.isValid(number)) throw new Error('Number "' + number + '" contains of non-alphabetic digits (' + this.srcAlphabet + ')');
    if (this.srcAlphabet === this.dstAlphabet) return number;
    for(i = 0; i < length; i++)numberMap[i] = this.srcAlphabet.indexOf(number[i]);
    do {
        divide = 0;
        newlen = 0;
        for(i = 0; i < length; i++){
            divide = divide * fromBase + numberMap[i];
            if (divide >= toBase) {
                numberMap[newlen++] = parseInt(divide / toBase, 10);
                divide = divide % toBase;
            } else if (newlen > 0) numberMap[newlen++] = 0;
        }
        length = newlen;
        result = this.dstAlphabet.slice(divide, divide + 1).concat(result);
    }while (newlen !== 0);
    return result;
};
/**
 * Valid number with source alphabet
 *
 * @param {number} number
 *
 * @returns {boolean}
 */ $c9a8f9b4c68a2b34$var$Converter.prototype.isValid = function(number) {
    var i = 0;
    for(; i < number.length; ++i){
        if (this.srcAlphabet.indexOf(number[i]) === -1) return false;
    }
    return true;
};
$c9a8f9b4c68a2b34$exports = $c9a8f9b4c68a2b34$var$Converter;


/**
 * Function get source and destination alphabet and return convert function
 *
 * @param {string|Array} srcAlphabet
 * @param {string|Array} dstAlphabet
 *
 * @returns {function(number|Array)}
 */ function $6a7a773a09983504$var$anyBase(srcAlphabet, dstAlphabet) {
    var converter = new $c9a8f9b4c68a2b34$exports(srcAlphabet, dstAlphabet);
    /**
     * Convert function
     *
     * @param {string|Array} number
     *
     * @return {string|Array} number
     */ return function(number) {
        return converter.convert(number);
    };
}
$6a7a773a09983504$var$anyBase.BIN = '01';
$6a7a773a09983504$var$anyBase.OCT = '01234567';
$6a7a773a09983504$var$anyBase.DEC = '0123456789';
$6a7a773a09983504$var$anyBase.HEX = '0123456789abcdef';
$6a7a773a09983504$exports = $6a7a773a09983504$var$anyBase;


const $188ff129cb2c0207$var$constants = {
    cookieBase90: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~",
    flickrBase58: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ',
    uuid25Base36: '0123456789abcdefghijklmnopqrstuvwxyz'
};
const $188ff129cb2c0207$var$baseOptions = {
    consistentLength: true
};
// A default generator, instantiated only if used.
let $188ff129cb2c0207$var$toFlickr;
/**
 * Takes a UUID, strips the dashes, and translates.
 * @param {string} longId
 * @param {function(string):string} translator
 * @param {Object} [paddingParams]
 * @returns {string}
 */ const $188ff129cb2c0207$var$shortenUUID = (longId, translator, paddingParams)=>{
    const translated = translator(longId.toLowerCase().replace(/-/g, ''));
    if (!paddingParams || !paddingParams.consistentLength) return translated;
    return translated.padStart(paddingParams.shortIdLength, paddingParams.paddingChar);
};
/**
 * Translate back to hex and turn back into UUID format, with dashes
 * @param {string} shortId
 * @param {function(string)} translator
 * @returns {string}
 */ const $188ff129cb2c0207$var$enlargeUUID = (shortId, translator)=>{
    const uu1 = translator(shortId).padStart(32, '0');
    // Join the zero padding and the UUID and then slice it up with match
    const m = uu1.match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
    // Accumulate the matches and join them.
    return [
        m[1],
        m[2],
        m[3],
        m[4],
        m[5]
    ].join('-');
};
/**
 * Calculate length for the shortened ID
 * @param {number} alphabetLength
 * @returns {number}
 */ const $188ff129cb2c0207$var$getShortIdLength = (alphabetLength)=>Math.ceil(Math.log(2 ** 128) / Math.log(alphabetLength));
$188ff129cb2c0207$exports = (()=>{
    /**
   * @param {string} toAlphabet
   * @param {{ consistentLength: boolean }} [options]
   * @returns {{
   *  alphabet: string,
   *  fromUUID: (function(*): string),
   *  generate: (function(): string),
   *  maxLength: number,
   *  new: (function(): string),
   *  toUUID: (function(*): string),
   *  uuid: ((function(*, *, *): (*))|*),
   *  validate: ((function(*, boolean=false): (boolean))|*)}}
   */ const makeConvertor = (toAlphabet, options)=>{
        // Default to Flickr 58
        const useAlphabet = toAlphabet || $188ff129cb2c0207$var$constants.flickrBase58;
        // Default to baseOptions
        const selectedOptions = {
            ...$188ff129cb2c0207$var$baseOptions,
            ...options
        };
        // Check alphabet for duplicate entries
        if ([
            ...new Set(Array.from(useAlphabet))
        ].length !== useAlphabet.length) throw new Error('The provided Alphabet has duplicate characters resulting in unreliable results');
        const shortIdLength = $188ff129cb2c0207$var$getShortIdLength(useAlphabet.length);
        // Padding Params
        const paddingParams = {
            shortIdLength: shortIdLength,
            consistentLength: selectedOptions.consistentLength,
            paddingChar: useAlphabet[0]
        };
        // UUIDs are in hex, so we translate to and from.
        const fromHex = $6a7a773a09983504$exports($6a7a773a09983504$exports.HEX, useAlphabet);
        const toHex = $6a7a773a09983504$exports(useAlphabet, $6a7a773a09983504$exports.HEX);
        /**
     * @returns {string} - short id
     */ const generate = ()=>$188ff129cb2c0207$var$shortenUUID($188ff129cb2c0207$require$uuidV4(), fromHex, paddingParams);
        /**
     * Confirm if string is a valid id. Checks length and alphabet.
     * If the second parameter is true it will translate to standard UUID
     *  and check the result for UUID validity.
     * @param {string} shortId - The string to check for validity
     * @param {boolean} [rigorous=false] - If true, also check for a valid UUID
     * @returns {boolean}
     */ const validate = (shortId, rigorous = false)=>{
            if (!shortId || typeof shortId !== 'string') return false;
            const isCorrectLength = selectedOptions.consistentLength ? shortId.length === shortIdLength : shortId.length <= shortIdLength;
            const onlyAlphabet = shortId.split('').every((letter)=>useAlphabet.includes(letter));
            if (rigorous === false) return isCorrectLength && onlyAlphabet;
            return isCorrectLength && onlyAlphabet && $188ff129cb2c0207$require$uuidValidate($188ff129cb2c0207$var$enlargeUUID(shortId, toHex));
        };
        const translator = {
            alphabet: useAlphabet,
            fromUUID: (uuid)=>$188ff129cb2c0207$var$shortenUUID(uuid, fromHex, paddingParams),
            maxLength: shortIdLength,
            generate: generate,
            new: generate,
            toUUID: (shortUuid)=>$188ff129cb2c0207$var$enlargeUUID(shortUuid, toHex),
            uuid: $188ff129cb2c0207$require$uuidV4,
            validate: validate
        };
        Object.freeze(translator);
        return translator;
    };
    // Expose the constants for other purposes.
    makeConvertor.constants = $188ff129cb2c0207$var$constants;
    // Expose the generic v4 UUID generator for convenience
    makeConvertor.uuid = $188ff129cb2c0207$require$uuidV4;
    // Provide a generic generator
    makeConvertor.generate = ()=>{
        if (!$188ff129cb2c0207$var$toFlickr) // Generate on first use;
        $188ff129cb2c0207$var$toFlickr = makeConvertor($188ff129cb2c0207$var$constants.flickrBase58).generate;
        return $188ff129cb2c0207$var$toFlickr();
    };
    return makeConvertor;
})();







var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");






var $eeH7J = parcelRequire("eeH7J");
const $fad4e3b90b087a8b$var$Modal = ({ isOpen: isOpen, onClose: onClose, children: children })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-[999]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-white  w-[95vw] h-[95vh] rounded-lg overflow-hidden shadow-xl flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex-grow overflow-auto"
    }, children)));
};
var $fad4e3b90b087a8b$export$2e2bcd8739ae039 = $fad4e3b90b087a8b$var$Modal;





const $ff983ef19f38fcda$var$ImagePicker = (props)=>{
    const [file, setFile] = $eeH7J.useState(props.image_url);
    const [isLoading, setIsLoading] = $eeH7J.useState(false);
    const [isModalOpen, setModalOpen] = $eeH7J.useState(false);
    $eeH7J.useEffect(()=>{
        setFile(props.image_url);
    // console.log('props.image_url', props.image_url);
    }, [
        props.image_url
    ]);
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $fad4e3b90b087a8b$export$2e2bcd8739ae039), {
        isOpen: isModalOpen,
        onClose: ()=>setModalOpen(false)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $162e110d4fb932a6$export$2e2bcd8739ae039), {
        isBlog: props.isBlog,
        siteId: props.siteId,
        onClose: ()=>setModalOpen(false),
        onChange: (url)=>{
            setFile(url);
            props.onImageChange(url);
            setModalOpen(false);
        }
    })), props.title && /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, props.title), props.desc && /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, props.desc), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `w-full border border-catelina-blue/60 rounded flex flex-col ${props.size === "small" ? "h-40 md:w-48" : props.size === "full" ? "w-full" : "h-60 md:w-80"} `
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "border-b border-catelina-blue/60  h-10 flex flex-row justify-end items-center px-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3aeb16233e51b8e7$exports))), {
        className: "text-catelina-blue mr-2 hover:cursor-pointer edit-image",
        fontSize: "small",
        onClick: ()=>{
            setModalOpen(true);
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($04943e88a6b167d3$exports))), {
        className: "text-catelina-blue hover:cursor-pointer",
        fontSize: "small",
        onClick: ()=>{
            setFile("");
            props.onImageChange && props.onImageChange("");
        }
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "h-full flex justify-center items-center px-4 cursor-pointer",
        onClick: ()=>{
            setModalOpen(true);
        }
    }, file !== "" && /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "h-52 object-contain",
        src: file
    }), (file === "" || file === undefined || !file) && // <ImageNotSupportedOutlinedIcon className="" fontSize="large" />
    /*#__PURE__*/ $eeH7J.createElement("img", {
        className: "text-catelina-blue mr-2 hover:cursor-pointer ml-2",
        width: "40",
        src: (parcelRequire("ejk8q"))
    })), props.showAlt && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex  justify-around items-center mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-light"
    }, "Alt & Title  ", /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        width: "20",
        sx: {
            color: '#243060'
        }
    })), /*#__PURE__*/ $eeH7J.createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        className: "border rounded border-red py-1 text-base-2 w-3/5 ",
        placeholder: "Image Name",
        size: "small",
        defaultValue: props.altValue,
        onChange: (e)=>props.onAltChange(e.target.value),
        error: props.altError,
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1,
                    width: '100%'
                },
                '& .MuiFormControl-root': {
                    width: '250px'
                }
            }
        }
    }))), props.notes && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "items-center text-xsm"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        fontSize: "inherit"
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "ml-1"
    }, props.notes)));
};
var $ff983ef19f38fcda$export$2e2bcd8739ae039 = $ff983ef19f38fcda$var$ImagePicker;





var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");




var $4A7Fh = parcelRequire("4A7Fh");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $f62ff229b2126a57$export$717666c39ec07e12(slot) {
    return (0, $aBqGi.default)('MuiFormControlLabel', slot);
}
const $f62ff229b2126a57$var$formControlLabelClasses = (0, $cDqLM.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $f62ff229b2126a57$export$2e2bcd8739ae039 = $f62ff229b2126a57$var$formControlLabelClasses;




var $dRzna = parcelRequire("dRzna");
'use client';
const $96c468de08a5d3c2$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $96c468de08a5d3c2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $4A7Fh.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $f62ff229b2126a57$export$717666c39ec07e12), classes);
};
const $96c468de08a5d3c2$export$1b479270917a5676 = (0, $hikmr.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f62ff229b2126a57$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $4A7Fh.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $f62ff229b2126a57$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $f62ff229b2126a57$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $f62ff229b2126a57$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $96c468de08a5d3c2$var$AsteriskComponent = (0, $hikmr.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $f62ff229b2126a57$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $96c468de08a5d3c2$var$FormControlLabel = /*#__PURE__*/ $eeH7J.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $fbOaB.default)(props, $96c468de08a5d3c2$var$_excluded);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $h4XE0.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $96c468de08a5d3c2$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $32193c68ed830861$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $dRzna.jsx)((0, $32193c68ed830861$export$2e2bcd8739ae039), (0, $h4XE0.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $er6YD.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $dRzna.jsxs)($96c468de08a5d3c2$export$1b479270917a5676, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $eeH7J.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $dRzna.jsxs)((0, $b764c91e8a13a465$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $dRzna.jsxs)($96c468de08a5d3c2$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
$96c468de08a5d3c2$var$FormControlLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component appears selected.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        typography: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */ control: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element.isRequired,
    /**
   * If `true`, the control is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * A text or an element to be used in an enclosing label element.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The position of the label.
   * @default 'end'
   */ labelPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * @ignore
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        typography: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The value of the component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
var $96c468de08a5d3c2$export$2e2bcd8739ae039 = $96c468de08a5d3c2$var$FormControlLabel;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");

var $4A7Fh = parcelRequire("4A7Fh");


var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $1c26553fe83a6583$export$39f6debbec19b3ba(slot) {
    return (0, $aBqGi.default)('MuiSwitch', slot);
}
const $1c26553fe83a6583$var$switchClasses = (0, $cDqLM.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $1c26553fe83a6583$export$2e2bcd8739ae039 = $1c26553fe83a6583$var$switchClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $e8392f33c4dcd0bc$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $e8392f33c4dcd0bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $4A7Fh.default)(edge)}`,
            `size${(0, $4A7Fh.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $4A7Fh.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $doIAf.default)(slots, (0, $1c26553fe83a6583$export$39f6debbec19b3ba), classes);
    return (0, $h4XE0.default)({}, classes, composedClasses);
};
const $e8392f33c4dcd0bc$var$SwitchRoot = (0, $hikmr.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $4A7Fh.default)(ownerState.edge)}`],
            styles[`size${(0, $4A7Fh.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $e8392f33c4dcd0bc$var$SwitchSwitchBase = (0, $hikmr.default)((0, $2e099faf6f4f0cd0$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $4A7Fh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).checked} + .${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).disabled} + .${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $5YtKS.lighten)(theme.palette[color].main, 0.62) : (0, $5YtKS.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).checked} + .${(0, $1c26553fe83a6583$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $e8392f33c4dcd0bc$var$SwitchTrack = (0, $hikmr.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $e8392f33c4dcd0bc$var$SwitchThumb = (0, $hikmr.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $e8392f33c4dcd0bc$var$Switch = /*#__PURE__*/ $eeH7J.forwardRef(function Switch(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $fbOaB.default)(props, $e8392f33c4dcd0bc$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $e8392f33c4dcd0bc$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $dRzna.jsx)($e8392f33c4dcd0bc$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $dRzna.jsxs)($e8392f33c4dcd0bc$var$SwitchRoot, {
        className: (0, $er6YD.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)($e8392f33c4dcd0bc$var$SwitchSwitchBase, (0, $h4XE0.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $h4XE0.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $dRzna.jsx)($e8392f33c4dcd0bc$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
$e8392f33c4dcd0bc$var$Switch.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
var $e8392f33c4dcd0bc$export$2e2bcd8739ae039 = $e8392f33c4dcd0bc$var$Switch;






var $eeH7J = parcelRequire("eeH7J");

var $dRzna = parcelRequire("dRzna");
function $027bbc41a3b6cda8$var$V(e, { insertAt: n } = {}) {
    if (!e || typeof document > "u") return;
    let t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.type = "text/css", n === "top" && t.firstChild ? t.insertBefore(r, t.firstChild) : t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
$027bbc41a3b6cda8$var$V(`.rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}
`);
var $027bbc41a3b6cda8$var$Me = {
    allItemsAreSelected: "All items are selected.",
    clearSearch: "Clear Search",
    clearSelected: "Clear Selected",
    noOptions: "No options",
    search: "Search",
    selectAll: "Select All",
    selectAllFiltered: "Select All (Filtered)",
    selectSomeItems: "Select...",
    create: "Create"
}, $027bbc41a3b6cda8$var$De = {
    value: [],
    hasSelectAll: !0,
    className: "multi-select",
    debounceDuration: 200,
    options: []
}, $027bbc41a3b6cda8$var$re = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext({}), $027bbc41a3b6cda8$var$ne = ({ props: e, children: n })=>{
    let [t, r] = (0, $eeH7J.useState)(e.options), a = (c)=>{
        var u;
        return ((u = e.overrideStrings) == null ? void 0 : u[c]) || $027bbc41a3b6cda8$var$Me[c];
    };
    return (0, $eeH7J.useEffect)(()=>{
        r(e.options);
    }, [
        e.options
    ]), (0, $dRzna.jsx)($027bbc41a3b6cda8$var$re.Provider, {
        value: {
            t: a,
            ...$027bbc41a3b6cda8$var$De,
            ...e,
            options: t,
            setOptions: r
        },
        children: n
    });
}, $027bbc41a3b6cda8$var$w = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useContext($027bbc41a3b6cda8$var$re);
function $027bbc41a3b6cda8$var$se(e, n) {
    let t = (0, $eeH7J.useRef)(!1);
    (0, $eeH7J.useEffect)(()=>{
        t.current ? e() : t.current = !0;
    }, n);
}
var $027bbc41a3b6cda8$var$He = {
    when: !0,
    eventTypes: [
        "keydown"
    ]
};
function $027bbc41a3b6cda8$var$R(e, n, t) {
    let r = (0, $eeH7J.useMemo)(()=>Array.isArray(e) ? e : [
            e
        ], [
        e
    ]), a = Object.assign({}, $027bbc41a3b6cda8$var$He, t), { when: c, eventTypes: u } = a, b = (0, $eeH7J.useRef)(n), { target: s } = a;
    (0, $eeH7J.useEffect)(()=>{
        b.current = n;
    });
    let p = (0, $eeH7J.useCallback)((i)=>{
        r.some((l)=>i.key === l || i.code === l) && b.current(i);
    }, [
        r
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (c && typeof window < "u") {
            let i = s ? s.current : window;
            return u.forEach((l)=>{
                i && i.addEventListener(l, p);
            }), ()=>{
                u.forEach((l)=>{
                    i && i.removeEventListener(l, p);
                });
            };
        }
    }, [
        c,
        u,
        r,
        s,
        n
    ]);
}
var $027bbc41a3b6cda8$var$f = {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: "Space"
};
var $027bbc41a3b6cda8$var$le = (e, n)=>{
    let t;
    return function(...r) {
        clearTimeout(t), t = setTimeout(()=>{
            e.apply(null, r);
        }, n);
    };
};
function $027bbc41a3b6cda8$var$ie(e, n) {
    return n ? e.filter(({ label: t, value: r })=>t != null && r != null && t.toLowerCase().includes(n.toLowerCase())) : e;
}
var $027bbc41a3b6cda8$var$T = ()=>(0, $dRzna.jsxs)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-search-clear-icon gray",
        children: [
            (0, $dRzna.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            (0, $dRzna.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
var $027bbc41a3b6cda8$var$Ue = ({ checked: e, option: n, onClick: t, disabled: r })=>(0, $dRzna.jsxs)("div", {
        className: `item-renderer ${r ? "disabled" : ""}`,
        children: [
            (0, $dRzna.jsx)("input", {
                type: "checkbox",
                onChange: t,
                checked: e,
                tabIndex: -1,
                disabled: r
            }),
            (0, $dRzna.jsx)("span", {
                children: n.label
            })
        ]
    }), $027bbc41a3b6cda8$var$pe = $027bbc41a3b6cda8$var$Ue;
var $027bbc41a3b6cda8$var$Ye = ({ itemRenderer: e = $027bbc41a3b6cda8$var$pe, option: n, checked: t, tabIndex: r, disabled: a, onSelectionChanged: c, onClick: u })=>{
    let b = (0, $eeH7J.useRef)(), s = (l)=>{
        p(), l.preventDefault();
    }, p = ()=>{
        a || c(!t);
    }, i = (l)=>{
        p(), u(l);
    };
    return $027bbc41a3b6cda8$var$R([
        $027bbc41a3b6cda8$var$f.ENTER,
        $027bbc41a3b6cda8$var$f.SPACE
    ], s, {
        target: b
    }), (0, $dRzna.jsx)("label", {
        className: `select-item ${t ? "selected" : ""}`,
        role: "option",
        "aria-selected": t,
        tabIndex: r,
        ref: b,
        children: (0, $dRzna.jsx)(e, {
            option: n,
            checked: t,
            onClick: i,
            disabled: a
        })
    });
}, $027bbc41a3b6cda8$export$13ef48a934230896 = $027bbc41a3b6cda8$var$Ye;
var $027bbc41a3b6cda8$var$ze = ({ options: e, onClick: n, skipIndex: t })=>{
    let { disabled: r, value: a, onChange: c, ItemRenderer: u } = $027bbc41a3b6cda8$var$w(), b = (s, p)=>{
        r || c(p ? [
            ...a,
            s
        ] : a.filter((i)=>i.value !== s.value));
    };
    return (0, $dRzna.jsx)((0, $dRzna.Fragment), {
        children: e.map((s, p)=>{
            let i = p + t;
            return (0, $dRzna.jsx)("li", {
                children: (0, $dRzna.jsx)($027bbc41a3b6cda8$export$13ef48a934230896, {
                    tabIndex: i,
                    option: s,
                    onSelectionChanged: (l)=>b(s, l),
                    checked: !!a.find((l)=>l.value === s.value),
                    onClick: (l)=>n(l, i),
                    itemRenderer: u,
                    disabled: s.disabled || r
                })
            }, (s == null ? void 0 : s.key) || p);
        })
    });
}, $027bbc41a3b6cda8$var$ue = $027bbc41a3b6cda8$var$ze;
var $027bbc41a3b6cda8$var$Je = ()=>{
    let { t: e, onChange: n, options: t, setOptions: r, value: a, filterOptions: c, ItemRenderer: u, disabled: b, disableSearch: s, hasSelectAll: p, ClearIcon: i, debounceDuration: l, isCreatable: L, onCreateOption: y } = $027bbc41a3b6cda8$var$w(), O = (0, $eeH7J.useRef)(), g = (0, $eeH7J.useRef)(), [m, M] = (0, $eeH7J.useState)(""), [v, K] = (0, $eeH7J.useState)(t), [x, D] = (0, $eeH7J.useState)(""), [E, I] = (0, $eeH7J.useState)(0), W = (0, $eeH7J.useCallback)($027bbc41a3b6cda8$var$le((o)=>D(o), l), []), A = (0, $eeH7J.useMemo)(()=>{
        let o = 0;
        return s || (o += 1), p && (o += 1), o;
    }, [
        s,
        p
    ]), _ = {
        label: e(m ? "selectAllFiltered" : "selectAll"),
        value: ""
    }, H = (o)=>{
        let d = v.filter((C)=>!C.disabled).map((C)=>C.value);
        if (o) {
            let Ae = [
                ...a.map((U)=>U.value),
                ...d
            ];
            return (c ? v : t).filter((U)=>Ae.includes(U.value));
        }
        return a.filter((C)=>!d.includes(C.value));
    }, B = (o)=>{
        let d = H(o);
        n(d);
    }, h = (o)=>{
        W(o.target.value), M(o.target.value), I(0);
    }, P = ()=>{
        var o;
        D(""), M(""), (o = g == null ? void 0 : g.current) == null || o.focus();
    }, Z = (o)=>I(o), we = (o)=>{
        switch(o.code){
            case $027bbc41a3b6cda8$var$f.ARROW_UP:
                ee(-1);
                break;
            case $027bbc41a3b6cda8$var$f.ARROW_DOWN:
                ee(1);
                break;
            default:
                return;
        }
        o.stopPropagation(), o.preventDefault();
    };
    $027bbc41a3b6cda8$var$R([
        $027bbc41a3b6cda8$var$f.ARROW_DOWN,
        $027bbc41a3b6cda8$var$f.ARROW_UP
    ], we, {
        target: O
    });
    let Oe = ()=>{
        I(0);
    }, j = async ()=>{
        let o = {
            label: m,
            value: m,
            __isNew__: !0
        };
        y && (o = await y(m)), r([
            o,
            ...t
        ]), P(), n([
            ...a,
            o
        ]);
    }, Re = async ()=>c ? await c(t, x) : $027bbc41a3b6cda8$var$ie(t, x), ee = (o)=>{
        let d = E + o;
        d = Math.max(0, d), d = Math.min(d, t.length + Math.max(A - 1, 0)), I(d);
    };
    (0, $eeH7J.useEffect)(()=>{
        var o, d;
        (d = (o = O == null ? void 0 : O.current) == null ? void 0 : o.querySelector(`[tabIndex='${E}']`)) == null || d.focus();
    }, [
        E
    ]);
    let [ke, Ee] = (0, $eeH7J.useMemo)(()=>{
        let o = v.filter((d)=>!d.disabled);
        return [
            o.every((d)=>a.findIndex((C)=>C.value === d.value) !== -1),
            o.length !== 0
        ];
    }, [
        v,
        a
    ]);
    (0, $eeH7J.useEffect)(()=>{
        Re().then(K);
    }, [
        x,
        t
    ]);
    let te = (0, $eeH7J.useRef)();
    $027bbc41a3b6cda8$var$R([
        $027bbc41a3b6cda8$var$f.ENTER
    ], j, {
        target: te
    });
    let Ie = L && m && !v.some((o)=>(o == null ? void 0 : o.value) === m);
    return (0, $dRzna.jsxs)("div", {
        className: "select-panel",
        role: "listbox",
        ref: O,
        children: [
            !s && (0, $dRzna.jsxs)("div", {
                className: "search",
                children: [
                    (0, $dRzna.jsx)("input", {
                        placeholder: e("search"),
                        type: "text",
                        "aria-describedby": e("search"),
                        onChange: h,
                        onFocus: Oe,
                        value: m,
                        ref: g,
                        tabIndex: 0
                    }),
                    (0, $dRzna.jsx)("button", {
                        type: "button",
                        className: "search-clear-button",
                        hidden: !m,
                        onClick: P,
                        "aria-label": e("clearSearch"),
                        children: i || (0, $dRzna.jsx)($027bbc41a3b6cda8$var$T, {})
                    })
                ]
            }),
            (0, $dRzna.jsxs)("ul", {
                className: "options",
                children: [
                    p && Ee && (0, $dRzna.jsx)($027bbc41a3b6cda8$export$13ef48a934230896, {
                        tabIndex: A === 1 ? 0 : 1,
                        checked: ke,
                        option: _,
                        onSelectionChanged: B,
                        onClick: ()=>Z(1),
                        itemRenderer: u,
                        disabled: b
                    }),
                    v.length ? (0, $dRzna.jsx)($027bbc41a3b6cda8$var$ue, {
                        skipIndex: A,
                        options: v,
                        onClick: (o, d)=>Z(d)
                    }) : Ie ? (0, $dRzna.jsx)("li", {
                        onClick: j,
                        className: "select-item creatable",
                        tabIndex: 1,
                        ref: te,
                        children: `${e("create")} "${m}"`
                    }) : (0, $dRzna.jsx)("li", {
                        className: "no-options",
                        children: e("noOptions")
                    })
                ]
            })
        ]
    });
}, $027bbc41a3b6cda8$export$9640093ec8451560 = $027bbc41a3b6cda8$var$Je;
var $027bbc41a3b6cda8$var$ge = ({ expanded: e })=>(0, $dRzna.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-heading-dropdown-arrow gray",
        children: (0, $dRzna.jsx)("path", {
            d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
        })
    });
var $027bbc41a3b6cda8$var$xe = ()=>{
    let { t: e, value: n, options: t, valueRenderer: r } = $027bbc41a3b6cda8$var$w(), a = n.length === 0, c = n.length === t.length, u = r && r(n, t);
    return a ? (0, $dRzna.jsx)("span", {
        className: "gray",
        children: u || e("selectSomeItems")
    }) : (0, $dRzna.jsx)("span", {
        children: u || (c ? e("allItemsAreSelected") : (()=>n.map((s)=>s.label).join(", "))())
    });
};
var $027bbc41a3b6cda8$var$Se = ({ size: e = 24 })=>(0, $dRzna.jsx)("span", {
        style: {
            width: e,
            marginRight: "0.2rem"
        },
        children: (0, $dRzna.jsx)("svg", {
            width: e,
            height: e,
            className: "spinner",
            viewBox: "0 0 50 50",
            style: {
                display: "inline",
                verticalAlign: "middle"
            },
            children: (0, $dRzna.jsx)("circle", {
                cx: "25",
                cy: "25",
                r: "20",
                fill: "none",
                className: "path"
            })
        })
    });
var $027bbc41a3b6cda8$var$Xe = ()=>{
    let { t: e, onMenuToggle: n, ArrowRenderer: t, shouldToggleOnHover: r, isLoading: a, disabled: c, onChange: u, labelledBy: b, value: s, isOpen: p, defaultIsOpen: i, ClearSelectedIcon: l, closeOnChangedValue: L } = $027bbc41a3b6cda8$var$w();
    (0, $eeH7J.useEffect)(()=>{
        L && m(!1);
    }, [
        s
    ]);
    let [y, O] = (0, $eeH7J.useState)(!0), [g, m] = (0, $eeH7J.useState)(i), [M, v] = (0, $eeH7J.useState)(!1), K = t || $027bbc41a3b6cda8$var$ge, x = (0, $eeH7J.useRef)();
    $027bbc41a3b6cda8$var$se(()=>{
        n && n(g);
    }, [
        g
    ]), (0, $eeH7J.useEffect)(()=>{
        i === void 0 && typeof p == "boolean" && (O(!1), m(p));
    }, [
        p
    ]);
    let D = (h)=>{
        var P;
        [
            "text",
            "button"
        ].includes(h.target.type) && [
            $027bbc41a3b6cda8$var$f.SPACE,
            $027bbc41a3b6cda8$var$f.ENTER
        ].includes(h.code) || (y && (h.code === $027bbc41a3b6cda8$var$f.ESCAPE ? (m(!1), (P = x == null ? void 0 : x.current) == null || P.focus()) : m(!0)), h.preventDefault());
    };
    $027bbc41a3b6cda8$var$R([
        $027bbc41a3b6cda8$var$f.ENTER,
        $027bbc41a3b6cda8$var$f.ARROW_DOWN,
        $027bbc41a3b6cda8$var$f.SPACE,
        $027bbc41a3b6cda8$var$f.ESCAPE
    ], D, {
        target: x
    });
    let E = (h)=>{
        y && r && m(h);
    }, I = ()=>!M && v(!0), W = (h)=>{
        !h.currentTarget.contains(h.relatedTarget) && y && (v(!1), m(!1));
    }, A = ()=>E(!0), _ = ()=>E(!1), H = ()=>{
        y && m(a || c ? !1 : !g);
    }, B = (h)=>{
        h.stopPropagation(), u([]), y && m(!1);
    };
    return (0, $dRzna.jsxs)("div", {
        tabIndex: 0,
        className: "dropdown-container",
        "aria-labelledby": b,
        "aria-expanded": g,
        "aria-readonly": !0,
        "aria-disabled": c,
        ref: x,
        onFocus: I,
        onBlur: W,
        onMouseEnter: A,
        onMouseLeave: _,
        children: [
            (0, $dRzna.jsxs)("div", {
                className: "dropdown-heading",
                onClick: H,
                children: [
                    (0, $dRzna.jsx)("div", {
                        className: "dropdown-heading-value",
                        children: (0, $dRzna.jsx)($027bbc41a3b6cda8$var$xe, {})
                    }),
                    a && (0, $dRzna.jsx)($027bbc41a3b6cda8$var$Se, {}),
                    s.length > 0 && l !== null && (0, $dRzna.jsx)("button", {
                        type: "button",
                        className: "clear-selected-button",
                        onClick: B,
                        disabled: c,
                        "aria-label": e("clearSelected"),
                        children: l || (0, $dRzna.jsx)($027bbc41a3b6cda8$var$T, {})
                    }),
                    (0, $dRzna.jsx)(K, {
                        expanded: g
                    })
                ]
            }),
            g && (0, $dRzna.jsx)("div", {
                className: "dropdown-content",
                children: (0, $dRzna.jsx)("div", {
                    className: "panel-content",
                    children: (0, $dRzna.jsx)($027bbc41a3b6cda8$export$9640093ec8451560, {})
                })
            })
        ]
    });
}, $027bbc41a3b6cda8$export$931cbfb6bfb85fc = $027bbc41a3b6cda8$var$Xe;
var $027bbc41a3b6cda8$var$Ze = (e)=>(0, $dRzna.jsx)($027bbc41a3b6cda8$var$ne, {
        props: e,
        children: (0, $dRzna.jsx)("div", {
            className: `rmsc ${e.className || "multi-select"}`,
            children: (0, $dRzna.jsx)($027bbc41a3b6cda8$export$931cbfb6bfb85fc, {})
        })
    }), $027bbc41a3b6cda8$export$1e7dfd31545b5809 = $027bbc41a3b6cda8$var$Ze;




//people.sort((a, b) => a.name.localeCompare(b.name));
const $e12add26e07ddef3$var$ConfigAdministration = (props)=>{
    $eeH7J.useEffect(()=>{
        setSelected((props.data.templateCategories || [])?.map((lk)=>({
                label: lk,
                value: lk
            })));
    }, [
        props.data.templateCategories
    ]);
    const [selected, setSelected] = $eeH7J.useState([]);
    const colorPalletKeys = (0, (/*@__PURE__*/$parcel$interopDefault($188ff129cb2c0207$exports)))();
    // console.log("ConfigAdministration.data", props.data);
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "left-sidebar-admin"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Template name"), /*#__PURE__*/ $eeH7J.createElement("input", {
        className: "border rounded border-catelina-blue/60 w-full py-1 px-2 md:w-80",
        placeholder: "Website name",
        value: props.data.templateName || props.data.siteName,
        //   disabled
        onChange: (e)=>{
            props.onDataChange({
                templateName: (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value)
            });
        }
    }), props.data && /*#__PURE__*/ $eeH7J.createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        variant: "standard"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $96c468de08a5d3c2$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ $eeH7J.createElement((0, $e8392f33c4dcd0bc$export$2e2bcd8739ae039), {
            defaultChecked: props.data.isTemplate === "true",
            checked: props.data.isTemplate === "true",
            onChange: (event)=>{
                props.onDataChange({
                    isTemplate: event.target.checked ? "true" : "false"
                });
            // setSelected(event.target.checked)
            },
            name: "isTemplate"
        }),
        label: "Is Template"
    }), /*#__PURE__*/ $eeH7J.createElement((0, $96c468de08a5d3c2$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ $eeH7J.createElement((0, $e8392f33c4dcd0bc$export$2e2bcd8739ae039), {
            defaultChecked: props.data.isAITemplate === "true",
            checked: props.data.isAITemplate === "true",
            onChange: (event)=>{
                props.onDataChange({
                    isAITemplate: event.target.checked ? "true" : "false"
                });
            // setSelected(event.target.checked)
            },
            name: "isAITemplate"
        }),
        label: "Is AI Template"
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Template Categories"), /*#__PURE__*/ $eeH7J.createElement((0, $027bbc41a3b6cda8$export$1e7dfd31545b5809), {
        options: props.templateSiteCategories.map((ol)=>{
            return {
                label: ol.name,
                value: ol.name
            };
        }).sort((a, b)=>a.label.localeCompare(b.label, undefined, {
                numeric: true,
                sensitivity: "base"
            })),
        value: selected,
        // value={props.data.templateCategories || []}
        onChange: (vals)=>{
            // console.log(
            //   "sasasdas",
            //   vals.map((kk) => kk.label)
            // );
            setSelected(vals);
            props.onDataChange({
                templateCategories: vals.map((kk)=>kk.label)
            });
        },
        labelledBy: "Template Categories"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col md:flex-row text-center mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2"
    }, "Applicable color pallets "), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        // className="w-full"
        variant: "outlined",
        size: "small",
        onClick: ()=>{
            let _prevData = [
                ...props.data.templateColorPalettes
            ];
            _prevData.push({
                keyIndex: colorPalletKeys.new(),
                id: props.data.currentSiteColorPalette ? props.data.currentSiteColorPalette.id : "",
                imageUrl: props.data.siteImageURL || ""
            });
            props.onDataChange({
                templateColorPalettes: _prevData
            });
        },
        sx: {
            marginLeft: 2,
            backgroundColor: "#fff",
            border: "1px solid",
            borderColor: "#243060",
            color: "#243060",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        }
    }, "Add new color palette")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2"
    }, props.data.templateColorPalettes && props.data.templateColorPalettes.map((rr)=>{
        return /*#__PURE__*/ $eeH7J.createElement("div", {
            key: rr.keyIndex,
            className: "w-full md:w-50 xl:w-60 rounded overflow-hidden shadow-lg p-4 bg-white"
        }, /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
            sx: {
                maxWidth: "100%",
                width: "100%"
            },
            size: "small"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $79a0d4fc41924020$export$2e2bcd8739ae039), {
            id: "select",
            value: rr.id,
            onChange: (e)=>{
                // setSelectedLang(e.target.value)
                // console.log(e.target.value);
                // props.onDataChange({ primaryLanguage: e.target.value });
                let _prevData = [
                    ...props.data.templateColorPalettes
                ];
                let idx = _prevData.findIndex((jh)=>jh.keyIndex === rr.keyIndex);
                _prevData[idx] = {
                    ..._prevData[idx],
                    id: e.target.value
                };
                props.onDataChange({
                    templateColorPalettes: _prevData
                });
            },
            className: "w-full text-sm mb-2"
        }, props.allTemplateColors.sort((a, b)=>a.id.localeCompare(b.id, undefined, {
                numeric: true,
                sensitivity: "base"
            })).map((row)=>{
            return /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
                key: row.id,
                className: "text-sm",
                value: row.id
            }, row.id, " - (", row.category, ")");
        })), /*#__PURE__*/ $eeH7J.createElement((0, $ff983ef19f38fcda$export$2e2bcd8739ae039), {
            image_url: rr.imageUrl,
            siteId: props.siteId,
            size: "full",
            // title="Favicon image"
            // desc="Favicon is displayed on your site's tab in a browser."
            // notes="Please upload a 16x16px .PNG or .JPG image."
            onImageChange: (img_url)=>{
                let _prevData = [
                    ...props.data.templateColorPalettes
                ];
                let idx = _prevData.findIndex((jh)=>jh.keyIndex === rr.keyIndex);
                _prevData[idx] = {
                    ..._prevData[idx],
                    imageUrl: img_url
                };
                props.onDataChange({
                    templateColorPalettes: _prevData
                });
            }
        }), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            className: "w-full",
            variant: "outlined",
            size: "small",
            onClick: ()=>{
                let _prevData = [
                    ...props.data.templateColorPalettes
                ];
                let idx = _prevData.findIndex((jh)=>jh.keyIndex === rr.keyIndex);
                _prevData.splice(idx, 1);
                props.onDataChange({
                    templateColorPalettes: _prevData
                });
            },
            sx: {
                marginTop: 2,
                backgroundColor: "#fff",
                border: "1px solid",
                borderColor: "red",
                color: "red",
                textTransform: "none",
                "&:hover": {
                    backgroundColor: "red",
                    color: "#fff"
                }
            }
        }, "Delete"))));
    }))));
};
var $e12add26e07ddef3$export$2e2bcd8739ae039 = $e12add26e07ddef3$var$ConfigAdministration;


var $880d53c39aa7bd1b$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($880d53c39aa7bd1b$exports, "__esModule", {
    value: true
});
$880d53c39aa7bd1b$exports.default = void 0;

var $880d53c39aa7bd1b$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $880d53c39aa7bd1b$var$_default = $880d53c39aa7bd1b$exports.default = (0, $880d53c39aa7bd1b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M18 17H6v-2h12zm0-4H6v-2h12zm0-4H6V7h12zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2z"
}), 'ReceiptSharp');



var $eeH7J = parcelRequire("eeH7J");
var $c5d7f6be3eaefd44$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($c5d7f6be3eaefd44$exports, "__esModule", {
    value: true
});
$c5d7f6be3eaefd44$exports.default = void 0;

var $c5d7f6be3eaefd44$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $c5d7f6be3eaefd44$var$_default = $c5d7f6be3eaefd44$exports.default = (0, $c5d7f6be3eaefd44$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M17 13l-5 5-5-5h3V9h4v4z"
}), 'CloudDownload');


var $3b8002affd54488a$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($3b8002affd54488a$exports, "__esModule", {
    value: true
});
$3b8002affd54488a$exports.default = void 0;

var $3b8002affd54488a$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $3b8002affd54488a$var$_default = $3b8002affd54488a$exports.default = (0, $3b8002affd54488a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');




var $eeH7J = parcelRequire("eeH7J");

const $b9d284724e5e72bd$var$InvoiceItem = (props)=>{
    //   console.log("InvoiceItem", props);
    const invoice_date = new Date(props.data.created * 1000);
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `bg-white border rounded-lg shadow-md p-3 md:p-4 w-full mr-2 my-2  text-xsm sm:text-base grid grid-cols-1 xl:grid-cols-4 gap-4`
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "self-center"
    }, invoice_date.toLocaleDateString("en-GB")), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "self-center flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "Invoice:\xa0"), /*#__PURE__*/ $eeH7J.createElement("span", null, props.data.id)), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "xl:text-right self-center"
    }, "$", props.data.amount_paid / 100), props.data.status !== 'uncollectible' && /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "flex justify-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        color: "primary",
        "aria-label": "add to shopping cart",
        href: props.data.hosted_invoice_url
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3b8002affd54488a$exports))), {
        className: "mx-2",
        fontSize: "small"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        color: "primary",
        "aria-label": "add to shopping cart",
        href: props.data.invoice_pdf
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c5d7f6be3eaefd44$exports))), {
        className: "mx-2",
        fontSize: "small"
    }))), props.data.status === 'uncollectible' && /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-sm mb-0 flex   text-catelina-blue  rounded bg-[#E1E4EF] px-2 py-0 pl-4 relative"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        className: "mr-1 absolute top-1.5 left-1",
        style: {
            fontSize: 16
        }
    }), " ", /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "flex flex-wrap pl-1"
    }, "Payment failed. View/download unavailable. ")));
};
var $b9d284724e5e72bd$export$2e2bcd8739ae039 = $b9d284724e5e72bd$var$InvoiceItem;


const $f1879511b722e3f2$var$ConfigBillings = (props)=>{
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "config-billings flex flex-col justify-center items-left w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full"
    }, props.isLoading && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($880d53c39aa7bd1b$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "Fetching Invoices...")), !props.isLoading && props.invoices.length === 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($880d53c39aa7bd1b$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "No invoices found"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-xsm mb-4 mt-0"
    }, "you haven't generated any invoices so far.")), !props.isLoading && props.invoices.length > 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "text-lg font-bold mb-4 mt-0"
    }, "Invoices"), props.invoices?.map((invoice)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $b9d284724e5e72bd$export$2e2bcd8739ae039), {
            key: invoice.id,
            data: invoice
        });
    })))));
};
var $f1879511b722e3f2$export$2e2bcd8739ae039 = $f1879511b722e3f2$var$ConfigBillings;




var $eeH7J = parcelRequire("eeH7J");


var $1V8au = parcelRequire("1V8au");


var $9ace0d94a76f7c03$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($9ace0d94a76f7c03$exports, "__esModule", {
    value: true
});
$9ace0d94a76f7c03$exports.default = void 0;

var $9ace0d94a76f7c03$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $9ace0d94a76f7c03$var$_default = $9ace0d94a76f7c03$exports.default = (0, $9ace0d94a76f7c03$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');



const $b5c2d083d601c9b9$var$ConfigContactForm = (props)=>{
    const [data, setData] = $eeH7J.useState([]);
    const [subscriptions, setSubscriptions] = $eeH7J.useState();
    const [loading, setLoading] = $eeH7J.useState(false);
    const [fromDate, setFromDate] = $eeH7J.useState("");
    const [toDate, setToDate] = $eeH7J.useState("");
    const [allData, setAllData] = $eeH7J.useState(false);
    const [expandedMonth, setExpandedMonth] = $eeH7J.useState(null); // Accordion state
    // Fetch data from the API
    async function fetchData(siteId, fromDate, toDate, allData) {
        setLoading(true);
        try {
            let queryParams = `?siteId=${siteId}`;
            if (!allData) {
                if (fromDate) queryParams += `&fromDate=${fromDate}`;
                if (toDate) queryParams += `&toDate=${toDate}`;
            }
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/all-form-submissions${queryParams}`);
            setData(response.data.data);
            setSubscriptions(response.data.subsDetails);
        } catch (err) {
            console.log(err);
        } finally{
            setLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchData(props.siteId);
    }, [
        props.siteId
    ]);
    // Handle date change and API call
    const handleFromDateChange = (e)=>{
        const date = e.target.value;
        setFromDate(date);
        fetchData(props.siteId, date, toDate, allData); // Fetch with the new fromDate
    };
    const handleToDateChange = (e)=>{
        const date = e.target.value;
        setToDate(date);
        fetchData(props.siteId, fromDate, date, allData); // Fetch with the new toDate
    };
    // Handle checkbox change and API call
    const handleAllDataChange = (e)=>{
        const checked = e.target.checked;
        setAllData(checked);
        fetchData(props.siteId, fromDate, toDate, checked); // Fetch with "all" data if checked
    };
    // Toggle accordion
    const toggleMonth = (month)=>{
        setExpandedMonth((prev)=>prev === month ? null : month);
    };
    // Group data by month
    const groupedData = data.reduce((acc, item)=>{
        const month = (0, (/*@__PURE__*/$parcel$interopDefault($1V8au)))(item.created_at_dt).format("MMMM YYYY");
        if (!acc[month]) acc[month] = [];
        acc[month].push(item);
        return acc;
    }, {});
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black h-screen flex-1 md:mr-4 mt-2.5 md:mt-0"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, loading ? "Loading..." : `${data.length} Response(s)`), !loading && data.filter((ll)=>ll.isBlur).length > 0 && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col md:flex-row justify-between items-center mt-3 mb-5 gap-4 leading-5"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-3 text-red-500 relative pl-6"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a8f55969fffb7a$exports))), {
        fontSize: "small",
        sx: {
            color: "red",
            left: "0px",
            position: "absolute",
            top: "2px"
        }
    }), `You have reached the limit of ${subscriptions.form_submission} contact form submissions on the ${subscriptions.name}. Upgrade to view all submissions.`), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        className: "h-8 pr-8 pl-8 mt-2 md:mt-0 whitespace-nowrap",
        variant: "contained",
        sx: {
            textTransform: "none"
        },
        onClick: ()=>{
            let _url = `/site-settings/${props.siteId}?section=Subscriptions`;
            window.open(_url, "_self")?.focus();
        }
    }, "View Plans")), Object.keys(groupedData).map((month)=>{
        const hasBlurredRows = groupedData[month].some((row)=>row.isBlur);
        let displayedBlurMessage = false; // Flag to track if the message has been displayed
        const formattedMonth = (0, (/*@__PURE__*/$parcel$interopDefault($1V8au)))(month, "MMMM YYYY").format("MMMM, YYYY");
        let blurredRowsCount = 0;
        return /*#__PURE__*/ $eeH7J.createElement("div", {
            key: month,
            className: "mb-2"
        }, /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "cursor-pointer bg-gray-100 py-2 px-4 font-bold border border-gray-300 flex items-center justify-between",
            onClick: ()=>toggleMonth(month)
        }, /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "flex-grow"
        }, formattedMonth, " (", groupedData[month].length, " responses)"), expandedMonth === month ? /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ace0d94a76f7c03$exports))), {
            className: "ml-auto text-gray-500"
        }) : /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9a37ff2c25189b1$exports))), {
            className: "ml-auto text-gray-500"
        })), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "overflow-x-auto max-h-[400px]"
        }, expandedMonth === month && /*#__PURE__*/ $eeH7J.createElement("table", {
            className: "relative xl:w-full border-collapse font-body rounded bg-white table-fixed mb-0 submissionTable"
        }, /*#__PURE__*/ $eeH7J.createElement("thead", {
            className: "sticky top-0 bg-white z-10"
        }, /*#__PURE__*/ $eeH7J.createElement("tr", null, /*#__PURE__*/ $eeH7J.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Submitted"), /*#__PURE__*/ $eeH7J.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "First Name"), /*#__PURE__*/ $eeH7J.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Last Name"), /*#__PURE__*/ $eeH7J.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Email"), /*#__PURE__*/ $eeH7J.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Phone Number"), /*#__PURE__*/ $eeH7J.createElement("th", {
            className: "text-left w-1/6 min-w-[300px] px-2 py-1 border text-base"
        }, "Message"))), /*#__PURE__*/ $eeH7J.createElement("tbody", null, groupedData[month].map((row)=>{
            const isBlurred = row.isBlur;
            const isFirstBlurredRow = isBlurred && !displayedBlurMessage;
            // Skip rendering more than 5 blurred rows
            if (isBlurred && blurredRowsCount >= 5) return null; // Stop rendering if we have already displayed 5 blurred rows
            // Increment the count if it's a blurred row
            if (isBlurred) blurredRowsCount++;
            if (isFirstBlurredRow) displayedBlurMessage = true; // Set the flag to true after displaying the message
            return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, {
                key: row.id
            }, isFirstBlurredRow && /*#__PURE__*/ $eeH7J.createElement("tr", {
                className: "absolute bottom-0 left-0 right-0"
            }, /*#__PURE__*/ $eeH7J.createElement("td", {
                colSpan: 6,
                className: "absolute bottom-0 left-0 right-0 py-8"
            }, /*#__PURE__*/ $eeH7J.createElement("div", {
                className: "w-[400px] mx-auto text-center bg-white relative border border-red-400 text-red-600 px-4 pb-2 pt-4 flex flex-col items-center justify-center seeResponse"
            }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
                className: "mr-2 text-red-600"
            }), /*#__PURE__*/ $eeH7J.createElement("span", {
                className: "mb-3 text-base leading-6"
            }, "Upgrade to see the rest", " ", groupedData[month].length - subscriptions.form_submission, groupedData[month].length - subscriptions.form_submission > 1 ? /*#__PURE__*/ $eeH7J.createElement("span", null, " responses") : /*#__PURE__*/ $eeH7J.createElement("span", null, " response"), "."), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
                size: "small",
                className: "h-8 pr-4 pl-4 mt-2 md:mt-0 whitespace-nowrap",
                variant: "contained",
                sx: {
                    textTransform: "none"
                },
                onClick: ()=>{
                    let _url = `/site-settings/${props.siteId}?section=Subscriptions`;
                    window.open(_url, "_self")?.focus();
                }
            }, "View Plans")))), /*#__PURE__*/ $eeH7J.createElement("tr", {
                className: `${isBlurred ? "relative isBlurred" : ""}`
            }, /*#__PURE__*/ $eeH7J.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($1V8au)))(row.created_at_dt).format("HH:mm:ss, DD-MM-YYYY")), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.firstName), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.lastName), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.email), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.phoneNumber), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.message)));
        }), hasBlurredRows && Array.from({
            length: 5 - blurredRowsCount
        }).map((_, index)=>/*#__PURE__*/ $eeH7J.createElement("tr", {
                key: `placeholder-${index}`,
                className: "relative isBlurred"
            }, " ", /*#__PURE__*/ $eeH7J.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $eeH7J.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0")))))));
    }));
};
var $b5c2d083d601c9b9$export$2e2bcd8739ae039 = $b5c2d083d601c9b9$var$ConfigContactForm;





var $eeH7J = parcelRequire("eeH7J");



var $eeH7J = parcelRequire("eeH7J");



const $7b808775e29c9cb3$var$ContributorItem = (props)=>{
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row justify-between my-2 items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-sm sm:text-base"
    }, props.email), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        variant: "outlined",
        className: "hidden sm:block",
        sx: {
            textTransform: "none"
        },
        onClick: props.onRemoveUser
    }, "Remove"), /*#__PURE__*/ $eeH7J.createElement((0, $035814a890448735$export$2e2bcd8739ae039), {
        "aria-label": "delete",
        className: "sm:hidden",
        size: "small"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eec45c1bd37e4a90$exports))), {
        fontSize: "inherit"
    })));
};
var $7b808775e29c9cb3$export$2e2bcd8739ae039 = $7b808775e29c9cb3$var$ContributorItem;



const $da24085d6632689d$var$ConfigContributors = (props)=>{
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const [emails, setEmails] = $eeH7J.useState("");
    const [error, setError] = $eeH7J.useState("");
    const [addOnUsers, setAddOnUsers] = $eeH7J.useState(props.addOnUsers || []);
    $eeH7J.useEffect(()=>{
        // console.log("ConfigContributors", props.addOnUsers);
        setAddOnUsers(props.addOnUsers);
    }, [
        props.addOnUsers
    ]);
    const onSendInvite = ()=>{
        // Split string by comma into an array
        let l_emails = emails.split(",");
        let l_validEmails = [];
        var valid = true;
        var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let invalidEmails = [];
        for(var i = 0; i < l_emails.length; i++){
            // Trim whitespaces from email address
            l_emails[i] = l_emails[i].trim();
            // Check email against our regex to determine if email is valid
            // console.log(
            //   "asasas",
            //   cookies.rp_user_data ? cookies.rp_user_data.email : ""
            // );
            if (l_emails[i] == "" || !regex.test(l_emails[i]) || l_emails[i] === (cookies.rp_user_data ? cookies.rp_user_data.email : "")) invalidEmails.push(l_emails[i]);
            else if (!addOnUsers.find((kk)=>kk.email === l_emails[i]) && !l_validEmails.find((kk)=>kk.email === l_emails[i])) l_validEmails.push({
                email: l_emails[i],
                role: "editor"
            });
        }
        if (invalidEmails.filter((kk)=>kk !== "").length > 0) // setError(`Invalid Email Address. Please make sure you've entered a correctly formatted email address (e.g., example@email.com): ${invalidEmails.join(", ")}`);
        setError(`The email address "${invalidEmails.join(", ")}" is invalid. Please ensure you've entered a correctly formatted email address (e.g., example@email.com)`);
        else {
            setError(``);
            setEmails("");
            let l_onlyEmails = [];
            l_validEmails.forEach((ii)=>{
                l_onlyEmails.push(ii.email);
            });
            props.onAddOnUsersAdd(l_onlyEmails);
            setAddOnUsers((old)=>{
                props.onDataChange({
                    addOnUsers: [
                        ...old,
                        ...l_validEmails
                    ]
                });
                return [
                    ...old,
                    ...l_validEmails
                ];
            });
        }
    // console.log(invalidEmails);
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black h-screen left-sidebar-contributors"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Invite contributors"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "Contributors can view, edit and publish the shared website. However, they cannot delete or duplicate it. You can cancel access at any time."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col lg:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col pb-2 lg:pb-0"
    }, /*#__PURE__*/ $eeH7J.createElement("input", {
        className: "border rounded border-catelina-blue/60 py-1 px-2 mr-3 w-full md:w-80",
        placeholder: "Email, comma separated",
        value: emails,
        onChange: (e)=>{
            setEmails((0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value));
            setError("");
        }
    })), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        className: "h-8 w-28",
        variant: "contained",
        sx: {
            textTransform: "none"
        },
        onClick: onSendInvite,
        disabled: emails === ""
    }, "Send invite")), error !== "" && /*#__PURE__*/ $eeH7J.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($565dc97da8a86871$exports))).errorLabels}`
    }, error), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-2 w-full max-w-full md:max-w-md"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full max-w-full md:max-w-md"
    }, addOnUsers && addOnUsers.map((row)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $7b808775e29c9cb3$export$2e2bcd8739ae039), {
            key: row.email,
            email: row.email,
            onRemoveUser: ()=>{
                // console.log('onremove user', row.email)
                props.onAddOnUsersRemove(row.email);
                let l_new_addonusers = addOnUsers.filter((ll)=>ll.email !== row.email);
                props.onDataChange({
                    addOnUsers: l_new_addonusers
                });
                setAddOnUsers(l_new_addonusers);
            }
        });
    }))));
};
var $da24085d6632689d$export$2e2bcd8739ae039 = $da24085d6632689d$var$ConfigContributors;




var $eeH7J = parcelRequire("eeH7J");
const $8b2770f625cf1793$var$ConfigCustomCode = (props)=>{
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black left-sidebar-custome-code"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "<head> custom HTML code"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "Include HTML code to your website <head>. You can make use of <script> and <style> HTML tags too."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("textarea", {
        value: props.head_customHtmlCode,
        onChange: (e)=>{
            props.onDataChange({
                head_customHtmlCode: e.target.value
            });
        },
        className: "w-full lg:w-4/5 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "<script src=\u201Dhttps://www.googletagmanager.com/gtag/js?id=UA-XXX-X\u201D></script>",
        rows: 8
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "<body> custom HTML code"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "Include HTML code to your website <body>. This code will be appended at the last of body tag."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("textarea", {
        value: props.body_customHtmlCode,
        onChange: (e)=>{
            props.onDataChange({
                body_customHtmlCode: e.target.value
            });
        },
        className: "w-full lg:w-4/5 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "<script src=\u201Dhttps://www.googletagmanager.com/gtag/js?id=UA-XXX-X\u201D></script>",
        rows: 8
    })));
};
var $8b2770f625cf1793$export$2e2bcd8739ae039 = $8b2770f625cf1793$var$ConfigCustomCode;



var $eeH7J = parcelRequire("eeH7J");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");


var $4A7Fh = parcelRequire("4A7Fh");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");
function $4c75cad9c08a3140$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
    return null;
}


var $f44eac46a6f785b1$export$2e2bcd8739ae039 = (0, $4c75cad9c08a3140$export$2e2bcd8739ae039);



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $752ac41b77e61934$export$72aef224d6115253(slot) {
    return (0, $aBqGi.default)('MuiTab', slot);
}
const $752ac41b77e61934$var$tabClasses = (0, $cDqLM.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $752ac41b77e61934$export$2e2bcd8739ae039 = $752ac41b77e61934$var$tabClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $6878910a69f430c4$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $6878910a69f430c4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $4A7Fh.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $752ac41b77e61934$export$72aef224d6115253), classes);
};
const $6878910a69f430c4$var$TabRoot = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $4A7Fh.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $752ac41b77e61934$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $752ac41b77e61934$export$2e2bcd8739ae039).iconWrapper}`]: (0, $h4XE0.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $752ac41b77e61934$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $752ac41b77e61934$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $752ac41b77e61934$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $752ac41b77e61934$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $752ac41b77e61934$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $752ac41b77e61934$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $6878910a69f430c4$var$Tab = /*#__PURE__*/ $eeH7J.forwardRef(function Tab(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $fbOaB.default)(props, $6878910a69f430c4$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $6878910a69f430c4$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $eeH7J.isValidElement(iconProp) ? /*#__PURE__*/ $eeH7J.cloneElement(iconProp, {
        className: (0, $er6YD.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $dRzna.jsxs)($6878910a69f430c4$var$TabRoot, (0, $h4XE0.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
$6878910a69f430c4$var$Tab.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: (0, $f44eac46a6f785b1$export$2e2bcd8739ae039),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The position of the icon relative to the label.
   * @default 'top'
   */ iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * The label element.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */ wrapped: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
};
var $6878910a69f430c4$export$2e2bcd8739ae039 = $6878910a69f430c4$var$Tab;



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $dRzna = parcelRequire("dRzna");
'use client';
const $1ebad4d8fc8d8546$var$Context = /*#__PURE__*/ $eeH7J.createContext(null);
$1ebad4d8fc8d8546$var$Context.displayName = 'TabContext';
function $1ebad4d8fc8d8546$var$useUniquePrefix() {
    const [id, setId] = $eeH7J.useState(null);
    $eeH7J.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $1ebad4d8fc8d8546$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $1ebad4d8fc8d8546$var$useUniquePrefix();
    const context = $eeH7J.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)($1ebad4d8fc8d8546$var$Context.Provider, {
        value: context,
        children: children
    });
}
$1ebad4d8fc8d8546$export$2e2bcd8739ae039.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The value of the currently selected `Tab`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]).isRequired
};
function $1ebad4d8fc8d8546$export$5a3bad273ac578e0() {
    return $eeH7J.useContext($1ebad4d8fc8d8546$var$Context);
}
function $1ebad4d8fc8d8546$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $1ebad4d8fc8d8546$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");
function $29a716c69c56d532$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $29a716c69c56d532$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $29a716c69c56d532$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $29a716c69c56d532$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $29a716c69c56d532$export$2e2bcd8739ae039 = $29a716c69c56d532$export$4f5d2d50c9deca37;



var $hikmr = parcelRequire("hikmr");

var $xHBjO = parcelRequire("xHBjO");

var $4hHwC = parcelRequire("4hHwC");
'use client';
function $8f8ff45f85c6940c$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $8c1ba3299ee127fd$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $xHBjO.default,
        themeId: (0, $4hHwC.default)
    });
}



var $doIAf = parcelRequire("doIAf");

var $aBqGi = parcelRequire("aBqGi");

var $cDqLM = parcelRequire("cDqLM");
function $bac2e02c831d26ea$export$cfb3da2e74936ec(slot) {
    return (0, $aBqGi.default)('MuiTabPanel', slot);
}
const $bac2e02c831d26ea$var$tabPanelClasses = (0, $cDqLM.default)('MuiTabPanel', [
    'root'
]);
var $bac2e02c831d26ea$export$2e2bcd8739ae039 = $bac2e02c831d26ea$var$tabPanelClasses;




var $dRzna = parcelRequire("dRzna");
'use client';
const $77641e8807ec5b93$var$_excluded = [
    "children",
    "className",
    "value"
];
const $77641e8807ec5b93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $bac2e02c831d26ea$export$cfb3da2e74936ec), classes);
};
const $77641e8807ec5b93$var$TabPanelRoot = (0, $hikmr.default)('div', {
    name: 'MuiTabPanel',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $77641e8807ec5b93$var$TabPanel = /*#__PURE__*/ $eeH7J.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $8f8ff45f85c6940c$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTabPanel'
    });
    const { children: children, className: className, value: value } = props, other = (0, $fbOaB.default)(props, $77641e8807ec5b93$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props);
    const classes = $77641e8807ec5b93$var$useUtilityClasses(ownerState);
    const context = (0, $1ebad4d8fc8d8546$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const id = (0, $1ebad4d8fc8d8546$export$629f80328afcade5)(context, value);
    const tabId = (0, $1ebad4d8fc8d8546$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $dRzna.jsx)($77641e8807ec5b93$var$TabPanelRoot, (0, $h4XE0.default)({
        "aria-labelledby": tabId,
        className: (0, $29a716c69c56d532$export$2e2bcd8739ae039)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState
    }, other, {
        children: value === context.value && children
    }));
});
$77641e8807ec5b93$var$TabPanel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The `value` of the corresponding `Tab`. Must use the index of the `Tab` when
   * no `value` was passed to `Tab`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string.isRequired
};
var $77641e8807ec5b93$export$2e2bcd8739ae039 = $77641e8807ec5b93$var$TabPanel;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");



var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $86a83f0105292295$var$cachedType;
function $86a83f0105292295$export$a10970ffb6510128() {
    if ($86a83f0105292295$var$cachedType) return $86a83f0105292295$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $86a83f0105292295$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $86a83f0105292295$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $86a83f0105292295$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $86a83f0105292295$var$cachedType;
}
function $86a83f0105292295$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $86a83f0105292295$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $d4394bb141d07b9c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $d4394bb141d07b9c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $d4394bb141d07b9c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");



var $dRzna = parcelRequire("dRzna");
'use client';
const $6e04ae8e429c05ca$var$_excluded = [
    "onChange"
];
const $6e04ae8e429c05ca$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $6e04ae8e429c05ca$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $fbOaB.default)(props, $6e04ae8e429c05ca$var$_excluded);
    const scrollbarHeight = $eeH7J.useRef();
    const nodeRef = $eeH7J.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $caa7ff66ed2b6d13$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $c370e859c3c397cd$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $e722e67392aff1bf$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $eeH7J.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)("div", (0, $h4XE0.default)({
        style: $6e04ae8e429c05ca$var$styles
    }, other, {
        ref: nodeRef
    }));
}
$6e04ae8e429c05ca$export$2e2bcd8739ae039.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.isRequired
};



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $74a6ad4a793e7e74$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $8b0b487b0ea2a343$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $95163404b0c35d12$export$34861783d3c2eef8(slot) {
    return (0, $aBqGi.default)('MuiTabScrollButton', slot);
}
const $95163404b0c35d12$var$tabScrollButtonClasses = (0, $cDqLM.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $95163404b0c35d12$export$2e2bcd8739ae039 = $95163404b0c35d12$var$tabScrollButtonClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $a4c4023454dade08$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $a4c4023454dade08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $95163404b0c35d12$export$34861783d3c2eef8), classes);
};
const $a4c4023454dade08$var$TabScrollButtonRoot = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $95163404b0c35d12$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $a4c4023454dade08$var$TabScrollButton = /*#__PURE__*/ $eeH7J.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $fbOaB.default)(props, $a4c4023454dade08$var$_excluded);
    const isRtl = (0, $24165880ce40ccbd$export$b2dd014b6c321cb)();
    const ownerState = (0, $h4XE0.default)({
        isRtl: isRtl
    }, props);
    const classes = $a4c4023454dade08$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $74a6ad4a793e7e74$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $8b0b487b0ea2a343$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $dRzna.jsx)($a4c4023454dade08$var$TabScrollButtonRoot, (0, $h4XE0.default)({
        component: "div",
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $dRzna.jsx)(StartButtonIcon, (0, $h4XE0.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $dRzna.jsx)(EndButtonIcon, (0, $h4XE0.default)({}, endButtonIconProps))
    }));
});
$a4c4023454dade08$var$TabScrollButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The direction the button should indicate.
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'left',
        'right'
    ]).isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The component orientation (layout flow direction).
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'horizontal',
        'vertical'
    ]).isRequired,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        endScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        startScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        EndScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        StartScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $a4c4023454dade08$export$2e2bcd8739ae039 = $a4c4023454dade08$var$TabScrollButton;




var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $77cc62d1be581d8e$export$cdd93bd054dec359(slot) {
    return (0, $aBqGi.default)('MuiTabs', slot);
}
const $77cc62d1be581d8e$var$tabsClasses = (0, $cDqLM.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $77cc62d1be581d8e$export$2e2bcd8739ae039 = $77cc62d1be581d8e$var$tabsClasses;





var $dRzna = parcelRequire("dRzna");
'use client';
const $6146074d8a2c7938$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $6146074d8a2c7938$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $6146074d8a2c7938$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $6146074d8a2c7938$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $6146074d8a2c7938$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $77cc62d1be581d8e$export$cdd93bd054dec359), classes);
};
const $6146074d8a2c7938$var$TabsRoot = (0, $hikmr.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $77cc62d1be581d8e$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $77cc62d1be581d8e$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $h4XE0.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $77cc62d1be581d8e$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $6146074d8a2c7938$var$TabsScroller = (0, $hikmr.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $6146074d8a2c7938$var$FlexContainer = (0, $hikmr.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $6146074d8a2c7938$var$TabsIndicator = (0, $hikmr.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $h4XE0.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $6146074d8a2c7938$var$TabsScrollbarSize = (0, $hikmr.default)((0, $6e04ae8e429c05ca$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $6146074d8a2c7938$var$defaultIndicatorStyle = {};
let $6146074d8a2c7938$var$warnedOnceTabPresent = false;
const $6146074d8a2c7938$var$Tabs = /*#__PURE__*/ $eeH7J.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $c7b8a7ef63736600$export$2e2bcd8739ae039)();
    const isRtl = (0, $24165880ce40ccbd$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $a4c4023454dade08$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $fbOaB.default)(props, $6146074d8a2c7938$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $h4XE0.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $6146074d8a2c7938$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $d752081878235039$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    if (centered && scrollable) console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
    const [mounted, setMounted] = $eeH7J.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $eeH7J.useState($6146074d8a2c7938$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $eeH7J.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $eeH7J.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $eeH7J.useState(false);
    const [scrollerStyle, setScrollerStyle] = $eeH7J.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $eeH7J.useRef(null);
    const tabListRef = $eeH7J.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $86a83f0105292295$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                if (!tab) console.error([
                    `MUI: The \`value\` provided to the Tabs component is invalid.`,
                    `None of the Tabs' children match with "${value}".`,
                    valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(', ')}.` : null
                ].join('\n'));
                tabMeta = tab ? tab.getBoundingClientRect() : null;
                if (!$6146074d8a2c7938$var$warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 && // if the whole Tabs component is hidden, don't warn
                tabsMeta.clientWidth !== 0) {
                    tabsMeta = null;
                    console.error([
                        'MUI: The `value` provided to the Tabs component is invalid.',
                        `The Tab with this \`value\` ("${value}") is not part of the document layout.`,
                        "Make sure the tab item is present in the document or that it's not `display: none`."
                    ].join('\n'));
                    $6146074d8a2c7938$var$warnedOnceTabPresent = true;
                }
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $6acee5fdb4b8c69c$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $d4394bb141d07b9c$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $86a83f0105292295$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $eeH7J.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $dRzna.jsx)($6146074d8a2c7938$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $er6YD.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $dRzna.jsx)(ScrollButtonComponent, (0, $h4XE0.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $er6YD.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $dRzna.jsx)(ScrollButtonComponent, (0, $h4XE0.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $er6YD.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $6acee5fdb4b8c69c$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $6acee5fdb4b8c69c$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $eeH7J.useEffect(()=>{
        const handleResize = (0, $c370e859c3c397cd$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $e722e67392aff1bf$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $eeH7J.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $eeH7J.useEffect(()=>{
        setMounted(true);
    }, []);
    $eeH7J.useEffect(()=>{
        updateIndicatorState();
    });
    $eeH7J.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($6146074d8a2c7938$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $eeH7J.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $dRzna.jsx)($6146074d8a2c7938$var$TabsIndicator, (0, $h4XE0.default)({}, TabIndicatorProps, {
        className: (0, $er6YD.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $h4XE0.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $eeH7J.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(child)) return null;
        if ((0, $631d1dee154373e2$exports.isFragment)(child)) console.error([
            "MUI: The Tabs component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $eeH7J.cloneElement(child, (0, $h4XE0.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $420c0ad55da0a5b0$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $6146074d8a2c7938$var$moveFocus(list, currentFocus, $6146074d8a2c7938$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $6146074d8a2c7938$var$moveFocus(list, currentFocus, $6146074d8a2c7938$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $6146074d8a2c7938$var$moveFocus(list, null, $6146074d8a2c7938$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $6146074d8a2c7938$var$moveFocus(list, null, $6146074d8a2c7938$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $dRzna.jsxs)($6146074d8a2c7938$var$TabsRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $dRzna.jsxs)($6146074d8a2c7938$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $dRzna.jsx)($6146074d8a2c7938$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
$6146074d8a2c7938$var$Tabs.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */ action: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */ allowScrollButtonsMobile: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The label for the Tabs as a string.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * An id or list of ids separated by a space that label the Tabs.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */ centered: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Determines the color of the indicator.
   * @default 'primary'
   */ indicatorColor: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */ ScrollButtonComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */ scrollButtons: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOf([
        'auto',
        false,
        true
    ]),
    /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */ selectionFollowsFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        endScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ]),
        startScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        EndScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        StartScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * Props applied to the tab indicator element.
   * @default  {}
   */ TabIndicatorProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */ TabScrollButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */ textColor: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'fullWidth',
        'scrollable',
        'standard'
    ]),
    /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */ visibleScrollbar: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
};
var $6146074d8a2c7938$export$2e2bcd8739ae039 = $6146074d8a2c7938$var$Tabs;




var $eeH7J = parcelRequire("eeH7J");



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $6cdde18522ceb6dc$export$797947b6292e28e1(slot) {
    return (0, $aBqGi.default)('MuiStepper', slot);
}
const $6cdde18522ceb6dc$var$stepperClasses = (0, $cDqLM.default)('MuiStepper', [
    'root',
    'horizontal',
    'vertical',
    'nonLinear',
    'alternativeLabel'
]);
var $6cdde18522ceb6dc$export$2e2bcd8739ae039 = $6cdde18522ceb6dc$var$stepperClasses;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $4A7Fh = parcelRequire("4A7Fh");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $eeH7J = parcelRequire("eeH7J");
/**
 * Provides information about the current step in Stepper.
 */ const $2d713390f1294458$var$StepperContext = /*#__PURE__*/ $eeH7J.createContext({});
$2d713390f1294458$var$StepperContext.displayName = 'StepperContext';
function $2d713390f1294458$export$1ff9b16b13b0447() {
    return $eeH7J.useContext($2d713390f1294458$var$StepperContext);
}
var $2d713390f1294458$export$2e2bcd8739ae039 = $2d713390f1294458$var$StepperContext;



var $eeH7J = parcelRequire("eeH7J");
/**
 * Provides information about the current step in Stepper.
 */ const $6577b62bdbdb7ce1$var$StepContext = /*#__PURE__*/ $eeH7J.createContext({});
$6577b62bdbdb7ce1$var$StepContext.displayName = 'StepContext';
function $6577b62bdbdb7ce1$export$90d5f24cfecec416() {
    return $eeH7J.useContext($6577b62bdbdb7ce1$var$StepContext);
}
var $6577b62bdbdb7ce1$export$2e2bcd8739ae039 = $6577b62bdbdb7ce1$var$StepContext;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d9f81f704c30786b$export$6fbaff484b0d9308(slot) {
    return (0, $aBqGi.default)('MuiStepConnector', slot);
}
const $d9f81f704c30786b$var$stepConnectorClasses = (0, $cDqLM.default)('MuiStepConnector', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'active',
    'completed',
    'disabled',
    'line',
    'lineHorizontal',
    'lineVertical'
]);
var $d9f81f704c30786b$export$2e2bcd8739ae039 = $d9f81f704c30786b$var$stepConnectorClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $f2b5067640a6490b$var$_excluded = [
    "className"
];
const $f2b5067640a6490b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            active && 'active',
            completed && 'completed',
            disabled && 'disabled'
        ],
        line: [
            'line',
            `line${(0, $4A7Fh.default)(orientation)}`
        ]
    };
    return (0, $doIAf.default)(slots, (0, $d9f81f704c30786b$export$6fbaff484b0d9308), classes);
};
const $f2b5067640a6490b$var$StepConnectorRoot = (0, $hikmr.default)('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        flex: '1 1 auto'
    }, ownerState.orientation === 'vertical' && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: 'absolute',
        top: 12,
        left: 'calc(-50% + 20px)',
        right: 'calc(50% + 20px)'
    }));
const $f2b5067640a6490b$var$StepConnectorLine = (0, $hikmr.default)('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $4A7Fh.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $h4XE0.default)({
        display: 'block',
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === 'horizontal' && {
        borderTopStyle: 'solid',
        borderTopWidth: 1
    }, ownerState.orientation === 'vertical' && {
        borderLeftStyle: 'solid',
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $f2b5067640a6490b$var$StepConnector = /*#__PURE__*/ $eeH7J.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepConnector'
    });
    const { className: className } = props, other = (0, $fbOaB.default)(props, $f2b5067640a6490b$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = 'horizontal' } = $eeH7J.useContext((0, $2d713390f1294458$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $eeH7J.useContext((0, $6577b62bdbdb7ce1$export$2e2bcd8739ae039));
    const ownerState = (0, $h4XE0.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $f2b5067640a6490b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($f2b5067640a6490b$var$StepConnectorRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)($f2b5067640a6490b$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
$f2b5067640a6490b$var$StepConnector.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $f2b5067640a6490b$export$2e2bcd8739ae039 = $f2b5067640a6490b$var$StepConnector;




var $dRzna = parcelRequire("dRzna");
'use client';
const $f1ee2ff54ecfec1a$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $f1ee2ff54ecfec1a$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, nonLinear: nonLinear, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            nonLinear && 'nonLinear',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $6cdde18522ceb6dc$export$797947b6292e28e1), classes);
};
const $f1ee2ff54ecfec1a$var$StepperRoot = (0, $hikmr.default)('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.nonLinear && styles.nonLinear
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'flex'
    }, ownerState.orientation === 'horizontal' && {
        flexDirection: 'row',
        alignItems: 'center'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.alternativeLabel && {
        alignItems: 'flex-start'
    }));
const $f1ee2ff54ecfec1a$var$defaultConnector = /*#__PURE__*/ (0, $dRzna.jsx)((0, $f2b5067640a6490b$export$2e2bcd8739ae039), {});
const $f1ee2ff54ecfec1a$var$Stepper = /*#__PURE__*/ $eeH7J.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepper'
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = 'div', connector: connector = $f1ee2ff54ecfec1a$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = 'horizontal' } = props, other = (0, $fbOaB.default)(props, $f1ee2ff54ecfec1a$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        nonLinear: nonLinear,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $f1ee2ff54ecfec1a$var$useUtilityClasses(ownerState);
    const childrenArray = $eeH7J.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $eeH7J.cloneElement(step, (0, $h4XE0.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $eeH7J.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $2d713390f1294458$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $dRzna.jsx)($f1ee2ff54ecfec1a$var$StepperRoot, (0, $h4XE0.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $er6YD.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
$f1ee2ff54ecfec1a$var$Stepper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */ activeStep: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */ alternativeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Two or more `<Step />` components.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */ connector: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).element,
    /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */ nonLinear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $f1ee2ff54ecfec1a$export$2e2bcd8739ae039 = $f1ee2ff54ecfec1a$var$Stepper;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");



var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $15f802b321ab8d8a$export$8977e0f3c012cfac(slot) {
    return (0, $aBqGi.default)('MuiStep', slot);
}
const $15f802b321ab8d8a$var$stepClasses = (0, $cDqLM.default)('MuiStep', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'completed'
]);
var $15f802b321ab8d8a$export$2e2bcd8739ae039 = $15f802b321ab8d8a$var$stepClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $444e2f34da61d4a1$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $444e2f34da61d4a1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            completed && 'completed'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $15f802b321ab8d8a$export$8977e0f3c012cfac), classes);
};
const $444e2f34da61d4a1$var$StepRoot = (0, $hikmr.default)('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({}, ownerState.orientation === 'horizontal' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: 'relative'
    }));
const $444e2f34da61d4a1$var$Step = /*#__PURE__*/ $eeH7J.forwardRef(function Step(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiStep'
    });
    const { active: activeProp, children: children, className: className, component: component = 'div', completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $fbOaB.default)(props, $444e2f34da61d4a1$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $eeH7J.useContext((0, $2d713390f1294458$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $eeH7J.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $h4XE0.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $444e2f34da61d4a1$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $dRzna.jsxs)($444e2f34da61d4a1$var$StepRoot, (0, $h4XE0.default)({
        as: component,
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $6577b62bdbdb7ce1$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $dRzna.jsxs)($eeH7J.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
$444e2f34da61d4a1$var$Step.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Sets the step as active. Is passed to child components.
   */ active: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Mark the step as completed. Is passed to child components.
   */ completed: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Expand the step.
   * @default false
   */ expanded: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */ index: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */ last: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $444e2f34da61d4a1$export$2e2bcd8739ae039 = $444e2f34da61d4a1$var$Step;



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");
parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $0621682f6c401dbb$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $bd09eb8cbb4e1d71$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');



var $2OuJK = parcelRequire("2OuJK");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $fb68be340cd11a3b$export$62a6e0748bec9297(slot) {
    return (0, $aBqGi.default)('MuiStepIcon', slot);
}
const $fb68be340cd11a3b$var$stepIconClasses = (0, $cDqLM.default)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $fb68be340cd11a3b$export$2e2bcd8739ae039 = $fb68be340cd11a3b$var$stepIconClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
var $684514ad1d4a8026$var$_circle;
const $684514ad1d4a8026$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $684514ad1d4a8026$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $fb68be340cd11a3b$export$62a6e0748bec9297), classes);
};
const $684514ad1d4a8026$var$StepIconRoot = (0, $hikmr.default)((0, $2OuJK.default), {
    name: 'MuiStepIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $fb68be340cd11a3b$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $fb68be340cd11a3b$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $fb68be340cd11a3b$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $684514ad1d4a8026$var$StepIconText = (0, $hikmr.default)('text', {
    name: 'MuiStepIcon',
    slot: 'Text',
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $684514ad1d4a8026$var$StepIcon = /*#__PURE__*/ $eeH7J.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $fbOaB.default)(props, $684514ad1d4a8026$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $684514ad1d4a8026$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $er6YD.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $dRzna.jsx)($684514ad1d4a8026$var$StepIconRoot, (0, $h4XE0.default)({
            as: (0, $bd09eb8cbb4e1d71$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $dRzna.jsx)($684514ad1d4a8026$var$StepIconRoot, (0, $h4XE0.default)({
            as: (0, $0621682f6c401dbb$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $dRzna.jsxs)($684514ad1d4a8026$var$StepIconRoot, (0, $h4XE0.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $684514ad1d4a8026$var$_circle || ($684514ad1d4a8026$var$_circle = /*#__PURE__*/ (0, $dRzna.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $dRzna.jsx)($684514ad1d4a8026$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
$684514ad1d4a8026$var$StepIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Whether this step is active.
   * @default false
   */ active: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */ completed: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the step is marked as failed.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The label displayed in the step icon.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $684514ad1d4a8026$export$2e2bcd8739ae039 = $684514ad1d4a8026$var$StepIcon;





var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $86dfef933b002d0c$export$9625a725551d158a(slot) {
    return (0, $aBqGi.default)('MuiStepLabel', slot);
}
const $86dfef933b002d0c$var$stepLabelClasses = (0, $cDqLM.default)('MuiStepLabel', [
    'root',
    'horizontal',
    'vertical',
    'label',
    'active',
    'completed',
    'error',
    'disabled',
    'iconContainer',
    'alternativeLabel',
    'labelContainer'
]);
var $86dfef933b002d0c$export$2e2bcd8739ae039 = $86dfef933b002d0c$var$stepLabelClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $eca79d5ed236d127$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $eca79d5ed236d127$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $86dfef933b002d0c$export$9625a725551d158a), classes);
};
const $eca79d5ed236d127$var$StepLabelRoot = (0, $hikmr.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'flex',
        alignItems: 'center',
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: 'column'
        },
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.orientation === 'vertical' && {
        textAlign: 'left',
        padding: '8px 0'
    }));
const $eca79d5ed236d127$var$StepLabelLabel = (0, $hikmr.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $h4XE0.default)({}, theme.typography.body2, {
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $eca79d5ed236d127$var$StepLabelIconContainer = (0, $hikmr.default)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer',
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: 'flex',
        paddingRight: 8,
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $eca79d5ed236d127$var$StepLabelLabelContainer = (0, $hikmr.default)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer',
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $86dfef933b002d0c$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: 'center'
        }
    }));
const $eca79d5ed236d127$var$StepLabel = /*#__PURE__*/ $eeH7J.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $fbOaB.default)(props, $eca79d5ed236d127$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $eeH7J.useContext((0, $2d713390f1294458$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $eeH7J.useContext((0, $6577b62bdbdb7ce1$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $684514ad1d4a8026$export$2e2bcd8739ae039);
    const ownerState = (0, $h4XE0.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $eca79d5ed236d127$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $dRzna.jsxs)($eca79d5ed236d127$var$StepLabelRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $dRzna.jsx)($eca79d5ed236d127$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $dRzna.jsx)(StepIconComponent, (0, $h4XE0.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $dRzna.jsxs)($eca79d5ed236d127$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $dRzna.jsx)($eca79d5ed236d127$var$StepLabelLabel, (0, $h4XE0.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $er6YD.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$eca79d5ed236d127$var$StepLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * In most cases will simply be a string containing a title for the label.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * If `true`, the step is marked as failed.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override the default label of the step icon.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The optional node to display.
   */ optional: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    }),
    /**
   * The component to render in place of the [`StepIcon`](/material-ui/api/step-icon/).
   */ StepIconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Props applied to the [`StepIcon`](/material-ui/api/step-icon/) element.
   */ StepIconProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
$eca79d5ed236d127$var$StepLabel.muiName = 'StepLabel';
var $eca79d5ed236d127$export$2e2bcd8739ae039 = $eca79d5ed236d127$var$StepLabel;




var $eeH7J = parcelRequire("eeH7J");
const $5b6094d1bc75836b$var$DNSProviders = ({ domain: domain, caddyServerIP: caddyServerIP })=>{
    const [openIndex, setOpenIndex] = (0, $eeH7J.useState)(null);
    const toggleAccordion = (index)=>{
        setOpenIndex(openIndex === index ? null : index);
    };
    let _isWWW = domain.split(".")[0] === "www" ? true : false;
    let _domain = "";
    if (domain.split(".").length === 2) _domain = "@";
    else if (domain.split(".").length === 3) _domain = domain.split(".")[0];
    console.log('_www', _isWWW, domain.replace("www.", ""));
    const items = [
        {
            title: 'GoDaddy',
            content: `<ol>
              <li>
                <b>Sign In to GoDaddy:</b>
                <ul>
                  <li>Log in to your GoDaddy account.</li>
                </ul>
              </li>
              <li>
                <b>Access Domain Settings:</b>
                <ul>
                  <li>Navigate to "My Products."</li>
                  <li>Find your domain and click on "DNS" or "Manage."</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Scroll down to the "Records" section.</li>
                  <li>Click "Add" to create a new DNS record.</li>
                  <li>Select ${_isWWW ? '"CNAME"' : '"A"'} as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Value:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Default
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click the pencil icon next to the record to edit it.</li>
                  <li>
                    Update the details as needed (e.g., change the ${_isWWW ? 'domain name' : 'IP address'} in
                    the "Value" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Cloudflare',
            content: `<ol>
              <li>
                <b>Sign In to Cloudflare:</b>
                <ul>
                  <li>Log in to your Cloudflare account.</li>
                </ul>
              </li>
              <li>
                <b>Access DNS Settings:</b>
                <ul>
                  <li>Select the domain you want to manage.</li>
                  <li>Click on the "DNS" tab.</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Click "Add record."</li>
                  <li>Select ${_isWWW ? '"CNAME"' : '"A"'} as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>${_isWWW ? 'value:' : 'IPv4 address:'}</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Auto
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click on the record to edit it.</li>
                  <li>
                    Update the details as needed (e.g., change the ${_isWWW ? 'domain name' : 'IP address'} in
                    the "IPv4 address" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Amazon Route 53',
            content: `<ol>
              <li>
                <b>Sign In to AWS Management Console:</b>
                <ul>
                  <li>Go to the AWS Management Console and log in.</li>
                </ul>
              </li>
              <li>
                <b>Access Route 53:</b>
                <ul>
                  <li>Navigate to Amazon Route 53.</li>
                  <li>Click on "Hosted Zones."</li>
                </ul>
              </li>
              <li>
                <b>Select Domain:</b>
                <ul>
                  <li>Choose the domain you want to manage.</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Click "Create Record Set."</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Type:</b> A - IPv4 address
                      </li>
                      <li>
                        <b>Value:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click on the record to edit it.</li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Value" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save Record Set."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Google Domains',
            content: `<ol>
              <li>
                <b>Sign In to Google Domains:</b>
                <ul>
                  <li>Go to Google Domains and log in to your account.</li>
                </ul>
              </li>
              <li>
                <b>Manage Domain:</b>
                <ul>
                  <li>Locate your domain and click on "Manage" or "DNS."</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Scroll down to the "Custom resource records" section.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Type:</b>  ${_isWWW ? 'CNAME' : 'A'}
                      </li>
                      <li>
                        <b>TTL:</b> 1h
                      </li>
                      <li>
                        <b>Data:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>
                    Click on the pencil icon next to the record to edit it.
                  </li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Data" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Namecheap',
            content: `<ol>
              <li>
                <b>Sign In to Namecheap:</b>
                <ul>
                  <li>Log in to your Namecheap account.</li>
                </ul>
              </li>
              <li>
                <b>Manage Domain:</b>
                <ul>
                  <li>Select the domain you want to manage.</li>
                  <li>Click on "Manage" next to the domain.</li>
                </ul>
              </li>
              <li>
                <b>Access Advanced DNS:</b>
                <ul>
                  <li>Click on the "Advanced DNS" tab.</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Scroll down to the "Host Records" section.</li>
                  <li>Click "Add New Record."</li>
                  <li>Select "${_isWWW ? 'CNAME' : 'A'} Record" as the type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Host Record:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Points To:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Automatic
                      </li>
                    </ul>
                  </li>
                  <li>Click the checkmark to save.</li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>
                    Click on the pencil icon next to the record to edit it.
                  </li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "IP Address" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click the checkmark to save.</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Bluehost',
            content: `<ol>
              <li>
                <b>Sign In to Namecheap:</b>
                <ul>
                  <li>Log in to your Bluehost account.</li>
                </ul>
              </li>
              <li>
                <b>Access Domain Manager:</b>
                <ul>
                  <li>
                    From the Bluehost dashboard, click on "Domains" and then "My
                    Domains."
                  </li>
                </ul>
              </li>
              <li>
                <b>Manage DNS:</b>
                <ul>
                  <li>
                    Click the "Manage" button next to the domain you want to
                    update.
                  </li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Go to the "DNS" tab.</li>
                  <li>Scroll down to the "Add DNS Record" section.</li>
                  <li>Select "${_isWWW ? 'CNAME' : 'A'}" as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Host Record:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Points To:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Default
                      </li>
                    </ul>
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click "Edit" next to the record.</li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Points To" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'HostGator',
            content: `<ol>
              <li>
                <b>Sign In to HostGator:</b>
                <ul>
                  <li>Log in to your HostGator account.</li>
                </ul>
              </li>
              <li>
                <b>Access Domain Manager:</b>
                <ul>
                  <li>
                    From the HostGator dashboard, click on "Domains" and then
                    "My Domains."
                  </li>
                </ul>
              </li>
              <li>
                <b>Manage DNS:</b>
                <ul>
                  <li>
                    Click the "Manage" button next to the domain you want to
                    update.
                  </li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Go to the "DNS" tab.</li>
                  <li>Scroll down to the "Add DNS Record" section.</li>
                  <li>Select "${_isWWW ? 'CNAME' : 'A'}" as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Host Record:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Points To:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Default
                      </li>
                    </ul>
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'}  Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'}  record you want to update.</li>
                  <li>Click "Edit" next to the record.</li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Points To" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ul", {
        className: "border border-gray-200 rounded-lg list-none p-0 mt-2"
    }, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", {
            key: index,
            className: "border-b border-gray-200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
            onClick: ()=>toggleAccordion(index),
            className: "accordion-header w-full text-left px-4 py-2 focus:outline-none focus:ring focus:ring-gray-300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, item.title)), openIndex === index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "accordion-content px-4 py-2 font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: item.content
            }
        }))))));
};
var $5b6094d1bc75836b$export$2e2bcd8739ae039 = $5b6094d1bc75836b$var$DNSProviders;


const $083eb880fe9354d8$var$CustomDomainModal = ({ siteId: siteId, domainName: domainName, isOpen: isOpen, onClose: onClose, showStepper: showStepper, isPointDNS: isPointDNS })=>{
    const [domain, setDomain] = (0, $eeH7J.useState)(domainName);
    const [isValid, setIsValid] = (0, $eeH7J.useState)(false);
    const [showValidattionError, setShowValidationError] = (0, $eeH7J.useState)(false);
    const [isChecked, setIsChecked] = (0, $eeH7J.useState)(false);
    // const [isSubDomain, setIsSubDomain] = useState(false);
    const [isPrimary, setIsPrimary] = (0, $eeH7J.useState)(true);
    const [stepperActive, setStepperActive] = (0, $eeH7J.useState)(showStepper);
    const [showPointDNS, setShowPointDNS] = (0, $eeH7J.useState)(isPointDNS);
    const [caddyServerIP, setCaddyServerIP] = (0, $eeH7J.useState)("143.198.78.133");
    const steps = [
        "Add domain",
        "Point DNS"
    ];
    // Function to handle subdomain input change
    const handleSubdomainChange = (event)=>{
        setDomain(event.target.value);
        const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Change the pattern as needed
        const isValidDomain = domainPattern.test(event.target.value);
        setIsValid(isValidDomain);
        setShowValidationError(false);
    };
    // Function to handle form submission
    const onAddDomain = async (event)=>{
        event.preventDefault();
        setShowValidationError(!isValid);
        if (isValid) {
            // onClose(domain);
            let data = {
                siteId: siteId
            };
            try {
                data = {
                    ...data,
                    domain: domain,
                    isPrimary: isPrimary
                };
                await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/custom-domain", data);
                if (isChecked) {
                    data = {
                        ...data,
                        domain: `www.${domain}`,
                        isPrimary: false
                    };
                    await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/custom-domain", data);
                }
                setStepperActive(true);
                setShowPointDNS(false);
            } catch (err) {
                console.log(err);
            }
        }
    };
    const getCaddyServerIP = ()=>{
        let currentURL = window.location.href;
        if (currentURL.includes("app.rocketpages.io")) setCaddyServerIP("146.190.156.136");
        else setCaddyServerIP("143.198.78.133");
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useEffect(()=>{
        // Actually runs when isOpen changes
        getCaddyServerIP();
        return ()=>{
            setDomain("");
            setIsValid(false);
            setShowValidationError(false);
            //setStepperActive(false);
            //setShowPointDNS(false);
            setIsChecked(false);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `fixed z-50 inset-0 overflow-y-auto ${isOpen ? "block" : "hidden"}`
    }, stepperActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-center justify-center min-h-screen p-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed inset-0 bg-black opacity-50"
    }), showPointDNS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-slate-100 rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20 add-domain-popup-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h2", {
        className: "text-lg font-semibold mb-2 mt-0"
    }, "Update your DNS records at your DNS provider"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-xsm mb-0"
    }, "Create a records for ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("b", null, domain), isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, " ", "and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("b", null, "www.", domain)), " ", "with your domain provider so they can direct traffic to your site."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $5b6094d1bc75836b$export$2e2bcd8739ae039), {
        domain: domain,
        caddyServerIP: caddyServerIP
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-end mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "save",
        className: "sm:w-32 py-1 z-0 mb-2.5 sm:mb-0 h-[52] sm:h-auto",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: onClose
    }, "Ok I've done this"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "I'll do this later")))), !showPointDNS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-slate-100 rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20 add-domain-popup-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $f1ee2ff54ecfec1a$export$2e2bcd8739ae039), {
        activeStep: 0,
        alternativeLabel: true
    }, steps.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $444e2f34da61d4a1$export$2e2bcd8739ae039), {
            key: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $eca79d5ed236d127$export$2e2bcd8739ae039), null, label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20 mt-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h2", {
        className: "text-lg font-semibold mb-2 mt-0"
    }, "Your domain has been added to your environment."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-xsm mb-1"
    }, "The final step when taking your site live is to update your DNS records. This will route web traffic from your domain to your site hosted on Rocket Pages IO's server. Most of the time you will update these records at your domain registrar - where your domain was purchased."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-end mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "save",
        className: "sm:w-32 py-1 z-0 mb-2.5 sm:mb-0 h-[52] sm:h-auto",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>{
            setStepperActive(true);
            setShowPointDNS(true);
        }
    }, "Point DNS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "I'll do this later"))))), !stepperActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-center justify-center min-h-screen p-4 add-domain-popup-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed inset-0 bg-black opacity-50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h2", {
        className: "text-xl font-semibold mb-2 mt-0"
    }, "What is your domain (URL)?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-sm font-semibold mb-1"
    }, "Domain"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-xsm  mb-2"
    }, "e.g. mydomain.com"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        type: "text",
        className: "w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:border-[#243060]-300",
        // placeholder="Enter subdomain"
        value: domain,
        onChange: handleSubdomainChange
    }), showValidattionError && !isValid && domain !== "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: `text-red-500 mt-1 ${domain === "" ? "hidden" : ""}`
    }, "Please enter a valid domain name.") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-row mt-2 -ml-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
        disabled: !(isValid && domain.substring(0, 3) !== "www"),
        checked: isChecked,
        onChange: ()=>setIsChecked(!isChecked),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: `mb-0 self-center ${isValid && domain.substring(0, 3) !== "www" ? "cursor-pointer" : ""} text-xsm`,
        onClick: ()=>{
            if (isValid && domain.substring(0, 3) !== "www") setIsChecked(!isChecked);
        }
    }, `Also add www.${domain} ?`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-row -ml-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
        // disabled={!(isValid && domain.substring(0, 3) !== "www")}
        checked: isPrimary,
        onChange: ()=>setIsPrimary(!isPrimary),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: `mb-0 self-center cursor-pointer text-xsm`,
        onClick: ()=>{
            setIsPrimary(!isPrimary);
        }
    }, `Set this domain as primary domain`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-end mt-4 sm:mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "save",
        className: "sm:w-32 py-1 z-0 mb-2.5 sm:mb-0 h-[52] sm:h-auto",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: onAddDomain
    }, "Add domain"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "Close"))))));
};
var $083eb880fe9354d8$export$2e2bcd8739ae039 = $083eb880fe9354d8$var$CustomDomainModal;



var $eeH7J = parcelRequire("eeH7J");
const $3df569444812dcbb$var$CustomDomainHelpTextModal = ({ siteId: siteId, domainName: domainName, isOpen: isOpen, onClose: onClose })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useEffect(()=>{}, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `fixed z-50 inset-0 overflow-y-auto ${isOpen ? "block" : "hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-center justify-center min-h-screen p-4 add-domain-popup-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed inset-0 bg-black opacity-50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", {
        className: "text-lg font-semibold mb-2 mt-0"
    }, "Connecting a Custom Domain and Setting a Primary Domain"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-sm/6 mb-4"
    }, "A ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "primary domain"), " is the main domain where your site will be served. If you add multiple custom domains, you can set", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "one"), " as your primary domain."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-sm mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "If you don\u2019t set any domain as primary, your site will still be available but will use your default RocketPages subdomain (e.g.,", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "yourproject.rocketpagesweb.com"), "), even if you\u2019ve added a custom domain."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "When adding a custom domain, you can choose to use it with or without ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "www"), " (for example,", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "www.example.com"), " or ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "example.com"), "). The version with ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "www"), " is technically a subdomain, while the version without is called the root or apex domain. Both work the same \u2014 you can pick whichever you prefer."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "It\u2019s best practice to add both versions so your visitors can reach your site no matter which one they type."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "If you attach a custom domain but don\u2019t validate it, your site will continue to use your RocketPages subdomain until the domain is validated. We strongly recommend validating your domain to ensure secure and reliable delivery."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-end mt-4 sm:mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "Close"))))));
};
var $3df569444812dcbb$export$2e2bcd8739ae039 = $3df569444812dcbb$var$CustomDomainHelpTextModal;








const $3649fa2aef7877ab$var$ConfigDomain = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [anchorEl, setAnchorEl] = $eeH7J.useState(null);
    const [value, setValue] = $eeH7J.useState(props.selectedDomainTab);
    const open = Boolean(anchorEl);
    const [moreOptionMenu, setMoreOptionMenu] = $eeH7J.useState();
    const handleChange = (event, newValue)=>{
        setValue(newValue);
        props.onTabChange(newValue);
    };
    const [isOpen, setIsOpen] = $eeH7J.useState(false);
    const [isModalOpen, setIsModalOpen] = $eeH7J.useState(false);
    const [domains, setDomains] = $eeH7J.useState([]);
    const [domainWiseCount, setDomainWiseCount] = $eeH7J.useState([]);
    const [reloadDomains, setReloadDomains] = $eeH7J.useState(false);
    const [currentDomainName, setCurrentDomainName] = $eeH7J.useState("");
    const [isPointDNS, setIsPointDNS] = $eeH7J.useState(false);
    const [isStepper, setIsStepper] = $eeH7J.useState(false);
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const [textClassObj] = $eeH7J.useState([
        {
            fontSize: "14px",
            color: "#243060"
        },
        {
            "&:hover": {
                fontWeight: 700
            }
        }
    ]);
    const handleClick = (event, domain)=>{
        // console.log('sssss', domain, isValidated, isPrimary)
        setMoreOptionMenu(domain);
        setAnchorEl(event.currentTarget);
    };
    $eeH7J.useEffect(()=>{
        async function fetchDomainData(siteId) {
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/site-domains?siteId=${siteId}`);
            // console.log("//", response.data);
            setDomains(response.data.data);
            let domainWiseCount = [];
            response.data.data.forEach((row)=>{
                let idx = domainWiseCount.findIndex((kk)=>kk.domain === row.domain.replace("www.", ""));
                if (idx === -1) domainWiseCount.push({
                    domain: row.domain.replace("www.", ""),
                    cnt: 1
                });
                else domainWiseCount[idx].cnt += 1;
            });
            // console.log("domainWiseCount", domainWiseCount);
            setDomainWiseCount(domainWiseCount);
        }
        fetchDomainData(props.siteId);
    }, [
        isOpen,
        reloadDomains
    ]);
    // Function to handle domain validation
    const handleValidate = async (domain)=>{
        props.setIsCheckingSSL(true);
        let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/validate-custom-domain`, {
            siteId: props.siteId,
            domain: domain
        });
        if (response.data.data.isValidated === "true") {
            if (props.isPublished) handleCheckSSL(domain);
            else {
                setReloadDomains(!reloadDomains);
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validated successfully!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            }
        } else {
            props.setIsCheckingSSL(false);
            enqueueSnackbar("Domain validation failed!", {
                variant: "error",
                className: "bg-grey-400"
            });
        }
    };
    const handleCheckSSL = async (domain)=>{
        let checkInterval = setInterval(async ()=>{
            const sslResponse = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/check-ssl?url=https://${domain}`);
            if (sslResponse.status === 200) {
                clearInterval(checkInterval);
                checkInterval = false;
                setReloadDomains(!reloadDomains);
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validated successfully!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            } else if (sslResponse.status === 500) {
                clearInterval(checkInterval);
                checkInterval = false;
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validation failed!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            }
        }, 5000);
        setTimeout(()=>{
            if (checkInterval) {
                clearInterval(checkInterval);
                checkInterval = false;
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validation failed!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            }
        }, 300000);
    };
    const handleSetPrimaryDomain = (domainName)=>{
        async function setPrimaryCustomDomain(siteId, domain) {
            props.setIsLoading(true);
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/set-primary-domain`, {
                siteId: siteId,
                domain: domain
            });
            if (response.status === 200) {
                if (props.isPublished) props.checkPublishStatus("Primary domain set successfully!");
                setReloadDomains(!reloadDomains);
            } else props.setIsLoading(false);
        }
        // console.log("onsetprimarydomain", props.siteId, domainName);
        setPrimaryCustomDomain(props.siteId, domainName);
    };
    const handleDelete = (domainName)=>{
        async function deleteCustomDomain(siteId, domain) {
            try {
                props.setIsLoading(true);
                let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/delete-custom-domain`, {
                    siteId: siteId,
                    domain: domain
                });
                // console.log("//", response.data);
                props.setIsLoading(false);
                setReloadDomains(!reloadDomains);
                enqueueSnackbar("Domain deleted successfully!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            } catch (err) {
                props.setIsLoading(false);
                enqueueSnackbar(err.response.data.message, {
                    variant: "error",
                    className: "bg-grey-400"
                });
            }
        }
        deleteCustomDomain(props.siteId, domainName);
    };
    function isValidSubdomain(subdomain) {
        // Regular expression to validate subdomain
        const subdomainRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?$/;
        // Check if the subdomain matches the regex
        return subdomainRegex.test(subdomain);
    }
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black h-screen  left-sidebar-domain"
    }, isOpen && /*#__PURE__*/ $eeH7J.createElement((0, $083eb880fe9354d8$export$2e2bcd8739ae039), {
        siteId: props.siteId,
        showStepper: isPointDNS && isStepper,
        isOpen: isOpen,
        domainName: currentDomainName,
        onClose: ()=>setIsOpen(false),
        isPointDNS: isPointDNS
    }), isModalOpen && /*#__PURE__*/ $eeH7J.createElement((0, $3df569444812dcbb$export$2e2bcd8739ae039), {
        siteId: props.siteId,
        isOpen: isModalOpen,
        domainName: currentDomainName,
        onClose: ()=>setIsModalOpen(false)
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white-smoke z-0"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1ebad4d8fc8d8546$export$2e2bcd8739ae039), {
        value: value
    }, /*#__PURE__*/ $eeH7J.createElement((0, $6146074d8a2c7938$export$2e2bcd8739ae039), {
        value: value,
        onChange: handleChange,
        indicatorColor: "secondary",
        variant: "scrollable",
        allowScrollButtonsMobile: true,
        "aria-label": "full width tabs example",
        scrollButtons: "auto",
        className: "domain-tabs"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $6878910a69f430c4$export$2e2bcd8739ae039), {
        value: "subdomain",
        label: "Rocket Pages Domain"
    }), /*#__PURE__*/ $eeH7J.createElement((0, $6878910a69f430c4$export$2e2bcd8739ae039), {
        value: "customdomain",
        label: "Custom Domain"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $77641e8807ec5b93$export$2e2bcd8739ae039), {
        value: "subdomain",
        className: "px-0 bg-white-smoke z-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Subdomain"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-4"
    }, "After publishing, this domain name will serve as your website's address, making it easily accessible to your customers or viewers."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col lg:flex-row font-normal lg:items-baseline"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "mr-3"
    }, "https://"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("input", {
        // disabled
        className: "border rounded border-catelina-blue/60 w-full sm:w-80 py-1 px-2",
        placeholder: "xyzwebsite",
        value: props.subDomain,
        onChange: (e)=>{
            let tmp_ErrorMessage = "";
            if (e.target.value.toLowerCase() === "") tmp_ErrorMessage = "Subdomain can't be empty!";
            else if ((e.target.value.toLowerCase() === "app" || e.target.value.toLowerCase() === "server" || e.target.value.toLowerCase() === "editor" || e.target.value.toLowerCase() === "apps" || e.target.value.toLowerCase() === "rocketpages" || e.target.value.toLowerCase() === "admin" || e.target.value.toLowerCase() === "support" || e.target.value.toLowerCase() === "billing" || e.target.value.toLowerCase() === "blog" || e.target.value.toLowerCase() === "docs" || e.target.value.toLowerCase() === "dashboard" || e.target.value.toLowerCase() === "marketplace" || e.target.value.toLowerCase() === "marketing" || e.target.value.toLowerCase() === "account" || e.target.value.toLowerCase() === "feedback" || e.target.value.toLowerCase() === "login" || e.target.value.toLowerCase() === "status" || e.target.value.toLowerCase() === "preview") && props.userData.role !== "admin") tmp_ErrorMessage = "Invalid Subdomain!";
            else if (isValidSubdomain(e.target.value.toLowerCase())) tmp_ErrorMessage = "";
            else tmp_ErrorMessage = "Invalid Subdomain!";
            props.onDataChange({
                subDomain: e.target.value.toLowerCase(),
                subDomainErrorMessage: tmp_ErrorMessage
            });
        }
    }), props.subDomainErrorMessage !== "" && /*#__PURE__*/ $eeH7J.createElement("span", {
        className: `text-sm mx-1 ${"text-red-500"}`
    }, props.subDomainErrorMessage)), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "lg:ml-3"
    }, ".rocketpagesstage.com")))), /*#__PURE__*/ $eeH7J.createElement((0, $77641e8807ec5b93$export$2e2bcd8739ae039), {
        value: "customdomain",
        className: "px-0 bg-white-smoke z-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col md:flex-row mb-5 lg:mb-10 pl-3 space-y-2 md:space-y-0 md:items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-sm md:text-base"
    }, "\u2139\uFE0F Connecting a Custom Domain and Setting a Primary Domain.", /*#__PURE__*/ $eeH7J.createElement("a", {
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            setIsModalOpen(true);
        },
        className: "py-1 px-1 text-blue-600 rounded text-sm w-fit inline-block"
    }, "Learn more."))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row justify-start max-w-lg"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "save",
        className: "w-40 py-1 z-0",
        sx: {
            textTransform: "none"
        },
        onClick: ()=>{
            setIsOpen(true);
            setIsPointDNS(false);
            setIsStepper(false);
        },
        disabled: domainWiseCount.length > 0,
        size: "small",
        variant: "contained"
    }, "Add Custom Domain")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row justify-between font-normal items-center mt-4"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "overflow-x-auto"
    }, /*#__PURE__*/ $eeH7J.createElement("table", {
        className: "min-w-full divide-y divide-gray-200 mb-0"
    }, /*#__PURE__*/ $eeH7J.createElement("thead", null, /*#__PURE__*/ $eeH7J.createElement("tr", null, /*#__PURE__*/ $eeH7J.createElement("th", {
        className: "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 w-72 tracking-wider"
    }, "Domains"), /*#__PURE__*/ $eeH7J.createElement("th", {
        className: "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 w-36 tracking-wider"
    }, "Status"), /*#__PURE__*/ $eeH7J.createElement("th", {
        className: "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 w-20 tracking-wider"
    }, "Actions"))), /*#__PURE__*/ $eeH7J.createElement("tbody", {
        className: "bg-white divide-y divide-gray-200"
    }, domains.length > 0 && domains.map((rr)=>{
        // console.log("rr", rr);
        let l_domainName = rr.domain;
        return /*#__PURE__*/ $eeH7J.createElement("tr", {
            key: rr.domain
        }, /*#__PURE__*/ $eeH7J.createElement("td", {
            className: "px-6 py-4 whitespace-no-wrap"
        }, rr.domain, rr.isPrimary ? /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "mx-2 px-2 inline-flex text-xsm leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
        }, "Primary") : null), /*#__PURE__*/ $eeH7J.createElement("td", {
            className: "px-6 py-4 whitespace-no-wrap"
        }, rr.isValidated === "true" ? /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "px-2 inline-flex text-xsm leading-5 font-semibold rounded-full bg-green-100 text-green-800"
        }, "Valid") : /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "px-2 inline-flex text-xsm leading-5 font-semibold rounded-full bg-red-100 text-red-800"
        }, "Invalid")), /*#__PURE__*/ $eeH7J.createElement("td", {
            className: "px-6 py-4 whitespace-no-wrap flex flex-row justify-end"
        }, rr.isValidated !== "true" && /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            className: "py-1 px-3 z-0 capitalize",
            onClick: ()=>handleValidate(rr.domain),
            size: "small",
            variant: "contained"
        }, "Validate"), /*#__PURE__*/ $eeH7J.createElement("button", {
            className: "w-10 mx-2",
            onClick: (e)=>{
                handleClick(e, rr);
            }
        }, /*#__PURE__*/ $eeH7J.createElement("img", {
            // onClick={() => {
            //   props.onMoreOptionClick(rr.domain, rr.isValidated === "true", rr.isPrimary)
            // }}
            className: "w-[36px] hover:cursor-pointer",
            // src={require("../../images/extra-option.svg")}
            src: (parcelRequire("5Ggop")),
            alt: ""
        }))));
    })), moreOptionMenu && /*#__PURE__*/ $eeH7J.createElement((0, $e81d86cc7ed08456$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        id: "account-menu",
        open: open,
        onClose: handleClose,
        onClick: handleClose,
        PaperProps: {
            elevation: 0,
            sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                },
                "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0
                }
            }
        },
        transformOrigin: {
            horizontal: "right",
            vertical: "top"
        },
        anchorOrigin: {
            horizontal: "right",
            vertical: "bottom"
        },
        className: "domain-menu-list"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        sx: textClassObj,
        disabled: moreOptionMenu.isPrimary,
        onClick: ()=>{
            // console.log("ccc", moreOptionMenu.domain);
            handleSetPrimaryDomain(moreOptionMenu.domain);
        }
    }, "Set as primary domain"), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        sx: textClassObj,
        disabled: moreOptionMenu.isValidated === "true" ? true : false,
        onClick: ()=>handleValidate(moreOptionMenu.domain)
    }, "Validate domain"), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        sx: textClassObj,
        onClick: ()=>{
            setIsPointDNS(true);
            setIsOpen(true);
            setIsStepper(true);
            setCurrentDomainName(moreOptionMenu.domain);
        }
    }, "Update DNS"), /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), {
        sx: [
            {
                marginTop: 2,
                marginBottom: 2
            }
        ]
    }), /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
        sx: [
            ...textClassObj,
            {
                color: "#F00"
            }
        ],
        onClick: ()=>handleDelete(moreOptionMenu.domain)
    }, "Delete"))))))))));
};
var $3649fa2aef7877ab$export$2e2bcd8739ae039 = $3649fa2aef7877ab$var$ConfigDomain;



var $eeH7J = parcelRequire("eeH7J");




const $8cf81ed6e510d7ef$var$ConfigGeneral = (props)=>{
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "left-sidebar-gereral"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black site-name"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Site name"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-4"
    }, "A site name is a unique identifier for a website, aiding in easy organization and navigation within the dashboard."), /*#__PURE__*/ $eeH7J.createElement("input", {
        className: "border rounded border-catelina-blue/60 w-full py-1 px-2 md:w-80",
        placeholder: "Website name",
        value: props.siteName,
        //   disabled
        onChange: (e)=>{
            props.onDataChange({
                siteName: (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value)
            });
        }
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement((0, $ff983ef19f38fcda$export$2e2bcd8739ae039), {
        className: "favicon-image",
        image_url: props.faviconImage,
        siteId: props.siteId,
        title: "Favicon image",
        desc: "Favicon is displayed on your site's tab in a browser.",
        notes: "Please upload a 16x16px .PNG or .JPG image.",
        onImageChange: (img_url)=>{
            props.onDataChange({
                faviconImage: img_url
            });
        }
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement((0, $ff983ef19f38fcda$export$2e2bcd8739ae039), {
        className: "og-image",
        siteId: props.siteId,
        image_url: props.defaultSocialMediaImage,
        title: "Default social media image (Open graph image)",
        desc: "Open Graph images, also known as OG images, are designated images used to represent webpages when shared on social media platforms. They provide a visual representation of the content and help maintain a consistent and visually appealing appearance across different social media channels.",
        notes: "Please upload a 1200x630px .PNG or .JPG image.",
        onImageChange: (img_url)=>{
            props.onDataChange({
                defaultSocialMediaImage: img_url
            });
        }
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2 mt-4"
    }, "Alt text"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "Alt text for the image provide accessibility and additional information for use."), /*#__PURE__*/ $eeH7J.createElement("input", {
        className: "border rounded border-catelina-blue/60 w-full py-1 px-2 md:w-80",
        value: props.defaultSocialMediaImageAlt,
        onChange: (e)=>{
            props.onDataChange({
                defaultSocialMediaImageAlt: (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value)
            });
        }
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "items-center text-xsm"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        fontSize: "inherit"
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "ml-1"
    }, "Please enter social media image alt text."))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Default social media description (Open graph description)"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-4"
    }, "The Open Graph description enhances the appearance of your content when shared on platforms like Facebook and Twitter, helping to engage users and encourage clicks."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("textarea", {
        value: props.defaultSocialMediaDescription,
        onChange: (e)=>{
            props.onDataChange({
                defaultSocialMediaDescription: e.target.value
            });
        },
        className: "w-full lg:w-4/5 border rounded border-catelina-blue/60 py-1 px-2",
        rows: 4
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "items-center text-xsm"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        fontSize: "inherit"
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "ml-1 leading-normal"
    }, "This description will be used across all pages when a page-specific description is not provided. Write a brief, engaging summary (up to 160 characters) that represents your website or brand. It will appear in search results, social media previews (under the 'meta,' 'og,' and 'twitter' tags), and when shared on platforms like Facebook and Twitter."))));
};
var $8cf81ed6e510d7ef$export$2e2bcd8739ae039 = $8cf81ed6e510d7ef$var$ConfigGeneral;










var $eeH7J = parcelRequire("eeH7J");



const $2bbfebce2ca648bf$var$ConfigPricingPlan = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const [isYearly, setIsYearly] = (0, $eeH7J.useState)(false);
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const [planToBuy, setPlanToBuy] = (0, $eeH7J.useState)(null);
    const isQATeam = cookies?.rp_user_data?.role === "admin";
    const planFeatures = [
        {
            plan: "Forever Free",
            features: [
                "Attach custom domain",
                "Upto 1 GB storage",
                "Upto 10,000 visitors/month",
                "5 Contact form submissions/month",
                "Upto 1GB/month bandwidth",
                "Unlimited pages",
                "Unlimited team members",
                "Free SSL"
            ]
        },
        {
            plan: "Pro",
            features: [
                "Everything from Forever Free plan",
                "5 GB storage",
                "Upto 50,000 visitors/month",
                "50 Contact form submissions/month",
                "5 GB/month bandwidth",
                "No RocketPages branding"
            ]
        },
        {
            plan: "Business",
            features: [
                "Everything from Pro plan",
                "100 GB storage",
                "Upto 500,000 visitors/month",
                "Unlimited contact form submissions",
                "Unlimited bandwidth"
            ]
        }
    ];
    if (isQATeam) {
        if (!planFeatures.find((planFeature)=>planFeature.plan === "QA Only")) planFeatures.push({
            plan: "QA Only",
            features: [
                "Everything from Pro plan",
                "100 GB storage",
                "Upto 500,000 visitors/month",
                "Unlimited contact form submissions",
                "Unlimited bandwidth"
            ]
        });
    }
    const togglePricing = ()=>{
        setIsYearly(!isYearly);
    };
    // Check if the active subscription matches a given plan card,
    // handling old/unrecognized price IDs via selectedPlan fallback
    function isCurrentPlan(plan) {
        if (!props.activeSub) return false;
        if (props.activeSub.plan_id === plan.priceId) return true;
        const sp = props.activeSub.selectedPlan;
        return sp && sp.plan === plan.plan && sp.duration === plan.duration;
    }
    function checkPlanStatus(currentPlan) {
        if (props.activeSub?.selectedPlan && currentPlan && props.activeSub?.selectedPlan.price > currentPlan.price) return "Downgrade";
        else return "Upgrade";
    }
    function upgradeSubscription(plan) {
        if (isCurrentPlan(plan) && props.activeSub?.cancel_at_period_end) resumeSubscription();
        else if (props.activeSub?.plan_id) setPlanToBuy(plan);
        else createStripeCheckout(plan.priceId);
    }
    async function createStripeCheckout(priceId) {
        setIsLoading(true);
        let data = JSON.stringify({
            priceId: priceId,
            email: cookies.rp_user_data.email,
            siteId: props.id
        });
        setPlanToBuy(null);
        let config = {
            method: "post",
            mode: "no-cors",
            maxBodyLength: Infinity,
            url: `${"https://apistage.rocketpages.io"}/api/configs/create-stripe-checkout-session`,
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            data: data
        };
        let res = await (0, $33a3fff7c402f495$export$2e2bcd8739ae039).request(config);
        if (res.data.sessionUrl) window.location.href = res.data.sessionUrl;
        else {
            if (res.data.error) {
                setIsLoading(false);
                enqueueSnackbar(res.data.error, {
                    variant: "error",
                    className: "bg-catelina-blue"
                });
                return;
            } else if (res.data.status && res.data.msg) {
                setIsLoading(false);
                const isDowngrade = res.data.msg.toLowerCase().includes("downgrade");
                if (isDowngrade && res.data.subscription?.subscription_end) {
                    const endDate = new Date(res.data.subscription.subscription_end * 1000).toLocaleDateString(undefined, {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    });
                    enqueueSnackbar(`Your plan will be downgraded on ${endDate}. You can continue using your current features until then.`, {
                        variant: "success",
                        className: "bg-catelina-blue",
                        autoHideDuration: 9000
                    });
                } else enqueueSnackbar(res.data.msg, {
                    variant: "success",
                    className: "bg-catelina-blue"
                });
                props.updateActiveSub(res.data.subscription);
                props.reFetch();
                return;
            }
        }
    }
    async function resumeSubscription() {
        setIsLoading(true);
        let data = JSON.stringify({
            subscriptionId: props.activeSub.subscriptionId,
            email: cookies.rp_user_data.email,
            siteId: props.id
        });
        let config = {
            method: "put",
            mode: "no-cors",
            maxBodyLength: Infinity,
            url: `${"https://apistage.rocketpages.io"}/api/configs/site-config-resume-subscription`,
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            data: data
        };
        let res = await (0, $33a3fff7c402f495$export$2e2bcd8739ae039).request(config);
        if (!res.data.error && res.data.status && !res.data.subscription.cancel_at_period_end) {
            setIsLoading(false);
            enqueueSnackbar("Your subscription is resumed.", {
                variant: "success",
                className: "bg-catelina-blue"
            });
            props.updateActiveSub(res.data.subscription);
            props.reFetch();
        } else {
            setIsLoading(false);
            enqueueSnackbar(res.data.error ?? "Something went wrong while resuming subscription", {
                variant: "error",
                autoHideDuration: 9000
            });
        }
    }
    return /*#__PURE__*/ $eeH7J.createElement("section", {
        id: "plans",
        className: "config-pricing-plan flex flex-col justify-center items-center w-full"
    }, !!planToBuy && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white max-w-md rounded-lg py-6 px-6 md:px-10 m-4 z-50 items-center flex text-center flex-col relative"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("1o8uV")),
        className: "absolute right-3 top-3 cursor-pointer",
        onClick: ()=>setPlanToBuy(null)
    }), /*#__PURE__*/ $eeH7J.createElement("h4", {
        className: "mb-1",
        style: {
            color: "#243060"
        }
    }, "Update to ", planToBuy?.plan, " (", planToBuy?.duration, "ly)"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-500 mb-3 text-sm"
    }, "You are currently on the", " ", /*#__PURE__*/ $eeH7J.createElement("strong", null, props.activeSub?.selectedPlan?.plan, " (", props.activeSub?.selectedPlan?.duration, "ly)"), " ", "plan which expires on", " ", new Date(props.activeSub?.subscription_end * 1000).toLocaleDateString("en-GB"), "."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-[#F7F8FA] rounded p-3 mb-3 w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-600 mb-0 text-sm font-normal leading-5"
    }, props.activeSub?.selectedPlan?.price > planToBuy?.price ? "Your new plan will take effect at the end of your current billing cycle. You will not be charged immediately." : "Your new plan will start and you will be charged immediately. Your current plan will be replaced.")), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "shadow-none w-full",
        disabled: isLoading,
        size: "large",
        variant: "contained",
        color: "primary",
        onClick: ()=>createStripeCheckout(planToBuy.priceId)
    }, "Update Plan"))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "billing-cycle"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        className: "flex mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        className: "mask-box"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        className: "mask",
        style: {
            transform: `translateX(${isYearly === false ? 0 : "100px"})`
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        disableRipple: true,
        variant: "text",
        sx: {
            color: isYearly === false ? "#ffffff" : "#243060"
        },
        onClick: ()=>togglePricing()
    }, "Monthly"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        disableRipple: true,
        variant: "text",
        sx: {
            color: isYearly === true ? "#ffffff" : "#243060"
        },
        onClick: ()=>togglePricing()
    }, "Yearly")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex relative flex-col lg:flex-row grid grid-col-1 lg:grid-cols-3 md:grid-cols-1 gap-2 pricing-wrapper"
    }, props.plans.filter((plan)=>plan.duration === (isYearly ? "year" : "month")).map((plan, index)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $9cd9945bb4eead3d$export$2e2bcd8739ae039), {
            key: index,
            sx: {},
            className: "lg:m-0 mt-2 md:mt-0 shadow-none border border-gray p-2 rounded-lg  flex flex-col justify-between max-w-sm lg:max-w-auto w-full lg:w-auto m-auto"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $e769f4d48b989a5f$export$2e2bcd8739ae039), {
            className: "relative p-0"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
            className: "flex  border-b border-gray pb-3.5"
        }, /*#__PURE__*/ $eeH7J.createElement("h4", {
            className: "text-center m-0 pr-2",
            style: {
                color: "#243060"
            }
        }, plan.plan), !props.isLoading && (isCurrentPlan(plan) && props.activeSub?.subscription_status === "active" || props.activeSub === undefined && plan.priceId == "") && /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "border m-0 text-xs rounded-xl bg-catelina-blue text-white px-2",
            style: {
                fontSize: "12px"
            }
        }, "Current Plan")), /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
            className: "py-3.5 border-b border-gray"
        }, /*#__PURE__*/ $eeH7J.createElement("h4", {
            className: "m-0 flex items-center",
            style: {
                color: "#3B3B3B"
            }
        }, /*#__PURE__*/ $eeH7J.createElement("sup", null, "$"), /*#__PURE__*/ $eeH7J.createElement("span", {
            style: {
                fontSize: "38px"
            }
        }, plan.price), " ", /*#__PURE__*/ $eeH7J.createElement("span", {
            style: {
                fontWeight: 300
            }
        }, "/site/", plan.duration))), /*#__PURE__*/ $eeH7J.createElement("ul", {
            className: "list-disc list-none plan-feature p-0 mb-8 mt-3.5"
        }, planFeatures.find((planFeature)=>planFeature.plan === plan.plan)?.features.map((feature, idx)=>/*#__PURE__*/ $eeH7J.createElement("li", {
                key: idx,
                className: "mb-1"
            }, feature)))), plan.price > 0 && /*#__PURE__*/ $eeH7J.createElement((0, $64f662c6a0feea4f$export$2e2bcd8739ae039), {
            className: "flex justify-center mb-4 p-0"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            className: "shadow-none w-full",
            // disabled={buttonDisabled}
            disabled: props.isLoading || isLoading || isCurrentPlan(plan) && props.activeSub?.subscription_status !== "canceled" && (!props.activeSub?.cancel_at_period_end || props.activeSub?.cancel_at_period_end && props.upcomingPhase) || props.upcomingPhase && props.upcomingPhase?.selectedPlan?.priceId === plan.priceId,
            size: "small",
            variant: "contained",
            onClick: ()=>upgradeSubscription(plan)
        }, props.isLoading && "Fetching current plan...", !props.isLoading && /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, isCurrentPlan(plan) && props.activeSub?.cancel_at_period_end && !props.upcomingPhase ? "Resume Subscription" : checkPlanStatus(plan) + " to " + plan.plan))), plan.price > 0 && !props.isLoading && /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, isCurrentPlan(plan) && !props.activeSub?.cancel_at_period_end && /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", checkPlanStatus(plan), " button inactive:", " "), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "You are currently on this plan.")), isCurrentPlan(plan) && props.activeSub?.cancel_at_period_end && /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", "Attention"), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "Your subscription ends at the current cycle. Click", " ", /*#__PURE__*/ $eeH7J.createElement("b", null, "Resume Subscription"), " to continue your plan.")), !isCurrentPlan(plan) && props.upcomingPhase && props.upcomingPhase?.selectedPlan?.priceId === plan.priceId && /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", checkPlanStatus(plan), " button inactive:", " "), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "This is your upcoming plan which will auto-update post current plan's expiration."))), plan.price > 0 && !props.isLoading && props.activeSub?.plan_id && !isCurrentPlan(plan) && (!props.upcomingPhase || props.upcomingPhase?.selectedPlan?.priceId !== plan.priceId) && /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, props.activeSub?.amount_total / 100 < plan.price && /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", "Attention", " "), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "Upgrading to the ", plan.plan, " (", plan.duration, "ly) plan will process your payment immediately (prorated), and access to new features will be granted.")), props.activeSub?.amount_total / 100 > plan.price && /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", "Attention", " "), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "Downgrading to the ", plan.plan, " (", plan.duration, "ly) plan will prorate your payment from next billing cycle. You can access your current features until then."))));
    })));
};
var $2bbfebce2ca648bf$export$2e2bcd8739ae039 = $2bbfebce2ca648bf$var$ConfigPricingPlan;










var $eeH7J = parcelRequire("eeH7J");

const $178a0e1891e0d643$var$ConfigSEO = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    // const [selectedLang, setSelectedLang] = React.useState(props.primaryLanguage);
    // const [selectedLang, setSelectedLang] = React.useState("en-English");
    const languages = [
        {
            lang: "ab-Abkhazian",
            langName: "ab-Abkhazian"
        },
        {
            lang: "aa-Afar",
            langName: "aa-Afar"
        },
        {
            lang: "af-Afrikaans",
            langName: "af-Afrikaans"
        },
        {
            lang: "ak-Akan",
            langName: "ak-Akan"
        },
        {
            lang: "sq-Albanian",
            langName: "sq-Albanian"
        },
        {
            lang: "am-Amharic",
            langName: "am-Amharic"
        },
        {
            lang: "ar-Arabic",
            langName: "ar-Arabic"
        },
        {
            lang: "an-Aragonese",
            langName: "an-Aragonese"
        },
        {
            lang: "hy-Armenian",
            langName: "hy-Armenian"
        },
        {
            lang: "as-Assamese",
            langName: "as-Assamese"
        },
        {
            lang: "av-Avaric",
            langName: "av-Avaric"
        },
        {
            lang: "ae-Avestan",
            langName: "ae-Avestan"
        },
        {
            lang: "ay-Aymara",
            langName: "ay-Aymara"
        },
        {
            lang: "az-Azerbaijani",
            langName: "az-Azerbaijani"
        },
        {
            lang: "bm-Bambara",
            langName: "bm-Bambara"
        },
        {
            lang: "ba-Bashkir",
            langName: "ba-Bashkir"
        },
        {
            lang: "eu-Basque",
            langName: "eu-Basque"
        },
        {
            lang: "be-Belarusian",
            langName: "be-Belarusian"
        },
        {
            lang: "bn-Bengali (Bangla)",
            langName: "bn-Bengali (Bangla)"
        },
        {
            lang: "bh-Bihari",
            langName: "bh-Bihari"
        },
        {
            lang: "bi-Bislama",
            langName: "bi-Bislama"
        },
        {
            lang: "bs-Bosnian",
            langName: "bs-Bosnian"
        },
        {
            lang: "br-Breton",
            langName: "br-Breton"
        },
        {
            lang: "bg-Bulgarian",
            langName: "bg-Bulgarian"
        },
        {
            lang: "my-Burmese",
            langName: "my-Burmese"
        },
        {
            lang: "ca-Catalan",
            langName: "ca-Catalan"
        },
        {
            lang: "ch-Chamorro",
            langName: "ch-Chamorro"
        },
        {
            lang: "ce-Chechen",
            langName: "ce-Chechen"
        },
        {
            lang: "ny-Chichewa, Chewa, Nyanja",
            langName: "ny-Chichewa, Chewa, Nyanja"
        },
        {
            lang: "zh-Chinese",
            langName: "zh-Chinese"
        },
        {
            lang: "zh-Hans-Chinese (Simplified)",
            langName: "zh-Hans-Chinese (Simplified)"
        },
        {
            lang: "zh-Hant-Chinese (Traditional)",
            langName: "zh-Hant-Chinese (Traditional)"
        },
        {
            lang: "cv-Chuvash",
            langName: "cv-Chuvash"
        },
        {
            lang: "kw-Cornish",
            langName: "kw-Cornish"
        },
        {
            lang: "co-Corsican",
            langName: "co-Corsican"
        },
        {
            lang: "cr-Cree",
            langName: "cr-Cree"
        },
        {
            lang: "hr-Croatian",
            langName: "hr-Croatian"
        },
        {
            lang: "cs-Czech",
            langName: "cs-Czech"
        },
        {
            lang: "da-Danish",
            langName: "da-Danish"
        },
        {
            lang: "dv-Divehi, Dhivehi, Maldivian",
            langName: "dv-Divehi, Dhivehi, Maldivian"
        },
        {
            lang: "nl-Dutch",
            langName: "nl-Dutch"
        },
        {
            lang: "dz-Dzongkha",
            langName: "dz-Dzongkha"
        },
        {
            lang: "en-English",
            langName: "en-English"
        },
        {
            lang: "eo-Esperanto",
            langName: "eo-Esperanto"
        },
        {
            lang: "et-Estonian",
            langName: "et-Estonian"
        },
        {
            lang: "ee-Ewe",
            langName: "ee-Ewe"
        },
        {
            lang: "fo-Faroese",
            langName: "fo-Faroese"
        },
        {
            lang: "fj-Fijian",
            langName: "fj-Fijian"
        },
        {
            lang: "fi-Finnish",
            langName: "fi-Finnish"
        },
        {
            lang: "fr-French",
            langName: "fr-French"
        },
        {
            lang: "ff-Fula, Fulah, Pulaar, Pular",
            langName: "ff-Fula, Fulah, Pulaar, Pular"
        },
        {
            lang: "gl-Galician",
            langName: "gl-Galician"
        },
        {
            lang: "gd-Gaelic (Scottish)",
            langName: "gd-Gaelic (Scottish)"
        },
        {
            lang: "gv-Gaelic (Manx)",
            langName: "gv-Gaelic (Manx)"
        },
        {
            lang: "ka-Georgian",
            langName: "ka-Georgian"
        },
        {
            lang: "de-German",
            langName: "de-German"
        },
        {
            lang: "el-Greek",
            langName: "el-Greek"
        },
        {
            lang: "kl-Greenlandic",
            langName: "kl-Greenlandic"
        },
        {
            lang: "gn-Guarani",
            langName: "gn-Guarani"
        },
        {
            lang: "gu-Gujarati",
            langName: "gu-Gujarati"
        },
        {
            lang: "ht-Haitian Creole",
            langName: "ht-Haitian Creole"
        },
        {
            lang: "ha-Hausa",
            langName: "ha-Hausa"
        },
        {
            lang: "he-Hebrew",
            langName: "he-Hebrew"
        },
        {
            lang: "hz-Herero",
            langName: "hz-Herero"
        },
        {
            lang: "hi-Hindi",
            langName: "hi-Hindi"
        },
        {
            lang: "ho-Hiri Motu",
            langName: "ho-Hiri Motu"
        },
        {
            lang: "hu-Hungarian",
            langName: "hu-Hungarian"
        },
        {
            lang: "is-Icelandic",
            langName: "is-Icelandic"
        },
        {
            lang: "io-Ido",
            langName: "io-Ido"
        },
        {
            lang: "ig-Igbo",
            langName: "ig-Igbo"
        },
        {
            lang: "in-Indonesian",
            langName: "in-Indonesian"
        },
        {
            lang: "id-Indonesian",
            langName: "id-Indonesian"
        },
        {
            lang: "ia-Interlingua",
            langName: "ia-Interlingua"
        },
        {
            lang: "ie-Interlingue",
            langName: "ie-Interlingue"
        },
        {
            lang: "iu-Inuktitut",
            langName: "iu-Inuktitut"
        },
        {
            lang: "ik-Inupiak",
            langName: "ik-Inupiak"
        },
        {
            lang: "ga-Irish",
            langName: "ga-Irish"
        },
        {
            lang: "it-Italian",
            langName: "it-Italian"
        },
        {
            lang: "ja-Japanese",
            langName: "ja-Japanese"
        },
        {
            lang: "jv-Javanese",
            langName: "jv-Javanese"
        },
        {
            lang: "kl-Kalaallisut, Greenlandic",
            langName: "kl-Kalaallisut, Greenlandic"
        },
        {
            lang: "kn-Kannada",
            langName: "kn-Kannada"
        },
        {
            lang: "kr-Kanuri",
            langName: "kr-Kanuri"
        },
        {
            lang: "ks-Kashmiri",
            langName: "ks-Kashmiri"
        },
        {
            lang: "kk-Kazakh",
            langName: "kk-Kazakh"
        },
        {
            lang: "km-Khmer",
            langName: "km-Khmer"
        },
        {
            lang: "ki-Kikuyu",
            langName: "ki-Kikuyu"
        },
        {
            lang: "rw-Kinyarwanda (Rwanda)",
            langName: "rw-Kinyarwanda (Rwanda)"
        },
        {
            lang: "rn-Kirundi",
            langName: "rn-Kirundi"
        },
        {
            lang: "ky-Kyrgyz",
            langName: "ky-Kyrgyz"
        },
        {
            lang: "kv-Komi",
            langName: "kv-Komi"
        },
        {
            lang: "kg-Kongo",
            langName: "kg-Kongo"
        },
        {
            lang: "ko-Korean",
            langName: "ko-Korean"
        },
        {
            lang: "ku-Kurdish",
            langName: "ku-Kurdish"
        },
        {
            lang: "kj-Kwanyama",
            langName: "kj-Kwanyama"
        },
        {
            lang: "lo-Lao",
            langName: "lo-Lao"
        },
        {
            lang: "la-Latin",
            langName: "la-Latin"
        },
        {
            lang: "lv-Latvian (Lettish)",
            langName: "lv-Latvian (Lettish)"
        },
        {
            lang: "li-Limburgish ( Limburger)",
            langName: "li-Limburgish ( Limburger)"
        },
        {
            lang: "ln-Lingala",
            langName: "ln-Lingala"
        },
        {
            lang: "lt-Lithuanian",
            langName: "lt-Lithuanian"
        },
        {
            lang: "lu-Luga-Katanga",
            langName: "lu-Luga-Katanga"
        },
        {
            lang: "lg-Luganda, Ganda",
            langName: "lg-Luganda, Ganda"
        },
        {
            lang: "lb-Luxembourgish",
            langName: "lb-Luxembourgish"
        },
        {
            lang: "gv-Manx",
            langName: "gv-Manx"
        },
        {
            lang: "mk-Macedonian",
            langName: "mk-Macedonian"
        },
        {
            lang: "mg-Malagasy",
            langName: "mg-Malagasy"
        },
        {
            lang: "ms-Malay",
            langName: "ms-Malay"
        },
        {
            lang: "ml-Malayalam",
            langName: "ml-Malayalam"
        },
        {
            lang: "mt-Maltese",
            langName: "mt-Maltese"
        },
        {
            lang: "mi-Maori",
            langName: "mi-Maori"
        },
        {
            lang: "mr-Marathi",
            langName: "mr-Marathi"
        },
        {
            lang: "mh-Marshallese",
            langName: "mh-Marshallese"
        },
        {
            lang: "mo-Moldavian",
            langName: "mo-Moldavian"
        },
        {
            lang: "mn-Mongolian",
            langName: "mn-Mongolian"
        },
        {
            lang: "na-Nauru",
            langName: "na-Nauru"
        },
        {
            lang: "nv-Navajo",
            langName: "nv-Navajo"
        },
        {
            lang: "ng-Ndonga",
            langName: "ng-Ndonga"
        },
        {
            lang: "nd-Northern Ndebele",
            langName: "nd-Northern Ndebele"
        },
        {
            lang: "ne-Nepali",
            langName: "ne-Nepali"
        },
        {
            lang: "no-Norwegian",
            langName: "no-Norwegian"
        },
        {
            lang: "nb-Norwegian bokm\xe5l",
            langName: "nb-Norwegian bokm\xe5l"
        },
        {
            lang: "nn-Norwegian nynorsk",
            langName: "nn-Norwegian nynorsk"
        },
        {
            lang: "ii-Nuosu",
            langName: "ii-Nuosu"
        },
        {
            lang: "oc-Occitan",
            langName: "oc-Occitan"
        },
        {
            lang: "oj-Ojibwe",
            langName: "oj-Ojibwe"
        },
        {
            lang: "cu-Old Church Slavonic, Old Bulgarian",
            langName: "cu-Old Church Slavonic, Old Bulgarian"
        },
        {
            lang: "or-Oriya",
            langName: "or-Oriya"
        },
        {
            lang: "om-Oromo (Afaan Oromo)",
            langName: "om-Oromo (Afaan Oromo)"
        },
        {
            lang: "os-Ossetian",
            langName: "os-Ossetian"
        },
        {
            lang: "pi-P\u0101li",
            langName: "pi-P\u0101li"
        },
        {
            lang: "ps-Pashto, Pushto",
            langName: "ps-Pashto, Pushto"
        },
        {
            lang: "fa-Persian (Farsi)",
            langName: "fa-Persian (Farsi)"
        },
        {
            lang: "pl-Polish",
            langName: "pl-Polish"
        },
        {
            lang: "pt-Portuguese",
            langName: "pt-Portuguese"
        },
        {
            lang: "pa-Punjabi (Eastern)",
            langName: "pa-Punjabi (Eastern)"
        },
        {
            lang: "qu-Quechua",
            langName: "qu-Quechua"
        },
        {
            lang: "rm-Romansh",
            langName: "rm-Romansh"
        },
        {
            lang: "ro-Romanian",
            langName: "ro-Romanian"
        },
        {
            lang: "ru-Russian",
            langName: "ru-Russian"
        },
        {
            lang: "se-Sami",
            langName: "se-Sami"
        },
        {
            lang: "sm-Samoan",
            langName: "sm-Samoan"
        },
        {
            lang: "sg-Sango",
            langName: "sg-Sango"
        },
        {
            lang: "sa-Sanskrit",
            langName: "sa-Sanskrit"
        },
        {
            lang: "sr-Serbian",
            langName: "sr-Serbian"
        },
        {
            lang: "sh-Serbo-Croatian",
            langName: "sh-Serbo-Croatian"
        },
        {
            lang: "st-Sesotho",
            langName: "st-Sesotho"
        },
        {
            lang: "tn-Setswana",
            langName: "tn-Setswana"
        },
        {
            lang: "sn-Shona",
            langName: "sn-Shona"
        },
        {
            lang: "ii-Sichuan Yi",
            langName: "ii-Sichuan Yi"
        },
        {
            lang: "sd-Sindhi",
            langName: "sd-Sindhi"
        },
        {
            lang: "si-Sinhalese",
            langName: "si-Sinhalese"
        },
        {
            lang: "ss-Siswati",
            langName: "ss-Siswati"
        },
        {
            lang: "sk-Slovak",
            langName: "sk-Slovak"
        },
        {
            lang: "sl-Slovenian",
            langName: "sl-Slovenian"
        },
        {
            lang: "so-Somali",
            langName: "so-Somali"
        },
        {
            lang: "nr-Southern Ndebele",
            langName: "nr-Southern Ndebele"
        },
        {
            lang: "es-Spanish",
            langName: "es-Spanish"
        },
        {
            lang: "su-Sundanese",
            langName: "su-Sundanese"
        },
        {
            lang: "sw-Swahili (Kiswahili)",
            langName: "sw-Swahili (Kiswahili)"
        },
        {
            lang: "ss-Swati",
            langName: "ss-Swati"
        },
        {
            lang: "sv-Swedish",
            langName: "sv-Swedish"
        },
        {
            lang: "tl-Tagalog",
            langName: "tl-Tagalog"
        },
        {
            lang: "ty-Tahitian",
            langName: "ty-Tahitian"
        },
        {
            lang: "tg-Tajik",
            langName: "tg-Tajik"
        },
        {
            lang: "ta-Tamil",
            langName: "ta-Tamil"
        },
        {
            lang: "tt-Tatar",
            langName: "tt-Tatar"
        },
        {
            lang: "te-Telugu",
            langName: "te-Telugu"
        },
        {
            lang: "th-Thai",
            langName: "th-Thai"
        },
        {
            lang: "bo-Tibetan",
            langName: "bo-Tibetan"
        },
        {
            lang: "ti-Tigrinya",
            langName: "ti-Tigrinya"
        },
        {
            lang: "to-Tonga",
            langName: "to-Tonga"
        },
        {
            lang: "ts-Tsonga",
            langName: "ts-Tsonga"
        },
        {
            lang: "tr-Turkish",
            langName: "tr-Turkish"
        },
        {
            lang: "tk-Turkmen",
            langName: "tk-Turkmen"
        },
        {
            lang: "tw-Twi",
            langName: "tw-Twi"
        },
        {
            lang: "ug-Uyghur",
            langName: "ug-Uyghur"
        },
        {
            lang: "uk-Ukrainian",
            langName: "uk-Ukrainian"
        },
        {
            lang: "ur-Urdu",
            langName: "ur-Urdu"
        },
        {
            lang: "uz-Uzbek",
            langName: "uz-Uzbek"
        },
        {
            lang: "ve-Venda",
            langName: "ve-Venda"
        },
        {
            lang: "vi-Vietnamese",
            langName: "vi-Vietnamese"
        },
        {
            lang: "vo-Volap\xfck",
            langName: "vo-Volap\xfck"
        },
        {
            lang: "wa-Wallon",
            langName: "wa-Wallon"
        },
        {
            lang: "cy-Welsh",
            langName: "cy-Welsh"
        },
        {
            lang: "wo-Wolof",
            langName: "wo-Wolof"
        },
        {
            lang: "fy-Western Frisian",
            langName: "fy-Western Frisian"
        },
        {
            lang: "xh-Xhosa",
            langName: "xh-Xhosa"
        },
        {
            lang: "yi-Yiddish",
            langName: "yi-Yiddish"
        },
        {
            lang: "yo-Yoruba",
            langName: "yo-Yoruba"
        },
        {
            lang: "za-Zhuang, Chuang",
            langName: "za-Zhuang, Chuang"
        },
        {
            lang: "zu-Zulu",
            langName: "zu-Zulu"
        }
    ];
    const [addForm, setAddForm] = $eeH7J.useState({
        from: "",
        to: ""
    });
    const [redirects, setRedirects] = $eeH7J.useState(props.redirects ?? []);
    $eeH7J.useEffect(()=>{
        setRedirects(props.redirects);
    }, [
        props.redirects
    ]);
    const onAddRedirect = ()=>{
        // console.log('onAddRedirect', addForm);
        const from = addForm.from;
        const to = addForm.to;
        if (redirects.find((r)=>r.from === from)) return enqueueSnackbar("Redirect already exists", {
            variant: "error"
        });
        if (from === to) return enqueueSnackbar("Redirect From and To can't be same", {
            variant: "error"
        });
        const redirectsCopy = JSON.parse(JSON.stringify(redirects));
        redirectsCopy.push({
            from: from,
            to: to
        });
        setRedirects(redirectsCopy);
        setAddForm({
            from: "",
            to: ""
        });
        props.onDataChange({
            redirects: redirectsCopy
        });
    };
    const onChangeRedirect = (idx, value, field)=>{
        const redirectsCopy = JSON.parse(JSON.stringify(redirects));
        redirectsCopy[idx][field] = value;
        setRedirects(redirectsCopy);
        // setting error if same value for redirect from
        validateErrors(redirectsCopy);
        props.onDataChange({
            redirects: redirectsCopy
        });
    };
    const validateErrors = (redirectsCopy)=>{
        const redirectsFrom = {};
        redirectsCopy.forEach((r)=>{
            if (!redirectsFrom[r.from]) redirectsFrom[r.from] = 0;
            redirectsFrom[r.from]++;
        });
        redirectsCopy.forEach((r)=>{
            if (redirectsFrom[r.from] > 1) r.error = "duplicate";
            else if (r.from === r.to) r.error = "same";
            else delete r.error;
        });
        redirectsCopy.filter((r)=>r.error).length > 0 ? props.setSaveDisabled(true) : props.setSaveDisabled(false);
    };
    const onRemoveRedirect = (idx)=>{
        const redirectsCopy = JSON.parse(JSON.stringify(redirects));
        redirectsCopy.splice(idx, 1);
        setRedirects(redirectsCopy);
        validateErrors(redirectsCopy);
        props.onDataChange({
            redirects: redirectsCopy
        });
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black left-sidebar-seo"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Primary language"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "This language will be the default language of your website."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $4eba357c98d07975$export$2e2bcd8739ae039), {
        sx: {
            maxWidth: "100%",
            width: "100%"
        },
        size: "small"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $79a0d4fc41924020$export$2e2bcd8739ae039), {
        id: "language-select",
        value: props.primaryLanguage,
        onChange: (e)=>{
            // setSelectedLang(e.target.value)
            // console.log(e.target.value);
            props.onDataChange({
                primaryLanguage: e.target.value
            });
        },
        className: "w-full md:w-80 text-sm lang-selector"
    }, languages.map((row)=>{
        return /*#__PURE__*/ $eeH7J.createElement((0, $3cdaf87b331b5faf$export$2e2bcd8739ae039), {
            key: row.lang,
            className: "text-sm site-lang",
            value: row.lang
        }, row.langName);
    }))))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "301 Redirects (URL mapping)"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "overflow-x-auto"
    }, /*#__PURE__*/ $eeH7J.createElement("table", {
        className: "w-full border-collapse font-body rounded bg-white mb-2"
    }, /*#__PURE__*/ $eeH7J.createElement("thead", null, /*#__PURE__*/ $eeH7J.createElement("tr", null, /*#__PURE__*/ $eeH7J.createElement("th", {
        className: "text-left w-2/5 min-w-[200px] px-2 py-1 border text-base"
    }, "Redirect From"), /*#__PURE__*/ $eeH7J.createElement("th", {
        className: "text-left w-2/5 min-w-[200px] px-2 py-1 border text-base"
    }, "Redirect To"), /*#__PURE__*/ $eeH7J.createElement("th", {
        className: "text-center w-1/5 min-w-[150px] px-2 py-1 border text-base"
    }, "Action"))), /*#__PURE__*/ $eeH7J.createElement("tbody", null, /*#__PURE__*/ $eeH7J.createElement("tr", null, /*#__PURE__*/ $eeH7J.createElement("td", {
        className: "text-left px-2 py-1 border text-xsm"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
        value: addForm.from,
        className: "w-full border rounded border-catelina-blue/60 py-1 px-2 text-base",
        placeholder: "abc",
        onChange: (e)=>setAddForm({
                ...addForm,
                from: (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value)
            }),
        startAdornment: "/",
        size: "small",
        disableUnderline: true
    })), /*#__PURE__*/ $eeH7J.createElement("td", {
        className: "text-left px-2 py-1 border text-xsm"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
        value: addForm.to,
        className: "w-full border rounded border-catelina-blue/60 py-1 px-2 text-base",
        placeholder: "xyz",
        onChange: (e)=>setAddForm({
                ...addForm,
                to: (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value)
            }),
        startAdornment: "/",
        size: "small",
        disableUnderline: true
    })), /*#__PURE__*/ $eeH7J.createElement("td", null, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "add",
        className: "w-11/12 py-1",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>onAddRedirect()
    }, "Add"))), redirects.map((row, idx)=>{
        return /*#__PURE__*/ $eeH7J.createElement("tr", {
            key: idx
        }, /*#__PURE__*/ $eeH7J.createElement("td", {
            className: "text-left px-2 py-1 border text-xsm"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
            value: row.from,
            className: `w-full border rounded border-catelina-blue/60 py-1 px-2 text-base ${!!redirects[idx].error ? "border-red-600" : ""}`,
            onChange: (e)=>onChangeRedirect(idx, e.target.value, "from"),
            startAdornment: "/",
            size: "small",
            disableUnderline: true,
            error: true
        })), /*#__PURE__*/ $eeH7J.createElement("td", {
            className: "text-left px-2 py-1 border text-xsm"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $efff8c52466ed18b$export$2e2bcd8739ae039), {
            value: row.to,
            className: `w-full border rounded border-catelina-blue/60 py-1 px-2 text-base ${redirects[idx].error === "same" ? "border-red-600" : ""}`,
            onChange: (e)=>onChangeRedirect(idx, e.target.value, "to"),
            startAdornment: "/",
            size: "small",
            disableUnderline: true
        })), /*#__PURE__*/ $eeH7J.createElement("td", null, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            id: "delete",
            color: "error",
            className: "w-11/12 py-1",
            sx: {
                textTransform: "none"
            },
            variant: "outlined",
            onClick: (e)=>onRemoveRedirect(idx)
        }, "Remove")));
    }))), redirects.filter((r)=>r.error === "duplicate").length > 0 && /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-normal mb-2 text-red-600"
    }, "Please remove DUPLICATE redirects."), redirects.filter((r)=>r.error === "same").length > 0 && /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-normal mb-2 text-red-600"
    }, "Redirect FROM and TO can't be same."))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "The sitemap.xml file URL"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "The file is used by search engines. The file is auto-generated by RocketPages. We also auto-update when you create and publish a new page, delete or edit a page."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("input", {
        disabled: true,
        className: "w-full md:w-64 border rounded border-catelina-blue/60 py-1 px-2",
        // placeholder="<script src=”https;//www.googletagmanager.com/gtag/js?id=UA-XXX-X”></script>"
        value: "sitemap.xml"
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "The robots.txt file URL:"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "The file is used by search engines. The file is autogenerated by RocketPages and you can not change it"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("input", {
        disabled: true,
        className: "w-full md:w-64 border rounded border-catelina-blue/60 py-1 px-2",
        // placeholder="<script src=”https;//www.googletagmanager.com/gtag/js?id=UA-XXX-X”></script>"
        value: "robots.txt"
    }))));
};
var $178a0e1891e0d643$export$2e2bcd8739ae039 = $178a0e1891e0d643$var$ConfigSEO;




var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");



var $dRzna = parcelRequire("dRzna");
'use client';
const $6b23c1ceaddbb360$var$_excluded = [
    "children"
];
const $6b23c1ceaddbb360$var$TabList = /*#__PURE__*/ $eeH7J.forwardRef(function TabList(props, ref) {
    const { children: childrenProp } = props, other = (0, $fbOaB.default)(props, $6b23c1ceaddbb360$var$_excluded);
    const context = (0, $1ebad4d8fc8d8546$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const children = $eeH7J.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(child)) return null;
        return /*#__PURE__*/ $eeH7J.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            'aria-controls': (0, $1ebad4d8fc8d8546$export$629f80328afcade5)(context, child.props.value),
            id: (0, $1ebad4d8fc8d8546$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $6146074d8a2c7938$export$2e2bcd8739ae039), (0, $h4XE0.default)({}, other, {
        ref: ref,
        value: context.value,
        children: children
    }));
});
$6b23c1ceaddbb360$var$TabList.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A list of `<Tab />` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node
};
var $6b23c1ceaddbb360$export$2e2bcd8739ae039 = $6b23c1ceaddbb360$var$TabList;






var $eeH7J = parcelRequire("eeH7J");








var $eeH7J = parcelRequire("eeH7J");






var $eeH7J = parcelRequire("eeH7J");

const $5a68dd37d652d02c$var$SubscriptionCard = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [isCreatingUrl, setIsCreatingUrl] = $eeH7J.useState(false);
    //   console.log("SubscriptionCard", props);
    const s_start = new Date(props.data.subscription_start * 1000);
    const s_end = new Date(props.data.subscription_end * 1000);
    const getStripeCustomerPortalUrl = async ()=>{
        setIsCreatingUrl(true);
        let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/site-config-get-stripe-customer-session?siteId=${props.data.siteId}&subscriptionId=${props.data.subscriptionId}`);
        // console.log("getStripeCustomerPortalUrl", response.data);
        setIsCreatingUrl(false);
        if (response.data.error) return enqueueSnackbar(response.data.error, {
            variant: "error",
            autoHideDuration: 9000
        });
        window.location.href = response.data.url;
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", null, props.data.subscription_status !== 'past_due' && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mt-4 flex justify-end"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "shadow-none mr-2 rounded-md",
        disabled: props.data.subscription_status === "canceled" || isCreatingUrl || props.isCancelling || props.data.cancel_at_period_end && !props.upcomingPhase,
        size: "large",
        variant: "contained",
        color: "primary",
        onClick: ()=>getStripeCustomerPortalUrl()
    }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Update payment method")), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "shadow-none rounded-md bg-red-600",
        disabled: props.data.subscription_status === "canceled" || props.isCancelling || props.data.cancel_at_period_end && !props.upcomingPhase,
        size: "large",
        variant: "contained",
        color: "error",
        onClick: ()=>props.onCancel(props.data.subscription)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Cancel Subscription"))), /*#__PURE__*/ $eeH7J.createElement("h4", {
        className: "font-bold mb-2 mt-0"
    }, "Active Plan"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: `bg-white border border-[#E1E4EF] p-4 rounded-md`
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "grid grid-cols-1 gap-2 xl:grid-cols-2 text-xsm sm:text-sm"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Subscription ID:"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, props.data.subscriptionId)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Subscription Status:"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5" + (props.data.subscription_status === 'past_due' ? ' text-red-600 font-semibold' : ' text-lime-600 font-semibold capitalize')
    }, props.data.subscription_status === 'past_due' ? 'Pending' : props.data.subscription_status)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Plan:"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, props.data.plan_desc)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Price:"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, "$", props.data.amount_total / 100)), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Start Date:"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, s_start.toLocaleDateString("en-GB"))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, props.data.cancel_at_period_end || props.data.subscription_status === "canceled" || props.upcomingPhase ? 'End' : 'Renew', " Date:"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, s_end.toLocaleDateString("en-GB")))), props.data.subscription_status === 'past_due' && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col items-center lg:flex-row justify-between mt-6"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-[#E1E4EF] rounded p-2 mb-0 flex items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0 flex items-center text-red-600  flex-wrap md:flex-noWrap"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        className: "mr-1 text-red-600",
        style: {
            fontSize: 20
        }
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-semibold"
    }, "Transaction incomplete:"), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-grey-primary ml-1 font-norma text-red-600"
    }, "Please complete your current plan's payment to activate the features of this plan."))), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "shadow-none ml-2 lg:mt-0 mt-2",
        disabled: !props.latestInvoice,
        size: "large",
        variant: "contained",
        color: "primary",
        onClick: ()=>window.open(props.latestInvoice.hosted_invoice_url, '_blank')
    }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Pay Now")))));
};
var $5a68dd37d652d02c$export$2e2bcd8739ae039 = $5a68dd37d652d02c$var$SubscriptionCard;






const $35fec47f5a380aa9$var$ConfigActivePlans = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const { id: id } = (0, $0d4e57672a3dc010$export$99eaa27ddbbb95ef)();
    const [showConfirmation, setShowConfirmation] = $eeH7J.useState(false);
    const [showPlanSwitchConfirmation, setShowPlanSwitchConfirmation] = $eeH7J.useState(false);
    const [isCancelling, setIsCancelling] = $eeH7J.useState(false);
    const handleDelete = ()=>{
        onCancelSubs(props.activeSub.subscriptionId); // Call the delete function passed as a prop
        setShowConfirmation(false); // Close the confirmation dialog after delete
    };
    const onCancelSubs = async (subsId)=>{
        setIsCancelling(true);
        // console.log('onCancelSubs', subsId);
        let l_data = {
            siteId: id,
            subscriptionId: subsId
        };
        let rs = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/site-config-cancel-subscription", l_data);
        // console.log("api cancel res", rs.data);
        if (!rs.data.error && rs.data.status && rs.data.subscription.cancel_at_period_end) {
            enqueueSnackbar("Subscription cancelled successfully.", {
                variant: "success",
                className: "bg-catelina-blue"
            });
            setIsCancelling(false);
            props.reFetch();
        } else if (rs.data.error) {
            enqueueSnackbar("Something went wrong while cancelling subscription", {
                variant: "error",
                autoHideDuration: 9000
            });
            setIsCancelling(false);
        }
    // console.log("api cancel res", rs);
    };
    const onCancelUpcomingSubs = async ()=>{
        setShowPlanSwitchConfirmation(false);
        setIsCancelling(true);
        // console.log('onCancelSubs', props.activeSub.subscriptionId);
        let l_data = {
            siteId: id,
            subscriptionId: props.activeSub.subscriptionId
        };
        let rs = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/site-config-cancel-upcoming-subscription", l_data);
        // console.log("api cancel res", rs.data);
        if (!rs.data.error && rs.data.subscription) {
            enqueueSnackbar("Upcoming Subscription cancelled successfully.", {
                variant: "success",
                className: "bg-catelina-blue"
            });
            setIsCancelling(false);
            props.reFetch();
        } else if (rs.data.error) {
            enqueueSnackbar(rs.data.error ?? "Something went wrong while cancelling upcoming subscription", {
                variant: "error",
                autoHideDuration: 9000
            });
            setIsCancelling(false);
        }
    // console.log("api cancel res", rs);
    };
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "config-active-plan flex flex-col justify-center items-left w-full"
    }, showConfirmation && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white rounded py-8 py-8 md:px-16 m-4 z-50 flex items-center flex-col relative"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("1o8uV")),
        className: "absolute right-2 top-2 cursor-pointer",
        onClick: ()=>setShowConfirmation(false)
    }), /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("gN0Oc")),
        className: "mb-2"
    }), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-gray-800 mb-0"
    }, "Are you sure you want to cancel subscription?"), /*#__PURE__*/ $eeH7J.createElement("span", null, "This action will take effect at the end of your current billing cycle, and you will lose access to all features that comes with it."), !!props.upcomingPhase && /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-semibold text-black"
    }, "This will also cancel upcoming plans immediately."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row mt-6"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: handleDelete
    }, "Confirm Cancel")))), showPlanSwitchConfirmation && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white mx-w-xl rounded py-8 px-8 md:px-16  m-4 z-50 flex items-center flex-col relative"
    }, /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("1o8uV")),
        className: "absolute right-2 top-2 cursor-pointer",
        onClick: ()=>setShowPlanSwitchConfirmation(false)
    }), /*#__PURE__*/ $eeH7J.createElement("img", {
        src: (parcelRequire("gN0Oc"))
    }), /*#__PURE__*/ $eeH7J.createElement("h4", {
        className: "mb-4"
    }, "Cancel upcoming subscription"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-gray-800 mb-3 text-center"
    }, "Are you sure you want to cancel upcoming subscription and stay on current active one?"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-center mb-4 text-grey-primary font-normal w-2/3"
    }, "This action will take effect immediately."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("button", {
        className: "rounded-md bg-red-600 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: onCancelUpcomingSubs
    }, "Confirm Cancel")))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full flex flex-col"
    }, props.isLoading && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($880d53c39aa7bd1b$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "Fetching Subscriptions...")), !props.isLoading && !props.activeSub && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($880d53c39aa7bd1b$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $eeH7J.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "No active subscription found")), !props.isLoading && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full"
    }, props.activeSub && /*#__PURE__*/ $eeH7J.createElement((0, $5a68dd37d652d02c$export$2e2bcd8739ae039), {
        data: props.activeSub,
        upcomingPhase: props.upcomingPhase,
        latestInvoice: props.latestInvoice,
        isCancelling: isCancelling,
        onCancel: (subId)=>{
            setShowConfirmation(true);
        }
    }), props.upcomingPhase && /*#__PURE__*/ $eeH7J.createElement("div", null, /*#__PURE__*/ $eeH7J.createElement("h4", {
        className: "mb-2"
    }, "Upcoming Plan"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-white border border-[#E1E4EF] p-4 rounded-md"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex sm:items-center items-start justify-between flex-col sm:flex-row mb-2 sm:mb-0"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-bold mb-0.5 text-grey-primary"
    }, props.upcomingPhase.selectedPlan?.plan, " (", props.upcomingPhase.selectedPlan?.duration, "ly)"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-bold mb-0.5 text-grey-primary"
    }, "$", props.upcomingPhase.selectedPlan?.price, "/site/", props.upcomingPhase.selectedPlan?.duration)), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "mb-1 font-normal"
    }, "Valid for 1 ", props.upcomingPhase.selectedPlan?.duration), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-between mt-6 flex-col lg:flex-row"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-[#E1E4EF] rounded p-2 mb-0 flex items-center"
    }, /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm mb-0 flex items-center text-catelina-blue  flex-wrap md:flex-noWrap"
    }, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9927ad39f12d4a98$exports))), {
        className: "mr-1",
        style: {
            fontSize: 20
        }
    }), "Attention:", /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-grey-primary ml-1 font-normal"
    }, "Your upcoming ", props.upcomingPhase.selectedPlan?.plan, " ", "(", props.upcomingPhase.selectedPlan?.duration, "ly) plan will be auto-updated post current plan expires."))), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "shadow-none lg:mt-0 mt-2 rounded-md bg-red-600 lg:ml-2",
        disabled: isCancelling,
        size: "large",
        variant: "contained",
        color: "error",
        onClick: ()=>setShowPlanSwitchConfirmation(true)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $32193c68ed830861$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Cancel", " ", props.activeSub.amount_total / 100 > props.upcomingPhase.selectedPlan.price ? "Downgrade" : "Upgrade"))))))));
};
var $35fec47f5a380aa9$export$2e2bcd8739ae039 = $35fec47f5a380aa9$var$ConfigActivePlans;




const $4feb50dcb01399e1$var$plans = [
    {
        plan: "Forever Free",
        duration: "month",
        price: 0,
        priceId: ""
    },
    {
        plan: "Forever Free",
        duration: "year",
        price: 0,
        priceId: ""
    },
    {
        plan: "Pro",
        duration: "month",
        price: 1.99,
        priceId: "price_1PNqPdH46TpgZNWbBVrkmf4g"
    },
    {
        plan: "Pro",
        duration: "year",
        price: 9.99,
        priceId: "price_1PNqHLH46TpgZNWbKB04sa01"
    },
    {
        plan: "Business",
        duration: "month",
        price: 14.99,
        priceId: "price_1PNro9H46TpgZNWbbeye2dYT"
    },
    {
        plan: "Business",
        duration: "year",
        price: 99.99,
        priceId: "price_1PNrmZH46TpgZNWb7iAkJzba"
    }
];
const $4feb50dcb01399e1$var$ConfigSubscriptions = (props)=>{
    const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const query = $eeH7J.useMemo(()=>new URLSearchParams(search), [
        search
    ]);
    const l_activeTab = query.get("activeTab");
    const [currentTab, setCurrentTab] = $eeH7J.useState(props.defTab === "pricing" || l_activeTab === "pricing" ? "3" : "1");
    const [isLoading, setIsLoading] = $eeH7J.useState(true);
    const [isLoadingInvoices, setIsLoadingInvoices] = $eeH7J.useState(true);
    const [invoices, setInvoices] = $eeH7J.useState([]);
    const [latestInvoice, setLatestInvoice] = $eeH7J.useState();
    const [allSubs, setAllSubs] = $eeH7J.useState([]);
    const [activeSub, setActiveSub] = $eeH7J.useState();
    const [upcomingPhase, setUpcomingPhase] = $eeH7J.useState();
    const { id: id } = (0, $0d4e57672a3dc010$export$99eaa27ddbbb95ef)();
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const isQATeam = cookies?.rp_user_data?.role === "admin";
    if (isQATeam) {
        if (!$4feb50dcb01399e1$var$plans.find((plan)=>plan.plan === "QA Only")) $4feb50dcb01399e1$var$plans.push({
            plan: "QA Only",
            duration: "month",
            price: 1.0,
            priceId: "price_1SmpYWH46TpgZNWb8pBg8EoV"
        }, {
            plan: "QA Only",
            duration: "year",
            price: 1.0,
            priceId: "price_1SmpYWH46TpgZNWb8pBg8EoV"
        });
    }
    // React.useEffect(() => {
    //   console.log("node env", process.env.NODE_ENV)
    // },[])
    async function getAllSubscriptions() {
        try {
            setIsLoading(true);
            setIsLoadingInvoices(true);
            let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/site-config-get-subscriptions?siteId=${id}`);
            // console.log("getAllSubscriptions", res.data.data);
            setAllSubs(res.data.data);
            const activeSubscription = res.data.data.find((sub)=>sub.subscription_status !== "canceled");
            if (activeSubscription) {
                activeSubscription.selectedPlan = $4feb50dcb01399e1$var$plans.find((plan)=>plan.priceId === activeSubscription.plan_id);
                // Fallback: if the subscription has an old/unrecognized price ID,
                // derive the plan info from plan_desc and amount_total
                if (!activeSubscription.selectedPlan && activeSubscription.plan_id) {
                    const desc = (activeSubscription.plan_desc || "").toLowerCase();
                    let planName = "Pro";
                    if (desc.includes("business")) planName = "Business";
                    else if (desc.includes("free")) planName = "Forever Free";
                    const duration = desc.includes("year") ? "year" : "month";
                    activeSubscription.selectedPlan = {
                        plan: planName,
                        duration: duration,
                        price: activeSubscription.amount_total / 100,
                        priceId: activeSubscription.plan_id
                    };
                }
            }
            setActiveSub(activeSubscription);
            let upcomingPlan;
            if (activeSubscription?.scheduleData && activeSubscription.scheduleData.phases?.length > 1) {
                const upcomingSubPhase = activeSubscription.scheduleData.phases.find((phase)=>phase.start_date > Date.now() / 1000);
                // const upcomingSubPhase = activeSubscription.scheduleData.phases[1];
                if (upcomingSubPhase) {
                    upcomingSubPhase.selectedPlan = $4feb50dcb01399e1$var$plans.find((plan)=>plan.priceId === upcomingSubPhase.items[0].price);
                    upcomingPlan = upcomingSubPhase;
                }
            }
            setUpcomingPhase(upcomingPlan);
            setIsLoading(false);
            let subscriptions = [];
            res.data.data.forEach((row)=>{
                subscriptions.push(row.subscriptionId);
            });
            if (!subscriptions.length) {
                setIsLoadingInvoices(false);
                return;
            }
            let resInvoices = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/site-config-get-invoices`, {
                subscriptions: subscriptions
            });
            // console.log("getAllSubscriptions", resInvoices.data.data);
            setInvoices(resInvoices.data.data);
            if (activeSubscription) setLatestInvoice(resInvoices.data.data.filter((invoice)=>invoice.subscription === activeSubscription.subscriptionId).sort((a, b)=>b.created - a.created)[0]);
            setIsLoadingInvoices(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }
    $eeH7J.useEffect(()=>{
        // setLoggedUserData(JSON.parse(cookies.rp_user_data))
        getAllSubscriptions();
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        className: "left-sidebar-subscription"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1ebad4d8fc8d8546$export$2e2bcd8739ae039), {
        value: currentTab
    }, /*#__PURE__*/ $eeH7J.createElement((0, $7ec185bb4d6c4f83$export$2e2bcd8739ae039), {
        sx: {
            borderBottom: 1,
            borderColor: "divider"
        }
    }, /*#__PURE__*/ $eeH7J.createElement((0, $6b23c1ceaddbb360$export$2e2bcd8739ae039), {
        onChange: (e, newValue)=>setCurrentTab(newValue),
        "aria-label": "lab API tabs example",
        className: "subscription-tab-list"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $6878910a69f430c4$export$2e2bcd8739ae039), {
        label: "My Plan(s)",
        value: "1"
    }), /*#__PURE__*/ $eeH7J.createElement((0, $6878910a69f430c4$export$2e2bcd8739ae039), {
        label: "Invoices",
        value: "2"
    }), /*#__PURE__*/ $eeH7J.createElement((0, $6878910a69f430c4$export$2e2bcd8739ae039), {
        label: "Pricing Plans",
        value: "3"
    }))), /*#__PURE__*/ $eeH7J.createElement((0, $77641e8807ec5b93$export$2e2bcd8739ae039), {
        style: {
            paddingLeft: 0,
            paddingRight: 0
        },
        value: "1"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $35fec47f5a380aa9$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        activeSub: activeSub,
        updateActiveSub: setActiveSub,
        reFetch: getAllSubscriptions,
        upcomingPhase: upcomingPhase,
        latestInvoice: latestInvoice
    })), /*#__PURE__*/ $eeH7J.createElement((0, $77641e8807ec5b93$export$2e2bcd8739ae039), {
        style: {
            paddingLeft: 0,
            paddingRight: 0
        },
        value: "2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $f1879511b722e3f2$export$2e2bcd8739ae039), {
        isLoading: isLoadingInvoices,
        invoices: invoices
    })), /*#__PURE__*/ $eeH7J.createElement((0, $77641e8807ec5b93$export$2e2bcd8739ae039), {
        style: {
            paddingLeft: 0,
            paddingRight: 0
        },
        value: "3"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $2bbfebce2ca648bf$export$2e2bcd8739ae039), {
        id: id,
        plans: $4feb50dcb01399e1$var$plans,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        activeSub: activeSub,
        updateActiveSub: setActiveSub,
        reFetch: getAllSubscriptions,
        upcomingPhase: upcomingPhase
    }))));
};
var $4feb50dcb01399e1$export$2e2bcd8739ae039 = $4feb50dcb01399e1$var$ConfigSubscriptions;



var $eeH7J = parcelRequire("eeH7J");


var $eeH7J = parcelRequire("eeH7J");
var $88b1044c55714645$exports = {};
'use strict';
Object.defineProperty($88b1044c55714645$exports, "__esModule", {
    value: true
});
$88b1044c55714645$exports.ReactCSS = $88b1044c55714645$exports.loop = $88b1044c55714645$exports.handleActive = $88b1044c55714645$exports.handleHover = $88b1044c55714645$exports.hover = undefined;
var $138ba754b5438268$exports = {};
'use strict';
Object.defineProperty($138ba754b5438268$exports, "__esModule", {
    value: true
});
$138ba754b5438268$exports.flattenNames = undefined;
var $f6644b72543b25d0$exports = {};
var $1c109846e1422af5$exports = {};
var $38422377e4b90883$exports = {};

var $670gj = parcelRequire("670gj");
/** Built-in value references. */ var $38422377e4b90883$var$Symbol = $670gj.Symbol;
$38422377e4b90883$exports = $38422377e4b90883$var$Symbol;


var $d4e01c5f2715a11b$exports = {};

/** Used for built-in method references. */ var $d4e01c5f2715a11b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4e01c5f2715a11b$var$hasOwnProperty = $d4e01c5f2715a11b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d4e01c5f2715a11b$var$nativeObjectToString = $d4e01c5f2715a11b$var$objectProto.toString;
/** Built-in value references. */ var $d4e01c5f2715a11b$var$symToStringTag = $38422377e4b90883$exports ? $38422377e4b90883$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d4e01c5f2715a11b$var$getRawTag(value) {
    var isOwn = $d4e01c5f2715a11b$var$hasOwnProperty.call(value, $d4e01c5f2715a11b$var$symToStringTag), tag = value[$d4e01c5f2715a11b$var$symToStringTag];
    try {
        value[$d4e01c5f2715a11b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d4e01c5f2715a11b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d4e01c5f2715a11b$var$symToStringTag] = tag;
        else delete value[$d4e01c5f2715a11b$var$symToStringTag];
    }
    return result;
}
$d4e01c5f2715a11b$exports = $d4e01c5f2715a11b$var$getRawTag;


var $15a5a1cc40a73b6d$exports = {};
/** Used for built-in method references. */ var $15a5a1cc40a73b6d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $15a5a1cc40a73b6d$var$nativeObjectToString = $15a5a1cc40a73b6d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $15a5a1cc40a73b6d$var$objectToString(value) {
    return $15a5a1cc40a73b6d$var$nativeObjectToString.call(value);
}
$15a5a1cc40a73b6d$exports = $15a5a1cc40a73b6d$var$objectToString;


/** `Object#toString` result references. */ var $1c109846e1422af5$var$nullTag = '[object Null]', $1c109846e1422af5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $1c109846e1422af5$var$symToStringTag = $38422377e4b90883$exports ? $38422377e4b90883$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $1c109846e1422af5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $1c109846e1422af5$var$undefinedTag : $1c109846e1422af5$var$nullTag;
    return $1c109846e1422af5$var$symToStringTag && $1c109846e1422af5$var$symToStringTag in Object(value) ? $d4e01c5f2715a11b$exports(value) : $15a5a1cc40a73b6d$exports(value);
}
$1c109846e1422af5$exports = $1c109846e1422af5$var$baseGetTag;


var $6f5a80e798063325$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $6f5a80e798063325$var$isArray = Array.isArray;
$6f5a80e798063325$exports = $6f5a80e798063325$var$isArray;


var $5188975b7cad44c5$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5188975b7cad44c5$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$5188975b7cad44c5$exports = $5188975b7cad44c5$var$isObjectLike;


/** `Object#toString` result references. */ var $f6644b72543b25d0$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f6644b72543b25d0$var$isString(value) {
    return typeof value == 'string' || !$6f5a80e798063325$exports(value) && $5188975b7cad44c5$exports(value) && $1c109846e1422af5$exports(value) == $f6644b72543b25d0$var$stringTag;
}
$f6644b72543b25d0$exports = $f6644b72543b25d0$var$isString;


var $138ba754b5438268$var$_isString3 = $138ba754b5438268$var$_interopRequireDefault($f6644b72543b25d0$exports);
var $318719a69d0cc713$exports = {};
var $16c0518aee3073d2$exports = {};
var $5f0d520ab670c24a$exports = {};
var $6ec325f5078fe83b$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6ec325f5078fe83b$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$6ec325f5078fe83b$exports = $6ec325f5078fe83b$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $5f0d520ab670c24a$var$baseFor = $6ec325f5078fe83b$exports();
$5f0d520ab670c24a$exports = $5f0d520ab670c24a$var$baseFor;


var $fe18181eec9f466e$exports = {};
var $ea23925fdf992f08$exports = {};
var $d90d012d66ab3f11$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d90d012d66ab3f11$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$d90d012d66ab3f11$exports = $d90d012d66ab3f11$var$baseTimes;


var $952c49f88874830d$exports = {};
var $55d74fe6ea74b14c$exports = {};


/** `Object#toString` result references. */ var $55d74fe6ea74b14c$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $55d74fe6ea74b14c$var$baseIsArguments(value) {
    return $5188975b7cad44c5$exports(value) && $1c109846e1422af5$exports(value) == $55d74fe6ea74b14c$var$argsTag;
}
$55d74fe6ea74b14c$exports = $55d74fe6ea74b14c$var$baseIsArguments;



/** Used for built-in method references. */ var $952c49f88874830d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $952c49f88874830d$var$hasOwnProperty = $952c49f88874830d$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $952c49f88874830d$var$propertyIsEnumerable = $952c49f88874830d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $952c49f88874830d$var$isArguments = $55d74fe6ea74b14c$exports(function() {
    return arguments;
}()) ? $55d74fe6ea74b14c$exports : function(value) {
    return $5188975b7cad44c5$exports(value) && $952c49f88874830d$var$hasOwnProperty.call(value, 'callee') && !$952c49f88874830d$var$propertyIsEnumerable.call(value, 'callee');
};
$952c49f88874830d$exports = $952c49f88874830d$var$isArguments;




var $etvPu = parcelRequire("etvPu");
var $ca0882ca61ffd0f9$exports = {};
/** Used as references for various `Number` constants. */ var $ca0882ca61ffd0f9$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ca0882ca61ffd0f9$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ca0882ca61ffd0f9$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ca0882ca61ffd0f9$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ca0882ca61ffd0f9$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ca0882ca61ffd0f9$exports = $ca0882ca61ffd0f9$var$isIndex;


var $ca3b16e2adebd851$exports = {};
var $03eba33bba5373f8$exports = {};

var $663f93e59223648f$exports = {};
/** Used as references for various `Number` constants. */ var $663f93e59223648f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $663f93e59223648f$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $663f93e59223648f$var$MAX_SAFE_INTEGER;
}
$663f93e59223648f$exports = $663f93e59223648f$var$isLength;



/** `Object#toString` result references. */ var $03eba33bba5373f8$var$argsTag = '[object Arguments]', $03eba33bba5373f8$var$arrayTag = '[object Array]', $03eba33bba5373f8$var$boolTag = '[object Boolean]', $03eba33bba5373f8$var$dateTag = '[object Date]', $03eba33bba5373f8$var$errorTag = '[object Error]', $03eba33bba5373f8$var$funcTag = '[object Function]', $03eba33bba5373f8$var$mapTag = '[object Map]', $03eba33bba5373f8$var$numberTag = '[object Number]', $03eba33bba5373f8$var$objectTag = '[object Object]', $03eba33bba5373f8$var$regexpTag = '[object RegExp]', $03eba33bba5373f8$var$setTag = '[object Set]', $03eba33bba5373f8$var$stringTag = '[object String]', $03eba33bba5373f8$var$weakMapTag = '[object WeakMap]';
var $03eba33bba5373f8$var$arrayBufferTag = '[object ArrayBuffer]', $03eba33bba5373f8$var$dataViewTag = '[object DataView]', $03eba33bba5373f8$var$float32Tag = '[object Float32Array]', $03eba33bba5373f8$var$float64Tag = '[object Float64Array]', $03eba33bba5373f8$var$int8Tag = '[object Int8Array]', $03eba33bba5373f8$var$int16Tag = '[object Int16Array]', $03eba33bba5373f8$var$int32Tag = '[object Int32Array]', $03eba33bba5373f8$var$uint8Tag = '[object Uint8Array]', $03eba33bba5373f8$var$uint8ClampedTag = '[object Uint8ClampedArray]', $03eba33bba5373f8$var$uint16Tag = '[object Uint16Array]', $03eba33bba5373f8$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $03eba33bba5373f8$var$typedArrayTags = {};
$03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$float32Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$float64Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$int8Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$int16Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$int32Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint8Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint8ClampedTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint16Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint32Tag] = true;
$03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$argsTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$arrayTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$arrayBufferTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$boolTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$dataViewTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$dateTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$errorTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$funcTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$mapTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$numberTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$objectTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$regexpTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$setTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$stringTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $03eba33bba5373f8$var$baseIsTypedArray(value) {
    return $5188975b7cad44c5$exports(value) && $663f93e59223648f$exports(value.length) && !!$03eba33bba5373f8$var$typedArrayTags[$1c109846e1422af5$exports(value)];
}
$03eba33bba5373f8$exports = $03eba33bba5373f8$var$baseIsTypedArray;


var $bef6d3131c47d6d8$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $bef6d3131c47d6d8$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$bef6d3131c47d6d8$exports = $bef6d3131c47d6d8$var$baseUnary;



var $jCPbW = parcelRequire("jCPbW");
/* Node.js helper references. */ var $ca3b16e2adebd851$var$nodeIsTypedArray = $jCPbW && $jCPbW.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $ca3b16e2adebd851$var$isTypedArray = $ca3b16e2adebd851$var$nodeIsTypedArray ? $bef6d3131c47d6d8$exports($ca3b16e2adebd851$var$nodeIsTypedArray) : $03eba33bba5373f8$exports;
$ca3b16e2adebd851$exports = $ca3b16e2adebd851$var$isTypedArray;


/** Used for built-in method references. */ var $ea23925fdf992f08$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ea23925fdf992f08$var$hasOwnProperty = $ea23925fdf992f08$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $ea23925fdf992f08$var$arrayLikeKeys(value, inherited) {
    var isArr = $6f5a80e798063325$exports(value), isArg = !isArr && $952c49f88874830d$exports(value), isBuff = !isArr && !isArg && $etvPu(value), isType = !isArr && !isArg && !isBuff && $ca3b16e2adebd851$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $d90d012d66ab3f11$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $ea23925fdf992f08$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ca0882ca61ffd0f9$exports(key, length)))) result.push(key);
    return result;
}
$ea23925fdf992f08$exports = $ea23925fdf992f08$var$arrayLikeKeys;


var $ea8bd8c8494576f4$exports = {};
var $29a174d19294d445$exports = {};
/** Used for built-in method references. */ var $29a174d19294d445$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $29a174d19294d445$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $29a174d19294d445$var$objectProto;
    return value === proto;
}
$29a174d19294d445$exports = $29a174d19294d445$var$isPrototype;


var $bebe65d1d360c955$exports = {};
var $e2f54a2af776f5e8$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e2f54a2af776f5e8$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$e2f54a2af776f5e8$exports = $e2f54a2af776f5e8$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $bebe65d1d360c955$var$nativeKeys = $e2f54a2af776f5e8$exports(Object.keys, Object);
$bebe65d1d360c955$exports = $bebe65d1d360c955$var$nativeKeys;


/** Used for built-in method references. */ var $ea8bd8c8494576f4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ea8bd8c8494576f4$var$hasOwnProperty = $ea8bd8c8494576f4$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ea8bd8c8494576f4$var$baseKeys(object) {
    if (!$29a174d19294d445$exports(object)) return $bebe65d1d360c955$exports(object);
    var result = [];
    for(var key in Object(object))if ($ea8bd8c8494576f4$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$ea8bd8c8494576f4$exports = $ea8bd8c8494576f4$var$baseKeys;


var $2e138769f56eb023$exports = {};
var $5abac6f2b484f64d$exports = {};

var $4ccd3bc08bae62d6$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4ccd3bc08bae62d6$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$4ccd3bc08bae62d6$exports = $4ccd3bc08bae62d6$var$isObject;


/** `Object#toString` result references. */ var $5abac6f2b484f64d$var$asyncTag = '[object AsyncFunction]', $5abac6f2b484f64d$var$funcTag = '[object Function]', $5abac6f2b484f64d$var$genTag = '[object GeneratorFunction]', $5abac6f2b484f64d$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5abac6f2b484f64d$var$isFunction(value) {
    if (!$4ccd3bc08bae62d6$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $1c109846e1422af5$exports(value);
    return tag == $5abac6f2b484f64d$var$funcTag || tag == $5abac6f2b484f64d$var$genTag || tag == $5abac6f2b484f64d$var$asyncTag || tag == $5abac6f2b484f64d$var$proxyTag;
}
$5abac6f2b484f64d$exports = $5abac6f2b484f64d$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $2e138769f56eb023$var$isArrayLike(value) {
    return value != null && $663f93e59223648f$exports(value.length) && !$5abac6f2b484f64d$exports(value);
}
$2e138769f56eb023$exports = $2e138769f56eb023$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $fe18181eec9f466e$var$keys(object) {
    return $2e138769f56eb023$exports(object) ? $ea23925fdf992f08$exports(object) : $ea8bd8c8494576f4$exports(object);
}
$fe18181eec9f466e$exports = $fe18181eec9f466e$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $16c0518aee3073d2$var$baseForOwn(object, iteratee) {
    return object && $5f0d520ab670c24a$exports(object, iteratee, $fe18181eec9f466e$exports);
}
$16c0518aee3073d2$exports = $16c0518aee3073d2$var$baseForOwn;


var $cee3b0ec74822e7e$exports = {};
var $d619c6166c2f293d$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d619c6166c2f293d$var$identity(value) {
    return value;
}
$d619c6166c2f293d$exports = $d619c6166c2f293d$var$identity;


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $cee3b0ec74822e7e$var$castFunction(value) {
    return typeof value == 'function' ? value : $d619c6166c2f293d$exports;
}
$cee3b0ec74822e7e$exports = $cee3b0ec74822e7e$var$castFunction;


/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $318719a69d0cc713$var$forOwn(object, iteratee) {
    return object && $16c0518aee3073d2$exports(object, $cee3b0ec74822e7e$exports(iteratee));
}
$318719a69d0cc713$exports = $318719a69d0cc713$var$forOwn;


var $138ba754b5438268$var$_forOwn3 = $138ba754b5438268$var$_interopRequireDefault($318719a69d0cc713$exports);
var $80f71c47c5545146$exports = {};

var $0bd1df8323fb0fd5$exports = {};

/** Built-in value references. */ var $0bd1df8323fb0fd5$var$getPrototype = $e2f54a2af776f5e8$exports(Object.getPrototypeOf, Object);
$0bd1df8323fb0fd5$exports = $0bd1df8323fb0fd5$var$getPrototype;



/** `Object#toString` result references. */ var $80f71c47c5545146$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $80f71c47c5545146$var$funcProto = Function.prototype, $80f71c47c5545146$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $80f71c47c5545146$var$funcToString = $80f71c47c5545146$var$funcProto.toString;
/** Used to check objects for own properties. */ var $80f71c47c5545146$var$hasOwnProperty = $80f71c47c5545146$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $80f71c47c5545146$var$objectCtorString = $80f71c47c5545146$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $80f71c47c5545146$var$isPlainObject(value) {
    if (!$5188975b7cad44c5$exports(value) || $1c109846e1422af5$exports(value) != $80f71c47c5545146$var$objectTag) return false;
    var proto = $0bd1df8323fb0fd5$exports(value);
    if (proto === null) return true;
    var Ctor = $80f71c47c5545146$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $80f71c47c5545146$var$funcToString.call(Ctor) == $80f71c47c5545146$var$objectCtorString;
}
$80f71c47c5545146$exports = $80f71c47c5545146$var$isPlainObject;


var $138ba754b5438268$var$_isPlainObject3 = $138ba754b5438268$var$_interopRequireDefault($80f71c47c5545146$exports);
var $54a9e0e05c5ff4f1$exports = {};
var $9bfe25932a8249eb$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9bfe25932a8249eb$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$9bfe25932a8249eb$exports = $9bfe25932a8249eb$var$arrayMap;


var $ec2888ce0234c423$exports = {};
var $9ad8e58dc4f40f76$exports = {};
var $87a64dadef47d73e$exports = {};
var $fc45fc460db7b739$exports = {};
var $04f425b956ac809b$exports = {};
var $7d80433245292a2c$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $7d80433245292a2c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$7d80433245292a2c$exports = $7d80433245292a2c$var$listCacheClear;


var $c65ac335cf242164$exports = {};
var $cb68f99bcd12729f$exports = {};
var $e620c205668af378$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e620c205668af378$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$e620c205668af378$exports = $e620c205668af378$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cb68f99bcd12729f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e620c205668af378$exports(array[length][0], key)) return length;
    }
    return -1;
}
$cb68f99bcd12729f$exports = $cb68f99bcd12729f$var$assocIndexOf;


/** Used for built-in method references. */ var $c65ac335cf242164$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $c65ac335cf242164$var$splice = $c65ac335cf242164$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c65ac335cf242164$var$listCacheDelete(key) {
    var data = this.__data__, index = $cb68f99bcd12729f$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c65ac335cf242164$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$c65ac335cf242164$exports = $c65ac335cf242164$var$listCacheDelete;


var $a66fa7978e0ce50b$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a66fa7978e0ce50b$var$listCacheGet(key) {
    var data = this.__data__, index = $cb68f99bcd12729f$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$a66fa7978e0ce50b$exports = $a66fa7978e0ce50b$var$listCacheGet;


var $6fafa33856d519ec$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6fafa33856d519ec$var$listCacheHas(key) {
    return $cb68f99bcd12729f$exports(this.__data__, key) > -1;
}
$6fafa33856d519ec$exports = $6fafa33856d519ec$var$listCacheHas;


var $05140e4a1368b0c7$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $05140e4a1368b0c7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $cb68f99bcd12729f$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$05140e4a1368b0c7$exports = $05140e4a1368b0c7$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $04f425b956ac809b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$04f425b956ac809b$var$ListCache.prototype.clear = $7d80433245292a2c$exports;
$04f425b956ac809b$var$ListCache.prototype['delete'] = $c65ac335cf242164$exports;
$04f425b956ac809b$var$ListCache.prototype.get = $a66fa7978e0ce50b$exports;
$04f425b956ac809b$var$ListCache.prototype.has = $6fafa33856d519ec$exports;
$04f425b956ac809b$var$ListCache.prototype.set = $05140e4a1368b0c7$exports;
$04f425b956ac809b$exports = $04f425b956ac809b$var$ListCache;


var $0615c172f35e1194$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0615c172f35e1194$var$stackClear() {
    this.__data__ = new $04f425b956ac809b$exports;
    this.size = 0;
}
$0615c172f35e1194$exports = $0615c172f35e1194$var$stackClear;


var $e6ed41f1677f9012$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e6ed41f1677f9012$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$e6ed41f1677f9012$exports = $e6ed41f1677f9012$var$stackDelete;


var $a9fb94a03986c3dd$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a9fb94a03986c3dd$var$stackGet(key) {
    return this.__data__.get(key);
}
$a9fb94a03986c3dd$exports = $a9fb94a03986c3dd$var$stackGet;


var $0571a0e676afa454$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0571a0e676afa454$var$stackHas(key) {
    return this.__data__.has(key);
}
$0571a0e676afa454$exports = $0571a0e676afa454$var$stackHas;


var $6a6d04c47550ce38$exports = {};

var $e3238ee12913649c$exports = {};
var $f8cb39379728d11c$exports = {};
var $ef675819d7dd35e8$exports = {};

var $e22d2e0563e9381f$exports = {};
var $0630759302876204$exports = {};

var $670gj = parcelRequire("670gj");
/** Used to detect overreaching core-js shims. */ var $0630759302876204$var$coreJsData = $670gj["__core-js_shared__"];
$0630759302876204$exports = $0630759302876204$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $e22d2e0563e9381f$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($0630759302876204$exports && $0630759302876204$exports.keys && $0630759302876204$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e22d2e0563e9381f$var$isMasked(func) {
    return !!$e22d2e0563e9381f$var$maskSrcKey && $e22d2e0563e9381f$var$maskSrcKey in func;
}
$e22d2e0563e9381f$exports = $e22d2e0563e9381f$var$isMasked;



var $7b29489b8a37a7d5$exports = {};
/** Used for built-in method references. */ var $7b29489b8a37a7d5$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $7b29489b8a37a7d5$var$funcToString = $7b29489b8a37a7d5$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $7b29489b8a37a7d5$var$toSource(func) {
    if (func != null) {
        try {
            return $7b29489b8a37a7d5$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$7b29489b8a37a7d5$exports = $7b29489b8a37a7d5$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ef675819d7dd35e8$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ef675819d7dd35e8$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ef675819d7dd35e8$var$funcProto = Function.prototype, $ef675819d7dd35e8$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ef675819d7dd35e8$var$funcToString = $ef675819d7dd35e8$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ef675819d7dd35e8$var$hasOwnProperty = $ef675819d7dd35e8$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ef675819d7dd35e8$var$reIsNative = RegExp('^' + $ef675819d7dd35e8$var$funcToString.call($ef675819d7dd35e8$var$hasOwnProperty).replace($ef675819d7dd35e8$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ef675819d7dd35e8$var$baseIsNative(value) {
    if (!$4ccd3bc08bae62d6$exports(value) || $e22d2e0563e9381f$exports(value)) return false;
    var pattern = $5abac6f2b484f64d$exports(value) ? $ef675819d7dd35e8$var$reIsNative : $ef675819d7dd35e8$var$reIsHostCtor;
    return pattern.test($7b29489b8a37a7d5$exports(value));
}
$ef675819d7dd35e8$exports = $ef675819d7dd35e8$var$baseIsNative;


var $72248c65eb0b86ac$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $72248c65eb0b86ac$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$72248c65eb0b86ac$exports = $72248c65eb0b86ac$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f8cb39379728d11c$var$getNative(object, key) {
    var value = $72248c65eb0b86ac$exports(object, key);
    return $ef675819d7dd35e8$exports(value) ? value : undefined;
}
$f8cb39379728d11c$exports = $f8cb39379728d11c$var$getNative;



var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $e3238ee12913649c$var$Map = $f8cb39379728d11c$exports($670gj, 'Map');
$e3238ee12913649c$exports = $e3238ee12913649c$var$Map;


var $883d93f394a42c19$exports = {};
var $7552b19c1d2ee879$exports = {};
var $4b72d07d396ab763$exports = {};
var $89fb9e08e3af02a2$exports = {};
var $c78df7a648626f9a$exports = {};

/* Built-in method references that are verified to be native. */ var $c78df7a648626f9a$var$nativeCreate = $f8cb39379728d11c$exports(Object, 'create');
$c78df7a648626f9a$exports = $c78df7a648626f9a$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $89fb9e08e3af02a2$var$hashClear() {
    this.__data__ = $c78df7a648626f9a$exports ? $c78df7a648626f9a$exports(null) : {};
    this.size = 0;
}
$89fb9e08e3af02a2$exports = $89fb9e08e3af02a2$var$hashClear;


var $33f8f386bd4a39f2$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $33f8f386bd4a39f2$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$33f8f386bd4a39f2$exports = $33f8f386bd4a39f2$var$hashDelete;


var $3ba32a1b80aa5c29$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $3ba32a1b80aa5c29$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $3ba32a1b80aa5c29$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3ba32a1b80aa5c29$var$hasOwnProperty = $3ba32a1b80aa5c29$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3ba32a1b80aa5c29$var$hashGet(key) {
    var data = this.__data__;
    if ($c78df7a648626f9a$exports) {
        var result = data[key];
        return result === $3ba32a1b80aa5c29$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3ba32a1b80aa5c29$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$3ba32a1b80aa5c29$exports = $3ba32a1b80aa5c29$var$hashGet;


var $bdc8887343d202c0$exports = {};

/** Used for built-in method references. */ var $bdc8887343d202c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdc8887343d202c0$var$hasOwnProperty = $bdc8887343d202c0$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bdc8887343d202c0$var$hashHas(key) {
    var data = this.__data__;
    return $c78df7a648626f9a$exports ? data[key] !== undefined : $bdc8887343d202c0$var$hasOwnProperty.call(data, key);
}
$bdc8887343d202c0$exports = $bdc8887343d202c0$var$hashHas;


var $6858acb0871b463e$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $6858acb0871b463e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6858acb0871b463e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $c78df7a648626f9a$exports && value === undefined ? $6858acb0871b463e$var$HASH_UNDEFINED : value;
    return this;
}
$6858acb0871b463e$exports = $6858acb0871b463e$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4b72d07d396ab763$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$4b72d07d396ab763$var$Hash.prototype.clear = $89fb9e08e3af02a2$exports;
$4b72d07d396ab763$var$Hash.prototype['delete'] = $33f8f386bd4a39f2$exports;
$4b72d07d396ab763$var$Hash.prototype.get = $3ba32a1b80aa5c29$exports;
$4b72d07d396ab763$var$Hash.prototype.has = $bdc8887343d202c0$exports;
$4b72d07d396ab763$var$Hash.prototype.set = $6858acb0871b463e$exports;
$4b72d07d396ab763$exports = $4b72d07d396ab763$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7552b19c1d2ee879$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $4b72d07d396ab763$exports,
        'map': new ($e3238ee12913649c$exports || $04f425b956ac809b$exports),
        'string': new $4b72d07d396ab763$exports
    };
}
$7552b19c1d2ee879$exports = $7552b19c1d2ee879$var$mapCacheClear;


var $40f6299cb2e1de05$exports = {};
var $905534c65ab3482f$exports = {};
var $95855cec243bad3c$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $95855cec243bad3c$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$95855cec243bad3c$exports = $95855cec243bad3c$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $905534c65ab3482f$var$getMapData(map, key) {
    var data = map.__data__;
    return $95855cec243bad3c$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$905534c65ab3482f$exports = $905534c65ab3482f$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $40f6299cb2e1de05$var$mapCacheDelete(key) {
    var result = $905534c65ab3482f$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$40f6299cb2e1de05$exports = $40f6299cb2e1de05$var$mapCacheDelete;


var $f237ea7d386d73f3$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f237ea7d386d73f3$var$mapCacheGet(key) {
    return $905534c65ab3482f$exports(this, key).get(key);
}
$f237ea7d386d73f3$exports = $f237ea7d386d73f3$var$mapCacheGet;


var $e311eba61a544757$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e311eba61a544757$var$mapCacheHas(key) {
    return $905534c65ab3482f$exports(this, key).has(key);
}
$e311eba61a544757$exports = $e311eba61a544757$var$mapCacheHas;


var $a13943b341499e94$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a13943b341499e94$var$mapCacheSet(key, value) {
    var data = $905534c65ab3482f$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$a13943b341499e94$exports = $a13943b341499e94$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $883d93f394a42c19$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$883d93f394a42c19$var$MapCache.prototype.clear = $7552b19c1d2ee879$exports;
$883d93f394a42c19$var$MapCache.prototype['delete'] = $40f6299cb2e1de05$exports;
$883d93f394a42c19$var$MapCache.prototype.get = $f237ea7d386d73f3$exports;
$883d93f394a42c19$var$MapCache.prototype.has = $e311eba61a544757$exports;
$883d93f394a42c19$var$MapCache.prototype.set = $a13943b341499e94$exports;
$883d93f394a42c19$exports = $883d93f394a42c19$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $6a6d04c47550ce38$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $6a6d04c47550ce38$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $04f425b956ac809b$exports) {
        var pairs = data.__data__;
        if (!$e3238ee12913649c$exports || pairs.length < $6a6d04c47550ce38$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $883d93f394a42c19$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$6a6d04c47550ce38$exports = $6a6d04c47550ce38$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fc45fc460db7b739$var$Stack(entries) {
    var data = this.__data__ = new $04f425b956ac809b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$fc45fc460db7b739$var$Stack.prototype.clear = $0615c172f35e1194$exports;
$fc45fc460db7b739$var$Stack.prototype['delete'] = $e6ed41f1677f9012$exports;
$fc45fc460db7b739$var$Stack.prototype.get = $a9fb94a03986c3dd$exports;
$fc45fc460db7b739$var$Stack.prototype.has = $0571a0e676afa454$exports;
$fc45fc460db7b739$var$Stack.prototype.set = $6a6d04c47550ce38$exports;
$fc45fc460db7b739$exports = $fc45fc460db7b739$var$Stack;


var $77eb358af26f84f5$exports = {};
var $a40753a635b3d091$exports = {};

var $1e1338a6f6abc879$exports = {};
var $36d57a53c6b2d352$exports = {};

var $d7f4411c64491e7f$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $d7f4411c64491e7f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $d7f4411c64491e7f$var$setCacheAdd(value) {
    this.__data__.set(value, $d7f4411c64491e7f$var$HASH_UNDEFINED);
    return this;
}
$d7f4411c64491e7f$exports = $d7f4411c64491e7f$var$setCacheAdd;


var $056e99d810bb2b21$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $056e99d810bb2b21$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$056e99d810bb2b21$exports = $056e99d810bb2b21$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $36d57a53c6b2d352$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $883d93f394a42c19$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$36d57a53c6b2d352$var$SetCache.prototype.add = $36d57a53c6b2d352$var$SetCache.prototype.push = $d7f4411c64491e7f$exports;
$36d57a53c6b2d352$var$SetCache.prototype.has = $056e99d810bb2b21$exports;
$36d57a53c6b2d352$exports = $36d57a53c6b2d352$var$SetCache;


var $f2e93ca7651c4308$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $f2e93ca7651c4308$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$f2e93ca7651c4308$exports = $f2e93ca7651c4308$var$arraySome;


var $c735966c5af6027f$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c735966c5af6027f$var$cacheHas(cache, key) {
    return cache.has(key);
}
$c735966c5af6027f$exports = $c735966c5af6027f$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1e1338a6f6abc879$var$COMPARE_PARTIAL_FLAG = 1, $1e1338a6f6abc879$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1e1338a6f6abc879$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1e1338a6f6abc879$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1e1338a6f6abc879$var$COMPARE_UNORDERED_FLAG ? new $36d57a53c6b2d352$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$f2e93ca7651c4308$exports(other, function(othValue, othIndex) {
                if (!$c735966c5af6027f$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1e1338a6f6abc879$exports = $1e1338a6f6abc879$var$equalArrays;


var $d0283ba6febeb8e3$exports = {};

var $ca327083cdd4be51$exports = {};

var $670gj = parcelRequire("670gj");
/** Built-in value references. */ var $ca327083cdd4be51$var$Uint8Array = $670gj.Uint8Array;
$ca327083cdd4be51$exports = $ca327083cdd4be51$var$Uint8Array;




var $52df8ead90e90dce$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $52df8ead90e90dce$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$52df8ead90e90dce$exports = $52df8ead90e90dce$var$mapToArray;


var $4cf70a545bf15f76$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $4cf70a545bf15f76$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$4cf70a545bf15f76$exports = $4cf70a545bf15f76$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $d0283ba6febeb8e3$var$COMPARE_PARTIAL_FLAG = 1, $d0283ba6febeb8e3$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d0283ba6febeb8e3$var$boolTag = '[object Boolean]', $d0283ba6febeb8e3$var$dateTag = '[object Date]', $d0283ba6febeb8e3$var$errorTag = '[object Error]', $d0283ba6febeb8e3$var$mapTag = '[object Map]', $d0283ba6febeb8e3$var$numberTag = '[object Number]', $d0283ba6febeb8e3$var$regexpTag = '[object RegExp]', $d0283ba6febeb8e3$var$setTag = '[object Set]', $d0283ba6febeb8e3$var$stringTag = '[object String]', $d0283ba6febeb8e3$var$symbolTag = '[object Symbol]';
var $d0283ba6febeb8e3$var$arrayBufferTag = '[object ArrayBuffer]', $d0283ba6febeb8e3$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $d0283ba6febeb8e3$var$symbolProto = $38422377e4b90883$exports ? $38422377e4b90883$exports.prototype : undefined, $d0283ba6febeb8e3$var$symbolValueOf = $d0283ba6febeb8e3$var$symbolProto ? $d0283ba6febeb8e3$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d0283ba6febeb8e3$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d0283ba6febeb8e3$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d0283ba6febeb8e3$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $ca327083cdd4be51$exports(object), new $ca327083cdd4be51$exports(other))) return false;
            return true;
        case $d0283ba6febeb8e3$var$boolTag:
        case $d0283ba6febeb8e3$var$dateTag:
        case $d0283ba6febeb8e3$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $e620c205668af378$exports(+object, +other);
        case $d0283ba6febeb8e3$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d0283ba6febeb8e3$var$regexpTag:
        case $d0283ba6febeb8e3$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $d0283ba6febeb8e3$var$mapTag:
            var convert = $52df8ead90e90dce$exports;
        case $d0283ba6febeb8e3$var$setTag:
            var isPartial = bitmask & $d0283ba6febeb8e3$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $4cf70a545bf15f76$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d0283ba6febeb8e3$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1e1338a6f6abc879$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $d0283ba6febeb8e3$var$symbolTag:
            if ($d0283ba6febeb8e3$var$symbolValueOf) return $d0283ba6febeb8e3$var$symbolValueOf.call(object) == $d0283ba6febeb8e3$var$symbolValueOf.call(other);
    }
    return false;
}
$d0283ba6febeb8e3$exports = $d0283ba6febeb8e3$var$equalByTag;


var $85814f6475ddec07$exports = {};
var $4a5d4e8672052dd8$exports = {};
var $65e41f7def8bea4c$exports = {};
var $2828668373b7e86b$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $2828668373b7e86b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$2828668373b7e86b$exports = $2828668373b7e86b$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $65e41f7def8bea4c$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $6f5a80e798063325$exports(object) ? result : $2828668373b7e86b$exports(result, symbolsFunc(object));
}
$65e41f7def8bea4c$exports = $65e41f7def8bea4c$var$baseGetAllKeys;


var $4259b5c48eed3385$exports = {};
var $e03d1852dfb1db75$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e03d1852dfb1db75$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$e03d1852dfb1db75$exports = $e03d1852dfb1db75$var$arrayFilter;


var $91d6d593b6c2242e$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $91d6d593b6c2242e$var$stubArray() {
    return [];
}
$91d6d593b6c2242e$exports = $91d6d593b6c2242e$var$stubArray;


/** Used for built-in method references. */ var $4259b5c48eed3385$var$objectProto = Object.prototype;
/** Built-in value references. */ var $4259b5c48eed3385$var$propertyIsEnumerable = $4259b5c48eed3385$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4259b5c48eed3385$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4259b5c48eed3385$var$getSymbols = !$4259b5c48eed3385$var$nativeGetSymbols ? $91d6d593b6c2242e$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $e03d1852dfb1db75$exports($4259b5c48eed3385$var$nativeGetSymbols(object), function(symbol) {
        return $4259b5c48eed3385$var$propertyIsEnumerable.call(object, symbol);
    });
};
$4259b5c48eed3385$exports = $4259b5c48eed3385$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4a5d4e8672052dd8$var$getAllKeys(object) {
    return $65e41f7def8bea4c$exports(object, $fe18181eec9f466e$exports, $4259b5c48eed3385$exports);
}
$4a5d4e8672052dd8$exports = $4a5d4e8672052dd8$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $85814f6475ddec07$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $85814f6475ddec07$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $85814f6475ddec07$var$hasOwnProperty = $85814f6475ddec07$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $85814f6475ddec07$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $85814f6475ddec07$var$COMPARE_PARTIAL_FLAG, objProps = $4a5d4e8672052dd8$exports(object), objLength = objProps.length, othProps = $4a5d4e8672052dd8$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $85814f6475ddec07$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$85814f6475ddec07$exports = $85814f6475ddec07$var$equalObjects;


var $c663ac3340ae323c$exports = {};
var $2cf6b07cf380d1dc$exports = {};


var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $2cf6b07cf380d1dc$var$DataView = $f8cb39379728d11c$exports($670gj, 'DataView');
$2cf6b07cf380d1dc$exports = $2cf6b07cf380d1dc$var$DataView;



var $49949043198d0f76$exports = {};


var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $49949043198d0f76$var$Promise = $f8cb39379728d11c$exports($670gj, 'Promise');
$49949043198d0f76$exports = $49949043198d0f76$var$Promise;


var $091e63a778593cff$exports = {};


var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $091e63a778593cff$var$Set = $f8cb39379728d11c$exports($670gj, 'Set');
$091e63a778593cff$exports = $091e63a778593cff$var$Set;


var $f50d32193ef56417$exports = {};


var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $f50d32193ef56417$var$WeakMap = $f8cb39379728d11c$exports($670gj, 'WeakMap');
$f50d32193ef56417$exports = $f50d32193ef56417$var$WeakMap;




/** `Object#toString` result references. */ var $c663ac3340ae323c$var$mapTag = '[object Map]', $c663ac3340ae323c$var$objectTag = '[object Object]', $c663ac3340ae323c$var$promiseTag = '[object Promise]', $c663ac3340ae323c$var$setTag = '[object Set]', $c663ac3340ae323c$var$weakMapTag = '[object WeakMap]';
var $c663ac3340ae323c$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $c663ac3340ae323c$var$dataViewCtorString = $7b29489b8a37a7d5$exports($2cf6b07cf380d1dc$exports), $c663ac3340ae323c$var$mapCtorString = $7b29489b8a37a7d5$exports($e3238ee12913649c$exports), $c663ac3340ae323c$var$promiseCtorString = $7b29489b8a37a7d5$exports($49949043198d0f76$exports), $c663ac3340ae323c$var$setCtorString = $7b29489b8a37a7d5$exports($091e63a778593cff$exports), $c663ac3340ae323c$var$weakMapCtorString = $7b29489b8a37a7d5$exports($f50d32193ef56417$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $c663ac3340ae323c$var$getTag = $1c109846e1422af5$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2cf6b07cf380d1dc$exports && $c663ac3340ae323c$var$getTag(new $2cf6b07cf380d1dc$exports(new ArrayBuffer(1))) != $c663ac3340ae323c$var$dataViewTag || $e3238ee12913649c$exports && $c663ac3340ae323c$var$getTag(new $e3238ee12913649c$exports) != $c663ac3340ae323c$var$mapTag || $49949043198d0f76$exports && $c663ac3340ae323c$var$getTag($49949043198d0f76$exports.resolve()) != $c663ac3340ae323c$var$promiseTag || $091e63a778593cff$exports && $c663ac3340ae323c$var$getTag(new $091e63a778593cff$exports) != $c663ac3340ae323c$var$setTag || $f50d32193ef56417$exports && $c663ac3340ae323c$var$getTag(new $f50d32193ef56417$exports) != $c663ac3340ae323c$var$weakMapTag) $c663ac3340ae323c$var$getTag = function(value) {
    var result = $1c109846e1422af5$exports(value), Ctor = result == $c663ac3340ae323c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $7b29489b8a37a7d5$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $c663ac3340ae323c$var$dataViewCtorString:
            return $c663ac3340ae323c$var$dataViewTag;
        case $c663ac3340ae323c$var$mapCtorString:
            return $c663ac3340ae323c$var$mapTag;
        case $c663ac3340ae323c$var$promiseCtorString:
            return $c663ac3340ae323c$var$promiseTag;
        case $c663ac3340ae323c$var$setCtorString:
            return $c663ac3340ae323c$var$setTag;
        case $c663ac3340ae323c$var$weakMapCtorString:
            return $c663ac3340ae323c$var$weakMapTag;
    }
    return result;
};
$c663ac3340ae323c$exports = $c663ac3340ae323c$var$getTag;




var $etvPu = parcelRequire("etvPu");

/** Used to compose bitmasks for value comparisons. */ var $a40753a635b3d091$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $a40753a635b3d091$var$argsTag = '[object Arguments]', $a40753a635b3d091$var$arrayTag = '[object Array]', $a40753a635b3d091$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $a40753a635b3d091$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a40753a635b3d091$var$hasOwnProperty = $a40753a635b3d091$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a40753a635b3d091$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $6f5a80e798063325$exports(object), othIsArr = $6f5a80e798063325$exports(other), objTag = objIsArr ? $a40753a635b3d091$var$arrayTag : $c663ac3340ae323c$exports(object), othTag = othIsArr ? $a40753a635b3d091$var$arrayTag : $c663ac3340ae323c$exports(other);
    objTag = objTag == $a40753a635b3d091$var$argsTag ? $a40753a635b3d091$var$objectTag : objTag;
    othTag = othTag == $a40753a635b3d091$var$argsTag ? $a40753a635b3d091$var$objectTag : othTag;
    var objIsObj = objTag == $a40753a635b3d091$var$objectTag, othIsObj = othTag == $a40753a635b3d091$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $etvPu(object)) {
        if (!$etvPu(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $fc45fc460db7b739$exports);
        return objIsArr || $ca3b16e2adebd851$exports(object) ? $1e1338a6f6abc879$exports(object, other, bitmask, customizer, equalFunc, stack) : $d0283ba6febeb8e3$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $a40753a635b3d091$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $a40753a635b3d091$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $a40753a635b3d091$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $fc45fc460db7b739$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $fc45fc460db7b739$exports);
    return $85814f6475ddec07$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$a40753a635b3d091$exports = $a40753a635b3d091$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $77eb358af26f84f5$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5188975b7cad44c5$exports(value) && !$5188975b7cad44c5$exports(other)) return value !== value && other !== other;
    return $a40753a635b3d091$exports(value, other, bitmask, customizer, $77eb358af26f84f5$var$baseIsEqual, stack);
}
$77eb358af26f84f5$exports = $77eb358af26f84f5$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $87a64dadef47d73e$var$COMPARE_PARTIAL_FLAG = 1, $87a64dadef47d73e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $87a64dadef47d73e$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $fc45fc460db7b739$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $77eb358af26f84f5$exports(srcValue, objValue, $87a64dadef47d73e$var$COMPARE_PARTIAL_FLAG | $87a64dadef47d73e$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$87a64dadef47d73e$exports = $87a64dadef47d73e$var$baseIsMatch;


var $671f2090ea009f2e$exports = {};
var $3ff8c2f3f8cbc61f$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $3ff8c2f3f8cbc61f$var$isStrictComparable(value) {
    return value === value && !$4ccd3bc08bae62d6$exports(value);
}
$3ff8c2f3f8cbc61f$exports = $3ff8c2f3f8cbc61f$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $671f2090ea009f2e$var$getMatchData(object) {
    var result = $fe18181eec9f466e$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $3ff8c2f3f8cbc61f$exports(value)
        ];
    }
    return result;
}
$671f2090ea009f2e$exports = $671f2090ea009f2e$var$getMatchData;


var $6740ebdd8fcf04e8$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6740ebdd8fcf04e8$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$6740ebdd8fcf04e8$exports = $6740ebdd8fcf04e8$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $9ad8e58dc4f40f76$var$baseMatches(source) {
    var matchData = $671f2090ea009f2e$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $6740ebdd8fcf04e8$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $87a64dadef47d73e$exports(object, source, matchData);
    };
}
$9ad8e58dc4f40f76$exports = $9ad8e58dc4f40f76$var$baseMatches;


var $6fb8ec29129ca398$exports = {};

var $0235b24b0dbd4897$exports = {};
var $5b51b70f75b94aaa$exports = {};
var $c1a464b29c4b94e9$exports = {};

var $1dea514531de1ce0$exports = {};

var $a55af577c3525046$exports = {};


/** `Object#toString` result references. */ var $a55af577c3525046$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a55af577c3525046$var$isSymbol(value) {
    return typeof value == 'symbol' || $5188975b7cad44c5$exports(value) && $1c109846e1422af5$exports(value) == $a55af577c3525046$var$symbolTag;
}
$a55af577c3525046$exports = $a55af577c3525046$var$isSymbol;


/** Used to match property names within property paths. */ var $1dea514531de1ce0$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $1dea514531de1ce0$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $1dea514531de1ce0$var$isKey(value, object) {
    if ($6f5a80e798063325$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $a55af577c3525046$exports(value)) return true;
    return $1dea514531de1ce0$var$reIsPlainProp.test(value) || !$1dea514531de1ce0$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$1dea514531de1ce0$exports = $1dea514531de1ce0$var$isKey;


var $5c9d4634a80bbc90$exports = {};
var $063b2bcbf12fef93$exports = {};
var $f0919805c233e0e4$exports = {};

/** Error message constants. */ var $f0919805c233e0e4$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $f0919805c233e0e4$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($f0919805c233e0e4$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($f0919805c233e0e4$var$memoize.Cache || $883d93f394a42c19$exports);
    return memoized;
}
// Expose `MapCache`.
$f0919805c233e0e4$var$memoize.Cache = $883d93f394a42c19$exports;
$f0919805c233e0e4$exports = $f0919805c233e0e4$var$memoize;


/** Used as the maximum memoize cache size. */ var $063b2bcbf12fef93$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $063b2bcbf12fef93$var$memoizeCapped(func) {
    var result = $f0919805c233e0e4$exports(func, function(key) {
        if (cache.size === $063b2bcbf12fef93$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$063b2bcbf12fef93$exports = $063b2bcbf12fef93$var$memoizeCapped;


/** Used to match property names within property paths. */ var $5c9d4634a80bbc90$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $5c9d4634a80bbc90$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $5c9d4634a80bbc90$var$stringToPath = $063b2bcbf12fef93$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($5c9d4634a80bbc90$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($5c9d4634a80bbc90$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$5c9d4634a80bbc90$exports = $5c9d4634a80bbc90$var$stringToPath;


var $e151845f0d26f5dd$exports = {};
var $625233b1a89b29f8$exports = {};




/** Used as references for various `Number` constants. */ var $625233b1a89b29f8$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $625233b1a89b29f8$var$symbolProto = $38422377e4b90883$exports ? $38422377e4b90883$exports.prototype : undefined, $625233b1a89b29f8$var$symbolToString = $625233b1a89b29f8$var$symbolProto ? $625233b1a89b29f8$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $625233b1a89b29f8$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($6f5a80e798063325$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $9bfe25932a8249eb$exports(value, $625233b1a89b29f8$var$baseToString) + '';
    if ($a55af577c3525046$exports(value)) return $625233b1a89b29f8$var$symbolToString ? $625233b1a89b29f8$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$625233b1a89b29f8$var$INFINITY ? '-0' : result;
}
$625233b1a89b29f8$exports = $625233b1a89b29f8$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e151845f0d26f5dd$var$toString(value) {
    return value == null ? '' : $625233b1a89b29f8$exports(value);
}
$e151845f0d26f5dd$exports = $e151845f0d26f5dd$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $c1a464b29c4b94e9$var$castPath(value, object) {
    if ($6f5a80e798063325$exports(value)) return value;
    return $1dea514531de1ce0$exports(value, object) ? [
        value
    ] : $5c9d4634a80bbc90$exports($e151845f0d26f5dd$exports(value));
}
$c1a464b29c4b94e9$exports = $c1a464b29c4b94e9$var$castPath;


var $65ef066dd8d9fb30$exports = {};

/** Used as references for various `Number` constants. */ var $65ef066dd8d9fb30$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $65ef066dd8d9fb30$var$toKey(value) {
    if (typeof value == 'string' || $a55af577c3525046$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$65ef066dd8d9fb30$var$INFINITY ? '-0' : result;
}
$65ef066dd8d9fb30$exports = $65ef066dd8d9fb30$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $5b51b70f75b94aaa$var$baseGet(object, path) {
    path = $c1a464b29c4b94e9$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$65ef066dd8d9fb30$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$5b51b70f75b94aaa$exports = $5b51b70f75b94aaa$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $0235b24b0dbd4897$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5b51b70f75b94aaa$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$0235b24b0dbd4897$exports = $0235b24b0dbd4897$var$get;


var $ae3add7078329b6b$exports = {};
var $1273cf1cd84c38eb$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $1273cf1cd84c38eb$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$1273cf1cd84c38eb$exports = $1273cf1cd84c38eb$var$baseHasIn;


var $3bfa41a4606ac4ec$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $3bfa41a4606ac4ec$var$hasPath(object, path, hasFunc) {
    path = $c1a464b29c4b94e9$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $65ef066dd8d9fb30$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $663f93e59223648f$exports(length) && $ca0882ca61ffd0f9$exports(key, length) && ($6f5a80e798063325$exports(object) || $952c49f88874830d$exports(object));
}
$3bfa41a4606ac4ec$exports = $3bfa41a4606ac4ec$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ae3add7078329b6b$var$hasIn(object, path) {
    return object != null && $3bfa41a4606ac4ec$exports(object, path, $1273cf1cd84c38eb$exports);
}
$ae3add7078329b6b$exports = $ae3add7078329b6b$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $6fb8ec29129ca398$var$COMPARE_PARTIAL_FLAG = 1, $6fb8ec29129ca398$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6fb8ec29129ca398$var$baseMatchesProperty(path, srcValue) {
    if ($1dea514531de1ce0$exports(path) && $3ff8c2f3f8cbc61f$exports(srcValue)) return $6740ebdd8fcf04e8$exports($65ef066dd8d9fb30$exports(path), srcValue);
    return function(object) {
        var objValue = $0235b24b0dbd4897$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $ae3add7078329b6b$exports(object, path) : $77eb358af26f84f5$exports(srcValue, objValue, $6fb8ec29129ca398$var$COMPARE_PARTIAL_FLAG | $6fb8ec29129ca398$var$COMPARE_UNORDERED_FLAG);
    };
}
$6fb8ec29129ca398$exports = $6fb8ec29129ca398$var$baseMatchesProperty;




var $714e7229fba84c40$exports = {};
var $da922114e5dcb314$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $da922114e5dcb314$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$da922114e5dcb314$exports = $da922114e5dcb314$var$baseProperty;


var $c2c689b3a0e9c45f$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c2c689b3a0e9c45f$var$basePropertyDeep(path) {
    return function(object) {
        return $5b51b70f75b94aaa$exports(object, path);
    };
}
$c2c689b3a0e9c45f$exports = $c2c689b3a0e9c45f$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $714e7229fba84c40$var$property(path) {
    return $1dea514531de1ce0$exports(path) ? $da922114e5dcb314$exports($65ef066dd8d9fb30$exports(path)) : $c2c689b3a0e9c45f$exports(path);
}
$714e7229fba84c40$exports = $714e7229fba84c40$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $ec2888ce0234c423$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $d619c6166c2f293d$exports;
    if (typeof value == 'object') return $6f5a80e798063325$exports(value) ? $6fb8ec29129ca398$exports(value[0], value[1]) : $9ad8e58dc4f40f76$exports(value);
    return $714e7229fba84c40$exports(value);
}
$ec2888ce0234c423$exports = $ec2888ce0234c423$var$baseIteratee;


var $abdaec661b8f1f5a$exports = {};
var $c7234a3490286f20$exports = {};

var $b501a1b045f70104$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b501a1b045f70104$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$2e138769f56eb023$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$b501a1b045f70104$exports = $b501a1b045f70104$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $c7234a3490286f20$var$baseEach = $b501a1b045f70104$exports($16c0518aee3073d2$exports);
$c7234a3490286f20$exports = $c7234a3490286f20$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $abdaec661b8f1f5a$var$baseMap(collection, iteratee) {
    var index = -1, result = $2e138769f56eb023$exports(collection) ? Array(collection.length) : [];
    $c7234a3490286f20$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$abdaec661b8f1f5a$exports = $abdaec661b8f1f5a$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $54a9e0e05c5ff4f1$var$map(collection, iteratee) {
    var func = $6f5a80e798063325$exports(collection) ? $9bfe25932a8249eb$exports : $abdaec661b8f1f5a$exports;
    return func(collection, $ec2888ce0234c423$exports(iteratee, 3));
}
$54a9e0e05c5ff4f1$exports = $54a9e0e05c5ff4f1$var$map;


var $138ba754b5438268$var$_map3 = $138ba754b5438268$var$_interopRequireDefault($54a9e0e05c5ff4f1$exports);
function $138ba754b5438268$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $138ba754b5438268$var$flattenNames = $138ba754b5438268$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $138ba754b5438268$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $138ba754b5438268$var$_isPlainObject3.default)(thing)) (0, $138ba754b5438268$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, $138ba754b5438268$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$138ba754b5438268$exports.default = $138ba754b5438268$var$flattenNames;


var $88b1044c55714645$var$_flattenNames2 = $88b1044c55714645$var$_interopRequireDefault($138ba754b5438268$exports);
var $333fc2326c264bcb$exports = {};
'use strict';
Object.defineProperty($333fc2326c264bcb$exports, "__esModule", {
    value: true
});
$333fc2326c264bcb$exports.mergeClasses = undefined;

var $333fc2326c264bcb$var$_forOwn3 = $333fc2326c264bcb$var$_interopRequireDefault($318719a69d0cc713$exports);
var $8bf86a7a9e6c9e94$exports = {};
var $70408e0ac85f94f3$exports = {};

var $a4cf88419f5d3598$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a4cf88419f5d3598$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$a4cf88419f5d3598$exports = $a4cf88419f5d3598$var$arrayEach;


var $25463c6f03af6701$exports = {};
var $f52eba647ed2dfde$exports = {};
var $c4a5375f1fd6ad5b$exports = {};

var $c4a5375f1fd6ad5b$var$defineProperty = function() {
    try {
        var func = $f8cb39379728d11c$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$c4a5375f1fd6ad5b$exports = $c4a5375f1fd6ad5b$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f52eba647ed2dfde$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $c4a5375f1fd6ad5b$exports) $c4a5375f1fd6ad5b$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$f52eba647ed2dfde$exports = $f52eba647ed2dfde$var$baseAssignValue;



/** Used for built-in method references. */ var $25463c6f03af6701$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $25463c6f03af6701$var$hasOwnProperty = $25463c6f03af6701$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $25463c6f03af6701$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($25463c6f03af6701$var$hasOwnProperty.call(object, key) && $e620c205668af378$exports(objValue, value)) || value === undefined && !(key in object)) $f52eba647ed2dfde$exports(object, key, value);
}
$25463c6f03af6701$exports = $25463c6f03af6701$var$assignValue;


var $477358bae285d241$exports = {};
var $a4d0d461080f0a9c$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $a4d0d461080f0a9c$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $f52eba647ed2dfde$exports(object, key, newValue);
        else $25463c6f03af6701$exports(object, key, newValue);
    }
    return object;
}
$a4d0d461080f0a9c$exports = $a4d0d461080f0a9c$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $477358bae285d241$var$baseAssign(object, source) {
    return object && $a4d0d461080f0a9c$exports(source, $fe18181eec9f466e$exports(source), object);
}
$477358bae285d241$exports = $477358bae285d241$var$baseAssign;


var $59f1855ca64dea68$exports = {};

var $9159fee14d98f593$exports = {};

var $b880691ba9b7a1b1$exports = {};


var $969a1e4c3cd2a5a7$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $969a1e4c3cd2a5a7$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$969a1e4c3cd2a5a7$exports = $969a1e4c3cd2a5a7$var$nativeKeysIn;


/** Used for built-in method references. */ var $b880691ba9b7a1b1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b880691ba9b7a1b1$var$hasOwnProperty = $b880691ba9b7a1b1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b880691ba9b7a1b1$var$baseKeysIn(object) {
    if (!$4ccd3bc08bae62d6$exports(object)) return $969a1e4c3cd2a5a7$exports(object);
    var isProto = $29a174d19294d445$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$b880691ba9b7a1b1$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$b880691ba9b7a1b1$exports = $b880691ba9b7a1b1$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9159fee14d98f593$var$keysIn(object) {
    return $2e138769f56eb023$exports(object) ? $ea23925fdf992f08$exports(object, true) : $b880691ba9b7a1b1$exports(object);
}
$9159fee14d98f593$exports = $9159fee14d98f593$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $59f1855ca64dea68$var$baseAssignIn(object, source) {
    return object && $a4d0d461080f0a9c$exports(source, $9159fee14d98f593$exports(source), object);
}
$59f1855ca64dea68$exports = $59f1855ca64dea68$var$baseAssignIn;



var $bl8CU = parcelRequire("bl8CU");
var $5715d4f68e9aeaa7$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $5715d4f68e9aeaa7$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$5715d4f68e9aeaa7$exports = $5715d4f68e9aeaa7$var$copyArray;


var $7b5d9007d57c682d$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $7b5d9007d57c682d$var$copySymbols(source, object) {
    return $a4d0d461080f0a9c$exports(source, $4259b5c48eed3385$exports(source), object);
}
$7b5d9007d57c682d$exports = $7b5d9007d57c682d$var$copySymbols;


var $b6d24c404eeaf6a0$exports = {};

var $b7d8297ccef06bfe$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $b7d8297ccef06bfe$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b7d8297ccef06bfe$var$getSymbolsIn = !$b7d8297ccef06bfe$var$nativeGetSymbols ? $91d6d593b6c2242e$exports : function(object) {
    var result = [];
    while(object){
        $2828668373b7e86b$exports(result, $4259b5c48eed3385$exports(object));
        object = $0bd1df8323fb0fd5$exports(object);
    }
    return result;
};
$b7d8297ccef06bfe$exports = $b7d8297ccef06bfe$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b6d24c404eeaf6a0$var$copySymbolsIn(source, object) {
    return $a4d0d461080f0a9c$exports(source, $b7d8297ccef06bfe$exports(source), object);
}
$b6d24c404eeaf6a0$exports = $b6d24c404eeaf6a0$var$copySymbolsIn;



var $aef48cf6f55bb946$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $aef48cf6f55bb946$var$getAllKeysIn(object) {
    return $65e41f7def8bea4c$exports(object, $9159fee14d98f593$exports, $b7d8297ccef06bfe$exports);
}
$aef48cf6f55bb946$exports = $aef48cf6f55bb946$var$getAllKeysIn;



var $24d3b690f7d7d218$exports = {};
/** Used for built-in method references. */ var $24d3b690f7d7d218$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $24d3b690f7d7d218$var$hasOwnProperty = $24d3b690f7d7d218$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $24d3b690f7d7d218$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $24d3b690f7d7d218$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$24d3b690f7d7d218$exports = $24d3b690f7d7d218$var$initCloneArray;


var $7532787a934cf479$exports = {};
var $e71821ad86a68f84$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e71821ad86a68f84$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $ca327083cdd4be51$exports(result).set(new $ca327083cdd4be51$exports(arrayBuffer));
    return result;
}
$e71821ad86a68f84$exports = $e71821ad86a68f84$var$cloneArrayBuffer;


var $2c8e78442e765490$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2c8e78442e765490$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $e71821ad86a68f84$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$2c8e78442e765490$exports = $2c8e78442e765490$var$cloneDataView;


var $cc34e479ff39f879$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $cc34e479ff39f879$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $cc34e479ff39f879$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $cc34e479ff39f879$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$cc34e479ff39f879$exports = $cc34e479ff39f879$var$cloneRegExp;


var $c846e5daee9b64e4$exports = {};

/** Used to convert symbols to primitives and strings. */ var $c846e5daee9b64e4$var$symbolProto = $38422377e4b90883$exports ? $38422377e4b90883$exports.prototype : undefined, $c846e5daee9b64e4$var$symbolValueOf = $c846e5daee9b64e4$var$symbolProto ? $c846e5daee9b64e4$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $c846e5daee9b64e4$var$cloneSymbol(symbol) {
    return $c846e5daee9b64e4$var$symbolValueOf ? Object($c846e5daee9b64e4$var$symbolValueOf.call(symbol)) : {};
}
$c846e5daee9b64e4$exports = $c846e5daee9b64e4$var$cloneSymbol;


var $3c34435280c2c437$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $3c34435280c2c437$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $e71821ad86a68f84$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$3c34435280c2c437$exports = $3c34435280c2c437$var$cloneTypedArray;


/** `Object#toString` result references. */ var $7532787a934cf479$var$boolTag = '[object Boolean]', $7532787a934cf479$var$dateTag = '[object Date]', $7532787a934cf479$var$mapTag = '[object Map]', $7532787a934cf479$var$numberTag = '[object Number]', $7532787a934cf479$var$regexpTag = '[object RegExp]', $7532787a934cf479$var$setTag = '[object Set]', $7532787a934cf479$var$stringTag = '[object String]', $7532787a934cf479$var$symbolTag = '[object Symbol]';
var $7532787a934cf479$var$arrayBufferTag = '[object ArrayBuffer]', $7532787a934cf479$var$dataViewTag = '[object DataView]', $7532787a934cf479$var$float32Tag = '[object Float32Array]', $7532787a934cf479$var$float64Tag = '[object Float64Array]', $7532787a934cf479$var$int8Tag = '[object Int8Array]', $7532787a934cf479$var$int16Tag = '[object Int16Array]', $7532787a934cf479$var$int32Tag = '[object Int32Array]', $7532787a934cf479$var$uint8Tag = '[object Uint8Array]', $7532787a934cf479$var$uint8ClampedTag = '[object Uint8ClampedArray]', $7532787a934cf479$var$uint16Tag = '[object Uint16Array]', $7532787a934cf479$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $7532787a934cf479$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $7532787a934cf479$var$arrayBufferTag:
            return $e71821ad86a68f84$exports(object);
        case $7532787a934cf479$var$boolTag:
        case $7532787a934cf479$var$dateTag:
            return new Ctor(+object);
        case $7532787a934cf479$var$dataViewTag:
            return $2c8e78442e765490$exports(object, isDeep);
        case $7532787a934cf479$var$float32Tag:
        case $7532787a934cf479$var$float64Tag:
        case $7532787a934cf479$var$int8Tag:
        case $7532787a934cf479$var$int16Tag:
        case $7532787a934cf479$var$int32Tag:
        case $7532787a934cf479$var$uint8Tag:
        case $7532787a934cf479$var$uint8ClampedTag:
        case $7532787a934cf479$var$uint16Tag:
        case $7532787a934cf479$var$uint32Tag:
            return $3c34435280c2c437$exports(object, isDeep);
        case $7532787a934cf479$var$mapTag:
            return new Ctor;
        case $7532787a934cf479$var$numberTag:
        case $7532787a934cf479$var$stringTag:
            return new Ctor(object);
        case $7532787a934cf479$var$regexpTag:
            return $cc34e479ff39f879$exports(object);
        case $7532787a934cf479$var$setTag:
            return new Ctor;
        case $7532787a934cf479$var$symbolTag:
            return $c846e5daee9b64e4$exports(object);
    }
}
$7532787a934cf479$exports = $7532787a934cf479$var$initCloneByTag;


var $30a57accd224e5d6$exports = {};
var $a8ab5c6b4bf9eae4$exports = {};

/** Built-in value references. */ var $a8ab5c6b4bf9eae4$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a8ab5c6b4bf9eae4$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$4ccd3bc08bae62d6$exports(proto)) return {};
        if ($a8ab5c6b4bf9eae4$var$objectCreate) return $a8ab5c6b4bf9eae4$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$a8ab5c6b4bf9eae4$exports = $a8ab5c6b4bf9eae4$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $30a57accd224e5d6$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$29a174d19294d445$exports(object) ? $a8ab5c6b4bf9eae4$exports($0bd1df8323fb0fd5$exports(object)) : {};
}
$30a57accd224e5d6$exports = $30a57accd224e5d6$var$initCloneObject;




var $etvPu = parcelRequire("etvPu");
var $758f51e75cb905c8$exports = {};
var $81be819596944f12$exports = {};


/** `Object#toString` result references. */ var $81be819596944f12$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $81be819596944f12$var$baseIsMap(value) {
    return $5188975b7cad44c5$exports(value) && $c663ac3340ae323c$exports(value) == $81be819596944f12$var$mapTag;
}
$81be819596944f12$exports = $81be819596944f12$var$baseIsMap;




var $jCPbW = parcelRequire("jCPbW");
/* Node.js helper references. */ var $758f51e75cb905c8$var$nodeIsMap = $jCPbW && $jCPbW.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $758f51e75cb905c8$var$isMap = $758f51e75cb905c8$var$nodeIsMap ? $bef6d3131c47d6d8$exports($758f51e75cb905c8$var$nodeIsMap) : $81be819596944f12$exports;
$758f51e75cb905c8$exports = $758f51e75cb905c8$var$isMap;



var $29eb63f13ff96864$exports = {};
var $45f51a0c30e5ab9c$exports = {};


/** `Object#toString` result references. */ var $45f51a0c30e5ab9c$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $45f51a0c30e5ab9c$var$baseIsSet(value) {
    return $5188975b7cad44c5$exports(value) && $c663ac3340ae323c$exports(value) == $45f51a0c30e5ab9c$var$setTag;
}
$45f51a0c30e5ab9c$exports = $45f51a0c30e5ab9c$var$baseIsSet;




var $jCPbW = parcelRequire("jCPbW");
/* Node.js helper references. */ var $29eb63f13ff96864$var$nodeIsSet = $jCPbW && $jCPbW.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $29eb63f13ff96864$var$isSet = $29eb63f13ff96864$var$nodeIsSet ? $bef6d3131c47d6d8$exports($29eb63f13ff96864$var$nodeIsSet) : $45f51a0c30e5ab9c$exports;
$29eb63f13ff96864$exports = $29eb63f13ff96864$var$isSet;




/** Used to compose bitmasks for cloning. */ var $70408e0ac85f94f3$var$CLONE_DEEP_FLAG = 1, $70408e0ac85f94f3$var$CLONE_FLAT_FLAG = 2, $70408e0ac85f94f3$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $70408e0ac85f94f3$var$argsTag = '[object Arguments]', $70408e0ac85f94f3$var$arrayTag = '[object Array]', $70408e0ac85f94f3$var$boolTag = '[object Boolean]', $70408e0ac85f94f3$var$dateTag = '[object Date]', $70408e0ac85f94f3$var$errorTag = '[object Error]', $70408e0ac85f94f3$var$funcTag = '[object Function]', $70408e0ac85f94f3$var$genTag = '[object GeneratorFunction]', $70408e0ac85f94f3$var$mapTag = '[object Map]', $70408e0ac85f94f3$var$numberTag = '[object Number]', $70408e0ac85f94f3$var$objectTag = '[object Object]', $70408e0ac85f94f3$var$regexpTag = '[object RegExp]', $70408e0ac85f94f3$var$setTag = '[object Set]', $70408e0ac85f94f3$var$stringTag = '[object String]', $70408e0ac85f94f3$var$symbolTag = '[object Symbol]', $70408e0ac85f94f3$var$weakMapTag = '[object WeakMap]';
var $70408e0ac85f94f3$var$arrayBufferTag = '[object ArrayBuffer]', $70408e0ac85f94f3$var$dataViewTag = '[object DataView]', $70408e0ac85f94f3$var$float32Tag = '[object Float32Array]', $70408e0ac85f94f3$var$float64Tag = '[object Float64Array]', $70408e0ac85f94f3$var$int8Tag = '[object Int8Array]', $70408e0ac85f94f3$var$int16Tag = '[object Int16Array]', $70408e0ac85f94f3$var$int32Tag = '[object Int32Array]', $70408e0ac85f94f3$var$uint8Tag = '[object Uint8Array]', $70408e0ac85f94f3$var$uint8ClampedTag = '[object Uint8ClampedArray]', $70408e0ac85f94f3$var$uint16Tag = '[object Uint16Array]', $70408e0ac85f94f3$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $70408e0ac85f94f3$var$cloneableTags = {};
$70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$argsTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$arrayTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$arrayBufferTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$dataViewTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$boolTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$dateTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$float32Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$float64Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$int8Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$int16Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$int32Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$mapTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$numberTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$objectTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$regexpTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$setTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$stringTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$symbolTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint8Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint8ClampedTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint16Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint32Tag] = true;
$70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$errorTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$funcTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $70408e0ac85f94f3$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $70408e0ac85f94f3$var$CLONE_DEEP_FLAG, isFlat = bitmask & $70408e0ac85f94f3$var$CLONE_FLAT_FLAG, isFull = bitmask & $70408e0ac85f94f3$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$4ccd3bc08bae62d6$exports(value)) return value;
    var isArr = $6f5a80e798063325$exports(value);
    if (isArr) {
        result = $24d3b690f7d7d218$exports(value);
        if (!isDeep) return $5715d4f68e9aeaa7$exports(value, result);
    } else {
        var tag = $c663ac3340ae323c$exports(value), isFunc = tag == $70408e0ac85f94f3$var$funcTag || tag == $70408e0ac85f94f3$var$genTag;
        if ($etvPu(value)) return $bl8CU(value, isDeep);
        if (tag == $70408e0ac85f94f3$var$objectTag || tag == $70408e0ac85f94f3$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $30a57accd224e5d6$exports(value);
            if (!isDeep) return isFlat ? $b6d24c404eeaf6a0$exports(value, $59f1855ca64dea68$exports(result, value)) : $7b5d9007d57c682d$exports(value, $477358bae285d241$exports(result, value));
        } else {
            if (!$70408e0ac85f94f3$var$cloneableTags[tag]) return object ? value : {};
            result = $7532787a934cf479$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $fc45fc460db7b739$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($29eb63f13ff96864$exports(value)) value.forEach(function(subValue) {
        result.add($70408e0ac85f94f3$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($758f51e75cb905c8$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $70408e0ac85f94f3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $aef48cf6f55bb946$exports : $4a5d4e8672052dd8$exports : isFlat ? $9159fee14d98f593$exports : $fe18181eec9f466e$exports;
    var props = isArr ? undefined : keysFunc(value);
    $a4cf88419f5d3598$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $25463c6f03af6701$exports(result, key, $70408e0ac85f94f3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$70408e0ac85f94f3$exports = $70408e0ac85f94f3$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $8bf86a7a9e6c9e94$var$CLONE_DEEP_FLAG = 1, $8bf86a7a9e6c9e94$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8bf86a7a9e6c9e94$var$cloneDeep(value) {
    return $70408e0ac85f94f3$exports(value, $8bf86a7a9e6c9e94$var$CLONE_DEEP_FLAG | $8bf86a7a9e6c9e94$var$CLONE_SYMBOLS_FLAG);
}
$8bf86a7a9e6c9e94$exports = $8bf86a7a9e6c9e94$var$cloneDeep;


var $333fc2326c264bcb$var$_cloneDeep3 = $333fc2326c264bcb$var$_interopRequireDefault($8bf86a7a9e6c9e94$exports);
var $333fc2326c264bcb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $333fc2326c264bcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $333fc2326c264bcb$var$mergeClasses = $333fc2326c264bcb$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $333fc2326c264bcb$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $333fc2326c264bcb$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $333fc2326c264bcb$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$333fc2326c264bcb$exports.default = $333fc2326c264bcb$var$mergeClasses;


var $88b1044c55714645$var$_mergeClasses2 = $88b1044c55714645$var$_interopRequireDefault($333fc2326c264bcb$exports);
var $ddda6ea7d03b65fb$exports = {};
'use strict';
Object.defineProperty($ddda6ea7d03b65fb$exports, "__esModule", {
    value: true
});
$ddda6ea7d03b65fb$exports.autoprefix = undefined;

var $ddda6ea7d03b65fb$var$_forOwn3 = $ddda6ea7d03b65fb$var$_interopRequireDefault($318719a69d0cc713$exports);
var $ddda6ea7d03b65fb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $ddda6ea7d03b65fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ddda6ea7d03b65fb$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var $ddda6ea7d03b65fb$var$autoprefix = $ddda6ea7d03b65fb$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $ddda6ea7d03b65fb$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $ddda6ea7d03b65fb$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $ddda6ea7d03b65fb$var$transforms[key];
            if (transform) expanded = $ddda6ea7d03b65fb$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$ddda6ea7d03b65fb$exports.default = $ddda6ea7d03b65fb$var$autoprefix;


var $88b1044c55714645$var$_autoprefix2 = $88b1044c55714645$var$_interopRequireDefault($ddda6ea7d03b65fb$exports);
var $11be081181caf551$exports = {};
'use strict';
Object.defineProperty($11be081181caf551$exports, "__esModule", {
    value: true
});
$11be081181caf551$exports.hover = undefined;
var $11be081181caf551$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $11be081181caf551$var$_react2 = $11be081181caf551$var$_interopRequireDefault($eeH7J);
function $11be081181caf551$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11be081181caf551$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11be081181caf551$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $11be081181caf551$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $11be081181caf551$var$hover = $11be081181caf551$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $11be081181caf551$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $11be081181caf551$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $11be081181caf551$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $11be081181caf551$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $11be081181caf551$var$_react2.default.createElement(Component, $11be081181caf551$var$_extends({}, _this.props, _this.state)));
            }, _temp), $11be081181caf551$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($11be081181caf551$var$_react2.default.Component);
};
$11be081181caf551$exports.default = $11be081181caf551$var$hover;


var $88b1044c55714645$var$_hover3 = $88b1044c55714645$var$_interopRequireDefault($11be081181caf551$exports);
var $422d59563359ba56$exports = {};
'use strict';
Object.defineProperty($422d59563359ba56$exports, "__esModule", {
    value: true
});
$422d59563359ba56$exports.active = undefined;
var $422d59563359ba56$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $422d59563359ba56$var$_react2 = $422d59563359ba56$var$_interopRequireDefault($eeH7J);
function $422d59563359ba56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $422d59563359ba56$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $422d59563359ba56$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $422d59563359ba56$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $422d59563359ba56$var$active = $422d59563359ba56$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $422d59563359ba56$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $422d59563359ba56$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $422d59563359ba56$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $422d59563359ba56$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $422d59563359ba56$var$_react2.default.createElement(Component, $422d59563359ba56$var$_extends({}, _this.props, _this.state)));
            }, _temp), $422d59563359ba56$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($422d59563359ba56$var$_react2.default.Component);
};
$422d59563359ba56$exports.default = $422d59563359ba56$var$active;


var $88b1044c55714645$var$_active2 = $88b1044c55714645$var$_interopRequireDefault($422d59563359ba56$exports);
var $17ee8816aab573d4$exports = {};
'use strict';
Object.defineProperty($17ee8816aab573d4$exports, "__esModule", {
    value: true
});
var $17ee8816aab573d4$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
$17ee8816aab573d4$exports.default = $17ee8816aab573d4$var$loopable;


var $88b1044c55714645$var$_loop3 = $88b1044c55714645$var$_interopRequireDefault($17ee8816aab573d4$exports);
function $88b1044c55714645$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$88b1044c55714645$exports.hover = $88b1044c55714645$var$_hover3.default;
$88b1044c55714645$exports.handleHover = $88b1044c55714645$var$_hover3.default;
$88b1044c55714645$exports.handleActive = $88b1044c55714645$var$_active2.default;
$88b1044c55714645$exports.loop = $88b1044c55714645$var$_loop3.default;
var $88b1044c55714645$var$ReactCSS = $88b1044c55714645$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $88b1044c55714645$var$_flattenNames2.default)(activations);
    var merged = (0, $88b1044c55714645$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $88b1044c55714645$var$_autoprefix2.default)(merged);
};
$88b1044c55714645$exports.default = $88b1044c55714645$var$ReactCSS;



var $eeH7J = parcelRequire("eeH7J");

var $6cbc2b6dc50c7381$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};



var $eeH7J = parcelRequire("eeH7J");

var $1357a3e0e7266dc9$var$checkboardCache = {};
var $1357a3e0e7266dc9$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $1357a3e0e7266dc9$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if ($1357a3e0e7266dc9$var$checkboardCache[key]) return $1357a3e0e7266dc9$var$checkboardCache[key];
    var checkboard = $1357a3e0e7266dc9$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $1357a3e0e7266dc9$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $a30c75ca5a20b075$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a30c75ca5a20b075$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + $1357a3e0e7266dc9$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, $eeH7J.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement(children, $a30c75ca5a20b075$var$_extends({}, children.props, {
        style: $a30c75ca5a20b075$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.grid
    });
};
$a30c75ca5a20b075$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
var $a30c75ca5a20b075$export$2e2bcd8739ae039 = $a30c75ca5a20b075$export$457ff74489f64b4a;


var $9232e77ca409a344$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9232e77ca409a344$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $9232e77ca409a344$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9232e77ca409a344$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9232e77ca409a344$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9232e77ca409a344$export$b3d0ceb706f8af43 = function(_ref) {
    $9232e77ca409a344$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $9232e77ca409a344$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $9232e77ca409a344$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $6cbc2b6dc50c7381$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), $9232e77ca409a344$var$_possibleConstructorReturn(_this, _ret);
    }
    $9232e77ca409a344$var$_createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': $9232e77ca409a344$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a30c75ca5a20b075$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $9232e77ca409a344$export$2e2bcd8739ae039 = $9232e77ca409a344$export$b3d0ceb706f8af43;




var $eeH7J = parcelRequire("eeH7J");

var $75750ef8547f0a1f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $75750ef8547f0a1f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75750ef8547f0a1f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $75750ef8547f0a1f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $75750ef8547f0a1f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $75750ef8547f0a1f$var$DEFAULT_ARROW_OFFSET = 1;
var $75750ef8547f0a1f$var$UP_KEY_CODE = 38;
var $75750ef8547f0a1f$var$DOWN_KEY_CODE = 40;
var $75750ef8547f0a1f$var$VALID_KEY_CODES = [
    $75750ef8547f0a1f$var$UP_KEY_CODE,
    $75750ef8547f0a1f$var$DOWN_KEY_CODE
];
var $75750ef8547f0a1f$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $75750ef8547f0a1f$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $75750ef8547f0a1f$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var $75750ef8547f0a1f$var$idCounter = 1;
var $75750ef8547f0a1f$export$bfb3cbb78d3c298 = function(_ref) {
    $75750ef8547f0a1f$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $75750ef8547f0a1f$var$_classCallCheck(this, EditableInput);
        var _this = $75750ef8547f0a1f$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $75750ef8547f0a1f$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $75750ef8547f0a1f$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $75750ef8547f0a1f$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + $75750ef8547f0a1f$var$idCounter++;
        return _this;
    }
    $75750ef8547f0a1f$var$_createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return $75750ef8547f0a1f$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || $75750ef8547f0a1f$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $75750ef8547f0a1f$export$2e2bcd8739ae039 = $75750ef8547f0a1f$export$bfb3cbb78d3c298;



var $eeH7J = parcelRequire("eeH7J");

var $dcb0afcec562769f$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};


var $bec2357555e376de$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $bec2357555e376de$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bec2357555e376de$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bec2357555e376de$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $bec2357555e376de$export$3e22a96a58989a47 = function(_ref) {
    $bec2357555e376de$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $bec2357555e376de$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $bec2357555e376de$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $dcb0afcec562769f$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $bec2357555e376de$var$_possibleConstructorReturn(_this, _ret);
    }
    $bec2357555e376de$var$_createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $bec2357555e376de$export$2e2bcd8739ae039 = $bec2357555e376de$export$3e22a96a58989a47;



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $a963e94352234617$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $a963e94352234617$export$2e2bcd8739ae039 = $a963e94352234617$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $eeb9e562c601df3d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $eeb9e562c601df3d$export$2e2bcd8739ae039 = $eeb9e562c601df3d$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a5e932794ccc5943$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $eeb9e562c601df3d$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $a5e932794ccc5943$export$2e2bcd8739ae039 = $a5e932794ccc5943$var$assocIndexOf;


/** Used for built-in method references. */ var $de13f2741e96eeaa$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $de13f2741e96eeaa$var$splice = $de13f2741e96eeaa$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $de13f2741e96eeaa$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $a5e932794ccc5943$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $de13f2741e96eeaa$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $de13f2741e96eeaa$export$2e2bcd8739ae039 = $de13f2741e96eeaa$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $439bfafb0d4013cb$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $a5e932794ccc5943$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $439bfafb0d4013cb$export$2e2bcd8739ae039 = $439bfafb0d4013cb$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8ee4113c4ab76748$var$listCacheHas(key) {
    return (0, $a5e932794ccc5943$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $8ee4113c4ab76748$export$2e2bcd8739ae039 = $8ee4113c4ab76748$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1e629bd60b5fcf66$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $a5e932794ccc5943$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $1e629bd60b5fcf66$export$2e2bcd8739ae039 = $1e629bd60b5fcf66$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2e14b868b1672986$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$2e14b868b1672986$var$ListCache.prototype.clear = (0, $a963e94352234617$export$2e2bcd8739ae039);
$2e14b868b1672986$var$ListCache.prototype['delete'] = (0, $de13f2741e96eeaa$export$2e2bcd8739ae039);
$2e14b868b1672986$var$ListCache.prototype.get = (0, $439bfafb0d4013cb$export$2e2bcd8739ae039);
$2e14b868b1672986$var$ListCache.prototype.has = (0, $8ee4113c4ab76748$export$2e2bcd8739ae039);
$2e14b868b1672986$var$ListCache.prototype.set = (0, $1e629bd60b5fcf66$export$2e2bcd8739ae039);
var $2e14b868b1672986$export$2e2bcd8739ae039 = $2e14b868b1672986$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $88aaef4666839ddf$var$stackClear() {
    this.__data__ = new (0, $2e14b868b1672986$export$2e2bcd8739ae039);
    this.size = 0;
}
var $88aaef4666839ddf$export$2e2bcd8739ae039 = $88aaef4666839ddf$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d6113d1b0d6dd432$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $d6113d1b0d6dd432$export$2e2bcd8739ae039 = $d6113d1b0d6dd432$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b90e898f852a6ab8$var$stackGet(key) {
    return this.__data__.get(key);
}
var $b90e898f852a6ab8$export$2e2bcd8739ae039 = $b90e898f852a6ab8$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ff136f11dbc7024b$var$stackHas(key) {
    return this.__data__.has(key);
}
var $ff136f11dbc7024b$export$2e2bcd8739ae039 = $ff136f11dbc7024b$var$stackHas;




var $ier4x = parcelRequire("ier4x");
/** Built-in value references. */ var $5a41d29b535fbda9$var$Symbol = (0, $ier4x.default).Symbol;
var $5a41d29b535fbda9$export$2e2bcd8739ae039 = $5a41d29b535fbda9$var$Symbol;



/** Used for built-in method references. */ var $9698a749e3adeb0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9698a749e3adeb0b$var$hasOwnProperty = $9698a749e3adeb0b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9698a749e3adeb0b$var$nativeObjectToString = $9698a749e3adeb0b$var$objectProto.toString;
/** Built-in value references. */ var $9698a749e3adeb0b$var$symToStringTag = (0, $5a41d29b535fbda9$export$2e2bcd8739ae039) ? (0, $5a41d29b535fbda9$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9698a749e3adeb0b$var$getRawTag(value) {
    var isOwn = $9698a749e3adeb0b$var$hasOwnProperty.call(value, $9698a749e3adeb0b$var$symToStringTag), tag = value[$9698a749e3adeb0b$var$symToStringTag];
    try {
        value[$9698a749e3adeb0b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9698a749e3adeb0b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9698a749e3adeb0b$var$symToStringTag] = tag;
        else delete value[$9698a749e3adeb0b$var$symToStringTag];
    }
    return result;
}
var $9698a749e3adeb0b$export$2e2bcd8739ae039 = $9698a749e3adeb0b$var$getRawTag;


/** Used for built-in method references. */ var $d5b71aff0f880d1b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d5b71aff0f880d1b$var$nativeObjectToString = $d5b71aff0f880d1b$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d5b71aff0f880d1b$var$objectToString(value) {
    return $d5b71aff0f880d1b$var$nativeObjectToString.call(value);
}
var $d5b71aff0f880d1b$export$2e2bcd8739ae039 = $d5b71aff0f880d1b$var$objectToString;


/** `Object#toString` result references. */ var $a4a68779135a927a$var$nullTag = '[object Null]', $a4a68779135a927a$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a4a68779135a927a$var$symToStringTag = (0, $5a41d29b535fbda9$export$2e2bcd8739ae039) ? (0, $5a41d29b535fbda9$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a4a68779135a927a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a4a68779135a927a$var$undefinedTag : $a4a68779135a927a$var$nullTag;
    return $a4a68779135a927a$var$symToStringTag && $a4a68779135a927a$var$symToStringTag in Object(value) ? (0, $9698a749e3adeb0b$export$2e2bcd8739ae039)(value) : (0, $d5b71aff0f880d1b$export$2e2bcd8739ae039)(value);
}
var $a4a68779135a927a$export$2e2bcd8739ae039 = $a4a68779135a927a$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $25748a0d7cbe14c0$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $25748a0d7cbe14c0$export$2e2bcd8739ae039 = $25748a0d7cbe14c0$var$isObject;


/** `Object#toString` result references. */ var $dc2f9f78d9753304$var$asyncTag = '[object AsyncFunction]', $dc2f9f78d9753304$var$funcTag = '[object Function]', $dc2f9f78d9753304$var$genTag = '[object GeneratorFunction]', $dc2f9f78d9753304$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $dc2f9f78d9753304$var$isFunction(value) {
    if (!(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $a4a68779135a927a$export$2e2bcd8739ae039)(value);
    return tag == $dc2f9f78d9753304$var$funcTag || tag == $dc2f9f78d9753304$var$genTag || tag == $dc2f9f78d9753304$var$asyncTag || tag == $dc2f9f78d9753304$var$proxyTag;
}
var $dc2f9f78d9753304$export$2e2bcd8739ae039 = $dc2f9f78d9753304$var$isFunction;



var $ier4x = parcelRequire("ier4x");
/** Used to detect overreaching core-js shims. */ var $5af25f95eb06a072$var$coreJsData = (0, $ier4x.default)['__core-js_shared__'];
var $5af25f95eb06a072$export$2e2bcd8739ae039 = $5af25f95eb06a072$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $a8ffd5b6435114d2$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $5af25f95eb06a072$export$2e2bcd8739ae039) && (0, $5af25f95eb06a072$export$2e2bcd8739ae039).keys && (0, $5af25f95eb06a072$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $a8ffd5b6435114d2$var$isMasked(func) {
    return !!$a8ffd5b6435114d2$var$maskSrcKey && $a8ffd5b6435114d2$var$maskSrcKey in func;
}
var $a8ffd5b6435114d2$export$2e2bcd8739ae039 = $a8ffd5b6435114d2$var$isMasked;



/** Used for built-in method references. */ var $35277c0394d92823$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $35277c0394d92823$var$funcToString = $35277c0394d92823$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $35277c0394d92823$var$toSource(func) {
    if (func != null) {
        try {
            return $35277c0394d92823$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $35277c0394d92823$export$2e2bcd8739ae039 = $35277c0394d92823$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $432bf4158c16bc46$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $432bf4158c16bc46$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $432bf4158c16bc46$var$funcProto = Function.prototype, $432bf4158c16bc46$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $432bf4158c16bc46$var$funcToString = $432bf4158c16bc46$var$funcProto.toString;
/** Used to check objects for own properties. */ var $432bf4158c16bc46$var$hasOwnProperty = $432bf4158c16bc46$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $432bf4158c16bc46$var$reIsNative = RegExp('^' + $432bf4158c16bc46$var$funcToString.call($432bf4158c16bc46$var$hasOwnProperty).replace($432bf4158c16bc46$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $432bf4158c16bc46$var$baseIsNative(value) {
    if (!(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(value) || (0, $a8ffd5b6435114d2$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $dc2f9f78d9753304$export$2e2bcd8739ae039)(value) ? $432bf4158c16bc46$var$reIsNative : $432bf4158c16bc46$var$reIsHostCtor;
    return pattern.test((0, $35277c0394d92823$export$2e2bcd8739ae039)(value));
}
var $432bf4158c16bc46$export$2e2bcd8739ae039 = $432bf4158c16bc46$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $05f2d406672c2a96$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $05f2d406672c2a96$export$2e2bcd8739ae039 = $05f2d406672c2a96$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $0db1eac8602cea00$var$getNative(object, key) {
    var value = (0, $05f2d406672c2a96$export$2e2bcd8739ae039)(object, key);
    return (0, $432bf4158c16bc46$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $0db1eac8602cea00$export$2e2bcd8739ae039 = $0db1eac8602cea00$var$getNative;



var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $25773aa5940e7b4c$var$Map = (0, $0db1eac8602cea00$export$2e2bcd8739ae039)((0, $ier4x.default), 'Map');
var $25773aa5940e7b4c$export$2e2bcd8739ae039 = $25773aa5940e7b4c$var$Map;



/* Built-in method references that are verified to be native. */ var $835dcdfabf22e39b$var$nativeCreate = (0, $0db1eac8602cea00$export$2e2bcd8739ae039)(Object, 'create');
var $835dcdfabf22e39b$export$2e2bcd8739ae039 = $835dcdfabf22e39b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $045c2dfe2bd671f4$var$hashClear() {
    this.__data__ = (0, $835dcdfabf22e39b$export$2e2bcd8739ae039) ? (0, $835dcdfabf22e39b$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $045c2dfe2bd671f4$export$2e2bcd8739ae039 = $045c2dfe2bd671f4$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5d98102cf28b1901$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $5d98102cf28b1901$export$2e2bcd8739ae039 = $5d98102cf28b1901$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $3102f812a723a943$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $3102f812a723a943$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3102f812a723a943$var$hasOwnProperty = $3102f812a723a943$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3102f812a723a943$var$hashGet(key) {
    var data = this.__data__;
    if (0, $835dcdfabf22e39b$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $3102f812a723a943$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3102f812a723a943$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $3102f812a723a943$export$2e2bcd8739ae039 = $3102f812a723a943$var$hashGet;



/** Used for built-in method references. */ var $b43f54681c6dab3a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b43f54681c6dab3a$var$hasOwnProperty = $b43f54681c6dab3a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b43f54681c6dab3a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $835dcdfabf22e39b$export$2e2bcd8739ae039) ? data[key] !== undefined : $b43f54681c6dab3a$var$hasOwnProperty.call(data, key);
}
var $b43f54681c6dab3a$export$2e2bcd8739ae039 = $b43f54681c6dab3a$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $c66bd1b800da54ad$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c66bd1b800da54ad$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $835dcdfabf22e39b$export$2e2bcd8739ae039) && value === undefined ? $c66bd1b800da54ad$var$HASH_UNDEFINED : value;
    return this;
}
var $c66bd1b800da54ad$export$2e2bcd8739ae039 = $c66bd1b800da54ad$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ac7d2e0b5c1c445f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$ac7d2e0b5c1c445f$var$Hash.prototype.clear = (0, $045c2dfe2bd671f4$export$2e2bcd8739ae039);
$ac7d2e0b5c1c445f$var$Hash.prototype['delete'] = (0, $5d98102cf28b1901$export$2e2bcd8739ae039);
$ac7d2e0b5c1c445f$var$Hash.prototype.get = (0, $3102f812a723a943$export$2e2bcd8739ae039);
$ac7d2e0b5c1c445f$var$Hash.prototype.has = (0, $b43f54681c6dab3a$export$2e2bcd8739ae039);
$ac7d2e0b5c1c445f$var$Hash.prototype.set = (0, $c66bd1b800da54ad$export$2e2bcd8739ae039);
var $ac7d2e0b5c1c445f$export$2e2bcd8739ae039 = $ac7d2e0b5c1c445f$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $84c5fe143b0f805f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $ac7d2e0b5c1c445f$export$2e2bcd8739ae039),
        'map': new ((0, $25773aa5940e7b4c$export$2e2bcd8739ae039) || (0, $2e14b868b1672986$export$2e2bcd8739ae039)),
        'string': new (0, $ac7d2e0b5c1c445f$export$2e2bcd8739ae039)
    };
}
var $84c5fe143b0f805f$export$2e2bcd8739ae039 = $84c5fe143b0f805f$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ec32eb3b35ab32ec$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $ec32eb3b35ab32ec$export$2e2bcd8739ae039 = $ec32eb3b35ab32ec$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ad842007ed75dbc7$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $ec32eb3b35ab32ec$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $ad842007ed75dbc7$export$2e2bcd8739ae039 = $ad842007ed75dbc7$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fded07795f582f2e$var$mapCacheDelete(key) {
    var result = (0, $ad842007ed75dbc7$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $fded07795f582f2e$export$2e2bcd8739ae039 = $fded07795f582f2e$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $379759e530f16f4c$var$mapCacheGet(key) {
    return (0, $ad842007ed75dbc7$export$2e2bcd8739ae039)(this, key).get(key);
}
var $379759e530f16f4c$export$2e2bcd8739ae039 = $379759e530f16f4c$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1440fe90d804fbe0$var$mapCacheHas(key) {
    return (0, $ad842007ed75dbc7$export$2e2bcd8739ae039)(this, key).has(key);
}
var $1440fe90d804fbe0$export$2e2bcd8739ae039 = $1440fe90d804fbe0$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1aa05ff4308d8b18$var$mapCacheSet(key, value) {
    var data = (0, $ad842007ed75dbc7$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $1aa05ff4308d8b18$export$2e2bcd8739ae039 = $1aa05ff4308d8b18$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3c705e7737702eab$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3c705e7737702eab$var$MapCache.prototype.clear = (0, $84c5fe143b0f805f$export$2e2bcd8739ae039);
$3c705e7737702eab$var$MapCache.prototype['delete'] = (0, $fded07795f582f2e$export$2e2bcd8739ae039);
$3c705e7737702eab$var$MapCache.prototype.get = (0, $379759e530f16f4c$export$2e2bcd8739ae039);
$3c705e7737702eab$var$MapCache.prototype.has = (0, $1440fe90d804fbe0$export$2e2bcd8739ae039);
$3c705e7737702eab$var$MapCache.prototype.set = (0, $1aa05ff4308d8b18$export$2e2bcd8739ae039);
var $3c705e7737702eab$export$2e2bcd8739ae039 = $3c705e7737702eab$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $1d96887e2aab365e$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $1d96887e2aab365e$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $2e14b868b1672986$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $25773aa5940e7b4c$export$2e2bcd8739ae039) || pairs.length < $1d96887e2aab365e$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $3c705e7737702eab$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $1d96887e2aab365e$export$2e2bcd8739ae039 = $1d96887e2aab365e$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d9bf16d4d84249b6$var$Stack(entries) {
    var data = this.__data__ = new (0, $2e14b868b1672986$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$d9bf16d4d84249b6$var$Stack.prototype.clear = (0, $88aaef4666839ddf$export$2e2bcd8739ae039);
$d9bf16d4d84249b6$var$Stack.prototype['delete'] = (0, $d6113d1b0d6dd432$export$2e2bcd8739ae039);
$d9bf16d4d84249b6$var$Stack.prototype.get = (0, $b90e898f852a6ab8$export$2e2bcd8739ae039);
$d9bf16d4d84249b6$var$Stack.prototype.has = (0, $ff136f11dbc7024b$export$2e2bcd8739ae039);
$d9bf16d4d84249b6$var$Stack.prototype.set = (0, $1d96887e2aab365e$export$2e2bcd8739ae039);
var $d9bf16d4d84249b6$export$2e2bcd8739ae039 = $d9bf16d4d84249b6$var$Stack;



var $0eba72c26ca3c12e$var$defineProperty = function() {
    try {
        var func = (0, $0db1eac8602cea00$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $0eba72c26ca3c12e$export$2e2bcd8739ae039 = $0eba72c26ca3c12e$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9ecf54100ca47aba$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $0eba72c26ca3c12e$export$2e2bcd8739ae039)) (0, $0eba72c26ca3c12e$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $9ecf54100ca47aba$export$2e2bcd8739ae039 = $9ecf54100ca47aba$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $cb20bdf7805c2c76$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $eeb9e562c601df3d$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $9ecf54100ca47aba$export$2e2bcd8739ae039)(object, key, value);
}
var $cb20bdf7805c2c76$export$2e2bcd8739ae039 = $cb20bdf7805c2c76$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $1468832735f89d21$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $1468832735f89d21$export$2e2bcd8739ae039 = $1468832735f89d21$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $84e140eb0a34aa86$var$baseFor = (0, $1468832735f89d21$export$2e2bcd8739ae039)();
var $84e140eb0a34aa86$export$2e2bcd8739ae039 = $84e140eb0a34aa86$var$baseFor;




var $i04Md = parcelRequire("i04Md");

var $ier4x = parcelRequire("ier4x");
/** Built-in value references. */ var $c6e9b4ec73f542b2$var$Uint8Array = (0, $ier4x.default).Uint8Array;
var $c6e9b4ec73f542b2$export$2e2bcd8739ae039 = $c6e9b4ec73f542b2$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $f5c7dda80d34a02a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $c6e9b4ec73f542b2$export$2e2bcd8739ae039)(result).set(new (0, $c6e9b4ec73f542b2$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $f5c7dda80d34a02a$export$2e2bcd8739ae039 = $f5c7dda80d34a02a$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $13accf28b5781771$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $f5c7dda80d34a02a$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $13accf28b5781771$export$2e2bcd8739ae039 = $13accf28b5781771$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0e8e86ab14c0a404$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $0e8e86ab14c0a404$export$2e2bcd8739ae039 = $0e8e86ab14c0a404$var$copyArray;



/** Built-in value references. */ var $34d6bb04b10f8aea$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $34d6bb04b10f8aea$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(proto)) return {};
        if ($34d6bb04b10f8aea$var$objectCreate) return $34d6bb04b10f8aea$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $34d6bb04b10f8aea$export$2e2bcd8739ae039 = $34d6bb04b10f8aea$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $47a4ad607c69fe3a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $47a4ad607c69fe3a$export$2e2bcd8739ae039 = $47a4ad607c69fe3a$var$overArg;


/** Built-in value references. */ var $cdc9416ec3a0264b$var$getPrototype = (0, $47a4ad607c69fe3a$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $cdc9416ec3a0264b$export$2e2bcd8739ae039 = $cdc9416ec3a0264b$var$getPrototype;


/** Used for built-in method references. */ var $085c372fceab446a$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $085c372fceab446a$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $085c372fceab446a$var$objectProto;
    return value === proto;
}
var $085c372fceab446a$export$2e2bcd8739ae039 = $085c372fceab446a$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $e74270428480da5e$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $085c372fceab446a$export$2e2bcd8739ae039)(object) ? (0, $34d6bb04b10f8aea$export$2e2bcd8739ae039)((0, $cdc9416ec3a0264b$export$2e2bcd8739ae039)(object)) : {};
}
var $e74270428480da5e$export$2e2bcd8739ae039 = $e74270428480da5e$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $071ae2763fad6b0a$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $071ae2763fad6b0a$export$2e2bcd8739ae039 = $071ae2763fad6b0a$var$isObjectLike;


/** `Object#toString` result references. */ var $7481c2f94683e9a0$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $7481c2f94683e9a0$var$baseIsArguments(value) {
    return (0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && (0, $a4a68779135a927a$export$2e2bcd8739ae039)(value) == $7481c2f94683e9a0$var$argsTag;
}
var $7481c2f94683e9a0$export$2e2bcd8739ae039 = $7481c2f94683e9a0$var$baseIsArguments;



/** Used for built-in method references. */ var $feaaf99b892a2807$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $feaaf99b892a2807$var$hasOwnProperty = $feaaf99b892a2807$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $feaaf99b892a2807$var$propertyIsEnumerable = $feaaf99b892a2807$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $feaaf99b892a2807$var$isArguments = (0, $7481c2f94683e9a0$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $7481c2f94683e9a0$export$2e2bcd8739ae039) : function(value) {
    return (0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && $feaaf99b892a2807$var$hasOwnProperty.call(value, 'callee') && !$feaaf99b892a2807$var$propertyIsEnumerable.call(value, 'callee');
};
var $feaaf99b892a2807$export$2e2bcd8739ae039 = $feaaf99b892a2807$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0482a7b1c37d82c4$var$isArray = Array.isArray;
var $0482a7b1c37d82c4$export$2e2bcd8739ae039 = $0482a7b1c37d82c4$var$isArray;



/** Used as references for various `Number` constants. */ var $a502e9cfca20b420$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $a502e9cfca20b420$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $a502e9cfca20b420$var$MAX_SAFE_INTEGER;
}
var $a502e9cfca20b420$export$2e2bcd8739ae039 = $a502e9cfca20b420$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $9fa71e83b98fbb84$var$isArrayLike(value) {
    return value != null && (0, $a502e9cfca20b420$export$2e2bcd8739ae039)(value.length) && !(0, $dc2f9f78d9753304$export$2e2bcd8739ae039)(value);
}
var $9fa71e83b98fbb84$export$2e2bcd8739ae039 = $9fa71e83b98fbb84$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $7a6c5d83033800e1$var$isArrayLikeObject(value) {
    return (0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && (0, $9fa71e83b98fbb84$export$2e2bcd8739ae039)(value);
}
var $7a6c5d83033800e1$export$2e2bcd8739ae039 = $7a6c5d83033800e1$var$isArrayLikeObject;



var $igoKr = parcelRequire("igoKr");





/** `Object#toString` result references. */ var $9384df634da96665$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $9384df634da96665$var$funcProto = Function.prototype, $9384df634da96665$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9384df634da96665$var$funcToString = $9384df634da96665$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9384df634da96665$var$hasOwnProperty = $9384df634da96665$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $9384df634da96665$var$objectCtorString = $9384df634da96665$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $9384df634da96665$var$isPlainObject(value) {
    if (!(0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) || (0, $a4a68779135a927a$export$2e2bcd8739ae039)(value) != $9384df634da96665$var$objectTag) return false;
    var proto = (0, $cdc9416ec3a0264b$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $9384df634da96665$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $9384df634da96665$var$funcToString.call(Ctor) == $9384df634da96665$var$objectCtorString;
}
var $9384df634da96665$export$2e2bcd8739ae039 = $9384df634da96665$var$isPlainObject;





/** `Object#toString` result references. */ var $fabe0cce3f5d5b01$var$argsTag = '[object Arguments]', $fabe0cce3f5d5b01$var$arrayTag = '[object Array]', $fabe0cce3f5d5b01$var$boolTag = '[object Boolean]', $fabe0cce3f5d5b01$var$dateTag = '[object Date]', $fabe0cce3f5d5b01$var$errorTag = '[object Error]', $fabe0cce3f5d5b01$var$funcTag = '[object Function]', $fabe0cce3f5d5b01$var$mapTag = '[object Map]', $fabe0cce3f5d5b01$var$numberTag = '[object Number]', $fabe0cce3f5d5b01$var$objectTag = '[object Object]', $fabe0cce3f5d5b01$var$regexpTag = '[object RegExp]', $fabe0cce3f5d5b01$var$setTag = '[object Set]', $fabe0cce3f5d5b01$var$stringTag = '[object String]', $fabe0cce3f5d5b01$var$weakMapTag = '[object WeakMap]';
var $fabe0cce3f5d5b01$var$arrayBufferTag = '[object ArrayBuffer]', $fabe0cce3f5d5b01$var$dataViewTag = '[object DataView]', $fabe0cce3f5d5b01$var$float32Tag = '[object Float32Array]', $fabe0cce3f5d5b01$var$float64Tag = '[object Float64Array]', $fabe0cce3f5d5b01$var$int8Tag = '[object Int8Array]', $fabe0cce3f5d5b01$var$int16Tag = '[object Int16Array]', $fabe0cce3f5d5b01$var$int32Tag = '[object Int32Array]', $fabe0cce3f5d5b01$var$uint8Tag = '[object Uint8Array]', $fabe0cce3f5d5b01$var$uint8ClampedTag = '[object Uint8ClampedArray]', $fabe0cce3f5d5b01$var$uint16Tag = '[object Uint16Array]', $fabe0cce3f5d5b01$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $fabe0cce3f5d5b01$var$typedArrayTags = {};
$fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$float32Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$float64Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$int8Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$int16Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$int32Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint8Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint8ClampedTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint16Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint32Tag] = true;
$fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$argsTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$arrayTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$arrayBufferTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$boolTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$dataViewTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$dateTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$errorTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$funcTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$mapTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$numberTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$objectTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$regexpTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$setTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$stringTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $fabe0cce3f5d5b01$var$baseIsTypedArray(value) {
    return (0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && (0, $a502e9cfca20b420$export$2e2bcd8739ae039)(value.length) && !!$fabe0cce3f5d5b01$var$typedArrayTags[(0, $a4a68779135a927a$export$2e2bcd8739ae039)(value)];
}
var $fabe0cce3f5d5b01$export$2e2bcd8739ae039 = $fabe0cce3f5d5b01$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $dcb7ddab35a86b1b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $dcb7ddab35a86b1b$export$2e2bcd8739ae039 = $dcb7ddab35a86b1b$var$baseUnary;



var $85lyy = parcelRequire("85lyy");
/* Node.js helper references. */ var $6cc58537eccc3ef4$var$nodeIsTypedArray = (0, $85lyy.default) && (0, $85lyy.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $6cc58537eccc3ef4$var$isTypedArray = $6cc58537eccc3ef4$var$nodeIsTypedArray ? (0, $dcb7ddab35a86b1b$export$2e2bcd8739ae039)($6cc58537eccc3ef4$var$nodeIsTypedArray) : (0, $fabe0cce3f5d5b01$export$2e2bcd8739ae039);
var $6cc58537eccc3ef4$export$2e2bcd8739ae039 = $6cc58537eccc3ef4$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1272191af27ff4d6$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $1272191af27ff4d6$export$2e2bcd8739ae039 = $1272191af27ff4d6$var$safeGet;




/** Used for built-in method references. */ var $29d812442ab2ad15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $29d812442ab2ad15$var$hasOwnProperty = $29d812442ab2ad15$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $29d812442ab2ad15$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($29d812442ab2ad15$var$hasOwnProperty.call(object, key) && (0, $eeb9e562c601df3d$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $9ecf54100ca47aba$export$2e2bcd8739ae039)(object, key, value);
}
var $29d812442ab2ad15$export$2e2bcd8739ae039 = $29d812442ab2ad15$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $f24c78760842e746$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $9ecf54100ca47aba$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $29d812442ab2ad15$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $f24c78760842e746$export$2e2bcd8739ae039 = $f24c78760842e746$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b597e704417ae8ed$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $b597e704417ae8ed$export$2e2bcd8739ae039 = $b597e704417ae8ed$var$baseTimes;





var $igoKr = parcelRequire("igoKr");
/** Used as references for various `Number` constants. */ var $07d39108da3cbde2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $07d39108da3cbde2$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $07d39108da3cbde2$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $07d39108da3cbde2$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $07d39108da3cbde2$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $07d39108da3cbde2$export$2e2bcd8739ae039 = $07d39108da3cbde2$var$isIndex;



/** Used for built-in method references. */ var $23b1565ad7fdac35$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $23b1565ad7fdac35$var$hasOwnProperty = $23b1565ad7fdac35$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $23b1565ad7fdac35$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $feaaf99b892a2807$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $igoKr.default)(value), isType = !isArr && !isArg && !isBuff && (0, $6cc58537eccc3ef4$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $b597e704417ae8ed$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $23b1565ad7fdac35$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $07d39108da3cbde2$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $23b1565ad7fdac35$export$2e2bcd8739ae039 = $23b1565ad7fdac35$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bfd586a8a9957928$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $bfd586a8a9957928$export$2e2bcd8739ae039 = $bfd586a8a9957928$var$nativeKeysIn;


/** Used for built-in method references. */ var $5e9f58ef4d9efe26$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5e9f58ef4d9efe26$var$hasOwnProperty = $5e9f58ef4d9efe26$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5e9f58ef4d9efe26$var$baseKeysIn(object) {
    if (!(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(object)) return (0, $bfd586a8a9957928$export$2e2bcd8739ae039)(object);
    var isProto = (0, $085c372fceab446a$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$5e9f58ef4d9efe26$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $5e9f58ef4d9efe26$export$2e2bcd8739ae039 = $5e9f58ef4d9efe26$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $b96a2990172eaa9c$var$keysIn(object) {
    return (0, $9fa71e83b98fbb84$export$2e2bcd8739ae039)(object) ? (0, $23b1565ad7fdac35$export$2e2bcd8739ae039)(object, true) : (0, $5e9f58ef4d9efe26$export$2e2bcd8739ae039)(object);
}
var $b96a2990172eaa9c$export$2e2bcd8739ae039 = $b96a2990172eaa9c$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $2f7a877accc13af9$var$toPlainObject(value) {
    return (0, $f24c78760842e746$export$2e2bcd8739ae039)(value, (0, $b96a2990172eaa9c$export$2e2bcd8739ae039)(value));
}
var $2f7a877accc13af9$export$2e2bcd8739ae039 = $2f7a877accc13af9$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $0232c8dd76261eb5$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $1272191af27ff4d6$export$2e2bcd8739ae039)(object, key), srcValue = (0, $1272191af27ff4d6$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $cb20bdf7805c2c76$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $igoKr.default)(srcValue), isTyped = !isArr && !isBuff && (0, $6cc58537eccc3ef4$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $7a6c5d83033800e1$export$2e2bcd8739ae039)(objValue)) newValue = (0, $0e8e86ab14c0a404$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $i04Md.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $13accf28b5781771$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $9384df634da96665$export$2e2bcd8739ae039)(srcValue) || (0, $feaaf99b892a2807$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $feaaf99b892a2807$export$2e2bcd8739ae039)(objValue)) newValue = (0, $2f7a877accc13af9$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(objValue) || (0, $dc2f9f78d9753304$export$2e2bcd8739ae039)(objValue)) newValue = (0, $e74270428480da5e$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $cb20bdf7805c2c76$export$2e2bcd8739ae039)(object, key, newValue);
}
var $0232c8dd76261eb5$export$2e2bcd8739ae039 = $0232c8dd76261eb5$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $5e1e71aba0a953c9$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $84e140eb0a34aa86$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $d9bf16d4d84249b6$export$2e2bcd8739ae039));
        if ((0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(srcValue)) (0, $0232c8dd76261eb5$export$2e2bcd8739ae039)(object, source, key, srcIndex, $5e1e71aba0a953c9$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $1272191af27ff4d6$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $cb20bdf7805c2c76$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $b96a2990172eaa9c$export$2e2bcd8739ae039));
}
var $5e1e71aba0a953c9$export$2e2bcd8739ae039 = $5e1e71aba0a953c9$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $189d21307abb93f3$var$identity(value) {
    return value;
}
var $189d21307abb93f3$export$2e2bcd8739ae039 = $189d21307abb93f3$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $55a19dee0554f46f$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $55a19dee0554f46f$export$2e2bcd8739ae039 = $55a19dee0554f46f$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $3ccc7e18edddfab7$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3ccc7e18edddfab7$var$overRest(func, start, transform) {
    start = $3ccc7e18edddfab7$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3ccc7e18edddfab7$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $55a19dee0554f46f$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $3ccc7e18edddfab7$export$2e2bcd8739ae039 = $3ccc7e18edddfab7$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $1352d369f3eedffd$var$constant(value) {
    return function() {
        return value;
    };
}
var $1352d369f3eedffd$export$2e2bcd8739ae039 = $1352d369f3eedffd$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $525f95a0c78b3d5d$var$baseSetToString = !(0, $0eba72c26ca3c12e$export$2e2bcd8739ae039) ? (0, $189d21307abb93f3$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $0eba72c26ca3c12e$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $1352d369f3eedffd$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $525f95a0c78b3d5d$export$2e2bcd8739ae039 = $525f95a0c78b3d5d$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $a6866c0708382a66$var$HOT_COUNT = 800, $a6866c0708382a66$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a6866c0708382a66$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $a6866c0708382a66$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $a6866c0708382a66$var$nativeNow(), remaining = $a6866c0708382a66$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $a6866c0708382a66$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $a6866c0708382a66$export$2e2bcd8739ae039 = $a6866c0708382a66$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1a2a55af2d995f7f$var$setToString = (0, $a6866c0708382a66$export$2e2bcd8739ae039)((0, $525f95a0c78b3d5d$export$2e2bcd8739ae039));
var $1a2a55af2d995f7f$export$2e2bcd8739ae039 = $1a2a55af2d995f7f$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $f368b662e65c065d$var$baseRest(func, start) {
    return (0, $1a2a55af2d995f7f$export$2e2bcd8739ae039)((0, $3ccc7e18edddfab7$export$2e2bcd8739ae039)(func, start, (0, $189d21307abb93f3$export$2e2bcd8739ae039)), func + '');
}
var $f368b662e65c065d$export$2e2bcd8739ae039 = $f368b662e65c065d$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $d0d563dc551cd5da$var$isIterateeCall(value, index, object) {
    if (!(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $9fa71e83b98fbb84$export$2e2bcd8739ae039)(object) && (0, $07d39108da3cbde2$export$2e2bcd8739ae039)(index, object.length) : type == 'string' && index in object) return (0, $eeb9e562c601df3d$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $d0d563dc551cd5da$export$2e2bcd8739ae039 = $d0d563dc551cd5da$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $3a839a7985f8c7d7$var$createAssigner(assigner) {
    return (0, $f368b662e65c065d$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $d0d563dc551cd5da$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $3a839a7985f8c7d7$export$2e2bcd8739ae039 = $3a839a7985f8c7d7$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $451ad2baa4201321$var$merge = (0, $3a839a7985f8c7d7$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $5e1e71aba0a953c9$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $451ad2baa4201321$export$2e2bcd8739ae039 = $451ad2baa4201321$var$merge;


var $1bea058f31f647d1$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.content
    }, children));
};
$1bea058f31f647d1$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$1bea058f31f647d1$export$5eec0980ed568dae.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $1bea058f31f647d1$export$2e2bcd8739ae039 = $1bea058f31f647d1$export$5eec0980ed568dae;



var $eeH7J = parcelRequire("eeH7J");



var $ier4x = parcelRequire("ier4x");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $9a0b0cf4e533013c$var$now = function() {
    return (0, $ier4x.default).Date.now();
};
var $9a0b0cf4e533013c$export$2e2bcd8739ae039 = $9a0b0cf4e533013c$var$now;


/** Used to match a single whitespace character. */ var $2e355ca75638a323$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $2e355ca75638a323$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $2e355ca75638a323$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $2e355ca75638a323$export$2e2bcd8739ae039 = $2e355ca75638a323$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0cfbfbab64539034$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0cfbfbab64539034$var$baseTrim(string) {
    return string ? string.slice(0, (0, $2e355ca75638a323$export$2e2bcd8739ae039)(string) + 1).replace($0cfbfbab64539034$var$reTrimStart, '') : string;
}
var $0cfbfbab64539034$export$2e2bcd8739ae039 = $0cfbfbab64539034$var$baseTrim;





/** `Object#toString` result references. */ var $73f2a2efa770cd29$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $73f2a2efa770cd29$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && (0, $a4a68779135a927a$export$2e2bcd8739ae039)(value) == $73f2a2efa770cd29$var$symbolTag;
}
var $73f2a2efa770cd29$export$2e2bcd8739ae039 = $73f2a2efa770cd29$var$isSymbol;


/** Used as references for various `Number` constants. */ var $c23b03dc8b8f2d2e$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $c23b03dc8b8f2d2e$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c23b03dc8b8f2d2e$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c23b03dc8b8f2d2e$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c23b03dc8b8f2d2e$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c23b03dc8b8f2d2e$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $73f2a2efa770cd29$export$2e2bcd8739ae039)(value)) return $c23b03dc8b8f2d2e$var$NAN;
    if ((0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $0cfbfbab64539034$export$2e2bcd8739ae039)(value);
    var isBinary = $c23b03dc8b8f2d2e$var$reIsBinary.test(value);
    return isBinary || $c23b03dc8b8f2d2e$var$reIsOctal.test(value) ? $c23b03dc8b8f2d2e$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c23b03dc8b8f2d2e$var$reIsBadHex.test(value) ? $c23b03dc8b8f2d2e$var$NAN : +value;
}
var $c23b03dc8b8f2d2e$export$2e2bcd8739ae039 = $c23b03dc8b8f2d2e$var$toNumber;


/** Error message constants. */ var $aada37bdadcad455$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $aada37bdadcad455$var$nativeMax = Math.max, $aada37bdadcad455$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $aada37bdadcad455$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($aada37bdadcad455$var$FUNC_ERROR_TEXT);
    wait = (0, $c23b03dc8b8f2d2e$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $aada37bdadcad455$var$nativeMax((0, $c23b03dc8b8f2d2e$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $aada37bdadcad455$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $9a0b0cf4e533013c$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $9a0b0cf4e533013c$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $9a0b0cf4e533013c$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $aada37bdadcad455$export$2e2bcd8739ae039 = $aada37bdadcad455$var$debounce;



/** Error message constants. */ var $d8752382aa1e49e3$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $d8752382aa1e49e3$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($d8752382aa1e49e3$var$FUNC_ERROR_TEXT);
    if ((0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, $aada37bdadcad455$export$2e2bcd8739ae039)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $d8752382aa1e49e3$export$2e2bcd8739ae039 = $d8752382aa1e49e3$var$throttle;


var $27188cb07d1da1f0$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};


var $a6bc1b50f0230709$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a6bc1b50f0230709$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a6bc1b50f0230709$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a6bc1b50f0230709$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a6bc1b50f0230709$export$c4dbe12ffaee3c8e = function(_ref) {
    $a6bc1b50f0230709$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $a6bc1b50f0230709$var$_classCallCheck(this, Saturation);
        var _this = $a6bc1b50f0230709$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, $27188cb07d1da1f0$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $d8752382aa1e49e3$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $a6bc1b50f0230709$var$_createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $a6bc1b50f0230709$export$2e2bcd8739ae039 = $a6bc1b50f0230709$export$c4dbe12ffaee3c8e;



var $eeH7J = parcelRequire("eeH7J");

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $bbe33133fd3ce979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $bbe33133fd3ce979$export$2e2bcd8739ae039 = $bbe33133fd3ce979$var$arrayEach;






/* Built-in method references for those with the same name as other `lodash` methods. */ var $f079176491e590a5$var$nativeKeys = (0, $47a4ad607c69fe3a$export$2e2bcd8739ae039)(Object.keys, Object);
var $f079176491e590a5$export$2e2bcd8739ae039 = $f079176491e590a5$var$nativeKeys;


/** Used for built-in method references. */ var $e139dce7c96b603b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e139dce7c96b603b$var$hasOwnProperty = $e139dce7c96b603b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e139dce7c96b603b$var$baseKeys(object) {
    if (!(0, $085c372fceab446a$export$2e2bcd8739ae039)(object)) return (0, $f079176491e590a5$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($e139dce7c96b603b$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $e139dce7c96b603b$export$2e2bcd8739ae039 = $e139dce7c96b603b$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $399159d0b86c4de3$var$keys(object) {
    return (0, $9fa71e83b98fbb84$export$2e2bcd8739ae039)(object) ? (0, $23b1565ad7fdac35$export$2e2bcd8739ae039)(object) : (0, $e139dce7c96b603b$export$2e2bcd8739ae039)(object);
}
var $399159d0b86c4de3$export$2e2bcd8739ae039 = $399159d0b86c4de3$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $84ced69bcc11b73b$var$baseForOwn(object, iteratee) {
    return object && (0, $84e140eb0a34aa86$export$2e2bcd8739ae039)(object, iteratee, (0, $399159d0b86c4de3$export$2e2bcd8739ae039));
}
var $84ced69bcc11b73b$export$2e2bcd8739ae039 = $84ced69bcc11b73b$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $06fa804ad653500a$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $9fa71e83b98fbb84$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $06fa804ad653500a$export$2e2bcd8739ae039 = $06fa804ad653500a$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $09b3909ad9877cfc$var$baseEach = (0, $06fa804ad653500a$export$2e2bcd8739ae039)((0, $84ced69bcc11b73b$export$2e2bcd8739ae039));
var $09b3909ad9877cfc$export$2e2bcd8739ae039 = $09b3909ad9877cfc$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $f07166d29730fb14$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $189d21307abb93f3$export$2e2bcd8739ae039);
}
var $f07166d29730fb14$export$2e2bcd8739ae039 = $f07166d29730fb14$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $d3b2161cb880b56e$var$forEach(collection, iteratee) {
    var func = (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(collection) ? (0, $bbe33133fd3ce979$export$2e2bcd8739ae039) : (0, $09b3909ad9877cfc$export$2e2bcd8739ae039);
    return func(collection, (0, $f07166d29730fb14$export$2e2bcd8739ae039)(iteratee));
}
var $d3b2161cb880b56e$export$2e2bcd8739ae039 = $d3b2161cb880b56e$var$forEach;


var $7b0eec87cb7788cd$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $7b0eec87cb7788cd$exports = factory();
})($7b0eec87cb7788cd$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


var $5d0dff9fa57aef75$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, $d3b2161cb880b56e$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $5d0dff9fa57aef75$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, (/*@__PURE__*/$parcel$interopDefault($7b0eec87cb7788cd$exports)))(data.hex) : (0, (/*@__PURE__*/$parcel$interopDefault($7b0eec87cb7788cd$exports)))(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $5d0dff9fa57aef75$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, (/*@__PURE__*/$parcel$interopDefault($7b0eec87cb7788cd$exports)))(hex).isValid();
};
var $5d0dff9fa57aef75$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = $5d0dff9fa57aef75$export$6bed283375899438(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var $5d0dff9fa57aef75$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $5d0dff9fa57aef75$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, (/*@__PURE__*/$parcel$interopDefault($7b0eec87cb7788cd$exports)))(type + ' (' + stringWithoutDegree + ')')._ok;
};


var $5f6afe5189f8d29a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5f6afe5189f8d29a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $5f6afe5189f8d29a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5f6afe5189f8d29a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5f6afe5189f8d29a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5f6afe5189f8d29a$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $5f6afe5189f8d29a$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $5f6afe5189f8d29a$var$_classCallCheck(this, ColorPicker);
            var _this = $5f6afe5189f8d29a$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $5d0dff9fa57aef75$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $5d0dff9fa57aef75$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $5d0dff9fa57aef75$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $5d0dff9fa57aef75$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $5f6afe5189f8d29a$var$_extends({}, $5d0dff9fa57aef75$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $aada37bdadcad455$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $5f6afe5189f8d29a$var$_createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Picker, $5f6afe5189f8d29a$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $5f6afe5189f8d29a$var$_extends({}, $5d0dff9fa57aef75$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
    ColorPicker.propTypes = $5f6afe5189f8d29a$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $5f6afe5189f8d29a$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $5f6afe5189f8d29a$export$2e2bcd8739ae039 = $5f6afe5189f8d29a$export$68265aef2e61bec7;



var $eeH7J = parcelRequire("eeH7J");


var $jyeBD = parcelRequire("jyeBD");

var $1ebc3a59bc6291c3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1ebc3a59bc6291c3$var$ENTER = 13;
var $1ebc3a59bc6291c3$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        default: {
            swatch: $1ebc3a59bc6291c3$var$_extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $1ebc3a59bc6291c3$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', $1ebc3a59bc6291c3$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a30c75ca5a20b075$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
var $1ebc3a59bc6291c3$export$2e2bcd8739ae039 = (0, $jyeBD.handleFocus)($1ebc3a59bc6291c3$export$c463048d6131b309);





var $eeH7J = parcelRequire("eeH7J");

var $6b88b6adb17a79e1$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
var $6b88b6adb17a79e1$export$2e2bcd8739ae039 = $6b88b6adb17a79e1$export$5bbd8091d1d0e224;


var $2d74e30868c902ed$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2d74e30868c902ed$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            alpha: {
                radius: '2px',
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker,
        className: 'alpha-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $9232e77ca409a344$export$2e2bcd8739ae039), $2d74e30868c902ed$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$2d74e30868c902ed$export$421d2c1bdabf8a68.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $6b88b6adb17a79e1$export$2e2bcd8739ae039)
};
var $2d74e30868c902ed$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($2d74e30868c902ed$export$421d2c1bdabf8a68);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");





var $eeH7J = parcelRequire("eeH7J");

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $5ee6da836cd5603d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $5ee6da836cd5603d$export$2e2bcd8739ae039 = $5ee6da836cd5603d$var$arrayMap;





/** Used to stand-in for `undefined` hash values. */ var $9d2e2beb86dbb305$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $9d2e2beb86dbb305$var$setCacheAdd(value) {
    this.__data__.set(value, $9d2e2beb86dbb305$var$HASH_UNDEFINED);
    return this;
}
var $9d2e2beb86dbb305$export$2e2bcd8739ae039 = $9d2e2beb86dbb305$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $0fe7ed53f2bb963c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $0fe7ed53f2bb963c$export$2e2bcd8739ae039 = $0fe7ed53f2bb963c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $de428f5920c73ad5$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $3c705e7737702eab$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$de428f5920c73ad5$var$SetCache.prototype.add = $de428f5920c73ad5$var$SetCache.prototype.push = (0, $9d2e2beb86dbb305$export$2e2bcd8739ae039);
$de428f5920c73ad5$var$SetCache.prototype.has = (0, $0fe7ed53f2bb963c$export$2e2bcd8739ae039);
var $de428f5920c73ad5$export$2e2bcd8739ae039 = $de428f5920c73ad5$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c8103599476381de$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $c8103599476381de$export$2e2bcd8739ae039 = $c8103599476381de$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ed1ffb1940a13b0a$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $ed1ffb1940a13b0a$export$2e2bcd8739ae039 = $ed1ffb1940a13b0a$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $65a0cc7c3ac9f810$var$COMPARE_PARTIAL_FLAG = 1, $65a0cc7c3ac9f810$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $65a0cc7c3ac9f810$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $65a0cc7c3ac9f810$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $65a0cc7c3ac9f810$var$COMPARE_UNORDERED_FLAG ? new (0, $de428f5920c73ad5$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $c8103599476381de$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $ed1ffb1940a13b0a$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $65a0cc7c3ac9f810$export$2e2bcd8739ae039 = $65a0cc7c3ac9f810$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $2e9a469ffc51ef28$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $2e9a469ffc51ef28$export$2e2bcd8739ae039 = $2e9a469ffc51ef28$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $d7e815a53300e7ef$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $d7e815a53300e7ef$export$2e2bcd8739ae039 = $d7e815a53300e7ef$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $51cbeca4e50a3c8e$var$COMPARE_PARTIAL_FLAG = 1, $51cbeca4e50a3c8e$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $51cbeca4e50a3c8e$var$boolTag = '[object Boolean]', $51cbeca4e50a3c8e$var$dateTag = '[object Date]', $51cbeca4e50a3c8e$var$errorTag = '[object Error]', $51cbeca4e50a3c8e$var$mapTag = '[object Map]', $51cbeca4e50a3c8e$var$numberTag = '[object Number]', $51cbeca4e50a3c8e$var$regexpTag = '[object RegExp]', $51cbeca4e50a3c8e$var$setTag = '[object Set]', $51cbeca4e50a3c8e$var$stringTag = '[object String]', $51cbeca4e50a3c8e$var$symbolTag = '[object Symbol]';
var $51cbeca4e50a3c8e$var$arrayBufferTag = '[object ArrayBuffer]', $51cbeca4e50a3c8e$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $51cbeca4e50a3c8e$var$symbolProto = (0, $5a41d29b535fbda9$export$2e2bcd8739ae039) ? (0, $5a41d29b535fbda9$export$2e2bcd8739ae039).prototype : undefined, $51cbeca4e50a3c8e$var$symbolValueOf = $51cbeca4e50a3c8e$var$symbolProto ? $51cbeca4e50a3c8e$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $51cbeca4e50a3c8e$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $51cbeca4e50a3c8e$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $51cbeca4e50a3c8e$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $c6e9b4ec73f542b2$export$2e2bcd8739ae039)(object), new (0, $c6e9b4ec73f542b2$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $51cbeca4e50a3c8e$var$boolTag:
        case $51cbeca4e50a3c8e$var$dateTag:
        case $51cbeca4e50a3c8e$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $eeb9e562c601df3d$export$2e2bcd8739ae039)(+object, +other);
        case $51cbeca4e50a3c8e$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $51cbeca4e50a3c8e$var$regexpTag:
        case $51cbeca4e50a3c8e$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $51cbeca4e50a3c8e$var$mapTag:
            var convert = (0, $2e9a469ffc51ef28$export$2e2bcd8739ae039);
        case $51cbeca4e50a3c8e$var$setTag:
            var isPartial = bitmask & $51cbeca4e50a3c8e$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $d7e815a53300e7ef$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $51cbeca4e50a3c8e$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $65a0cc7c3ac9f810$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $51cbeca4e50a3c8e$var$symbolTag:
            if ($51cbeca4e50a3c8e$var$symbolValueOf) return $51cbeca4e50a3c8e$var$symbolValueOf.call(object) == $51cbeca4e50a3c8e$var$symbolValueOf.call(other);
    }
    return false;
}
var $51cbeca4e50a3c8e$export$2e2bcd8739ae039 = $51cbeca4e50a3c8e$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $01fbf5bea9de21d8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $01fbf5bea9de21d8$export$2e2bcd8739ae039 = $01fbf5bea9de21d8$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c375f0615d6af45e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(object) ? result : (0, $01fbf5bea9de21d8$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $c375f0615d6af45e$export$2e2bcd8739ae039 = $c375f0615d6af45e$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $3aaa964ec501a7d3$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $3aaa964ec501a7d3$export$2e2bcd8739ae039 = $3aaa964ec501a7d3$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $a447355209f603cc$var$stubArray() {
    return [];
}
var $a447355209f603cc$export$2e2bcd8739ae039 = $a447355209f603cc$var$stubArray;


/** Used for built-in method references. */ var $af20ba618912d99a$var$objectProto = Object.prototype;
/** Built-in value references. */ var $af20ba618912d99a$var$propertyIsEnumerable = $af20ba618912d99a$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $af20ba618912d99a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $af20ba618912d99a$var$getSymbols = !$af20ba618912d99a$var$nativeGetSymbols ? (0, $a447355209f603cc$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $3aaa964ec501a7d3$export$2e2bcd8739ae039)($af20ba618912d99a$var$nativeGetSymbols(object), function(symbol) {
        return $af20ba618912d99a$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $af20ba618912d99a$export$2e2bcd8739ae039 = $af20ba618912d99a$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $443c9e920004bef7$var$getAllKeys(object) {
    return (0, $c375f0615d6af45e$export$2e2bcd8739ae039)(object, (0, $399159d0b86c4de3$export$2e2bcd8739ae039), (0, $af20ba618912d99a$export$2e2bcd8739ae039));
}
var $443c9e920004bef7$export$2e2bcd8739ae039 = $443c9e920004bef7$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $6aad8dd5844a80b2$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $6aad8dd5844a80b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6aad8dd5844a80b2$var$hasOwnProperty = $6aad8dd5844a80b2$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6aad8dd5844a80b2$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $6aad8dd5844a80b2$var$COMPARE_PARTIAL_FLAG, objProps = (0, $443c9e920004bef7$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $443c9e920004bef7$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $6aad8dd5844a80b2$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $6aad8dd5844a80b2$export$2e2bcd8739ae039 = $6aad8dd5844a80b2$var$equalObjects;




var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $d6f4b42f12b91728$var$DataView = (0, $0db1eac8602cea00$export$2e2bcd8739ae039)((0, $ier4x.default), 'DataView');
var $d6f4b42f12b91728$export$2e2bcd8739ae039 = $d6f4b42f12b91728$var$DataView;





var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $17713701cee9027b$var$Promise = (0, $0db1eac8602cea00$export$2e2bcd8739ae039)((0, $ier4x.default), 'Promise');
var $17713701cee9027b$export$2e2bcd8739ae039 = $17713701cee9027b$var$Promise;




var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $d13c8861af0aab68$var$Set = (0, $0db1eac8602cea00$export$2e2bcd8739ae039)((0, $ier4x.default), 'Set');
var $d13c8861af0aab68$export$2e2bcd8739ae039 = $d13c8861af0aab68$var$Set;




var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $53c78fb67aa34365$var$WeakMap = (0, $0db1eac8602cea00$export$2e2bcd8739ae039)((0, $ier4x.default), 'WeakMap');
var $53c78fb67aa34365$export$2e2bcd8739ae039 = $53c78fb67aa34365$var$WeakMap;




/** `Object#toString` result references. */ var $32a53861144c518f$var$mapTag = '[object Map]', $32a53861144c518f$var$objectTag = '[object Object]', $32a53861144c518f$var$promiseTag = '[object Promise]', $32a53861144c518f$var$setTag = '[object Set]', $32a53861144c518f$var$weakMapTag = '[object WeakMap]';
var $32a53861144c518f$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $32a53861144c518f$var$dataViewCtorString = (0, $35277c0394d92823$export$2e2bcd8739ae039)((0, $d6f4b42f12b91728$export$2e2bcd8739ae039)), $32a53861144c518f$var$mapCtorString = (0, $35277c0394d92823$export$2e2bcd8739ae039)((0, $25773aa5940e7b4c$export$2e2bcd8739ae039)), $32a53861144c518f$var$promiseCtorString = (0, $35277c0394d92823$export$2e2bcd8739ae039)((0, $17713701cee9027b$export$2e2bcd8739ae039)), $32a53861144c518f$var$setCtorString = (0, $35277c0394d92823$export$2e2bcd8739ae039)((0, $d13c8861af0aab68$export$2e2bcd8739ae039)), $32a53861144c518f$var$weakMapCtorString = (0, $35277c0394d92823$export$2e2bcd8739ae039)((0, $53c78fb67aa34365$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $32a53861144c518f$var$getTag = (0, $a4a68779135a927a$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $d6f4b42f12b91728$export$2e2bcd8739ae039) && $32a53861144c518f$var$getTag(new (0, $d6f4b42f12b91728$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $32a53861144c518f$var$dataViewTag || (0, $25773aa5940e7b4c$export$2e2bcd8739ae039) && $32a53861144c518f$var$getTag(new (0, $25773aa5940e7b4c$export$2e2bcd8739ae039)) != $32a53861144c518f$var$mapTag || (0, $17713701cee9027b$export$2e2bcd8739ae039) && $32a53861144c518f$var$getTag((0, $17713701cee9027b$export$2e2bcd8739ae039).resolve()) != $32a53861144c518f$var$promiseTag || (0, $d13c8861af0aab68$export$2e2bcd8739ae039) && $32a53861144c518f$var$getTag(new (0, $d13c8861af0aab68$export$2e2bcd8739ae039)) != $32a53861144c518f$var$setTag || (0, $53c78fb67aa34365$export$2e2bcd8739ae039) && $32a53861144c518f$var$getTag(new (0, $53c78fb67aa34365$export$2e2bcd8739ae039)) != $32a53861144c518f$var$weakMapTag) $32a53861144c518f$var$getTag = function(value) {
    var result = (0, $a4a68779135a927a$export$2e2bcd8739ae039)(value), Ctor = result == $32a53861144c518f$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $35277c0394d92823$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $32a53861144c518f$var$dataViewCtorString:
            return $32a53861144c518f$var$dataViewTag;
        case $32a53861144c518f$var$mapCtorString:
            return $32a53861144c518f$var$mapTag;
        case $32a53861144c518f$var$promiseCtorString:
            return $32a53861144c518f$var$promiseTag;
        case $32a53861144c518f$var$setCtorString:
            return $32a53861144c518f$var$setTag;
        case $32a53861144c518f$var$weakMapCtorString:
            return $32a53861144c518f$var$weakMapTag;
    }
    return result;
};
var $32a53861144c518f$export$2e2bcd8739ae039 = $32a53861144c518f$var$getTag;




var $igoKr = parcelRequire("igoKr");

/** Used to compose bitmasks for value comparisons. */ var $7793720dd23d8d83$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $7793720dd23d8d83$var$argsTag = '[object Arguments]', $7793720dd23d8d83$var$arrayTag = '[object Array]', $7793720dd23d8d83$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $7793720dd23d8d83$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7793720dd23d8d83$var$hasOwnProperty = $7793720dd23d8d83$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7793720dd23d8d83$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(object), othIsArr = (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $7793720dd23d8d83$var$arrayTag : (0, $32a53861144c518f$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $7793720dd23d8d83$var$arrayTag : (0, $32a53861144c518f$export$2e2bcd8739ae039)(other);
    objTag = objTag == $7793720dd23d8d83$var$argsTag ? $7793720dd23d8d83$var$objectTag : objTag;
    othTag = othTag == $7793720dd23d8d83$var$argsTag ? $7793720dd23d8d83$var$objectTag : othTag;
    var objIsObj = objTag == $7793720dd23d8d83$var$objectTag, othIsObj = othTag == $7793720dd23d8d83$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $igoKr.default)(object)) {
        if (!(0, $igoKr.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $d9bf16d4d84249b6$export$2e2bcd8739ae039));
        return objIsArr || (0, $6cc58537eccc3ef4$export$2e2bcd8739ae039)(object) ? (0, $65a0cc7c3ac9f810$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $51cbeca4e50a3c8e$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $7793720dd23d8d83$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $7793720dd23d8d83$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $7793720dd23d8d83$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $d9bf16d4d84249b6$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $d9bf16d4d84249b6$export$2e2bcd8739ae039));
    return (0, $6aad8dd5844a80b2$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $7793720dd23d8d83$export$2e2bcd8739ae039 = $7793720dd23d8d83$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $69b2d5aed7356a78$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && !(0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $7793720dd23d8d83$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $69b2d5aed7356a78$var$baseIsEqual, stack);
}
var $69b2d5aed7356a78$export$2e2bcd8739ae039 = $69b2d5aed7356a78$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $24c37403d0c02e08$var$COMPARE_PARTIAL_FLAG = 1, $24c37403d0c02e08$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $24c37403d0c02e08$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $d9bf16d4d84249b6$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $69b2d5aed7356a78$export$2e2bcd8739ae039)(srcValue, objValue, $24c37403d0c02e08$var$COMPARE_PARTIAL_FLAG | $24c37403d0c02e08$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $24c37403d0c02e08$export$2e2bcd8739ae039 = $24c37403d0c02e08$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $44f8c4132346397a$var$isStrictComparable(value) {
    return value === value && !(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(value);
}
var $44f8c4132346397a$export$2e2bcd8739ae039 = $44f8c4132346397a$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $566c891b79b6828a$var$getMatchData(object) {
    var result = (0, $399159d0b86c4de3$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $44f8c4132346397a$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $566c891b79b6828a$export$2e2bcd8739ae039 = $566c891b79b6828a$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7e2928d27c1c6b04$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $7e2928d27c1c6b04$export$2e2bcd8739ae039 = $7e2928d27c1c6b04$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $41475b3dfe71cb50$var$baseMatches(source) {
    var matchData = (0, $566c891b79b6828a$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $7e2928d27c1c6b04$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $24c37403d0c02e08$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $41475b3dfe71cb50$export$2e2bcd8739ae039 = $41475b3dfe71cb50$var$baseMatches;






/** Used to match property names within property paths. */ var $6f41c85803132900$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6f41c85803132900$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6f41c85803132900$var$isKey(value, object) {
    if ((0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $73f2a2efa770cd29$export$2e2bcd8739ae039)(value)) return true;
    return $6f41c85803132900$var$reIsPlainProp.test(value) || !$6f41c85803132900$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $6f41c85803132900$export$2e2bcd8739ae039 = $6f41c85803132900$var$isKey;



/** Error message constants. */ var $ec29b4b25185964a$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $ec29b4b25185964a$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($ec29b4b25185964a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($ec29b4b25185964a$var$memoize.Cache || (0, $3c705e7737702eab$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$ec29b4b25185964a$var$memoize.Cache = (0, $3c705e7737702eab$export$2e2bcd8739ae039);
var $ec29b4b25185964a$export$2e2bcd8739ae039 = $ec29b4b25185964a$var$memoize;


/** Used as the maximum memoize cache size. */ var $3f5a2d6b19ac800f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $3f5a2d6b19ac800f$var$memoizeCapped(func) {
    var result = (0, $ec29b4b25185964a$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $3f5a2d6b19ac800f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $3f5a2d6b19ac800f$export$2e2bcd8739ae039 = $3f5a2d6b19ac800f$var$memoizeCapped;


/** Used to match property names within property paths. */ var $95dd0cfd74ae7e61$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $95dd0cfd74ae7e61$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $95dd0cfd74ae7e61$var$stringToPath = (0, $3f5a2d6b19ac800f$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($95dd0cfd74ae7e61$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($95dd0cfd74ae7e61$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $95dd0cfd74ae7e61$export$2e2bcd8739ae039 = $95dd0cfd74ae7e61$var$stringToPath;






/** Used as references for various `Number` constants. */ var $bcf4d99f1e71c34d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $bcf4d99f1e71c34d$var$symbolProto = (0, $5a41d29b535fbda9$export$2e2bcd8739ae039) ? (0, $5a41d29b535fbda9$export$2e2bcd8739ae039).prototype : undefined, $bcf4d99f1e71c34d$var$symbolToString = $bcf4d99f1e71c34d$var$symbolProto ? $bcf4d99f1e71c34d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $bcf4d99f1e71c34d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $5ee6da836cd5603d$export$2e2bcd8739ae039)(value, $bcf4d99f1e71c34d$var$baseToString) + '';
    if ((0, $73f2a2efa770cd29$export$2e2bcd8739ae039)(value)) return $bcf4d99f1e71c34d$var$symbolToString ? $bcf4d99f1e71c34d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$bcf4d99f1e71c34d$var$INFINITY ? '-0' : result;
}
var $bcf4d99f1e71c34d$export$2e2bcd8739ae039 = $bcf4d99f1e71c34d$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $3dc5abcda995063b$var$toString(value) {
    return value == null ? '' : (0, $bcf4d99f1e71c34d$export$2e2bcd8739ae039)(value);
}
var $3dc5abcda995063b$export$2e2bcd8739ae039 = $3dc5abcda995063b$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $dd1a12c381fa2ff6$var$castPath(value, object) {
    if ((0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(value)) return value;
    return (0, $6f41c85803132900$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $95dd0cfd74ae7e61$export$2e2bcd8739ae039)((0, $3dc5abcda995063b$export$2e2bcd8739ae039)(value));
}
var $dd1a12c381fa2ff6$export$2e2bcd8739ae039 = $dd1a12c381fa2ff6$var$castPath;



/** Used as references for various `Number` constants. */ var $97b4626f534b31ab$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $97b4626f534b31ab$var$toKey(value) {
    if (typeof value == 'string' || (0, $73f2a2efa770cd29$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$97b4626f534b31ab$var$INFINITY ? '-0' : result;
}
var $97b4626f534b31ab$export$2e2bcd8739ae039 = $97b4626f534b31ab$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ff7f7c54696f3270$var$baseGet(object, path) {
    path = (0, $dd1a12c381fa2ff6$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $97b4626f534b31ab$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $ff7f7c54696f3270$export$2e2bcd8739ae039 = $ff7f7c54696f3270$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $4be2eb93a1c90874$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $ff7f7c54696f3270$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $4be2eb93a1c90874$export$2e2bcd8739ae039 = $4be2eb93a1c90874$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $a7a5759331ec2de2$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $a7a5759331ec2de2$export$2e2bcd8739ae039 = $a7a5759331ec2de2$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $dc6ec30dfc7e0e95$var$hasPath(object, path, hasFunc) {
    path = (0, $dd1a12c381fa2ff6$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $97b4626f534b31ab$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $a502e9cfca20b420$export$2e2bcd8739ae039)(length) && (0, $07d39108da3cbde2$export$2e2bcd8739ae039)(key, length) && ((0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(object) || (0, $feaaf99b892a2807$export$2e2bcd8739ae039)(object));
}
var $dc6ec30dfc7e0e95$export$2e2bcd8739ae039 = $dc6ec30dfc7e0e95$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5558af032a8e9bb9$var$hasIn(object, path) {
    return object != null && (0, $dc6ec30dfc7e0e95$export$2e2bcd8739ae039)(object, path, (0, $a7a5759331ec2de2$export$2e2bcd8739ae039));
}
var $5558af032a8e9bb9$export$2e2bcd8739ae039 = $5558af032a8e9bb9$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $29857086473d0bac$var$COMPARE_PARTIAL_FLAG = 1, $29857086473d0bac$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $29857086473d0bac$var$baseMatchesProperty(path, srcValue) {
    if ((0, $6f41c85803132900$export$2e2bcd8739ae039)(path) && (0, $44f8c4132346397a$export$2e2bcd8739ae039)(srcValue)) return (0, $7e2928d27c1c6b04$export$2e2bcd8739ae039)((0, $97b4626f534b31ab$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $4be2eb93a1c90874$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $5558af032a8e9bb9$export$2e2bcd8739ae039)(object, path) : (0, $69b2d5aed7356a78$export$2e2bcd8739ae039)(srcValue, objValue, $29857086473d0bac$var$COMPARE_PARTIAL_FLAG | $29857086473d0bac$var$COMPARE_UNORDERED_FLAG);
    };
}
var $29857086473d0bac$export$2e2bcd8739ae039 = $29857086473d0bac$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a0b73e9a0ae139ea$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $a0b73e9a0ae139ea$export$2e2bcd8739ae039 = $a0b73e9a0ae139ea$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $db74ec5683d6f882$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $ff7f7c54696f3270$export$2e2bcd8739ae039)(object, path);
    };
}
var $db74ec5683d6f882$export$2e2bcd8739ae039 = $db74ec5683d6f882$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $a6c0deee1099fb08$var$property(path) {
    return (0, $6f41c85803132900$export$2e2bcd8739ae039)(path) ? (0, $a0b73e9a0ae139ea$export$2e2bcd8739ae039)((0, $97b4626f534b31ab$export$2e2bcd8739ae039)(path)) : (0, $db74ec5683d6f882$export$2e2bcd8739ae039)(path);
}
var $a6c0deee1099fb08$export$2e2bcd8739ae039 = $a6c0deee1099fb08$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $63fd23164343c22d$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $189d21307abb93f3$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(value) ? (0, $29857086473d0bac$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $41475b3dfe71cb50$export$2e2bcd8739ae039)(value);
    return (0, $a6c0deee1099fb08$export$2e2bcd8739ae039)(value);
}
var $63fd23164343c22d$export$2e2bcd8739ae039 = $63fd23164343c22d$var$baseIteratee;




/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $66369f7bb6447a18$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $9fa71e83b98fbb84$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $09b3909ad9877cfc$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $66369f7bb6447a18$export$2e2bcd8739ae039 = $66369f7bb6447a18$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $44d4b6b3f15b91cd$var$map(collection, iteratee) {
    var func = (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(collection) ? (0, $5ee6da836cd5603d$export$2e2bcd8739ae039) : (0, $66369f7bb6447a18$export$2e2bcd8739ae039);
    return func(collection, (0, $63fd23164343c22d$export$2e2bcd8739ae039)(iteratee, 3));
}
var $44d4b6b3f15b91cd$export$2e2bcd8739ae039 = $44d4b6b3f15b91cd$var$map;



var $1ee65a3ac93838c3$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            swatches: {
                marginRight: '-10px'
            },
            swatch: {
                width: '22px',
                height: '22px',
                float: 'left',
                marginRight: '10px',
                marginBottom: '10px',
                borderRadius: '4px'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatches
    }, (0, $44d4b6b3f15b91cd$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ebc3a59bc6291c3$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.clear
    }));
};
var $1ee65a3ac93838c3$export$2e2bcd8739ae039 = $1ee65a3ac93838c3$export$2ce88c5250e54734;


var $a005181c6dc3949e$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';
    var handleChange = function handleChange(hexCode, e) {
        $5d0dff9fa57aef75$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                boxShadow: '0 1px rgba(0,0,0,.1)',
                borderRadius: '6px',
                position: 'relative'
            },
            head: {
                height: '110px',
                background: hex,
                borderRadius: '6px 6px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            },
            body: {
                padding: '10px'
            },
            label: {
                fontSize: '18px',
                color: $5d0dff9fa57aef75$export$3609eb1d7e55dec(hex),
                position: 'relative'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 10px 10px 10px',
                borderColor: 'transparent transparent ' + hex + ' transparent',
                position: 'absolute',
                top: '-10px',
                left: '50%',
                marginLeft: '-10px'
            },
            input: {
                width: '100%',
                fontSize: '12px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '22px',
                boxShadow: 'inset 0 0 0 1px #ddd',
                borderRadius: '4px',
                padding: '0 7px',
                boxSizing: 'border-box'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.card,
        className: 'block-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a30c75ca5a20b075$export$2e2bcd8739ae039), {
        borderRadius: '6px 6px 0 0'
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ee65a3ac93838c3$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$a005181c6dc3949e$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'top',
        'hide'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$a005181c6dc3949e$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        '#D9E3F0',
        '#F47373',
        '#697689',
        '#37D67A',
        '#2CCCE4',
        '#555555',
        '#dce775',
        '#ff8a65',
        '#ba68c8'
    ],
    triangle: 'top',
    styles: {}
};
var $a005181c6dc3949e$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($a005181c6dc3949e$export$d96a8827a60d6b69);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");



var $11300cc8beffd7e4$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $11300cc8beffd7e4$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $11300cc8beffd7e4$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $11300cc8beffd7e4$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $11300cc8beffd7e4$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $11300cc8beffd7e4$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $11300cc8beffd7e4$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $11300cc8beffd7e4$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $11300cc8beffd7e4$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $11300cc8beffd7e4$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $11300cc8beffd7e4$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $11300cc8beffd7e4$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $11300cc8beffd7e4$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $11300cc8beffd7e4$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $11300cc8beffd7e4$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $11300cc8beffd7e4$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $11300cc8beffd7e4$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $11300cc8beffd7e4$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $11300cc8beffd7e4$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $11300cc8beffd7e4$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $11300cc8beffd7e4$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $11300cc8beffd7e4$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $11300cc8beffd7e4$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $11300cc8beffd7e4$export$8fa4e5556fd77a60 = "#ffffff";
var $11300cc8beffd7e4$export$c073df10e766abfa = "#000000";
var $11300cc8beffd7e4$export$2e2bcd8739ae039 = {
    red: $11300cc8beffd7e4$export$a90204d1394caf30,
    pink: $11300cc8beffd7e4$export$47853bc718611763,
    purple: $11300cc8beffd7e4$export$e13cce2a2d16a9d4,
    deepPurple: $11300cc8beffd7e4$export$51ef95b19086af57,
    indigo: $11300cc8beffd7e4$export$3e6ccc7b8562d453,
    blue: $11300cc8beffd7e4$export$2aa0182783e7e9de,
    lightBlue: $11300cc8beffd7e4$export$7b0d29b70b435c21,
    cyan: $11300cc8beffd7e4$export$7474046f446842ee,
    teal: $11300cc8beffd7e4$export$8bf7dff220b82b4a,
    green: $11300cc8beffd7e4$export$955a2ebd2fb142ae,
    lightGreen: $11300cc8beffd7e4$export$559a8c00376dc936,
    lime: $11300cc8beffd7e4$export$221d31baf2636aad,
    yellow: $11300cc8beffd7e4$export$594c5a8758200c32,
    amber: $11300cc8beffd7e4$export$7c1ecc66643fdbd6,
    orange: $11300cc8beffd7e4$export$ad766f34ace1cafd,
    deepOrange: $11300cc8beffd7e4$export$1ceed3dd9ec11704,
    brown: $11300cc8beffd7e4$export$b6e6178d3f565007,
    grey: $11300cc8beffd7e4$export$e4c89085febbc618,
    blueGrey: $11300cc8beffd7e4$export$7c2da42d08c019c9,
    darkText: $11300cc8beffd7e4$export$b413907788b50267,
    lightText: $11300cc8beffd7e4$export$c962f8177a273028,
    darkIcons: $11300cc8beffd7e4$export$969f6c634341b5cf,
    lightIcons: $11300cc8beffd7e4$export$6b4a43519c60f4b1,
    white: $11300cc8beffd7e4$export$8fa4e5556fd77a60,
    black: $11300cc8beffd7e4$export$c073df10e766abfa
};




var $eeH7J = parcelRequire("eeH7J");


var $98ee10d15c5d76c7$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: 'scale(1)',
                transition: '100ms transform ease'
            },
            Swatch: {
                borderRadius: '50%',
                background: 'transparent',
                boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
                transition: '100ms box-shadow ease'
            }
        },
        'hover': {
            swatch: {
                transform: 'scale(1.2)'
            }
        },
        'active': {
            Swatch: {
                boxShadow: 'inset 0 0 0 3px ' + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ebc3a59bc6291c3$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
        }
    }));
};
$98ee10d15c5d76c7$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $98ee10d15c5d76c7$export$2e2bcd8739ae039 = (0, $88b1044c55714645$exports.handleHover)($98ee10d15c5d76c7$export$945d5c8ebb42b0ff);


var $be2a08abfb8069f9$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                display: 'flex',
                flexWrap: 'wrap',
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.card,
        className: 'circle-picker ' + className
    }, (0, $44d4b6b3f15b91cd$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $98ee10d15c5d76c7$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$be2a08abfb8069f9$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$be2a08abfb8069f9$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $11300cc8beffd7e4$export$a90204d1394caf30['500'],
        $11300cc8beffd7e4$export$47853bc718611763['500'],
        $11300cc8beffd7e4$export$e13cce2a2d16a9d4['500'],
        $11300cc8beffd7e4$export$51ef95b19086af57['500'],
        $11300cc8beffd7e4$export$3e6ccc7b8562d453['500'],
        $11300cc8beffd7e4$export$2aa0182783e7e9de['500'],
        $11300cc8beffd7e4$export$7b0d29b70b435c21['500'],
        $11300cc8beffd7e4$export$7474046f446842ee['500'],
        $11300cc8beffd7e4$export$8bf7dff220b82b4a['500'],
        $11300cc8beffd7e4$export$955a2ebd2fb142ae['500'],
        $11300cc8beffd7e4$export$559a8c00376dc936['500'],
        $11300cc8beffd7e4$export$221d31baf2636aad['500'],
        $11300cc8beffd7e4$export$594c5a8758200c32['500'],
        $11300cc8beffd7e4$export$7c1ecc66643fdbd6['500'],
        $11300cc8beffd7e4$export$ad766f34ace1cafd['500'],
        $11300cc8beffd7e4$export$1ceed3dd9ec11704['500'],
        $11300cc8beffd7e4$export$b6e6178d3f565007['500'],
        $11300cc8beffd7e4$export$7c2da42d08c019c9['500']
    ],
    styles: {}
};
var $be2a08abfb8069f9$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($be2a08abfb8069f9$export$c89a927ffc67e6fa);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");




var $eeH7J = parcelRequire("eeH7J");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a9c1a41f4206cc13$var$isUndefined(value) {
    return value === undefined;
}
var $a9c1a41f4206cc13$export$2e2bcd8739ae039 = $a9c1a41f4206cc13$var$isUndefined;



var $430667b819e6d99a$exports = {};
'use strict';
Object.defineProperty($430667b819e6d99a$exports, "__esModule", {
    value: true
});
var $430667b819e6d99a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $430667b819e6d99a$var$_react2 = $430667b819e6d99a$var$_interopRequireDefault($eeH7J);
function $430667b819e6d99a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $430667b819e6d99a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $430667b819e6d99a$var$DEFAULT_SIZE = 24;
$430667b819e6d99a$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $430667b819e6d99a$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $430667b819e6d99a$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $430667b819e6d99a$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $430667b819e6d99a$var$_react2.default.createElement('svg', $430667b819e6d99a$var$_extends({
        viewBox: '0 0 ' + $430667b819e6d99a$var$DEFAULT_SIZE + ' ' + $430667b819e6d99a$var$DEFAULT_SIZE,
        style: $430667b819e6d99a$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $430667b819e6d99a$var$_react2.default.createElement('path', {
        d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
};


var $d990c4981d985c8e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $d990c4981d985c8e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d990c4981d985c8e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d990c4981d985c8e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d990c4981d985c8e$export$71685d48a2432635 = function(_React$Component) {
    $d990c4981d985c8e$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $d990c4981d985c8e$var$_classCallCheck(this, ChromeFields);
        var _this = $d990c4981d985c8e$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === 'hex') _this.setState({
                view: 'rgb'
            });
            else if (_this.state.view === 'rgb') _this.setState({
                view: 'hsl'
            });
            else if (_this.state.view === 'hsl') {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: 'hex'
                });
                else _this.setState({
                    view: 'rgb'
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $5d0dff9fa57aef75$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: 'hex'
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: 'rgb'
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === 'string' && data.s.includes('%')) data.s = data.s.replace('%', '');
                if (typeof data.l === 'string' && data.l.includes('%')) data.l = data.l.replace('%', '');
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $a9c1a41f4206cc13$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $a9c1a41f4206cc13$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: 'hsl'
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = '#eee';
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = 'transparent';
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $d990c4981d985c8e$var$_createClass(ChromeFields, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
                    'default': {
                        wrap: {
                            paddingTop: '16px',
                            display: 'flex'
                        },
                        fields: {
                            flex: '1',
                            display: 'flex',
                            marginLeft: '-6px'
                        },
                        field: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        alpha: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        toggle: {
                            width: '32px',
                            textAlign: 'right',
                            position: 'relative'
                        },
                        icon: {
                            marginRight: '-4px',
                            marginTop: '12px',
                            cursor: 'pointer',
                            position: 'relative'
                        },
                        iconHighlight: {
                            position: 'absolute',
                            width: '24px',
                            height: '28px',
                            background: '#eee',
                            borderRadius: '4px',
                            top: '10px',
                            left: '12px',
                            display: 'none'
                        },
                        input: {
                            fontSize: '11px',
                            color: '#333',
                            width: '100%',
                            borderRadius: '2px',
                            border: 'none',
                            boxShadow: 'inset 0 0 0 1px #dadada',
                            height: '21px',
                            textAlign: 'center'
                        },
                        label: {
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            lineHeight: '11px',
                            color: '#969696',
                            textAlign: 'center',
                            display: 'block',
                            marginTop: '12px'
                        },
                        svg: {
                            fill: '#333',
                            width: '24px',
                            height: '24px',
                            border: '1px transparent solid',
                            borderRadius: '5px'
                        }
                    },
                    'disableAlpha': {
                        alpha: {
                            display: 'none'
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === 'hex') fields = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'hex',
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'rgb') fields = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'r',
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'g',
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'b',
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'hsl') fields = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'h',
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 's',
                    value: Math.round(this.props.hsl.s * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'l',
                    value: Math.round(this.props.hsl.l * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.wrap,
                    className: 'flexbox-fix'
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($430667b819e6d99a$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === 'hex') return {
                    view: 'rgb'
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$d990c4981d985c8e$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $d990c4981d985c8e$export$2e2bcd8739ae039 = $d990c4981d985c8e$export$71685d48a2432635;



var $eeH7J = parcelRequire("eeH7J");

var $09fd94c0d2994a2d$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                transform: 'translate(-6px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
var $09fd94c0d2994a2d$export$2e2bcd8739ae039 = $09fd94c0d2994a2d$export$a632586f9a957100;



var $eeH7J = parcelRequire("eeH7J");

var $5af25887fe0e0d5d$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
var $5af25887fe0e0d5d$export$2e2bcd8739ae039 = $5af25887fe0e0d5d$export$190c1afe887f7ef7;


var $1095190821273845$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                borderRadius: '2px',
                boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
                boxSizing: 'initial',
                fontFamily: 'Menlo'
            },
            saturation: {
                width: '100%',
                paddingBottom: '55%',
                position: 'relative',
                borderRadius: '2px 2px 0 0',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '2px 2px 0 0'
            },
            body: {
                padding: '16px 16px 12px'
            },
            controls: {
                display: 'flex'
            },
            color: {
                width: '32px'
            },
            swatch: {
                marginTop: '6px',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            },
            active: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '8px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
                zIndex: '2'
            },
            toggles: {
                flex: '1'
            },
            hue: {
                height: '10px',
                position: 'relative',
                marginBottom: '8px'
            },
            Hue: {
                radius: '2px'
            },
            alpha: {
                height: '10px',
                position: 'relative'
            },
            Alpha: {
                radius: '2px'
            }
        },
        'disableAlpha': {
            color: {
                width: '22px'
            },
            alpha: {
                display: 'none'
            },
            hue: {
                marginBottom: '0px'
            },
            swatch: {
                width: '10px',
                height: '10px',
                marginTop: '0px'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker,
        className: 'chrome-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a6bc1b50f0230709$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $5af25887fe0e0d5d$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a30c75ca5a20b075$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bec2357555e376de$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $09fd94c0d2994a2d$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $9232e77ca409a344$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $09fd94c0d2994a2d$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d990c4981d985c8e$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$1095190821273845$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$1095190821273845$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $1095190821273845$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($1095190821273845$export$31a305e9779b48b4);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");






var $eeH7J = parcelRequire("eeH7J");



var $71d298e93093fb86$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            color: {
                background: color,
                width: '15px',
                height: '15px',
                float: 'left',
                marginRight: '5px',
                marginBottom: '5px',
                position: 'relative',
                cursor: 'pointer'
            },
            dot: {
                absolute: '5px 5px 5px 5px',
                background: $5d0dff9fa57aef75$export$3609eb1d7e55dec(color),
                borderRadius: '50%',
                opacity: '0'
            }
        },
        'active': {
            dot: {
                opacity: '1'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            dot: {
                background: '#000'
            }
        },
        'transparent': {
            dot: {
                background: '#000'
            }
        }
    }, {
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ebc3a59bc6291c3$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.dot
    }));
};
var $71d298e93093fb86$export$2e2bcd8739ae039 = $71d298e93093fb86$export$df654652e5203306;



var $eeH7J = parcelRequire("eeH7J");


var $628fe0a663fbccae$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingBottom: '6px',
                paddingRight: '5px',
                position: 'relative'
            },
            active: {
                position: 'absolute',
                top: '6px',
                left: '5px',
                height: '9px',
                width: '9px',
                background: hex
            },
            HEXwrap: {
                flex: '6',
                position: 'relative'
            },
            HEXinput: {
                width: '80%',
                padding: '0px',
                paddingLeft: '20%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            HEXlabel: {
                display: 'none'
            },
            RGBwrap: {
                flex: '3',
                position: 'relative'
            },
            RGBinput: {
                width: '70%',
                padding: '0px',
                paddingLeft: '30%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '3px',
                left: '0px',
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '12px',
                color: '#999'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }));
};
var $628fe0a663fbccae$export$2e2bcd8739ae039 = $628fe0a663fbccae$export$11cdb14a03223d9c;


var $3071cb5ed1b8597a$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            Compact: {
                background: '#f6f6f6',
                radius: '4px'
            },
            compact: {
                paddingTop: '5px',
                paddingLeft: '5px',
                boxSizing: 'initial',
                width: '240px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $5d0dff9fa57aef75$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1bea058f31f647d1$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.compact,
        className: 'compact-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', null, (0, $44d4b6b3f15b91cd$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $71d298e93093fb86$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $628fe0a663fbccae$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$3071cb5ed1b8597a$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$3071cb5ed1b8597a$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        '#4D4D4D',
        '#999999',
        '#FFFFFF',
        '#F44E3B',
        '#FE9200',
        '#FCDC00',
        '#DBDF00',
        '#A4DD00',
        '#68CCCA',
        '#73D8FF',
        '#AEA1FF',
        '#FDA1FF',
        '#333333',
        '#808080',
        '#cccccc',
        '#D33115',
        '#E27300',
        '#FCC400',
        '#B0BC00',
        '#68BC00',
        '#16A5A5',
        '#009CE0',
        '#7B64FF',
        '#FA28FF',
        '#000000',
        '#666666',
        '#B3B3B3',
        '#9F0500',
        '#C45100',
        '#FB9E00',
        '#808900',
        '#194D33',
        '#0C797D',
        '#0062B1',
        '#653294',
        '#AB149E'
    ],
    styles: {}
};
var $3071cb5ed1b8597a$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($3071cb5ed1b8597a$export$6479582a9c9e50ce);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");





var $eeH7J = parcelRequire("eeH7J");


var $ab97a63f7134dce2$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: 'relative',
        zIndex: '2',
        outline: '2px solid #fff',
        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            swatch: {
                width: '25px',
                height: '25px',
                fontSize: '0'
            }
        },
        'hover': {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ebc3a59bc6291c3$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $ab97a63f7134dce2$export$2e2bcd8739ae039 = (0, $88b1044c55714645$exports.handleHover)($ab97a63f7134dce2$export$d653c538b92bb84f);


var $a5ae6da4efe90fee$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                borderRadius: '4px',
                position: 'relative',
                padding: '5px',
                display: 'flex',
                flexWrap: 'wrap'
            },
            triangle: {
                position: 'absolute',
                border: '7px solid transparent',
                borderBottomColor: '#fff'
            },
            triangleShadow: {
                position: 'absolute',
                border: '8px solid transparent',
                borderBottomColor: 'rgba(0,0,0,0.15)'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-14px',
                left: '10px'
            },
            triangleShadow: {
                top: '-16px',
                left: '9px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-14px',
                right: '10px'
            },
            triangleShadow: {
                top: '-16px',
                right: '9px'
            }
        },
        'bottom-left-triangle': {
            triangle: {
                top: '35px',
                left: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                left: '9px',
                transform: 'rotate(180deg)'
            }
        },
        'bottom-right-triangle': {
            triangle: {
                top: '35px',
                right: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                right: '9px',
                transform: 'rotate(180deg)'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right',
        'bottom-left-triangle': triangle === 'bottom-left',
        'bottom-right-triangle': triangle === 'bottom-right'
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.card,
        className: 'github-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.triangle
    }), (0, $44d4b6b3f15b91cd$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ab97a63f7134dce2$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$a5ae6da4efe90fee$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'hide',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$a5ae6da4efe90fee$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        '#B80000',
        '#DB3E00',
        '#FCCB00',
        '#008B02',
        '#006B76',
        '#1273DE',
        '#004DCF',
        '#5300EB',
        '#EB9694',
        '#FAD0C3',
        '#FEF3BD',
        '#C1E1C5',
        '#BEDADC',
        '#C4DEF6',
        '#BED3F3',
        '#D4C4FB'
    ],
    triangle: 'top-left',
    styles: {}
};
var $a5ae6da4efe90fee$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($a5ae6da4efe90fee$export$61d478c2aba5d9a5);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");




var $eeH7J = parcelRequire("eeH7J");

var $534637106ab7e47c$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
var $534637106ab7e47c$export$2e2bcd8739ae039 = $534637106ab7e47c$export$9c10b52c64965f67;


var $65a49550568f735f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $65a49550568f735f$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker,
        className: 'hue-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bec2357555e376de$export$2e2bcd8739ae039), $65a49550568f735f$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$65a49550568f735f$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$65a49550568f735f$export$f176087feb20230e.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $534637106ab7e47c$export$2e2bcd8739ae039),
    styles: {}
};
var $65a49550568f735f$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($65a49550568f735f$export$f176087feb20230e);



var $eeH7J = parcelRequire("eeH7J");




var $c720aa1e4fccba52$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            material: {
                width: '98px',
                height: '98px',
                padding: '16px',
                fontFamily: 'Roboto'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '2px solid ' + hex,
                outline: 'none',
                height: '30px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '1px solid #eee',
                outline: 'none',
                height: '30px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            split: {
                display: 'flex',
                marginRight: '-10px',
                paddingTop: '11px'
            },
            third: {
                flex: '1',
                paddingRight: '10px'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $5d0dff9fa57aef75$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1bea058f31f647d1$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.material,
        className: 'material-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.split,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $c720aa1e4fccba52$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($c720aa1e4fccba52$export$a2d8b23205c25948);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");




var $eeH7J = parcelRequire("eeH7J");



var $338eca795ded3eb7$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            fields: {
                paddingTop: '5px',
                paddingBottom: '9px',
                width: '80px',
                position: 'relative'
            },
            divider: {
                height: '5px'
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                marginLeft: '40%',
                width: '40%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '5px',
                fontSize: '13px',
                paddingLeft: '3px',
                marginRight: '10px'
            },
            RGBlabel: {
                left: '0px',
                top: '0px',
                width: '34px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px',
                position: 'absolute'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                marginLeft: '20%',
                width: '80%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '6px',
                fontSize: '13px',
                paddingLeft: '3px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '14px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px'
            },
            fieldSymbols: {
                position: 'absolute',
                top: '5px',
                right: '-7px',
                fontSize: '13px'
            },
            symbol: {
                height: '20px',
                lineHeight: '22px',
                paddingBottom: '7px'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data['#']) $5d0dff9fa57aef75$export$944f75ec5697b362(data['#']) && onChange({
            hex: data['#'],
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: 'hsv'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'h',
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 's',
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'v',
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: '#',
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.symbol
    }, '\xB0'), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.symbol
    }, '%'), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.symbol
    }, '%')));
};
var $338eca795ded3eb7$export$2e2bcd8739ae039 = $338eca795ded3eb7$export$b1808ee9bfa8f4d0;



var $eeH7J = parcelRequire("eeH7J");

var $44097db7cf08fc15$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        },
        'black-outline': {
            picker: {
                boxShadow: 'inset 0 0 0 1px #000'
            }
        }
    }, {
        'black-outline': hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
var $44097db7cf08fc15$export$2e2bcd8739ae039 = $44097db7cf08fc15$export$123b96ff8455915;



var $eeH7J = parcelRequire("eeH7J");

var $6dbab6da23f0a762$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '4px 0 4px 6px',
                borderColor: 'transparent transparent transparent #fff',
                position: 'absolute',
                top: '1px',
                left: '1px'
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '5px 0 5px 8px',
                borderColor: 'transparent transparent transparent #555'
            },
            left: {
                Extend: 'triangleBorder',
                transform: 'translate(-13px, -4px)'
            },
            leftInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            },
            right: {
                Extend: 'triangleBorder',
                transform: 'translate(20px, -14px) rotate(180deg)'
            },
            rightInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.rightInside
    })));
};
var $6dbab6da23f0a762$export$2e2bcd8739ae039 = $6dbab6da23f0a762$export$123b96ff8455915;



var $eeH7J = parcelRequire("eeH7J");

var $aa785966637bcbc4$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            button: {
                backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
                border: '1px solid #878787',
                borderRadius: '2px',
                height: '20px',
                boxShadow: '0 1px 0 0 #EAEAEA',
                fontSize: '14px',
                color: '#000',
                lineHeight: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                cursor: 'pointer'
            }
        },
        'active': {
            button: {
                boxShadow: '0 0 0 1px #878787'
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $aa785966637bcbc4$export$2e2bcd8739ae039 = $aa785966637bcbc4$export$f7d38a0bd3b98717;



var $eeH7J = parcelRequire("eeH7J");

var $10704874a9b8e800$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            swatches: {
                border: '1px solid #B3B3B3',
                borderBottom: '1px solid #F0F0F0',
                marginBottom: '2px',
                marginTop: '1px'
            },
            new: {
                height: '34px',
                background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
            },
            current: {
                height: '34px',
                background: currentColor,
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
            },
            label: {
                fontSize: '14px',
                color: '#000',
                textAlign: 'center'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.label
    }, 'new'), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.label
    }, 'current'));
};
var $10704874a9b8e800$export$2e2bcd8739ae039 = $10704874a9b8e800$export$ce0d7acd66f46f2b;


var $503ed9a93574dbce$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $503ed9a93574dbce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $503ed9a93574dbce$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $503ed9a93574dbce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $503ed9a93574dbce$export$4ed116dea8ad5956 = function(_React$Component) {
    $503ed9a93574dbce$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $503ed9a93574dbce$var$_classCallCheck(this, Photoshop);
        var _this = $503ed9a93574dbce$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $503ed9a93574dbce$var$_createClass(Photoshop, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
                    'default': {
                        picker: {
                            background: '#DCDCDC',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
                            boxSizing: 'initial',
                            width: '513px'
                        },
                        head: {
                            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
                            borderBottom: '1px solid #B1B1B1',
                            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
                            height: '23px',
                            lineHeight: '24px',
                            borderRadius: '4px 4px 0 0',
                            fontSize: '13px',
                            color: '#4D4D4D',
                            textAlign: 'center'
                        },
                        body: {
                            padding: '15px 15px 0',
                            display: 'flex'
                        },
                        saturation: {
                            width: '256px',
                            height: '256px',
                            position: 'relative',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0',
                            overflow: 'hidden'
                        },
                        hue: {
                            position: 'relative',
                            height: '256px',
                            width: '19px',
                            marginLeft: '10px',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0'
                        },
                        controls: {
                            width: '180px',
                            marginLeft: '10px'
                        },
                        top: {
                            display: 'flex'
                        },
                        previews: {
                            width: '60px'
                        },
                        actions: {
                            flex: '1',
                            marginLeft: '20px'
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.picker,
                    className: 'photoshop-picker ' + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.body,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a6bc1b50f0230709$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $44097db7cf08fc15$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bec2357555e376de$export$2e2bcd8739ae039), {
                    direction: 'vertical',
                    hsl: this.props.hsl,
                    pointer: (0, $6dbab6da23f0a762$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.top,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $10704874a9b8e800$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $aa785966637bcbc4$export$2e2bcd8739ae039), {
                    label: 'OK',
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $aa785966637bcbc4$export$2e2bcd8739ae039), {
                    label: 'Cancel',
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $338eca795ded3eb7$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$503ed9a93574dbce$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$503ed9a93574dbce$export$4ed116dea8ad5956.defaultProps = {
    header: 'Color Picker',
    styles: {}
};
var $503ed9a93574dbce$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($503ed9a93574dbce$export$4ed116dea8ad5956);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");



/* eslint-disable no-param-reassign */ 
var $eeH7J = parcelRequire("eeH7J");



var $59408c4348026e80$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingTop: '4px'
            },
            single: {
                flex: '1',
                paddingLeft: '6px'
            },
            alpha: {
                flex: '1',
                paddingLeft: '6px'
            },
            double: {
                flex: '2'
            },
            input: {
                width: '80%',
                padding: '4px 10% 3px',
                border: 'none',
                boxShadow: 'inset 0 0 0 1px #ccc',
                fontSize: '11px'
            },
            label: {
                display: 'block',
                textAlign: 'center',
                fontSize: '11px',
                color: '#222',
                paddingTop: '3px',
                paddingBottom: '4px',
                textTransform: 'capitalize'
            }
        },
        'disableAlpha': {
            alpha: {
                display: 'none'
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $5d0dff9fa57aef75$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: 'rgb'
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: 'rgb'
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
    })));
};
var $59408c4348026e80$export$2e2bcd8739ae039 = $59408c4348026e80$export$a9bdb1170868e062;



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");


var $c4ebfb2288cdf6f9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c4ebfb2288cdf6f9$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            colors: {
                margin: '0 -10px',
                padding: '10px 0 0 10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                flexWrap: 'wrap',
                position: 'relative'
            },
            swatchWrap: {
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0'
            },
            swatch: {
                borderRadius: '3px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
            }
        },
        'no-presets': {
            colors: {
                display: 'none'
            }
        }
    }, {
        'no-presets': !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.colors,
        className: 'flexbox-fix'
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === 'string' ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = '' + c.color + (c.title || '');
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ebc3a59bc6291c3$export$2e2bcd8739ae039), $c4ebfb2288cdf6f9$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
            }
        })));
    }));
};
$c4ebfb2288cdf6f9$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        })
    ])).isRequired
};
var $c4ebfb2288cdf6f9$export$2e2bcd8739ae039 = $c4ebfb2288cdf6f9$export$cc78acae6744db3b;


var $d0f43b3245f5dd9d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d0f43b3245f5dd9d$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': $d0f43b3245f5dd9d$var$_extends({
            picker: {
                width: width,
                padding: '10px 10px 0',
                boxSizing: 'initial',
                background: '#fff',
                borderRadius: '4px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
            },
            saturation: {
                width: '100%',
                paddingBottom: '75%',
                position: 'relative',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '3px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            controls: {
                display: 'flex'
            },
            sliders: {
                padding: '4px 0',
                flex: '1'
            },
            color: {
                width: '24px',
                height: '24px',
                position: 'relative',
                marginTop: '4px',
                marginLeft: '4px',
                borderRadius: '3px'
            },
            activeColor: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '2px',
                background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            hue: {
                position: 'relative',
                height: '10px',
                overflow: 'hidden'
            },
            Hue: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            alpha: {
                position: 'relative',
                height: '10px',
                marginTop: '4px',
                overflow: 'hidden'
            },
            Alpha: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            }
        }, passedStyles),
        'disableAlpha': {
            color: {
                height: '10px'
            },
            hue: {
                height: '10px'
            },
            alpha: {
                display: 'none'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker,
        className: 'sketch-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a6bc1b50f0230709$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bec2357555e376de$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $9232e77ca409a344$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a30c75ca5a20b075$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $59408c4348026e80$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $c4ebfb2288cdf6f9$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$d0f43b3245f5dd9d$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$d0f43b3245f5dd9d$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        '#D0021B',
        '#F5A623',
        '#F8E71C',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
        '#4A90E2',
        '#50E3C2',
        '#B8E986',
        '#000000',
        '#4A4A4A',
        '#9B9B9B',
        '#FFFFFF'
    ]
};
var $d0f43b3245f5dd9d$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($d0f43b3245f5dd9d$export$361fce2090be193f);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");




var $eeH7J = parcelRequire("eeH7J");


var $eeH7J = parcelRequire("eeH7J");

var $97ccb948e72df062$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            swatch: {
                height: '12px',
                background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
                cursor: 'pointer'
            }
        },
        'first': {
            swatch: {
                borderRadius: '2px 0 0 2px'
            }
        },
        'last': {
            swatch: {
                borderRadius: '0 2px 2px 0'
            }
        },
        'active': {
            swatch: {
                transform: 'scaleY(1.8)',
                borderRadius: '3.6px/2px'
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: 'hsl'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $97ccb948e72df062$export$2e2bcd8739ae039 = $97ccb948e72df062$export$5c11afa672411de4;


var $26800ec7003bb469$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            swatches: {
                marginTop: '20px'
            },
            swatch: {
                boxSizing: 'border-box',
                width: '20%',
                paddingRight: '1px',
                float: 'left'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $97ccb948e72df062$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $97ccb948e72df062$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $97ccb948e72df062$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $97ccb948e72df062$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $97ccb948e72df062$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.clear
    }));
};
var $26800ec7003bb469$export$2e2bcd8739ae039 = $26800ec7003bb469$export$48f49e32c66cdd61;



var $eeH7J = parcelRequire("eeH7J");

var $7fc20eaea7bd60dc$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '14px',
                height: '14px',
                borderRadius: '6px',
                transform: 'translate(-7px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
var $7fc20eaea7bd60dc$export$2e2bcd8739ae039 = $7fc20eaea7bd60dc$export$9c10b52c64965f67;


var $780c4ce08e08f432$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            hue: {
                height: '12px',
                position: 'relative'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.wrap || {},
        className: 'slider-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bec2357555e376de$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $26800ec7003bb469$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$780c4ce08e08f432$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$780c4ce08e08f432$export$472062a354075cee.defaultProps = {
    pointer: (0, $7fc20eaea7bd60dc$export$2e2bcd8739ae039),
    styles: {}
};
var $780c4ce08e08f432$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($780c4ce08e08f432$export$472062a354075cee);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");






var $eeH7J = parcelRequire("eeH7J");



var $eeH7J = parcelRequire("eeH7J");



var $47449f912eb49cb2$exports = {};
'use strict';
Object.defineProperty($47449f912eb49cb2$exports, "__esModule", {
    value: true
});
var $47449f912eb49cb2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $47449f912eb49cb2$var$_react2 = $47449f912eb49cb2$var$_interopRequireDefault($eeH7J);
function $47449f912eb49cb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47449f912eb49cb2$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $47449f912eb49cb2$var$DEFAULT_SIZE = 24;
$47449f912eb49cb2$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $47449f912eb49cb2$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $47449f912eb49cb2$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $47449f912eb49cb2$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $47449f912eb49cb2$var$_react2.default.createElement('svg', $47449f912eb49cb2$var$_extends({
        viewBox: '0 0 ' + $47449f912eb49cb2$var$DEFAULT_SIZE + ' ' + $47449f912eb49cb2$var$DEFAULT_SIZE,
        style: $47449f912eb49cb2$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $47449f912eb49cb2$var$_react2.default.createElement('path', {
        d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
};


var $b93ae3c48b46815d$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            color: {
                width: '40px',
                height: '24px',
                cursor: 'pointer',
                background: color,
                marginBottom: '1px'
            },
            check: {
                color: $5d0dff9fa57aef75$export$3609eb1d7e55dec(color),
                marginLeft: '8px',
                display: 'none'
            }
        },
        'first': {
            color: {
                overflow: 'hidden',
                borderRadius: '2px 2px 0 0'
            }
        },
        'last': {
            color: {
                overflow: 'hidden',
                borderRadius: '0 0 2px 2px'
            }
        },
        'active': {
            check: {
                display: 'block'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            check: {
                color: '#333'
            }
        },
        'transparent': {
            check: {
                color: '#333'
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ebc3a59bc6291c3$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($47449f912eb49cb2$exports))), null)));
};
var $b93ae3c48b46815d$export$2e2bcd8739ae039 = $b93ae3c48b46815d$export$af5303fde6798b43;


var $ea3d91f1e98d14d2$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            group: {
                paddingBottom: '10px',
                width: '40px',
                float: 'left',
                marginRight: '10px'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.group
    }, (0, $44d4b6b3f15b91cd$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b93ae3c48b46815d$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $ea3d91f1e98d14d2$export$2e2bcd8739ae039 = $ea3d91f1e98d14d2$export$354a0399ec1ad469;


var $497b852eb3cf0034$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: 'scroll'
            },
            body: {
                padding: '16px 0 6px 16px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker,
        className: 'swatches-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1bea058f31f647d1$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.body
    }, (0, $44d4b6b3f15b91cd$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ea3d91f1e98d14d2$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.clear
    })))));
};
$497b852eb3cf0034$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$497b852eb3cf0034$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $11300cc8beffd7e4$export$a90204d1394caf30['900'],
            $11300cc8beffd7e4$export$a90204d1394caf30['700'],
            $11300cc8beffd7e4$export$a90204d1394caf30['500'],
            $11300cc8beffd7e4$export$a90204d1394caf30['300'],
            $11300cc8beffd7e4$export$a90204d1394caf30['100']
        ],
        [
            $11300cc8beffd7e4$export$47853bc718611763['900'],
            $11300cc8beffd7e4$export$47853bc718611763['700'],
            $11300cc8beffd7e4$export$47853bc718611763['500'],
            $11300cc8beffd7e4$export$47853bc718611763['300'],
            $11300cc8beffd7e4$export$47853bc718611763['100']
        ],
        [
            $11300cc8beffd7e4$export$e13cce2a2d16a9d4['900'],
            $11300cc8beffd7e4$export$e13cce2a2d16a9d4['700'],
            $11300cc8beffd7e4$export$e13cce2a2d16a9d4['500'],
            $11300cc8beffd7e4$export$e13cce2a2d16a9d4['300'],
            $11300cc8beffd7e4$export$e13cce2a2d16a9d4['100']
        ],
        [
            $11300cc8beffd7e4$export$51ef95b19086af57['900'],
            $11300cc8beffd7e4$export$51ef95b19086af57['700'],
            $11300cc8beffd7e4$export$51ef95b19086af57['500'],
            $11300cc8beffd7e4$export$51ef95b19086af57['300'],
            $11300cc8beffd7e4$export$51ef95b19086af57['100']
        ],
        [
            $11300cc8beffd7e4$export$3e6ccc7b8562d453['900'],
            $11300cc8beffd7e4$export$3e6ccc7b8562d453['700'],
            $11300cc8beffd7e4$export$3e6ccc7b8562d453['500'],
            $11300cc8beffd7e4$export$3e6ccc7b8562d453['300'],
            $11300cc8beffd7e4$export$3e6ccc7b8562d453['100']
        ],
        [
            $11300cc8beffd7e4$export$2aa0182783e7e9de['900'],
            $11300cc8beffd7e4$export$2aa0182783e7e9de['700'],
            $11300cc8beffd7e4$export$2aa0182783e7e9de['500'],
            $11300cc8beffd7e4$export$2aa0182783e7e9de['300'],
            $11300cc8beffd7e4$export$2aa0182783e7e9de['100']
        ],
        [
            $11300cc8beffd7e4$export$7b0d29b70b435c21['900'],
            $11300cc8beffd7e4$export$7b0d29b70b435c21['700'],
            $11300cc8beffd7e4$export$7b0d29b70b435c21['500'],
            $11300cc8beffd7e4$export$7b0d29b70b435c21['300'],
            $11300cc8beffd7e4$export$7b0d29b70b435c21['100']
        ],
        [
            $11300cc8beffd7e4$export$7474046f446842ee['900'],
            $11300cc8beffd7e4$export$7474046f446842ee['700'],
            $11300cc8beffd7e4$export$7474046f446842ee['500'],
            $11300cc8beffd7e4$export$7474046f446842ee['300'],
            $11300cc8beffd7e4$export$7474046f446842ee['100']
        ],
        [
            $11300cc8beffd7e4$export$8bf7dff220b82b4a['900'],
            $11300cc8beffd7e4$export$8bf7dff220b82b4a['700'],
            $11300cc8beffd7e4$export$8bf7dff220b82b4a['500'],
            $11300cc8beffd7e4$export$8bf7dff220b82b4a['300'],
            $11300cc8beffd7e4$export$8bf7dff220b82b4a['100']
        ],
        [
            '#194D33',
            $11300cc8beffd7e4$export$955a2ebd2fb142ae['700'],
            $11300cc8beffd7e4$export$955a2ebd2fb142ae['500'],
            $11300cc8beffd7e4$export$955a2ebd2fb142ae['300'],
            $11300cc8beffd7e4$export$955a2ebd2fb142ae['100']
        ],
        [
            $11300cc8beffd7e4$export$559a8c00376dc936['900'],
            $11300cc8beffd7e4$export$559a8c00376dc936['700'],
            $11300cc8beffd7e4$export$559a8c00376dc936['500'],
            $11300cc8beffd7e4$export$559a8c00376dc936['300'],
            $11300cc8beffd7e4$export$559a8c00376dc936['100']
        ],
        [
            $11300cc8beffd7e4$export$221d31baf2636aad['900'],
            $11300cc8beffd7e4$export$221d31baf2636aad['700'],
            $11300cc8beffd7e4$export$221d31baf2636aad['500'],
            $11300cc8beffd7e4$export$221d31baf2636aad['300'],
            $11300cc8beffd7e4$export$221d31baf2636aad['100']
        ],
        [
            $11300cc8beffd7e4$export$594c5a8758200c32['900'],
            $11300cc8beffd7e4$export$594c5a8758200c32['700'],
            $11300cc8beffd7e4$export$594c5a8758200c32['500'],
            $11300cc8beffd7e4$export$594c5a8758200c32['300'],
            $11300cc8beffd7e4$export$594c5a8758200c32['100']
        ],
        [
            $11300cc8beffd7e4$export$7c1ecc66643fdbd6['900'],
            $11300cc8beffd7e4$export$7c1ecc66643fdbd6['700'],
            $11300cc8beffd7e4$export$7c1ecc66643fdbd6['500'],
            $11300cc8beffd7e4$export$7c1ecc66643fdbd6['300'],
            $11300cc8beffd7e4$export$7c1ecc66643fdbd6['100']
        ],
        [
            $11300cc8beffd7e4$export$ad766f34ace1cafd['900'],
            $11300cc8beffd7e4$export$ad766f34ace1cafd['700'],
            $11300cc8beffd7e4$export$ad766f34ace1cafd['500'],
            $11300cc8beffd7e4$export$ad766f34ace1cafd['300'],
            $11300cc8beffd7e4$export$ad766f34ace1cafd['100']
        ],
        [
            $11300cc8beffd7e4$export$1ceed3dd9ec11704['900'],
            $11300cc8beffd7e4$export$1ceed3dd9ec11704['700'],
            $11300cc8beffd7e4$export$1ceed3dd9ec11704['500'],
            $11300cc8beffd7e4$export$1ceed3dd9ec11704['300'],
            $11300cc8beffd7e4$export$1ceed3dd9ec11704['100']
        ],
        [
            $11300cc8beffd7e4$export$b6e6178d3f565007['900'],
            $11300cc8beffd7e4$export$b6e6178d3f565007['700'],
            $11300cc8beffd7e4$export$b6e6178d3f565007['500'],
            $11300cc8beffd7e4$export$b6e6178d3f565007['300'],
            $11300cc8beffd7e4$export$b6e6178d3f565007['100']
        ],
        [
            $11300cc8beffd7e4$export$7c2da42d08c019c9['900'],
            $11300cc8beffd7e4$export$7c2da42d08c019c9['700'],
            $11300cc8beffd7e4$export$7c2da42d08c019c9['500'],
            $11300cc8beffd7e4$export$7c2da42d08c019c9['300'],
            $11300cc8beffd7e4$export$7c2da42d08c019c9['100']
        ],
        [
            '#000000',
            '#525252',
            '#969696',
            '#D9D9D9',
            '#FFFFFF'
        ]
    ],
    styles: {}
};
var $497b852eb3cf0034$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($497b852eb3cf0034$export$81ebbfd13e06b049);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");





var $f65b5a01cf2d6872$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '0 solid rgba(0,0,0,0.25)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                borderRadius: '4px',
                position: 'relative'
            },
            body: {
                padding: '15px 9px 9px 15px'
            },
            label: {
                fontSize: '18px',
                color: '#fff'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent #fff transparent',
                position: 'absolute'
            },
            triangleShadow: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
                position: 'absolute'
            },
            hash: {
                background: '#F0F0F0',
                height: '30px',
                width: '30px',
                borderRadius: '4px 0 0 4px',
                float: 'left',
                color: '#98A1A4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            input: {
                width: '100px',
                fontSize: '14px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '28px',
                boxShadow: 'inset 0 0 0 1px #F0F0F0',
                boxSizing: 'content-box',
                borderRadius: '0 4px 4px 0',
                float: 'left',
                paddingLeft: '8px'
            },
            swatch: {
                width: '30px',
                height: '30px',
                float: 'left',
                borderRadius: '4px',
                margin: '0 6px 6px 0'
            },
            clear: {
                clear: 'both'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-10px',
                left: '12px'
            },
            triangleShadow: {
                top: '-11px',
                left: '12px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-10px',
                right: '12px'
            },
            triangleShadow: {
                top: '-11px',
                right: '12px'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right'
    });
    var handleChange = function handleChange(hexcode, e) {
        $5d0dff9fa57aef75$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.card,
        className: 'twitter-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.body
    }, (0, $44d4b6b3f15b91cd$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1ebc3a59bc6291c3$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.hash
    }, '#'), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.clear
    })));
};
$f65b5a01cf2d6872$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'hide',
        'top-left',
        'top-right'
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$f65b5a01cf2d6872$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF'
    ],
    triangle: 'top-left',
    styles: {}
};
var $f65b5a01cf2d6872$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($f65b5a01cf2d6872$export$9e389cdad32a5b7a);



var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");




var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");
var $0478ca2e91807913$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                border: '2px #fff solid',
                transform: 'translate(-12px, -13px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
$0478ca2e91807913$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    })
};
$0478ca2e91807913$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $0478ca2e91807913$export$2e2bcd8739ae039 = $0478ca2e91807913$export$a928e0fe8b70765d;



var $eeH7J = parcelRequire("eeH7J");


var $4yBem = parcelRequire("4yBem");
var $f9ef6655b7cdc44f$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                transform: 'translate(-10px, -7px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
                border: '2px white solid'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker
    });
};
$f9ef6655b7cdc44f$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    })
};
$f9ef6655b7cdc44f$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $f9ef6655b7cdc44f$export$2e2bcd8739ae039 = $f9ef6655b7cdc44f$export$9de61b9626feed9a;



var $eeH7J = parcelRequire("eeH7J");



var $43a414bbd8f3d0f8$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $5d0dff9fa57aef75$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(',');
            $5d0dff9fa57aef75$export$e76ec4c5b3cadd73(data.rgb, 'rgb') && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: 'rgb'
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(',');
            if ($5d0dff9fa57aef75$export$e76ec4c5b3cadd73(data.hsv, 'hsv')) {
                _values[2] = _values[2].replace('%', '');
                _values[1] = _values[1].replace('%', '');
                _values[0] = _values[0].replace("\xb0", '');
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: 'hsv'
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(',');
            if ($5d0dff9fa57aef75$export$e76ec4c5b3cadd73(data.hsl, 'hsl')) {
                _values2[2] = _values2[2].replace('%', '');
                _values2[1] = _values2[1].replace('%', '');
                _values2[0] = _values2[0].replace("\xb0", '');
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: 'hsl'
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))({
        'default': {
            wrap: {
                display: 'flex',
                height: '100px',
                marginTop: '4px'
            },
            fields: {
                width: '100%'
            },
            column: {
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between'
            },
            double: {
                padding: '0px 4.4px',
                boxSizing: 'border-box'
            },
            input: {
                width: '100%',
                height: '38px',
                boxSizing: 'border-box',
                padding: '4px 10% 3px',
                textAlign: 'center',
                border: '1px solid #dadce0',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            input2: {
                height: '38px',
                width: '100%',
                border: '1px solid #dadce0',
                boxSizing: 'border-box',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                paddingLeft: '10px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label: {
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '35px',
                top: '-6px',
                left: '0',
                right: '0',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label2: {
                left: '10px',
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '32px',
                top: '-6px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            single: {
                flexGrow: '1',
                margin: '0px 4.4px'
            }
        }
    });
    var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
    var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
    var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'rgb',
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsv',
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $75750ef8547f0a1f$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsl',
        value: hslValue,
        onChange: handleChange
    })))));
};
var $43a414bbd8f3d0f8$export$2e2bcd8739ae039 = $43a414bbd8f3d0f8$export$e50902ed332e5599;


var $867da7f194b7f614$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($88b1044c55714645$exports)))((0, $451ad2baa4201321$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                border: '1px solid #dfe1e5',
                boxSizing: 'initial',
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: '8px 8px 0px 0px'
            },
            head: {
                height: '57px',
                width: '100%',
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                fontSize: '20px',
                boxSizing: 'border-box',
                fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
            },
            saturation: {
                width: '70%',
                padding: '0px',
                position: 'relative',
                overflow: 'hidden'
            },
            swatch: {
                width: '30%',
                height: '228px',
                padding: '0px',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
                position: 'relative',
                overflow: 'hidden'
            },
            body: {
                margin: 'auto',
                width: '95%'
            },
            controls: {
                display: 'flex',
                boxSizing: 'border-box',
                height: '52px',
                paddingTop: '22px'
            },
            color: {
                width: '32px'
            },
            hue: {
                height: '8px',
                position: 'relative',
                margin: '0px 16px 0px 16px',
                width: '100%'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.picker,
        className: 'google-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a6bc1b50f0230709$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $0478ca2e91807913$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $bec2357555e376de$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: '4px',
        pointer: (0, $f9ef6655b7cdc44f$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $43a414bbd8f3d0f8$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$867da7f194b7f614$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
};
$867da7f194b7f614$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: 'Color picker'
};
var $867da7f194b7f614$export$2e2bcd8739ae039 = (0, $5f6afe5189f8d29a$export$2e2bcd8739ae039)($867da7f194b7f614$export$347eee6e8bf67997);





var $9db445fa7fb2abd6$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($9db445fa7fb2abd6$exports, "__esModule", {
    value: true
});
$9db445fa7fb2abd6$exports.default = void 0;

var $9db445fa7fb2abd6$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $9db445fa7fb2abd6$var$_default = $9db445fa7fb2abd6$exports.default = (0, $9db445fa7fb2abd6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M16.56 8.94 7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12M5.21 10 10 5.21 14.79 10zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5M2 20h20v4H2z"
}), 'FormatColorFillOutlined');


var $08752b61b5d1eb8f$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($08752b61b5d1eb8f$exports, "__esModule", {
    value: true
});
$08752b61b5d1eb8f$exports.default = void 0;

var $08752b61b5d1eb8f$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $08752b61b5d1eb8f$var$_default = $08752b61b5d1eb8f$exports.default = (0, $08752b61b5d1eb8f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M2 20h20v4H2zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5zm4.42-5.61 2.03-5.79h.12l2.03 5.79z"
}), 'FormatColorTextOutlined');



const $5273f505000f263e$var$ConfigWidgets = (props)=>{
    const [backgroudColor, setBackgroundColor] = $eeH7J.useState({
        displayColorPicker: false,
        color: props.cookies.cookieBackgroundColor
    });
    const [fontColor, setFontColor] = $eeH7J.useState({
        displayColorPicker: false,
        color: props.cookies.cookieFontColor
    });
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black h-screen left-sidebar-widgets"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Cookie consent banner", /*#__PURE__*/ $eeH7J.createElement((0, $e8392f33c4dcd0bc$export$2e2bcd8739ae039), {
        checked: props.cookies.cookieBannerVisible,
        onChange: (e)=>{
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieBannerVisible: e.target.checked
                }
            });
        }
    })), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "font-normal mb-2"
    }, "This will add a cookie policy widget on each page."), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col mt-3 text-sm font-normal relative"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "Message"), /*#__PURE__*/ $eeH7J.createElement("input", {
        className: "w-96 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "We use cookies to improve your experience on our site.  ",
        value: props.cookies.cookieText,
        onChange: (e)=>{
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieText: (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value)
                }
            });
        }
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col mt-3 text-sm font-normal"
    }, /*#__PURE__*/ $eeH7J.createElement("span", null, "Button title"), /*#__PURE__*/ $eeH7J.createElement("input", {
        className: "w-96 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "Okay",
        value: props.cookies.cookieButtonText,
        onChange: (e)=>{
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieButtonText: (0, $afb063dffe111db3$export$2e2bcd8739ae039)(e.target.value)
                }
            });
        }
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row mt-6 text-sm font-normal items-center w-96 justify-between relative"
    }, /*#__PURE__*/ $eeH7J.createElement("div", null, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9db445fa7fb2abd6$exports))), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "mx-2"
    }, "Background color")), /*#__PURE__*/ $eeH7J.createElement("div", {
        style: {
            backgroundColor: `rgba(${backgroudColor.color.r}, ${backgroudColor.color.g}, ${backgroudColor.color.b}, ${backgroudColor.color.a})`
        },
        className: `h-8 w-8 rounded border`,
        onClick: ()=>{
            setBackgroundColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: !old.displayColorPicker
                };
            });
        }
    }), backgroudColor.displayColorPicker ? /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute z-10 inset-x-60 inset-y-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0",
        onClick: ()=>{
            setBackgroundColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: false
                };
            });
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, $d0f43b3245f5dd9d$export$2e2bcd8739ae039), {
        color: backgroudColor.color,
        onChange: (color)=>{
            setBackgroundColor((old)=>{
                return {
                    ...old,
                    color: color.rgb
                };
            });
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieBackgroundColor: color.rgb
                }
            });
        }
    })) : null), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-row mt-3 text-sm font-normal items-center w-96 justify-between relative"
    }, /*#__PURE__*/ $eeH7J.createElement("div", null, /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($08752b61b5d1eb8f$exports))), null), /*#__PURE__*/ $eeH7J.createElement("span", {
        className: "mx-2"
    }, "Font color")), /*#__PURE__*/ $eeH7J.createElement("div", {
        style: {
            backgroundColor: `rgba(${fontColor.color.r}, ${fontColor.color.g}, ${fontColor.color.b}, ${fontColor.color.a})`
        },
        className: `h-8 w-8 rounded border`,
        onClick: ()=>{
            setFontColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: !old.displayColorPicker
                };
            });
        }
    }), fontColor.displayColorPicker ? /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "absolute z-10 inset-x-60 inset-y-0"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed inset-0",
        onClick: ()=>{
            setFontColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: false
                };
            });
        }
    }), /*#__PURE__*/ $eeH7J.createElement((0, $d0f43b3245f5dd9d$export$2e2bcd8739ae039), {
        color: fontColor.color,
        onChange: (color)=>{
            setFontColor((old)=>{
                return {
                    ...old,
                    color: color.rgb
                };
            });
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieFontColor: color.rgb
                }
            });
        }
    })) : null)));
};
var $5273f505000f263e$export$2e2bcd8739ae039 = $5273f505000f263e$var$ConfigWidgets;




const $c31800981d94ff20$export$bae4861c03af8b17 = (props)=>{
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [searchParams, setSearchParams] = (0, $42e24d1152893e59$export$f1a78c17382fe22a)();
    const [saveDisabled, setSaveDisabled] = (0, $eeH7J.useState)();
    const updateQueryParam = (key, value)=>{
        const params = new URLSearchParams(searchParams);
        params.set(key, value);
        setSearchParams(params);
    };
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    const handleUpdateQueryParam = (section)=>{
        updateQueryParam("section", section);
    };
    const colorPalletKeys = (0, (/*@__PURE__*/$parcel$interopDefault($188ff129cb2c0207$exports)))();
    const { id: id } = (0, $0d4e57672a3dc010$export$99eaa27ddbbb95ef)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const [selectedDomainTab, setSelectedDomainTab] = (0, $eeH7J.useState)("subdomain");
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const [isCheckingSSL, setIsCheckingSSL] = (0, $eeH7J.useState)(false);
    const [siteData, setSiteData] = (0, $eeH7J.useState)({});
    const [allTemplateColors, setAllTemplateColors] = (0, $eeH7J.useState)([]);
    const [formData, setFormData] = (0, $eeH7J.useState)({
        siteId: id,
        siteName: "",
        faviconImage: "",
        defaultSocialMediaImage: "",
        defaultSocialMediaDescription: "",
        defaultSocialMediaImageAlt: "",
        subDomain: "",
        head_customHtmlCode: "",
        body_customHtmlCode: "",
        primaryLanguage: "en",
        redirects: [],
        subDomainErrorMessage: "",
        cookies: {
            cookieBannerVisible: false,
            cookieText: "",
            cookieButtonText: "",
            cookieBackgroundColor: {
                r: "24",
                g: "160",
                b: "251",
                a: "100"
            },
            cookieFontColor: {
                r: "0",
                g: "0",
                b: "0",
                a: "100"
            }
        },
        siteOwnerUserId: "",
        addOnUsers: [],
        currButtonConfig: [],
        isPublished: false,
        templateColorPalettes: [],
        templateCategories: [],
        templateName: "",
        isTemplate: "false",
        isAITemplate: "false",
        siteUrl: ""
    });
    const stateData = location.state;
    const [templateSiteCategories, setTemplateSiteCategories] = (0, $eeH7J.useState)([]);
    const [siteCategory, setSiteCategory] = (0, $eeH7J.useState)([
        "General",
        "Domain",
        "Custom Code",
        "SEO",
        // "Widgets",
        "Contact Form",
        "Contributors",
        // "Billing",
        // "Plans",
        "Subscriptions"
    ]);
    const onFormDataChange = (data)=>{
        // console.log("onFormDataChange", data);
        setFormData((old)=>{
            return {
                ...old,
                ...data
            };
        });
    };
    const objectWithoutKey = (object, key)=>{
        const { [key]: deletedKey, ...otherKeys } = object;
        return otherKeys;
    };
    const deepCompare = (arg1, arg2)=>{
        if (Object.prototype.toString.call(arg1) === Object.prototype.toString.call(arg2)) {
            if (Object.prototype.toString.call(arg1) === "[object Object]" || Object.prototype.toString.call(arg1) === "[object Array]") {
                if (Object.keys(arg1).length !== Object.keys(arg2).length) return false;
                return Object.keys(arg1).every(function(key) {
                    return deepCompare(arg1[key], arg2[key]);
                });
            }
            return arg1 === arg2;
        }
        return false;
    };
    function findDuplicates(array) {
        const seen = {};
        const duplicates = [];
        array.forEach((item)=>{
            const itemString = JSON.stringify(item);
            if (seen[itemString]) {
                if (seen[itemString] === 1) duplicates.push(item);
                seen[itemString]++;
            } else seen[itemString] = 1;
        });
        return duplicates;
    }
    const onSave = async ()=>{
        //validation for templates
        if (formData.templateColorPalettes) {
            let _dup = findDuplicates(formData.templateColorPalettes?.map((ol)=>ol.id));
            let _emptyImage = formData.templateColorPalettes.filter((kl)=>kl.imageUrl.length === 0);
            if (_dup.length > 0 || _emptyImage.length > 0) {
                enqueueSnackbar("Invalid applicable color pallet", {
                    variant: "error"
                });
                return;
            }
        }
        if ((formData.isTemplate === "true" || formData.isAITemplate === "true") && (!Array.isArray(formData.templateCategories) || formData.templateCategories.length === 0)) {
            enqueueSnackbar("Atleast one template category should be selected!", {
                variant: "error"
            });
            return;
        }
        if ((formData.isTemplate === "true" || formData.isAITemplate === "true") && (!Array.isArray(formData.templateColorPalettes) || formData.templateColorPalettes.length === 0)) {
            enqueueSnackbar("Atleast one template color pallet should be there!", {
                variant: "error"
            });
            return;
        }
        if ((formData.isTemplate === "true" || formData.isAITemplate === "true") && (formData.templateName === "" || !formData.templateName || formData.templateName === null || formData.templateName === undefined)) {
            enqueueSnackbar("Template name can't be blank!", {
                variant: "error"
            });
            return;
        }
        if (formData.defaultSocialMediaDescription && formData.defaultSocialMediaDescription.trim().length > 160) {
            enqueueSnackbar("Description exceeds the 160-character limit.", {
                variant: "error"
            });
            return;
        }
        // return;
        setIsLoading(true);
        try {
            if (formData.subDomainErrorMessage && formData.subDomainErrorMessage !== "") {
                enqueueSnackbar(formData.subDomainErrorMessage, {
                    variant: "error"
                });
                setIsLoading(false);
                return;
            }
            let data = objectWithoutKey(formData, "subDomainErrorMessage");
            data = objectWithoutKey(data, "siteOwnerUserId");
            // console.log("onsave click", data);
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/configs/append-site-config", data);
            if (siteData.isPublished) {
                if (data.subDomain !== siteData.subDomain) await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).patch("/api/configs/subdomain", {
                    siteId: data.siteId
                });
                if (data.siteName !== siteData.siteName || data.head_customHtmlCode !== siteData.head_customHtmlCode || data.body_customHtmlCode !== siteData.body_customHtmlCode || data.primaryLanguage !== siteData.primaryLanguage || data.defaultSocialMediaImage && !siteData.defaultSocialMediaImage || !data.defaultSocialMediaImage && siteData.defaultSocialMediaImage || data.defaultSocialMediaDescription !== siteData.defaultSocialMediaDescription || data.defaultSocialMediaImageAlt !== siteData.defaultSocialMediaImageAlt) {
                    const publishRes = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/configs/publish", {
                        siteId: data.siteId,
                        siteConfig: true
                    });
                    checkPublishStatus({
                        kind: "site",
                        siteId: data.siteId
                    }, "Site setting saved successfully!");
                } else {
                    if (data.faviconImage && data.faviconImage !== siteData.faviconImage || data.defaultSocialMediaImage !== siteData.defaultSocialMediaImage) await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).patch("/api/configs/site-images", {
                        siteId: data.siteId,
                        faviconChanged: data.faviconImage !== siteData.faviconImage,
                        socialImageChanged: data.defaultSocialMediaImage !== siteData.defaultSocialMediaImage
                    });
                    if (!deepCompare(data.redirects, siteData.redirects)) await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).patch("/api/configs/url-redirects", {
                        siteId: data.siteId
                    });
                    setIsLoading(false);
                    enqueueSnackbar("Site setting saved successfully!", {
                        variant: "success",
                        className: "bg-catelina-blue",
                        onExited: ()=>{
                            enqueueSnackbar("Refreshing preview. Please wait.", {
                                variant: "info",
                                autoHideDuration: 10000
                            });
                        }
                    });
                }
            } else {
                setIsLoading(false);
                enqueueSnackbar("Site setting saved successfully!", {
                    variant: "success",
                    className: "bg-catelina-blue"
                });
            }
            // Update siteUrl to reflect the new subdomain after save
            const updatedData = {
                ...data
            };
            if (data.subDomain !== siteData.subDomain && siteData.siteUrl) {
                const domainParts = siteData.siteUrl.split(".").slice(1).join(".");
                updatedData.siteUrl = `${data.subDomain}.${domainParts}`;
            }
            setSiteData(updatedData);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            let message = "An error occurred";
            if (err && typeof err === "object" && "response" in err) {
                const axiosError = err;
                message = axiosError.response?.data?.message || "An error occurred";
            } else if (err instanceof Error) message = err.message;
            enqueueSnackbar(message, {
                variant: "error"
            });
        }
    };
    // --- Publish status polling (singleton) ---
    const publishPollRef = $eeH7J.useRef({
        intervalId: null,
        timeoutId: null,
        inFlight: false
    });
    const stopPublishPolling = $eeH7J.useCallback(()=>{
        if (publishPollRef.current.intervalId) clearInterval(publishPollRef.current.intervalId);
        if (publishPollRef.current.timeoutId) clearTimeout(publishPollRef.current.timeoutId);
        publishPollRef.current.intervalId = null;
        publishPollRef.current.timeoutId = null;
        publishPollRef.current.inFlight = false;
    }, []);
    $eeH7J.useEffect(()=>{
        return ()=>stopPublishPolling();
    }, [
        stopPublishPolling
    ]);
    const checkPublishStatus = (target, successMessage)=>{
        // Ensure there is only one active poller at a time.
        stopPublishPolling();
        publishPollRef.current.intervalId = setInterval(async ()=>{
            if (publishPollRef.current.inFlight) return;
            publishPollRef.current.inFlight = true;
            try {
                const queryString = target.kind === "page" ? `pageId=${encodeURIComponent(target.pageId)}` : `siteId=${encodeURIComponent(target.siteId)}`;
                const publishResponse = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/check-publish-status?${queryString}`);
                const statusPayload = (0, $3e95173fd5aea333$export$f00a55a332eb5e99)(publishResponse);
                const status = (0, $3e95173fd5aea333$export$2fec6246253ef2cb)(statusPayload?.status ?? statusPayload?.publishStatus ?? statusPayload?.pageStatus ?? statusPayload?.publishingStatus);
                if (status === "completed") {
                    stopPublishPolling();
                    setIsLoading(false);
                    enqueueSnackbar(successMessage, {
                        variant: "success",
                        className: "bg-catelina-blue",
                        onExited: ()=>{
                            enqueueSnackbar("Refreshing preview. Please wait.", {
                                variant: "info",
                                autoHideDuration: 10000
                            });
                        }
                    });
                    if (statusPayload?.publishError) enqueueSnackbar(statusPayload.publishError, {
                        variant: "info",
                        className: "bg-grey-400"
                    });
                } else if (status === "failed") {
                    stopPublishPolling();
                    setIsLoading(false);
                    enqueueSnackbar(statusPayload?.publishError || "Something went wrong. Please try again.", {
                        variant: "error"
                    });
                }
            } catch (e) {
                stopPublishPolling();
                setIsLoading(false);
                enqueueSnackbar("Failed to check publish status.", {
                    variant: "error"
                });
            } finally{
                publishPollRef.current.inFlight = false;
            }
        }, 5000);
        publishPollRef.current.timeoutId = setTimeout(()=>{
            stopPublishPolling();
            setIsLoading(false);
            enqueueSnackbar("Something went wrong. Please try again.", {
                variant: "error"
            });
        }, 300000);
    };
    const onAddOnUsersAdd = async (emails)=>{
        setIsLoading(true);
        try {
            let l_data = {
                siteId: formData.siteId,
                contributorsEmail: emails
            };
            // console.log("onAddOnUsersAdd", l_data);
            let rs = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/site-config-add-contributors", l_data);
            // console.log(l_data);
            // Lets send the email.
            emails.map(async (email)=>{
                let mailBody = "Dear " + email + ",";
                let siteLink = "https://editor.rocketpages.io/" + l_data.siteId;
                // mailBody += "<br> You are added as contributor";
                mailBody += "<br><br> We are excited to inform you that you have been added as a contributor to RocketPages.";
                mailBody += "<br><br> You can now access the site and start collaborating by visiting " + siteLink + ".";
                mailBody += "<br><br> Best regards,";
                mailBody += "<br> The RocketPages Team";
                let mailData = {
                    to: email,
                    subject: "Welcome to RocketPages!",
                    text: mailBody,
                    html: mailBody
                };
                let res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/sg-mail/send", mailData);
            });
            // Lets notify the user that mail has been sent.
            enqueueSnackbar("Contributor mail has been sent!", {
                variant: "info",
                className: "bg-grey-400"
            });
            setIsLoading(false);
        // console.log("save res", rs);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };
    const onAddOnUsersRemove = async (email)=>{
        setIsLoading(true);
        try {
            let l_data = {
                siteId: formData.siteId,
                email: email
            };
            // console.log("onAddOnUsersRemove", l_data);
            let rs = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).put("/api/configs/site-config-remove-contributor", l_data);
            setIsLoading(false);
        // console.log("save res", rs);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };
    const [selectedCategory, setSelectedCategory] = (0, $eeH7J.useState)(searchParams.get("section") || "General");
    const handleCategoryChange = (category)=>{
        setSelectedCategory(category);
        handleUpdateQueryParam(category);
    };
    // Fetch site data when id changes
    $eeH7J.useEffect(()=>{
        if (!id) return;
        let cancelled = false;
        (async ()=>{
            setIsLoading(true);
            try {
                const [siteRes, colorsRes, categoriesRes] = await Promise.all([
                    (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/site-config?siteId=${id}`),
                    (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`),
                    (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/all-site-category`)
                ]);
                if (cancelled) return;
                const site = siteRes.data;
                setSiteData(site);
                setFormData({
                    ...site,
                    templateColorPalettes: site.templateColorPalettes ? site.templateColorPalettes.map((item)=>({
                            ...item,
                            keyIndex: colorPalletKeys.new()
                        })) : []
                });
                setAllTemplateColors(colorsRes.data.data);
                setTemplateSiteCategories(categoriesRes.data.data);
                // Use functional update to avoid stale 'siteCategory'
                setSiteCategory((prev)=>{
                    let next = [
                        ...prev
                    ];
                    if (site.siteOwnerUserId !== cookies.rp_user_data.userId) next = next.filter((c)=>c !== "Contributors" && c !== "Subscriptions");
                    if (cookies.rp_user_data.role === "admin") {
                        if (!next.includes("Administration")) next.push("Administration");
                    }
                    return next;
                });
            } catch (err) {
                const status = err?.response?.status;
                if (status === 404) navigate(`/404?msgType=SiteNotFound`);
                else if (status === 401) navigate(`/404?msgType=SiteNotAuthorizedToAccess`);
                else console.log("err", err);
            } finally{
                if (!cancelled) setIsLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        id
    ]);
    // To hide sitename of preview on mobile view
    const useMobileView = ()=>{
        const [isMobileView, setIsMobile] = (0, $eeH7J.useState)(window.innerWidth <= 601);
        $eeH7J.useEffect(()=>{
            const mediaQuery = window.matchMedia("(max-width: 601px)");
            const handleMediaChange = ()=>setIsMobile(mediaQuery.matches);
            handleMediaChange(); // Initial check
            mediaQuery.addEventListener("change", handleMediaChange); // Listen for changes
            return ()=>mediaQuery.removeEventListener("change", handleMediaChange); // Cleanup
        }, []);
        return isMobileView;
    };
    let isMobile = useMobileView();
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $0206968a9c2cf7b5$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Site Settings"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading || isCheckingSSL
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    }), isCheckingSSL && /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "mt-4"
    }, "Updating your site's domain...")), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        isPublished: formData.isPublished,
        siteId: id,
        title: `Site settings${!isMobile ? ` : ${formData ? formData.siteName : ""}` : ""}`,
        siteUrl: siteData.siteUrl ? `https://${siteData.siteUrl}` : ""
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 top-[64px] hidden md:flex"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "left-navbar-tabs w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, siteCategory.map((ii)=>{
        return /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `px-6 hover:cursor-pointer py-2 left-sidebar-tab-${ii.toLowerCase().replace(/\s+/g, "-")} ${selectedCategory === ii ? "bg-white-smoke text-catelina-blue" : ""}`,
            key: ii,
            onClick: ()=>handleCategoryChange(ii)
        }, ii);
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: " left-navbar-tab-contents min-h-screen flex w-full my-4 px-4 md:pl-[280px] pb-10 pt-[64px] bg-white-smoke flex-col"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex md:hidden py-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $3fb1cc9123a3eb67$export$2e2bcd8739ae039), {
        items: siteCategory,
        handleChange: handleCategoryChange,
        category: selectedCategory
    })), formData && selectedCategory === "General" && /*#__PURE__*/ $eeH7J.createElement((0, $8cf81ed6e510d7ef$export$2e2bcd8739ae039), {
        siteId: formData.siteId,
        onDataChange: onFormDataChange,
        faviconImage: formData.faviconImage,
        siteName: formData.siteName,
        defaultSocialMediaImage: formData.defaultSocialMediaImage,
        defaultSocialMediaDescription: formData.defaultSocialMediaDescription,
        defaultSocialMediaImageAlt: formData.defaultSocialMediaImageAlt
    }), formData && selectedCategory === "Administration" && cookies.rp_user_data.role === "admin" && /*#__PURE__*/ $eeH7J.createElement((0, $e12add26e07ddef3$export$2e2bcd8739ae039), {
        siteId: formData.siteId,
        onDataChange: onFormDataChange,
        data: formData,
        allTemplateColors: allTemplateColors,
        templateSiteCategories: templateSiteCategories
    }), formData && selectedCategory === "Domain" && /*#__PURE__*/ $eeH7J.createElement((0, $3649fa2aef7877ab$export$2e2bcd8739ae039), {
        siteId: formData.siteId,
        userData: cookies.rp_user_data,
        onDataChange: onFormDataChange,
        subDomain: formData.subDomain,
        subDomainErrorMessage: formData.subDomainErrorMessage,
        selectedDomainTab: selectedDomainTab,
        onTabChange: (tab)=>{
            setSelectedDomainTab(tab);
        },
        isPublished: formData.isPublished,
        setIsLoading: setIsLoading,
        setIsCheckingSSL: setIsCheckingSSL,
        checkPublishStatus: checkPublishStatus
    }), formData && selectedCategory === "Custom Code" && /*#__PURE__*/ $eeH7J.createElement((0, $8b2770f625cf1793$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        head_customHtmlCode: formData.head_customHtmlCode,
        body_customHtmlCode: formData.body_customHtmlCode
    }), formData && selectedCategory === "SEO" && /*#__PURE__*/ $eeH7J.createElement((0, $178a0e1891e0d643$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        primaryLanguage: formData.primaryLanguage,
        redirects: formData.redirects ?? [],
        setSaveDisabled: setSaveDisabled
    }), formData && selectedCategory === "Widgets" && /*#__PURE__*/ $eeH7J.createElement((0, $5273f505000f263e$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        cookies: formData.cookies
    }), selectedCategory === "Contributors" && (formData && cookies.rp_user_data?.userId && formData.siteOwnerUserId === cookies.rp_user_data.userId ? /*#__PURE__*/ $eeH7J.createElement((0, $da24085d6632689d$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        addOnUsers: formData.addOnUsers,
        onAddOnUsersAdd: onAddOnUsersAdd,
        onAddOnUsersRemove: onAddOnUsersRemove
    }) : !formData ? /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-center items-center py-16"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        size: 32,
        sx: {
            color: "#243060"
        }
    })) : null), selectedCategory === "Contact Form" && (formData ? /*#__PURE__*/ $eeH7J.createElement((0, $b5c2d083d601c9b9$export$2e2bcd8739ae039), {
        siteId: id
    }) : /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-center items-center py-16"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        size: 32,
        sx: {
            color: "#243060"
        }
    }))), (selectedCategory === "Plans" || selectedCategory === "Billing" || selectedCategory === "Subscriptions") && (formData && cookies.rp_user_data?.userId && formData.siteOwnerUserId === cookies.rp_user_data.userId ? /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, selectedCategory === "Plans" && /*#__PURE__*/ $eeH7J.createElement((0, $2bbfebce2ca648bf$export$2e2bcd8739ae039), null), selectedCategory === "Billing" && /*#__PURE__*/ $eeH7J.createElement((0, $f1879511b722e3f2$export$2e2bcd8739ae039), null), selectedCategory === "Subscriptions" && /*#__PURE__*/ $eeH7J.createElement((0, $4feb50dcb01399e1$export$2e2bcd8739ae039), null)) : !formData ? /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex justify-center items-center py-16"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        size: 32,
        sx: {
            color: "#243060"
        }
    })) : null)), selectedCategory !== "Contributors" && selectedCategory !== "Contact Form" && (selectedCategory !== "Domain" || selectedDomainTab !== "customdomain") && selectedCategory !== "Billing" && selectedCategory !== "Blog" && selectedCategory !== "Plans" && selectedCategory !== "Subscriptions" && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed bottom-0 w-full z-50 flex justify-end px-4 py-2 bg-white-smoke"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "save",
        disabled: saveDisabled,
        className: "min-w-[6rem] px-4 py-1 capitalize",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: onSave
    }, "Save ", siteData.isPublished && " & Publish"))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");



const $8d3a66b9ca618982$var$TermsAndConditions = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("main", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).contentWrapper}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).spacing} mt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).h1}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "RocketPages Terms and Conditions"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Last updated: May 17, 2024")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", null, "Welcome to RocketPages! These terms and conditions govern your use of our Website Builder. By accessing and using RocketPages, you agree to comply with the following terms and conditions. If you do not agree with any part of these terms, please refrain from using RocketPages.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "User Accounts"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "To access certain features of RocketPages, users may be required to create an account. Users are responsible for maintaining the confidentiality of their account credentials and for any activity that occurs under their accounts."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages reserves the right to refuse service, terminate accounts, or remove content at our sole discretion."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "User Roles"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages offers various user roles with differing levels of access and permissions. These roles include but are not limited to contributors, who can create and edit content, and owners, who have full control over site management."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "Account owners are responsible for managing user roles and permissions within RocketPages."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Site Creation and Duplication"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "Users can create and duplicate websites using RocketPages Website Builder."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages does not claim ownership of any content created by users but may use such content for promotional purposes."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Site Publication"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "Users can publish their websites using RocketPages, making them accessible to end-users."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages is not responsible for the content published by users and does not endorse any views expressed therein."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Video Embedding and Social Login"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages allows users to embed videos from Vimeo and YouTube and utilize social login features within their websites."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "By embedding videos or using social login features, users agree to comply with the terms and conditions of Vimeo, YouTube, and any other applicable third-party platforms."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Custom Domain Attachment"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "Users have the option to attach a custom domain to their website on RocketPages.\xa0"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Payment Processing and Subscription"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages offers paid subscription plans for access to premium features. Payment for RocketPages services is handled by Stripe, a third-party payment processor."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "By subscribing to a paid plan, you agree to comply with the terms of service and privacy policy of Stripe."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages does not store or process payment information directly and is not responsible for any issues arising from the use of Stripe's services."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Limitation of Liability"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages shall not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with the use of RocketPages."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages does not guarantee the accuracy, completeness, or reliability of any content or information provided on the platform."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Privacy Policy"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "Your use of RocketPages is subject to our Privacy Policy, which outlines how we collect, use, and disclose your personal information."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Modification of Terms"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "RocketPages reserves the right to modify these terms and conditions at any time without prior notice. Continued use of RocketPages after any such changes shall constitute your consent to such changes."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Governing Law"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "These terms and conditions shall be governed by and construed in accordance with the laws of California, and any disputes relating to these terms and conditions shall be subject to the exclusive jurisdiction of the courts of California."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, " Acceptance of Terms"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "By using RocketPages, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. If you do not agree with any part of these terms and conditions, please refrain from using RocketPages."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("strong", null, "Age Requirements"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($30a2a61f5e92bc64$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("li", null, "By accessing or using this website, you affirm that you are at least 13 years old or the age of majority in your jurisdiction, whichever is greater. If you are under the specified age, you must obtain consent from your parent or guardian before using this website. Please be aware that if you are located in the European Union, you may need to comply with the General Data Protection Regulation (GDPR), which sets the minimum age for consent at 16 in most cases, though individual EU member states may have different age requirements.")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};
var $8d3a66b9ca618982$export$2e2bcd8739ae039 = $8d3a66b9ca618982$var$TermsAndConditions;




const $9a8670a3503f2617$export$3e6dfd2ec8bf3ef9 = (props)=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [cookie, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Terms and conditions"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        skipCheckCookies: true
    }), /*#__PURE__*/ $eeH7J.createElement((0, $8d3a66b9ca618982$export$2e2bcd8739ae039), null));
};



var $26mQo = parcelRequire("26mQo");
var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");
parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");


var $eeH7J = parcelRequire("eeH7J");
const $787bfa227ec29e8c$var$ThemeContext = /*#__PURE__*/ $eeH7J.createContext(null);
$787bfa227ec29e8c$var$ThemeContext.displayName = 'ThemeContext';
var $787bfa227ec29e8c$export$2e2bcd8739ae039 = $787bfa227ec29e8c$var$ThemeContext;



var $eeH7J = parcelRequire("eeH7J");

function $d8729ccf64027e8d$export$2e2bcd8739ae039() {
    const theme = $eeH7J.useContext((0, $787bfa227ec29e8c$export$2e2bcd8739ae039));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useDebugValue(theme);
    return theme;
}


const $1f938f7d856f51eb$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $1f938f7d856f51eb$export$2e2bcd8739ae039 = $1f938f7d856f51eb$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $dRzna = parcelRequire("dRzna");
function $73073a5d05f415b6$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        if (!mergedTheme) console.error([
            'MUI: You should return an object from your theme function, i.e.',
            '<ThemeProvider theme={() => ({})} />'
        ].join('\n'));
        return mergedTheme;
    }
    return (0, $h4XE0.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $73073a5d05f415b6$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $d8729ccf64027e8d$export$2e2bcd8739ae039)();
    if (outerTheme === null && typeof localTheme === 'function') console.error([
        'MUI: You are providing a theme function prop to the ThemeProvider component:',
        '<ThemeProvider theme={outerTheme => outerTheme} />',
        '',
        'However, no outer theme is present.',
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join('\n'));
    const theme = $eeH7J.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $73073a5d05f415b6$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $1f938f7d856f51eb$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $787bfa227ec29e8c$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
$73073a5d05f415b6$var$ThemeProvider.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ]).isRequired
};
$73073a5d05f415b6$var$ThemeProvider.propTypes = (0, $b11fa6e7a8da4552$export$2e2bcd8739ae039)($73073a5d05f415b6$var$ThemeProvider.propTypes);
var $73073a5d05f415b6$export$2e2bcd8739ae039 = $73073a5d05f415b6$var$ThemeProvider;



parcelRequire("1IdKE");
var $kHakb = parcelRequire("kHakb");



var $d9OwS = parcelRequire("d9OwS");
parcelRequire("eeH7J");





var $dRzna = parcelRequire("dRzna");
'use client';
function $4d7d3550730a0a26$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $867cd157dee718e1$export$2e2bcd8739ae039)();
    const id = (0, $cb6186ed251df147$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $27c0fbde361ccc36$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $00048fed6c8dfb5f$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $dRzna = parcelRequire("dRzna");
'use client';
const $078d9d2a81547c1d$var$EMPTY_THEME = {};
function $078d9d2a81547c1d$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $eeH7J.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $h4XE0.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $h4XE0.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $h4XE0.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $078d9d2a81547c1d$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $867cd157dee718e1$export$2e2bcd8739ae039)($078d9d2a81547c1d$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $d8729ccf64027e8d$export$2e2bcd8739ae039)() || $078d9d2a81547c1d$var$EMPTY_THEME;
    if (upperTheme === null && typeof localTheme === 'function' || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === 'function') console.error([
        'MUI: You are providing a theme function prop to the ThemeProvider component:',
        '<ThemeProvider theme={outerTheme => outerTheme} />',
        '',
        'However, no outer theme is present.',
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join('\n'));
    const engineTheme = $078d9d2a81547c1d$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $078d9d2a81547c1d$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $4d7d3550730a0a26$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $73073a5d05f415b6$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $dRzna.jsx)((0, $kHakb.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $dRzna.jsx)((0, $24165880ce40ccbd$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $dRzna.jsxs)((0, $d9OwS.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
$078d9d2a81547c1d$var$ThemeProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]).isRequired,
    /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */ themeId: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
};
$078d9d2a81547c1d$var$ThemeProvider.propTypes = (0, $b11fa6e7a8da4552$export$2e2bcd8739ae039)($078d9d2a81547c1d$var$ThemeProvider.propTypes);
var $078d9d2a81547c1d$export$2e2bcd8739ae039 = $078d9d2a81547c1d$var$ThemeProvider;



var $4hHwC = parcelRequire("4hHwC");

var $dRzna = parcelRequire("dRzna");
'use client';
const $c16a9e487aa3ec68$var$_excluded = [
    "theme"
];
function $c16a9e487aa3ec68$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $fbOaB.default)(_ref, $c16a9e487aa3ec68$var$_excluded);
    const scopedTheme = themeInput[0, $4hHwC.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $h4XE0.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $h4XE0.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $078d9d2a81547c1d$export$2e2bcd8739ae039), (0, $h4XE0.default)({}, props, {
        themeId: scopedTheme ? (0, $4hHwC.default) : undefined,
        theme: finalTheme
    }));
}
$c16a9e487aa3ec68$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
    ]).isRequired
};




var $eeH7J = parcelRequire("eeH7J");


var $d1cef9ee2ad489ef$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d1cef9ee2ad489ef$var$CookiesProvider = /** @class */ function(_super) {
    $d1cef9ee2ad489ef$var$__extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) _this.cookies = props.cookies;
        else _this.cookies = new (0, $145dbbcf71e58b86$export$2e2bcd8739ae039)();
        return _this;
    }
    CookiesProvider.prototype.render = function() {
        return $eeH7J.createElement((0, $ee5eb3b2ac845186$export$2881499e37b75b9a), {
            value: this.cookies
        }, this.props.children);
    };
    return CookiesProvider;
}($eeH7J.Component);
var $d1cef9ee2ad489ef$export$2e2bcd8739ae039 = $d1cef9ee2ad489ef$var$CookiesProvider;






var $eeH7J = parcelRequire("eeH7J");









const $a49b92b51f5ef152$var$NotFoundPage = ()=>{
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const [cookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    function useQuery() {
        const { search: search } = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useMemo(()=>new URLSearchParams(search), [
            search
        ]);
    }
    let query = useQuery();
    let l_msgType = query.get("msgType");
    let actionInfos;
    if (l_msgType === "SiteNotFound") actionInfos = {
        message: "Oops! This site doesn't exist. Go back to the homepage to explore.",
        actionButtomText: "Back to homepage",
        actionButtonUrl: "/dashboard"
    };
    else if (l_msgType === "SiteNotAuthorizedToAccess" && cookie.rp_user_data) actionInfos = {
        message: "Access Denied. Check your dashboard for your websites.",
        actionButtomText: "Go to Dashboard",
        actionButtonUrl: "/dashboard"
    };
    else if (l_msgType === "SiteNotAuthorizedToAccess" && !cookie.rp_user_data) actionInfos = {
        message: "Login Required. Log in or sign up to access this page.",
        actionButtomText: "Log In or Sign Up",
        actionButtonUrl: "/login"
    };
    else if (l_msgType === "UnAuthorizedUser") actionInfos = {
        message: "Private Content. Log in or sign up to access this page.",
        actionButtomText: "Log In or Sign Up",
        actionButtonUrl: "/login"
    };
    else if (l_msgType === "UnAuthorizedAdmin") actionInfos = {
        message: "Unauthorised access. Check your dashboard for your websites.",
        actionButtomText: "Go to Dashboard",
        actionButtonUrl: "/dashboard"
    };
    else actionInfos = {
        message: "Oops! This page doesn't exist. Go back to the homepage to explore.",
        actionButtomText: "Back to homepage",
        actionButtonUrl: "/dashboard"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("title", null, "RocketPages - Choose Template"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        skipCheckCookies: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "fixed w-full h-screen flex justify-center items-center text-center page404"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-center flex-col bg-white w-full -mt-12 px-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: "m-0 text-catelina-blue tracking-widest"
    }, "404"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        className: "text-catelina-blue mt-1 text-lg"
    }, actionInfos.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        className: "mt-0 bg-transparent hover:bg-catelina-blue text-catelina-blue font-medium py-2 px-4 border border-catelina-blue hover:border-catelina-blue hover:text-white rounded",
        onClick: ()=>{
            navigate(actionInfos.actionButtonUrl);
        }
    }, actionInfos.actionButtomText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "absolute bottom-0 w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a33a1bed5691b2ee$export$2e2bcd8739ae039), null)));
};
var $a49b92b51f5ef152$export$2e2bcd8739ae039 = $a49b92b51f5ef152$var$NotFoundPage;






var $eeH7J = parcelRequire("eeH7J");














var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");


var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");


var $lNnGW = parcelRequire("lNnGW");

var $h4XE0 = parcelRequire("h4XE0");
parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");
parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $0abb6fd6a3e0905a$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $484d095bc07f74a0$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $dRzna = parcelRequire("dRzna");
'use client';
const $c556a7a15d2e9d49$var$RadioButtonIconRoot = (0, $hikmr.default)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $lzlXq.default)
})({
    position: 'relative',
    display: 'flex'
});
const $c556a7a15d2e9d49$var$RadioButtonIconBackground = (0, $hikmr.default)((0, $0abb6fd6a3e0905a$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $c556a7a15d2e9d49$var$RadioButtonIconDot = (0, $hikmr.default)((0, $484d095bc07f74a0$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $c556a7a15d2e9d49$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $h4XE0.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $dRzna.jsxs)($c556a7a15d2e9d49$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $dRzna.jsx)($c556a7a15d2e9d49$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $dRzna.jsx)($c556a7a15d2e9d49$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
$c556a7a15d2e9d49$var$RadioButtonIcon.propTypes = {
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */ fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'small',
        'medium'
    ])
};
var $c556a7a15d2e9d49$export$2e2bcd8739ae039 = $c556a7a15d2e9d49$var$RadioButtonIcon;



var $4A7Fh = parcelRequire("4A7Fh");

var $ce998d8e0e913f63$export$2e2bcd8739ae039 = (0, $3cba5361c5650826$export$2e2bcd8739ae039);



var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
/**
 * @ignore - internal component.
 */ const $8f8301fec4971698$var$RadioGroupContext = /*#__PURE__*/ $eeH7J.createContext(undefined);
$8f8301fec4971698$var$RadioGroupContext.displayName = 'RadioGroupContext';
var $8f8301fec4971698$export$2e2bcd8739ae039 = $8f8301fec4971698$var$RadioGroupContext;


'use client';
function $a4e4b531674a9f04$export$2e2bcd8739ae039() {
    return $eeH7J.useContext((0, $8f8301fec4971698$export$2e2bcd8739ae039));
}



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $f34519938ad8a461$export$192f7b2363c77155(slot) {
    return (0, $aBqGi.default)('MuiRadio', slot);
}
const $f34519938ad8a461$var$radioClasses = (0, $cDqLM.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $f34519938ad8a461$export$2e2bcd8739ae039 = $f34519938ad8a461$var$radioClasses;



var $hikmr = parcelRequire("hikmr");
var $lzlXq = parcelRequire("lzlXq");

var $dRzna = parcelRequire("dRzna");
'use client';
const $befcecc4238c4e1a$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $befcecc4238c4e1a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4A7Fh.default)(color)}`,
            size !== 'medium' && `size${(0, $4A7Fh.default)(size)}`
        ]
    };
    return (0, $h4XE0.default)({}, classes, (0, $doIAf.default)(slots, (0, $f34519938ad8a461$export$192f7b2363c77155), classes));
};
const $befcecc4238c4e1a$var$RadioRoot = (0, $hikmr.default)((0, $2e099faf6f4f0cd0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $lzlXq.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $4A7Fh.default)(ownerState.size)}`],
            styles[`color${(0, $4A7Fh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $5YtKS.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $f34519938ad8a461$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $f34519938ad8a461$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $befcecc4238c4e1a$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $befcecc4238c4e1a$var$defaultCheckedIcon = /*#__PURE__*/ (0, $dRzna.jsx)((0, $c556a7a15d2e9d49$export$2e2bcd8739ae039), {
    checked: true
});
const $befcecc4238c4e1a$var$defaultIcon = /*#__PURE__*/ (0, $dRzna.jsx)((0, $c556a7a15d2e9d49$export$2e2bcd8739ae039), {});
const $befcecc4238c4e1a$var$Radio = /*#__PURE__*/ $eeH7J.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $befcecc4238c4e1a$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $befcecc4238c4e1a$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className } = props, other = (0, $fbOaB.default)(props, $befcecc4238c4e1a$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $befcecc4238c4e1a$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $a4e4b531674a9f04$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $ce998d8e0e913f63$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $befcecc4238c4e1a$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $dRzna.jsx)($befcecc4238c4e1a$var$RadioRoot, (0, $h4XE0.default)({
        type: "radio",
        icon: /*#__PURE__*/ $eeH7J.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $befcecc4238c4e1a$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $eeH7J.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $befcecc4238c4e1a$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $er6YD.default)(classes.root, className)
    }, other));
});
$befcecc4238c4e1a$var$Radio.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5da2d8f3003410bd$export$2e2bcd8739ae039),
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
var $befcecc4238c4e1a$export$2e2bcd8739ae039 = $befcecc4238c4e1a$var$Radio;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $d966b39d6f3b318b$export$d72d4cbdc30b331f(slot) {
    return (0, $aBqGi.default)('MuiFormGroup', slot);
}
const $d966b39d6f3b318b$var$formGroupClasses = (0, $cDqLM.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $d966b39d6f3b318b$export$2e2bcd8739ae039 = $d966b39d6f3b318b$var$formGroupClasses;





var $dRzna = parcelRequire("dRzna");
'use client';
const $0c1de4c13e34cbf8$var$_excluded = [
    "className",
    "row"
];
const $0c1de4c13e34cbf8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $d966b39d6f3b318b$export$d72d4cbdc30b331f), classes);
};
const $0c1de4c13e34cbf8$var$FormGroupRoot = (0, $hikmr.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $0c1de4c13e34cbf8$var$FormGroup = /*#__PURE__*/ $eeH7J.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $fbOaB.default)(props, $0c1de4c13e34cbf8$var$_excluded);
    const muiFormControl = (0, $09caf452de208040$export$2e2bcd8739ae039)();
    const fcs = (0, $e521f0af82ff26b4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $h4XE0.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $0c1de4c13e34cbf8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($0c1de4c13e34cbf8$var$FormGroupRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$0c1de4c13e34cbf8$var$FormGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Display group of elements in a compact row.
   * @default false
   */ row: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $0c1de4c13e34cbf8$export$2e2bcd8739ae039 = $0c1de4c13e34cbf8$var$FormGroup;



var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $deb9c69aae25c2b8$export$c4cff3a43f7cabb6(slot) {
    return (0, $aBqGi.default)('MuiRadioGroup', slot);
}
const $deb9c69aae25c2b8$var$radioGroupClasses = (0, $cDqLM.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $deb9c69aae25c2b8$export$2e2bcd8739ae039 = $deb9c69aae25c2b8$var$radioGroupClasses;






'use client';
var $06cd62dabbf5901f$export$2e2bcd8739ae039 = (0, $cb6186ed251df147$export$2e2bcd8739ae039);



var $dRzna = parcelRequire("dRzna");
'use client';
const $662382d0a707876b$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $662382d0a707876b$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $deb9c69aae25c2b8$export$c4cff3a43f7cabb6), classes);
};
const $662382d0a707876b$var$RadioGroup = /*#__PURE__*/ $eeH7J.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $fbOaB.default)(props, $662382d0a707876b$var$_excluded);
    const rootRef = $eeH7J.useRef(null);
    const classes = $662382d0a707876b$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $7a2443d826ebcf5f$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $eeH7J.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $9d2e4ebd8f7a919e$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $06cd62dabbf5901f$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $eeH7J.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)((0, $8f8301fec4971698$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $dRzna.jsx)((0, $0c1de4c13e34cbf8$export$2e2bcd8739ae039), (0, $h4XE0.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $er6YD.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
$662382d0a707876b$var$RadioGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any
};
var $662382d0a707876b$export$2e2bcd8739ae039 = $662382d0a707876b$var$RadioGroup;



var $eeH7J = parcelRequire("eeH7J");


const $50f40506a44c2203$var$ConfigIntegrations = ()=>{
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    // --- MCP Connected Apps state ---
    const [mcpApps, setMcpApps] = $eeH7J.useState([]);
    const [mcpRevokeRes, setMcpRevokeRes] = $eeH7J.useState({
        message: "",
        isVisible: false,
        isError: false
    });
    // --- Permanent API Keys state ---
    const [apiKeys, setApiKeys] = $eeH7J.useState([]);
    const [newApiKey, setNewApiKey] = $eeH7J.useState("");
    const [apiKeyLabel, setApiKeyLabel] = $eeH7J.useState("");
    const [apiKeyLoading, setApiKeyLoading] = $eeH7J.useState(false);
    const [apiKeyCopied, setApiKeyCopied] = $eeH7J.useState(false);
    const [apiKeyRes, setApiKeyRes] = $eeH7J.useState({
        message: "",
        isVisible: false,
        isError: false
    });
    // --- Site scoping state ---
    const [siteMode, setSiteMode] = $eeH7J.useState("all");
    const [userSites, setUserSites] = $eeH7J.useState([]);
    const [selectedSiteIds, setSelectedSiteIds] = $eeH7J.useState(new Set());
    const [showCreateForm, setShowCreateForm] = $eeH7J.useState(false);
    async function copyToClipboard(text, setCopied) {
        try {
            await navigator.clipboard.writeText(text);
        } catch  {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
        }
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    }
    async function fetchMcpApps() {
        try {
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get("/api/mcp-connected-apps");
            setMcpApps(response.data.apps || []);
        } catch (err) {
            console.log("fetchMcpApps error", err);
        }
    }
    async function revokeMcpApp(clientId) {
        try {
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/revoke-mcp-app", {
                clientId: clientId
            });
            setMcpRevokeRes({
                message: response.data.message,
                isVisible: true,
                isError: false
            });
            fetchMcpApps();
        } catch (err) {
            setMcpRevokeRes({
                message: err.response?.data?.message || "Failed to revoke",
                isVisible: true,
                isError: true
            });
        } finally{
            setTimeout(()=>{
                setMcpRevokeRes((old)=>({
                        ...old,
                        isVisible: false
                    }));
            }, 5000);
        }
    }
    // --- Permanent API Key functions ---
    async function fetchApiKeys() {
        try {
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get("/oauth/api-keys");
            setApiKeys(response.data.api_keys || []);
        } catch (err) {
            console.log("fetchApiKeys error", err);
        }
    }
    async function fetchUserSites() {
        try {
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get("/oauth/api-key-permissions");
            const sites = (response.data.sites || []).map((s)=>({
                    siteId: s.siteId,
                    siteName: s.siteName
                }));
            setUserSites(sites);
        } catch (err) {
            console.log("fetchUserSites error", err);
        }
    }
    function resetForm() {
        setApiKeyLabel("");
        setSiteMode("all");
        setSelectedSiteIds(new Set());
    }
    function openCreateForm() {
        resetForm();
        setShowCreateForm(true);
        fetchUserSites();
    }
    function toggleSiteSelection(siteId) {
        setSelectedSiteIds((prev)=>{
            const next = new Set(prev);
            if (next.has(siteId)) next.delete(siteId);
            else next.add(siteId);
            return next;
        });
    }
    async function createApiKey() {
        if (!apiKeyLabel.trim()) {
            setApiKeyRes({
                message: "Key label is required.",
                isVisible: true,
                isError: true
            });
            setTimeout(()=>setApiKeyRes((old)=>({
                        ...old,
                        isVisible: false
                    })), 5000);
            return;
        }
        if (siteMode === "specific" && selectedSiteIds.size === 0) {
            setApiKeyRes({
                message: "Please select at least one site.",
                isVisible: true,
                isError: true
            });
            setTimeout(()=>setApiKeyRes((old)=>({
                        ...old,
                        isVisible: false
                    })), 5000);
            return;
        }
        setApiKeyLoading(true);
        try {
            const sites = siteMode === "all" ? [
                "*"
            ] : Array.from(selectedSiteIds);
            const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/oauth/api-keys", {
                label: apiKeyLabel.trim(),
                sites: sites
            });
            setNewApiKey(response.data.api_key || "");
            setShowCreateForm(false);
            resetForm();
            setApiKeyRes({
                message: "API key created. Copy it now \u2014 it won't be shown again.",
                isVisible: true,
                isError: false
            });
            fetchApiKeys();
        } catch (err) {
            const msg = err.response?.data?.error_description || err.response?.data?.message || "Failed to create API key";
            setApiKeyRes({
                message: msg,
                isVisible: true,
                isError: true
            });
        } finally{
            setApiKeyLoading(false);
            setTimeout(()=>setApiKeyRes((old)=>({
                        ...old,
                        isVisible: false
                    })), 10000);
        }
    }
    async function revokeApiKey(keyPrefix) {
        try {
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).delete(`/oauth/api-keys/${keyPrefix}`);
            setApiKeyRes({
                message: "API key revoked successfully.",
                isVisible: true,
                isError: false
            });
            fetchApiKeys();
            if (newApiKey.startsWith(keyPrefix)) setNewApiKey("");
        } catch (err) {
            const msg = err.response?.data?.error_description || err.response?.data?.message || "Failed to revoke API key";
            setApiKeyRes({
                message: msg,
                isVisible: true,
                isError: true
            });
        } finally{
            setTimeout(()=>setApiKeyRes((old)=>({
                        ...old,
                        isVisible: false
                    })), 5000);
        }
    }
    $eeH7J.useEffect(()=>{
        fetchMcpApps();
        fetchApiKeys();
    }, []);
    return /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex flex-col text-black h-screen flex-1 md:mr-4 mt-2.5 md:mt-0"
    }, /*#__PURE__*/ $eeH7J.createElement("h1", {
        style: {
            color: "#243060",
            fontSize: "24px",
            fontWeight: 700,
            marginTop: 0,
            marginBottom: "24px"
        }
    }, "Connected Apps & API Keys"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "pt-5 border-t border-slate-300 mb-8"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        style: {
            color: "#243060",
            marginBottom: "12px",
            display: "flex"
        }
    }, "Permanent API Keys"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-normal text-sm mb-4",
        style: {
            color: "#3B3B3B"
        }
    }, "Create API keys to access the RocketPages API from your apps, scripts, and integrations. Keys never expire and can be revoked whenever needed."), newApiKey && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-3"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        className: "text-sm font-semibold",
        style: {
            color: "#3B3B3B"
        }
    }, "New API Key"), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex items-center gap-2 p-3 bg-gray-100 rounded border border-gray-300 mt-1"
    }, /*#__PURE__*/ $eeH7J.createElement("code", {
        className: "flex-1 text-sm break-all",
        style: {
            color: "#243060"
        }
    }, newApiKey), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        size: "small",
        onClick: ()=>copyToClipboard(newApiKey, setApiKeyCopied),
        sx: {
            minWidth: "auto",
            padding: "4px 8px",
            color: "#243060",
            textTransform: "none"
        },
        startIcon: /*#__PURE__*/ $eeH7J.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d660f2eec4f22fb9$exports))), {
            fontSize: "small"
        })
    }, apiKeyCopied ? "Copied!" : "Copy"))), apiKeyRes.isVisible && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-3"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: `text-sm ${apiKeyRes.isError ? "text-red-500" : "text-green-500"}`
    }, apiKeyRes.message)), !showCreateForm ? /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex items-center gap-2 mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        onClick: openCreateForm,
        sx: {
            backgroundColor: "#243060",
            border: "1px solid",
            borderColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#1a2347",
                color: "#fff"
            }
        }
    }, "Create API Key")) : /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-4 p-4 border border-gray-300 rounded-lg bg-gray-50"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        className: "text-sm font-semibold block mb-1",
        style: {
            color: "#3B3B3B"
        }
    }, "Key Label ", /*#__PURE__*/ $eeH7J.createElement("span", {
        style: {
            color: "red"
        }
    }, "*")), /*#__PURE__*/ $eeH7J.createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        size: "small",
        placeholder: "e.g. My CI/CD key",
        value: apiKeyLabel,
        onChange: (e)=>setApiKeyLabel(e.target.value.slice(0, 64)),
        inputProps: {
            maxLength: 64
        },
        sx: {
            width: "100%",
            maxWidth: 400,
            '& input::placeholder': {
                fontSize: '0.75rem'
            }
        }
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        className: "text-sm font-semibold block mb-1",
        style: {
            color: "#3B3B3B"
        }
    }, "Site Access"), /*#__PURE__*/ $eeH7J.createElement((0, $662382d0a707876b$export$2e2bcd8739ae039), {
        value: siteMode,
        onChange: (e)=>setSiteMode(e.target.value)
    }, /*#__PURE__*/ $eeH7J.createElement((0, $96c468de08a5d3c2$export$2e2bcd8739ae039), {
        value: "all",
        control: /*#__PURE__*/ $eeH7J.createElement((0, $befcecc4238c4e1a$export$2e2bcd8739ae039), {
            size: "small",
            sx: {
                color: "#243060",
                "&.Mui-checked": {
                    color: "#243060"
                }
            }
        }),
        label: /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "text-sm"
        }, "All sites")
    }), /*#__PURE__*/ $eeH7J.createElement((0, $96c468de08a5d3c2$export$2e2bcd8739ae039), {
        value: "specific",
        control: /*#__PURE__*/ $eeH7J.createElement((0, $befcecc4238c4e1a$export$2e2bcd8739ae039), {
            size: "small",
            sx: {
                color: "#243060",
                "&.Mui-checked": {
                    color: "#243060"
                }
            }
        }),
        label: /*#__PURE__*/ $eeH7J.createElement("span", {
            className: "text-sm"
        }, "Specific sites")
    })), siteMode === "specific" && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "ml-7 mt-1 max-h-40 overflow-y-auto border border-gray-200 rounded p-2 bg-white"
    }, userSites.length === 0 ? /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-xs",
        style: {
            color: "#6B7280"
        }
    }, "Loading sites...") : userSites.map((site)=>/*#__PURE__*/ $eeH7J.createElement((0, $96c468de08a5d3c2$export$2e2bcd8739ae039), {
            key: site.siteId,
            control: /*#__PURE__*/ $eeH7J.createElement((0, $46e23713790889f2$export$2e2bcd8739ae039), {
                size: "small",
                checked: selectedSiteIds.has(site.siteId),
                onChange: ()=>toggleSiteSelection(site.siteId),
                sx: {
                    color: "#243060",
                    "&.Mui-checked": {
                        color: "#243060"
                    },
                    py: 0.25
                }
            }),
            label: /*#__PURE__*/ $eeH7J.createElement("span", {
                className: "text-sm"
            }, site.siteName),
            sx: {
                display: "flex",
                mb: 0
            }
        })))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex items-center gap-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        disabled: apiKeyLoading,
        onClick: createApiKey,
        sx: {
            backgroundColor: "#243060",
            border: "1px solid",
            borderColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#1a2347",
                color: "#fff"
            }
        }
    }, apiKeyLoading ? "Creating..." : "Create Key"), /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        variant: "outlined",
        size: "small",
        onClick: ()=>{
            setShowCreateForm(false);
            resetForm();
        },
        sx: {
            borderColor: "#243060",
            color: "#243060",
            textTransform: "none"
        }
    }, "Cancel"))), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-xs mb-3",
        style: {
            color: "#6B7280"
        }
    }, apiKeys.length, " ", apiKeys.length === 1 ? "key" : "keys", " created"), apiKeys.length > 0 && apiKeys.map((key)=>/*#__PURE__*/ $eeH7J.createElement("div", {
            key: key.key_prefix,
            className: "flex flex-col items-start justify-between sm:flex-row sm:items-center mb-4"
        }, /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ $eeH7J.createElement("label", {
            style: {
                fontWeight: 600,
                color: "#3B3B3B"
            }
        }, key.key_prefix, "...", key.label && /*#__PURE__*/ $eeH7J.createElement("span", {
            style: {
                fontWeight: 400,
                marginLeft: 8,
                color: "#6B7280"
            }
        }, key.label)), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "mb-0 font-normal text-xs mt-1",
            style: {
                color: "#6B7280"
            }
        }, "Sites: ", key.sites ? key.sites.includes("*") ? "All sites" : `${key.sites.length} site${key.sites.length !== 1 ? "s" : ""}` : "All sites"), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "mb-0 font-normal text-xs mt-0.5",
            style: {
                color: "#6B7280"
            }
        }, "Created ", new Date(key.created_at).toLocaleDateString(), " ", key.last_used_at && /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, "\xb7 Last used", " ", new Date(key.last_used_at).toLocaleDateString()))), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex ml-0 mt-2 sm:ml-0 sm:mt-0"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            className: "px-4 py-2",
            variant: "contained",
            size: "small",
            onClick: ()=>revokeApiKey(key.key_prefix),
            sx: {
                backgroundColor: "#fff",
                border: "1px solid",
                borderColor: "#ff0000",
                color: "#ff0000",
                textTransform: "none",
                "&:hover": {
                    backgroundColor: "#ff0000",
                    color: "#fff"
                }
            }
        }, "Revoke")))), apiKeys.length === 0 && /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "text-sm",
        style: {
            color: "#6B7280"
        }
    }, "No API keys created yet.")), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "pt-5 border-t border-slate-300 mcp-connected-apps"
    }, /*#__PURE__*/ $eeH7J.createElement("label", {
        style: {
            color: "#243060",
            marginBottom: "12px",
            display: "flex"
        }
    }, "Connected Apps"), /*#__PURE__*/ $eeH7J.createElement("p", {
        className: "font-normal text-sm mb-4",
        style: {
            color: "#3B3B3B"
        }
    }, mcpApps.length === 0 ? "No apps or tools are currently connected to your site." : "MCP tools and APIs currently connected to your site. You can revoke access at any time."), mcpRevokeRes.isVisible && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "mb-3"
    }, /*#__PURE__*/ $eeH7J.createElement("span", {
        className: `text-sm ${mcpRevokeRes.isError ? "text-red-500" : "text-green-500"}`
    }, mcpRevokeRes.message)), mcpApps.length > 0 && mcpApps.map((app)=>/*#__PURE__*/ $eeH7J.createElement("div", {
            key: app.clientId,
            className: "flex flex-col items-start justify-between sm:flex-row sm:items-center mb-4"
        }, /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ $eeH7J.createElement("label", {
            style: {
                fontWeight: 600,
                color: "#3B3B3B"
            }
        }, app.clientName), /*#__PURE__*/ $eeH7J.createElement("p", {
            style: {
                color: "#3B3B3B"
            },
            className: "mb-0 font-normal text-sm"
        }, "Grants full access to RocketPages APIs"), /*#__PURE__*/ $eeH7J.createElement("p", {
            className: "mb-0 font-normal text-sm mt-1",
            style: {
                color: "#6B7280"
            }
        }, "Connected on", " ", new Date(app.connectedAt).toLocaleDateString(), " ", "at ", new Date(app.connectedAt).toLocaleTimeString())), /*#__PURE__*/ $eeH7J.createElement("div", {
            className: "flex ml-0 mt-2 sm:ml-0 sm:mt-0"
        }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
            className: "px-4 py-2",
            variant: "contained",
            size: "small",
            onClick: ()=>revokeMcpApp(app.clientId),
            sx: {
                backgroundColor: "#fff",
                border: "1px solid",
                borderColor: "#ff0000",
                color: "#ff0000",
                textTransform: "none",
                "&:hover": {
                    backgroundColor: "#ff0000",
                    color: "#fff"
                }
            }
        }, "Revoke"))))));
};
var $50f40506a44c2203$export$2e2bcd8739ae039 = $50f40506a44c2203$var$ConfigIntegrations;


var $898e5931a7911559$exports = {};
$898e5931a7911559$exports = new URL("bi_eye.6d8dacc1.svg", import.meta.url).toString();


var $ae58b22cee3e686a$exports = {};
$ae58b22cee3e686a$exports = new URL("open_eye.688ef7e6.svg", import.meta.url).toString();




const $7a98e731e8db0cac$var$accountCategories = [
    "Account Settings",
    "API & MCP Access"
];
const $7a98e731e8db0cac$var$categoryToPath = {
    "Account Settings": "/account/account-settings",
    "API & MCP Access": "/account/api-mcp-access"
};
const $7a98e731e8db0cac$var$pathToCategory = {
    "/account/account-settings": "Account Settings",
    "/account/api-mcp-access": "API & MCP Access"
};
const $7a98e731e8db0cac$var$MIN_PASSWORD_LENGTH = 8;
const $7a98e731e8db0cac$var$MAX_PASSWORD_LENGTH = 72;


const $7a98e731e8db0cac$var$AccountSetting = ()=>{
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const [updatePasswordRes, setUpdatePasswordRes] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        message: "",
        isVisible: false,
        isError: false
    });
    const [googleLinkRes, setGoogleLinkRes] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        message: "",
        isVisible: false,
        isError: false
    });
    const [linkedInLinkRes, setLinkedInLinkRes] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        message: "",
        isVisible: false,
        isError: false
    });
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [cookies, setCookie, removeCookie] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data",
        "rp_user_id"
    ]);
    const [accountSettingData, setAccountSettingData] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({});
    (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState([]);
    const styleEnabled = {
        backgroundColor: "#fff",
        border: "1px solid",
        borderColor: "#243060",
        color: "#243060",
        textTransform: "none",
        "&:hover": {
            backgroundColor: "#243060",
            color: "#fff"
        }
    };
    const styleDisabled = {
        backgroundColor: "#fff",
        border: "1px solid",
        borderColor: "#ff0000",
        color: "#ff0000",
        textTransform: "none",
        "&:hover": {
            backgroundColor: "#ff0000",
            color: "#fff"
        }
    };
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        currentPassword: "",
        password: "",
        rePassword: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        currentPassword: "",
        password: "",
        rePassword: ""
    });
    const [toggleAttributes, setToggleAttributes] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState({
        currentPassword: "password",
        password: "password",
        rePassword: "password"
    });
    const selectedCategory = $7a98e731e8db0cac$var$pathToCategory[location.pathname] || "Account Settings";
    const handleCategoryChange = (category)=>{
        const path = $7a98e731e8db0cac$var$categoryToPath[category];
        if (path) navigate(path);
    };
    async function fetchAccountSettings(email) {
        let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/account-settings?email=${email}`);
        let prepData = {};
        response.data.linkedAccounts && response.data.linkedAccounts.forEach((row)=>{
            if (row.hasGoogleLogin === true || row.googleSource === true) prepData = {
                ...prepData,
                googleSource: true,
                googleSourceEmail: row.email
            };
            if (row.hasLinkedInLogin === true || row.linkedInSource === true) prepData = {
                ...prepData,
                linkedInSource: true,
                linkedInSourceEmail: row.email
            };
            if (row.hasEmailLogin || row.emailSource) prepData = {
                ...prepData,
                emailSource: true,
                emailSourceEmail: row.email
            };
        });
        const data = response.data.data || {};
        // Map sanitized backend field names to frontend field names
        if (data.hasEmailLogin && !prepData.emailSource) prepData.emailSource = true;
        if (data.hasGoogleLogin && !prepData.googleSource) prepData.googleSource = true;
        if (data.hasLinkedInLogin && !prepData.linkedInSource) prepData.linkedInSource = true;
        setAccountSettingData({
            ...data,
            ...prepData
        });
    }
    (0, $eeH7J.useEffect)(()=>{
        fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
    }, []);
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setFormErrors((old)=>{
            return {
                ...old,
                [event.target.id]: ""
            };
        });
    }
    function handleTogglePassword(id) {
        setToggleAttributes((old)=>{
            return {
                ...old,
                [id]: old[id] === "password" ? "text" : "password"
            };
        });
    }
    function validateForm(formData) {
        try {
            setFormErrors({
                currentPassword: "",
                password: "",
                rePassword: ""
            });
            if (formData.currentPassword === "" && accountSettingData.emailSource) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        currentPassword: "Current password can not be empty"
                    };
                });
                return false;
            }
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "New password can not be empty"
                    };
                });
                return false;
            }
            if (formData.rePassword === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Re-password can not be empty"
                    };
                });
                return false;
            }
            if (formData.password.length < $7a98e731e8db0cac$var$MIN_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: `New password must be at least ${$7a98e731e8db0cac$var$MIN_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.password.length > $7a98e731e8db0cac$var$MAX_PASSWORD_LENGTH) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: `New password cannot exceed ${$7a98e731e8db0cac$var$MAX_PASSWORD_LENGTH} characters.`
                    };
                });
                return false;
            }
            if (formData.password !== formData.rePassword) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Re-password does not match password."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    const onUpdatePassword = async ()=>{
        if (validateForm(formData)) try {
            (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/update-account-password", {
                email: cookies.rp_user_data.email,
                currentPassword: formData.currentPassword,
                newPassword: formData.password
            }).then((response)=>{
                setUpdatePasswordRes({
                    message: response.data.message,
                    isVisible: true,
                    isError: false
                });
            }).catch((err)=>{
                setUpdatePasswordRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setUpdatePasswordRes((old)=>{
                    if (!old.isError) setFormData({
                        currentPassword: "",
                        password: "",
                        rePassword: ""
                    });
                    return {
                        ...old
                    };
                });
                setTimeout(()=>{
                    setUpdatePasswordRes((old)=>{
                        if (!old.isError) setFormData({
                            currentPassword: "",
                            password: "",
                            rePassword: ""
                        });
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                    fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
                }, 5000);
            });
        } catch (err) {
            console.log("onUpdatePassword", err);
        }
        else console.log("false", formErrors);
    };
    const handleLogout = ()=>{
        async function logoutUser() {
            try {
                setCookie("rp_user_data", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                setCookie("rp_user_id", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post("/api/logout", {}, {
                    withCredentials: true
                });
            } catch (err) {
                console.log(err);
            }
        }
        logoutUser();
        navigate("/login", {
            state: {
                removeCookies: true
            }
        });
    };
    const { linkedInLogin: linkedInLogin } = (0, $5e832946007203dd$export$798996ac402ec5d0)({
        clientId: "86q0502we7bi54",
        scope: "email profile openid",
        redirectUri: "https://appstage.rocketpages.io/linkedin",
        onSuccess: (code)=>{
            onLoginViaLinkedIn(code);
        },
        onError: (error)=>{
            console.log(error);
        }
    });
    async function onLoginViaLinkedIn(authCode) {
        setIsLoading(true);
        try {
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`api/link-social-login`, {
                userId: cookies.rp_user_data.userId,
                email: cookies.rp_user_data.email,
                socialAccountType: "linkedIn",
                authCode: authCode
            }).then((response)=>{
                setLinkedInLinkRes({
                    message: "Linked Successfully!",
                    isVisible: true,
                    isError: false
                });
                fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
            }).catch((err)=>{
                setLinkedInLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setTimeout(()=>{
                    setLinkedInLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                }, 5000);
            });
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }
    async function unLinkAccount(type) {
        setIsLoading(true);
        try {
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`api/unlink-social-login`, {
                email: type === "google" ? accountSettingData.googleSourceEmail : accountSettingData.linkedInSourceEmail,
                socialAccountType: type
            }).then((response)=>{
                if (response.status === 200) {
                    setCookie("rp_user_data", JSON.stringify(response.data.data), {
                        maxAge: 604800,
                        domain: ".rocketpages.io"
                    });
                    fetchAccountSettings(response.data.data.email);
                }
            }).catch((err)=>{
                if (type === "google") setGoogleLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
                else if (type === "linkedIn") setLinkedInLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setTimeout(()=>{
                    if (type === "google") setGoogleLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                    else if (type === "linkedIn") setLinkedInLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                }, 5000);
            });
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }
    const googleLinkAccount = (0, $0964ed3e14b7bf9e$export$6ca4c5d94f9e170b)({
        hint: cookies.rp_user_data ? cookies.rp_user_data.email : "",
        onSuccess: async (codeResponse)=>{
            const userInfo = await (0, $33a3fff7c402f495$export$2e2bcd8739ae039).get("https://www.googleapis.com/oauth2/v3/userinfo", {
                headers: {
                    Authorization: `Bearer ${codeResponse.access_token}`
                }
            });
            const result = userInfo.data;
            await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`api/link-social-login`, {
                userId: cookies.rp_user_data.userId,
                email: cookies.rp_user_data.email,
                socialAccountType: "google",
                googleRes: result
            }).then((response)=>{
                setGoogleLinkRes({
                    message: "Linked Successfully!",
                    isVisible: true,
                    isError: false
                });
                fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
            }).catch((err)=>{
                setGoogleLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setTimeout(()=>{
                    setGoogleLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                }, 5000);
            });
        },
        onError: (errorResponse)=>console.log(errorResponse)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("title", null, selectedCategory, " | RocketPages IO"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $14e6855d8f24a58e$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "font-body text-base font-medium account-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        title: "Account"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 top-[64px] hidden md:flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "left-navbar-tabs w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, $7a98e731e8db0cac$var$accountCategories.map((cat)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
            className: `px-6 hover:cursor-pointer py-2 left-sidebar-tab-${cat.toLowerCase().replace(/\s+/g, "-")} ${selectedCategory === cat ? "bg-white-smoke text-catelina-blue" : ""}`,
            key: cat,
            onClick: ()=>handleCategoryChange(cat)
        }, cat)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "left-navbar-tab-contents min-h-screen flex w-full my-4 px-4 md:pl-[280px] pb-10 pt-[64px] bg-white-smoke flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex md:hidden py-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $3fb1cc9123a3eb67$export$2e2bcd8739ae039), {
        items: $7a98e731e8db0cac$var$accountCategories,
        handleChange: handleCategoryChange,
        category: selectedCategory
    })), selectedCategory === "Account Settings" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "lg:w-auto xl:w-8/12 m-auto bg-white px-4 lg:px-24 py-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "pb-[30px] sm:pb-8 border-b border-slate-300 email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        style: {
            color: "#243060"
        }
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-between items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: "text-sm sm:text-base break-all font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, cookies.rp_user_data ? cookies.rp_user_data.email : ""))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "py-5 sm:py-8 border-b border-slate-300 password"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        style: {
            color: "#243060"
        }
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-sm font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, "Current password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "relative mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        className: `pw-field appearance-none border ${formErrors.currentPassword !== "" ? "border-red-500" : ""} rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`,
        id: "currentPassword",
        type: toggleAttributes.currentPassword,
        value: formData.currentPassword,
        onChange: handleChange,
        disabled: !accountSettingData.emailSource
    }), formData.currentPassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        tabIndex: -1,
        type: "button",
        id: "toggleCurrentPassword",
        onClick: ()=>handleTogglePassword("currentPassword")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: toggleAttributes.currentPassword === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($898e5931a7911559$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ae58b22cee3e686a$exports))),
        alt: "Show/Hide Password",
        id: "eye-icon"
    })), formErrors.currentPassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `text-red-500 text-xsm`
    }, formErrors.currentPassword))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "grid grid-cols-1 sm:grid-cols-2 gap-0 sm:gap-4 mt-3 mb-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-sm font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, "New password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "relative mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        className: `pw-field pw-position appearance-none border ${formErrors.password !== "" ? "border-red-500" : ""} rounded w-full py-2 px-3 text-gray-700  leading-tight focus:outline-none focus:shadow-outline`,
        id: "password",
        type: toggleAttributes.password,
        placeholder: "",
        value: formData.password,
        onChange: handleChange
    }), formData.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        tabIndex: -1,
        type: "button",
        id: "togglePassword",
        onClick: ()=>handleTogglePassword("password")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: toggleAttributes.password === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($898e5931a7911559$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ae58b22cee3e686a$exports))),
        alt: "Show/Hide Password",
        id: "eye-icon"
    })), formErrors.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `text-red-500 text-xsm leading-3`
    }, formErrors.password))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-sm font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, "Repeat password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "relative mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
        className: `pw-field pw-position appearance-none border ${formErrors.rePassword !== "" ? "border-red-500" : ""} rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`,
        id: "rePassword",
        type: toggleAttributes.rePassword,
        placeholder: "",
        value: formData.rePassword,
        onChange: handleChange
    }), formData.rePassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("button", {
        tabIndex: -1,
        type: "button",
        id: "toggleRePassword",
        onClick: ()=>handleTogglePassword("rePassword")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        src: toggleAttributes.rePassword === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($898e5931a7911559$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ae58b22cee3e686a$exports))),
        alt: "Show/Hide Password",
        id: "eye-icon"
    })), formErrors.rePassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: `text-red-500 text-xsm`
    }, formErrors.rePassword)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "w-full",
        variant: "contained",
        size: "small",
        onClick: onUpdatePassword,
        sx: {
            backgroundColor: "#243060",
            border: "1px solid",
            borderColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        }
    }, "Save"), updatePasswordRes.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `${updatePasswordRes.isError ? "text-red-500" : "text-green-500"}`
    }, updatePasswordRes.message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "pt-5 social-logins"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        style: {
            color: "#243060",
            marginBottom: "24px",
            display: "flex"
        }
    }, "Social logins"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col items-start justify-between sm:flex-row sm:items-center mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        style: {
            marginRight: "16px",
            marginTop: "8px"
        },
        src: (parcelRequire("7KrIt")),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        style: {
            fontWeight: 600,
            color: "#3B3B3B"
        }
    }, "Google account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        style: {
            color: "#3B3B3B"
        },
        className: "mb-0 font-normal"
    }, accountSettingData.googleSource && accountSettingData.googleSource === true ? "Enabled " : "Disabled ", accountSettingData.googleSourceEmail && accountSettingData.googleSourceEmail !== accountSettingData.email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, "(", accountSettingData.googleSourceEmail, ")")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex ml-8 mt-2 sm:ml-0 sm:mt-0"
    }, googleLinkRes.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `text-xsm mx-2 ${googleLinkRes.isError ? "text-red-500" : "text-green-500"}`
    }, googleLinkRes.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "px-4 py-2 w-24",
        variant: "contained",
        size: "small",
        onClick: ()=>{
            if (accountSettingData.googleSource && accountSettingData.googleSource === true) unLinkAccount("google");
            else googleLinkAccount();
        },
        sx: accountSettingData.googleSource && accountSettingData.googleSource === true ? styleDisabled : styleEnabled
    }, accountSettingData.googleSource && accountSettingData.googleSource === true ? "Disable" : "Enable"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col items-start justify-between sm:flex-row sm:items-center mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex items-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
        style: {
            marginRight: "16px",
            marginTop: "8px"
        },
        src: (parcelRequire("2k6GV")),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        style: {
            fontWeight: 600,
            color: "#3B3B3B"
        }
    }, "LinkedIn account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
        style: {
            color: "#3B3B3B"
        },
        className: "mb-0 font-normal"
    }, accountSettingData.linkedInSource && accountSettingData.linkedInSource === true ? "Enabled " : "Disabled ", accountSettingData.linkedInSourceEmail && accountSettingData.linkedInSourceEmail !== accountSettingData.email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", null, "(", accountSettingData.linkedInSourceEmail, ")")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex ml-8 mt-2 sm:ml-0 sm:mt-0"
    }, linkedInLinkRes.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        className: `text-xsm mx-2 ${linkedInLinkRes.isError ? "text-red-500" : "text-green-500"}`
    }, linkedInLinkRes.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "px-4 py-2 w-24",
        variant: "contained",
        size: "small",
        onClick: ()=>{
            if (accountSettingData.linkedInSource && accountSettingData.linkedInSource === true) unLinkAccount("linkedIn");
            else linkedInLogin();
        },
        sx: accountSettingData.linkedInSource && accountSettingData.linkedInSource === true ? styleDisabled : styleEnabled
    }, accountSettingData.linkedInSource && accountSettingData.linkedInSource === true ? "Disable" : "Enable"))))), selectedCategory === "API & MCP Access" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $50f40506a44c2203$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};
var $7a98e731e8db0cac$export$2e2bcd8739ae039 = $7a98e731e8db0cac$var$AccountSetting;







var $eeH7J = parcelRequire("eeH7J");





var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");


var $4A7Fh = parcelRequire("4A7Fh");




var $lNnGW = parcelRequire("lNnGW");

var $hikmr = parcelRequire("hikmr");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $7f2a31b088b5bdde$export$2177af0aa15c34c2(slot) {
    return (0, $aBqGi.default)('MuiDialog', slot);
}
const $7f2a31b088b5bdde$var$dialogClasses = (0, $cDqLM.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $7f2a31b088b5bdde$export$2e2bcd8739ae039 = $7f2a31b088b5bdde$var$dialogClasses;



var $eeH7J = parcelRequire("eeH7J");
const $0012b478d39638cf$var$DialogContext = /*#__PURE__*/ $eeH7J.createContext({});
$0012b478d39638cf$var$DialogContext.displayName = 'DialogContext';
var $0012b478d39638cf$export$2e2bcd8739ae039 = $0012b478d39638cf$var$DialogContext;





var $dRzna = parcelRequire("dRzna");
'use client';
const $f1516034835581bb$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $f1516034835581bb$var$DialogBackdrop = (0, $hikmr.default)((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $f1516034835581bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $4A7Fh.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $4A7Fh.default)(scroll)}`,
            `paperWidth${(0, $4A7Fh.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $7f2a31b088b5bdde$export$2177af0aa15c34c2), classes);
};
const $f1516034835581bb$var$DialogRoot = (0, $hikmr.default)((0, $12701cbbecd35d9f$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $f1516034835581bb$var$DialogContainer = (0, $hikmr.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $4A7Fh.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $f1516034835581bb$var$DialogPaper = (0, $hikmr.default)((0, $d3bbaaf68436ce97$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $4A7Fh.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $4A7Fh.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $7f2a31b088b5bdde$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $7f2a31b088b5bdde$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $7f2a31b088b5bdde$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $f1516034835581bb$var$Dialog = /*#__PURE__*/ $eeH7J.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $c7b8a7ef63736600$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $d3bbaaf68436ce97$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $cc46c16f051631ac$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $fbOaB.default)(props, $f1516034835581bb$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $f1516034835581bb$var$useUtilityClasses(ownerState);
    const backdropClick = $eeH7J.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $cb6186ed251df147$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $eeH7J.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $dRzna.jsx)($f1516034835581bb$var$DialogRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $f1516034835581bb$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $h4XE0.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)(TransitionComponent, (0, $h4XE0.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $dRzna.jsx)($f1516034835581bb$var$DialogContainer, {
                className: (0, $er6YD.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $dRzna.jsx)($f1516034835581bb$var$DialogPaper, (0, $h4XE0.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $er6YD.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $dRzna.jsx)((0, $0012b478d39638cf$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
$f1516034835581bb$var$Dialog.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The id(s) of the element(s) that describe the dialog.
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The id(s) of the element(s) that label the dialog.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * @ignore
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Dialog children, usually the included sub-components.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the dialog is full-screen.
   * @default false
   */ fullScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */ maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            false
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool.isRequired,
    /**
   * The component used to render the body of the dialog.
   * @default Paper
   */ PaperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */ scroll: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'body',
        'paper'
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
var $f1516034835581bb$export$2e2bcd8739ae039 = $f1516034835581bb$var$Dialog;


var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $40495197f8cf6dd9$export$5e57a444791c63be(slot) {
    return (0, $aBqGi.default)('MuiDialogActions', slot);
}
const $40495197f8cf6dd9$var$dialogActionsClasses = (0, $cDqLM.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $40495197f8cf6dd9$export$2e2bcd8739ae039 = $40495197f8cf6dd9$var$dialogActionsClasses;



var $dRzna = parcelRequire("dRzna");
'use client';
const $c53071d61af48ae6$var$_excluded = [
    "className",
    "disableSpacing"
];
const $c53071d61af48ae6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $40495197f8cf6dd9$export$5e57a444791c63be), classes);
};
const $c53071d61af48ae6$var$DialogActionsRoot = (0, $hikmr.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $h4XE0.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $c53071d61af48ae6$var$DialogActions = /*#__PURE__*/ $eeH7J.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $fbOaB.default)(props, $c53071d61af48ae6$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $c53071d61af48ae6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($c53071d61af48ae6$var$DialogActionsRoot, (0, $h4XE0.default)({
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$c53071d61af48ae6$var$DialogActions.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */ disableSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $c53071d61af48ae6$export$2e2bcd8739ae039 = $c53071d61af48ae6$var$DialogActions;


var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");


var $hikmr = parcelRequire("hikmr");

var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $20ac16cfc8576c4d$export$f5d2ec7e4c47e088(slot) {
    return (0, $aBqGi.default)('MuiDialogTitle', slot);
}
const $20ac16cfc8576c4d$var$dialogTitleClasses = (0, $cDqLM.default)('MuiDialogTitle', [
    'root'
]);
var $20ac16cfc8576c4d$export$2e2bcd8739ae039 = $20ac16cfc8576c4d$var$dialogTitleClasses;




var $dRzna = parcelRequire("dRzna");
'use client';
const $d05b73e6cf89853f$var$_excluded = [
    "className",
    "id"
];
const $d05b73e6cf89853f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $20ac16cfc8576c4d$export$f5d2ec7e4c47e088), classes);
};
const $d05b73e6cf89853f$var$DialogTitleRoot = (0, $hikmr.default)((0, $32193c68ed830861$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $d05b73e6cf89853f$var$DialogTitle = /*#__PURE__*/ $eeH7J.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $fbOaB.default)(props, $d05b73e6cf89853f$var$_excluded);
    const ownerState = props;
    const classes = $d05b73e6cf89853f$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $eeH7J.useContext((0, $0012b478d39638cf$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $dRzna.jsx)($d05b73e6cf89853f$var$DialogTitleRoot, (0, $h4XE0.default)({
        component: "h2",
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
$d05b73e6cf89853f$var$DialogTitle.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * @ignore
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ])
};
var $d05b73e6cf89853f$export$2e2bcd8739ae039 = $d05b73e6cf89853f$var$DialogTitle;


var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");


var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $081435eebff85040$export$427f1c1e2e839f85(slot) {
    return (0, $aBqGi.default)('MuiPagination', slot);
}
const $081435eebff85040$var$paginationClasses = (0, $cDqLM.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $081435eebff85040$export$2e2bcd8739ae039 = $081435eebff85040$var$paginationClasses;



var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

'use client';
const $5c784f5e2861219b$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $5c784f5e2861219b$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $fbOaB.default)(props, $5c784f5e2861219b$var$_excluded);
    const [page, setPageState] = (0, $bcd4f903766661d9$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'true' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return (0, $h4XE0.default)({
        items: items
    }, other);
}



var $fbOaB = parcelRequire("fbOaB");

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $er6YD = parcelRequire("er6YD");

var $doIAf = parcelRequire("doIAf");

var $5YtKS = parcelRequire("5YtKS");


var $lNnGW = parcelRequire("lNnGW");

var $cDqLM = parcelRequire("cDqLM");

var $aBqGi = parcelRequire("aBqGi");
function $e8813a4184b81f7c$export$e4ce0a775adf2f74(slot) {
    return (0, $aBqGi.default)('MuiPaginationItem', slot);
}
const $e8813a4184b81f7c$var$paginationItemClasses = (0, $cDqLM.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $e8813a4184b81f7c$export$2e2bcd8739ae039 = $e8813a4184b81f7c$var$paginationItemClasses;




var $4A7Fh = parcelRequire("4A7Fh");
parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $5eef613fd1b0ed4e$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $881c8d8b9dce0996$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $3019868f126685ed$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');


parcelRequire("eeH7J");

var $2uNLd = parcelRequire("2uNLd");

var $dRzna = parcelRequire("dRzna");
'use client';
var $c1c51832d066dcb7$export$2e2bcd8739ae039 = (0, $2uNLd.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');



var $hikmr = parcelRequire("hikmr");

var $dRzna = parcelRequire("dRzna");
'use client';
const $e85c147dc7259fef$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $e85c147dc7259fef$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $4A7Fh.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $4A7Fh.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $4A7Fh.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $e85c147dc7259fef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $4A7Fh.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $4A7Fh.default)(color)}`,
            color !== 'standard' && `${variant}${(0, $4A7Fh.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $e8813a4184b81f7c$export$e4ce0a775adf2f74), classes);
};
const $e85c147dc7259fef$var$PaginationItemEllipsis = (0, $hikmr.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $e85c147dc7259fef$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }));
const $e85c147dc7259fef$var$PaginationItemPage = (0, $hikmr.default)((0, $2a52f24a6713d052$export$2e2bcd8739ae039), {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $e85c147dc7259fef$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $5YtKS.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $5YtKS.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({}, ownerState.variant === 'text' && {
        [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).selected}`]: (0, $h4XE0.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === 'outlined' && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
        [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).selected}`]: (0, $h4XE0.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $5YtKS.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $5YtKS.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $5YtKS.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $5YtKS.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $e8813a4184b81f7c$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $e85c147dc7259fef$var$PaginationItemPageIcon = (0, $hikmr.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $h4XE0.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px'
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $e85c147dc7259fef$var$PaginationItem = /*#__PURE__*/ $eeH7J.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, type: type = 'page', variant: variant = 'text' } = props, other = (0, $fbOaB.default)(props, $e85c147dc7259fef$var$_excluded);
    const ownerState = (0, $h4XE0.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const isRtl = (0, $24165880ce40ccbd$export$b2dd014b6c321cb)();
    const classes = $e85c147dc7259fef$var$useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, $c1c51832d066dcb7$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $3019868f126685ed$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $5eef613fd1b0ed4e$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $881c8d8b9dce0996$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $3019868f126685ed$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $c1c51832d066dcb7$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $5eef613fd1b0ed4e$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $881c8d8b9dce0996$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $dRzna.jsx)($e85c147dc7259fef$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $er6YD.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $dRzna.jsxs)($e85c147dc7259fef$var$PaginationItemPage, (0, $h4XE0.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $er6YD.default)(classes.root, className)
    }, other, {
        children: [
            type === 'page' && page,
            Icon ? /*#__PURE__*/ (0, $dRzna.jsx)($e85c147dc7259fef$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
$e85c147dc7259fef$var$PaginationItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary',
            'standard'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        first: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        last: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        next: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        previous: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The current page number.
   */ page: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).node,
    /**
   * If `true` the pagination item is selected.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * The shape of the pagination item.
   * @default 'circular'
   */ shape: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'circular',
        'rounded'
    ]),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        first: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        last: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        next: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
        previous: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The type of pagination item.
   * @default 'page'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'end-ellipsis',
        'first',
        'last',
        'next',
        'page',
        'previous',
        'start-ellipsis'
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'outlined',
            'text'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $e85c147dc7259fef$export$2e2bcd8739ae039 = $e85c147dc7259fef$var$PaginationItem;



var $hikmr = parcelRequire("hikmr");

var $dRzna = parcelRequire("dRzna");
'use client';
const $c186f8785e46a619$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $c186f8785e46a619$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $doIAf.default)(slots, (0, $081435eebff85040$export$427f1c1e2e839f85), classes);
};
const $c186f8785e46a619$var$PaginationRoot = (0, $hikmr.default)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $c186f8785e46a619$var$PaginationUl = (0, $hikmr.default)('ul', {
    name: 'MuiPagination',
    slot: 'Ul',
    overridesResolver: (props, styles)=>styles.ul
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $c186f8785e46a619$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $c186f8785e46a619$var$Pagination = /*#__PURE__*/ $eeH7J.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $lNnGW.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $c186f8785e46a619$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $dRzna.jsx)((0, $e85c147dc7259fef$export$2e2bcd8739ae039), (0, $h4XE0.default)({}, item)), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text' } = props, other = (0, $fbOaB.default)(props, $c186f8785e46a619$var$_excluded);
    const { items: items } = (0, $5c784f5e2861219b$export$2e2bcd8739ae039)((0, $h4XE0.default)({}, props, {
        componentName: 'Pagination'
    }));
    const ownerState = (0, $h4XE0.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $c186f8785e46a619$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dRzna.jsx)($c186f8785e46a619$var$PaginationRoot, (0, $h4XE0.default)({
        "aria-label": "pagination navigation",
        className: (0, $er6YD.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $dRzna.jsx)($c186f8785e46a619$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $dRzna.jsx)("li", {
                    children: renderItem((0, $h4XE0.default)({}, item, {
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
// @default tags synced with default values from usePagination
$c186f8785e46a619$var$Pagination.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */ boundaryCount: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'primary',
            'secondary',
            'standard'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The total number of pages.
   * @default 1
   */ count: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */ defaultPage: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */ getItemAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * If `true`, hide the next-page button.
   * @default false
   */ hideNextButton: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, hide the previous-page button.
   * @default false
   */ hidePrevButton: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */ page: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */ renderItem: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * The shape of the pagination items.
   * @default 'circular'
   */ shape: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        'circular',
        'rounded'
    ]),
    /**
   * If `true`, show the first-page button.
   * @default false
   */ showFirstButton: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If `true`, show the last-page button.
   * @default false
   */ showLastButton: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */ siblingCount: (0, $ec9311ff626ebe07$export$2e2bcd8739ae039),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
            'outlined',
            'text'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
    ])
};
var $c186f8785e46a619$export$2e2bcd8739ae039 = $c186f8785e46a619$var$Pagination;



var $eeH7J = parcelRequire("eeH7J");

// import "quill/dist/quill.snow.css";
var $0628f66b8cb65c53$exports = {};
"use strict";
"use client";

var $aoClO = parcelRequire("aoClO");
Object.defineProperty($0628f66b8cb65c53$exports, "__esModule", {
    value: true
});
$0628f66b8cb65c53$exports.default = void 0;

var $0628f66b8cb65c53$var$_createSvgIcon = $aoClO((parcelRequire("ayKK6")));

var $dRzna = parcelRequire("dRzna");
var $0628f66b8cb65c53$var$_default = $0628f66b8cb65c53$exports.default = (0, $0628f66b8cb65c53$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dRzna.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBackOutlined');





var $eeH7J = parcelRequire("eeH7J");



var $98ba5df99acb183a$exports = {};

$parcel$export($98ba5df99acb183a$exports, "Scope", function () { return $98ba5df99acb183a$export$775b6bb06e53a214; });
$parcel$export($98ba5df99acb183a$exports, "Attributor", function () { return $98ba5df99acb183a$export$217610c4183502d0; });
$parcel$export($98ba5df99acb183a$exports, "Registry", function () { return $98ba5df99acb183a$export$4d9facee29974f3; });
$parcel$export($98ba5df99acb183a$exports, "ClassAttributor", function () { return $98ba5df99acb183a$export$651d45509677cf07; });
$parcel$export($98ba5df99acb183a$exports, "StyleAttributor", function () { return $98ba5df99acb183a$export$7c8099bbfe87b94d; });
$parcel$export($98ba5df99acb183a$exports, "AttributorStore", function () { return $98ba5df99acb183a$export$68ad86ab95e8de42; });
$parcel$export($98ba5df99acb183a$exports, "LeafBlot", function () { return $98ba5df99acb183a$export$7420b9c542181544; });
$parcel$export($98ba5df99acb183a$exports, "ParentBlot", function () { return $98ba5df99acb183a$export$e43113f0aad76fe; });
$parcel$export($98ba5df99acb183a$exports, "InlineBlot", function () { return $98ba5df99acb183a$export$f67a34bc25a7a861; });
$parcel$export($98ba5df99acb183a$exports, "BlockBlot", function () { return $98ba5df99acb183a$export$4f7f03641f7bfc8c; });
$parcel$export($98ba5df99acb183a$exports, "ContainerBlot", function () { return $98ba5df99acb183a$export$c898d510319704c0; });
$parcel$export($98ba5df99acb183a$exports, "EmbedBlot", function () { return $98ba5df99acb183a$export$297a1fa96f55f00f; });
$parcel$export($98ba5df99acb183a$exports, "ScrollBlot", function () { return $98ba5df99acb183a$export$7175329dad7a46f1; });
$parcel$export($98ba5df99acb183a$exports, "TextBlot", function () { return $98ba5df99acb183a$export$10ac0c5716409de6; });
var $98ba5df99acb183a$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($98ba5df99acb183a$export$775b6bb06e53a214 || {});
class $98ba5df99acb183a$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $98ba5df99acb183a$export$775b6bb06e53a214.TYPE & $98ba5df99acb183a$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $98ba5df99acb183a$export$775b6bb06e53a214.LEVEL | attributeBit : $98ba5df99acb183a$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $98ba5df99acb183a$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $98ba5df99acb183a$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $98ba5df99acb183a$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $98ba5df99acb183a$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $98ba5df99acb183a$export$775b6bb06e53a214.LEVEL & $98ba5df99acb183a$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $98ba5df99acb183a$export$775b6bb06e53a214.LEVEL & $98ba5df99acb183a$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $98ba5df99acb183a$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $98ba5df99acb183a$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $98ba5df99acb183a$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $98ba5df99acb183a$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$98ba5df99acb183a$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $98ba5df99acb183a$export$4d9facee29974f3 = $98ba5df99acb183a$var$_Registry;
function $98ba5df99acb183a$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $98ba5df99acb183a$var$ClassAttributor extends $98ba5df99acb183a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $98ba5df99acb183a$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($98ba5df99acb183a$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $98ba5df99acb183a$export$651d45509677cf07 = $98ba5df99acb183a$var$ClassAttributor;
function $98ba5df99acb183a$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $98ba5df99acb183a$var$StyleAttributor extends $98ba5df99acb183a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$98ba5df99acb183a$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$98ba5df99acb183a$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$98ba5df99acb183a$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $98ba5df99acb183a$export$7c8099bbfe87b94d = $98ba5df99acb183a$var$StyleAttributor;
class $98ba5df99acb183a$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $98ba5df99acb183a$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $98ba5df99acb183a$export$217610c4183502d0.keys(this.domNode), classes = $98ba5df99acb183a$export$651d45509677cf07.keys(this.domNode), styles = $98ba5df99acb183a$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $98ba5df99acb183a$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $98ba5df99acb183a$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $98ba5df99acb183a$export$68ad86ab95e8de42 = $98ba5df99acb183a$var$AttributorStore, $98ba5df99acb183a$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $98ba5df99acb183a$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $98ba5df99acb183a$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $98ba5df99acb183a$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $98ba5df99acb183a$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $98ba5df99acb183a$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $98ba5df99acb183a$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$98ba5df99acb183a$var$_ShadowBlot.blotName = "abstract";
let $98ba5df99acb183a$var$ShadowBlot = $98ba5df99acb183a$var$_ShadowBlot;
const $98ba5df99acb183a$var$_LeafBlot = class _LeafBlot extends $98ba5df99acb183a$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$98ba5df99acb183a$var$_LeafBlot.scope = $98ba5df99acb183a$export$775b6bb06e53a214.INLINE_BLOT;
let $98ba5df99acb183a$var$LeafBlot = $98ba5df99acb183a$var$_LeafBlot;
const $98ba5df99acb183a$export$7420b9c542181544 = $98ba5df99acb183a$var$LeafBlot;
class $98ba5df99acb183a$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $98ba5df99acb183a$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($98ba5df99acb183a$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $98ba5df99acb183a$var$_ParentBlot = class _ParentBlot extends $98ba5df99acb183a$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $98ba5df99acb183a$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $98ba5df99acb183a$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $98ba5df99acb183a$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $98ba5df99acb183a$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $98ba5df99acb183a$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$98ba5df99acb183a$var$_ParentBlot.uiClass = "";
let $98ba5df99acb183a$var$ParentBlot = $98ba5df99acb183a$var$_ParentBlot;
const $98ba5df99acb183a$export$e43113f0aad76fe = $98ba5df99acb183a$var$ParentBlot;
function $98ba5df99acb183a$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $98ba5df99acb183a$var$_InlineBlot = class _InlineBlot extends $98ba5df99acb183a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $98ba5df99acb183a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $98ba5df99acb183a$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $98ba5df99acb183a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $98ba5df99acb183a$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $98ba5df99acb183a$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$98ba5df99acb183a$var$_InlineBlot.allowedChildren = [
    $98ba5df99acb183a$var$_InlineBlot,
    $98ba5df99acb183a$export$7420b9c542181544
], $98ba5df99acb183a$var$_InlineBlot.blotName = "inline", $98ba5df99acb183a$var$_InlineBlot.scope = $98ba5df99acb183a$export$775b6bb06e53a214.INLINE_BLOT, $98ba5df99acb183a$var$_InlineBlot.tagName = "SPAN";
let $98ba5df99acb183a$var$InlineBlot = $98ba5df99acb183a$var$_InlineBlot;
const $98ba5df99acb183a$export$f67a34bc25a7a861 = $98ba5df99acb183a$var$InlineBlot, $98ba5df99acb183a$var$_BlockBlot = class _BlockBlot extends $98ba5df99acb183a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $98ba5df99acb183a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $98ba5df99acb183a$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $98ba5df99acb183a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $98ba5df99acb183a$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $98ba5df99acb183a$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$98ba5df99acb183a$var$_BlockBlot.blotName = "block", $98ba5df99acb183a$var$_BlockBlot.scope = $98ba5df99acb183a$export$775b6bb06e53a214.BLOCK_BLOT, $98ba5df99acb183a$var$_BlockBlot.tagName = "P", $98ba5df99acb183a$var$_BlockBlot.allowedChildren = [
    $98ba5df99acb183a$export$f67a34bc25a7a861,
    $98ba5df99acb183a$var$_BlockBlot,
    $98ba5df99acb183a$export$7420b9c542181544
];
let $98ba5df99acb183a$var$BlockBlot = $98ba5df99acb183a$var$_BlockBlot;
const $98ba5df99acb183a$export$4f7f03641f7bfc8c = $98ba5df99acb183a$var$BlockBlot, $98ba5df99acb183a$var$_ContainerBlot = class _ContainerBlot extends $98ba5df99acb183a$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$98ba5df99acb183a$var$_ContainerBlot.blotName = "container", $98ba5df99acb183a$var$_ContainerBlot.scope = $98ba5df99acb183a$export$775b6bb06e53a214.BLOCK_BLOT;
let $98ba5df99acb183a$var$ContainerBlot = $98ba5df99acb183a$var$_ContainerBlot;
const $98ba5df99acb183a$export$c898d510319704c0 = $98ba5df99acb183a$var$ContainerBlot;
class $98ba5df99acb183a$var$EmbedBlot extends $98ba5df99acb183a$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $98ba5df99acb183a$export$297a1fa96f55f00f = $98ba5df99acb183a$var$EmbedBlot, $98ba5df99acb183a$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $98ba5df99acb183a$var$MAX_OPTIMIZE_ITERATIONS = 100, $98ba5df99acb183a$var$_ScrollBlot = class _ScrollBlot extends $98ba5df99acb183a$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $98ba5df99acb183a$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $98ba5df99acb183a$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $98ba5df99acb183a$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $98ba5df99acb183a$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $98ba5df99acb183a$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$98ba5df99acb183a$var$_ScrollBlot.blotName = "scroll", $98ba5df99acb183a$var$_ScrollBlot.defaultChild = $98ba5df99acb183a$export$4f7f03641f7bfc8c, $98ba5df99acb183a$var$_ScrollBlot.allowedChildren = [
    $98ba5df99acb183a$export$4f7f03641f7bfc8c,
    $98ba5df99acb183a$export$c898d510319704c0
], $98ba5df99acb183a$var$_ScrollBlot.scope = $98ba5df99acb183a$export$775b6bb06e53a214.BLOCK_BLOT, $98ba5df99acb183a$var$_ScrollBlot.tagName = "DIV";
let $98ba5df99acb183a$var$ScrollBlot = $98ba5df99acb183a$var$_ScrollBlot;
const $98ba5df99acb183a$export$7175329dad7a46f1 = $98ba5df99acb183a$var$ScrollBlot, $98ba5df99acb183a$var$_TextBlot = class _TextBlot extends $98ba5df99acb183a$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$98ba5df99acb183a$var$_TextBlot.blotName = "text", $98ba5df99acb183a$var$_TextBlot.scope = $98ba5df99acb183a$export$775b6bb06e53a214.INLINE_BLOT;
let $98ba5df99acb183a$var$TextBlot = $98ba5df99acb183a$var$_TextBlot;
const $98ba5df99acb183a$export$10ac0c5716409de6 = $98ba5df99acb183a$var$TextBlot;


var $82e25a5a05c59b45$exports = {};
"use strict";
Object.defineProperty($82e25a5a05c59b45$exports, "__esModule", {
    value: true
});
$82e25a5a05c59b45$exports.AttributeMap = $82e25a5a05c59b45$exports.OpIterator = $82e25a5a05c59b45$exports.Op = void 0;
var $c4cb8ac573ef9b1e$exports = {};
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $c4cb8ac573ef9b1e$var$DIFF_DELETE = -1;
var $c4cb8ac573ef9b1e$var$DIFF_INSERT = 1;
var $c4cb8ac573ef9b1e$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $c4cb8ac573ef9b1e$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $c4cb8ac573ef9b1e$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $c4cb8ac573ef9b1e$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $c4cb8ac573ef9b1e$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $c4cb8ac573ef9b1e$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $c4cb8ac573ef9b1e$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $c4cb8ac573ef9b1e$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $c4cb8ac573ef9b1e$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $c4cb8ac573ef9b1e$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $c4cb8ac573ef9b1e$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $c4cb8ac573ef9b1e$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $c4cb8ac573ef9b1e$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $c4cb8ac573ef9b1e$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $c4cb8ac573ef9b1e$var$DIFF_DELETE,
            text1
        ],
        [
            $c4cb8ac573ef9b1e$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $c4cb8ac573ef9b1e$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $c4cb8ac573ef9b1e$var$diff_main(text1_a, text2_a);
        var diffs_b = $c4cb8ac573ef9b1e$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $c4cb8ac573ef9b1e$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $c4cb8ac573ef9b1e$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $c4cb8ac573ef9b1e$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $c4cb8ac573ef9b1e$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $c4cb8ac573ef9b1e$var$DIFF_DELETE,
            text1
        ],
        [
            $c4cb8ac573ef9b1e$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $c4cb8ac573ef9b1e$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $c4cb8ac573ef9b1e$var$diff_main(text1a, text2a);
    var diffsb = $c4cb8ac573ef9b1e$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $c4cb8ac573ef9b1e$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($c4cb8ac573ef9b1e$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $c4cb8ac573ef9b1e$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $c4cb8ac573ef9b1e$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($c4cb8ac573ef9b1e$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $c4cb8ac573ef9b1e$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $c4cb8ac573ef9b1e$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $c4cb8ac573ef9b1e$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $c4cb8ac573ef9b1e$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $c4cb8ac573ef9b1e$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $c4cb8ac573ef9b1e$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $c4cb8ac573ef9b1e$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $c4cb8ac573ef9b1e$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $c4cb8ac573ef9b1e$var$diff_cleanupMerge(diffs);
    $c4cb8ac573ef9b1e$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $c4cb8ac573ef9b1e$var$DIFF_DELETE && diffs[pointer][0] == $c4cb8ac573ef9b1e$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $c4cb8ac573ef9b1e$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $c4cb8ac573ef9b1e$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $c4cb8ac573ef9b1e$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $c4cb8ac573ef9b1e$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $c4cb8ac573ef9b1e$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $c4cb8ac573ef9b1e$var$whitespaceRegex_ = /\s/;
var $c4cb8ac573ef9b1e$var$linebreakRegex_ = /[\r\n]/;
var $c4cb8ac573ef9b1e$var$blanklineEndRegex_ = /\n\r?\n$/;
var $c4cb8ac573ef9b1e$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $c4cb8ac573ef9b1e$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($c4cb8ac573ef9b1e$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($c4cb8ac573ef9b1e$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($c4cb8ac573ef9b1e$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($c4cb8ac573ef9b1e$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($c4cb8ac573ef9b1e$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($c4cb8ac573ef9b1e$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($c4cb8ac573ef9b1e$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($c4cb8ac573ef9b1e$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $c4cb8ac573ef9b1e$var$DIFF_EQUAL && diffs[pointer + 1][0] == $c4cb8ac573ef9b1e$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $c4cb8ac573ef9b1e$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $c4cb8ac573ef9b1e$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $c4cb8ac573ef9b1e$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $c4cb8ac573ef9b1e$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $c4cb8ac573ef9b1e$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $c4cb8ac573ef9b1e$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $c4cb8ac573ef9b1e$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $c4cb8ac573ef9b1e$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($c4cb8ac573ef9b1e$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $c4cb8ac573ef9b1e$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $c4cb8ac573ef9b1e$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $c4cb8ac573ef9b1e$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $c4cb8ac573ef9b1e$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $c4cb8ac573ef9b1e$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $c4cb8ac573ef9b1e$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $c4cb8ac573ef9b1e$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $c4cb8ac573ef9b1e$var$DIFF_EQUAL && diffs[pointer + 1][0] === $c4cb8ac573ef9b1e$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $c4cb8ac573ef9b1e$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $c4cb8ac573ef9b1e$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $c4cb8ac573ef9b1e$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $c4cb8ac573ef9b1e$var$starts_with_pair_end(str) {
    return $c4cb8ac573ef9b1e$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $c4cb8ac573ef9b1e$var$ends_with_pair_start(str) {
    return $c4cb8ac573ef9b1e$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $c4cb8ac573ef9b1e$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $c4cb8ac573ef9b1e$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($c4cb8ac573ef9b1e$var$ends_with_pair_start(before) || $c4cb8ac573ef9b1e$var$starts_with_pair_end(after)) return null;
    return $c4cb8ac573ef9b1e$var$remove_empty_tuples([
        [
            $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
            before
        ],
        [
            $c4cb8ac573ef9b1e$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $c4cb8ac573ef9b1e$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $c4cb8ac573ef9b1e$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $c4cb8ac573ef9b1e$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $c4cb8ac573ef9b1e$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $c4cb8ac573ef9b1e$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $c4cb8ac573ef9b1e$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $c4cb8ac573ef9b1e$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $c4cb8ac573ef9b1e$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$c4cb8ac573ef9b1e$var$diff.INSERT = $c4cb8ac573ef9b1e$var$DIFF_INSERT;
$c4cb8ac573ef9b1e$var$diff.DELETE = $c4cb8ac573ef9b1e$var$DIFF_DELETE;
$c4cb8ac573ef9b1e$var$diff.EQUAL = $c4cb8ac573ef9b1e$var$DIFF_EQUAL;
$c4cb8ac573ef9b1e$exports = $c4cb8ac573ef9b1e$var$diff;



var $eeRV7 = parcelRequire("eeRV7");

var $cJRqn = parcelRequire("cJRqn");
var $e989767d27f6c114$exports = {};
"use strict";
Object.defineProperty($e989767d27f6c114$exports, "__esModule", {
    value: true
});

var $eeRV7 = parcelRequire("eeRV7");

var $cJRqn = parcelRequire("cJRqn");
var $e989767d27f6c114$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $eeRV7(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$cJRqn(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($e989767d27f6c114$var$AttributeMap || ($e989767d27f6c114$var$AttributeMap = {}));
$e989767d27f6c114$exports.default = $e989767d27f6c114$var$AttributeMap;


$82e25a5a05c59b45$exports.AttributeMap = $e989767d27f6c114$exports.default;
var $dc103ff6ad42613c$exports = {};
"use strict";
Object.defineProperty($dc103ff6ad42613c$exports, "__esModule", {
    value: true
});
var $dc103ff6ad42613c$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($dc103ff6ad42613c$var$Op || ($dc103ff6ad42613c$var$Op = {}));
$dc103ff6ad42613c$exports.default = $dc103ff6ad42613c$var$Op;


$82e25a5a05c59b45$exports.Op = $dc103ff6ad42613c$exports.default;
var $b47f92d71c69cbd6$exports = {};
"use strict";
Object.defineProperty($b47f92d71c69cbd6$exports, "__esModule", {
    value: true
});

class $b47f92d71c69cbd6$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $dc103ff6ad42613c$exports.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $dc103ff6ad42613c$exports.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
$b47f92d71c69cbd6$exports.default = $b47f92d71c69cbd6$var$Iterator;


$82e25a5a05c59b45$exports.OpIterator = $b47f92d71c69cbd6$exports.default;
const $82e25a5a05c59b45$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $82e25a5a05c59b45$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $82e25a5a05c59b45$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $eeRV7(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($cJRqn(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $dc103ff6ad42613c$exports.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $dc103ff6ad42613c$exports.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $b47f92d71c69cbd6$exports.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $dc103ff6ad42613c$exports.default.length(nextOp);
        }
        return new $82e25a5a05c59b45$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $b47f92d71c69cbd6$exports.default(this.ops);
        const otherIter = new $b47f92d71c69cbd6$exports.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $82e25a5a05c59b45$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $82e25a5a05c59b45$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $82e25a5a05c59b45$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $e989767d27f6c114$exports.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $cJRqn(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $82e25a5a05c59b45$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $82e25a5a05c59b45$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $82e25a5a05c59b45$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $82e25a5a05c59b45$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $82e25a5a05c59b45$var$Delta();
        const diffResult = $c4cb8ac573ef9b1e$exports(strings[0], strings[1], cursor, true);
        const thisIter = new $b47f92d71c69cbd6$exports.default(this.ops);
        const otherIter = new $b47f92d71c69cbd6$exports.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $c4cb8ac573ef9b1e$exports.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $c4cb8ac573ef9b1e$exports.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $c4cb8ac573ef9b1e$exports.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($cJRqn(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $e989767d27f6c114$exports.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $b47f92d71c69cbd6$exports.default(this.ops);
        let line = new $82e25a5a05c59b45$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $dc103ff6ad42613c$exports.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $82e25a5a05c59b45$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $82e25a5a05c59b45$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($dc103ff6ad42613c$exports.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($dc103ff6ad42613c$exports.default.length(baseOp), $e989767d27f6c114$exports.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $b47f92d71c69cbd6$exports.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $82e25a5a05c59b45$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $82e25a5a05c59b45$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $e989767d27f6c114$exports.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $b47f92d71c69cbd6$exports.default(this.ops);
        const otherIter = new $b47f92d71c69cbd6$exports.default(other.ops);
        const delta = new $82e25a5a05c59b45$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($dc103ff6ad42613c$exports.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $82e25a5a05c59b45$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $e989767d27f6c114$exports.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $b47f92d71c69cbd6$exports.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$82e25a5a05c59b45$var$Delta.Op = $dc103ff6ad42613c$exports.default;
$82e25a5a05c59b45$var$Delta.OpIterator = $b47f92d71c69cbd6$exports.default;
$82e25a5a05c59b45$var$Delta.AttributeMap = $e989767d27f6c114$exports.default;
$82e25a5a05c59b45$var$Delta.handlers = {};
$82e25a5a05c59b45$exports.default = $82e25a5a05c59b45$var$Delta;
$82e25a5a05c59b45$exports = $82e25a5a05c59b45$var$Delta;
$82e25a5a05c59b45$exports.default = $82e25a5a05c59b45$var$Delta;







/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $1ef83bdae287cdbd$var$baseAssign(object, source) {
    return object && (0, $f24c78760842e746$export$2e2bcd8739ae039)(source, (0, $399159d0b86c4de3$export$2e2bcd8739ae039)(source), object);
}
var $1ef83bdae287cdbd$export$2e2bcd8739ae039 = $1ef83bdae287cdbd$var$baseAssign;




/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $8c935a0f0c1037e6$var$baseAssignIn(object, source) {
    return object && (0, $f24c78760842e746$export$2e2bcd8739ae039)(source, (0, $b96a2990172eaa9c$export$2e2bcd8739ae039)(source), object);
}
var $8c935a0f0c1037e6$export$2e2bcd8739ae039 = $8c935a0f0c1037e6$var$baseAssignIn;



var $i04Md = parcelRequire("i04Md");



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d93fc69eaacd314a$var$copySymbols(source, object) {
    return (0, $f24c78760842e746$export$2e2bcd8739ae039)(source, (0, $af20ba618912d99a$export$2e2bcd8739ae039)(source), object);
}
var $d93fc69eaacd314a$export$2e2bcd8739ae039 = $d93fc69eaacd314a$var$copySymbols;







/* Built-in method references for those with the same name as other `lodash` methods. */ var $b400d1fe9c2cf1bf$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b400d1fe9c2cf1bf$var$getSymbolsIn = !$b400d1fe9c2cf1bf$var$nativeGetSymbols ? (0, $a447355209f603cc$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $01fbf5bea9de21d8$export$2e2bcd8739ae039)(result, (0, $af20ba618912d99a$export$2e2bcd8739ae039)(object));
        object = (0, $cdc9416ec3a0264b$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $b400d1fe9c2cf1bf$export$2e2bcd8739ae039 = $b400d1fe9c2cf1bf$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $423a4b73f0084469$var$copySymbolsIn(source, object) {
    return (0, $f24c78760842e746$export$2e2bcd8739ae039)(source, (0, $b400d1fe9c2cf1bf$export$2e2bcd8739ae039)(source), object);
}
var $423a4b73f0084469$export$2e2bcd8739ae039 = $423a4b73f0084469$var$copySymbolsIn;






/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c0ef4e8fd7285d16$var$getAllKeysIn(object) {
    return (0, $c375f0615d6af45e$export$2e2bcd8739ae039)(object, (0, $b96a2990172eaa9c$export$2e2bcd8739ae039), (0, $b400d1fe9c2cf1bf$export$2e2bcd8739ae039));
}
var $c0ef4e8fd7285d16$export$2e2bcd8739ae039 = $c0ef4e8fd7285d16$var$getAllKeysIn;



/** Used for built-in method references. */ var $d6e974b7b4b602bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d6e974b7b4b602bc$var$hasOwnProperty = $d6e974b7b4b602bc$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $d6e974b7b4b602bc$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $d6e974b7b4b602bc$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $d6e974b7b4b602bc$export$2e2bcd8739ae039 = $d6e974b7b4b602bc$var$initCloneArray;




/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2cf23ce546d4cc7f$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $f5c7dda80d34a02a$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $2cf23ce546d4cc7f$export$2e2bcd8739ae039 = $2cf23ce546d4cc7f$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $55c155768015a469$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $55c155768015a469$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $55c155768015a469$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $55c155768015a469$export$2e2bcd8739ae039 = $55c155768015a469$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $fb6ad6eb02e05cdb$var$symbolProto = (0, $5a41d29b535fbda9$export$2e2bcd8739ae039) ? (0, $5a41d29b535fbda9$export$2e2bcd8739ae039).prototype : undefined, $fb6ad6eb02e05cdb$var$symbolValueOf = $fb6ad6eb02e05cdb$var$symbolProto ? $fb6ad6eb02e05cdb$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $fb6ad6eb02e05cdb$var$cloneSymbol(symbol) {
    return $fb6ad6eb02e05cdb$var$symbolValueOf ? Object($fb6ad6eb02e05cdb$var$symbolValueOf.call(symbol)) : {};
}
var $fb6ad6eb02e05cdb$export$2e2bcd8739ae039 = $fb6ad6eb02e05cdb$var$cloneSymbol;



/** `Object#toString` result references. */ var $c1c156d1542b93c7$var$boolTag = '[object Boolean]', $c1c156d1542b93c7$var$dateTag = '[object Date]', $c1c156d1542b93c7$var$mapTag = '[object Map]', $c1c156d1542b93c7$var$numberTag = '[object Number]', $c1c156d1542b93c7$var$regexpTag = '[object RegExp]', $c1c156d1542b93c7$var$setTag = '[object Set]', $c1c156d1542b93c7$var$stringTag = '[object String]', $c1c156d1542b93c7$var$symbolTag = '[object Symbol]';
var $c1c156d1542b93c7$var$arrayBufferTag = '[object ArrayBuffer]', $c1c156d1542b93c7$var$dataViewTag = '[object DataView]', $c1c156d1542b93c7$var$float32Tag = '[object Float32Array]', $c1c156d1542b93c7$var$float64Tag = '[object Float64Array]', $c1c156d1542b93c7$var$int8Tag = '[object Int8Array]', $c1c156d1542b93c7$var$int16Tag = '[object Int16Array]', $c1c156d1542b93c7$var$int32Tag = '[object Int32Array]', $c1c156d1542b93c7$var$uint8Tag = '[object Uint8Array]', $c1c156d1542b93c7$var$uint8ClampedTag = '[object Uint8ClampedArray]', $c1c156d1542b93c7$var$uint16Tag = '[object Uint16Array]', $c1c156d1542b93c7$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $c1c156d1542b93c7$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $c1c156d1542b93c7$var$arrayBufferTag:
            return (0, $f5c7dda80d34a02a$export$2e2bcd8739ae039)(object);
        case $c1c156d1542b93c7$var$boolTag:
        case $c1c156d1542b93c7$var$dateTag:
            return new Ctor(+object);
        case $c1c156d1542b93c7$var$dataViewTag:
            return (0, $2cf23ce546d4cc7f$export$2e2bcd8739ae039)(object, isDeep);
        case $c1c156d1542b93c7$var$float32Tag:
        case $c1c156d1542b93c7$var$float64Tag:
        case $c1c156d1542b93c7$var$int8Tag:
        case $c1c156d1542b93c7$var$int16Tag:
        case $c1c156d1542b93c7$var$int32Tag:
        case $c1c156d1542b93c7$var$uint8Tag:
        case $c1c156d1542b93c7$var$uint8ClampedTag:
        case $c1c156d1542b93c7$var$uint16Tag:
        case $c1c156d1542b93c7$var$uint32Tag:
            return (0, $13accf28b5781771$export$2e2bcd8739ae039)(object, isDeep);
        case $c1c156d1542b93c7$var$mapTag:
            return new Ctor;
        case $c1c156d1542b93c7$var$numberTag:
        case $c1c156d1542b93c7$var$stringTag:
            return new Ctor(object);
        case $c1c156d1542b93c7$var$regexpTag:
            return (0, $55c155768015a469$export$2e2bcd8739ae039)(object);
        case $c1c156d1542b93c7$var$setTag:
            return new Ctor;
        case $c1c156d1542b93c7$var$symbolTag:
            return (0, $fb6ad6eb02e05cdb$export$2e2bcd8739ae039)(object);
    }
}
var $c1c156d1542b93c7$export$2e2bcd8739ae039 = $c1c156d1542b93c7$var$initCloneByTag;





var $igoKr = parcelRequire("igoKr");


/** `Object#toString` result references. */ var $08c890bc77fd8fbe$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $08c890bc77fd8fbe$var$baseIsMap(value) {
    return (0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && (0, $32a53861144c518f$export$2e2bcd8739ae039)(value) == $08c890bc77fd8fbe$var$mapTag;
}
var $08c890bc77fd8fbe$export$2e2bcd8739ae039 = $08c890bc77fd8fbe$var$baseIsMap;




var $85lyy = parcelRequire("85lyy");
/* Node.js helper references. */ var $24d09b31323729b8$var$nodeIsMap = (0, $85lyy.default) && (0, $85lyy.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $24d09b31323729b8$var$isMap = $24d09b31323729b8$var$nodeIsMap ? (0, $dcb7ddab35a86b1b$export$2e2bcd8739ae039)($24d09b31323729b8$var$nodeIsMap) : (0, $08c890bc77fd8fbe$export$2e2bcd8739ae039);
var $24d09b31323729b8$export$2e2bcd8739ae039 = $24d09b31323729b8$var$isMap;





/** `Object#toString` result references. */ var $7f1827e8262da689$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $7f1827e8262da689$var$baseIsSet(value) {
    return (0, $071ae2763fad6b0a$export$2e2bcd8739ae039)(value) && (0, $32a53861144c518f$export$2e2bcd8739ae039)(value) == $7f1827e8262da689$var$setTag;
}
var $7f1827e8262da689$export$2e2bcd8739ae039 = $7f1827e8262da689$var$baseIsSet;




var $85lyy = parcelRequire("85lyy");
/* Node.js helper references. */ var $3e84301dc727057e$var$nodeIsSet = (0, $85lyy.default) && (0, $85lyy.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $3e84301dc727057e$var$isSet = $3e84301dc727057e$var$nodeIsSet ? (0, $dcb7ddab35a86b1b$export$2e2bcd8739ae039)($3e84301dc727057e$var$nodeIsSet) : (0, $7f1827e8262da689$export$2e2bcd8739ae039);
var $3e84301dc727057e$export$2e2bcd8739ae039 = $3e84301dc727057e$var$isSet;




/** Used to compose bitmasks for cloning. */ var $7a22204b78f1a813$var$CLONE_DEEP_FLAG = 1, $7a22204b78f1a813$var$CLONE_FLAT_FLAG = 2, $7a22204b78f1a813$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $7a22204b78f1a813$var$argsTag = '[object Arguments]', $7a22204b78f1a813$var$arrayTag = '[object Array]', $7a22204b78f1a813$var$boolTag = '[object Boolean]', $7a22204b78f1a813$var$dateTag = '[object Date]', $7a22204b78f1a813$var$errorTag = '[object Error]', $7a22204b78f1a813$var$funcTag = '[object Function]', $7a22204b78f1a813$var$genTag = '[object GeneratorFunction]', $7a22204b78f1a813$var$mapTag = '[object Map]', $7a22204b78f1a813$var$numberTag = '[object Number]', $7a22204b78f1a813$var$objectTag = '[object Object]', $7a22204b78f1a813$var$regexpTag = '[object RegExp]', $7a22204b78f1a813$var$setTag = '[object Set]', $7a22204b78f1a813$var$stringTag = '[object String]', $7a22204b78f1a813$var$symbolTag = '[object Symbol]', $7a22204b78f1a813$var$weakMapTag = '[object WeakMap]';
var $7a22204b78f1a813$var$arrayBufferTag = '[object ArrayBuffer]', $7a22204b78f1a813$var$dataViewTag = '[object DataView]', $7a22204b78f1a813$var$float32Tag = '[object Float32Array]', $7a22204b78f1a813$var$float64Tag = '[object Float64Array]', $7a22204b78f1a813$var$int8Tag = '[object Int8Array]', $7a22204b78f1a813$var$int16Tag = '[object Int16Array]', $7a22204b78f1a813$var$int32Tag = '[object Int32Array]', $7a22204b78f1a813$var$uint8Tag = '[object Uint8Array]', $7a22204b78f1a813$var$uint8ClampedTag = '[object Uint8ClampedArray]', $7a22204b78f1a813$var$uint16Tag = '[object Uint16Array]', $7a22204b78f1a813$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $7a22204b78f1a813$var$cloneableTags = {};
$7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$argsTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$arrayTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$arrayBufferTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$dataViewTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$boolTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$dateTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$float32Tag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$float64Tag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$int8Tag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$int16Tag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$int32Tag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$mapTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$numberTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$objectTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$regexpTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$setTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$stringTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$symbolTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$uint8Tag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$uint8ClampedTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$uint16Tag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$uint32Tag] = true;
$7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$errorTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$funcTag] = $7a22204b78f1a813$var$cloneableTags[$7a22204b78f1a813$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $7a22204b78f1a813$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $7a22204b78f1a813$var$CLONE_DEEP_FLAG, isFlat = bitmask & $7a22204b78f1a813$var$CLONE_FLAT_FLAG, isFull = bitmask & $7a22204b78f1a813$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $25748a0d7cbe14c0$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $0482a7b1c37d82c4$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $d6e974b7b4b602bc$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $0e8e86ab14c0a404$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $32a53861144c518f$export$2e2bcd8739ae039)(value), isFunc = tag == $7a22204b78f1a813$var$funcTag || tag == $7a22204b78f1a813$var$genTag;
        if ((0, $igoKr.default)(value)) return (0, $i04Md.default)(value, isDeep);
        if (tag == $7a22204b78f1a813$var$objectTag || tag == $7a22204b78f1a813$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $e74270428480da5e$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $423a4b73f0084469$export$2e2bcd8739ae039)(value, (0, $8c935a0f0c1037e6$export$2e2bcd8739ae039)(result, value)) : (0, $d93fc69eaacd314a$export$2e2bcd8739ae039)(value, (0, $1ef83bdae287cdbd$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$7a22204b78f1a813$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $c1c156d1542b93c7$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $d9bf16d4d84249b6$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $3e84301dc727057e$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($7a22204b78f1a813$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $24d09b31323729b8$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $7a22204b78f1a813$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $c0ef4e8fd7285d16$export$2e2bcd8739ae039) : (0, $443c9e920004bef7$export$2e2bcd8739ae039) : isFlat ? (0, $b96a2990172eaa9c$export$2e2bcd8739ae039) : (0, $399159d0b86c4de3$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $bbe33133fd3ce979$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $29d812442ab2ad15$export$2e2bcd8739ae039)(result, key, $7a22204b78f1a813$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $7a22204b78f1a813$export$2e2bcd8739ae039 = $7a22204b78f1a813$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $cac460a179087ae5$var$CLONE_DEEP_FLAG = 1, $cac460a179087ae5$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $cac460a179087ae5$var$cloneDeep(value) {
    return (0, $7a22204b78f1a813$export$2e2bcd8739ae039)(value, $cac460a179087ae5$var$CLONE_DEEP_FLAG | $cac460a179087ae5$var$CLONE_SYMBOLS_FLAG);
}
var $cac460a179087ae5$export$2e2bcd8739ae039 = $cac460a179087ae5$var$cloneDeep;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $152666c0b41a34b7$var$isEqual(value, other) {
    return (0, $69b2d5aed7356a78$export$2e2bcd8739ae039)(value, other);
}
var $152666c0b41a34b7$export$2e2bcd8739ae039 = $152666c0b41a34b7$var$isEqual;







class $11f44e78483cf1e0$var$Break extends (0, $98ba5df99acb183a$export$297a1fa96f55f00f) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$11f44e78483cf1e0$var$Break.blotName = 'break';
$11f44e78483cf1e0$var$Break.tagName = 'BR';
var $11f44e78483cf1e0$export$2e2bcd8739ae039 = $11f44e78483cf1e0$var$Break;





class $c13b40c809f3e8de$export$2e2bcd8739ae039 extends (0, $98ba5df99acb183a$export$10ac0c5716409de6) {
}
// https://lodash.com/docs#escape
const $c13b40c809f3e8de$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $c13b40c809f3e8de$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$c13b40c809f3e8de$var$entityMap[s]);
}


class $4f3156e5894c7a42$var$Inline extends (0, $98ba5df99acb183a$export$f67a34bc25a7a861) {
    static allowedChildren = [
        $4f3156e5894c7a42$var$Inline,
        (0, $11f44e78483cf1e0$export$2e2bcd8739ae039),
        (0, $98ba5df99acb183a$export$297a1fa96f55f00f),
        (0, $c13b40c809f3e8de$export$2e2bcd8739ae039)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $4f3156e5894c7a42$var$Inline.order.indexOf(self);
        const otherIndex = $4f3156e5894c7a42$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($4f3156e5894c7a42$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $4f3156e5894c7a42$var$Inline && $4f3156e5894c7a42$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $4f3156e5894c7a42$export$2e2bcd8739ae039 = $4f3156e5894c7a42$var$Inline;



const $91aa38be8274cd36$var$NEWLINE_LENGTH = 1;
class $91aa38be8274cd36$export$2e2bcd8739ae039 extends (0, $98ba5df99acb183a$export$4f7f03641f7bfc8c) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $91aa38be8274cd36$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $11f44e78483cf1e0$export$2e2bcd8739ae039)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $91aa38be8274cd36$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $91aa38be8274cd36$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$91aa38be8274cd36$export$2e2bcd8739ae039.blotName = 'block';
$91aa38be8274cd36$export$2e2bcd8739ae039.tagName = 'P';
$91aa38be8274cd36$export$2e2bcd8739ae039.defaultChild = (0, $11f44e78483cf1e0$export$2e2bcd8739ae039);
$91aa38be8274cd36$export$2e2bcd8739ae039.allowedChildren = [
    (0, $11f44e78483cf1e0$export$2e2bcd8739ae039),
    (0, $4f3156e5894c7a42$export$2e2bcd8739ae039),
    (0, $98ba5df99acb183a$export$297a1fa96f55f00f),
    (0, $c13b40c809f3e8de$export$2e2bcd8739ae039)
];
class $91aa38be8274cd36$export$48b9f0688962d028 extends (0, $98ba5df99acb183a$export$297a1fa96f55f00f) {
    attach() {
        super.attach();
        this.attributes = new (0, $98ba5df99acb183a$export$68ad86ab95e8de42)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($91aa38be8274cd36$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$91aa38be8274cd36$export$48b9f0688962d028.scope = (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $91aa38be8274cd36$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $98ba5df99acb183a$export$7420b9c542181544)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $91aa38be8274cd36$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))()).insert('\n', $91aa38be8274cd36$export$e4bb5a6163449612(blot));
}
function $91aa38be8274cd36$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $91aa38be8274cd36$export$e4bb5a6163449612(blot.parent, formats, filter);
}





class $d650dae3143ef8bb$var$Cursor extends (0, $98ba5df99acb183a$export$297a1fa96f55f00f) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($d650dae3143ef8bb$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $d650dae3143ef8bb$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $d650dae3143ef8bb$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $c13b40c809f3e8de$export$2e2bcd8739ae039) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $c13b40c809f3e8de$export$2e2bcd8739ae039) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($d650dae3143ef8bb$var$Cursor.CONTENTS).join('');
        textNode.data = $d650dae3143ef8bb$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $d650dae3143ef8bb$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $d650dae3143ef8bb$export$2e2bcd8739ae039 = $d650dae3143ef8bb$var$Cursor;





var $11cacb7fdf2cadf1$exports = {};
'use strict';
var $11cacb7fdf2cadf1$var$has = Object.prototype.hasOwnProperty, $11cacb7fdf2cadf1$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $11cacb7fdf2cadf1$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $11cacb7fdf2cadf1$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $11cacb7fdf2cadf1$var$Events().__proto__) $11cacb7fdf2cadf1$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $11cacb7fdf2cadf1$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $11cacb7fdf2cadf1$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $11cacb7fdf2cadf1$var$EE(fn, context || emitter, once), evt = $11cacb7fdf2cadf1$var$prefix ? $11cacb7fdf2cadf1$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $11cacb7fdf2cadf1$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $11cacb7fdf2cadf1$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $11cacb7fdf2cadf1$var$EventEmitter() {
    this._events = new $11cacb7fdf2cadf1$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($11cacb7fdf2cadf1$var$has.call(events, name)) names.push($11cacb7fdf2cadf1$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $11cacb7fdf2cadf1$var$prefix ? $11cacb7fdf2cadf1$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $11cacb7fdf2cadf1$var$prefix ? $11cacb7fdf2cadf1$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $11cacb7fdf2cadf1$var$prefix ? $11cacb7fdf2cadf1$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $11cacb7fdf2cadf1$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $11cacb7fdf2cadf1$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $11cacb7fdf2cadf1$var$prefix ? $11cacb7fdf2cadf1$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $11cacb7fdf2cadf1$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $11cacb7fdf2cadf1$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $11cacb7fdf2cadf1$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $11cacb7fdf2cadf1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $11cacb7fdf2cadf1$var$prefix ? $11cacb7fdf2cadf1$var$prefix + event : event;
        if (this._events[evt]) $11cacb7fdf2cadf1$var$clearEvent(this, evt);
    } else {
        this._events = new $11cacb7fdf2cadf1$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$11cacb7fdf2cadf1$var$EventEmitter.prototype.off = $11cacb7fdf2cadf1$var$EventEmitter.prototype.removeListener;
$11cacb7fdf2cadf1$var$EventEmitter.prototype.addListener = $11cacb7fdf2cadf1$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$11cacb7fdf2cadf1$var$EventEmitter.prefixed = $11cacb7fdf2cadf1$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$11cacb7fdf2cadf1$var$EventEmitter.EventEmitter = $11cacb7fdf2cadf1$var$EventEmitter;
$11cacb7fdf2cadf1$exports = $11cacb7fdf2cadf1$var$EventEmitter;


var $1dfac2695cf173cf$export$2e2bcd8739ae039 = new WeakMap();


const $38e9458ec9bb8ee6$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $38e9458ec9bb8ee6$var$level = 'warn';
function $38e9458ec9bb8ee6$var$debug(method) {
    if ($38e9458ec9bb8ee6$var$level) {
        if ($38e9458ec9bb8ee6$var$levels.indexOf(method) <= $38e9458ec9bb8ee6$var$levels.indexOf($38e9458ec9bb8ee6$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $38e9458ec9bb8ee6$var$namespace(ns) {
    return $38e9458ec9bb8ee6$var$levels.reduce((logger, method)=>{
        logger[method] = $38e9458ec9bb8ee6$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$38e9458ec9bb8ee6$var$namespace.level = (newLevel)=>{
    $38e9458ec9bb8ee6$var$level = newLevel;
};
$38e9458ec9bb8ee6$var$debug.level = $38e9458ec9bb8ee6$var$namespace.level;
var $38e9458ec9bb8ee6$export$2e2bcd8739ae039 = $38e9458ec9bb8ee6$var$namespace;


const $86b9bfd1834ce2b9$var$debug = (0, $38e9458ec9bb8ee6$export$2e2bcd8739ae039)('quill:events');
const $86b9bfd1834ce2b9$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$86b9bfd1834ce2b9$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $1dfac2695cf173cf$export$2e2bcd8739ae039).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $86b9bfd1834ce2b9$var$Emitter extends (0, $11cacb7fdf2cadf1$exports.EventEmitter) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $86b9bfd1834ce2b9$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $86b9bfd1834ce2b9$var$debug.log.call($86b9bfd1834ce2b9$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $86b9bfd1834ce2b9$export$2e2bcd8739ae039 = $86b9bfd1834ce2b9$var$Emitter;



const $f277c87dff6d716f$var$debug = (0, $38e9458ec9bb8ee6$export$2e2bcd8739ae039)('quill:selection');
class $f277c87dff6d716f$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $f277c87dff6d716f$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $f277c87dff6d716f$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER), 1);
        });
        this.emitter.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT);
            }
        });
        this.update((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $98ba5df99acb183a$export$7420b9c542181544)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $f277c87dff6d716f$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $f277c87dff6d716f$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $98ba5df99acb183a$export$7420b9c542181544)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $f277c87dff6d716f$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$f277c87dff6d716f$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$f277c87dff6d716f$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $f277c87dff6d716f$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $f277c87dff6d716f$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $152666c0b41a34b7$export$2e2bcd8739ae039)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SELECTION_CHANGE,
                (0, $cac460a179087ae5$export$2e2bcd8739ae039)(this.lastRange),
                (0, $cac460a179087ae5$export$2e2bcd8739ae039)(oldRange),
                source
            ];
            this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $f277c87dff6d716f$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $f277c87dff6d716f$export$2e2bcd8739ae039 = $f277c87dff6d716f$var$Selection;


const $897b04d501a24aed$var$ASCII = /^[ -~]*$/;
class $897b04d501a24aed$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $897b04d501a24aed$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
        const normalizedOps = $897b04d501a24aed$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $82e25a5a05c59b45$exports.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $91aa38be8274cd36$export$48b9f0688962d028), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $451ad2baa4201321$export$2e2bcd8739ae039)({}, (0, $91aa38be8274cd36$export$e4bb5a6163449612)(line));
                    if (line instanceof (0, $91aa38be8274cd36$export$2e2bcd8739ae039)) {
                        const [leaf] = line.descendant((0, $98ba5df99acb183a$export$7420b9c542181544), offset);
                        if (leaf) formats = (0, $451ad2baa4201321$export$2e2bcd8739ae039)(formats, (0, $91aa38be8274cd36$export$e4bb5a6163449612)(leaf));
                    }
                    attributes = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $91aa38be8274cd36$export$48b9f0688962d028), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $98ba5df99acb183a$export$7420b9c542181544), index - 1);
                        if (leaf instanceof (0, $c13b40c809f3e8de$export$2e2bcd8739ae039)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $98ba5df99acb183a$export$297a1fa96f55f00f) && leaf.statics.scope === (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $98ba5df99acb183a$export$7420b9c542181544), index);
                        if (leaf) {
                            const formats = (0, $451ad2baa4201321$export$2e2bcd8739ae039)({}, (0, $91aa38be8274cd36$export$e4bb5a6163449612)(leaf));
                            attributes = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $82e25a5a05c59b45$exports.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).retain(length, (0, $cac460a179087ae5$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).retain(length, (0, $cac460a179087ae5$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $91aa38be8274cd36$export$2e2bcd8739ae039)) lines.push(blot);
            else if (blot instanceof (0, $98ba5df99acb183a$export$7420b9c542181544)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $98ba5df99acb183a$export$7420b9c542181544), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $91aa38be8274cd36$export$e4bb5a6163449612)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $897b04d501a24aed$var$combineFormats((0, $91aa38be8274cd36$export$e4bb5a6163449612)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $897b04d501a24aed$var$convertHTML(line, lineOffset, length, true);
            return $897b04d501a24aed$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $897b04d501a24aed$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).insert(text, (0, $cac460a179087ae5$export$2e2bcd8739ae039)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $91aa38be8274cd36$export$2e2bcd8739ae039).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $11f44e78483cf1e0$export$2e2bcd8739ae039);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($897b04d501a24aed$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $91aa38be8274cd36$export$e4bb5a6163449612)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $d650dae3143ef8bb$export$2e2bcd8739ae039).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $897b04d501a24aed$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $897b04d501a24aed$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $152666c0b41a34b7$export$2e2bcd8739ae039)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $897b04d501a24aed$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $897b04d501a24aed$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$897b04d501a24aed$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $897b04d501a24aed$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$897b04d501a24aed$var$convertHTML(child, offset, length)}${$897b04d501a24aed$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$897b04d501a24aed$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$897b04d501a24aed$var$convertHTML(child, offset, length)}${$897b04d501a24aed$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $897b04d501a24aed$var$getListType(types.pop());
    return `</li></${endTag}>${$897b04d501a24aed$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $897b04d501a24aed$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $c13b40c809f3e8de$export$2e2bcd8739ae039)) {
        const escapedText = (0, $c13b40c809f3e8de$export$96e6fc3a139b2555)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $98ba5df99acb183a$export$e43113f0aad76fe)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $897b04d501a24aed$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($897b04d501a24aed$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $897b04d501a24aed$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $897b04d501a24aed$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $897b04d501a24aed$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
}
function $897b04d501a24aed$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $f277c87dff6d716f$export$9a58ef0d7ad3278c)(index + amount, length);
}
function $897b04d501a24aed$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $897b04d501a24aed$export$2e2bcd8739ae039 = $897b04d501a24aed$var$Editor;





class $526ece9aac0d6999$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $526ece9aac0d6999$export$2e2bcd8739ae039 = $526ece9aac0d6999$var$Module;





const $9747a5ed652b7dc2$var$GUARD_TEXT = '\uFEFF';
class $9747a5ed652b7dc2$var$Embed extends (0, $98ba5df99acb183a$export$297a1fa96f55f00f) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($9747a5ed652b7dc2$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($9747a5ed652b7dc2$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($9747a5ed652b7dc2$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $c13b40c809f3e8de$export$2e2bcd8739ae039)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $c13b40c809f3e8de$export$2e2bcd8739ae039)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $9747a5ed652b7dc2$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $9747a5ed652b7dc2$export$2e2bcd8739ae039 = $9747a5ed652b7dc2$var$Embed;



class $008953a03f1390df$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $9747a5ed652b7dc2$export$2e2bcd8739ae039))) {
            this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $008953a03f1390df$export$2e2bcd8739ae039 = $008953a03f1390df$var$Composition;


class $160b75e6fe1673cc$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $160b75e6fe1673cc$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $160b75e6fe1673cc$export$2e2bcd8739ae039 = $160b75e6fe1673cc$var$Theme;


const $40598c32aa8f8a8c$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $40598c32aa8f8a8c$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $40598c32aa8f8a8c$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $40598c32aa8f8a8c$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $40598c32aa8f8a8c$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $40598c32aa8f8a8c$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $40598c32aa8f8a8c$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $40598c32aa8f8a8c$var$paddingValueToInt(style.scrollPaddingLeft), $40598c32aa8f8a8c$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $40598c32aa8f8a8c$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $40598c32aa8f8a8c$var$paddingValueToInt(style.scrollPaddingTop), $40598c32aa8f8a8c$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $40598c32aa8f8a8c$var$getParentElement(current);
    }
};
var $40598c32aa8f8a8c$export$2e2bcd8739ae039 = $40598c32aa8f8a8c$var$scrollRectIntoView;



const $e5fbf3746dd79836$var$MAX_REGISTER_ITERATIONS = 100;
const $e5fbf3746dd79836$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $e5fbf3746dd79836$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $98ba5df99acb183a$export$4d9facee29974f3)();
    $e5fbf3746dd79836$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $e5fbf3746dd79836$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $e5fbf3746dd79836$export$2e2bcd8739ae039 = $e5fbf3746dd79836$var$createRegistryWithFormats;


const $e427c28fc0504942$var$debug = (0, $38e9458ec9bb8ee6$export$2e2bcd8739ae039)('quill');
const $e427c28fc0504942$export$bc58ce2776ecdb6f = new $98ba5df99acb183a$exports.Registry();
$98ba5df99acb183a$exports.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $e427c28fc0504942$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $e427c28fc0504942$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events;
    static sources = (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports))),
        parchment: $98ba5df99acb183a$exports,
        'core/module': (0, $526ece9aac0d6999$export$2e2bcd8739ae039),
        'core/theme': (0, $160b75e6fe1673cc$export$2e2bcd8739ae039)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $38e9458ec9bb8ee6$export$2e2bcd8739ae039).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $1dfac2695cf173cf$export$2e2bcd8739ae039).get(node) || $e427c28fc0504942$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $e427c28fc0504942$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $e427c28fc0504942$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $e427c28fc0504942$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($e427c28fc0504942$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $e427c28fc0504942$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $e427c28fc0504942$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $e427c28fc0504942$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $1dfac2695cf173cf$export$2e2bcd8739ae039).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039)();
        const scrollBlotName = $98ba5df99acb183a$exports.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $897b04d501a24aed$export$2e2bcd8739ae039)(this.scroll);
        this.selection = new (0, $f277c87dff6d716f$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.composition = new (0, $008953a03f1390df$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $e427c28fc0504942$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $e427c28fc0504942$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $e427c28fc0504942$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $e427c28fc0504942$export$e336952123c0bccd(index, length, source);
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.API;
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
            if (range == null) return change;
            if (this.scroll.query(name, $98ba5df99acb183a$exports.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $e427c28fc0504942$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $e427c28fc0504942$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $e427c28fc0504942$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $e427c28fc0504942$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $e427c28fc0504942$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e427c28fc0504942$export$2e2bcd8739ae039.sources.API;
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $e427c28fc0504942$export$e336952123c0bccd(index, 0, name, value, source);
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $e427c28fc0504942$export$e336952123c0bccd(index, length, source);
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $40598c32aa8f8a8c$export$2e2bcd8739ae039)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.API;
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $e427c28fc0504942$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $e427c28fc0504942$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $f277c87dff6d716f$export$9a58ef0d7ad3278c)(Math.max(0, index), length), source);
            if (source !== (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.API;
        return $e427c28fc0504942$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $e427c28fc0504942$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $e427c28fc0504942$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $e427c28fc0504942$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $e427c28fc0504942$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $e427c28fc0504942$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $e427c28fc0504942$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $160b75e6fe1673cc$export$2e2bcd8739ae039) : $e427c28fc0504942$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $e427c28fc0504942$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $e427c28fc0504942$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $451ad2baa4201321$export$2e2bcd8739ae039)({}, $e427c28fc0504942$var$expandModuleConfig(quillModuleDefaults), $e427c28fc0504942$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$e427c28fc0504942$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$e427c28fc0504942$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $e427c28fc0504942$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $e5fbf3746dd79836$export$2e2bcd8739ae039)(options.formats, config.registry, $e427c28fc0504942$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $e427c28fc0504942$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $e427c28fc0504942$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $451ad2baa4201321$export$2e2bcd8739ae039)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $e427c28fc0504942$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $e427c28fc0504942$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $e427c28fc0504942$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $e427c28fc0504942$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $e427c28fc0504942$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $e427c28fc0504942$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $f277c87dff6d716f$export$9a58ef0d7ad3278c)(start, end - start);
}





class $3fd3b9a1161f7ddd$var$Container extends (0, $98ba5df99acb183a$export$c898d510319704c0) {
}
var $3fd3b9a1161f7ddd$export$2e2bcd8739ae039 = $3fd3b9a1161f7ddd$var$Container;











function $eef887622f3b7d5c$var$isLine(blot) {
    return blot instanceof (0, $91aa38be8274cd36$export$2e2bcd8739ae039) || blot instanceof (0, $91aa38be8274cd36$export$48b9f0688962d028);
}
function $eef887622f3b7d5c$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $eef887622f3b7d5c$var$Scroll extends (0, $98ba5df99acb183a$export$7175329dad7a46f1) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $91aa38be8274cd36$export$2e2bcd8739ae039);
    static allowedChildren = [
        (0, $91aa38be8274cd36$export$2e2bcd8739ae039),
        (0, $91aa38be8274cd36$export$48b9f0688962d028),
        (0, $3fd3b9a1161f7ddd$export$2e2bcd8739ae039)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $91aa38be8274cd36$export$48b9f0688962d028) || last instanceof (0, $91aa38be8274cd36$export$48b9f0688962d028)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $11f44e78483cf1e0$export$2e2bcd8739ae039) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $91aa38be8274cd36$export$48b9f0688962d028), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert({
                [first.key]: first.value
            });
            $eef887622f3b7d5c$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $91aa38be8274cd36$export$e4bb5a6163449612)(this.line(index)[0]);
            const attributes = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $eef887622f3b7d5c$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $eef887622f3b7d5c$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $98ba5df99acb183a$export$7420b9c542181544) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($eef887622f3b7d5c$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($eef887622f3b7d5c$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $98ba5df99acb183a$export$c898d510319704c0)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$eef887622f3b7d5c$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $91aa38be8274cd36$export$48b9f0688962d028), index);
        if (blot && blot.statics.blotName === key && $eef887622f3b7d5c$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK & (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $eef887622f3b7d5c$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $82e25a5a05c59b45$exports.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $98ba5df99acb183a$export$7420b9c542181544), index);
                const formats = (0, $91aa38be8274cd36$export$e4bb5a6163449612)(leaf);
                attributes = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $98ba5df99acb183a$export$7420b9c542181544), index);
                    const formats = (0, $91aa38be8274cd36$export$e4bb5a6163449612)(leaf);
                    attributes = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $eef887622f3b7d5c$export$2e2bcd8739ae039 = $eef887622f3b7d5c$var$Scroll;










const $15eefb82df67033a$var$config = {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $15eefb82df67033a$export$2ef0f9fb04a51388 = new (0, $98ba5df99acb183a$export$217610c4183502d0)('align', 'align', $15eefb82df67033a$var$config);
const $15eefb82df67033a$export$7f3685f5846c07da = new (0, $98ba5df99acb183a$export$651d45509677cf07)('align', 'ql-align', $15eefb82df67033a$var$config);
const $15eefb82df67033a$export$d2060f5d114c9fe8 = new (0, $98ba5df99acb183a$export$7c8099bbfe87b94d)('align', 'text-align', $15eefb82df67033a$var$config);




class $169716956cabd648$export$c992e3369f248f6e extends (0, $98ba5df99acb183a$export$7c8099bbfe87b94d) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $169716956cabd648$export$42795dcf0ec6f3c8 = new (0, $98ba5df99acb183a$export$651d45509677cf07)('color', 'ql-color', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE
});
const $169716956cabd648$export$1415f56796d9a5a9 = new $169716956cabd648$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE
});


const $4ed9b61effc385b4$export$8aa96c8963152b12 = new (0, $98ba5df99acb183a$export$651d45509677cf07)('background', 'ql-bg', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE
});
const $4ed9b61effc385b4$export$dc1cbcab4c682ef = new (0, $169716956cabd648$export$c992e3369f248f6e)('background', 'background-color', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE
});









class $358eddd4869da41b$export$3b131632d3d15165 extends (0, $3fd3b9a1161f7ddd$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $c13b40c809f3e8de$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
}
class $358eddd4869da41b$export$2e2bcd8739ae039 extends (0, $91aa38be8274cd36$export$2e2bcd8739ae039) {
    static TAB = '  ';
    static register() {
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register($358eddd4869da41b$export$3b131632d3d15165);
    }
}
class $358eddd4869da41b$export$52f0f02147b12c03 extends (0, $4f3156e5894c7a42$export$2e2bcd8739ae039) {
}
$358eddd4869da41b$export$52f0f02147b12c03.blotName = 'code';
$358eddd4869da41b$export$52f0f02147b12c03.tagName = 'CODE';
$358eddd4869da41b$export$2e2bcd8739ae039.blotName = 'code-block';
$358eddd4869da41b$export$2e2bcd8739ae039.className = 'ql-code-block';
$358eddd4869da41b$export$2e2bcd8739ae039.tagName = 'DIV';
$358eddd4869da41b$export$3b131632d3d15165.blotName = 'code-block-container';
$358eddd4869da41b$export$3b131632d3d15165.className = 'ql-code-block-container';
$358eddd4869da41b$export$3b131632d3d15165.tagName = 'DIV';
$358eddd4869da41b$export$3b131632d3d15165.allowedChildren = [
    $358eddd4869da41b$export$2e2bcd8739ae039
];
$358eddd4869da41b$export$2e2bcd8739ae039.allowedChildren = [
    (0, $c13b40c809f3e8de$export$2e2bcd8739ae039),
    (0, $11f44e78483cf1e0$export$2e2bcd8739ae039),
    (0, $d650dae3143ef8bb$export$2e2bcd8739ae039)
];
$358eddd4869da41b$export$2e2bcd8739ae039.requiredContainer = $358eddd4869da41b$export$3b131632d3d15165;




const $81390373d29f2d8e$var$config = {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $81390373d29f2d8e$export$4158215dafad9efa = new (0, $98ba5df99acb183a$export$217610c4183502d0)('direction', 'dir', $81390373d29f2d8e$var$config);
const $81390373d29f2d8e$export$630028b3af294dec = new (0, $98ba5df99acb183a$export$651d45509677cf07)('direction', 'ql-direction', $81390373d29f2d8e$var$config);
const $81390373d29f2d8e$export$175979e518d1dfd1 = new (0, $98ba5df99acb183a$export$7c8099bbfe87b94d)('direction', 'direction', $81390373d29f2d8e$var$config);



const $3eade1afb6ffe4bd$var$config = {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $3eade1afb6ffe4bd$export$78a99ee601572ab = new (0, $98ba5df99acb183a$export$651d45509677cf07)('font', 'ql-font', $3eade1afb6ffe4bd$var$config);
class $3eade1afb6ffe4bd$var$FontStyleAttributor extends (0, $98ba5df99acb183a$export$7c8099bbfe87b94d) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $3eade1afb6ffe4bd$export$23b468d4ca3f8c96 = new $3eade1afb6ffe4bd$var$FontStyleAttributor('font', 'font-family', $3eade1afb6ffe4bd$var$config);



const $b14d39691f988cde$export$c84684d52bca9684 = new (0, $98ba5df99acb183a$export$651d45509677cf07)('size', 'ql-size', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $b14d39691f988cde$export$5443b95a30e89ac5 = new (0, $98ba5df99acb183a$export$7c8099bbfe87b94d)('size', 'font-size', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});








const $6747bc4e394910ac$var$debug = (0, $38e9458ec9bb8ee6$export$2e2bcd8739ae039)('quill:keyboard');
const $6747bc4e394910ac$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $6747bc4e394910ac$export$2e2bcd8739ae039 extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $6747bc4e394910ac$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $6747bc4e394910ac$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$6747bc4e394910ac$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $e427c28fc0504942$export$2e2bcd8739ae039).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $98ba5df99acb183a$export$10ac0c5716409de6) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $98ba5df99acb183a$export$10ac0c5716409de6) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $152666c0b41a34b7$export$2e2bcd8739ae039)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $6747bc4e394910ac$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.focus();
    }
}
const $6747bc4e394910ac$var$defaultOptions = {
    bindings: {
        bold: $6747bc4e394910ac$var$makeFormatHandler('bold'),
        italic: $6747bc4e394910ac$var$makeFormatHandler('italic'),
        underline: $6747bc4e394910ac$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'indent code-block': $6747bc4e394910ac$var$makeCodeBlockHandler(true),
        'outdent code-block': $6747bc4e394910ac$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $6747bc4e394910ac$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $6747bc4e394910ac$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $6747bc4e394910ac$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $6747bc4e394910ac$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $6747bc4e394910ac$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $6747bc4e394910ac$var$makeTableArrowHandler(false),
        'table up': $6747bc4e394910ac$var$makeTableArrowHandler(true)
    }
};
$6747bc4e394910ac$export$2e2bcd8739ae039.DEFAULTS = $6747bc4e394910ac$var$defaultOptions;
function $6747bc4e394910ac$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(index, length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        }
    };
}
function $6747bc4e394910ac$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $98ba5df99acb183a$export$297a1fa96f55f00f))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            return false;
        }
    };
}
function $6747bc4e394910ac$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        }
    };
}
function $6747bc4e394910ac$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                }
            }
            return false;
        }
    };
}
function $6747bc4e394910ac$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $cac460a179087ae5$export$2e2bcd8739ae039)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$6747bc4e394910ac$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $6747bc4e394910ac$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $82e25a5a05c59b45$exports.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
    quill.setSelection(range.index, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
}
function $6747bc4e394910ac$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}


const $45ca7d3df97e7b11$var$normalWeightRegexp = /font-weight:\s*normal/;
const $45ca7d3df97e7b11$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $45ca7d3df97e7b11$var$isBlockElement = (element)=>{
    return element && $45ca7d3df97e7b11$var$blockTagNames.includes(element.tagName);
};
const $45ca7d3df97e7b11$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$45ca7d3df97e7b11$var$isBlockElement(br.previousElementSibling) && $45ca7d3df97e7b11$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $45ca7d3df97e7b11$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($45ca7d3df97e7b11$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $45ca7d3df97e7b11$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $45ca7d3df97e7b11$var$normalizeFontWeight(doc);
        $45ca7d3df97e7b11$var$normalizeEmptyLines(doc);
    }
}


const $7712a9d1665eb666$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $7712a9d1665eb666$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $7712a9d1665eb666$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $7712a9d1665eb666$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($7712a9d1665eb666$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($7712a9d1665eb666$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $7712a9d1665eb666$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($7712a9d1665eb666$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$7712a9d1665eb666$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $7712a9d1665eb666$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $7712a9d1665eb666$var$normalizeListItem(doc);
}


const $43f45f6f350e8b88$var$NORMALIZERS = [
    (0, $7712a9d1665eb666$export$2e2bcd8739ae039),
    (0, $45ca7d3df97e7b11$export$2e2bcd8739ae039)
];
const $43f45f6f350e8b88$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $43f45f6f350e8b88$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $43f45f6f350e8b88$export$2e2bcd8739ae039 = $43f45f6f350e8b88$var$normalizeExternalHTML;


const $93214c81831f46f5$var$debug = (0, $38e9458ec9bb8ee6$export$2e2bcd8739ae039)('quill:clipboard');
const $93214c81831f46f5$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $93214c81831f46f5$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $93214c81831f46f5$export$c695b9637111f586
    ],
    [
        'br',
        $93214c81831f46f5$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $93214c81831f46f5$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $93214c81831f46f5$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $93214c81831f46f5$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $93214c81831f46f5$var$matchStyles
    ],
    [
        'li',
        $93214c81831f46f5$var$matchIndent
    ],
    [
        'ol, ul',
        $93214c81831f46f5$var$matchList
    ],
    [
        'pre',
        $93214c81831f46f5$var$matchCodeBlock
    ],
    [
        'tr',
        $93214c81831f46f5$var$matchTable
    ],
    [
        'b',
        $93214c81831f46f5$var$createMatchAlias('bold')
    ],
    [
        'i',
        $93214c81831f46f5$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $93214c81831f46f5$var$createMatchAlias('strike')
    ],
    [
        'style',
        $93214c81831f46f5$var$matchIgnore
    ]
];
const $93214c81831f46f5$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $15eefb82df67033a$export$2ef0f9fb04a51388),
    (0, $81390373d29f2d8e$export$4158215dafad9efa)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $93214c81831f46f5$var$STYLE_ATTRIBUTORS = [
    (0, $15eefb82df67033a$export$d2060f5d114c9fe8),
    (0, $4ed9b61effc385b4$export$dc1cbcab4c682ef),
    (0, $169716956cabd648$export$1415f56796d9a5a9),
    (0, $81390373d29f2d8e$export$175979e518d1dfd1),
    (0, $3eade1afb6ffe4bd$export$23b468d4ca3f8c96),
    (0, $b14d39691f988cde$export$5443b95a30e89ac5)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $93214c81831f46f5$export$2e2bcd8739ae039 extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $93214c81831f46f5$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $358eddd4869da41b$export$2e2bcd8739ae039).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(text || '', {
            [(0, $358eddd4869da41b$export$2e2bcd8739ae039).blotName]: formats[(0, $358eddd4869da41b$export$2e2bcd8739ae039).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($93214c81831f46f5$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $43f45f6f350e8b88$export$2e2bcd8739ae039)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $93214c81831f46f5$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $6747bc4e394910ac$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $93214c81831f46f5$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $93214c81831f46f5$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
}
function $93214c81831f46f5$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $93214c81831f46f5$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $98ba5df99acb183a$export$297a1fa96f55f00f)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $93214c81831f46f5$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$93214c81831f46f5$var$isLine(node.previousElementSibling, scroll) && !$93214c81831f46f5$var$isLine(node.nextElementSibling, scroll);
}
const $93214c81831f46f5$var$preNodes = new WeakMap();
function $93214c81831f46f5$var$isPre(node) {
    if (node == null) return false;
    if (!$93214c81831f46f5$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $93214c81831f46f5$var$preNodes.set(node, true);
        else $93214c81831f46f5$var$preNodes.set(node, $93214c81831f46f5$var$isPre(node.parentNode));
    }
    return $93214c81831f46f5$var$preNodes.get(node);
}
function $93214c81831f46f5$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $93214c81831f46f5$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
}
function $93214c81831f46f5$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $93214c81831f46f5$var$applyFormat(delta, format, true, scroll);
    };
}
function $93214c81831f46f5$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $98ba5df99acb183a$export$217610c4183502d0).keys(node);
    const classes = (0, $98ba5df99acb183a$export$651d45509677cf07).keys(node);
    const styles = (0, $98ba5df99acb183a$export$7c8099bbfe87b94d).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $98ba5df99acb183a$export$775b6bb06e53a214).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $93214c81831f46f5$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $93214c81831f46f5$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $93214c81831f46f5$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $93214c81831f46f5$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $93214c81831f46f5$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $98ba5df99acb183a$export$297a1fa96f55f00f)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $98ba5df99acb183a$export$4f7f03641f7bfc8c) && !$93214c81831f46f5$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $93214c81831f46f5$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $93214c81831f46f5$var$matchBreak(node, delta) {
    if (!$93214c81831f46f5$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $93214c81831f46f5$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $93214c81831f46f5$var$applyFormat(delta, 'code-block', language, scroll);
}
function $93214c81831f46f5$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))();
}
function $93214c81831f46f5$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$93214c81831f46f5$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
}
function $93214c81831f46f5$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $93214c81831f46f5$var$applyFormat(delta, 'list', list, scroll);
}
function $93214c81831f46f5$export$c695b9637111f586(node, delta, scroll) {
    if (!$93214c81831f46f5$var$deltaEndsWith(delta, '\n')) {
        if ($93214c81831f46f5$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($93214c81831f46f5$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $91aa38be8274cd36$export$48b9f0688962d028)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $93214c81831f46f5$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $93214c81831f46f5$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().insert('\t').concat(delta);
    return delta;
}
function $93214c81831f46f5$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $93214c81831f46f5$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $93214c81831f46f5$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$93214c81831f46f5$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$93214c81831f46f5$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $93214c81831f46f5$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $93214c81831f46f5$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $93214c81831f46f5$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $93214c81831f46f5$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}





class $138d729f4c38d274$export$2e2bcd8739ae039 extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $e427c28fc0504942$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $e427c28fc0504942$export$2e2bcd8739ae039).events.SELECTION_CHANGE) {
                if (value && source !== (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $e427c28fc0504942$export$2e2bcd8739ae039).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $138d729f4c38d274$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $138d729f4c38d274$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $138d729f4c38d274$var$transformStack(this.stack.undo, delta);
        $138d729f4c38d274$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        else {
            const index = $138d729f4c38d274$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        }
    }
}
function $138d729f4c38d274$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $138d729f4c38d274$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $138d729f4c38d274$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK) != null;
    });
    return false;
}
function $138d729f4c38d274$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($138d729f4c38d274$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $138d729f4c38d274$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}






class $d00ba6efa2a92efd$var$Uploader extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$d00ba6efa2a92efd$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.SILENT);
        });
    }
};
var $d00ba6efa2a92efd$export$2e2bcd8739ae039 = $d00ba6efa2a92efd$var$Uploader;







const $f2ba53db6c07d9b2$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $f2ba53db6c07d9b2$var$Input extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $e427c28fc0504942$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $6747bc4e394910ac$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index).insert(text, formats), (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$f2ba53db6c07d9b2$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $f2ba53db6c07d9b2$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $f2ba53db6c07d9b2$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $f2ba53db6c07d9b2$export$2e2bcd8739ae039 = $f2ba53db6c07d9b2$var$Input;





const $4419d02e5a0d585d$var$isMac = /Mac/i.test(navigator.platform);
const $4419d02e5a0d585d$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $4419d02e5a0d585d$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($4419d02e5a0d585d$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $4419d02e5a0d585d$var$UINode extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $98ba5df99acb183a$export$e43113f0aad76fe)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $4419d02e5a0d585d$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $4419d02e5a0d585d$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $98ba5df99acb183a$export$e43113f0aad76fe)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $4419d02e5a0d585d$export$2e2bcd8739ae039 = $4419d02e5a0d585d$var$UINode;



(0, $e427c28fc0504942$export$2e2bcd8739ae039).register({
    'blots/block': (0, $91aa38be8274cd36$export$2e2bcd8739ae039),
    'blots/block/embed': (0, $91aa38be8274cd36$export$48b9f0688962d028),
    'blots/break': (0, $11f44e78483cf1e0$export$2e2bcd8739ae039),
    'blots/container': (0, $3fd3b9a1161f7ddd$export$2e2bcd8739ae039),
    'blots/cursor': (0, $d650dae3143ef8bb$export$2e2bcd8739ae039),
    'blots/embed': (0, $9747a5ed652b7dc2$export$2e2bcd8739ae039),
    'blots/inline': (0, $4f3156e5894c7a42$export$2e2bcd8739ae039),
    'blots/scroll': (0, $eef887622f3b7d5c$export$2e2bcd8739ae039),
    'blots/text': (0, $c13b40c809f3e8de$export$2e2bcd8739ae039),
    'modules/clipboard': (0, $93214c81831f46f5$export$2e2bcd8739ae039),
    'modules/history': (0, $138d729f4c38d274$export$2e2bcd8739ae039),
    'modules/keyboard': (0, $6747bc4e394910ac$export$2e2bcd8739ae039),
    'modules/uploader': (0, $d00ba6efa2a92efd$export$2e2bcd8739ae039),
    'modules/input': (0, $f2ba53db6c07d9b2$export$2e2bcd8739ae039),
    'modules/uiNode': (0, $4419d02e5a0d585d$export$2e2bcd8739ae039)
});
var $03b7c19bc69c2a05$export$2e2bcd8739ae039 = (0, $e427c28fc0504942$export$2e2bcd8739ae039);





class $667ef56a0138454e$var$IndentAttributor extends (0, $98ba5df99acb183a$export$651d45509677cf07) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $667ef56a0138454e$var$IndentClass = new $667ef56a0138454e$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $667ef56a0138454e$export$2e2bcd8739ae039 = $667ef56a0138454e$var$IndentClass;



class $1576dba529f87ed1$var$Blockquote extends (0, $91aa38be8274cd36$export$2e2bcd8739ae039) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $1576dba529f87ed1$export$2e2bcd8739ae039 = $1576dba529f87ed1$var$Blockquote;



class $a2bbc6e606cc124e$var$Header extends (0, $91aa38be8274cd36$export$2e2bcd8739ae039) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $a2bbc6e606cc124e$export$2e2bcd8739ae039 = $a2bbc6e606cc124e$var$Header;





class $f4a3fc62f450ca36$export$122a2a667e12876b extends (0, $3fd3b9a1161f7ddd$export$2e2bcd8739ae039) {
}
$f4a3fc62f450ca36$export$122a2a667e12876b.blotName = 'list-container';
$f4a3fc62f450ca36$export$122a2a667e12876b.tagName = 'OL';
class $f4a3fc62f450ca36$export$2e2bcd8739ae039 extends (0, $91aa38be8274cd36$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register($f4a3fc62f450ca36$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$f4a3fc62f450ca36$export$2e2bcd8739ae039.blotName = 'list';
$f4a3fc62f450ca36$export$2e2bcd8739ae039.tagName = 'LI';
$f4a3fc62f450ca36$export$122a2a667e12876b.allowedChildren = [
    $f4a3fc62f450ca36$export$2e2bcd8739ae039
];
$f4a3fc62f450ca36$export$2e2bcd8739ae039.requiredContainer = $f4a3fc62f450ca36$export$122a2a667e12876b;







class $faaac3f0b2148231$var$Bold extends (0, $4f3156e5894c7a42$export$2e2bcd8739ae039) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $faaac3f0b2148231$export$2e2bcd8739ae039 = $faaac3f0b2148231$var$Bold;



class $3ece3b42dec887a7$var$Italic extends (0, $faaac3f0b2148231$export$2e2bcd8739ae039) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $3ece3b42dec887a7$export$2e2bcd8739ae039 = $3ece3b42dec887a7$var$Italic;



class $8f39594da6a77995$export$2e2bcd8739ae039 extends (0, $4f3156e5894c7a42$export$2e2bcd8739ae039) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $8f39594da6a77995$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $8f39594da6a77995$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}



class $01ad7bcd508260ed$var$Script extends (0, $4f3156e5894c7a42$export$2e2bcd8739ae039) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $01ad7bcd508260ed$export$2e2bcd8739ae039 = $01ad7bcd508260ed$var$Script;



class $217e5df9cde32432$var$Strike extends (0, $faaac3f0b2148231$export$2e2bcd8739ae039) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $217e5df9cde32432$export$2e2bcd8739ae039 = $217e5df9cde32432$var$Strike;



class $423506536392ee48$var$Underline extends (0, $4f3156e5894c7a42$export$2e2bcd8739ae039) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $423506536392ee48$export$2e2bcd8739ae039 = $423506536392ee48$var$Underline;



class $421a3cc30e95d193$var$Formula extends (0, $9747a5ed652b7dc2$export$2e2bcd8739ae039) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $421a3cc30e95d193$export$2e2bcd8739ae039 = $421a3cc30e95d193$var$Formula;




const $7db01872f459733a$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $7db01872f459733a$var$Image extends (0, $98ba5df99acb183a$export$297a1fa96f55f00f) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $7db01872f459733a$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $8f39594da6a77995$export$83d2e9e3e4ee39ed)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($7db01872f459733a$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $7db01872f459733a$export$2e2bcd8739ae039 = $7db01872f459733a$var$Image;




const $74d0a4a57ba81a2a$var$ATTRIBUTES = [
    'height',
    'width'
];
class $74d0a4a57ba81a2a$var$Video extends (0, $91aa38be8274cd36$export$48b9f0688962d028) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $74d0a4a57ba81a2a$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $8f39594da6a77995$export$2e2bcd8739ae039).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($74d0a4a57ba81a2a$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $74d0a4a57ba81a2a$export$2e2bcd8739ae039 = $74d0a4a57ba81a2a$var$Video;














const $3722210973a840d9$var$TokenAttributor = new (0, $98ba5df99acb183a$export$651d45509677cf07)('code-token', 'hljs', {
    scope: (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE
});
class $3722210973a840d9$export$9460eee64f276be7 extends (0, $4f3156e5894c7a42$export$2e2bcd8739ae039) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $358eddd4869da41b$export$2e2bcd8739ae039).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $3722210973a840d9$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $3722210973a840d9$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $3722210973a840d9$var$TokenAttributor.add(this.domNode, value);
        else {
            $3722210973a840d9$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$3722210973a840d9$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$3722210973a840d9$export$9460eee64f276be7.blotName = 'code-token';
$3722210973a840d9$export$9460eee64f276be7.className = 'ql-token';
class $3722210973a840d9$export$6c415d1fdae3dfdb extends (0, $358eddd4869da41b$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $3722210973a840d9$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $3722210973a840d9$var$SyntaxCodeBlockContainer extends (0, $358eddd4869da41b$export$3b131632d3d15165) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $3722210973a840d9$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $3722210973a840d9$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $3722210973a840d9$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $91aa38be8274cd36$export$992ff47219af5a2b)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $3722210973a840d9$export$6c415d1fdae3dfdb.blotName,
                            $3722210973a840d9$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $3722210973a840d9$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $c13b40c809f3e8de$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $3722210973a840d9$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$3722210973a840d9$var$SyntaxCodeBlockContainer.allowedChildren = [
    $3722210973a840d9$export$6c415d1fdae3dfdb
];
$3722210973a840d9$export$6c415d1fdae3dfdb.requiredContainer = $3722210973a840d9$var$SyntaxCodeBlockContainer;
$3722210973a840d9$export$6c415d1fdae3dfdb.allowedChildren = [
    $3722210973a840d9$export$9460eee64f276be7,
    (0, $d650dae3143ef8bb$export$2e2bcd8739ae039),
    (0, $c13b40c809f3e8de$export$2e2bcd8739ae039),
    (0, $11f44e78483cf1e0$export$2e2bcd8739ae039)
];
const $3722210973a840d9$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $3722210973a840d9$export$2e2bcd8739ae039 extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    static register() {
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register($3722210973a840d9$export$9460eee64f276be7, true);
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register($3722210973a840d9$export$6c415d1fdae3dfdb, true);
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register($3722210973a840d9$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $e427c28fc0504942$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $3722210973a840d9$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($3722210973a840d9$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $3722210973a840d9$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $e427c28fc0504942$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($3722210973a840d9$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $c13b40c809f3e8de$export$96e6fc3a139b2555)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $358eddd4869da41b$export$2e2bcd8739ae039).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $358eddd4869da41b$export$2e2bcd8739ae039).className);
        container.innerHTML = $3722210973a840d9$var$highlight(this.options.hljs, language, text);
        return (0, $93214c81831f46f5$export$df3f009e3d155b20)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $3722210973a840d9$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(delta.length(), {
                    [$3722210973a840d9$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $358eddd4869da41b$export$2e2bcd8739ae039).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$3722210973a840d9$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};







class $abf8e1f50d231098$export$1e4baea7053fc0e3 extends (0, $91aa38be8274cd36$export$2e2bcd8739ae039) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $abf8e1f50d231098$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $abf8e1f50d231098$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $abf8e1f50d231098$export$b05581f4e764e162 extends (0, $3fd3b9a1161f7ddd$export$2e2bcd8739ae039) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $abf8e1f50d231098$export$76ccd210b9029917 extends (0, $3fd3b9a1161f7ddd$export$2e2bcd8739ae039) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $abf8e1f50d231098$export$f2c3aea42b2a048f extends (0, $3fd3b9a1161f7ddd$export$2e2bcd8739ae039) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($abf8e1f50d231098$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $abf8e1f50d231098$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($abf8e1f50d231098$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($abf8e1f50d231098$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($abf8e1f50d231098$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $abf8e1f50d231098$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($abf8e1f50d231098$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($abf8e1f50d231098$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $abf8e1f50d231098$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($abf8e1f50d231098$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($abf8e1f50d231098$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$abf8e1f50d231098$export$f2c3aea42b2a048f.allowedChildren = [
    $abf8e1f50d231098$export$76ccd210b9029917
];
$abf8e1f50d231098$export$76ccd210b9029917.requiredContainer = $abf8e1f50d231098$export$f2c3aea42b2a048f;
$abf8e1f50d231098$export$76ccd210b9029917.allowedChildren = [
    $abf8e1f50d231098$export$b05581f4e764e162
];
$abf8e1f50d231098$export$b05581f4e764e162.requiredContainer = $abf8e1f50d231098$export$76ccd210b9029917;
$abf8e1f50d231098$export$b05581f4e764e162.allowedChildren = [
    $abf8e1f50d231098$export$1e4baea7053fc0e3
];
$abf8e1f50d231098$export$1e4baea7053fc0e3.requiredContainer = $abf8e1f50d231098$export$b05581f4e764e162;
function $abf8e1f50d231098$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}


class $06b877e7b145b352$var$Table extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    static register() {
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register((0, $abf8e1f50d231098$export$1e4baea7053fc0e3));
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register((0, $abf8e1f50d231098$export$b05581f4e764e162));
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register((0, $abf8e1f50d231098$export$76ccd210b9029917));
        (0, $e427c28fc0504942$export$2e2bcd8739ae039).register((0, $abf8e1f50d231098$export$f2c3aea42b2a048f));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $abf8e1f50d231098$export$f2c3aea42b2a048f)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(offset, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $abf8e1f50d231098$export$1e4baea7053fc0e3).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $abf8e1f50d231098$export$9bd6f73cbe857f1b)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))().retain(range.index));
        this.quill.updateContents(delta, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $e427c28fc0504942$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $e427c28fc0504942$export$2e2bcd8739ae039).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $06b877e7b145b352$export$2e2bcd8739ae039 = $06b877e7b145b352$var$Table;







const $156512c93d9b9274$var$debug = (0, $38e9458ec9bb8ee6$export$2e2bcd8739ae039)('quill:toolbar');
class $156512c93d9b9274$export$2e2bcd8739ae039 extends (0, $526ece9aac0d6999$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $156512c93d9b9274$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $156512c93d9b9274$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $e427c28fc0504942$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $156512c93d9b9274$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $98ba5df99acb183a$export$297a1fa96f55f00f)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($82e25a5a05c59b45$exports)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format(format, value, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$156512c93d9b9274$export$2e2bcd8739ae039.DEFAULTS = {};
function $156512c93d9b9274$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $156512c93d9b9274$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $156512c93d9b9274$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $156512c93d9b9274$var$addSelect(group, format, value);
                else $156512c93d9b9274$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $156512c93d9b9274$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$156512c93d9b9274$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $98ba5df99acb183a$export$775b6bb06e53a214).INLINE) != null) this.quill.format(name, false, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            this.quill.format('direction', value, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format('list', value, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
        }
    }
};


const $ae9649e2ebdccf40$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $ae9649e2ebdccf40$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $ae9649e2ebdccf40$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $ae9649e2ebdccf40$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $ae9649e2ebdccf40$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $ae9649e2ebdccf40$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $ae9649e2ebdccf40$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $ae9649e2ebdccf40$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $ae9649e2ebdccf40$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $ae9649e2ebdccf40$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $ae9649e2ebdccf40$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $ae9649e2ebdccf40$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $ae9649e2ebdccf40$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $ae9649e2ebdccf40$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $ae9649e2ebdccf40$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $ae9649e2ebdccf40$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $ae9649e2ebdccf40$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $ae9649e2ebdccf40$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $ae9649e2ebdccf40$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $ae9649e2ebdccf40$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $ae9649e2ebdccf40$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $ae9649e2ebdccf40$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $ae9649e2ebdccf40$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $ae9649e2ebdccf40$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $ae9649e2ebdccf40$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $ae9649e2ebdccf40$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $ae9649e2ebdccf40$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $ae9649e2ebdccf40$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $ae9649e2ebdccf40$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $ae9649e2ebdccf40$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $ae9649e2ebdccf40$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $ae9649e2ebdccf40$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $ae9649e2ebdccf40$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $ae9649e2ebdccf40$export$2e2bcd8739ae039 = {
    align: {
        '': $ae9649e2ebdccf40$var$alignLeftIcon,
        center: $ae9649e2ebdccf40$var$alignCenterIcon,
        right: $ae9649e2ebdccf40$var$alignRightIcon,
        justify: $ae9649e2ebdccf40$var$alignJustifyIcon
    },
    background: $ae9649e2ebdccf40$var$backgroundIcon,
    blockquote: $ae9649e2ebdccf40$var$blockquoteIcon,
    bold: $ae9649e2ebdccf40$var$boldIcon,
    clean: $ae9649e2ebdccf40$var$cleanIcon,
    code: $ae9649e2ebdccf40$var$codeIcon,
    'code-block': $ae9649e2ebdccf40$var$codeIcon,
    color: $ae9649e2ebdccf40$var$colorIcon,
    direction: {
        '': $ae9649e2ebdccf40$var$directionLeftToRightIcon,
        rtl: $ae9649e2ebdccf40$var$directionRightToLeftIcon
    },
    formula: $ae9649e2ebdccf40$var$formulaIcon,
    header: {
        '1': $ae9649e2ebdccf40$var$headerIcon,
        '2': $ae9649e2ebdccf40$var$header2Icon,
        '3': $ae9649e2ebdccf40$var$header3Icon,
        '4': $ae9649e2ebdccf40$var$header4Icon,
        '5': $ae9649e2ebdccf40$var$header5Icon,
        '6': $ae9649e2ebdccf40$var$header6Icon
    },
    italic: $ae9649e2ebdccf40$var$italicIcon,
    image: $ae9649e2ebdccf40$var$imageIcon,
    indent: {
        '+1': $ae9649e2ebdccf40$var$indentIcon,
        '-1': $ae9649e2ebdccf40$var$outdentIcon
    },
    link: $ae9649e2ebdccf40$var$linkIcon,
    list: {
        bullet: $ae9649e2ebdccf40$var$listBulletIcon,
        check: $ae9649e2ebdccf40$var$listCheckIcon,
        ordered: $ae9649e2ebdccf40$var$listOrderedIcon
    },
    script: {
        sub: $ae9649e2ebdccf40$var$subscriptIcon,
        super: $ae9649e2ebdccf40$var$superscriptIcon
    },
    strike: $ae9649e2ebdccf40$var$strikeIcon,
    table: $ae9649e2ebdccf40$var$tableIcon,
    underline: $ae9649e2ebdccf40$var$underlineIcon,
    video: $ae9649e2ebdccf40$var$videoIcon
};


const $bf0c1fdf18a853c6$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $bf0c1fdf18a853c6$var$optionsCounter = 0;
function $bf0c1fdf18a853c6$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $bf0c1fdf18a853c6$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $bf0c1fdf18a853c6$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $bf0c1fdf18a853c6$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $bf0c1fdf18a853c6$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$bf0c1fdf18a853c6$var$optionsCounter}`;
        $bf0c1fdf18a853c6$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $bf0c1fdf18a853c6$export$2e2bcd8739ae039 = $bf0c1fdf18a853c6$var$Picker;



class $33283f92b0474ec8$var$ColorPicker extends (0, $bf0c1fdf18a853c6$export$2e2bcd8739ae039) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $33283f92b0474ec8$export$2e2bcd8739ae039 = $33283f92b0474ec8$var$ColorPicker;



class $98b1a6da0143cdf4$var$IconPicker extends (0, $bf0c1fdf18a853c6$export$2e2bcd8739ae039) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $98b1a6da0143cdf4$export$2e2bcd8739ae039 = $98b1a6da0143cdf4$var$IconPicker;


const $851807008fabc115$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $851807008fabc115$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($851807008fabc115$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $851807008fabc115$export$2e2bcd8739ae039 = $851807008fabc115$var$Tooltip;











const $03d3bcd149288754$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $03d3bcd149288754$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $03d3bcd149288754$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $03d3bcd149288754$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $03d3bcd149288754$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $03d3bcd149288754$export$2e2bcd8739ae039 extends (0, $160b75e6fe1673cc$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $03d3bcd149288754$var$fillSelect(select, $03d3bcd149288754$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $98b1a6da0143cdf4$export$2e2bcd8739ae039)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $03d3bcd149288754$var$fillSelect(select, $03d3bcd149288754$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $33283f92b0474ec8$export$2e2bcd8739ae039)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $03d3bcd149288754$var$fillSelect(select, $03d3bcd149288754$var$FONTS);
                else if (select.classList.contains('ql-header')) $03d3bcd149288754$var$fillSelect(select, $03d3bcd149288754$var$HEADERS);
                else if (select.classList.contains('ql-size')) $03d3bcd149288754$var$fillSelect(select, $03d3bcd149288754$var$SIZES);
            }
            return new (0, $bf0c1fdf18a853c6$export$2e2bcd8739ae039)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.EDITOR_CHANGE, update);
    }
}
$03d3bcd149288754$export$2e2bcd8739ae039.DEFAULTS = (0, $451ad2baa4201321$export$2e2bcd8739ae039)({}, (0, $160b75e6fe1673cc$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $03d3bcd149288754$export$ba0102162f9e195c extends (0, $851807008fabc115$export$2e2bcd8739ae039) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $03d3bcd149288754$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index + 2, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $03d3bcd149288754$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $03d3bcd149288754$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}





const $2f9493b6b0d022ca$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $2f9493b6b0d022ca$export$572b56f7a5e9813a extends (0, $03d3bcd149288754$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $f277c87dff6d716f$export$9a58ef0d7ad3278c)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $2f9493b6b0d022ca$export$2e2bcd8739ae039 extends (0, $03d3bcd149288754$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $2f9493b6b0d022ca$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $2f9493b6b0d022ca$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $ae9649e2ebdccf40$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $ae9649e2ebdccf40$export$2e2bcd8739ae039));
        }
    }
}
$2f9493b6b0d022ca$export$2e2bcd8739ae039.DEFAULTS = (0, $451ad2baa4201321$export$2e2bcd8739ae039)({}, (0, $03d3bcd149288754$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});









const $f6db6b904554c683$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $f6db6b904554c683$var$SnowTooltip extends (0, $03d3bcd149288754$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $86b9bfd1834ce2b9$export$2e2bcd8739ae039).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $8f39594da6a77995$export$2e2bcd8739ae039), range.index);
                if (link != null) {
                    this.linkRange = new (0, $f277c87dff6d716f$export$9a58ef0d7ad3278c)(range.index - offset, link.length());
                    const preview = (0, $8f39594da6a77995$export$2e2bcd8739ae039).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $f6db6b904554c683$var$SnowTheme extends (0, $03d3bcd149288754$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $f6db6b904554c683$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $ae9649e2ebdccf40$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $ae9649e2ebdccf40$export$2e2bcd8739ae039));
            // @ts-expect-error
            this.tooltip = new $f6db6b904554c683$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$f6db6b904554c683$var$SnowTheme.DEFAULTS = (0, $451ad2baa4201321$export$2e2bcd8739ae039)({}, (0, $03d3bcd149288754$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $e427c28fc0504942$export$2e2bcd8739ae039).sources.USER);
                }
            }
        }
    }
});
var $f6db6b904554c683$export$2e2bcd8739ae039 = $f6db6b904554c683$var$SnowTheme;


(0, $03b7c19bc69c2a05$export$2e2bcd8739ae039).register({
    'attributors/attribute/direction': (0, $81390373d29f2d8e$export$4158215dafad9efa),
    'attributors/class/align': (0, $15eefb82df67033a$export$7f3685f5846c07da),
    'attributors/class/background': (0, $4ed9b61effc385b4$export$8aa96c8963152b12),
    'attributors/class/color': (0, $169716956cabd648$export$42795dcf0ec6f3c8),
    'attributors/class/direction': (0, $81390373d29f2d8e$export$630028b3af294dec),
    'attributors/class/font': (0, $3eade1afb6ffe4bd$export$78a99ee601572ab),
    'attributors/class/size': (0, $b14d39691f988cde$export$c84684d52bca9684),
    'attributors/style/align': (0, $15eefb82df67033a$export$d2060f5d114c9fe8),
    'attributors/style/background': (0, $4ed9b61effc385b4$export$dc1cbcab4c682ef),
    'attributors/style/color': (0, $169716956cabd648$export$1415f56796d9a5a9),
    'attributors/style/direction': (0, $81390373d29f2d8e$export$175979e518d1dfd1),
    'attributors/style/font': (0, $3eade1afb6ffe4bd$export$23b468d4ca3f8c96),
    'attributors/style/size': (0, $b14d39691f988cde$export$5443b95a30e89ac5)
}, true);
(0, $03b7c19bc69c2a05$export$2e2bcd8739ae039).register({
    'formats/align': (0, $15eefb82df67033a$export$7f3685f5846c07da),
    'formats/direction': (0, $81390373d29f2d8e$export$630028b3af294dec),
    'formats/indent': (0, $667ef56a0138454e$export$2e2bcd8739ae039),
    'formats/background': (0, $4ed9b61effc385b4$export$dc1cbcab4c682ef),
    'formats/color': (0, $169716956cabd648$export$1415f56796d9a5a9),
    'formats/font': (0, $3eade1afb6ffe4bd$export$78a99ee601572ab),
    'formats/size': (0, $b14d39691f988cde$export$c84684d52bca9684),
    'formats/blockquote': (0, $1576dba529f87ed1$export$2e2bcd8739ae039),
    'formats/code-block': (0, $358eddd4869da41b$export$2e2bcd8739ae039),
    'formats/header': (0, $a2bbc6e606cc124e$export$2e2bcd8739ae039),
    'formats/list': (0, $f4a3fc62f450ca36$export$2e2bcd8739ae039),
    'formats/bold': (0, $faaac3f0b2148231$export$2e2bcd8739ae039),
    'formats/code': (0, $358eddd4869da41b$export$52f0f02147b12c03),
    'formats/italic': (0, $3ece3b42dec887a7$export$2e2bcd8739ae039),
    'formats/link': (0, $8f39594da6a77995$export$2e2bcd8739ae039),
    'formats/script': (0, $01ad7bcd508260ed$export$2e2bcd8739ae039),
    'formats/strike': (0, $217e5df9cde32432$export$2e2bcd8739ae039),
    'formats/underline': (0, $423506536392ee48$export$2e2bcd8739ae039),
    'formats/formula': (0, $421a3cc30e95d193$export$2e2bcd8739ae039),
    'formats/image': (0, $7db01872f459733a$export$2e2bcd8739ae039),
    'formats/video': (0, $74d0a4a57ba81a2a$export$2e2bcd8739ae039),
    'modules/syntax': (0, $3722210973a840d9$export$2e2bcd8739ae039),
    'modules/table': (0, $06b877e7b145b352$export$2e2bcd8739ae039),
    'modules/toolbar': (0, $156512c93d9b9274$export$2e2bcd8739ae039),
    'themes/bubble': (0, $2f9493b6b0d022ca$export$2e2bcd8739ae039),
    'themes/snow': (0, $f6db6b904554c683$export$2e2bcd8739ae039),
    'ui/icons': (0, $ae9649e2ebdccf40$export$2e2bcd8739ae039),
    'ui/picker': (0, $bf0c1fdf18a853c6$export$2e2bcd8739ae039),
    'ui/icon-picker': (0, $98b1a6da0143cdf4$export$2e2bcd8739ae039),
    'ui/color-picker': (0, $33283f92b0474ec8$export$2e2bcd8739ae039),
    'ui/tooltip': (0, $851807008fabc115$export$2e2bcd8739ae039)
}, true);
var $04785250aeaaea2a$export$2e2bcd8739ae039 = (0, $03b7c19bc69c2a05$export$2e2bcd8739ae039);




var $eeH7J = parcelRequire("eeH7J");

// Editor is an uncontrolled React component
const $40f677e58b6f6bdb$var$Editor = /*#__PURE__*/ (0, $eeH7J.forwardRef)(({ readOnly: readOnly, siteId: siteId, defaultValue: defaultValue, content: content, onTextChange: onTextChange, onSelectionChange: onSelectionChange, error: error }, ref)=>{
    const containerRef = (0, $eeH7J.useRef)(null);
    // const defaultValueRef = useRef(defaultValue);
    const onTextChangeRef = (0, $eeH7J.useRef)(onTextChange);
    const onSelectionChangeRef = (0, $eeH7J.useRef)(onSelectionChange);
    const [showImageUpload, setShowImageUpload] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const [range, setRange] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(null);
    (0, $eeH7J.useLayoutEffect)(()=>{
        onTextChangeRef.current = onTextChange;
        onSelectionChangeRef.current = onSelectionChange;
    });
    (0, $eeH7J.useEffect)(()=>{
        ref.current?.enable(!readOnly);
    }, [
        ref,
        readOnly
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (ref?.current?.root) ref.current.root.innerHTML = content;
    }, [
        content
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const container = containerRef.current;
        const editorContainer = container.appendChild(container.ownerDocument.createElement('div'));
        const quill = new (0, $04785250aeaaea2a$export$2e2bcd8739ae039)(editorContainer, {
            modules: {
                toolbar: {
                    container: [
                        [
                            // { 'font': [] }, 
                            {
                                'size': []
                            }
                        ],
                        [
                            'bold',
                            'italic',
                            'underline',
                            'strike'
                        ],
                        [
                            {
                                'color': []
                            },
                            {
                                'background': []
                            }
                        ],
                        [
                            {
                                'script': 'super'
                            },
                            {
                                'script': 'sub'
                            }
                        ],
                        [
                            {
                                'header': '1'
                            },
                            {
                                'header': '2'
                            },
                            'blockquote',
                            'code-block'
                        ],
                        [
                            {
                                'list': 'ordered'
                            },
                            {
                                'list': 'bullet'
                            },
                            {
                                'indent': '-1'
                            },
                            {
                                'indent': '+1'
                            }
                        ],
                        [
                            'direction',
                            {
                                'align': []
                            }
                        ],
                        [
                            'link',
                            'image',
                            'video',
                            'formula'
                        ],
                        [
                            'clean'
                        ]
                    ],
                    handlers: {
                        'image': ()=>{
                            // setShowImageUpload(true);
                            const range = ref.current.getSelection();
                            // setRange(range);
                            insertImage('https://pagebuilder-images-bucket.s3.amazonaws.com/01c1d933-53c9-4b12-803a-b264d5e94cd7-ScreenshotatPM.png');
                        }
                    }
                }
            },
            placeholder: 'Enter post content here...',
            theme: 'snow'
        });
        ref.current = quill;
        if (content) // quill.setContents(defaultValue);
        quill.root.innerHTML = content;
        quill.on((0, $04785250aeaaea2a$export$2e2bcd8739ae039).events.TEXT_CHANGE, (...args)=>{
            onTextChangeRef.current?.(quill.root.innerHTML);
        });
        quill.on((0, $04785250aeaaea2a$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (...args)=>{
            onSelectionChangeRef.current?.(...args);
        });
        return ()=>{
            ref.current = null;
            container.innerHTML = '';
        };
    }, [
        ref
    ]);
    function insertImage(url) {
        console.log('insertImage', url);
        // const range = ref.current.getSelection();
        ref.current.insertEmbed(range?.index, 'image', url);
        setShowImageUpload(false);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: error ? 'border border-red-300' : 'py-1',
        ref: containerRef
    }), showImageUpload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 100,
            backgroundColor: 'white',
            borderRadius: '10px',
            width: '80%',
            height: '80%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $162e110d4fb932a6$export$2e2bcd8739ae039), {
        siteId: siteId,
        onClose: ()=>setShowImageUpload(false),
        onSelect: (url)=>insertImage(url)
    })), !!error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "text-red-500 text-sm"
    }, error));
});
$40f677e58b6f6bdb$var$Editor.displayName = 'Editor';
var $40f677e58b6f6bdb$export$2e2bcd8739ae039 = $40f677e58b6f6bdb$var$Editor;


function $18379ea430b3b2f1$export$2e2bcd8739ae039(props) {
    const quillRef = (0, $eeH7J.useRef)(null);
    const [postData, setPostData] = (0, $eeH7J.useState)(props?.post ?? {}); // form data
    const [post, setPost] = (0, $eeH7J.useState)({}); // post we get from backend (full data in here)
    const [errors, setErrors] = (0, $eeH7J.useState)({});
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    (0, $eeH7J.useEffect)(()=>{
        if (!props.post) return;
        (async ()=>{
            const post = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get('/api/configs/post-for-admin', {
                params: {
                    id: props.post?.id
                }
            });
            console.log('post.data', post.data);
            setPost(post.data.post);
            setPostData(post.data.post);
        })();
    }, []);
    const validateForm = (action = 'save')=>{
        const errors = {};
        if (!postData.title) errors['title'] = 'Title is required';
        let isSlugAlreadyUsed = !!props.posts.find((p)=>p.slug === postData.slug && p.id !== postData.id); // find if slug is already used
        if (isSlugAlreadyUsed) errors['slug'] = 'Slug is already used';
        if (!postData.slug) errors['slug'] = 'Slug is required';
        if (action === 'publish') {
            if (!postData.bannerImage) errors['bannerImage'] = 'Banner image is required';
            if (!postData.bannerImageAlt) errors['bannerImageAlt'] = 'Banner image alt text is required';
            if (!quillRef.current?.root.innerText) errors['content'] = 'Content is required';
            else if (quillRef.current?.root.innerText.length < 50) errors['content'] = 'Content should be atleast 50 characters';
        }
        console.log('errors', errors, {
            ...postData,
            innerText: quillRef.current?.root?.innerText
        });
        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            // scroll to top smoothly
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            enqueueSnackbar('Please fix errors!', {
                variant: 'error'
            });
        }
        return Object.keys(errors).length === 0;
    };
    const handleBlogCreate = async ()=>{
        setIsLoading(true);
        const innerText = quillRef?.current?.root.innerHTML;
        setPostData({
            ...postData,
            content: innerText
        });
        if (!validateForm(!post?.publishedAt ? 'save' : 'publish')) {
            setIsLoading(false);
            return;
        }
        const assets = getImageUrlsFromContent(innerText);
        const res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post('/api/configs/post-for-admin', {
            ...post,
            ...postData,
            siteId: props.siteId,
            content: innerText,
            assets: assets
        });
        if (res.data.error) {
            enqueueSnackbar(res.data.error, {
                variant: 'error'
            });
            setIsLoading(false);
            return;
        }
        setPost(res.data.data);
        setPostData(res.data.data);
        props.onPostUpdateOrCreate && props.onPostUpdateOrCreate(res.data.data);
        if (!post.publishedAt) enqueueSnackbar('Post saved successfully', {
            variant: 'success'
        });
        else enqueueSnackbar('Post saved successfully. \nWe\'ll notify you once it\'s published.', {
            variant: 'success'
        });
        setIsLoading(false);
    };
    const handleBlogPublish = async ()=>{
        if (!post?.id) return;
        setIsLoading(true);
        if (!validateForm('publish')) {
            setIsLoading(false);
            return;
        }
        const res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post('/api/configs/post-for-admin', {
            id: post.id,
            siteId: props.siteId,
            publish: true
        });
        if (res.data.error) {
            enqueueSnackbar(res.data.error, {
                variant: 'error'
            });
            setIsLoading(false);
            return;
        }
        setPost(res.data.data);
        props.onPostUpdateOrCreate && props.onPostUpdateOrCreate(res.data.data);
        enqueueSnackbar("Post saved successfully. \nWe'll notify you once it's published.", {
            variant: 'success'
        });
        setIsLoading(false);
    };
    /**
   * get images embedded in the content text
   * we need these to upload to caddy server
   */ function getImageUrlsFromContent(htmlContent) {
        // Create a hidden DOM element
        const div = document.createElement('div');
        div.innerHTML = htmlContent;
        // Query for all img elements
        const imgElements = div.querySelectorAll('img');
        // Extract the src attribute from each img element
        const imageUrls = Array.from(imgElements).map((img)=>img.src).filter((src)=>src.startsWith('https://pagebuilder-images-bucket.s3.amazonaws.com'));
        return imageUrls;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, props.onBackClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-between items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-1 lg:my-6 my-2 rounded-md",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>props.onBackClick(),
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($0628f66b8cb65c53$exports))), {
        sx: {
            height: "22px",
            width: "22px",
            marginRight: 0.5
        }
    }), "Back")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex lg:flex-row flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "image-upload-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ff983ef19f38fcda$export$2e2bcd8739ae039), {
        size: "full",
        image_url: post?.bannerImage,
        siteId: props.siteId,
        title: "Post Cover image",
        notes: "Please upload a .PNG or .JPG image.",
        onImageChange: (img_url)=>setPostData({
                ...postData,
                bannerImage: img_url
            }),
        error: !!errors['bannerImage'],
        altError: !!errors['bannerImageAlt'],
        showAlt: true,
        altValue: postData?.bannerImageAlt,
        onAltChange: (value)=>setPostData({
                ...postData,
                bannerImageAlt: value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "lg:ml-10 ml-0 "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Post Url"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        defaultValue: props?.post?.slug,
        className: "w-full border rounded border-catelina-blue/60 py-1 text-base-2 mb-3  bg-white",
        onChange: (e)=>setPostData({
                ...postData,
                slug: e.target.value
            }),
        size: "small",
        InputProps: {
            startAdornment: 'xyz.rocketpages.io/blog/',
            classes: {
                input: 'text-base-2'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        },
        error: !!errors['slug'],
        helperText: errors['slug']
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Post Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        defaultValue: props?.post?.title,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Post Title",
        onChange: (e)=>setPostData({
                ...postData,
                title: e.target.value
            }),
        size: "small",
        error: !!errors['title'],
        helperText: errors['title'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Post Meta Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        value: postData?.metaDesc,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Post Meta Description",
        onChange: (e)=>setPostData({
                ...postData,
                metaDesc: e.target.value
            }),
        size: "small",
        error: !!errors['metaDesc'],
        helperText: errors['metaDesc'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-lg mb-2  text-grey-primary"
    }, "Post Body"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $40f677e58b6f6bdb$export$2e2bcd8739ae039), {
        ref: quillRef,
        siteId: props.siteId,
        content: post?.content,
        error: errors['content']
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-end"
    }, post.publishedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-1 my-6 mr-4",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        color: "error",
        disableElevation: true,
        onClick: (e)=>props.onPostDelete()
    }, "Delete"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        className: "py-1 my-6 rounded-md",
        disabled: isLoading,
        sx: {
            textTransform: "none"
        },
        variant: !post?.publishedAt ? "outlined" : "contained",
        onClick: (e)=>handleBlogCreate(),
        disableElevation: true
    }, post?.publishedAt ? 'Save & Publish' : 'Save'), !post?.publishedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        disabled: !post?.id || isLoading,
        className: "py-1 my-6 ml-4 rounded-md",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>handleBlogPublish()
    }, "Publish")));
}




var $eeH7J = parcelRequire("eeH7J");

function $0758e49def1d5147$export$2e2bcd8739ae039(props) {
    const [blogDetails, setBlogDetails] = (0, $eeH7J.useState)(props?.blogConfig?.blog ?? {
        url: 'blog'
    });
    const [errors, setErrors] = (0, $eeH7J.useState)({});
    (0, $eeH7J.useEffect)(()=>{
        // if (!props?.blogConfig?.blog?.url) return;
        const url = props?.blogConfig?.blog?.url?.startsWith('/') ? props?.blogConfig?.blog?.url?.substr(1) : props?.blogConfig?.blog?.url;
        setBlogDetails({
            ...props?.blogConfig?.blog,
            url: url || 'blog'
        });
    }, [
        JSON.stringify(props?.blogConfig?.blog ?? {})
    ]);
    const validateForm = ()=>{
        const errors = {};
        if (!blogDetails.title) errors['title'] = 'Title is required';
        if (!blogDetails.desc) errors['desc'] = 'Description is required';
        if (!blogDetails.url) errors['url'] = 'Blog URL is required';
        else if (props.sitePages?.map((page)=>page?.pageUrl?.split('/')?.filter((urlSection)=>urlSection !== '/' && !!urlSection)[0]).find((url)=>url === blogDetails.url)) errors['url'] = 'Page already exists with this URL';
        if (!blogDetails.metaImage) errors['metaImage'] = 'Meta Image is required';
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSave = ()=>{
        if (!validateForm()) return;
        props.onBlogConfigChange({
            ...props.blogConfig,
            blog: {
                ...props.blogConfig.blog,
                ...blogDetails
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex gap-10 flex-col-reverse lg:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "image-upload-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ff983ef19f38fcda$export$2e2bcd8739ae039), {
        size: "full",
        image_url: blogDetails?.metaImage,
        siteId: props.siteId,
        title: "Bloglist Meta Image",
        notes: "Please upload a .PNG or .JPG image.",
        onImageChange: (img_url)=>setBlogDetails({
                ...blogDetails,
                metaImage: img_url
            }),
        error: !!errors['metaImage'],
        altError: !!errors['metaImageAlt'],
        showAlt: true,
        altValue: blogDetails?.metaImageAlt,
        onAltChange: (value)=>setBlogDetails({
                ...blogDetails,
                metaImageAlt: value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Blog Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        value: blogDetails?.title,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Blog Title",
        onChange: (e)=>setBlogDetails({
                ...blogDetails,
                title: e.target.value
            }),
        size: "small",
        error: !!errors['title'],
        helperText: errors['title'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Blog Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        value: blogDetails?.desc,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Blog Description",
        onChange: (e)=>setBlogDetails({
                ...blogDetails,
                desc: e.target.value
            }),
        size: "small",
        error: !!errors['desc'],
        helperText: errors['desc'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
        className: "md:text-base-2 text-md mb-2 text-grey-primary flex"
    }, "Blog URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $b26788a1fbff39fd$export$2e2bcd8739ae039), {
        value: blogDetails?.url,
        // value={blogUrl ?? ''}
        className: "w-full border rounded border-catelina-blue/60  text-base  mr-4 ",
        onChange: (e)=>{
            let value = e.target.value;
            if (value.startsWith('/')) value = value.substring(1);
            if (value.endsWith('/')) value = value.substring(0, value.length - 1);
            setBlogDetails({
                ...blogDetails,
                url: value
            });
        },
        // size="small"
        error: !!errors['url'],
        helperText: errors['url'] ?? '',
        InputProps: {
            startAdornment: 'xyz.rocketpages.io/',
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            },
            classes: {
                input: 'py-2 text-base'
            }
        },
        sx: {
            padding: '0'
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "save",
        className: "py-1 md:w-20 w-full md:mt-0 mt-2  rounded-md",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        disabled: JSON.stringify(blogDetails) === JSON.stringify(props?.blogConfig?.blog),
        onClick: handleSave
    }, "Save")));
}


function $80868de56ac81b2c$export$2e2bcd8739ae039(props) {
    const [posts, setPosts] = (0, $eeH7J.useState)([]);
    const [showDeleteDialog, setShowDeleteDialog] = (0, $eeH7J.useState)(false);
    const [currentPage, setCurrentPage] = (0, $eeH7J.useState)(1);
    const [editMode, setEditMode] = (0, $eeH7J.useState)(false);
    const [currentEditPost, setCurrentEditPost] = (0, $eeH7J.useState)(props?.blogConfig?.blog ?? {});
    const [tab, setTab] = (0, $eeH7J.useState)(0);
    (0, $eeH7J.useEffect)(()=>{
        fetchPosts();
    }, []);
    const fetchPosts = async ()=>{
        const posts = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get('/api/configs/posts-for-admin', {
            params: {
                siteId: props.siteId
            }
        });
        console.log('posts.data', posts.data);
        setPosts(posts.data?.posts?.sort((a, b)=>{
            let dateA = new Date(a.createdAt);
            let dateB = new Date(b.createdAt);
            return dateB - dateA;
        }) ?? []);
    // setTotalPosts(posts.data?.count ?? 0);
    };
    // click of back button
    const handleBack = ()=>{
        setEditMode(false);
        setCurrentEditPost(null);
    };
    // if a post is updated from child component,
    // we update the posts array to update paginated list
    const handlePostUpdateOrCreate = (post)=>{
        if (post.id) {
            const idx = posts.findIndex((p)=>p.id === post.id);
            if (idx !== -1) posts[idx] = post;
            else posts.unshift(post);
        }
        setPosts(posts);
        if (post.publishedAt) props.listenToBlogPublish();
    // setEditMode(false);
    // setCurrentEditPost(null);
    };
    const handleDeletePost = async ()=>{
        if (!currentEditPost) return;
        const res = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).delete('/api/configs/post-for-admin', {
            params: {
                id: currentEditPost.id
            }
        });
        console.log('res', res);
        const idx = posts.findIndex((p)=>p.id === currentEditPost.id);
        if (idx !== -1) posts.splice(idx, 1);
        setPosts(posts);
        setShowDeleteDialog(false);
        setCurrentEditPost(null);
        setEditMode(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, !editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $0758e49def1d5147$export$2e2bcd8739ae039), {
        blogConfig: props.blogConfig,
        sitePages: props.sitePages,
        onBlogConfigChange: props.onBlogConfigChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), {
        className: "md:mt-10 mt-4",
        sx: {
            '&.MuiDivider-root': {
                borderColor: '#3B3B3B66'
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-between items-center my-5 bg-white border border-catelina-blue/20 py-2 px-4 rounded-md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: "text-lg my-0"
    }, "Posts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "add",
        className: "py-1.5 px-4 rounded-md text-base",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>setEditMode(true)
    }, "Create New Post")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($80868de56ac81b2c$var$BlogList, {
        posts: posts,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        setEditMode: setEditMode,
        setCurrentEditPost: setCurrentEditPost,
        setShowDeleteDialog: setShowDeleteDialog,
        tab: tab,
        setTab: setTab
    })), editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $18379ea430b3b2f1$export$2e2bcd8739ae039), {
        posts: posts,
        siteId: props.siteId,
        onBackClick: handleBack,
        post: currentEditPost,
        onPostUpdateOrCreate: handlePostUpdateOrCreate,
        onPostDelete: ()=>setShowDeleteDialog(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($80868de56ac81b2c$var$BlogDeleteDialog, {
        showDeleteDialog: showDeleteDialog,
        setShowDeleteDialog: setShowDeleteDialog,
        handleDeletePost: handleDeletePost
    }));
}



const $80868de56ac81b2c$var$BlogList = ({ posts: posts, currentPage: currentPage, setCurrentPage: setCurrentPage, setEditMode: setEditMode, setCurrentEditPost: setCurrentEditPost, setShowDeleteDialog: setShowDeleteDialog, tab: tab, setTab: setTab })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $6146074d8a2c7938$export$2e2bcd8739ae039), {
        value: tab,
        onChange: (e, newValue)=>{
            setCurrentPage(1);
            setTab(newValue);
        },
        className: "mb-4 border-b-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $6878910a69f430c4$export$2e2bcd8739ae039), {
        sx: {
            '&.MuiTab-root': {
                textTransform: 'capitalize'
            }
        },
        label: `Published (${posts.filter((post)=>post.publishedAt).length})`,
        ...$80868de56ac81b2c$var$a11yProps(0)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $6878910a69f430c4$export$2e2bcd8739ae039), {
        sx: {
            '&.MuiTab-root': {
                textTransform: 'capitalize'
            }
        },
        label: `Drafts (${posts.filter((post)=>!post.publishedAt).length})`,
        ...$80868de56ac81b2c$var$a11yProps(1)
    })), posts.filter((_, idx)=>(currentPage - 1) * 10 < idx + 1 && idx <= currentPage * 10 && (tab === 0 ? _.publishedAt : !_.publishedAt)).map((post)=>{
        const postDate = new Date(post.createdAt);
        const formattedDate = postDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit'
        }).replace(/\//g, '-');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            key: post.id,
            className: "flex justify-between bg-white mb-4 p-6 rounded-md border border-[#E1E4EF] items-start md:flex-row flex-col relative"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "flex mr-0 md:mr-10 md:flex-row flex-col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "border border-[#24306099] bg-[#FAFAFA] h-12 justify-center flex rounded-[6px]",
            style: {
                minWidth: '100px',
                width: '100px'
            }
        }, post.bannerImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: post.bannerImage,
            alt: post.title,
            className: " object-cover rounded-[6px] w-full"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            src: (parcelRequire("ejk8q")),
            alt: post.title,
            width: "30px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "md:ml-4 ml-0 md:mt-0 mt-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
            className: "text-grey-primary font-bold mb-0"
        }, post.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("p", {
            className: "text-grey-primary text-sm mb-0"
        }, formattedDate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            className: "flex items-center  justify-end w-full  md:w-auto edit-delete-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            className: "lg:mr-3 mr-2",
            width: "20",
            src: (parcelRequire("cdbbO")),
            onClick: ()=>{
                setCurrentEditPost(post);
                setEditMode(true);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            className: "lg:ml-4 ml-2",
            width: "20",
            src: (parcelRequire("8OUdM")),
            onClick: ()=>{
                setCurrentEditPost(post);
                setShowDeleteDialog(true);
            }
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: "flex justify-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $c186f8785e46a619$export$2e2bcd8739ae039), {
        hidden: posts.filter((_)=>tab === 0 ? _.publishedAt : !_.publishedAt).length <= 10,
        count: Math.ceil(posts.length / 10),
        page: currentPage,
        variant: "outlined",
        shape: "rounded",
        onChange: (e, page)=>setCurrentPage(page)
    })));
};
const $80868de56ac81b2c$var$BlogDeleteDialog = ({ showDeleteDialog: showDeleteDialog, setShowDeleteDialog: setShowDeleteDialog, handleDeletePost: handleDeletePost })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $f1516034835581bb$export$2e2bcd8739ae039), {
        open: showDeleteDialog,
        onClose: ()=>setShowDeleteDialog(false),
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d05b73e6cf89853f$export$2e2bcd8739ae039), {
        id: "alert-dialog-title"
    }, "Are you sure you want to delete this blog post?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $c53071d61af48ae6$export$2e2bcd8739ae039), {
        sx: {
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        onClick: ()=>setShowDeleteDialog(false),
        variant: "outlined",
        disableElevation: true
    }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        onClick: ()=>handleDeletePost(),
        autoFocus: true,
        color: "error",
        variant: "contained",
        disableElevation: true
    }, "Delete")));
};
function $80868de56ac81b2c$var$a11yProps(index) {
    return {
        id: `blog-tab-${index}`,
        'aria-controls': `blog-tabpanel-${index}`
    };
}




var $eeH7J = parcelRequire("eeH7J");

const $8346ae9b264c0b88$var$BlogThumbnails = [
    {
        layout: 'blog_v1',
        src: (parcelRequire("iIIUf")),
        default: true
    }
];
function $8346ae9b264c0b88$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: "text-lg mb-2"
    }, "Blog Listing Page"), $8346ae9b264c0b88$var$BlogThumbnails.map((thumbnail)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            key: thumbnail.layout,
            src: thumbnail.src,
            alt: "Blog Listing Page",
            className: `mb-4 cursor-pointer ${thumbnail.layout === props.blogConfig?.blog?.layout || thumbnail.default && !props.blogConfig?.blog?.layout ? ' border-solid border-2 border-catelina-blue' : ''}`,
            onClick: ()=>props.onBlogConfigChange({
                    ...props.blogConfig,
                    blog: {
                        ...props.blogConfig.blog,
                        layout: thumbnail.layout
                    }
                })
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $549aebd5e339f81b$export$2e2bcd8739ae039), {
        className: "mt-10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("h1", {
        className: "text-lg mb-2"
    }, "Blog Post Page"), $8346ae9b264c0b88$var$BlogThumbnails.map((thumbnail)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("img", {
            key: thumbnail.layout,
            src: thumbnail.src,
            alt: "Blog Listing Page",
            className: `mb-4 cursor-pointer ${thumbnail.layout === props.blogConfig?.post?.layout || thumbnail.default && !props.blogConfig?.post?.layout ? ' border-solid border-2 border-catelina-blue' : ''}`,
            onClick: ()=>props.onBlogConfigChange({
                    ...props.blogConfig,
                    post: {
                        ...props.blogConfig.post,
                        layout: thumbnail.layout
                    }
                })
        })));
}





function $112a0a8482d6e605$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
const $112a0a8482d6e605$export$6d5196b1205ae727 = (props)=>{
    const [isInIframe] = (0, $eeH7J.useState)($112a0a8482d6e605$var$checkIsInFrame());
    const [cookies] = (0, $695d41f3aa343730$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const navigate = (0, $0d4e57672a3dc010$export$9770f232ac06a008)();
    const { enqueueSnackbar: enqueueSnackbar } = (0, $4ff4ed24117608da$export$1c97ac2c9a6e7c09)();
    const [searchParams, setSearchParams] = (0, $42e24d1152893e59$export$f1a78c17382fe22a)();
    const [saveDisabled, setSaveDisabled] = (0, $eeH7J.useState)();
    const [checkPublishIntervalIterations, setCheckPublishIntervalIterations] = (0, $eeH7J.useState)(0);
    const [sitePages, setSitePages] = (0, $eeH7J.useState)([]);
    const updateQueryParam = (key, value)=>{
        const params = new URLSearchParams(searchParams);
        params.set(key, value);
        setSearchParams(params);
    };
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    const handleUpdateQueryParam = (section)=>{
        updateQueryParam("section", section);
    };
    const { id: id } = (0, $0d4e57672a3dc010$export$99eaa27ddbbb95ef)();
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(true);
    const [siteData, setSiteData] = (0, $eeH7J.useState)({});
    const [formData, setFormData] = (0, $eeH7J.useState)({
        siteId: id,
        siteName: ""
    });
    const stateData = location.state;
    const [siteCategory, setSiteCategory] = (0, $eeH7J.useState)([
        "Manage Posts",
        "Layout Settings"
    ]);
    const [blogConfig, setBlogConfig] = (0, $eeH7J.useState)(null);
    const [selectedCategory, setSelectedCategory] = (0, $eeH7J.useState)("");
    $eeH7J.useEffect(()=>{
        async function fetchSiteData(siteId) {
            try {
                let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/site-config?siteId=${siteId}`);
                console.log("//", response.data);
                setSiteData(response.data);
                setFormData(response.data);
                setIsLoading(false);
            } catch (err) {
                if (err.response.status === 404) navigate(`/404?msgType=SiteNotFound`);
                else if (err.response.status === 401) navigate(`/404?msgType=SiteNotAuthorizedToAccess`);
                else console.log("err", err.response.data.error);
            }
        }
        fetchSiteData(id);
        let gg = getQueryParam("section");
        if (!gg) setSelectedCategory("General");
        else setSelectedCategory(gg);
    // console.log('asasas', gg)
    // setSelectedCategory(gg ? "General" : "");
    }, []);
    $eeH7J.useEffect(()=>{
        handleUpdateQueryParam(selectedCategory);
    // console.log("s", selectedCategory);
    }, [
        selectedCategory
    ]);
    const updateBlogConfig = async (updatedBlogConfig = blogConfig, publishData = {})=>{
        const response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/blog?siteId=${id}`, updatedBlogConfig);
        console.log('response', response);
        setSiteData(response.data?.data);
        setBlogConfig(null);
        sendBlogConfigToParent(response.data?.data?.blogConfig);
        if (!response.data?.data?.blogConfig?.isPublished) {
            enqueueSnackbar("Changes saved successfully", {
                variant: "success"
            });
            return;
        }
        enqueueSnackbar("Blog is being published.\nWe'll notify you once it's ready.", {
            variant: "success"
        });
        const publishResponse = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).post(`/api/configs/publish-blog`, {
            ...publishData,
            siteId: id
        });
        console.log('publishResponse', publishResponse);
        listenToBlogPublish();
    };
    const listenToBlogPublish = async ()=>{
        const checkPublishInterval = setInterval(async ()=>{
            if (checkPublishIntervalIterations > 10) {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Blog publishing failed', {
                    variant: 'error'
                });
                setCheckPublishIntervalIterations(0);
                return;
            }
            setCheckPublishIntervalIterations(checkPublishIntervalIterations + 1);
            let response = await (0, $d71ae8ab9a4e1251$export$2e2bcd8739ae039).get(`/api/configs/site-config?siteId=${id}`);
            console.log('publish status', response.data);
            if (response.data?.blogConfig?.publishingStatus === 'Completed') {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Blog published successfully', {
                    variant: 'success'
                });
                sendBlogConfigToParent(response.data?.blogConfig);
            } else if (response.data?.blogConfig?.publishingStatus === 'Error') {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Blog publishing failed', {
                    variant: 'error'
                });
                setCheckPublishIntervalIterations(0);
                sendBlogConfigToParent(response.data?.blogConfig);
            } else if (!response.data?.blogConfig?.publishingStatus) {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Changes saved', {
                    variant: 'success'
                });
                setCheckPublishIntervalIterations(0);
                sendBlogConfigToParent(response.data?.blogConfig);
            }
        }, 5000);
    };
    // if is rendered in iframe, then send latest blog data to pagebuilder
    const sendBlogConfigToParent = (blogConfig)=>{
        if (isInIframe) window.parent.postMessage({
            blogUpdated: true,
            blogConfig: blogConfig
        }, "https://editorstage.rocketpages.io");
    };
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Site Settings"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), !isInIframe && /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), {
        ...stateData,
        siteId: id,
        title: `Site settings : ${formData ? formData.siteName : ""}`
    }), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 hidden md:flex" + (isInIframe ? '' : ' top-[64px]')
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, siteCategory.map((ii)=>{
        return /*#__PURE__*/ $eeH7J.createElement("span", {
            className: `px-6 hover:cursor-pointer text-sm py-2 ${selectedCategory === ii ? "bg-[#FAFAFA] text-catelina-blue" : ""}`,
            key: ii,
            onClick: ()=>setSelectedCategory(ii)
        }, ii);
    }))), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex w-full px-4 md:pl-[280px] pb-10 bg-[#FAFAFA] flex-col pt-5" + (isInIframe ? '' : ' min-h-screen pt-[64px] my-4')
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "flex md:hidden py-2"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $3fb1cc9123a3eb67$export$2e2bcd8739ae039), {
        items: siteCategory,
        handleChange: setSelectedCategory,
        category: selectedCategory
    })), formData && selectedCategory === "Manage Posts" && /*#__PURE__*/ $eeH7J.createElement((0, $80868de56ac81b2c$export$2e2bcd8739ae039), {
        siteId: id,
        blogConfig: siteData?.blogConfig || {},
        sitePages: sitePages,
        listenToBlogPublish: listenToBlogPublish,
        onBlogConfigChange: (updatedConfig)=>{
            setBlogConfig(updatedConfig);
            let publishData = {};
            if (updatedConfig?.blogConfig?.blog?.url !== siteData?.blogConfig?.blog?.url) publishData = {
                ...publishData,
                prevPageUrl: siteData?.blogConfig?.blog?.url
            };
            updateBlogConfig(updatedConfig, publishData);
        }
    }), formData && selectedCategory === "Layout Settings" && /*#__PURE__*/ $eeH7J.createElement((0, $8346ae9b264c0b88$export$2e2bcd8739ae039), {
        siteId: id,
        blogConfig: siteData?.blogConfig || {},
        onBlogConfigChange: (updatedConfig)=>setBlogConfig(updatedConfig)
    })), selectedCategory === "Layout Settings" && /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "fixed bottom-0 w-full z-50 flex justify-end px-4 py-2 bg-white-smoke"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $45e6ef255fe84fc0$export$2e2bcd8739ae039), {
        id: "save",
        disabled: !blogConfig,
        className: "min-w-[6rem] px-4 py-1 capitalize",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>updateBlogConfig()
    }, "Save"))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};



var $eeH7J = parcelRequire("eeH7J");






const $65247d25fa9e4ffa$export$324bdbb198bfbf81 = ()=>{
    const location = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)();
    // const stateData = location.state;
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    // const [data, setData] = useState();
    // const [subsRes, setSubsRes] = useState(null);
    const search = (0, $0d4e57672a3dc010$export$45d76561a5302f2b)().search;
    // const session_id = new URLSearchParams(search).get("session_id");
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $a25478a9e2cddd17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $eeH7J.createElement("title", null, "RocketPages - Dashboard"), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $eeH7J.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $eeH7J.createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $eeH7J.createElement((0, $b55830ff5efafe0e$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $eeH7J.createElement((0, $1a0ab4a0aedbac74$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $eeH7J.createElement((0, $c534a300000c6175$export$42cfbb80f7861e77), null), /*#__PURE__*/ $eeH7J.createElement("div", {
        className: "bg-red-300 h-full absolute top-[64px] w-full"
    }, /*#__PURE__*/ $eeH7J.createElement("div", {
        className: " m-auto h-20 bg-white-smoke"
    }, "failed"))), /*#__PURE__*/ $eeH7J.createElement((0, $ce7c1502b62fe5cb$export$2e2bcd8739ae039), null));
};


const $ecc2e384ea5714d0$var$router = (0, $42e24d1152893e59$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $26a7f59851190964$export$74ba1212fd768fa5), null)
    },
    {
        path: "/login",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $b6e6fe27e9740546$export$f14c0e3f98d164c0), null)
    },
    {
        path: "/signup",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $a8e122dcd7d8cd95$export$a2f4b65ede167ce5), null)
    },
    {
        path: "/linkedin",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $5e832946007203dd$export$4eba75a127a285cf), null)
    },
    {
        path: "/reset-password",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $b9910f44309337ac$export$da4433e8d8a5678), null)
    },
    {
        path: "/forgot-password",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $3c846f88b10cc416$export$c7a55480dba6f1f1), null)
    },
    {
        path: "/dashboard",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $5526b3720844f590$export$fedd53519a0e2bce), null)
    },
    {
        path: "/site-settings/:id",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $c31800981d94ff20$export$bae4861c03af8b17), null)
    },
    {
        path: "/admin",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $d468fc43ddb3813e$export$2e2bcd8739ae039), null)
    },
    {
        path: "/manage-blog/:id",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $112a0a8482d6e605$export$6d5196b1205ae727), null)
    },
    {
        path: "/preview/:id",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $ad55af00a8571df0$export$2d07bc60194ed90c), null)
    },
    {
        path: "/choose-template",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $23ddb206e2f3cb85$export$d26f610c9dea7073), null)
    },
    {
        path: "/image-uploder",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $6caf9b45167927de$export$2e2bcd8739ae039), null)
    },
    {
        path: "/404",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $a49b92b51f5ef152$export$2e2bcd8739ae039), null)
    },
    {
        path: "/image-uploder",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $6caf9b45167927de$export$2e2bcd8739ae039), null)
    },
    {
        path: "/account/account-settings",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $7a98e731e8db0cac$export$2e2bcd8739ae039), null)
    },
    {
        path: "/account/api-mcp-access",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $7a98e731e8db0cac$export$2e2bcd8739ae039), null)
    },
    // { path: "/checkout/:subscriptionId/:clientSecret", element: <CheckoutPage /> },
    {
        path: "/plan-success/:siteId",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $3d9d6900c354ceba$export$d1fd69b62921db79), null)
    },
    {
        path: "/plan-fail/:siteId",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $65247d25fa9e4ffa$export$324bdbb198bfbf81), null)
    },
    {
        path: "*",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $a49b92b51f5ef152$export$2e2bcd8739ae039), null)
    },
    {
        path: "/terms-conditions",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $9a8670a3503f2617$export$3e6dfd2ec8bf3ef9), null)
    },
    {
        path: "/privacy-policy",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $94f55d04ae492c0a$export$d5a29154259e944d), null)
    },
    {
        path: "/dns-service-providers",
        element: /*#__PURE__*/ $eeH7J.createElement((0, $afb3ca3d5bab8141$export$a76a49cc6daba0ed), null)
    }
]);
const $ecc2e384ea5714d0$var$theme = (0, $26mQo.default)({
    typography: {
        fontFamily: "Poppins"
    },
    palette: {
        primary: {
            main: "#243060"
        },
        secondary: {
            main: "#04155c"
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "@font-face": {
                    fontFamily: "Poppins"
                },
                body: {
                    fontSize: "3rem",
                    color: "purple"
                }
            }
        }
    }
});
const $ecc2e384ea5714d0$var$container = document.getElementById("app");
const $ecc2e384ea5714d0$var$root = (0, $edca1cc69f99f492$export$882461b6382ed46c)($ecc2e384ea5714d0$var$container); // createRoot(container!) if you use TypeScript
$ecc2e384ea5714d0$var$root.render(// <div>
//   Pagepro best react team in the world
//   <h1 className="text-3xl font-bold underline">Hello world!</h1>
// </div>
/*#__PURE__*/ $eeH7J.createElement((0, $0206968a9c2cf7b5$export$4719288a8f5f7e71), null, /*#__PURE__*/ $eeH7J.createElement((0, $c16a9e487aa3ec68$export$2e2bcd8739ae039), {
    theme: $ecc2e384ea5714d0$var$theme
}, /*#__PURE__*/ $eeH7J.createElement((0, $d1cef9ee2ad489ef$export$2e2bcd8739ae039), null, /*#__PURE__*/ $eeH7J.createElement((0, $0964ed3e14b7bf9e$export$a325976a38f291f5), {
    clientId: "1067520135858-3vc0neclju25u7amqeebqkmne2ouf3fe.apps.googleusercontent.com"
}, /*#__PURE__*/ $eeH7J.createElement((0, $4ff4ed24117608da$export$d1e619fddc3508ce), {
    maxSnack: 3,
    autoHideDuration: 2000,
    anchorOrigin: {
        horizontal: "right",
        vertical: "top"
    }
}, /*#__PURE__*/ $eeH7J.createElement("div", {
    className: "App"
}, /*#__PURE__*/ $eeH7J.createElement((0, $42e24d1152893e59$export$323e4fc2fa4753fb), {
    router: $ecc2e384ea5714d0$var$router
}))))))));


//# sourceMappingURL=index.35265eec.js.map
